import React, { useState, useEffect, useCallback, useRef } from "react";
import Reservation from "./Reservation";
import AiReportPage from './pages/AiReportPage'; import LockersPage from './pages/LockersPage'; import AnalyticsPage from './pages/AnalyticsPage';

const API_BASE = "https://heybiseo.ai.kr"
// 모두싸인 연동 UI 표시 여부 (자체 전자계약으로 전환 — 되살리려면 true)
const SHOW_MODUSIGN = false;
const LS = { get(k){ try { return window.localStorage.getItem(k); } catch(e){ return null; } }, set(k,v){ try { window.localStorage.setItem(k,v); } catch(e){} }, remove(k){ try { window.localStorage.removeItem(k); } catch(e){} } };

const api = async (path, options = {}, token = null) => {
  const headers = { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) };
  const res = await fetch(`${API_BASE}${path}`, { headers, ...options });
  const text = await res.text();
  let data;
  try { data = JSON.parse(text); } catch(e) { data = text; }
  if (!res.ok) {
    throw new Error(data?.detail || data || "요청 실패");
  }
  return data;
};

// KST(한국시간) 기준 YYYY-MM-DD. toISOString()은 UTC라 자정~오전9시 사이 날짜가 하루 밀리는(어제로 보이는) 문제를 방지.
const ymdKST = (d = new Date()) => d.toLocaleDateString('sv-SE', { timeZone: 'Asia/Seoul' });

// ── Icons ────────────────────────────────────────────────────────────────────
const Icon = ({ name, size = 18, color = "currentColor" }) => {
  const icons = {
    dashboard: <><path d="M13 3H21V11H13V3Z"/><path d="M3 3H11V11H3V3Z"/><path d="M3 13H11V21H3V13Z"/><path d="M13 13H21V21H13V13Z"/></>,
    members: <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></>,
    calendar: <><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
    payment: <><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></>,
    door: <><path d="M13 4H3v16h10V4z"/><polyline points="17 8 21 12 17 16"/><line x1="21" y1="12" x2="9" y2="12"/></>,
    staff: <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>,
    settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/></>,
    bell: <><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></>,
    sales: <><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></>,
    trend_up: <><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></>,
    more: <><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></>,
    plus: <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    logout: <><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>,
    search: <><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
    refresh: <><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></>,
    alert: <><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></>,
    check: <><polyline points="20 6 9 17 4 12"/></>,
    x: <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    dollar: <><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></>,
    user_x: <><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="18" y1="8" x2="23" y2="13"/><line x1="23" y1="8" x2="18" y2="13"/></>,
    user_check: <><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><polyline points="17 11 19 13 23 9"/></>,
    plan: <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></>,
    lead: <><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {icons[name]}
    </svg>
  );
};

// ── Toast ────────────────────────────────────────────────────────────────────
const Toast = ({ toasts, remove }) => (
  <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999, display: "flex", flexDirection: "column", gap: 10 }}>
    {toasts.map(t => (
      <div key={t.id} style={{
        display: "flex", alignItems: "center", gap: 10, padding: "12px 18px",
        background: t.type === "error" ? "#fff0f0" : "#f0fff4",
        border: `1px solid ${t.type === "error" ? "#fca5a5" : "#86efac"}`,
        borderRadius: 10, color: "#111", fontSize: 13, minWidth: 240,
        boxShadow: "0 4px 24px rgba(0,0,0,0.12)"
      }}>
        <span style={{ color: t.type === "error" ? "#ef4444" : "#22c55e" }}>
          <Icon name={t.type === "error" ? "alert" : "check"} size={16} />
        </span>
        <span style={{ flex: 1 }}>{t.msg}</span>
        <button onClick={() => remove(t.id)} style={{ background: "none", border: "none", color: "#aaa", cursor: "pointer" }}>
          <Icon name="x" size={14} />
        </button>
      </div>
    ))}
  </div>
);

// ── Table ────────────────────────────────────────────────────────────────────
const Table = ({ columns, data, loading, emptyMsg = "데이터 없음", pageSize = 0 }) => {
  const [page, setPage] = useState(1);
  const paginate = pageSize > 0 && data.length > pageSize;
  const totalPages = paginate ? Math.ceil(data.length / pageSize) : 1;
  useEffect(() => { setPage(1); }, [data.length]);
  const curPage = Math.min(page, totalPages);
  const pageData = paginate ? data.slice((curPage - 1) * pageSize, curPage * pageSize) : data;

  // 페이지 번호 윈도우 (현재 기준 최대 5개)
  const pageNums = [];
  if (paginate) {
    let start = Math.max(1, curPage - 2);
    let end = Math.min(totalPages, start + 4);
    start = Math.max(1, end - 4);
    for (let n = start; n <= end; n++) pageNums.push(n);
  }
  const pageBtn = (active) => ({
    minWidth: 32, padding: "6px 10px", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: active ? 700 : 500,
    border: `1px solid ${active ? "#2563eb" : "#e5e7eb"}`, background: active ? "#2563eb" : "#fff", color: active ? "#fff" : "#374151"
  });

  return (
    <div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr>
              {columns.map(c => (
                <th key={c.key} style={{ padding: "10px 14px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, letterSpacing: 0.5, textTransform: "uppercase", borderBottom: "1px solid #f3f4f6" }}>
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={columns.length} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>로딩 중...</td></tr>
            ) : data.length === 0 ? (
              <tr><td colSpan={columns.length} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>{emptyMsg}</td></tr>
            ) : pageData.map((row, i) => (
              <tr key={i} style={{ borderBottom: "1px solid #f9fafb" }}
                onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
                {columns.map(c => (
                  <td key={c.key} style={{ padding: "12px 14px", color: "#374151" }}>
                    {c.render ? c.render(row[c.key], row) : row[c.key] ?? "—"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {paginate && !loading && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6, padding: "18px 0 6px", flexWrap: "wrap" }}>
          <button disabled={curPage <= 1} onClick={() => setPage(curPage - 1)} style={{ ...pageBtn(false), opacity: curPage <= 1 ? 0.4 : 1, cursor: curPage <= 1 ? "default" : "pointer" }}>‹ 이전</button>
          {pageNums[0] > 1 && <span style={{ color: "#9ca3af", padding: "0 2px" }}>…</span>}
          {pageNums.map(n => (
            <button key={n} onClick={() => setPage(n)} style={pageBtn(n === curPage)}>{n}</button>
          ))}
          {pageNums[pageNums.length - 1] < totalPages && <span style={{ color: "#9ca3af", padding: "0 2px" }}>…</span>}
          <button disabled={curPage >= totalPages} onClick={() => setPage(curPage + 1)} style={{ ...pageBtn(false), opacity: curPage >= totalPages ? 0.4 : 1, cursor: curPage >= totalPages ? "default" : "pointer" }}>다음 ›</button>
          <span style={{ marginLeft: 10, fontSize: 12, color: "#9ca3af" }}>전체 {data.length.toLocaleString()}건 · {curPage}/{totalPages} 페이지</span>
        </div>
      )}
    </div>
  );
};

const Badge = ({ label, color }) => (
  <span style={{
    display: "inline-block", padding: "3px 9px", borderRadius: 20, fontSize: 11, fontWeight: 600,
    background: color + "18", color: color, border: `1px solid ${color}33`
  }}>{label}</span>
);

const Modal = ({ title, children, onClose, width }) => (
  <div style={{
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000,
    display: "flex", alignItems: "center", justifyContent: "center", padding: 20
  }} onClick={e => e.target === e.currentTarget && onClose()}>
    <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: width || 480, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.15)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 22 }}>
        <h3 style={{ color: "#111", margin: 0, fontSize: 16, fontWeight: 700 }}>{title}</h3>
        <button onClick={onClose} style={{ background: "#f3f4f6", border: "none", color: "#6b7280", cursor: "pointer", borderRadius: 8, padding: "6px 8px" }}>
          <Icon name="x" size={16} />
        </button>
      </div>
      {children}
    </div>
  </div>
);

const Input = ({ label, ...props }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>{label}</label>}
    <input {...props} style={{
      width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8,
      color: "#111", padding: "10px 12px", fontSize: 13, outline: "none", boxSizing: "border-box",
      ...props.style
    }} />
  </div>
);

const Select = ({ label, children, ...props }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>{label}</label>}
    <select {...props} style={{
      width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8,
      color: "#111", padding: "10px 12px", fontSize: 13, outline: "none", boxSizing: "border-box"
    }}>{children}</select>
  </div>
);

const Btn = ({ children, variant = "primary", onClick, disabled, style: s }) => {
  const styles = {
    primary: { background: "#2563eb", color: "#fff", border: "none" },
    secondary: { background: "#fff", color: "#374151", border: "1px solid #e5e7eb" },
    danger: { background: "#fee2e2", color: "#ef4444", border: "1px solid #fca5a5" },
  };
  return (
    <button onClick={onClick} disabled={disabled} style={{
      padding: "10px 18px", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer",
      display: "flex", alignItems: "center", gap: 6, opacity: disabled ? 0.5 : 1,
      transition: "all .15s", ...styles[variant], ...s
    }}>{children}</button>
  );
};

// ═══════════════════════════════════════════════════════════════
// SIMPLE MODE PAGE v8 (4-column + 매장명 + 청소 + 메모 + 반응형)
// ═══════════════════════════════════════════════════════════════
// v7 → v8 변경:
//   - 상단 통계 카드 6개 + 매장명 카드 1개 (총 7개)
//   - 메인 4-column 레이아웃 (좌:출입 / 가운데:검색·액션·만료 / 우중:문의·공지·상담 / 우:청소·메모)
//   - 청소 구역 관리 (체크 모달 + 구역 설정 모달)
//   - 인포 메모 (포스트잇 + 작성 모달)
//   - 완전 반응형: 1500/1280/900/600 브레이크포인트
// ═══════════════════════════════════════════════════════════════
// 회원 요약 팝업 (간편모드 회원검색 / 직원관리 담당회원 공용)
const MemberQuickPopup = ({ member: m, trainers = [], onClose, onPay, onDetail }) => {
  if (!m) return null;
  const days = m.end_date ? Math.ceil((new Date(m.end_date) - new Date()) / 86400000) : null;
  const expired = days !== null && days < 0;
  const expiringSoon = days !== null && days >= 0 && days <= 7;
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1200, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 8, width: "100%", maxWidth: 480, boxShadow: "0 20px 60px rgba(0,0,0,0.2)", overflow: "hidden" }}>
        <div style={{ background: "#2563eb", padding: "20px 24px", color: "#fff" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 22, fontWeight: 800 }}>{m.name}</span>
                {m.member_number && <span style={{ fontSize: 12, fontWeight: 700, background: "rgba(255,255,255,0.2)", borderRadius: 4, padding: "3px 8px", fontFamily: "monospace" }}>{m.member_number}</span>}
              </div>
              <div style={{ fontSize: 13, opacity: 0.9, marginTop: 4 }}>
                {m.phone || "전화번호 없음"} · {m.gender === "male" ? "남성" : m.gender === "female" ? "여성" : "성별 미설정"}
              </div>
            </div>
            <button onClick={onClose} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 4, padding: "6px 10px", cursor: "pointer", fontSize: 18 }}>×</button>
          </div>
        </div>
        <div style={{ padding: 24 }}>
          <div style={{ marginBottom: 14, padding: 14, borderRadius: 6, background: expired ? "#fee2e2" : expiringSoon ? "#fff7ed" : "#f0fdf4" }}>
            <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>회원권 상태</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: expired ? "#dc2626" : expiringSoon ? "#f97316" : "#16a34a" }}>
              {expired ? `만료 (${Math.abs(days)}일 지남)` : expiringSoon ? `만료 임박 (D-${days})` : days !== null ? `활성 (D-${days})` : "기간 미설정"}
            </div>
            {m.end_date && <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>만료일: {m.end_date}</div>}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 14 }}>
            <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
              <div style={{ fontSize: 11, color: "#9ca3af" }}>생년월일</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginTop: 2 }}>{m.birth_date || "-"}</div>
            </div>
            <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
              <div style={{ fontSize: 11, color: "#9ca3af" }}>가입일</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginTop: 2 }}>{m.created_at?.slice(0, 10) || "-"}</div>
            </div>
            <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
              <div style={{ fontSize: 11, color: "#9ca3af" }}>홀딩 상태</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: m.is_holding === "Y" ? "#8b5cf6" : "#111", marginTop: 2 }}>{m.is_holding === "Y" ? "홀딩중" : "정상"}</div>
            </div>
            <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
              <div style={{ fontSize: 11, color: "#9ca3af" }}>담당강사</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginTop: 2 }}>{trainers.find(t => t.id === m.trainer_id)?.name || "-"}</div>
            </div>
            <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
              <div style={{ fontSize: 11, color: "#9ca3af" }}>락커</div>
              {m._locker_info ? (
                <div style={{ fontSize: 12, fontWeight: 600, color: "#111", marginTop: 2, lineHeight: 1.5 }}>
                  <div>{m._locker_info.zone_name} {m._locker_info.number}번</div>
                  {m._locker_info.password && <div style={{ fontSize: 11, color: "#6b7280" }}>비번: {m._locker_info.password}</div>}
                </div>
              ) : (
                <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginTop: 2 }}>{m.locker_number ? `${m.locker_number}번` : "-"}</div>
              )}
            </div>
          </div>
          <div style={{ marginBottom: 14, padding: 12, background: "#f0f9ff", borderRadius: 6 }}>
            <div style={{ fontSize: 11, color: "#0369a1", fontWeight: 700, marginBottom: 6 }}>📋 약관 동의 현황</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
              <div>
                <div style={{ fontSize: 10, color: "#6b7280" }}>이용약관 (필수)</div>
                <div style={{ fontSize: 11, fontWeight: 600, color: m.terms_agreed_at ? "#16a34a" : "#dc2626", marginTop: 2 }}>{m.terms_agreed_at ? `✓ ${m.terms_agreed_at.slice(0, 10)}` : "✗ 미동의"}</div>
              </div>
              <div>
                <div style={{ fontSize: 10, color: "#6b7280" }}>개인정보 (필수)</div>
                <div style={{ fontSize: 11, fontWeight: 600, color: m.privacy_agreed_at ? "#16a34a" : "#dc2626", marginTop: 2 }}>{m.privacy_agreed_at ? `✓ ${m.privacy_agreed_at.slice(0, 10)}` : "✗ 미동의"}</div>
              </div>
              <div>
                <div style={{ fontSize: 10, color: "#6b7280" }}>마케팅 (선택)</div>
                <div style={{ fontSize: 11, fontWeight: 600, color: m.marketing_agreed_at ? "#16a34a" : "#9ca3af", marginTop: 2 }}>{m.marketing_agreed_at ? `✓ ${m.marketing_agreed_at.slice(0, 10)}` : "선택 안 함"}</div>
              </div>
            </div>
          </div>
          {m.memo && (
            <div style={{ marginBottom: 14, padding: 12, background: "#fefce8", borderRadius: 6 }}>
              <div style={{ fontSize: 11, color: "#a16207", fontWeight: 600, marginBottom: 4 }}>📝 메모</div>
              <div style={{ fontSize: 12, color: "#374151", whiteSpace: "pre-wrap" }}>{m.memo}</div>
            </div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: onPay ? "1fr 1fr" : "1fr", gap: 10 }}>
            {onPay && (
              <button onClick={() => onPay(m)} style={{ padding: "14px 0", background: "#2563eb", color: "#fff", border: "none", borderRadius: 6, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>💳 결제하기</button>
            )}
            <button onClick={() => onDetail(m)} style={{ padding: "14px 0", background: "#fff", color: "#374151", border: "1px solid #e5e7eb", borderRadius: 6, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>상세 보기 →</button>
          </div>
        </div>
      </div>
    </div>
  );
};

const SimpleModePage = ({ token, addToast, dashboardData, setSimpleMode, setPage, setMembersInitialFilter, setConsultAutoOpen, setConsultFocusId }) => {
  // ── 기존 상태 ──
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedMemberDetail, setSelectedMemberDetail] = useState(null);
  const [recentAttendance, setRecentAttendance] = useState([]);
  const [selectedAttendance, setSelectedAttendance] = useState(null);
  const [todayConsults, setTodayConsults] = useState([]);
  const [consultPopup, setConsultPopup] = useState(null);
  const [consultEdit, setConsultEdit] = useState({ date: "", start_time: "" });
  const [recentSearches, setRecentSearches] = useState([]);
  const [allMembers, setAllMembers] = useState([]);
  const [localDashData, setLocalDashData] = useState(null);
  const [notices, setNotices] = useState([]);
  const [noticeModal, setNoticeModal] = useState(null);

  // 매장 문의
  const [inquiries, setInquiries] = useState([]);
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [replyLoading, setReplyLoading] = useState(false);

  // 홀딩 PENDING
  const [holdingPendings, setHoldingPendings] = useState([]);
  const [selectedHolding, setSelectedHolding] = useState(null);
  const [holdingReviewNote, setHoldingReviewNote] = useState("");
  const [holdingActionLoading, setHoldingActionLoading] = useState(false);

  // 청소 구역 (NEW)
  const [cleaningAreas, setCleaningAreas] = useState([]);  // [{id,name,order_no,logs:[]}]
  const [showCleaningCheck, setShowCleaningCheck] = useState(false);
  const [selectedAreaIds, setSelectedAreaIds] = useState(() => new Set());
  const [cleaningSubmitting, setCleaningSubmitting] = useState(false);
  const [checkStaffId, setCheckStaffId] = useState(null);  // 청소 담당자 선택

  // 청소 구역 설정 (NEW)
  const [showCleaningSettings, setShowCleaningSettings] = useState(false);
  const [areaList, setAreaList] = useState([]);  // 마스터 목록
  const [newAreaName, setNewAreaName] = useState("");
  const [editingAreaId, setEditingAreaId] = useState(null);
  const [editingAreaName, setEditingAreaName] = useState("");

  // 메모 (NEW)
  const [memos, setMemos] = useState([]);
  const [showMemoAdd, setShowMemoAdd] = useState(false);
  const [newMemoText, setNewMemoText] = useState("");
  const [newMemoStaffId, setNewMemoStaffId] = useState(null);
  const [memoSubmitting, setMemoSubmitting] = useState(false);

  // 매장 정보 (NEW)
  const [storeInfo, setStoreInfo] = useState(null);

  // PaymentWizard
  const [showPaymentWizard, setShowPaymentWizard] = useState(false);
  const [paymentDefaultMember, setPaymentDefaultMember] = useState(null);
  const [plans, setPlans] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [modusignTemplates, setModusignTemplates] = useState([]);
  const visitRouteOptions = ["온라인", "지인 소개", "SNS", "현수막", "블로그", "기타"];

  const searchInputRef = useRef(null);

  useEffect(() => { searchInputRef.current?.focus(); }, []);

  // ── 데이터 로드 ──
  const loadAll = useCallback(async () => {
    try {
      const [m, p, t, mt] = await Promise.all([
        api("/members/?tenant_id=1", {}, token).catch(() => []),
        api("/membership-plan/list?tenant_id=1", {}, token).catch(() => []),
        api("/staff/list?tenant_id=1", {}, token).catch(() => []),
        // 자체 전자계약 양식 (구 모두싸인 템플릿 대체)
        api("/contract/template/list", {}, token).catch(() => []),
      ]);
      setAllMembers(Array.isArray(m) ? m : []);
      setPlans(Array.isArray(p) ? p : []);
      setTrainers(Array.isArray(t) ? t : []);
      setModusignTemplates(Array.isArray(mt) ? mt.filter(x => x.is_active !== false) : []);

    } catch (e) { console.error(e); }
  }, [token]);

  const loadAttendance = useCallback(async () => {
    try {
      const d = await api("/attendance/list?tenant_id=1", {}, token);
      const arr = Array.isArray(d) ? d : [];
      arr.sort((a, b) => new Date(b.check_in) - new Date(a.check_in));
      const today = ymdKST();
      const todayArr = arr.filter(a => a.check_in && a.check_in.slice(0, 10) === today);
      setRecentAttendance(todayArr);
      setSelectedAttendance(prev => prev || todayArr[0] || null);
    } catch (e) { console.error(e); }
  }, [token]);

  const loadHoldingPendings = useCallback(async () => {
    try {
      const d = await api("/holding/requests", {}, token);
      setHoldingPendings(Array.isArray(d) ? d : []);
    } catch (e) { console.error("홀딩 PENDING 로드 실패", e); }
  }, [token]);

  const loadTodayConsults = useCallback(async () => {
    try {
      const today = ymdKST();
      const d = await api(`/consultation/list?tenant_id=1`, {}, token);
      const arr = Array.isArray(d) ? d : [];
      const list = arr.filter(c => c.date === today && c.status !== "CANCELLED")
        .sort((a, b) => (a.start_time || "").localeCompare(b.start_time || ""));
      setTodayConsults(list);
    } catch (e) { console.error(e); }
  }, [token]);

  const loadInquiries = useCallback(async () => {
    try {
      const d = await api("/inquiry/pending", {}, token);
      setInquiries(Array.isArray(d) ? d : []);
    } catch (e) { console.error("inquiry load:", e); }
  }, [token]);

  const loadNotices = useCallback(async () => {
    try {
      // 발송 내역(앱푸시/문자)을 공지 위젯에 표시
      const d = await api("/targeting/broadcast-logs?limit=20", {}, token);
      const arr = Array.isArray(d?.logs) ? d.logs : [];
      setNotices(arr.map(l => ({
        id: l.id,
        title: l.title || (l.content ? l.content.slice(0, 24) : "(발송)"),
        content: l.content,
        created_at: l.created_at,
        channels: l.channels || [],
        target_label: l.target_label,
        target_count: l.target_count,
        push_sent: l.push_sent,
        sms_sent: l.sms_sent,
      })));
    } catch (e) { console.error("notice load:", e); setNotices([]); }
  }, [token]);

  // 청소 로드
  const loadCleaning = useCallback(async () => {
    try {
      const d = await api("/cleaning/today", {}, token);
      setCleaningAreas(Array.isArray(d) ? d : []);
    } catch (e) { console.error("cleaning load:", e); }
  }, [token]);

  // 메모 로드
  const loadMemos = useCallback(async () => {
    try {
      const d = await api("/memo/list", {}, token);
      setMemos(Array.isArray(d) ? d : []);
    } catch (e) { console.error("memo load:", e); }
  }, [token]);

  // 매장 정보 로드 (실패해도 무시)
  const loadStoreInfo = useCallback(async () => {
    try {
      // tenant API가 있다고 가정. 없으면 dashboardData에서 가져옴
      const d = await api("/tenant/me", {}, token).catch(() =>
        api("/tenant/1", {}, token).catch(() => null)
      );
      if (d) setStoreInfo(d);
    } catch (e) { console.error("store info:", e); }
  }, [token]);

  useEffect(() => {
    loadHoldingPendings();
    const interval = setInterval(loadHoldingPendings, 30000);
    return () => clearInterval(interval);
  }, [loadHoldingPendings]);

  useEffect(() => {
    loadAll();
    loadAttendance();
    loadTodayConsults();
    loadInquiries();
    loadNotices();
    loadCleaning();
    loadMemos();
    loadStoreInfo();
  }, [loadAll, loadAttendance, loadTodayConsults, loadInquiries, loadNotices, loadCleaning, loadMemos, loadStoreInfo]);

  useEffect(() => {
    if (!dashboardData) {
      api("/dashboard/summary?tenant_id=1", {}, token)
        .then(d => setLocalDashData(d))
        .catch(() => {});
    }
  }, [dashboardData, token]);

  // 폴링 (30초)
  useEffect(() => {
    const p = setInterval(() => {
      loadAttendance();
      loadTodayConsults();
      loadInquiries();
      loadNotices();
      loadCleaning();
      loadMemos();
    }, 30000);
    return () => clearInterval(p);
  }, [loadAttendance, loadTodayConsults, loadInquiries, loadNotices, loadCleaning, loadMemos]);

  // 검색
  useEffect(() => {
    if (!searchQuery.trim()) { setSearchResults([]); return; }
    const q = searchQuery.trim().toLowerCase();
    const qDigits = q.replace(/\D/g, "");
    const results = allMembers.filter(m => {
      const name = (m.name || "").toLowerCase();
      const phone = (m.phone || "").replace(/-/g, "");
      const num = (m.member_number || "");
      return name.includes(q) || (qDigits && phone.includes(qDigits)) || num.includes(q);
    }).slice(0, 8);
    setSearchResults(results);
  }, [searchQuery, allMembers]);

  // 만료 임박
  const expiringMembers = (() => {
    const today = new Date();
    const weekLater = new Date();
    weekLater.setDate(today.getDate() + 7);
    return allMembers.filter(m => {
      if (!m.end_date || m.is_holding === "Y") return false;
      const end = new Date(m.end_date);
      return end >= today && end <= weekLater;
    }).sort((a, b) => new Date(a.end_date) - new Date(b.end_date)).slice(0, 10);
  })();

  // 키보드
  useEffect(() => {
    const handler = (e) => {
      const active = document.activeElement;
      const isTyping = active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA");
      if (e.key === "F2") { e.preventDefault(); setPaymentDefaultMember(null); setShowPaymentWizard(true); }
      else if (e.key === "F3") { e.preventDefault(); setPaymentDefaultMember(null); setShowPaymentWizard(true); }
      else if (e.key === "F4") { e.preventDefault(); setSimpleMode(false); setPage("consult"); if (setConsultAutoOpen) setConsultAutoOpen(true); }
      else if (e.ctrlKey && (e.key === "f" || e.key === "F")) { e.preventDefault(); searchInputRef.current?.focus(); }
      else if (e.key === "Escape") {
        setSelectedMemberDetail(null);
        setSelectedInquiry(null);
        setShowCleaningCheck(false);
        setShowCleaningSettings(false);
        setShowMemoAdd(false);
        if (!isTyping) searchInputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 헬퍼
  const formatTime = (iso) => {
    if (!iso) return "";
    try {
      const s = iso.endsWith("Z") || iso.includes("+") ? iso : iso.replace(" ", "T") + "+09:00";
      const d = new Date(s);
      return d.toLocaleTimeString("ko-KR", { timeZone: "Asia/Seoul", hour: "2-digit", minute: "2-digit", hour12: false });
    } catch { return ""; }
  };
  const formatDate = (iso) => {
    if (!iso) return "";
    try {
      const s = iso.endsWith("Z") || iso.includes("+") ? iso : iso.replace(" ", "T") + "+09:00";
      const d = new Date(s);
      return d.toLocaleDateString("ko-KR", { timeZone: "Asia/Seoul", year: "numeric", month: "2-digit", day: "2-digit" }).replace(/\. /g, "-").replace(".", "").trim();
    } catch { return ""; }
  };
  const formatDateTime = (iso) => {
    if (!iso) return "";
    try {
      const s = iso.endsWith("Z") || iso.includes("+") ? iso : iso.replace(" ", "T") + "+09:00";
      const d = new Date(s);
      return d.toLocaleString("ko-KR", { timeZone: "Asia/Seoul", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
    } catch { return ""; }
  };
  const getDaysLeft = (endDate) => {
    if (!endDate) return null;
    return Math.ceil((new Date(endDate) - new Date()) / (1000 * 60 * 60 * 24));
  };

  const loadMemberLocker = async (memberId, setter) => {
    try {
      const lockers = await api("/locker/list?tenant_id=1", {}, token);
      const assigned = Array.isArray(lockers) ? lockers.find(l => l.member_id === memberId && (l.computed_status === "active" || l.computed_status === "expiring_soon" || l.computed_status === "in_use")) : null;
      if (assigned) setter(prev => prev ? { ...prev, _locker_info: { number: assigned.number, zone_name: assigned.zone_name, password: assigned.password } } : prev);
    } catch (e) {}
  };

  const onSelectMember = async (m) => {
    setSelectedMemberDetail(m);
    setRecentSearches(prev => {
      const filtered = prev.filter(x => x.id !== m.id);
      return [m, ...filtered].slice(0, 5);
    });
    setSearchQuery("");
    setSearchResults([]);
    loadMemberLocker(m.id, setSelectedMemberDetail);
  };

  // 문의 답변
  const submitReply = async () => {
    if (!selectedInquiry || !replyText.trim()) return;
    setReplyLoading(true);
    try {
      await api(`/inquiry/${selectedInquiry.id}/reply`, {
        method: "PUT",
        body: JSON.stringify({ reply: replyText.trim() }),
      }, token);
      addToast("✓ 답변 전송 완료 (회원 앱으로 푸시 발송)");
      setSelectedInquiry(null);
      setReplyText("");
      loadInquiries();
    } catch (e) {
      addToast(`답변 실패: ${e.message || e}`);
    } finally { setReplyLoading(false); }
  };

  // 청소 체크 모달 열기
  const openCleaningCheck = () => {
    setSelectedAreaIds(new Set());
    setCheckStaffId(null);
    setShowCleaningCheck(true);
  };

  // 청소 체크 제출
  const submitCleaningCheck = async () => {
    if (!checkStaffId) {
      addToast("담당자를 선택해주세요");
      return;
    }
    if (selectedAreaIds.size === 0) {
      addToast("청소한 구역을 1개 이상 선택해주세요");
      return;
    }
    setCleaningSubmitting(true);
    try {
      await api("/cleaning/check", {
        method: "POST",
        body: JSON.stringify({
          area_ids: Array.from(selectedAreaIds),
          staff_id: checkStaffId,
        }),
      }, token);
      const staffName = trainers.find(s => s.id === checkStaffId)?.name || "담당자";
      addToast(`✓ ${staffName} - ${selectedAreaIds.size}개 구역 청소 완료`);
      setShowCleaningCheck(false);
      setSelectedAreaIds(new Set());
      setCheckStaffId(null);
      loadCleaning();
    } catch (e) {
      addToast(`체크 실패: ${e.message || e}`);
    } finally { setCleaningSubmitting(false); }
  };

  // 청소 로그 취소 (본인 거만)
  const cancelCleaningLog = async (logId) => {
    try {
      await api(`/cleaning/log/${logId}`, { method: "DELETE" }, token);
      addToast("청소 기록 취소됨");
      loadCleaning();
    } catch (e) {
      addToast(`취소 실패: ${e.message || "본인이 추가한 기록만 취소 가능"}`);
    }
  };

  // 구역 설정 모달 열기
  const openCleaningSettings = async () => {
    try {
      const d = await api("/cleaning/areas", {}, token);
      setAreaList(Array.isArray(d) ? d : []);
      setShowCleaningSettings(true);
    } catch (e) {
      addToast(`구역 로드 실패: ${e.message || e}`);
    }
  };

  // 구역 추가
  const addArea = async () => {
    const name = newAreaName.trim();
    if (!name) { addToast("구역 이름 입력"); return; }
    try {
      const created = await api("/cleaning/areas", {
        method: "POST",
        body: JSON.stringify({ name }),
      }, token);
      setAreaList(prev => [...prev, created]);
      setNewAreaName("");
      addToast("✓ 구역 추가됨");
      loadCleaning();
    } catch (e) {
      addToast(`추가 실패: ${e.message || e}`);
    }
  };

  // 구역 이름 수정
  const saveAreaName = async () => {
    const name = editingAreaName.trim();
    if (!name || !editingAreaId) return;
    try {
      const updated = await api(`/cleaning/areas/${editingAreaId}`, {
        method: "PUT",
        body: JSON.stringify({ name }),
      }, token);
      setAreaList(prev => prev.map(a => a.id === editingAreaId ? updated : a));
      setEditingAreaId(null);
      setEditingAreaName("");
      addToast("✓ 수정됨");
      loadCleaning();
    } catch (e) {
      addToast(`수정 실패: ${e.message || e}`);
    }
  };

  // 구역 삭제
  const deleteArea = async (id) => {
    if (!window.confirm("이 구역을 삭제할까요? 해당 구역의 오늘 기록도 모두 삭제됩니다.")) return;
    try {
      await api(`/cleaning/areas/${id}`, { method: "DELETE" }, token);
      setAreaList(prev => prev.filter(a => a.id !== id));
      addToast("✓ 삭제됨");
      loadCleaning();
    } catch (e) {
      addToast(`삭제 실패: ${e.message || e}`);
    }
  };

  // 메모 추가
 const submitMemo = async () => {
    if (!newMemoStaffId) { addToast("작성자를 선택해주세요"); return; }
    const content = newMemoText.trim();
    if (!content) { addToast("메모 내용 입력"); return; }
    setMemoSubmitting(true);
    try {
      await api("/memo", {
        method: "POST",
        body: JSON.stringify({ content, staff_id: newMemoStaffId }),
      }, token);
      addToast("✓ 메모 추가됨");
      setShowMemoAdd(false);
      setNewMemoText("");
      setNewMemoStaffId(null);
      loadMemos();
    } catch (e) {
      addToast(`추가 실패: ${e.message || e}`);
    } finally { setMemoSubmitting(false); }
  };


  // 메모 고정 토글 (NEW)
  const togglePin = async (id) => {
    try {
      await api(`/memo/${id}/pin`, { method: "PUT" }, token);
      loadMemos();
    } catch (e) {
      addToast(`고정 변경 실패: ${e.message || e}`);
    }
  };

  // 메모 삭제
  const deleteMemo = async (memo) => {
    if (memo.is_pinned) {
      addToast("📌 고정된 메모는 먼저 고정 해제 후 삭제하세요");
      return;
    }
    if (!window.confirm("이 메모를 삭제할까요?")) return;
    try {
      await api(`/memo/${memo.id}`, { method: "DELETE" }, token);
      addToast("✓ 삭제됨");
      loadMemos();
    } catch (e) {
      addToast(`삭제 실패: ${e.message || e}`);
    }
  };

  const selectedAttMember = selectedAttendance
    ? allMembers.find(m => m.id === selectedAttendance.member_id)
    : null;
  const selectedMemberships = selectedAttendance?.memberships || [];

  const dash = dashboardData || localDashData;
  const storeName = storeInfo?.name || dash?.tenant_name || "헤이비서";
  const businessHours = (() => {
    try {
      const bh = storeInfo?.business_hours;
      if (!bh) return "09:00 - 22:00";
      const parsed = typeof bh === "string" ? JSON.parse(bh) : bh;
      const dayKeys = ["sun","mon","tue","wed","thu","fri","sat"];
      const dayKey = dayKeys[new Date().getDay()];
      const day = parsed[dayKey];
      if (!day) return "09:00 - 22:00";
      if (day.closed) return "휴무";
      return day.open + " - " + day.close;
    } catch(e) { return "09:00 - 22:00"; }
  })();

  const statCards = [
    { icon: "dollar", iconBg: "#eff6ff", iconColor: "#2563eb", label: "금일 매출",
      value: dash ? `${Number(dash.revenue?.today || 0).toLocaleString()}원` : "-",
      page: "sales" },
    { icon: "refresh", iconBg: "#fff0f0", iconColor: "#ef4444", label: "금일 환불",
      value: dash ? `${Number(dash.refunds_today_amount ?? 0).toLocaleString()}원` : "-",
      sub: dash ? <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 3 }}>{dash.refunds_today ?? 0}건</div> : null,
      valueColor: "#ef4444", page: "payment" },
    { icon: "bell", iconBg: "#fff0f0", iconColor: "#ef4444", label: "만료 7일전",
      value: dash ? `${dash.expiry_soon || 0}명` : "-",
      valueColor: "#ef4444", page: "members", filter: "expiry_soon" },
    { icon: "calendar", iconBg: "#f5f3ff", iconColor: "#8b5cf6", label: "금일 상담예약",
      value: dash ? `${dash.today_reservations || 0}건` : "-",
      valueColor: "#8b5cf6", page: "consult" },
    { icon: "door", iconBg: "#eff6ff", iconColor: "#2563eb", label: "금일 입장",
      value: dash ? `${dash.attendance?.today_total || 0}명` : "-",
      valueColor: "#2563eb", page: "attendance" },
    { icon: "members", iconBg: "#fff7ed", iconColor: "#f97316", label: "전체 회원",
      value: dash ? `${dash.members?.total || 0}명` : "-",
      valueColor: "#f97316",
      sub: dash ? <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 3 }}>오늘 신규 {dash.members?.today_new || 0}명</div> : null,
      page: "members", filter: "all" },
  ];

  const totalCleaningChecks = cleaningAreas.reduce((sum, a) => sum + (a.logs?.length || 0), 0);

  return (
    <div style={{
      display: "flex", flexDirection: "column",
      minHeight: "calc(100vh - 100px)",
      gap: 12
    }}>
      <style>{`
        @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.3; } }
        @keyframes inquiryGlow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(239,68,68,0.4); }
          50% { box-shadow: 0 0 0 4px rgba(239,68,68,0.15); }
        }
        .sm-scroll::-webkit-scrollbar { width: 6px; }
        .sm-scroll::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }
        .sm-scroll::-webkit-scrollbar-track { background: transparent; }

        /* ────── 상단: 통계 6개 + 매장명 ────── */
        .sm-top {
          display: grid;
          grid-template-columns: repeat(6, minmax(0, 1fr)) minmax(180px, 1.5fr);
          gap: 10px;
          flex-shrink: 0;
        }
        .sm-store { grid-column: 7; }
        @media (max-width: 1500px) { .sm-top { gap: 8px; } }
        @media (max-width: 1280px) {
          .sm-top {
            grid-template-columns: repeat(6, minmax(0, 1fr));
            grid-template-areas:
              "store store store store store store"
              "s1 s2 s3 s4 s5 s6";
          }
          .sm-store { grid-area: store; grid-column: auto; }
        }
        @media (max-width: 900px) {
          .sm-top {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            grid-template-areas:
              "store store store"
              "s1 s2 s3"
              "s4 s5 s6";
          }
        }
        @media (max-width: 600px) {
          .sm-top {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            grid-template-areas:
              "store store"
              "s1 s2"
              "s3 s4"
              "s5 s6";
          }
        }

        /* ────── 메인 4-column ────── */
        .sm-main {
          display: grid;
          grid-template-columns: minmax(240px, 1fr) minmax(440px, 1.4fr) minmax(220px, 1fr) minmax(240px, 1.1fr);
          gap: 10px;
          flex: 1;
          min-height: 0;
        }
        @media (max-width: 1500px) {
          .sm-main { grid-template-columns: minmax(220px, 1fr) minmax(420px, 1.4fr) minmax(210px, 1fr) minmax(230px, 1.1fr); gap: 8px; }
        }
        @media (max-width: 1280px) {
          .sm-main {
            grid-template-columns: 1fr 1fr;
            grid-template-areas:
              "mid mid"
              "left right1"
              "right2 right2";
          }
          .sm-col-mid { grid-area: mid; }
          .sm-col-left { grid-area: left; }
          .sm-col-right1 { grid-area: right1; }
          .sm-col-right2 { grid-area: right2; flex-direction: row !important; }
          .sm-col-right2 > * { flex: 1; }
        }
        @media (max-width: 900px) {
          .sm-main {
            grid-template-columns: 1fr;
            grid-template-areas:
              "mid"
              "left"
              "right1"
              "right2";
          }
          .sm-col-right2 { flex-direction: column !important; }
        }

        /* 출입 테이블 */
        .sm-att-row { display: grid; grid-template-columns: 1.3fr 1.2fr 1fr 0.9fr; gap: 8px; align-items: center; padding: 9px 8px; }
        .sm-att-head { font-size: 11px; color: #9ca3af; font-weight: 600; border-bottom: 1px solid #f3f4f6; }
        .sm-att-body { font-size: 12px; border-bottom: 1px solid #f3f4f6; cursor: pointer; transition: background 0.12s; }
        .sm-att-body:hover { background: #f9fafb; }
        .sm-att-body.active { background: #f0fdf4; }
      `}</style>

      {/* ━━━━━━ 상단: 통계 6개 + 매장명 ━━━━━━ */}
      <div className="sm-top">
        {statCards.map((c, i) => (
          <div key={i} onClick={() => { setSimpleMode(false); if (c.filter && setMembersInitialFilter) setMembersInitialFilter(c.filter); setPage(c.page); }} style={{
            background: "#fff", padding: "18px 16px", borderRadius: 6,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6",
            position: "relative", cursor: "pointer", transition: "all 0.15s"
          }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 4px 16px rgba(37,99,235,0.15)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
            onMouseLeave={e => { if (e.currentTarget) { e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = "translateY(0)"; } }}>
            <div style={{
              position: "absolute", top: 12, right: 12, width: 30, height: 30, borderRadius: 5,
              background: c.iconBg, display: "flex", alignItems: "center", justifyContent: "center"
            }}>
              <Icon name={c.icon} size={15} color={c.iconColor} />
            </div>
            <div style={{ color: "#9ca3af", fontSize: 12, fontWeight: 500, marginBottom: 6 }}>{c.label}</div>
            <div style={{ color: c.valueColor || "#111", fontSize: 20, fontWeight: 800, lineHeight: 1.1 }}>{c.value}</div>
            {c.sub}
          </div>
        ))}

        {/* 매장명 카드 (7번째) */}
        <div className="sm-store" style={{
          background: "linear-gradient(135deg, #1e40af, #2563eb)",
          padding: "16px 18px", borderRadius: 6,
          color: "#fff", display: "flex", flexDirection: "column", justifyContent: "center",
          boxShadow: "0 4px 12px rgba(37,99,235,0.25)"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4, opacity: 0.85 }}>
            <span style={{ fontSize: 12 }}>🏠</span>
            <span style={{ fontSize: 11, fontWeight: 500 }}>매장</span>
          </div>
          <div style={{ fontSize: 18, fontWeight: 800, lineHeight: 1.1, marginBottom: 6 }}>{storeName}</div>
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#4ade80" }} />
            <span style={{ fontSize: 11, opacity: 0.9 }}>영업중 · {businessHours}</span>
          </div>
        </div>
      </div>

      {/* ━━━━━━ 메인 4-column ━━━━━━ */}
      <div className="sm-main">

        {/* ═══ 좌: 출입 현황 ═══ */}
        <div className="sm-col-left" style={{
          background: "#fff", padding: 14, borderRadius: 6,
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6",
          display: "flex", flexDirection: "column", minHeight: 0, gap: 10
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>🚪 출입 현황</span>
              {selectedAttMember && (
                <span style={{ fontSize: 11, fontWeight: 700, color: "#22c55e", background: "#dcfce7", borderRadius: 3, padding: "2px 8px" }}>활성</span>
              )}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#22c55e", animation: "pulse 2s infinite" }} />
              <span style={{ fontSize: 11, color: "#22c55e", fontWeight: 700 }}>LIVE</span>
            </div>
          </div>

          {selectedAttendance ? (() => {
            const attDaysLeft = selectedAttMember?.end_date ? getDaysLeft(selectedAttMember.end_date) : null;
            const attColor = attDaysLeft === null ? "#9ca3af" : attDaysLeft < 0 ? "#ef4444" : attDaysLeft <= 7 ? "#f97316" : "#2563eb";
            return (
            <div style={{ background: "#f9fafb", borderRadius: 12, padding: 14, display: "flex", gap: 12, flexShrink: 0 }}>
              {/* 프로필 이미지 (대시보드와 동일) */}
              <div style={{ width: 64, height: 64, borderRadius: 10, background: selectedAttMember?.gender === "female" ? "#fce7f3" : "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, overflow: "hidden" }}>
                {selectedAttMember?.profile_image
                  ? <img src={`https://heybiseo.ai.kr/${String(selectedAttMember.profile_image).replace(/^\//, "")}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  : <Icon name="members" size={28} color={selectedAttMember?.gender === "female" ? "#ec4899" : "#2563eb"} />}
              </div>
              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 7, minWidth: 0 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 10px" }}>
                  <div>
                    <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 1 }}>이름</div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {selectedAttendance.member_name || selectedAttMember?.name || "-"}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 1 }}>생년월일</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#111", whiteSpace: "nowrap" }}>{selectedAttMember?.birth_date?.replace(/-/g, ".") || "-"}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 10px" }}>
                  <div>
                    <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 1 }}>전화번호</div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#111", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{selectedAttMember?.phone || "-"}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 10, color: attColor, marginBottom: 1 }}>만기{attDaysLeft !== null ? ` · D-${Math.abs(attDaysLeft)}` : ""}</div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: attColor, whiteSpace: "nowrap" }}>{selectedAttMember?.end_date || "-"}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 10px" }}>
                  <div>
                    <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 1 }}>담당강사</div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#111", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{trainers.find(t => t.id === selectedAttMember?.trainer_id)?.name || "-"}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 1 }}>락커</div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#111", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {selectedAttendance.locker_number
                        ? `${selectedAttendance.locker_zone ? selectedAttendance.locker_zone + " " : ""}${selectedAttendance.locker_number}번${selectedAttendance.locker_password ? " · " + selectedAttendance.locker_password : ""}`
                        : (selectedAttMember?._locker_info
                            ? `${selectedAttMember._locker_info.zone_name ? selectedAttMember._locker_info.zone_name + " " : ""}${selectedAttMember._locker_info.number}번${selectedAttMember._locker_info.password ? " · " + selectedAttMember._locker_info.password : ""}`
                            : selectedAttMember?.locker_number ? `${selectedAttMember.locker_number}번` : "-")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            );
          })() : (
            <div style={{ background: "#f9fafb", borderRadius: 6, padding: 20, textAlign: "center", color: "#9ca3af", fontSize: 12, flexShrink: 0 }}>
              회원 선택 시 정보 표시
            </div>
          )}

          {selectedAttMember && (() => {
            const attDays = getDaysLeft(selectedAttMember.end_date);
            const attExpired = attDays !== null && attDays < 0;
            const attSoon = attDays !== null && attDays >= 0 && attDays <= 7;
            return (
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, flexShrink: 0 }}>
                <div style={{ padding: "10px 12px", background: "#f9fafb", borderRadius: 6 }}>
                  <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 2 }}>가입일</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>{selectedAttMember.created_at?.slice(0, 10) || "-"}</div>
                </div>
                <div style={{ padding: "10px 12px", background: attExpired ? "#fee2e2" : attSoon ? "#fff7ed" : "#eff6ff", borderRadius: 6 }}>
                  <div style={{ fontSize: 10, color: attExpired ? "#dc2626" : attSoon ? "#f97316" : "#2563eb", marginBottom: 2 }}>만기일</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: attExpired ? "#dc2626" : attSoon ? "#f97316" : "#2563eb" }}>
                    {selectedAttMember.end_date || "-"}
                  </div>
                  {attDays !== null && (
                    <div style={{ fontSize: 10, fontWeight: 700, color: attExpired ? "#dc2626" : attSoon ? "#f97316" : "#2563eb", marginTop: 2 }}>
                      {attExpired ? `만료 ${Math.abs(attDays)}일` : `D-${attDays}`}
                    </div>
                  )}
                </div>
              </div>
            );
          })()}

          <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, borderTop: "1px solid #f3f4f6", paddingTop: 8 }}>
            <div className="sm-att-row sm-att-head" style={{ flexShrink: 0 }}>
              <span>날짜</span><span>회원명</span><span>시간</span><span>상태</span>
            </div>
            <div className="sm-scroll" style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
              {recentAttendance.length === 0 ? (
                <div style={{ color: "#9ca3af", fontSize: 12, textAlign: "center", padding: 24 }}>아직 출석 기록이 없습니다</div>
              ) : recentAttendance.map(a => {
                const isActive = selectedAttendance?.id === a.id;
                const days = a.end_date ? getDaysLeft(a.end_date) : null;
                const expired = days !== null && days < 0;
                const isValid = a.memberships?.length > 0;
                return (
                  <div key={a.id} className={`sm-att-row sm-att-body${isActive ? " active" : ""}`} onClick={async () => {
                    setSelectedAttendance(a);
                    const m = allMembers.find(x => x.id === a.member_id);
                    if (m) {
                      setSelectedMemberDetail(m);
                      loadMemberLocker(m.id, setSelectedMemberDetail);
                    }
                  }}>
                    <span style={{ color: "#6b7280" }}>{formatDate(a.check_in)}</span>
                    <span style={{ color: "#111", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.member_name || "-"}</span>
                    <span style={{ color: "#111", fontFamily: "monospace" }}>{formatTime(a.check_in)}</span>
                    <span>
                      {!isValid ? <span style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", background: "#f3f4f6", borderRadius: 3, padding: "2px 6px" }}>비회원</span>
                      : expired ? <span style={{ fontSize: 11, fontWeight: 700, color: "#ef4444", background: "#fee2e2", borderRadius: 3, padding: "2px 6px" }}>만료</span>
                      : <span style={{ fontSize: 11, fontWeight: 700, color: "#22c55e", background: "#dcfce7", borderRadius: 3, padding: "2px 6px" }}>활성</span>}
                    </span>

                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* ═══ 가운데: 검색 + 액션 + 만료 ═══ */}
        <div className="sm-col-mid" style={{ display: "flex", flexDirection: "column", gap: 12, minHeight: 0 }}>

          <div style={{ background: "#fff", padding: 20, borderRadius: 6, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6", flexShrink: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>🔍 회원 검색</div>
              <span style={{ fontSize: 11, color: "#9ca3af", background: "#f3f4f6", borderRadius: 3, padding: "2px 8px" }}>Ctrl + F</span>
            </div>
            <div style={{ position: "relative" }}>
              <input
                ref={searchInputRef}
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder="이름, 전화 뒤 4자리, 회원번호로 검색"
                style={{
                  width: "100%", padding: "18px 22px", fontSize: 18,
                  border: "2px solid #e5e7eb", borderRadius: 6, outline: "none",
                  boxSizing: "border-box", background: "#f9fafb", transition: "all 0.15s", fontWeight: 500
                }}
                onFocus={e => { e.target.style.borderColor = "#2563eb"; e.target.style.background = "#fff"; }}
                onBlur={e => { e.target.style.borderColor = "#e5e7eb"; e.target.style.background = "#f9fafb"; }}
              />
              {searchResults.length > 0 && (
                <div style={{
                  position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 100,
                  background: "#fff", border: "1px solid #e5e7eb", borderRadius: 6,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.1)", maxHeight: 360, overflowY: "auto"
                }}>
                  {searchResults.map(m => {
                    const days = getDaysLeft(m.end_date);
                    const expiringSoon = days !== null && days >= 0 && days <= 7;
                    const expired = days !== null && days < 0;
                    return (
                      <div key={m.id} onClick={() => onSelectMember(m)} style={{
                        padding: "12px 16px", cursor: "pointer", borderBottom: "1px solid #f3f4f6",
                        display: "flex", alignItems: "center", gap: 10
                      }}
                        onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                        onMouseLeave={e => { if (e.currentTarget) e.currentTarget.style.background = "#fff"; }}>
                        <div style={{ width: 36, height: 36, borderRadius: "50%", background: m.gender === "female" ? "#fce7f3" : "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, overflow: "hidden" }}>
                          {m.profile_image
                            ? <img src={`https://heybiseo.ai.kr/${String(m.profile_image).replace(/^\//, "")}`} alt="" loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            : <Icon name="members" size={16} color={m.gender === "female" ? "#ec4899" : "#2563eb"} />}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 5, flexWrap: "wrap" }}>
                            <span style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>{m.name}</span>
                            {expired && <span style={{ fontSize: 10, fontWeight: 700, color: "#9ca3af", background: "#f3f4f6", borderRadius: 3, padding: "1px 5px" }}>만료</span>}
                            {expiringSoon && <span style={{ fontSize: 10, fontWeight: 700, color: "#ef4444", background: "#fee2e2", borderRadius: 3, padding: "1px 5px" }}>D-{days}</span>}
                          </div>
                          <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{m.phone || "전화 없음"}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {searchQuery && searchResults.length === 0 && (
                <div style={{
                  position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 100,
                  background: "#fff", border: "1px solid #e5e7eb", borderRadius: 6,
                  padding: 16, textAlign: "center", color: "#9ca3af", fontSize: 13,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.1)"
                }}>검색 결과가 없습니다</div>
              )}
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, flexShrink: 0 }}>
            <button onClick={() => { setPaymentDefaultMember(null); setShowPaymentWizard(true); }} style={{
              background: "linear-gradient(135deg, #2563eb, #3b82f6)", color: "#fff", border: "none",
              borderRadius: 14, padding: "40px 14px", cursor: "pointer",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
              boxShadow: "0 4px 12px rgba(37,99,235,0.25)"
            }}>
              <Icon name="members" size={36} color="#fff" />
              <span style={{ fontSize: 18, fontWeight: 800 }}>신규 등록</span>
              <span style={{ fontSize: 11, opacity: 0.85, background: "rgba(255,255,255,0.2)", padding: "2px 10px", borderRadius: 4 }}>F2</span>
            </button>
            <button onClick={() => { setPaymentDefaultMember(null); setShowPaymentWizard(true); }} style={{
              background: "linear-gradient(135deg, #f59e0b, #fbbf24)", color: "#fff", border: "none",
              borderRadius: 14, padding: "40px 14px", cursor: "pointer",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
              boxShadow: "0 4px 12px rgba(245,158,11,0.25)"
            }}>
              <Icon name="payment" size={36} color="#fff" />
              <span style={{ fontSize: 18, fontWeight: 800 }}>결제 처리</span>
              <span style={{ fontSize: 11, opacity: 0.85, background: "rgba(255,255,255,0.2)", padding: "2px 10px", borderRadius: 4 }}>F3</span>
            </button>
            <button onClick={() => { setSimpleMode(false); setPage("consult"); if (setConsultAutoOpen) setConsultAutoOpen(true); }} style={{
              background: "linear-gradient(135deg, #16a34a, #22c55e)", color: "#fff", border: "none",
              borderRadius: 14, padding: "40px 14px", cursor: "pointer",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
              boxShadow: "0 4px 12px rgba(34,197,94,0.25)"
            }}>
              <Icon name="calendar" size={36} color="#fff" />
              <span style={{ fontSize: 18, fontWeight: 800 }}>상담 예약</span>
              <span style={{ fontSize: 11, opacity: 0.85, background: "rgba(255,255,255,0.2)", padding: "2px 10px", borderRadius: 4 }}>F4</span>
            </button>
          </div>

          {recentSearches.length > 0 && (
            <div style={{ background: "#fff", padding: 12, borderRadius: 6, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6", flexShrink: 0 }}>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 8, fontWeight: 600 }}>최근 조회</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {recentSearches.map(m => (
                  <button key={m.id} onClick={() => onSelectMember(m)} style={{
                    padding: "6px 12px", background: "#f3f4f6", border: "none",
                    borderRadius: 4, fontSize: 12, color: "#374151", cursor: "pointer", fontWeight: 600
                  }}>{m.name}</button>
                ))}
              </div>
            </div>
          )}

          <div style={{
            background: "#fff", padding: 14, borderRadius: 6,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6",
            flex: 1, minHeight: 0, display: "flex", flexDirection: "column"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, flexShrink: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#111" }}>⚠️ 이번 주 만료 회원</div>
              <span style={{ fontSize: 11, color: "#ef4444", fontWeight: 700, background: "#fee2e2", borderRadius: 3, padding: "2px 8px" }}>{expiringMembers.length}명</span>
            </div>
            {expiringMembers.length === 0 ? (
              <div style={{ color: "#9ca3af", fontSize: 12, textAlign: "center", flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>임박한 회원이 없습니다</div>
            ) : (
              <div className="sm-scroll" style={{ display: "flex", flexDirection: "column", gap: 6, overflowY: "auto", flex: 1, minHeight: 0, maxHeight: 300 }}>
                {expiringMembers.map(m => {
                  const days = getDaysLeft(m.end_date);
                  return (
                    <div key={m.id} style={{
                      display: "flex", alignItems: "center", justifyContent: "space-between",
                      padding: "10px 12px", background: "#fff7ed", borderRadius: 4,
                      border: "1px solid #fed7aa", flexShrink: 0
                    }}>
                      <div onClick={() => onSelectMember(m)} style={{ cursor: "pointer", flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 700, color: "#111" }}>{m.name}</div>
                        <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 1 }}>{m.phone || "-"} · {m.end_date}</div>
                      </div>
                      <div style={{ display: "flex", gap: 6, alignItems: "center", flexShrink: 0 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: "#ef4444", background: "#fee2e2", borderRadius: 3, padding: "2px 8px" }}>D-{days}</span>
                        <button onClick={(e) => { e.stopPropagation(); setPaymentDefaultMember(m); setShowPaymentWizard(true); }} style={{
                          padding: "6px 10px", background: "#2563eb", color: "#fff", border: "none",
                          borderRadius: 4, fontSize: 11, fontWeight: 600, cursor: "pointer"
                        }}>재등록</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* ═══ 우중: 매장문의 + 공지 + 오늘상담 ═══ */}
        <div className="sm-col-right1" style={{ display: "flex", flexDirection: "column", gap: 8, minHeight: 0 }}>

         <div style={{
            background: "#fff", padding: 12, borderRadius: 6,
            border: (inquiries.length + holdingPendings.length) > 0 ? "2px solid #ef4444" : "1px solid #f3f4f6",
            boxShadow: (inquiries.length + holdingPendings.length) === 0 ? "0 1px 4px rgba(0,0,0,0.06)" : "none",
            animation: (inquiries.length + holdingPendings.length) > 0 ? "inquiryGlow 2s infinite" : "none",
            flex: 1, minHeight: 0, display: "flex", flexDirection: "column"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, flexShrink: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>📋 매장 요청</div>
              {(inquiries.length + holdingPendings.length) > 0 ? (
                <span style={{ fontSize: 11, color: "#fff", fontWeight: 700, background: "#ef4444", borderRadius: 3, padding: "2px 7px" }}>
                  {inquiries.length + holdingPendings.length}건
                </span>
              ) : (
                <span style={{ fontSize: 11, color: "#9ca3af", fontWeight: 600 }}>대기 없음</span>
              )}
            </div>
            {(inquiries.length + holdingPendings.length) === 0 ? (
              <div style={{ color: "#9ca3af", fontSize: 11, textAlign: "center", flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 12 }}>
                대기 중인 요청 없음
              </div>
            ) : (
              <div className="sm-scroll" style={{ display: "flex", flexDirection: "column", gap: 4, overflowY: "auto", flex: 1, minHeight: 0, maxHeight: 270 }}>
                {[
                  ...inquiries.map(q => ({ ...q, _kind: "inquiry", _time: q.created_at })),
                  ...holdingPendings.map(h => ({ ...h, _kind: "holding", _time: h.created_at }))
                ]
                  .sort((a, b) => new Date(b._time) - new Date(a._time))
                  .map(item => {
                    if (item._kind === "inquiry") {
                      return (
                        <div key={`inq-${item.id}`} onClick={() => { setSelectedInquiry(item); setReplyText(""); }} style={{
                          padding: "8px 10px", background: "#fef2f2", borderRadius: 3,
                          cursor: "pointer", border: "1px solid #fecaca",
                          borderLeft: "3px solid #ef4444",
                          flexShrink: 0
                        }}>
                          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <span style={{ fontSize: 9, color: "#fff", fontWeight: 700, background: "#ef4444", borderRadius: 2, padding: "1px 5px" }}>문의</span>
                              <span style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>{item.member_name || "익명"}</span>
                            </div>
                            <span style={{ fontSize: 10, color: "#9ca3af" }}>{formatDateTime(item.created_at)}</span>
                          </div>
                          <div style={{ fontSize: 11, color: "#374151", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {item.content}
                          </div>
                        </div>
                      );
                    }
                    // 홀딩
                    return (
                      <div key={`hld-${item.id}`} onClick={() => { setSelectedHolding(item); setHoldingReviewNote(""); }} style={{
                        padding: "8px 10px", background: "#fff7ed", borderRadius: 3,
                        cursor: "pointer", border: "1px solid #fed7aa",
                        borderLeft: "3px solid #f59e0b",
                        flexShrink: 0
                      }}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <span style={{ fontSize: 9, color: "#fff", fontWeight: 700, background: "#f59e0b", borderRadius: 2, padding: "1px 5px" }}>홀딩</span>
                            <span style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>{item.member_name || "익명"}</span>
                          </div>
                          <span style={{ fontSize: 10, color: "#9ca3af" }}>{formatDateTime(item.created_at)}</span>
                        </div>
                        <div style={{ fontSize: 11, color: "#374151", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {item.start_date} ~ {item.end_date} ({item.days}일){item.reason ? ` · ${item.reason}` : ""}
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>

          <div style={{
            background: "#fff", padding: 12, borderRadius: 6,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6",
            flex: 1, minHeight: 0, display: "flex", flexDirection: "column"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, flexShrink: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>📢 공지사항</div>
              <span style={{ fontSize: 11, color: "#9ca3af" }}>{notices.length}건</span>
            </div>
            {notices.length === 0 ? (
              <div style={{ color: "#9ca3af", fontSize: 11, textAlign: "center", flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 12 }}>
                공지사항 없음
              </div>
            ) : (
              <div className="sm-scroll" style={{ display: "flex", flexDirection: "column", gap: 5, overflowY: "auto", flex: 1, minHeight: 0, maxHeight: 270 }}>
                {notices.map(n => (
                  <div key={n.id} onClick={() => setNoticeModal(n)} style={{
                    padding: "8px 10px", background: "#f9fafb", borderRadius: 3,
                    cursor: "pointer", flexShrink: 0
                  }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                      <span style={{ fontSize: 12, fontWeight: 700, color: "#111", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                        {n.title || "(제목 없음)"}
                      </span>
                      <span style={{ fontSize: 10, color: "#9ca3af", marginLeft: 6, flexShrink: 0 }}>{formatDate(n.created_at)}</span>
                    </div>
                    {n.content && (
                      <div style={{ fontSize: 11, color: "#6b7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {n.content.replace(/<[^>]*>/g, "")}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {noticeModal && (
            <div onClick={() => setNoticeModal(null)} style={{
              position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 2000,
              display: "flex", alignItems: "center", justifyContent: "center", padding: 20
            }}>
              <div onClick={e => e.stopPropagation()} style={{
                background: "#fff", borderRadius: 14, width: "100%", maxWidth: 480,
                maxHeight: "80vh", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px rgba(0,0,0,0.2)"
              }}>
                <div style={{ padding: "18px 20px", borderBottom: "1px solid #f3f4f6", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <div style={{ fontSize: 17, fontWeight: 800, color: "#111" }}>{noticeModal.title || "(제목 없음)"}</div>
                    <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>
                      {formatDate(noticeModal.created_at)}
                      {(noticeModal.channels || []).length > 0 && " · " + (noticeModal.channels || []).map(c => (c + "").toLowerCase().includes("push") ? "앱푸시" : (c + "").toLowerCase().includes("sms") ? "문자" : c).join(" · ")}
                    </div>
                    {(noticeModal.target_label || noticeModal.target_count != null) && (
                      <div style={{ fontSize: 12, color: "#6b7280", marginTop: 3 }}>
                        대상: {noticeModal.target_label || "-"}
                        {noticeModal.target_count != null && ` · 발송 ${noticeModal.target_count}명`}
                        {noticeModal.push_sent != null && ` (앱푸시 ${noticeModal.push_sent}`}
                        {noticeModal.sms_sent != null && ` · 문자 ${noticeModal.sms_sent})`}
                      </div>
                    )}
                  </div>
                  <button onClick={() => setNoticeModal(null)} style={{ background: "#f3f4f6", border: "none", borderRadius: 8, padding: "6px 10px", cursor: "pointer", fontSize: 14, color: "#6b7280" }}>✕</button>
                </div>
                <div style={{ padding: "18px 20px", overflowY: "auto", fontSize: 14, lineHeight: 1.7, color: "#374151", whiteSpace: "pre-wrap" }}>
                  {(noticeModal.content || "내용이 없습니다.").replace(/<[^>]*>/g, "")}
                </div>
              </div>
            </div>
          )}

          <div style={{
            background: "#fff", padding: 12, borderRadius: 6,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6",
            flex: 1, minHeight: 0, display: "flex", flexDirection: "column"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, flexShrink: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>📋 오늘 상담</div>
              <span style={{ fontSize: 11, color: "#9ca3af" }}>{todayConsults.length}건</span>
            </div>
            {todayConsults.length === 0 ? (
              <div style={{ color: "#9ca3af", fontSize: 11, textAlign: "center", flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>예정 없음</div>
            ) : (
              <div className="sm-scroll" style={{ display: "flex", flexDirection: "column", gap: 4, overflowY: "auto", flex: 1, minHeight: 0 }}>
                {todayConsults.map(c => {
                  const typeLabel = c.type === "PT" ? "개인" : c.type === "GROUP" ? "그룹" : "회원권";
                  const typeColor = c.type === "PT" ? "#ec4899" : c.type === "GROUP" ? "#22c55e" : "#eab308";
                  const isDone = c.status === "COMPLETED";
                  return (
                    <div key={c.id} onClick={() => { setConsultPopup(c); setConsultEdit({ date: c.date || "", start_time: (c.start_time || "").slice(0, 5) }); }} style={{
                      padding: "7px 10px", background: isDone ? "#f3f4f6" : "#f9fafb", borderRadius: 3,
                      display: "flex", alignItems: "center", gap: 6, opacity: isDone ? 0.6 : 1, flexShrink: 0, cursor: "pointer"
                    }}>
                      <span style={{ fontSize: 11, fontWeight: 700, color: "#374151", fontFamily: "monospace", minWidth: 32 }}>{c.start_time?.slice(0, 5)}</span>
                      <span style={{ fontSize: 11, fontWeight: 700, color: typeColor, background: typeColor + "20", borderRadius: 3, padding: "1px 5px" }}>{typeLabel}</span>
                      <span style={{ fontSize: 12, fontWeight: 600, color: "#111", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {c.member_name || c.member_name_manual || "-"}
                      </span>
                      {isDone && <span style={{ fontSize: 11, color: "#22c55e", fontWeight: 700 }}>✓</span>}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {consultPopup && (
          <div onClick={() => setConsultPopup(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 24, width: 380, maxWidth: "90vw", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#111" }}>상담 상세</div>
                <button onClick={() => setConsultPopup(null)} style={{ background: "#f3f4f6", border: "none", borderRadius: 8, padding: "4px 10px", cursor: "pointer", fontSize: 16, color: "#6b7280" }}>×</button>
              </div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 2 }}>{consultPopup.member_name || consultPopup.member_name_manual || "-"}</div>
              <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 14 }}>
                {consultPopup.phone ? consultPopup.phone + " · " : ""}{consultPopup.type === "PT" ? "개인PT 상담" : consultPopup.type === "GROUP" ? "그룹GX 상담" : "회원권 상담"}{consultPopup.trainer_name ? " · " + consultPopup.trainer_name : ""}
              </div>

              <div style={{ fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>상담 시간</div>
              <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
                <input type="date" value={consultEdit.date} onChange={e => setConsultEdit(p => ({ ...p, date: e.target.value }))} style={{ flex: 1, padding: "8px 10px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13 }} />
                <input type="time" value={consultEdit.start_time} onChange={e => setConsultEdit(p => ({ ...p, start_time: e.target.value }))} style={{ width: 120, padding: "8px 10px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13 }} />
              </div>

              <div style={{ fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>상담 메모</div>
              <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "10px 12px", fontSize: 13, color: "#374151", minHeight: 48, whiteSpace: "pre-wrap", marginBottom: 16 }}>
                {consultPopup.memo || "메모가 없습니다"}
              </div>

              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={async () => {
                  try {
                    await api(`/consultation/${consultPopup.id}`, { method: "PUT", body: JSON.stringify({ date: consultEdit.date, start_time: consultEdit.start_time }) }, token);
                    addToast("상담 시간이 변경되었습니다.");
                    setConsultPopup(null);
                    loadTodayConsults();
                  } catch (err) { addToast("변경 실패: " + err.message, "error"); }
                }} style={{ flex: 1, padding: "11px 0", borderRadius: 10, border: "none", background: "#2563eb", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>시간 저장</button>
                <button onClick={() => { if (setConsultFocusId) setConsultFocusId(consultPopup.id); setConsultPopup(null); setSimpleMode(false); setPage("consult"); }} style={{ flex: 1, padding: "11px 0", borderRadius: 10, border: "1px solid #d1d5db", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>수정하기</button>
              </div>
            </div>
          </div>
        )}

        {/* ═══ 우: 청소 구역 + 인포 메모 (NEW) ═══ */}
        <div className="sm-col-right2" style={{ display: "flex", flexDirection: "column", gap: 8, minHeight: 0 }}>

          {/* 청소 구역 */}
          <div style={{
            background: "#fff", padding: 12, borderRadius: 6,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6",
            flex: 1, minHeight: 0, display: "flex", flexDirection: "column"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, flexShrink: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>🧹 청소 구역</span>
                <span style={{ fontSize: 11, color: "#9ca3af" }}>{totalCleaningChecks}회</span>
              </div>
              <button onClick={openCleaningSettings} style={{
                background: "#f3f4f6", border: "none", borderRadius: 4,
                padding: "3px 8px", fontSize: 11, color: "#6b7280", fontWeight: 600, cursor: "pointer",
                display: "flex", alignItems: "center", gap: 3
              }}>⚙️ 설정</button>
            </div>

            {cleaningAreas.length === 0 ? (
              <div style={{ color: "#9ca3af", fontSize: 11, textAlign: "center", flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
                구역 설정에서 청소 구역을 추가해주세요
              </div>
            ) : (
              <div className="sm-scroll" style={{ display: "flex", flexDirection: "column", gap: 4, overflowY: "auto", flex: 1, minHeight: 0 }}>
                {cleaningAreas.map(a => (
                  <div key={a.id} style={{
                    padding: "7px 10px", background: "#f9fafb", borderRadius: 3,
                    border: "1px solid #f3f4f6", flexShrink: 0
                  }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "#111", marginBottom: 3 }}>{a.name}</div>
                    {a.logs && a.logs.length > 0 ? (
                      <div style={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
                        {a.logs.map(lg => (
                          <span key={lg.id} onClick={() => cancelCleaningLog(lg.id)} style={{
                            background: "#dcfce7", color: "#166534",
                            padding: "2px 6px", borderRadius: 3, fontSize: 11, fontWeight: 600,
                            cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 3
                          }}
                            title="클릭하여 취소 (본인 기록만)">
                            <span style={{ fontFamily: "monospace" }}>{lg.time_label}</span>
                            <span>{lg.staff_name || "?"}</span>
                          </span>
                        ))}
                      </div>
                    ) : (
                      <div style={{ fontSize: 11, color: "#d1d5db" }}>기록 없음</div>
                    )}
                  </div>
                ))}
              </div>
            )}

            <button onClick={openCleaningCheck} disabled={cleaningAreas.length === 0} style={{
              marginTop: 8, background: cleaningAreas.length === 0 ? "#9ca3af" : "#2563eb", color: "#fff", border: "none",
              borderRadius: 4, padding: "9px 0", fontSize: 12, fontWeight: 700,
              cursor: cleaningAreas.length === 0 ? "not-allowed" : "pointer", flexShrink: 0
            }}>
              ✓ 청소 완료 체크
            </button>
          </div>

          {/* 인포 메모 */}
          <div style={{
            background: "#fff", padding: 12, borderRadius: 6,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6",
            flex: 1, minHeight: 0, display: "flex", flexDirection: "column"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, flexShrink: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>📝 인포 메모</span>
                <span style={{ fontSize: 11, color: "#9ca3af" }}>{memos.length}개</span>
              </div>
              <button onClick={() => { setNewMemoText(""); setNewMemoStaffId(null); setShowMemoAdd(true); }} style={{
                background: "#2563eb", border: "none", borderRadius: 4,
                padding: "3px 8px", fontSize: 11, color: "#fff", fontWeight: 700, cursor: "pointer"
              }}>+ 새 메모</button>
            </div>

            {memos.length === 0 ? (
              <div style={{ color: "#9ca3af", fontSize: 11, textAlign: "center", flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
                작성된 메모가 없습니다
              </div>
            ) : (
              <div className="sm-scroll" style={{ display: "flex", flexDirection: "column", gap: 5, overflowY: "auto", flex: 1, minHeight: 0, maxHeight: 270 }}>
               {memos.map(mo => (
                  <div key={mo.id} style={{
                    background: mo.is_pinned ? "#fde68a" : "#fef9c3",
                    borderLeft: mo.is_pinned ? "4px solid #f59e0b" : "3px solid #facc15",
                    boxShadow: mo.is_pinned ? "0 2px 8px rgba(245,158,11,0.3)" : "none",
                    borderRadius: 3, padding: "8px 10px", flexShrink: 0,
                    position: "relative"
                  }}>
                    {mo.is_pinned && (
                      <span style={{
                        position: "absolute", top: -6, right: 6,
                        fontSize: 14, transform: "rotate(20deg)"
                      }} title="고정됨">📌</span>
                    )}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 3 }}>
                      <span style={{ fontSize: 11, fontWeight: 700, color: "#713f12" }}>
                        {mo.staff_name || "?"} · {formatDateTime(mo.created_at)}
                      </span>
                      <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                        <span
                          onClick={() => togglePin(mo.id)}
                          title={mo.is_pinned ? "고정 해제" : "메모 고정"}
                          style={{
                            fontSize: 13, cursor: "pointer", padding: "0 4px",
                            opacity: mo.is_pinned ? 1 : 0.4,
                            transition: "opacity 0.15s"
                          }}
                          onMouseEnter={e => e.currentTarget.style.opacity = "1"}
                          onMouseLeave={e => { if (e.currentTarget) e.currentTarget.style.opacity = mo.is_pinned ? "1" : "0.4"; }}
                        >📌</span>
                        <span
                          onClick={() => deleteMemo(mo)}
                          style={{
                            fontSize: 13, color: mo.is_pinned ? "#d1d5db" : "#a16207",
                            cursor: mo.is_pinned ? "not-allowed" : "pointer",
                            fontWeight: 700, padding: "0 4px"
                          }}
                          title={mo.is_pinned ? "고정 해제 후 삭제 가능" : "삭제"}
                        >×</span>
                      </div>
                    </div>
                    <div style={{ fontSize: 12, color: "#422006", whiteSpace: "pre-wrap", lineHeight: 1.45 }}>
                      {mo.content}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ━━━━━━ 청소 체크 모달 ━━━━━━ */}
      {showCleaningCheck && (
        <div onClick={() => setShowCleaningCheck(false)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000,
          display: "flex", alignItems: "center", justifyContent: "center", padding: 20
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", borderRadius: 8, width: "100%", maxWidth: 480,
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)", overflow: "hidden", maxHeight: "90vh", display: "flex", flexDirection: "column"
          }}>
            <div style={{ background: "#2563eb", padding: "18px 22px", color: "#fff", flexShrink: 0 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <div style={{ fontSize: 11, opacity: 0.85, marginBottom: 4 }}>✓ 청소 완료 체크</div>
                  <div style={{ fontSize: 18, fontWeight: 800 }}>청소한 구역을 선택해주세요</div>
                </div>
                <button onClick={() => setShowCleaningCheck(false)} style={{
                  background: "rgba(255,255,255,0.2)", border: "none", color: "#fff",
                  borderRadius: 4, padding: "5px 9px", cursor: "pointer", fontSize: 16
                }}>×</button>
              </div>
            </div>
            <div style={{ padding: 20, overflowY: "auto", flex: 1 }}>
             <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>
                  👤 담당자 선택 <span style={{ color: "#ef4444" }}>*</span>
                </div>
                <select
                  value={checkStaffId || ""}
                  onChange={e => setCheckStaffId(parseInt(e.target.value) || null)}
                  style={{
                    width: "100%", padding: "12px 14px", fontSize: 14,
                    border: "2px solid " + (checkStaffId ? "#2563eb" : "#e5e7eb"),
                    borderRadius: 6, outline: "none",
                    background: "#fff", cursor: "pointer", fontWeight: 600
                  }}
                >
                  <option value="">담당자를 선택하세요</option>
                  {trainers.map(s => (
                    <option key={s.id} value={s.id}>
                      {s.name}{s.role ? ` (${s.role})` : ""}
                    </option>
                  ))}
                </select>
                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 6 }}>
                  🕐 시간은 현재 시각으로 자동 기록됩니다
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                {cleaningAreas.map(a => {
                  const checked = selectedAreaIds.has(a.id);
                  return (
                    <label key={a.id} style={{
                      display: "flex", alignItems: "center",
                      padding: "10px 12px",
                      background: checked ? "#eff6ff" : "#f9fafb",
                      borderRadius: 4,
                      cursor: "pointer", gap: 10,
                      border: checked ? "1px solid #bfdbfe" : "1px solid #f3f4f6"
                    }}>
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => {
                          setSelectedAreaIds(prev => {
                            const next = new Set(prev);
                            if (next.has(a.id)) next.delete(a.id);
                            else next.add(a.id);
                            return next;
                          });
                        }}
                        style={{ width: 18, height: 18, cursor: "pointer" }}
                      />
                      <span style={{ fontSize: 14, color: checked ? "#1e3a8a" : "#374151", fontWeight: checked ? 700 : 500 }}>{a.name}</span>
                      {a.logs && a.logs.length > 0 && (
                        <span style={{ marginLeft: "auto", fontSize: 11, color: "#9ca3af" }}>
                          오늘 {a.logs.length}회
                        </span>
                      )}
                    </label>
                  );
                })}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 8, marginTop: 16 }}>
                <button onClick={() => setShowCleaningCheck(false)} style={{
                  padding: "12px 0", background: "#fff", color: "#374151", border: "1px solid #e5e7eb",
                  borderRadius: 6, fontSize: 13, fontWeight: 700, cursor: "pointer"
                }}>취소</button>
                <button onClick={submitCleaningCheck} disabled={cleaningSubmitting || selectedAreaIds.size === 0} style={{
                  padding: "12px 0",
                  background: (cleaningSubmitting || selectedAreaIds.size === 0) ? "#9ca3af" : "#2563eb",
                  color: "#fff", border: "none", borderRadius: 6, fontSize: 13, fontWeight: 700,
                  cursor: (cleaningSubmitting || selectedAreaIds.size === 0) ? "not-allowed" : "pointer"
                }}>
                  {cleaningSubmitting ? "등록 중..." : `✓ 선택한 ${selectedAreaIds.size}개 구역 등록`}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ═══ 홀딩 PENDING 처리 모달 ═══ */}
{selectedHolding && (
  <div onClick={() => setSelectedHolding(null)} style={{
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
  }}>
    <div onClick={e => e.stopPropagation()} style={{
      background: "#fff", borderRadius: 8, padding: 20, minWidth: 400, maxWidth: 500
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 10, color: "#fff", fontWeight: 700, background: "#f59e0b", borderRadius: 3, padding: "2px 7px" }}>홀딩 신청</span>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#111" }}>{selectedHolding.member_name || "회원"}</div>
        </div>
        <button onClick={() => setSelectedHolding(null)} style={{
          background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#9ca3af"
        }}>×</button>
      </div>

      <div style={{ background: "#f9fafb", borderRadius: 6, padding: 12, marginBottom: 12 }}>
        {selectedHolding.plan_name && (
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
            회원권: <span style={{ color: "#111", fontWeight: 600 }}>{selectedHolding.plan_name}</span>
          </div>
        )}
        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
          기간: <span style={{ color: "#111", fontWeight: 600 }}>{selectedHolding.start_date} ~ {selectedHolding.end_date} ({selectedHolding.days}일)</span>
        </div>
        <div style={{ fontSize: 12, color: "#6b7280" }}>
          신청일: <span style={{ color: "#111" }}>{formatDateTime(selectedHolding.created_at)}</span>
        </div>
      </div>

      {selectedHolding.reason && (
        <div style={{ background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 6, padding: 12, marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: "#92400e", fontWeight: 600, marginBottom: 4 }}>회원이 적은 사유</div>
          <div style={{ fontSize: 12, color: "#111", lineHeight: 1.5 }}>{selectedHolding.reason}</div>
        </div>
      )}

      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 600, marginBottom: 4 }}>
          검토 메모 <span style={{ color: "#9ca3af", fontWeight: 400 }}>(반려 시 필수)</span>
        </div>
        <textarea
          value={holdingReviewNote}
          onChange={e => setHoldingReviewNote(e.target.value)}
          placeholder="예) 출장 일정 확인 완료. 7일 승인합니다."
          style={{
            width: "100%", minHeight: 60, padding: 8, fontSize: 12,
            border: "1px solid #e5e7eb", borderRadius: 4, resize: "vertical",
            fontFamily: "inherit", boxSizing: "border-box"
          }}
        />
      </div>

      <div style={{ display: "flex", gap: 8 }}>
        <button
          onClick={async () => {
            if (!holdingReviewNote.trim()) {
              addToast?.("반려 사유를 입력해 주세요", "error");
              return;
            }
            setHoldingActionLoading(true);
            try {
              await api(`/holding/${selectedHolding.id}/reject`, {
                method: "POST",
                body: JSON.stringify({ review_note: holdingReviewNote.trim() })
              }, token);
              addToast?.("반려 완료", "success");
              setSelectedHolding(null);
              setHoldingReviewNote("");
              loadHoldingPendings();
            } catch (e) {
              addToast?.("반려 실패: " + (e?.message || ""), "error");
            } finally {
              setHoldingActionLoading(false);
            }
          }}
          disabled={holdingActionLoading}
          style={{
            flex: 1, padding: "10px 12px", background: "#fff", color: "#dc2626",
            border: "1px solid #fecaca", borderRadius: 6, fontSize: 13, fontWeight: 600,
            cursor: holdingActionLoading ? "not-allowed" : "pointer", opacity: holdingActionLoading ? 0.5 : 1
          }}
        >반려</button>
        <button
          onClick={async () => {
            setHoldingActionLoading(true);
            try {
              await api(`/holding/${selectedHolding.id}/approve`, {
                method: "POST",
                body: JSON.stringify({ review_note: holdingReviewNote.trim() || null })
              }, token);
              addToast?.("승인 완료. 회원에게 알림 전송됩니다.", "success");
              setSelectedHolding(null);
              setHoldingReviewNote("");
              loadHoldingPendings();
            } catch (e) {
              addToast?.("승인 실패: " + (e?.message || ""), "error");
            } finally {
              setHoldingActionLoading(false);
            }
          }}
          disabled={holdingActionLoading}
          style={{
            flex: 1, padding: "10px 12px", background: "#2B7FFF", color: "#fff",
            border: "none", borderRadius: 6, fontSize: 13, fontWeight: 700,
            cursor: holdingActionLoading ? "not-allowed" : "pointer", opacity: holdingActionLoading ? 0.5 : 1
          }}
        >승인</button>
      </div>
    </div>
  </div>
)}
      {/* ━━━━━━ 청소 구역 설정 모달 ━━━━━━ */}
      {showCleaningSettings && (
        <div onClick={() => setShowCleaningSettings(false)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000,
          display: "flex", alignItems: "center", justifyContent: "center", padding: 20
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", borderRadius: 8, width: "100%", maxWidth: 500,
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)", overflow: "hidden", maxHeight: "90vh", display: "flex", flexDirection: "column"
          }}>
            <div style={{ background: "#6b7280", padding: "18px 22px", color: "#fff", flexShrink: 0 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <div style={{ fontSize: 11, opacity: 0.85, marginBottom: 4 }}>⚙️ 청소 구역 설정</div>
                  <div style={{ fontSize: 18, fontWeight: 800 }}>매장 청소 구역 관리</div>
                </div>
                <button onClick={() => setShowCleaningSettings(false)} style={{
                  background: "rgba(255,255,255,0.2)", border: "none", color: "#fff",
                  borderRadius: 4, padding: "5px 9px", cursor: "pointer", fontSize: 16
                }}>×</button>
              </div>
            </div>
            <div style={{ padding: 20, overflowY: "auto", flex: 1 }}>
              <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
                <input
                  value={newAreaName}
                  onChange={e => setNewAreaName(e.target.value)}
                  onKeyDown={e => { if (e.key === "Enter") addArea(); }}
                  placeholder="새 구역 이름 (예: 화장실)"
                  style={{
                    flex: 1, padding: "10px 12px", fontSize: 13,
                    border: "1px solid #e5e7eb", borderRadius: 6, outline: "none"
                  }}
                />
                <button onClick={addArea} style={{
                  background: "#2563eb", color: "#fff", border: "none", borderRadius: 6,
                  padding: "10px 16px", fontSize: 13, fontWeight: 700, cursor: "pointer", flexShrink: 0
                }}>+ 추가</button>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                {areaList.length === 0 ? (
                  <div style={{ color: "#9ca3af", fontSize: 13, textAlign: "center", padding: 30 }}>
                    등록된 구역이 없습니다. 위에서 추가해주세요.
                  </div>
                ) : areaList.map(a => (
                  <div key={a.id} style={{
                    display: "flex", alignItems: "center", gap: 8,
                    padding: "10px 12px", background: "#f9fafb", borderRadius: 4,
                    border: "1px solid #f3f4f6"
                  }}>
                    {editingAreaId === a.id ? (
                      <>
                        <input
                          value={editingAreaName}
                          onChange={e => setEditingAreaName(e.target.value)}
                          onKeyDown={e => { if (e.key === "Enter") saveAreaName(); }}
                          autoFocus
                          style={{
                            flex: 1, padding: "6px 10px", fontSize: 13,
                            border: "1px solid #2563eb", borderRadius: 4, outline: "none"
                          }}
                        />
                        <button onClick={saveAreaName} style={{
                          background: "#22c55e", color: "#fff", border: "none", borderRadius: 4,
                          padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer"
                        }}>저장</button>
                        <button onClick={() => { setEditingAreaId(null); setEditingAreaName(""); }} style={{
                          background: "#fff", color: "#6b7280", border: "1px solid #e5e7eb", borderRadius: 4,
                          padding: "6px 10px", fontSize: 12, cursor: "pointer"
                        }}>취소</button>
                      </>
                    ) : (
                      <>
                        <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: "#111" }}>{a.name}</span>
                        <button onClick={() => { setEditingAreaId(a.id); setEditingAreaName(a.name); }} style={{
                          background: "#fff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: 4,
                          padding: "6px 10px", fontSize: 12, fontWeight: 600, cursor: "pointer"
                        }}>이름 수정</button>
                        <button onClick={() => deleteArea(a.id)} style={{
                          background: "#fff", color: "#ef4444", border: "1px solid #fecaca", borderRadius: 4,
                          padding: "6px 10px", fontSize: 12, fontWeight: 600, cursor: "pointer"
                        }}>삭제</button>
                      </>
                    )}
                  </div>
                ))}
              </div>

              <div style={{ marginTop: 14, padding: 10, background: "#fef3c7", borderRadius: 4, fontSize: 11, color: "#92400e" }}>
                💡 삭제 시 해당 구역의 오늘 청소 기록도 함께 삭제됩니다.
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ━━━━━━ 메모 작성 모달 ━━━━━━ */}
      {showMemoAdd && (
        <div onClick={() => setShowMemoAdd(false)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000,
          display: "flex", alignItems: "center", justifyContent: "center", padding: 20
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", borderRadius: 8, width: "100%", maxWidth: 460,
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)", overflow: "hidden"
          }}>
            <div style={{ background: "#facc15", padding: "16px 20px", color: "#713f12" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontSize: 16, fontWeight: 800 }}>📝 새 메모 작성</div>
                <button onClick={() => setShowMemoAdd(false)} style={{
                  background: "rgba(0,0,0,0.1)", border: "none", color: "#713f12",
                  borderRadius: 4, padding: "5px 9px", cursor: "pointer", fontSize: 16
                }}>×</button>
              </div>
            </div>
            <div style={{ padding: 18 }}>
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 6 }}>
                  ✍ 작성자 <span style={{ color: "#ef4444" }}>*</span>
                </div>
                <select
                  value={newMemoStaffId || ""}
                  onChange={e => setNewMemoStaffId(parseInt(e.target.value) || null)}
                  style={{
                    width: "100%", padding: "10px 12px", fontSize: 14,
                    border: "2px solid " + (newMemoStaffId ? "#2563eb" : "#e5e7eb"),
                    borderRadius: 6, outline: "none",
                    background: "#fff", cursor: "pointer", fontWeight: 600
                  }}
                >
                  <option value="">작성자를 선택하세요</option>
                  {trainers.map(s => (
                    <option key={s.id} value={s.id}>
                      {s.name}{s.role ? ` (${s.role})` : ""}
                    </option>
                  ))}
                </select>
              </div>
              <textarea
                value={newMemoText}
                onChange={e => setNewMemoText(e.target.value)}
                placeholder="인포 직원들이 공유할 메모를 입력하세요..."
                autoFocus
                rows={5}
                maxLength={2000}
                style={{
                  width: "100%", padding: 12, fontSize: 14, fontFamily: "inherit",
                  border: "1px solid #e5e7eb", borderRadius: 6, outline: "none",
                  boxSizing: "border-box", resize: "vertical", marginBottom: 8, lineHeight: 1.5,
                  background: "#fefce8"
                }}
              />
              <div style={{ textAlign: "right", fontSize: 11, color: "#9ca3af", marginBottom: 12 }}>
                {newMemoText.length} / 2000
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 8 }}>
                <button onClick={() => setShowMemoAdd(false)} style={{
                  padding: "12px 0", background: "#fff", color: "#374151", border: "1px solid #e5e7eb",
                  borderRadius: 6, fontSize: 13, fontWeight: 700, cursor: "pointer"
                }}>취소</button>
                <button onClick={submitMemo} disabled={memoSubmitting || !newMemoText.trim()} style={{
                  padding: "12px 0",
                  background: (memoSubmitting || !newMemoText.trim()) ? "#9ca3af" : "#2563eb",
                  color: "#fff", border: "none", borderRadius: 6, fontSize: 13, fontWeight: 700,
                  cursor: (memoSubmitting || !newMemoText.trim()) ? "not-allowed" : "pointer"
                }}>
                  {memoSubmitting ? "추가 중..." : "📝 메모 추가"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ━━━━━━ 문의 답변 모달 (기존 유지) ━━━━━━ */}
      {selectedInquiry && (
        <div onClick={() => { setSelectedInquiry(null); setReplyText(""); }} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000,
          display: "flex", alignItems: "center", justifyContent: "center", padding: 20
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", borderRadius: 8, width: "100%", maxWidth: 560,
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)", overflow: "hidden"
          }}>
            <div style={{ background: "#ef4444", padding: "20px 24px", color: "#fff" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <div style={{ fontSize: 11, opacity: 0.85, marginBottom: 4 }}>💬 매장 문의 답변</div>
                  <div style={{ fontSize: 22, fontWeight: 800 }}>{selectedInquiry.member_name || "익명"}</div>
                  <div style={{ fontSize: 12, opacity: 0.9, marginTop: 4 }}>
                    {selectedInquiry.member_phone || "전화번호 없음"} · {formatDateTime(selectedInquiry.created_at)}
                  </div>
                </div>
                <button onClick={() => { setSelectedInquiry(null); setReplyText(""); }} style={{
                  background: "rgba(255,255,255,0.2)", border: "none", color: "#fff",
                  borderRadius: 4, padding: "6px 10px", cursor: "pointer", fontSize: 18
                }}>×</button>
              </div>
            </div>
            <div style={{ padding: 24 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", marginBottom: 8 }}>📝 문의 내용</div>
              <div style={{ marginBottom: 20, padding: 14, background: "#f9fafb", borderRadius: 6, fontSize: 14, color: "#111", whiteSpace: "pre-wrap", lineHeight: 1.5, border: "1px solid #e5e7eb" }}>
                {selectedInquiry.content}
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", marginBottom: 8 }}>✍ 답변 작성</div>
              <textarea
                value={replyText}
                onChange={e => setReplyText(e.target.value)}
                placeholder="답변 내용을 입력하세요...&#10;전송 시 회원 앱으로 푸시 알림이 발송됩니다."
                autoFocus
                rows={6}
                maxLength={2000}
                style={{
                  width: "100%", padding: 14, fontSize: 14, fontFamily: "inherit",
                  border: "1px solid #e5e7eb", borderRadius: 6, outline: "none",
                  boxSizing: "border-box", resize: "vertical", marginBottom: 8, lineHeight: 1.5
                }}
              />
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                <span style={{ fontSize: 11, color: "#9ca3af" }}>💡 푸시 알림으로 회원에게 발송됩니다</span>
                <span style={{ fontSize: 11, color: "#9ca3af" }}>{replyText.length} / 2000</span>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 10 }}>
                <button onClick={() => { setSelectedInquiry(null); setReplyText(""); }} style={{
                  padding: "14px 0", background: "#fff", color: "#374151", border: "1px solid #e5e7eb",
                  borderRadius: 6, fontSize: 14, fontWeight: 700, cursor: "pointer"
                }}>취소</button>
                <button onClick={submitReply} disabled={replyLoading || !replyText.trim()} style={{
                  padding: "14px 0",
                  background: (replyLoading || !replyText.trim()) ? "#9ca3af" : "#2563eb",
                  color: "#fff", border: "none", borderRadius: 6, fontSize: 14, fontWeight: 700,
                  cursor: (replyLoading || !replyText.trim()) ? "not-allowed" : "pointer"
                }}>
                  {replyLoading ? "전송 중..." : "📨 답변 보내기"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 회원 상세 모달 (기존 유지) */}
      {selectedMemberDetail && (() => {
        const m = selectedMemberDetail;
        const days = getDaysLeft(m.end_date);
        const expired = days !== null && days < 0;
        const expiringSoon = days !== null && days >= 0 && days <= 7;
        return (
          <div onClick={() => setSelectedMemberDetail(null)} style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000,
            display: "flex", alignItems: "center", justifyContent: "center", padding: 20
          }}>
            <div onClick={e => e.stopPropagation()} style={{
              background: "#fff", borderRadius: 8, width: "100%", maxWidth: 480,
              boxShadow: "0 20px 60px rgba(0,0,0,0.2)", overflow: "hidden"
            }}>
              <div style={{ background: "#2563eb", padding: "20px 24px", color: "#fff" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{ fontSize: 22, fontWeight: 800 }}>{m.name}</span>
                      {m.member_number && <span style={{ fontSize: 12, fontWeight: 700, background: "rgba(255,255,255,0.2)", borderRadius: 4, padding: "3px 8px", fontFamily: "monospace" }}>{m.member_number}</span>}
                    </div>
                    <div style={{ fontSize: 13, opacity: 0.9, marginTop: 4 }}>
                      {m.phone || "전화번호 없음"} · {m.gender === "male" ? "남성" : m.gender === "female" ? "여성" : "성별 미설정"}
                    </div>
                  </div>
                  <button onClick={() => setSelectedMemberDetail(null)} style={{
                    background: "rgba(255,255,255,0.2)", border: "none", color: "#fff",
                    borderRadius: 4, padding: "6px 10px", cursor: "pointer", fontSize: 18
                  }}>×</button>
                </div>
              </div>
              <div style={{ padding: 24 }}>
                <div style={{ marginBottom: 14, padding: 14, borderRadius: 6, background: expired ? "#fee2e2" : expiringSoon ? "#fff7ed" : "#f0fdf4" }}>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>회원권 상태</div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: expired ? "#dc2626" : expiringSoon ? "#f97316" : "#16a34a" }}>
                    {expired ? `만료 (${Math.abs(days)}일 지남)` : expiringSoon ? `만료 임박 (D-${days})` : days !== null ? `활성 (D-${days})` : "기간 미설정"}
                  </div>
                  {m.end_date && <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>만료일: {m.end_date}</div>}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 14 }}>
                  <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
                    <div style={{ fontSize: 11, color: "#9ca3af" }}>생년월일</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginTop: 2 }}>{m.birth_date || "-"}</div>
                  </div>
                  <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
                    <div style={{ fontSize: 11, color: "#9ca3af" }}>가입일</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginTop: 2 }}>{m.created_at?.slice(0, 10) || "-"}</div>
                  </div>
                  <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
                    <div style={{ fontSize: 11, color: "#9ca3af" }}>홀딩 상태</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: m.is_holding === "Y" ? "#8b5cf6" : "#111", marginTop: 2 }}>
                      {m.is_holding === "Y" ? "홀딩중" : "정상"}
                    </div>
                  </div>
                  <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
                    <div style={{ fontSize: 11, color: "#9ca3af" }}>담당강사</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginTop: 2 }}>
                      {trainers.find(t => t.id === m.trainer_id)?.name || "-"}
                    </div>
                  </div>
                  <div style={{ padding: 12, background: "#f9fafb", borderRadius: 4 }}>
                    <div style={{ fontSize: 11, color: "#9ca3af" }}>락커</div>
                    {m._locker_info ? (
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#111", marginTop: 2, lineHeight: 1.5 }}>
                        <div>{m._locker_info.zone_name} {m._locker_info.number}번</div>
                        {m._locker_info.password && <div style={{ fontSize: 11, color: "#6b7280" }}>비번: {m._locker_info.password}</div>}
                      </div>
                    ) : (
                      <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginTop: 2 }}>{m.locker_number ? `${m.locker_number}번` : "-"}</div>
                    )}
                  </div>
                </div>
                {/* 약관 동의 현황 */}
                <div style={{ marginBottom: 14, padding: 12, background: "#f0f9ff", borderRadius: 6 }}>
                  <div style={{ fontSize: 11, color: "#0369a1", fontWeight: 700, marginBottom: 6 }}>📋 약관 동의 현황</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
                    <div>
                      <div style={{ fontSize: 10, color: "#6b7280" }}>이용약관 (필수)</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: m.terms_agreed_at ? "#16a34a" : "#dc2626", marginTop: 2 }}>
                        {m.terms_agreed_at ? `✓ ${m.terms_agreed_at.slice(0, 10)}` : "✗ 미동의"}
                      </div>
                    </div>
                    <div>
                      <div style={{ fontSize: 10, color: "#6b7280" }}>개인정보 (필수)</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: m.privacy_agreed_at ? "#16a34a" : "#dc2626", marginTop: 2 }}>
                        {m.privacy_agreed_at ? `✓ ${m.privacy_agreed_at.slice(0, 10)}` : "✗ 미동의"}
                      </div>
                    </div>
                    <div>
                      <div style={{ fontSize: 10, color: "#6b7280" }}>마케팅 (선택)</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: m.marketing_agreed_at ? "#16a34a" : "#9ca3af", marginTop: 2 }}>
                        {m.marketing_agreed_at ? `✓ ${m.marketing_agreed_at.slice(0, 10)}` : "선택 안 함"}
                      </div>
                    </div>
                  </div>
                </div>
                {m.memo && (
                  <div style={{ marginBottom: 14, padding: 12, background: "#fefce8", borderRadius: 6 }}>
                    <div style={{ fontSize: 11, color: "#a16207", fontWeight: 600, marginBottom: 4 }}>📝 메모</div>
                    <div style={{ fontSize: 12, color: "#374151", whiteSpace: "pre-wrap" }}>{m.memo}</div>
                  </div>
                )}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <button onClick={() => {
                    setSelectedMemberDetail(null);
                    setPaymentDefaultMember(m);
                    setShowPaymentWizard(true);
                  }} style={{
                    padding: "14px 0", background: "#2563eb", color: "#fff", border: "none",
                    borderRadius: 6, fontSize: 14, fontWeight: 700, cursor: "pointer"
                  }}>💳 결제하기</button>
                  <button onClick={() => {
                    setSelectedMemberDetail(null);
                    setSimpleMode(false);
                    setPage("members");
                    sessionStorage.setItem("openMemberId", String(m.id));
                  }} style={{
                    padding: "14px 0", background: "#fff", color: "#374151", border: "1px solid #e5e7eb",
                    borderRadius: 6, fontSize: 14, fontWeight: 700, cursor: "pointer"
                  }}>상세 보기 →</button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      <PaymentWizard
        open={showPaymentWizard}
        onClose={() => { setShowPaymentWizard(false); setPaymentDefaultMember(null); }}
        onSuccess={() => { loadAll(); loadAttendance(); }}
        defaultMember={paymentDefaultMember}
        token={token}
        addToast={addToast}
        plans={plans}
        trainers={trainers}
        modusignTemplates={modusignTemplates}
        visitRouteOptions={visitRouteOptions}
        members={allMembers}
      />
    </div>
  );
};
// ── Bar Chart ────────────────────────────────────────────────────────────────
const BarChart = ({ data }) => {
  const max = Math.max(...data.map(d => d.value));
  const chartH = 200;
  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: 6, height: chartH + 24, paddingBottom: 24, position: "relative" }}>
      {/* Y axis labels */}
      {[60, 45, 30, 15, 0].map(v => (
        <div key={v} style={{
          position: "absolute", left: 0, bottom: 24 + (v / 60) * chartH - 8,
          fontSize: 11, color: "#9ca3af", width: 24, textAlign: "right"
        }}>{v}</div>
      ))}
      <div style={{ display: "flex", alignItems: "flex-end", gap: 5, height: chartH, marginLeft: 32, flex: 1 }}>
        {data.map((d, i) => (
          <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 4, height: "100%", justifyContent: "flex-end" }}>
            <div style={{
              width: "100%", background: i === data.length - 1 ? "#1d4ed8" : "#93c5fd",
              borderRadius: "4px 4px 0 0",
              height: `${(d.value / 60) * 100}%`,
              transition: "height 0.5s ease",
              minHeight: 4
            }} />
            <span style={{ fontSize: 10, color: "#9ca3af", marginTop: 2 }}>{d.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// DASHBOARD PAGE
// ════════════════════════════════════════════════════════════════════════════
const DashboardPage = ({ token, addToast, dashboardData, setDashboardData, setPage, setMembersInitialFilter, setQuickResvModal, permissions }) => {
  const [monthlyRevenue, setMonthlyRevenue] = useState([]);
  const [todayReservations, setTodayReservations] = useState([]);
  const [attendanceList, setAttendanceList] = useState([]);
const [todayRevenue, setTodayRevenue] = useState(0);
const [yesterdayRevenue, setYesterdayRevenue] = useState(0);
const [dashBizHours, setDashBizHours] = React.useState({ startHour: 9, endHour: 22 });

  useEffect(() => {
  if (token) {
    api("/dashboard/summary?tenant_id=1", {}, token)
      .then(data => setDashboardData(data))
      .catch(err => console.error(err));
      api("/dashboard/monthly-revenue?tenant_id=1", {}, token)
        .then(data => setMonthlyRevenue(data))
        .catch(err => console.error(err));
      // 영업시간 로드
      api("/tenant/1/settings", {}, token).then(d => {
        if (!d?.business_hours) return;
        try {
          const dayKeys = ["sun","mon","tue","wed","thu","fri","sat"];
          const dayKey = dayKeys[new Date().getDay()];
          const bh = typeof d.business_hours === "string" ? JSON.parse(d.business_hours) : d.business_hours;
          const day = bh[dayKey];
          if (day && !day.closed) {
            setDashBizHours({ startHour: parseInt(day.open?.split(":")[0] || 9), endHour: parseInt(day.close?.split(":")[0] || 22) });
          }
        } catch(e) {}
      }).catch(() => {});
      api(`/consultation/list?date=${ymdKST()}`, {}, token)
        .then(data => setTodayReservations(data))
        .catch(err => console.error(err));
      api("/attendance/list?tenant_id=1", {}, token)
        .then(data => { const today = ymdKST(); const arr = Array.isArray(data) ? data.filter(a => a.check_in && a.check_in.slice(0, 10) === today) : []; setAttendanceList(arr); })
        .catch(err => console.error(err));
        const now = new Date();
      api(`/sales/daily?tenant_id=1&year=${now.getFullYear()}&month=${now.getMonth() + 1}`, {}, token)
        .then(data => {
          const today = now.getDate();
          const yesterday = today - 1;
          const todayData = data.find(d => d.day === today);
          const yesterdayData = data.find(d => d.day === yesterday);
          setTodayRevenue(todayData?.revenue || 0);
          setYesterdayRevenue(yesterdayData?.revenue || 0);
        })
        .catch(() => {});
    }
  }, [token]);

  // 출입현황 3초 폴링 (키오스크 실시간 반영)
  useEffect(() => {
    if (!token) return;
    const poll = () => {
      api("/attendance/list?tenant_id=1", {}, token)
        .then(data => setAttendanceList((() => { const today = ymdKST(); return Array.isArray(data) ? data.filter(a => a.check_in && a.check_in.slice(0, 10) === today) : []; })()))
        .catch(() => {});
    };
    const interval = setInterval(poll, 3000);
    return () => clearInterval(interval);
  }, [token]);

  const chartData = monthlyRevenue.map(d => ({ label: String(d.day), value: d.revenue / 10000 }));

  const statCards = [
    { icon: "dollar", iconBg: "#eff6ff", iconColor: "#2563eb", label: "금일 매출", value: dashboardData ? `${dashboardData.revenue.today.toLocaleString()}원` : "-", sub: <span style={{
  color: todayRevenue >= yesterdayRevenue ? "#22c55e" : "#ef4444",
  fontSize: 11
}}>
  {yesterdayRevenue === 0 && todayRevenue === 0
    ? "전일 대비 -"
    : yesterdayRevenue === 0
    ? "전일 대비 ▲신규"
    : `전일 대비 ${todayRevenue >= yesterdayRevenue ? "▲" : "▼"}${Math.abs(Math.round((todayRevenue - yesterdayRevenue) / yesterdayRevenue * 100))}%`
  }
</span> },
    { icon: "refresh", iconBg: "#fff0f0", iconColor: "#ef4444", label: "금일 환불", value: dashboardData ? `${Number(dashboardData.refunds_today_amount ?? 0).toLocaleString()}원` : "-", sub: dashboardData ? <span style={{color:"#9ca3af",fontSize:11}}>{dashboardData.refunds_today ?? 0}건</span> : null, valueColor: "#ef4444" },
    { icon: "bell", iconBg: "#fff0f0", iconColor: "#ef4444", label: "만료 7일전 회원수", value: dashboardData ? `${dashboardData.expiry_soon}명` : "-", valueColor: "#ef4444" },
    { icon: "calendar", iconBg: "#f5f3ff", iconColor: "#8b5cf6", label: "금일 상담예약건", value: dashboardData ? `${dashboardData.today_reservations}건` : "-", valueColor: "#8b5cf6" },
    { icon: "door", iconBg: "#eff6ff", iconColor: "#2563eb", label: "금일 입장수", value: dashboardData ? `${dashboardData.attendance.today_total}명` : "-", valueColor: "#2563eb" },
    { icon: "members", iconBg: "#fff7ed", iconColor: "#f97316", label: "전체 회원수", value: dashboardData ? `${dashboardData.members.total}명` : "-", valueColor: "#f97316", sub: dashboardData ? <span style={{color:"#9ca3af",fontSize:11}}>오늘 신규 {dashboardData.members.today_new}명</span> : null },
  ];

  // 타임라인 시간대 - 항상 영업시간 전체를 표시 (예약 유무와 무관).
  // 영업시간 밖에 예약이 있으면 그 시간까지 자동 확장.
const resHours = todayReservations.map(r => parseInt(r.start_time?.slice(0, 2))).filter(h => !isNaN(h));
const minHour = Math.min(dashBizHours.startHour, ...(resHours.length ? resHours : [dashBizHours.startHour]));
const maxHour = Math.max(dashBizHours.endHour, ...(resHours.length ? resHours : [dashBizHours.endHour]));

const hours = Array.from({ length: maxHour - minHour + 1 }, (_, i) => {
  const h = minHour + i;
  const label = h < 12 ? `오전 ${h}` : h === 12 ? "오후 12" : `오후 ${h - 12}`;
  return { label, hour: h };
});
const typeColors = { "PT": "#bfdbfe", "GROUP": "#bbf7d0", "MEMBERSHIP": "#fef08a" };
const typeLabels = { "PT": "PT 상담", "GROUP": "GX 상담", "MEMBERSHIP": "회원권 상담" };

  return (
    <div>
            {/* Stat Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, minmax(0, 1fr))", gap: 14, marginBottom: 24 }}>
        {statCards.map((c, i) => (
          <div key={i} onClick={() => {
  const pages = ["sales", "payment", "members", "consult", "attendance", "members"];
  if (pages[i] === "sales" && permissions?.sales === false) return;
  if (pages[i] === "members" && setMembersInitialFilter) setMembersInitialFilter(c.label && c.label.includes("만료") ? "expiry_soon" : "all");
  setPage(pages[i]);
}} style={{ background: "#fff", borderRadius: 14, padding: "18px 16px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6", position: "relative", cursor: "pointer", transition: "all 0.15s" }}
  onMouseEnter={e => { if(e.currentTarget) e.currentTarget.style.boxShadow = "0 4px 16px rgba(37,99,235,0.15)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
  onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = "translateY(0)"; }}>
            <div style={{ position: "absolute", top: 16, right: 16, width: 36, height: 36, borderRadius: 10, background: c.iconBg, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon name={c.icon} size={18} color={c.iconColor} />
            </div>
            <div style={{ color: "#9ca3af", fontSize: 11, fontWeight: 500, marginBottom: 10 }}>{c.label}</div>
            <div style={{ color: c.valueColor || "#111", fontSize: 22, fontWeight: 800, lineHeight: 1.1, marginBottom: 4 }}>{c.value}</div>
            {c.sub && <div style={{ marginTop: 4 }}>{c.sub}</div>}
          </div>
        ))}
      </div>

      {/* Main Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "calc(100% - 420px) 400px", gap: 12, marginBottom: 12 }}>

        {/* 상담 리스트 타임라인 */}
        <div style={{ background: "#fff", borderRadius: 0, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 16 }}>상담 리스트</div>
          <div style={{ overflowY: "auto", height: 340 }}>
           {hours.map(({ label, hour }) => {
  const slotReservations = todayReservations.filter(r => {
    const startHour = parseInt(r.start_time?.slice(0, 2));
    return startHour === hour;
  });
  return (
    <div key={hour} style={{ display: "flex", gap: 12, marginBottom: 8, minHeight: 48 }}>
      <div style={{ width: 48, color: "#9ca3af", fontSize: 12, paddingTop: 4, flexShrink: 0 }}>{label}</div>
                  <div style={{ flex: 1, display: "flex", gap: 8 }}>
                   {slotReservations.length > 0 ? slotReservations.map((r, j) => (
  <div key={j} style={{
    flex: 1, background: typeColors[r.type] || "#e0e7ff",
    borderRadius: 8, padding: "6px 10px", fontSize: 12
  }}>
    <div style={{ fontWeight: 700, color: "#374151", marginBottom: 2 }}>● {r.trainer_name}</div>
    <div style={{ color: "#6b7280", fontSize: 11 }}>{r.start_time?.slice(0,5)}~{r.end_time?.slice(0,5)}</div>
    <div style={{ color: "#6b7280", fontSize: 11 }}>{r.member_name} - {r.title}</div>
  </div>
                    )) : (
                      <div style={{ flex: 1, borderTop: "1px solid #f3f4f6" }} />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          {/* 범례 */}
          <div style={{ display: "flex", gap: 16, marginTop: 12 }}>
            {Object.entries(typeLabels).map(([type, label]) => (
              <div key={type} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div style={{ width: 12, height: 12, borderRadius: 3, background: typeColors[type] }} />
                <span style={{ fontSize: 11, color: "#9ca3af" }}>{label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* 출입 현황 */}
        <div style={{ background: "#fff", borderRadius: 0, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
  <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>출입 현황</div>
  {attendanceList[0] && (() => {
    const days = attendanceList[0]?.end_date ? Math.floor((new Date(attendanceList[0].end_date) - new Date()) / (1000 * 60 * 60 * 24)) : null;
    const isExpiringSoon = days !== null && days >= 0 && days <= 30;
    const isValid = attendanceList[0]?.memberships?.length > 0;
    return (
      <span style={{ background: isExpiringSoon ? "#fef9c3" : isValid ? "#dcfce7" : "#f3f4f6", color: isExpiringSoon ? "#ca8a04" : isValid ? "#16a34a" : "#6b7280", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20 }}>
        {isExpiringSoon ? `임박 D-${days}` : isValid ? "활성" : "비회원"}
      </span>
    );
  })()}
</div>

          {/* 회원 프로필 카드 */}
          {attendanceList[0] && (() => {
            const a0 = attendanceList[0];
            const daysLeft = a0.end_date ? Math.floor((new Date(a0.end_date) - new Date()) / (1000*60*60*24)) : null;
            const dColor = daysLeft === null ? "#9ca3af" : daysLeft < 0 ? "#ef4444" : daysLeft <= 7 ? "#f97316" : "#2563eb";
            return (
          <div style={{ marginBottom: 16, padding: 14, background: "#f9fafb", borderRadius: 12 }}>
            <div style={{ display: "flex", gap: 12 }}>
              {/* 프로필 이미지 */}
              <div style={{ width: 64, height: 64, borderRadius: 10, background: a0.gender === "female" ? "#fce7f3" : "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, overflow: "hidden" }}>
                {a0.profile_image
                  ? <img src={`https://heybiseo.ai.kr/${a0.profile_image}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  : <Icon name="members" size={28} color={a0.gender === "female" ? "#ec4899" : "#2563eb"} />}
              </div>
              {/* 상세 정보 */}
              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 7, minWidth: 0 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 10px" }}>
                  <div>
                    <div style={{ color: "#9ca3af", fontSize: 10, marginBottom: 1 }}>이름</div>
                    <div style={{ color: "#111", fontSize: 14, fontWeight: 700 }}>{a0.member_name || "-"}</div>
                  </div>
                  <div>
                    <div style={{ color: "#9ca3af", fontSize: 10, marginBottom: 1 }}>생년월일</div>
                    <div style={{ color: "#111", fontSize: 13, fontWeight: 600 }}>{a0.birth_date?.replace(/-/g, ".") || "-"}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 10px" }}>
                  <div>
                    <div style={{ color: "#9ca3af", fontSize: 10, marginBottom: 1 }}>전화번호</div>
                    <div style={{ color: "#111", fontSize: 12, fontWeight: 600 }}>{a0.phone || "-"}</div>
                  </div>
                  <div>
                    <div style={{ color: dColor, fontSize: 10, marginBottom: 1 }}>만기{daysLeft !== null ? ` · D-${Math.abs(daysLeft)}` : ""}</div>
                    <div style={{ color: dColor, fontSize: 12, fontWeight: 600 }}>{a0.end_date || "-"}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 10px" }}>
                  <div>
                    <div style={{ color: "#9ca3af", fontSize: 10, marginBottom: 1 }}>담당강사</div>
                    <div style={{ color: "#111", fontSize: 12, fontWeight: 600 }}>{a0.trainer_name || "-"}</div>
                  </div>
                  <div>
                    <div style={{ color: "#9ca3af", fontSize: 10, marginBottom: 1 }}>락커</div>
                    <div style={{ color: "#111", fontSize: 12, fontWeight: 600 }}>
                      {a0.locker_number ? `${a0.locker_zone ? a0.locker_zone + " " : ""}${a0.locker_number}번${a0.locker_password ? " · " + a0.locker_password : ""}` : "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            );
          })()}
          

          {/* 입장 리스트 */}
          <div style={{ overflowY: "auto", maxHeight: 200 }}>
            <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ color: "#9ca3af", fontWeight: 500, padding: "4px 0", textAlign: "left" }}>날짜</th>
                  <th style={{ color: "#9ca3af", fontWeight: 500, padding: "4px 0", textAlign: "left" }}>회원명</th>
                  <th style={{ color: "#9ca3af", fontWeight: 500, padding: "4px 0", textAlign: "left" }}>입장 시간</th>
                  <th style={{ color: "#9ca3af", fontWeight: 500, padding: "4px 0", textAlign: "left" }}>상태</th>

                </tr>
              </thead>
              <tbody>
                {attendanceList.map((a, i) => (
                  <tr key={i} style={{ borderTop: "1px solid #f3f4f6" }}>
                    <td style={{ padding: "8px 0", color: "#374151" }}>{a.check_in?.slice(0, 10) || "-"}</td>
                    <td style={{ padding: "8px 0", color: "#374151", fontWeight: 500 }}>{a.member_name || "-"}</td>
                    <td style={{ padding: "8px 0", color: "#6b7280" }}>{a.check_in?.slice(11, 16) || "-"}</td>
                    <td style={{ padding: "8px 0" }}>
                      {(() => {
  const days = a.end_date ? Math.floor((new Date(a.end_date) - new Date()) / (1000 * 60 * 60 * 24)) : null;
  const isExpiringSoon = days !== null && days >= 0 && days <= 30;
  const isValid = a.memberships?.length > 0;
  return (
    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
      <span style={{ background: isValid ? "#dcfce7" : "#f3f4f6", color: isValid ? "#16a34a" : "#6b7280", fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 4 }}>
        {isValid ? "활성" : "비회원"}
      </span>
      {isExpiringSoon && (
        <span style={{ background: "#fef9c3", color: "#ca8a04", fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 4 }}>
          임박 D-{days}
        </span>
      )}
    </div>
  );
})()}
                    </td>
                    <td style={{ padding: "8px 0" }}>

                    </td>
                  </tr>
                ))}
                {attendanceList.length === 0 && (
                  <tr><td colSpan={3} style={{ textAlign: "center", padding: 20, color: "#9ca3af" }}>출입 기록 없음</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* 이달의 매출 */}
      <div style={{ background: "#fff", borderRadius: 0, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>이달의 매출</div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ fontSize: 24, fontWeight: 800, color: "#2563eb" }}>
              ₩{monthlyRevenue.reduce((sum, d) => sum + d.revenue, 0).toLocaleString()}
            </span>
            {(() => {
  const thisMonth = monthlyRevenue.reduce((s, d) => s + d.revenue, 0);
  const prevMonth = dashboardData?.prev_month_revenue || 0;
  const diff = prevMonth === 0 && thisMonth === 0 ? null
    : prevMonth === 0 ? null
    : Math.round((thisMonth - prevMonth) / prevMonth * 100);
  const isUp = diff >= 0;
  return diff !== null ? (
    <>
      <span style={{ fontSize: 12, color: isUp ? "#22c55e" : "#ef4444", fontWeight: 600, background: isUp ? "#f0fdf4" : "#fff0f0", padding: "3px 8px", borderRadius: 6 }}>
        전달 대비
      </span>
      <span style={{ display: "flex", alignItems: "center", gap: 3, fontSize: 13, color: isUp ? "#22c55e" : "#ef4444", fontWeight: 600 }}>
        <Icon name="trend_up" size={14} color={isUp ? "#22c55e" : "#ef4444"} />
        {isUp ? "+" : ""}{diff}%
      </span>
    </>
  ) : (
    <span style={{ fontSize: 12, color: "#9ca3af" }}>전달 대비 -</span>
  );
})()}
          </div>
        </div>
        <BarChart data={chartData} />
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════

// ─────────────────────────────────────────────────────────────────
// CardPaymentModal - 나노 수기결제 / 수기 카드 기록 통합 모달
// ─────────────────────────────────────────────────────────────────
function CardPaymentModal({ isOpen, onClose, onSuccess, orderInfo = {}, token = "" }) {
  const [mode, setMode] = React.useState("nano"); // "nano" | "manual"
  const [cardNo, setCardNo] = React.useState("");
  const [expiry, setExpiry] = React.useState("");
  const [cardPw, setCardPw] = React.useState("");
  const [holderYmd, setHolderYmd] = React.useState("");
  const [installment, setInstallment] = React.useState("00");
  const [loading, setLoading] = React.useState(false);
  const [errors, setErrors] = React.useState({});
  const [apiError, setApiError] = React.useState("");
  const [pgEnabled, setPgEnabled] = React.useState(null); // null=확인중, true/false
  const cardNoRef = React.useRef(null);

  React.useEffect(() => {
    if (isOpen) {
      setCardNo(""); setExpiry(""); setCardPw(""); setHolderYmd("");
      setInstallment("00"); setErrors({}); setApiError("");
      setPgEnabled(null);
      setMode("manual"); // 확인 중엔 안전하게 수기 (미연동 기본)
      // 헬스페이 PG(나노) 연동 여부 조회 → 연동 시에만 카드 자동 승인창
      fetch("https://heybiseo.ai.kr/payment/pg-enabled", { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(d => {
          const on = !!(d && d.enabled);
          setPgEnabled(on);
          if (on) { setMode("nano"); setTimeout(() => cardNoRef.current?.focus(), 80); }
        })
        .catch(() => setPgEnabled(false));
    }
  }, [isOpen, token]);

  React.useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => { if (e.key === "Escape" && !loading) onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [isOpen, loading, onClose]);

  function fmtCardNo(v) {
    return v.replace(/\D/g, "").slice(0, 16).replace(/(.{4})/g, "$1 ").trim();
  }
  function fmtExpiry(v) {
    const d = v.replace(/\D/g, "").slice(0, 4);
    return d.length > 2 ? d.slice(0, 2) + "/" + d.slice(2) : d;
  }
  function genOrderNo() {
    const n = new Date();
    return "ORD" + String(n.getFullYear()) +
      String(n.getMonth()+1).padStart(2,"0") + String(n.getDate()).padStart(2,"0") +
      Math.floor(Math.random()*1000000).toString().padStart(6,"0");
  }

  function validate() {
    const errs = {};
    if (mode === "nano") {
      const raw = cardNo.replace(/\s/g, "");
      if (!raw || raw.length < 15) errs.cardNo = "카드번호를 올바르게 입력해주세요 (15~16자리)";
      const ed = expiry.replace(/\D/g, "");
      if (ed.length !== 4) errs.expiry = "유효기간을 MM/YY 형식으로 입력해주세요";
      else if (parseInt(ed.slice(0,2),10) < 1 || parseInt(ed.slice(0,2),10) > 12) errs.expiry = "월은 01~12 사이여야 합니다";
      if (!cardPw || cardPw.length !== 2) errs.cardPw = "비밀번호 앞 2자리를 입력해주세요";
      if (!holderYmd || (holderYmd.length !== 6 && holderYmd.length !== 10)) errs.holderYmd = "생년월일 6자리 또는 사업자번호 10자리를 입력해주세요";
    }
    return errs;
  }

  async function handlePay() {
    setApiError("");
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setLoading(true);
    try {
      if (mode === "nano") {
        const ed = expiry.replace(/\D/g, "");
        const body = {
          member_id: orderInfo.memberId ?? null,
          orderName: orderInfo.memberName ?? "",
          orderTel: (orderInfo.memberPhone ?? "").replace(/\D/g, ""),
          orderEmail: orderInfo.memberEmail ?? "",
          goodsName: orderInfo.goodsName ?? "",
          reqPayAmt: String(orderInfo.reqPayAmt ?? "0"),
          installment,
          compOrderNo: orderInfo.compOrderNo ?? genOrderNo(),
          compOrderMem: String(orderInfo.memberId ?? ""),
          cardNo: cardNo.replace(/\s/g, ""),
          cardExpYy: ed.slice(2, 4),
          cardExpMm: ed.slice(0, 2),
          cardPw,
          cardHolderYmd: holderYmd,
        };
        const res = await fetch("https://heybiseo.ai.kr/payment/approve", {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.detail ?? `서버 오류 (${res.status})`);
        if (data.resultCode !== "0000") throw new Error(`[${data.resultCode}] ${data.resultMsg ?? "결제에 실패했습니다."}`);
        onSuccess({ ...data, pg_method: "nano" });
      } else {
        const meta = orderInfo._meta || {};
        const res = await fetch("https://heybiseo.ai.kr/payment/manual-card", {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({
            member_id: orderInfo.memberId ?? null,
            amount: parseInt(orderInfo.reqPayAmt ?? "0", 10),
            installment,
            payment_type: meta.memberMode === "existing" ? "재등록" : "신규",
            payment_group_id: meta.paymentGroupId ?? null,
            original_amount: meta.totalPrice ?? null,
            discount_amount: meta.discount ?? 0,
            unpaid_amount: meta.unpaid ?? 0,
            payer_name: orderInfo.memberName ?? "",
            goods_name: orderInfo.goodsName ?? "",
            staff_id: meta.staffId ? parseInt(meta.staffId) : null,
          }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.detail ?? `서버 오류 (${res.status})`);
        onSuccess({ resultCode: "0000", pg_method: "manual", ...data });
      }
    } catch (err) {
      setApiError(err.message ?? "결제 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  }

  if (!isOpen) return null;

  const amt = parseInt(orderInfo.reqPayAmt ?? "0", 10);
  const inpStyle = (hasErr) => ({
    width: "100%", padding: "10px 12px", boxSizing: "border-box",
    border: `1.5px solid ${hasErr ? "#ef4444" : "#e5e7eb"}`,
    borderRadius: 8, fontSize: 14, color: "#111827", outline: "none",
    background: "#fff", transition: "border-color 0.15s",
  });
  const labelStyle = { display: "block", fontSize: 11, color: "#6b7280", marginBottom: 5, fontWeight: 600, letterSpacing: 0.3 };
  const errStyle = { fontSize: 11, color: "#ef4444", marginTop: 4 };

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9999, padding: 16
    }}>
      {loading && (
        <div style={{
          position: "absolute", inset: 0, background: "rgba(0,0,0,0.35)",
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          zIndex: 10000, gap: 12
        }}>
          <div style={{
            width: 44, height: 44, border: "4px solid rgba(255,255,255,0.3)",
            borderTopColor: "#fff", borderRadius: "50%",
            animation: "spin 0.8s linear infinite"
          }} />
          <span style={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>
            {mode === "nano" ? "결제 처리 중..." : "기록 저장 중..."}
          </span>
        </div>
      )}
      <div style={{
        background: "#fff", borderRadius: 16, width: "100%", maxWidth: 440,
        maxHeight: "92vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.25)"
      }}>
        <div style={{
          padding: "18px 20px 14px", borderBottom: "1px solid #f3f4f6",
          display: "flex", alignItems: "center", justifyContent: "space-between"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{
              width: 32, height: 32, borderRadius: 8,
              background: mode === "nano" ? "#2563eb" : "#7c3aed",
              display: "flex", alignItems: "center", justifyContent: "center"
            }}>
              <span style={{ fontSize: 16 }}>{mode === "nano" ? "💳" : "✏️"}</span>
            </div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>카드 결제</div>
              <div style={{ fontSize: 11, color: "#9ca3af" }}>
                {mode === "nano" ? "헬스페이 PG 결제" : "카드 수기 기록 (헬스페이 PG 미연동)"}
              </div>
            </div>
          </div>
          <button onClick={onClose} disabled={loading}
            style={{ background: "none", border: "none", cursor: loading ? "not-allowed" : "pointer",
              fontSize: 20, color: "#9ca3af", padding: 4 }}>✕</button>
        </div>

        <div style={{ padding: "16px 20px", display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{
            background: "linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%)",
            borderRadius: 12, padding: "16px 18px", color: "#fff"
          }}>
            <div style={{ fontSize: 11, opacity: 0.75, marginBottom: 2 }}>결제 상품</div>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 10, opacity: 0.95 }}>
              {orderInfo.goodsName || "—"}
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
              <div>
                <div style={{ fontSize: 11, opacity: 0.75 }}>결제 회원</div>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{orderInfo.memberName || "—"}</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 11, opacity: 0.75 }}>결제 금액</div>
                <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: -0.5 }}>
                  {amt.toLocaleString("ko-KR")}
                  <span style={{ fontSize: 14, fontWeight: 600, marginLeft: 2 }}>원</span>
                </div>
              </div>
            </div>
          </div>

          {pgEnabled && (
          <div style={{
            background: "#f9fafb", borderRadius: 10, padding: 4, display: "flex", gap: 4
          }}>
            {[
              { id: "nano", label: "💳 헬스페이 PG 결제", desc: "실시간 승인" },
              { id: "manual", label: "✏️ 수기 기록", desc: "카드기 직접" },
            ].map(m => (
              <button key={m.id} onClick={() => { setMode(m.id); setErrors({}); setApiError(""); }}
                disabled={loading}
                style={{
                  flex: 1, padding: "8px 6px", borderRadius: 8, border: "none",
                  background: mode === m.id ? "#fff" : "transparent",
                  boxShadow: mode === m.id ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
                  cursor: loading ? "not-allowed" : "pointer", transition: "all 0.15s"
                }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: mode === m.id ? (m.id === "nano" ? "#2563eb" : "#7c3aed") : "#9ca3af" }}>
                  {m.label}
                </div>
                <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 1 }}>{m.desc}</div>
              </button>
            ))}
          </div>
          )}

          {mode === "manual" && (
            <div style={{
              background: "#faf5ff", border: "1px solid #e9d5ff",
              borderRadius: 10, padding: "12px 14px", display: "flex", gap: 10, alignItems: "flex-start"
            }}>
              <span style={{ fontSize: 18 }}>ℹ️</span>
              <div>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#7c3aed", marginBottom: 3 }}>수기 카드 기록 모드</div>
                <div style={{ fontSize: 11, color: "#6b7280", lineHeight: 1.5 }}>
                  카드 단말기로 결제 후 시스템에 매출을 기록합니다.<br/>
                  카드 정보 입력 없이 내부 기록만 저장됩니다.
                </div>
              </div>
            </div>
          )}

          {pgEnabled === false && (
            <div style={{
              background: "#eef4ff", border: "1px solid #c7dbff",
              borderRadius: 10, padding: "12px 14px", display: "flex", gap: 10, alignItems: "flex-start"
            }}>
              <span style={{ fontSize: 18 }}>💳</span>
              <div>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#2563eb", marginBottom: 3 }}>앱에서 카드를 바로 결제하고 싶으신가요?</div>
                <div style={{ fontSize: 11, color: "#6b7280", lineHeight: 1.5 }}>
                  <b>헬스페이 PG</b>를 연동하면 단말기 없이 앱에서 즉시 카드 승인 + 무이자 할부까지 지원돼요.<br/>
                  연동 문의: ☎ 02-6672-7942
                </div>
              </div>
            </div>
          )}

          {mode === "nano" && (
            <div style={{
              border: "1px solid #e5e7eb", borderRadius: 12, padding: "16px",
              display: "flex", flexDirection: "column", gap: 12, background: "#fafafa"
            }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 2 }}>카드 정보 입력</div>
              <div>
                <label style={labelStyle}>카드번호</label>
                <input ref={cardNoRef} value={cardNo}
                  onChange={e => { setCardNo(fmtCardNo(e.target.value)); setErrors(p=>({...p,cardNo:""})); }}
                  placeholder="0000 0000 0000 0000"
                  style={{ ...inpStyle(errors.cardNo), fontFamily: "monospace", letterSpacing: 2, fontSize: 16 }}
                  disabled={loading} />
                {errors.cardNo && <div style={errStyle}>{errors.cardNo}</div>}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <div>
                  <label style={labelStyle}>유효기간 (MM/YY)</label>
                  <input value={expiry}
                    onChange={e => { setExpiry(fmtExpiry(e.target.value)); setErrors(p=>({...p,expiry:""})); }}
                    placeholder="MM/YY"
                    style={{ ...inpStyle(errors.expiry), fontFamily: "monospace" }}
                    disabled={loading} />
                  {errors.expiry && <div style={errStyle}>{errors.expiry}</div>}
                </div>
                <div>
                  <label style={labelStyle}>비밀번호 앞 2자리</label>
                  <input type="password" value={cardPw} maxLength={2}
                    onChange={e => { if (/^\d{0,2}$/.test(e.target.value)) { setCardPw(e.target.value); setErrors(p=>({...p,cardPw:""})); }}}
                    placeholder="●●" style={inpStyle(errors.cardPw)} disabled={loading} />
                  {errors.cardPw && <div style={errStyle}>{errors.cardPw}</div>}
                </div>
              </div>
              <div>
                <label style={labelStyle}>생년월일 6자리 / 사업자번호 10자리</label>
                <input value={holderYmd} maxLength={10}
                  onChange={e => { if (/^\d{0,10}$/.test(e.target.value)) { setHolderYmd(e.target.value); setErrors(p=>({...p,holderYmd:""})); }}}
                  placeholder="YYMMDD (개인) / 사업자번호 10자리 (법인)"
                  style={inpStyle(errors.holderYmd)} disabled={loading} />
                {errors.holderYmd && <div style={errStyle}>{errors.holderYmd}</div>}
              </div>
              <div>
                <label style={labelStyle}>할부 개월</label>
                <select value={installment} onChange={e => setInstallment(e.target.value)}
                  disabled={loading} style={{ ...inpStyle(false), cursor: "pointer" }}>
                  <option value="00">일시불</option>
                  {[2,3,4,5,6,7,8,9,10,11,12].map(n => (
                    <option key={n} value={String(n).padStart(2,"0")}>{n}개월</option>
                  ))}
                </select>
                {amt >= 50000 && (
                  <div style={{ fontSize: 11, color: "#2563eb", marginTop: 5 }}>
                    추천 {amt >= 2000000 ? "5" : "3"}개월 · 이 금액대 고객이 가장 많이 선택해요
                  </div>
                )}
              </div>
            </div>
          )}

          {mode === "manual" && (
            <div>
              <label style={labelStyle}>할부 개월</label>
              <select value={installment} onChange={e => setInstallment(e.target.value)}
                disabled={loading} style={{ ...inpStyle(false), cursor: "pointer" }}>
                <option value="00">일시불</option>
                {[2,3,4,5,6,7,8,9,10,11,12].map(n => (
                  <option key={n} value={String(n).padStart(2,"0")}>{n}개월</option>
                ))}
              </select>
              {amt >= 50000 && (
                <div style={{ fontSize: 11, color: "#2563eb", marginTop: 5 }}>
                  추천 {amt >= 2000000 ? "5" : "3"}개월 · 이 금액대 고객이 가장 많이 선택해요
                </div>
              )}
            </div>
          )}

          {apiError && (
            <div style={{
              background: "#fef2f2", border: "1px solid #fecaca",
              borderRadius: 8, padding: "10px 14px",
              fontSize: 13, color: "#dc2626", display: "flex", gap: 8, alignItems: "flex-start"
            }}>
              <span>⚠️</span><span>{apiError}</span>
            </div>
          )}

          <button onClick={handlePay} disabled={loading} style={{
            width: "100%", padding: "14px",
            background: loading ? "#9ca3af" : (mode === "nano" ? "#2563eb" : "#7c3aed"),
            color: "#fff", border: "none", borderRadius: 10,
            fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
            transition: "background 0.15s", display: "flex", alignItems: "center",
            justifyContent: "center", gap: 8
          }}>
            {loading ? (
              <>
                <div style={{
                  width: 18, height: 18, border: "2.5px solid rgba(255,255,255,0.4)",
                  borderTopColor: "#fff", borderRadius: "50%",
                  animation: "spin 0.8s linear infinite"
                }}/>
                {mode === "nano" ? "결제 처리 중..." : "저장 중..."}
              </>
            ) : (
              mode === "nano"
                ? `💳 ${amt.toLocaleString("ko-KR")}원 결제`
                : `✏️ ${amt.toLocaleString("ko-KR")}원 수기 기록`
            )}
          </button>

          <div style={{ textAlign: "center", fontSize: 11, color: "#9ca3af", lineHeight: 1.5 }}>
            {mode === "nano"
              ? "카드 정보는 헬스페이 결제 시스템으로 직접 전송되며 앱 서버에 저장되지 않습니다."
              : "PG 승인 없이 내부 매출 기록만 저장됩니다. 전표번호가 자동 생성됩니다."
            }
          </div>
        </div>
      </div>
      <style>{"@keyframes spin { to { transform: rotate(360deg); } }"}</style>
    </div>
  );
}

// PaymentWizard - 4단계 결제 위자드 (재사용 가능한 컴포넌트)
// 사용처: MembersPage, PaymentPage, MemberDetail
// ════════════════════════════════════════════════════════════════════════════
const PaymentWizard = ({
  open,
  onClose,
  onSuccess,
  defaultMember = null,           // 자동 선택될 회원 (회원상세에서 사용)
  // 공통 데이터
  token,
  addToast,
  plans = [],
  trainers = [],
  modusignTemplates = [],
  visitRouteOptions = [],
  members = [],                   // 기존 회원 검색용
}) => {
  // ── state (위자드 안에서만 관리) ──
  const [addStep, setAddStep] = useState(1);
  const [memberMode, setMemberMode] = useState(defaultMember ? "existing" : "existing");
  const [selectedExistingMember, setSelectedExistingMember] = useState(defaultMember);
  const [memberSearchQuery, setMemberSearchQuery] = useState("");
  const [form, setForm] = useState({
    name: "", phone: "", gender: "", birth_date: "", address: "",
    memo: "", visit_route: "", trainer_id: "",
    exercise_purpose: "", staff_id: "",
   payment_date: ymdKST(),
    terms_agreed: false, privacy_agreed: false, marketing_agreed: false,
  });
  const [selectedPlansForMember, setSelectedPlansForMember] = useState([]);
  const [productCategory, setProductCategory] = useState("all");
  const [productSearch, setProductSearch] = useState("");
  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedPayMethod, setSelectedPayMethod] = useState("");
  const [discountAmount, setDiscountAmount] = useState("0");
  const [unpaidAmount, setUnpaidAmount] = useState("0");
  const [newMemberProfileImage, setNewMemberProfileImage] = useState(null);
  const [showCameraForNewMember, setShowCameraForNewMember] = useState(false);
  const [signingMethod, setSigningMethod] = useState("SECURE_LINK");
  const [embeddedUrl, setEmbeddedUrl] = useState("");
  const [showSignIframe, setShowSignIframe] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showCardModal, setShowCardModal] = React.useState(false);
  const [cardPayInfo, setCardPayInfo] = React.useState({});

  // ── defaultMember 변경 시 자동 적용 ──
  useEffect(() => {
    if (open && defaultMember) {
      setSelectedExistingMember(defaultMember);
      setMemberMode("existing");
      if (defaultMember.trainer_id) {
        setForm(p => ({ ...p, trainer_id: String(defaultMember.trainer_id) }));
      }
    }
  }, [open, defaultMember]);

  // ── 닫을 때 초기화 ──
  const handleClose = () => {
    setAddStep(1);
    setMemberMode(defaultMember ? "existing" : "existing");
    setSelectedExistingMember(defaultMember || null);
    setMemberSearchQuery("");
    setForm({
      name: "", phone: "", gender: "", birth_date: "", address: "",
      memo: "", visit_route: "", trainer_id: "",
      exercise_purpose: "", staff_id: "",
      payment_date: ymdKST(),
    terms_agreed: false, privacy_agreed: false, marketing_agreed: false,
  });
    setSelectedPlansForMember([]);
    setProductCategory("all");
    setProductSearch("");
    setSelectedContract(null);
    setSelectedPayMethod("");
    setDiscountAmount("0");
    setUnpaidAmount("0");
    setNewMemberProfileImage(null);
    setSigningMethod("SECURE_LINK");
    setEmbeddedUrl("");
    setShowSignIframe(false);
    onClose();
  };

  // ── 결제 핸들러 ──
  // ── 카드 결제 모달 성공 콜백 ──
  const handleCardPaySuccess = async (nanoResult) => {
    setShowCardModal(false);
    const meta = cardPayInfo._meta;
    if (!meta) { addToast("결제 정보 오류", "error"); return; }
    setSaving(true);
    try {
      for (const plan of meta.planList) {
        const planPrice = Number(plan.card_price || plan.cash_price || plan.price || 0);
        const planRatio = meta.totalPrice > 0 ? planPrice / meta.totalPrice : 0;
        const planOriginal = planPrice;
        const planDiscount = Math.round(meta.discount * planRatio);
        const planUnpaid = Math.round(meta.unpaid * planRatio);
        const planReceived = Math.max(0, planOriginal - planDiscount - planUnpaid);
        try {
          await api("/membership/by-plan", { method: "POST", body: JSON.stringify({
            tenant_id: 1, member_id: meta.memberId, plan_id: plan.id,
            start_date: meta.paymentDate || ymdKST(),
            total_count: plan.sessions || null,
            trainer_id: meta.trainerId ? parseInt(meta.trainerId) : null,
          })}, token);
          if (nanoResult.pg_method !== "manual") {
            await api("/payment", { method: "POST", body: JSON.stringify({
              tenant_id: 1, member_id: meta.memberId, plan_id: plan.id,
              staff_id: meta.staffId ? parseInt(meta.staffId) : null,
              amount: planReceived,
              original_amount: planOriginal,
              discount_amount: planDiscount,
              unpaid_amount: planUnpaid,
              method: "card", status: "approved",
              payment_type: meta.memberMode === "existing" ? "재등록" : "신규",
              payment_group_id: meta.paymentGroupId,
              transactionId: nanoResult.tranNo || null,
              authCd: nanoResult.apprNo || null,
              cardIssuer: nanoResult.cardTxt || null,
            })}, token);
          }
        } catch(e) { console.error("저장 실패:", e); }
      }
      addToast(nanoResult.pg_method === "manual" ? "수기 카드 결제가 기록됐습니다 ✏️" : "결제가 완료됐습니다 💳", "success");
      if (onSuccess) onSuccess();
      handleClose();
    } catch(e) {
      addToast("저장 실패: " + e.message, "error");
    } finally {
      setSaving(false);
    }
  };

  const handleWizardComplete = async () => {
    if (selectedPlansForMember.length > 0 && !selectedPayMethod) {
      return addToast("결제수단을 선택해주세요", "error");
    }
    setSaving(true);
    try {
      // ── 1) 회원 처리 (기존/신규) ──
      let targetMember;
      if (memberMode === "existing") {
        if (!selectedExistingMember) {
          addToast("회원을 선택해주세요", "error");
          setSaving(false);
          return;
        }
        targetMember = selectedExistingMember;
      } else {
        // 신규 회원 등록
        if (!form.terms_agreed || !form.privacy_agreed) {
          addToast("필수 약관 동의를 체크해주세요", "error");
          setSaving(false);
          return;
        }
        const result = await api("/members/", {
          method: "POST",
          body: JSON.stringify({
            name: form.name, phone: form.phone, tenant_id: 1,
            gender: form.gender, address: form.address,
            birth_date: form.birth_date || null, memo: form.memo,
            visit_route: form.visit_route,
            exercise_purpose: form.exercise_purpose || null,
            trainer_id: form.trainer_id ? parseInt(form.trainer_id) : null,
            terms_agreed: form.terms_agreed,
            privacy_agreed: form.privacy_agreed,
            marketing_agreed: form.marketing_agreed,
          })
        }, token);
        targetMember = result.member || result;
        if (result.number_changed && result.message) addToast(result.message, "info");
        else if (result.member_number) addToast(`회원번호 ${result.member_number} 부여됨`, "success");

        // 프로필 이미지
        if (newMemberProfileImage) {
          try {
            const fd = new FormData();
            fd.append("file", newMemberProfileImage);
            await fetch(`https://heybiseo.ai.kr/members/${targetMember.id}/profile-image?tenant_id=1`, {
              method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd
            });
          } catch(e) { console.error("프로필 업로드 실패:", e); }
        }
      }

      // ── 2) 상품 + 결제 공통 변수 ──
      const memberId = targetMember.id;
      const memberName = targetMember.name;
      const paymentGroupId = `PG_${memberId}_${Date.now()}`;
      const totalPrice = selectedPlansForMember.reduce((sum, p) => sum + Number(p.card_price || p.cash_price || p.price || 0), 0);
      const discount = parseInt(discountAmount) || 0;
      const unpaid = parseInt(unpaidAmount) || 0;

      // ── 전자계약 발송 (3단계에서 양식을 고른 경우) ──
      // 카드 결제는 아래에서 모달로 빠지므로, 두 경로를 모두 커버하도록 결제 분기 '앞'에서 보낸다.
      // 서버가 회원앱 푸시를 먼저 시도하고, 앱 미사용 회원은 문자로 대체한다.
      if (selectedContract?.id) {
        const wonStr = n => `${Number(n || 0).toLocaleString()}원`;
        const periodOf = p => {
          if (!p.duration) return "";
          const u = { DAY: "일", YEAR: "년" }[String(p.duration_type || "MONTH").toUpperCase()] || "개월";
          return `${p.duration}${u}`;
        };
        try {
          const res = await api("/contract-pdf/send-self", {
            method: "POST",
            body: JSON.stringify({
              template_id: selectedContract.id,
              member_id: memberId,
              member_name: memberName,
              member_phone: (targetMember.phone || "").replace(/\D/g, ""),
              products: selectedPlansForMember.map(p => ({
                name: p.name || "",
                period: periodOf(p),
                count: p.sessions ? `${p.sessions}회` : "",
                price: wonStr(p.card_price || p.cash_price || p.price || 0),
              })),
              total_price: wonStr(totalPrice),
              discount: wonStr(discount),
              final_price: wonStr(Math.max(0, totalPrice - discount - unpaid)),
              pay_method: { card: "카드", cash: "현금", transfer: "계좌이체" }[selectedPayMethod] || "",
              start_date: form.payment_date || "",
              end_date: "",
              manager: "",   // 비우면 서버가 로그인한 직원으로 채운다
            })
          }, token);
          addToast(res?.channel === "sms" ? "계약서를 문자로 보냈습니다 ✉️" : "계약서 서명 요청을 보냈습니다 ✓", "success");
        } catch (e) {
          // 계약서 자체는 이미 생성돼 링크가 발급된 상태다. 서버 안내문(잔액·발신번호)을 그대로 보여준다.
          addToast("계약서 발송 실패: " + (e.message || ""), "error");
        }
      }

      // 카드 (나노 수기결제) - 카드 입력 모달 오픈
      if (selectedPlansForMember.length > 0 && selectedPayMethod === "card") {
        const finalAmount = Math.max(0, totalPrice - discount - unpaid);
        const planNames = selectedPlansForMember.map(p => p.name).join(", ");
        const memberPhone = (targetMember.phone || "").replace(/\D/g, "");
        setCardPayInfo({
          memberId,
          memberName,
          memberPhone,
          memberEmail: targetMember.email || "",
          goodsName: planNames,
          reqPayAmt: String(finalAmount),
          _meta: {
            memberId, memberName, memberMode, paymentGroupId,
            discount, unpaid, totalPrice, planList: selectedPlansForMember,
            staffId: form.staff_id, trainerId: form.trainer_id,
            paymentDate: form.payment_date,
          }
        });
        setSaving(false);
        setShowCardModal(true);
        return; // 모달에서 결제 완료 후 handleCardPaySuccess 호출
      }


      // 현금/계좌이체
      if (selectedPlansForMember.length > 0 && (selectedPayMethod === "cash" || selectedPayMethod === "transfer")) {
        for (const plan of selectedPlansForMember) {
          const planPrice = Number(plan.card_price || plan.cash_price || plan.price || 0);
          const planRatio = totalPrice > 0 ? planPrice / totalPrice : 0;
          const planOriginal = planPrice;
          const planDiscount = Math.round(discount * planRatio);
          const planUnpaid = Math.round(unpaid * planRatio);
          const planReceived = Math.max(0, planOriginal - planDiscount - planUnpaid);
          try {
            await api("/membership/by-plan", { method: "POST", body: JSON.stringify({
              tenant_id: 1, member_id: memberId, plan_id: plan.id,
              start_date: form.payment_date || ymdKST(),
              total_count: plan.sessions || null,
              trainer_id: form.trainer_id ? parseInt(form.trainer_id) : null,
            })}, token);
            await api("/payment", { method: "POST", body: JSON.stringify({
              tenant_id: 1, member_id: memberId, plan_id: plan.id,
              staff_id: form.staff_id ? parseInt(form.staff_id) : null,
              amount: planReceived,
              original_amount: planOriginal,
              discount_amount: planDiscount,
              unpaid_amount: planUnpaid,
              method: selectedPayMethod, status: "approved",
              payment_type: memberMode === "existing" ? "재등록" : "신규",
              payment_group_id: paymentGroupId
            })}, token);
          } catch(e) { console.error("저장 실패:", e); }
        }
        addToast("결제가 완료됐습니다 🎉", "success");
      } else if (memberMode === "new") {
        addToast("회원이 등록됐습니다", "success");
      }

      // ── 3) 전자계약 ──
      // 계약서 발송은 위 "전자계약 발송" 블록(결제 분기 앞)에서 이미 처리됨

      if (onSuccess) onSuccess();
      handleClose();
    } catch(e) {
      addToast("저장 실패: " + e.message, "error");
    } finally {
      setSaving(false);
    }
  };

  // ── 신규 회원만 등록 (결제 없이) ──
  const handleSaveOnly = async () => {
    if (!form.name || !form.phone) return addToast("이름과 전화번호는 필수입니다", "error");
    if (!form.terms_agreed || !form.privacy_agreed) return addToast("필수 약관 동의를 체크해주세요", "error");
    setSaving(true);
    try {
      const result = await api("/members/", {
        method: "POST",
        body: JSON.stringify({
          name: form.name, phone: form.phone, tenant_id: 1,
          gender: form.gender, address: form.address,
          birth_date: form.birth_date || null, memo: form.memo,
          visit_route: form.visit_route,
          exercise_purpose: form.exercise_purpose || null,
          trainer_id: form.trainer_id ? parseInt(form.trainer_id) : null,
          terms_agreed: form.terms_agreed,
          privacy_agreed: form.privacy_agreed,
          marketing_agreed: form.marketing_agreed,
        })
      }, token);

      if (result.number_changed && result.message) addToast(result.message, "info");
      else if (result.member_number) addToast(`회원번호 ${result.member_number} 부여됨`, "success");

      const newMember = result.member || result;
      if (newMemberProfileImage) {
        try {
          const fd = new FormData();
          fd.append("file", newMemberProfileImage);
          await fetch(`https://heybiseo.ai.kr/members/${newMember.id}/profile-image?tenant_id=1`, {
            method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd
          });
        } catch(e) { console.error("프로필 업로드 실패:", e); }
      }

      addToast("회원이 등록됐습니다", "success");
      if (onSuccess) onSuccess();
      handleClose();
    } catch(e) {
      addToast("저장 실패: " + e.message, "error");
    } finally {
      setSaving(false);
    }
  };

  // ── 렌더링 ──
  if (!open) return null;

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 880, maxHeight: "92vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 24px 80px rgba(0,0,0,0.2)" }}>

        {/* 헤더 */}
        <div style={{ background: "#fff", padding: "18px 24px 14px", borderBottom: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <h3 style={{ margin: "0 0 3px", fontSize: 16, fontWeight: 500, color: "#111827" }}>
              {addStep === 1 ? (defaultMember ? `${defaultMember.name}님 결제` : "신규 회원 등록") : addStep === 2 ? "상품 선택" : addStep === 3 ? "계약서 작성" : "최종 결제"}
            </h3>
            <p style={{ margin: 0, fontSize: 12, color: "#6b7280" }}>
              {addStep === 1 ? "회원의 정보를 입력해주세요." :
               addStep === 2 ? "구매할 상품을 선택해주세요. 여러 개 선택 가능합니다." :
               addStep === 3 ? "서명받을 계약서 템플릿을 선택해주세요." :
               "결제 정보를 확인하고 진행해주세요."}
            </p>
          </div>
          <button onClick={handleClose}
            style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 6, width: 28, height: 28, color: "#6b7280", fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
        </div>

        {/* 스텝 인디케이터 */}
        <div style={{ background: "#fafbfc", padding: "18px 60px", borderBottom: "1px solid #f0f0f0" }}>
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            {[
              { step: 1, label: "기본정보" },
              { step: 2, label: "상품선택" },
              { step: 3, label: "계약서" },
              { step: 4, label: "최종결제" },
            ].map((s, i) => (
              <React.Fragment key={s.step}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, flexShrink: 0 }}>
                  <div style={{
                    width: 32, height: 32, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
                    background: addStep >= s.step ? "#2563eb" : "#e5e7eb",
                    color: addStep >= s.step ? "#fff" : "#9ca3af",
                    fontSize: 13, fontWeight: 500
                  }}>{addStep > s.step ? "✓" : s.step}</div>
                  <span style={{ fontSize: 11, color: addStep >= s.step ? "#2563eb" : "#9ca3af", fontWeight: addStep === s.step ? 500 : 400 }}>{s.label}</span>
                </div>
                {i < 3 && (
                  <div style={{
                    flex: 1, height: 3, borderRadius: 2,
                    background: addStep > s.step ? "#2563eb" : (addStep === s.step ? "linear-gradient(to right, #2563eb 50%, #e5e7eb 50%)" : "#e5e7eb"),
                    margin: "14px 8px 0"
                  }} />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* 바디 */}
        <div style={{ flex: 1, overflowY: "auto", padding: "18px 24px 22px", background: "#fafbfc" }}>

          {/* 1단계 - 기본정보 */}
          {addStep === 1 && (
            <>
              {/* defaultMember가 있으면 모드 토글 숨김 (이미 회원 정해짐) */}
              {!defaultMember && (
                <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "14px 18px", marginBottom: 14, display: "flex", gap: 8 }}>
                  <button onClick={() => {
                    setMemberMode("existing");
                    setForm({
                      name: "", phone: "", gender: "", birth_date: "", address: "",
                      memo: "", visit_route: "", trainer_id: "",
                      exercise_purpose: "", staff_id: "",
                      payment_date: ymdKST(),
    terms_agreed: false, privacy_agreed: false, marketing_agreed: false,
  });
                  }} style={{
                    flex: 1, padding: "11px 0", borderRadius: 8,
                    border: `1.5px solid ${memberMode === "existing" ? "#2563eb" : "#e5e7eb"}`,
                    background: memberMode === "existing" ? "#eff6ff" : "#fff",
                    color: memberMode === "existing" ? "#2563eb" : "#374151",
                    fontSize: 13, fontWeight: 500, cursor: "pointer"
                  }}>
                    🔍 기존 회원
                  </button>
                  <button onClick={() => {
                    setMemberMode("new");
                    setSelectedExistingMember(null);
                    setMemberSearchQuery("");
                  }} style={{
                    flex: 1, padding: "11px 0", borderRadius: 8,
                    border: `1.5px solid ${memberMode === "new" ? "#2563eb" : "#e5e7eb"}`,
                    background: memberMode === "new" ? "#eff6ff" : "#fff",
                    color: memberMode === "new" ? "#2563eb" : "#374151",
                    fontSize: 13, fontWeight: 500, cursor: "pointer"
                  }}>
                    ✨ 신규 회원 등록
                  </button>
                </div>
              )}

              {/* ━━━━━ 모드 1: 기존 회원 검색 ━━━━━ */}
              {memberMode === "existing" && (
                <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 22px" }}>
                  <div style={{ display: "flex", alignItems: "flex-start", gap: 11, marginBottom: 16 }}>
                    <div style={{ width: 32, height: 32, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <Icon name="search" size={16} color="#2563eb" />
                    </div>
                    <div>
                      <h5 style={{ margin: "0 0 2px", fontSize: 13, fontWeight: 500, color: "#111827" }}>회원 검색</h5>
                      <p style={{ margin: 0, fontSize: 11, color: "#9ca3af" }}>이름/전화번호로 회원을 찾아주세요.</p>
                    </div>
                  </div>

                  {!selectedExistingMember && (
                    <div style={{ position: "relative" }}>
                      <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9ca3af", display: "flex" }}>
                        <Icon name="search" size={14} />
                      </span>
                      <input
                        value={memberSearchQuery}
                        onChange={e => setMemberSearchQuery(e.target.value)}
                        placeholder="회원 이름 또는 전화번호 입력"
                        autoFocus
                        style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px 0 36px", fontSize: 13, color: "#111", height: 40, outline: "none", boxSizing: "border-box" }} />

                      {memberSearchQuery && (
                        <div style={{ marginTop: 8, border: "1px solid #e5e7eb", borderRadius: 8, maxHeight: 240, overflowY: "auto", background: "#fff" }}>
                          {(() => {
                            const filtered = members.filter(m =>
                              m.name?.includes(memberSearchQuery) ||
                              m.phone?.includes(memberSearchQuery) ||
                              m.member_number?.includes(memberSearchQuery)
                            ).slice(0, 20);
                            if (filtered.length === 0) return (
                              <div style={{ padding: "20px", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>
                                검색 결과가 없습니다
                              </div>
                            );
                            return filtered.map(m => (
                              <div key={m.id} onClick={() => {
                                setSelectedExistingMember(m);
                                setMemberSearchQuery("");
                              }} style={{
                                padding: "10px 14px", borderBottom: "1px solid #f3f4f6",
                                cursor: "pointer", display: "flex", alignItems: "center", gap: 10
                              }}
                                onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                                onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                                <div style={{ width: 32, height: 32, borderRadius: "50%", background: m.gender === "female" ? "#fce7f3" : "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                  <Icon name="members" size={14} color={m.gender === "female" ? "#ec4899" : "#2563eb"} />
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ fontSize: 13, fontWeight: 500, color: "#111827" }}>{m.name}</div>
                                  <div style={{ fontSize: 11, color: "#9ca3af" }}>
                                    {m.phone}
                                    {m.member_number && <span style={{ marginLeft: 6, color: "#2563eb", fontFamily: "monospace" }}>#{m.member_number}</span>}
                                  </div>
                                </div>
                              </div>
                            ));
                          })()}
                        </div>
                      )}
                    </div>
                  )}

                  {/* 선택된 회원 카드 */}
                  {selectedExistingMember && (
                    <div style={{ background: "#eff6ff", border: "1.5px solid #2563eb", borderRadius: 10, padding: "16px 18px", display: "flex", alignItems: "center", gap: 14 }}>
                      <div style={{ width: 48, height: 48, borderRadius: "50%", background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", border: "1px solid #bfdbfe", flexShrink: 0 }}>
                        {selectedExistingMember.profile_image ? (
                          <img src={`https://heybiseo.ai.kr/${selectedExistingMember.profile_image}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        ) : (
                          <Icon name="members" size={24} color={selectedExistingMember.gender === "female" ? "#ec4899" : "#2563eb"} />
                        )}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                          <span style={{ fontSize: 15, fontWeight: 500, color: "#111827" }}>{selectedExistingMember.name}</span>
                          {selectedExistingMember.member_number && (
                            <span style={{ fontSize: 10, fontWeight: 500, background: "#fff", color: "#2563eb", padding: "2px 8px", borderRadius: 4, fontFamily: "monospace", border: "1px solid #bfdbfe" }}>
                              #{selectedExistingMember.member_number}
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: 12, color: "#374151", marginBottom: 2 }}>{selectedExistingMember.phone || "-"}</div>
                        <div style={{ fontSize: 11, color: "#6b7280" }}>
                          {selectedExistingMember.gender === "male" ? "남성" : selectedExistingMember.gender === "female" ? "여성" : "-"}
                          {selectedExistingMember.birth_date && ` · ${selectedExistingMember.birth_date}`}
                        </div>
                      </div>
                      {!defaultMember && (
                        <button onClick={() => {
                          setSelectedExistingMember(null);
                          setMemberSearchQuery("");
                        }} style={{
                          padding: "7px 12px", borderRadius: 6, border: "1px solid #bfdbfe",
                          background: "#fff", color: "#2563eb", fontSize: 11, fontWeight: 500, cursor: "pointer"
                        }}>변경</button>
                      )}
                    </div>
                  )}

                  {/* 기존 회원: 상담사 + 담당강사 */}
                  {selectedExistingMember && (
                    <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "16px 18px", marginTop: 14 }}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div>
                          <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 5 }}>
                            <label style={{ fontSize: 11, color: "#374151", fontWeight: 700 }}>상담사</label>
                            <span style={{ fontSize: 9, background: "#fee2e2", color: "#dc2626", padding: "1px 5px", borderRadius: 3, fontWeight: 500 }}>필수·매출귀속</span>
                          </div>
                          <select value={form.staff_id} onChange={e => setForm(p => ({ ...p, staff_id: e.target.value }))}
                            style={{ width: "100%", background: form.staff_id ? "#eff6ff" : "#fff", border: "1.5px solid " + (form.staff_id ? "#2563eb" : "#e5e7eb"), borderRadius: 8, padding: "0 10px", fontSize: 12, color: form.staff_id ? "#111" : "#9ca3af", height: 36, outline: "none", boxSizing: "border-box", cursor: "pointer" }}>
                            <option value="">상담사 선택</option>
                            {trainers.filter(s => s.role !== "SUPERADMIN").map(s => <option key={s.id} value={s.id}>{s.name}{s.role ? ` (${s.role})` : ""}</option>)}
                          </select>
                          {form.staff_id && (
                            <div style={{ marginTop: 5, background: "#fef9c3", border: "0.5px solid #fde047", borderRadius: 5, padding: "5px 8px", fontSize: 10, color: "#854d0e", display: "flex", gap: 4 }}>
                              <span>⚠</span>
                              <span>이 결제 매출은 <strong>{trainers.find(s => String(s.id) === String(form.staff_id))?.name}</strong>에게 귀속됩니다</span>
                            </div>
                          )}
                        </div>
                        <div>
                          <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 5 }}>
                            <label style={{ fontSize: 11, color: "#374151", fontWeight: 700 }}>담당강사</label>
                            <span style={{ fontSize: 9, background: "#f3f4f6", color: "#6b7280", padding: "1px 5px", borderRadius: 3 }}>선택·매출무관</span>
                          </div>
                          <select value={form.trainer_id} onChange={e => setForm(p => ({ ...p, trainer_id: e.target.value }))}
                            style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 10px", fontSize: 12, color: form.trainer_id ? "#111" : "#9ca3af", height: 36, outline: "none", boxSizing: "border-box", cursor: "pointer" }}>
                            <option value="">선택 안함</option>
                            {trainers.filter(t => t.role === "TRAINER").map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                          </select>
                          <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 4 }}>회원 관리 강사 (급여 정산 무관)</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* ━━━━━ 모드 2: 신규 회원 입력 ━━━━━ */}
              {memberMode === "new" && (
                <>
                  {/* 섹션 1: 기본정보 */}
                  <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 22px", marginBottom: 14 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 11, marginBottom: 16 }}>
                      <div style={{ width: 32, height: 32, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-7 8-7s8 3 8 7"/></svg>
                      </div>
                      <div>
                        <h5 style={{ margin: "0 0 2px", fontSize: 13, fontWeight: 500, color: "#111827" }}>기본정보</h5>
                        <p style={{ margin: 0, fontSize: 11, color: "#9ca3af" }}>회원의 기본 정보를 입력해주세요.</p>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
                      <div style={{ width: 178, flexShrink: 0, border: "1px dashed #d1d5db", borderRadius: 10, padding: "14px 12px 10px", display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
                        <div style={{ width: 76, height: 76, borderRadius: "50%", background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                          {newMemberProfileImage ? (
                            <img src={URL.createObjectURL(newMemberProfileImage)} alt="프로필" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          ) : (
                            <Icon name="members" size={36} color="#9ca3af" />
                          )}
                        </div>
                        <div style={{ display: "flex", gap: 6 }}>
                          <button type="button" onClick={() => setShowCameraForNewMember(true)}
                            style={{ padding: "5px 9px", fontSize: 11, borderRadius: 6, border: "1px solid #d1d5db", background: "#fff", color: "#374151", cursor: "pointer", whiteSpace: "nowrap" }}>📷 사진촬영</button>
                          <label htmlFor="wizard-profile-upload" style={{ padding: "5px 9px", fontSize: 11, borderRadius: 6, border: "1px solid #d1d5db", background: "#fff", color: "#374151", cursor: "pointer", whiteSpace: "nowrap" }}>📁 파일선택</label>
                          <input id="wizard-profile-upload" type="file" accept="image/*" style={{ display: "none" }}
                            onChange={(e) => { const f = e.target.files[0]; if (f) setNewMemberProfileImage(f); e.target.value = ""; }} />
                        </div>
                        <div style={{ fontSize: 10, color: "#9ca3af" }}>JPG, PNG (최대 5MB)</div>
                        {newMemberProfileImage && (
                          <button type="button" onClick={() => setNewMemberProfileImage(null)}
                            style={{ padding: "3px 8px", fontSize: 10, borderRadius: 4, border: "1px solid #fecaca", background: "#fff", color: "#ef4444", cursor: "pointer" }}>✕ 제거</button>
                        )}
                        <CameraCaptureModal
                          isOpen={showCameraForNewMember}
                          onClose={() => setShowCameraForNewMember(false)}
                          onCapture={(file) => { setNewMemberProfileImage(file); setShowCameraForNewMember(false); }}
                        />
                      </div>
                      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 12 }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                          <div>
                            <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>이름 <span style={{ color: "#ef4444" }}>*</span></label>
                            <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="이름 입력"
                              style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", fontSize: 12, color: "#111", height: 36, outline: "none", boxSizing: "border-box" }} />
                          </div>
                          <div>
                            <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>전화번호 <span style={{ color: "#ef4444" }}>*</span></label>
                            <input value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} placeholder="010-1234-5678"
                              style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", fontSize: 12, color: "#111", height: 36, outline: "none", boxSizing: "border-box" }} />
                          </div>
                          <div>
                            <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>
                              회원번호 <span style={{ fontSize: 9, background: "#eff6ff", color: "#2563eb", padding: "2px 6px", borderRadius: 4, fontWeight: 500, marginLeft: 4 }}>자동생성</span>
                            </label>
                            <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "0 12px", fontSize: 13, color: "#2563eb", fontWeight: 500, fontFamily: "monospace", height: 36, display: "flex", alignItems: "center", boxSizing: "border-box" }}>
                              {form.phone ? (form.phone.replace(/\D/g, "").slice(-4) || "—") : "—"}
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                          <div>
                            <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>성별</label>
                            <select value={form.gender} onChange={e => setForm(p => ({ ...p, gender: e.target.value }))}
                              style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", fontSize: 12, color: form.gender ? "#111" : "#9ca3af", height: 36, outline: "none", boxSizing: "border-box", cursor: "pointer" }}>
                              <option value="">선택</option>
                              <option value="male">남성</option>
                              <option value="female">여성</option>
                            </select>
                          </div>
                          <div>
                            <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>생년월일</label>
                            <input type="date" value={form.birth_date} onChange={e => setForm(p => ({ ...p, birth_date: e.target.value }))}
                              style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", fontSize: 12, color: "#111", height: 36, outline: "none", boxSizing: "border-box" }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 섹션 2: 상담/등록 정보 */}
                  <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 22px", marginBottom: 14 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 11, marginBottom: 16 }}>
                      <div style={{ width: 32, height: 32, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><rect x="6" y="3" width="12" height="18" rx="2"/><path d="M9 7h6M9 11h6M9 15h4"/></svg>
                      </div>
                      <div>
                        <h5 style={{ margin: "0 0 2px", fontSize: 13, fontWeight: 500, color: "#111827" }}>상담 / 등록 정보</h5>
                        <p style={{ margin: 0, fontSize: 11, color: "#9ca3af" }}>회원 상담 및 등록 관련 정보를 입력해주세요.</p>
                      </div>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                      {/* 상담사 - 전체 직원, 매출귀속 */}
                      <div style={{ gridColumn: "1 / -1" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                          <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 5 }}>
                              <label style={{ fontSize: 11, color: "#374151", fontWeight: 700 }}>상담사</label>
                              <span style={{ fontSize: 9, background: "#fee2e2", color: "#dc2626", padding: "1px 5px", borderRadius: 3, fontWeight: 500 }}>필수·매출귀속</span>
                            </div>
                            <select value={form.staff_id} onChange={e => setForm(p => ({ ...p, staff_id: e.target.value }))}
                              style={{ width: "100%", background: form.staff_id ? "#eff6ff" : "#fff", border: "1.5px solid " + (form.staff_id ? "#2563eb" : "#e5e7eb"), borderRadius: 8, padding: "0 10px", fontSize: 12, color: form.staff_id ? "#111" : "#9ca3af", height: 36, outline: "none", boxSizing: "border-box", cursor: "pointer" }}>
                              <option value="">상담사 선택</option>
                              {trainers.filter(s => s.role !== "SUPERADMIN").map(s => <option key={s.id} value={s.id}>{s.name}{s.role ? ` (${s.role})` : ""}</option>)}
                            </select>
                            {form.staff_id && (
                              <div style={{ marginTop: 5, background: "#fef9c3", border: "0.5px solid #fde047", borderRadius: 5, padding: "5px 8px", fontSize: 10, color: "#854d0e", display: "flex", gap: 4 }}>
                                <span>⚠</span>
                                <span>이 결제 매출은 <strong>{trainers.find(s => String(s.id) === String(form.staff_id))?.name}</strong>에게 귀속됩니다</span>
                              </div>
                            )}
                          </div>
                          <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 5 }}>
                              <label style={{ fontSize: 11, color: "#374151", fontWeight: 700 }}>담당강사</label>
                              <span style={{ fontSize: 9, background: "#f3f4f6", color: "#6b7280", padding: "1px 5px", borderRadius: 3 }}>선택·매출무관</span>
                            </div>
                            <select value={form.trainer_id} onChange={e => setForm(p => ({ ...p, trainer_id: e.target.value }))}
                              style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 10px", fontSize: 12, color: form.trainer_id ? "#111" : "#9ca3af", height: 36, outline: "none", boxSizing: "border-box", cursor: "pointer" }}>
                              <option value="">선택 안함</option>
                              {trainers.filter(t => t.role === "TRAINER").map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                            </select>
                            <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 4 }}>회원 관리 강사 (급여 정산 무관)</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 운동목적 / 방문경로 */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 10 }}>
                      <div>
                        <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>운동 목적</label>
                        <select value={form.exercise_purpose || ""} onChange={e => setForm(p => ({ ...p, exercise_purpose: e.target.value }))}
                          style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", fontSize: 12, color: form.exercise_purpose ? "#111" : "#9ca3af", height: 36, outline: "none", boxSizing: "border-box", cursor: "pointer" }}>
                          <option value="">선택 안함</option>
                          <option value="다이어트">다이어트</option>
                          <option value="근력증대">근력증대</option>
                          <option value="체력향상">체력향상</option>
                          <option value="건강관리">건강관리</option>
                          <option value="바디프로필">바디프로필</option>
                          <option value="재활/통증완화">재활/통증완화</option>
                          <option value="기타">기타</option>
                        </select>
                      </div>
                      <div>
                        <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>방문 경로</label>
                        <select value={form.visit_route} onChange={e => setForm(p => ({ ...p, visit_route: e.target.value }))}
                          style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", fontSize: 12, color: form.visit_route ? "#111" : "#9ca3af", height: 36, outline: "none", boxSizing: "border-box", cursor: "pointer" }}>
                          <option value="">선택 안함</option>
                          {visitRouteOptions.map(v => <option key={v} value={v}>{v}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* 섹션 3: 추가 정보 */}
                  <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 22px" }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 11, marginBottom: 16 }}>
                      <div style={{ width: 32, height: 32, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><path d="M3 12L12 4l9 8M5 10v10h14V10"/></svg>
                      </div>
                      <div>
                        <h5 style={{ margin: "0 0 2px", fontSize: 13, fontWeight: 500, color: "#111827" }}>추가 정보</h5>
                        <p style={{ margin: 0, fontSize: 11, color: "#9ca3af" }}>회원의 추가 정보를 입력해주세요.</p>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                      <div>
                        <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>주소</label>
                        <input value={form.address} onChange={e => setForm(p => ({ ...p, address: e.target.value }))} placeholder="주소 입력"
                          style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", fontSize: 12, color: "#111", height: 36, outline: "none", boxSizing: "border-box" }} />
                      </div>
                      <div>
                        <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>메모</label>
                        <div style={{ position: "relative" }}>
                          <textarea value={form.memo} onChange={e => setForm(p => ({ ...p, memo: e.target.value.slice(0, 500) }))} placeholder="특이사항 입력 (선택 사항)" rows={3}
                            style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "9px 12px", fontSize: 12, color: "#111", outline: "none", boxSizing: "border-box", resize: "vertical", fontFamily: "inherit", minHeight: 56 }} />
                          <span style={{ position: "absolute", bottom: 6, right: 10, fontSize: 10, color: "#9ca3af" }}>{(form.memo || "").length} / 500</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 섹션 4: 약관 동의 */}
                  <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 22px", marginTop: 14 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 11, marginBottom: 16 }}>
                      <div style={{ width: 32, height: 32, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <span style={{ fontSize: 14 }}>📋</span>
                      </div>
                      <div>
                        <h5 style={{ margin: "0 0 2px", fontSize: 13, fontWeight: 500, color: "#111827" }}>약관 동의</h5>
                        <p style={{ margin: 0, fontSize: 11, color: "#9ca3af" }}>회원으로부터 서면 동의를 받은 후 체크해주세요</p>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      {[
                        { key: "terms_agreed", required: true, label: "이용약관", url: "https://heybiseo.ai.kr/terms.html" },
                        { key: "privacy_agreed", required: true, label: "개인정보 수집·이용 동의", url: "https://heybiseo.ai.kr/privacy.html" },
                        { key: "marketing_agreed", required: false, label: "마케팅 정보 수신 동의", url: null },
                      ].map(item => (
                        <div key={item.key}
                          onClick={() => setForm(p => ({ ...p, [item.key]: !p[item.key] }))}
                          style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 4px", cursor: "pointer", borderRadius: 6 }}>
                          <div style={{
                            width: 20, height: 20, borderRadius: 5,
                            border: `1.5px solid ${form[item.key] ? "#2563eb" : "#d1d5db"}`,
                            background: form[item.key] ? "#2563eb" : "#fff",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            color: "#fff", fontSize: 12, fontWeight: 700, flexShrink: 0
                          }}>{form[item.key] && "✓"}</div>
                          <span style={{ fontSize: 12, color: "#374151", flex: 1 }}>
                            <span style={{ color: item.required ? "#dc2626" : "#6b7280", fontWeight: 600 }}>
                              [{item.required ? "필수" : "선택"}]
                            </span> {item.label}
                          </span>
                          {item.url && (
                            <a href={item.url} target="_blank" rel="noreferrer"
                              onClick={e => e.stopPropagation()}
                              style={{ fontSize: 11, color: "#6b7280", textDecoration: "underline" }}>보기</a>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {/* 2단계 - 상품 선택 (다중 선택) */}
          {addStep === 2 && (
            <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 22px" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: 11, marginBottom: 16 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><path d="M6 6h15l-2 12H8L6 6zM6 6L5 3H2"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>
                </div>
                <div>
                  <h5 style={{ margin: "0 0 2px", fontSize: 13, fontWeight: 500, color: "#111827" }}>상품 목록</h5>
                  <p style={{ margin: 0, fontSize: 11, color: "#9ca3af" }}>카테고리별로 상품을 확인하고 선택할 수 있습니다.</p>
                </div>
              </div>

              <div style={{ position: "relative", marginBottom: 12 }}>
                <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9ca3af", display: "flex" }}>
                  <Icon name="search" size={14} />
                </span>
                <input value={productSearch} onChange={e => setProductSearch(e.target.value)} placeholder="상품명 검색"
                  style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px 0 36px", fontSize: 12, color: "#111", height: 38, outline: "none", boxSizing: "border-box" }} />
              </div>

              <div style={{ display: "flex", gap: 6, marginBottom: 14, flexWrap: "wrap" }}>
                {[
                  { id: "all", label: "전체" },
                  { id: "membership", label: "회원권" },
                  { id: "pt", label: "PT" },
                  { id: "gx", label: "GX" },
                  { id: "locker", label: "락커" },
                  { id: "clothes", label: "운동복" },
                ].map(c => (
                  <button key={c.id} onClick={() => setProductCategory(c.id)}
                    style={{
                      padding: "7px 14px", borderRadius: 20, fontSize: 12,
                      border: `1px solid ${productCategory === c.id ? "#2563eb" : "#e5e7eb"}`,
                      background: productCategory === c.id ? "#2563eb" : "#fff",
                      color: productCategory === c.id ? "#fff" : "#6b7280",
                      fontWeight: productCategory === c.id ? 500 : 400, cursor: "pointer"
                    }}>{c.label}</button>
                ))}
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {(() => {
                  const catColors = {
                    membership: { bg: "#dbeafe", color: "#1d4ed8", label: "회원권" },
                    pt: { bg: "#dcfce7", color: "#16a34a", label: "PT" },
                    gx: { bg: "#fef3c7", color: "#b45309", label: "GX" },
                    locker: { bg: "#f3e8ff", color: "#7c3aed", label: "락커" },
                    clothes: { bg: "#fce7f3", color: "#be185d", label: "운동복" },
                  };
                  const filteredPlans = plans.filter(p => {
                    if (productCategory !== "all" && p.category !== productCategory) return false;
                    if (productSearch && !p.name?.includes(productSearch)) return false;
                    return true;
                  });
                  if (filteredPlans.length === 0) return (
                    <div style={{ textAlign: "center", padding: 30, color: "#9ca3af", fontSize: 13 }}>해당 카테고리에 상품이 없습니다</div>
                  );
                  return filteredPlans.map(p => {
                    const isSelected = selectedPlansForMember.some(sp => sp.id === p.id);
                    const cat = catColors[p.category] || { bg: "#f3f4f6", color: "#6b7280", label: p.category || "기타" };
                    return (
                      <div key={p.id} onClick={() => {
                        if (isSelected) {
                          setSelectedPlansForMember(selectedPlansForMember.filter(sp => sp.id !== p.id));
                        } else {
                          setSelectedPlansForMember([...selectedPlansForMember, p]);
                        }
                      }} style={{
                        border: `${isSelected ? "1.5px" : "1px"} solid ${isSelected ? "#2563eb" : "#e5e7eb"}`,
                        borderRadius: 10,
                        padding: isSelected ? "11.5px 13.5px" : "12px 14px",
                        display: "flex", alignItems: "center", gap: 12,
                        background: isSelected ? "#eff6ff" : "#fff",
                        cursor: "pointer"
                      }}>
                        <div style={{
                          width: 18, height: 18, borderRadius: 5,
                          border: `1.5px solid ${isSelected ? "#2563eb" : "#d1d5db"}`,
                          background: isSelected ? "#2563eb" : "#fff",
                          flexShrink: 0,
                          display: "flex", alignItems: "center", justifyContent: "center",
                          color: "#fff", fontSize: 12, fontWeight: 700
                        }}>{isSelected && "✓"}</div>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
                            <span style={{ display: "inline-block", padding: "2px 7px", borderRadius: 4, fontSize: 10, fontWeight: 500, background: cat.bg, color: cat.color }}>{cat.label}</span>
                            <span style={{ fontSize: 13, fontWeight: 500, color: "#111827" }}>{p.name}</span>
                          </div>
                          <div style={{ fontSize: 11, color: "#9ca3af" }}>
                            {p.duration_value ? `${p.duration_value}${p.duration_unit === "day" ? "일" : "개월"}` : ""}
                            {p.sessions ? ` · ${p.sessions}회` : ""}
                          </div>
                        </div>
                        <div style={{ fontSize: 14, fontWeight: 500, color: "#111827" }}>
                          {(p.card_price || p.cash_price || p.price || 0).toLocaleString()}원
                        </div>
                      </div>
                    );
                  });
                })()}
              </div>

              {selectedPlansForMember.length > 0 && (
                <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 12 }}>
                  <span style={{ fontSize: 12, color: "#2563eb", fontWeight: 500 }}>선택된 상품 {selectedPlansForMember.length}개</span>
                  <span style={{ fontSize: 16, fontWeight: 500, color: "#2563eb" }}>
                    {selectedPlansForMember.reduce((sum, p) => sum + Number(p.card_price || p.cash_price || p.price || 0), 0).toLocaleString()}원
                  </span>
                </div>
              )}
            </div>
          )}

          {/* 3단계 - 계약서 (자체 전자계약) */}
          {addStep === 3 && (
            <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 22px" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: 11, marginBottom: 16 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 14l2 2 4-4"/></svg>
                </div>
                <div>
                  <h5 style={{ margin: "0 0 2px", fontSize: 13, fontWeight: 500, color: "#111827" }}>계약서 템플릿</h5>
                  <p style={{ margin: 0, fontSize: 11, color: "#9ca3af" }}>서명 요청을 보낼 계약서를 선택해주세요.</p>
                </div>
              </div>
              <div style={{ background: "#fef3c7", border: "1px solid #fde68a", borderRadius: 8, padding: "10px 14px", fontSize: 12, color: "#854d0e", marginBottom: 14, display: "flex", gap: 8, alignItems: "center" }}>
                <span style={{ fontSize: 14 }}>💬</span>
                <span>등록이 완료되면 회원에게 서명 요청이 자동 발송됩니다 (회원앱 알림, 앱 미사용 시 문자)</span>
              </div>
              {modusignTemplates.length === 0 ? (
                <div style={{ textAlign: "center", padding: 40, color: "#9ca3af", fontSize: 13 }}>
                  등록된 계약서 양식이 없습니다<br />
                  <span style={{ fontSize: 11 }}>전자계약 메뉴에서 양식을 먼저 만들어주세요</span>
                </div>
              ) : (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  {modusignTemplates.map(t => {
                    const isSelected = selectedContract?.id === t.id;
                    return (
                      <div key={t.id} onClick={() => setSelectedContract(isSelected ? null : t)}
                        style={{
                          border: `${isSelected ? "1.5px" : "1px"} solid ${isSelected ? "#2563eb" : "#e5e7eb"}`,
                          borderRadius: 10,
                          padding: isSelected ? "11.5px 13.5px" : "12px 14px",
                          background: isSelected ? "#eff6ff" : "#fff",
                          cursor: "pointer"
                        }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 3 }}>
                          <span style={{ fontSize: 13, fontWeight: 500, color: "#111827" }}>{t.name}</span>
                          {isSelected && <span style={{ color: "#2563eb", fontWeight: 700, fontSize: 14 }}>✓</span>}
                        </div>
                        <div style={{ fontSize: 11, color: "#9ca3af" }}>전자계약 양식</div>
                      </div>
                    );
                  })}
                </div>
              )}
              <div style={{ background: "#f9fafb", border: "1px dashed #d1d5db", borderRadius: 8, padding: "10px 14px", fontSize: 11, color: "#6b7280", textAlign: "center", marginTop: 14 }}>
                계약서 작성 없이 결제만 진행하려면 "건너뛰기" 버튼을 눌러주세요.
              </div>
              {/* 서명 방식 선택은 없앰 — 서버가 회원앱 푸시를 먼저 시도하고, 앱 미사용 회원은 문자로 대체한다 */}
            </div>
          )}
          {/* 4단계 - 결제 (영수증 + 결제수단) */}
          {addStep === 4 && (
            <>
              {/* 영수증 박스 */}
              <div style={{ background: "#fff", border: "1.5px solid #2563eb", borderRadius: 12, padding: "18px 22px", marginBottom: 14 }}>
                <div style={{ fontSize: 11, color: "#2563eb", marginBottom: 12, fontWeight: 500 }}>금액 내역</div>

                {selectedPlansForMember.length === 0 ? (
                  <div style={{ textAlign: "center", padding: 24, color: "#9ca3af", fontSize: 13 }}>
                    선택된 상품이 없습니다.<br />
                    <span style={{ fontSize: 11 }}>"건너뛰기"로 결제 없이 등록만 진행할 수 있습니다.</span>
                  </div>
                ) : (
                  <>
                    {selectedPlansForMember.map(p => (
                      <div key={p.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
                        <span style={{ color: "#374151" }}>{p.name}</span>
                        <span style={{ color: "#111827" }}>{Number(p.card_price || p.cash_price || p.price || 0).toLocaleString()}원</span>
                      </div>
                    ))}

                    <div style={{ borderTop: "1px solid #e5e7eb", margin: "8px 0 4px" }} />

                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
                      <span style={{ color: "#374151" }}>원가 합계</span>
                      <span style={{ color: "#111827", fontWeight: 500 }}>
                        {selectedPlansForMember.reduce((sum, p) => sum + Number(p.card_price || p.cash_price || p.price || 0), 0).toLocaleString()}원
                      </span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
                      <span style={{ color: "#ef4444" }}>– 할인</span>
                      <input type="number" value={discountAmount} onChange={e => setDiscountAmount(e.target.value)} placeholder="0"
                        style={{ width: 120, background: "#fff", border: "1px solid #fecaca", borderRadius: 6, padding: "0 10px", fontSize: 12, color: "#ef4444", height: 30, outline: "none", textAlign: "right", boxSizing: "border-box" }} />
                    </div>

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
                      <span style={{ color: "#f97316" }}>– 미수금</span>
                      <input type="number" value={unpaidAmount} onChange={e => setUnpaidAmount(e.target.value)} placeholder="0"
                        style={{ width: 120, background: "#fff", border: "1px solid #fed7aa", borderRadius: 6, padding: "0 10px", fontSize: 12, color: "#f97316", height: 30, outline: "none", textAlign: "right", boxSizing: "border-box" }} />
                    </div>

                    <div style={{ borderTop: "1px solid #e5e7eb", margin: "8px 0 4px" }} />

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0" }}>
                      <span style={{ fontSize: 14, color: "#111827", fontWeight: 500 }}>실제 결제 금액</span>
                      <span style={{ fontSize: 22, fontWeight: 600, color: "#2563eb" }}>
                        {Math.max(0,
                          selectedPlansForMember.reduce((sum, p) => sum + Number(p.card_price || p.cash_price || p.price || 0), 0)
                          - (parseInt(discountAmount) || 0)
                          - (parseInt(unpaidAmount) || 0)
                        ).toLocaleString()}원
                      </span>
                    </div>
                  </>
                )}
              </div>

              {/* 결제수단 선택 */}
              {selectedPlansForMember.length > 0 && (
                <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 22px", marginBottom: 14 }}>
                  <div style={{ fontSize: 12, color: "#374151", marginBottom: 12, fontWeight: 500 }}>결제수단</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                    {[
                      { id: "card", label: "💳 카드", desc: "카드 정보 입력" },
                      { id: "cash", label: "💵 현금", desc: "즉시 저장" },
                      { id: "transfer", label: "🏦 계좌이체", desc: "즉시 저장" },
                    ].map(m => (
                      <button key={m.id} onClick={() => setSelectedPayMethod(m.id)}
                        style={{
                          padding: "13px 14px", borderRadius: 10, textAlign: "left",
                          border: `${selectedPayMethod === m.id ? "1.5px" : "1px"} solid ${selectedPayMethod === m.id ? "#2563eb" : "#e5e7eb"}`,
                          background: selectedPayMethod === m.id ? "#eff6ff" : "#fff",
                          cursor: "pointer"
                        }}>
                        <div style={{ fontSize: 13, fontWeight: 500, color: selectedPayMethod === m.id ? "#2563eb" : "#111827", marginBottom: 2 }}>{m.label}</div>
                        <div style={{ fontSize: 10, color: "#9ca3af" }}>{m.desc}</div>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* 결제일 */}
              <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "14px 18px" }}>
                <label style={{ display: "block", fontSize: 11, color: "#374151", marginBottom: 5, fontWeight: 500 }}>결제일</label>
                <input type="date" value={form.payment_date} onChange={e => setForm(p => ({ ...p, payment_date: e.target.value }))}
                  style={{ width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 12px", fontSize: 12, color: "#111", height: 36, outline: "none", boxSizing: "border-box" }} />
              </div>
            </>
          )}

        </div>

        {/* 푸터 - 단계별 버튼 */}
        {/* 카드 결제 모달 */}
      <CardPaymentModal
          isOpen={showCardModal}
          onClose={() => { setShowCardModal(false); setSaving(false); }}
          onSuccess={handleCardPaySuccess}
          orderInfo={cardPayInfo}
          token={token}
        />
        <div style={{ background: "#fff", padding: "12px 24px", borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "flex-end", gap: 8 }}>
          {/* 1단계 푸터 */}
          {addStep === 1 && (
            <>
              <button onClick={handleClose}
                style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>취소</button>
              {memberMode === "new" && (
                <button onClick={handleSaveOnly} disabled={saving}
                  style={{ padding: "10px 20px", borderRadius: 8, border: "1.5px solid #2563eb", background: "#fff", color: "#2563eb", fontSize: 13, fontWeight: 500, cursor: saving ? "not-allowed" : "pointer" }}>
                  {saving ? "저장 중..." : "등록하기 (결제없이)"}
                </button>
              )}
              <button onClick={() => {
                if (memberMode === "existing") {
                  if (!selectedExistingMember) return addToast("회원을 선택해주세요", "error");
                } else {
                  if (!form.name || !form.phone) return addToast("이름과 전화번호는 필수입니다", "error");
    if (!form.terms_agreed || !form.privacy_agreed) return addToast("필수 약관 동의를 체크해주세요", "error");
                }
                setAddStep(2);
              }}
                style={{ padding: "10px 24px", borderRadius: 8, border: "none", background: "#2563eb", color: "#fff", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>다음 →</button>
            </>
          )}

          {/* 2단계 푸터 */}
          {addStep === 2 && (
            <>
              <button onClick={() => setAddStep(1)}
                style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>← 이전</button>
              <button onClick={handleClose}
                style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>취소</button>
              <button onClick={() => {
                if (selectedPlansForMember.length === 0) return addToast("최소 1개의 상품을 선택해주세요", "error");
                setAddStep(3);
              }}
                style={{ padding: "10px 24px", borderRadius: 8, border: "none", background: "#2563eb", color: "#fff", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>다음 →</button>
            </>
          )}

          {/* 3단계 푸터 */}
          {addStep === 3 && (
            <>
              <button onClick={() => setAddStep(2)}
                style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>← 이전</button>
              <button onClick={() => setAddStep(4)}
                style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", color: "#6b7280", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>건너뛰기</button>
              <button onClick={() => {
                  // 자체 전자계약: 여기서는 양식만 고르고, 실제 발송은 마지막 완료 단계에서 한다.
                  // (그래야 상품·금액·결제수단이 확정된 상태로 계약서에 담긴다)
                  setAddStep(4);
                }}
                disabled={saving}
                style={{ padding: "10px 24px", borderRadius: 8, border: "none", background: saving ? "#9ca3af" : "#2563eb", color: "#fff", fontSize: 13, fontWeight: 500, cursor: saving ? "not-allowed" : "pointer" }}>
                {saving ? "처리 중..." : (selectedContract ? "다음 →" : "선택 안하고 다음 →")}
              </button>
            </>
          )}

          {/* 4단계 푸터 */}
          {addStep === 4 && (
            <>
              <button onClick={() => setAddStep(3)}
                style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>← 이전</button>
              <button onClick={handleClose}
                style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>취소</button>
              <button onClick={handleWizardComplete} disabled={saving}
                style={{ padding: "10px 24px", borderRadius: 8, border: "none", background: "#2563eb", color: "#fff", fontSize: 13, fontWeight: 500, cursor: saving ? "not-allowed" : "pointer" }}>
                {saving ? "처리 중..." : (selectedPlansForMember.length > 0 ? "💳 결제하기" : "등록하기")}
              </button>
            </>
          )}
        </div>

      </div>
      {/* 임베디드 서명 iframe 모달 */}
      {showSignIframe && embeddedUrl && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 1100, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 980, height: "92vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 24px 80px rgba(0,0,0,0.3)" }}>
            {/* 헤더 */}
            <div style={{ padding: "16px 24px", borderBottom: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff" }}>
              <div>
                <h3 style={{ margin: "0 0 3px", fontSize: 16, fontWeight: 500, color: "#111827" }}>📝 계약서 서명</h3>
                <p style={{ margin: 0, fontSize: 11, color: "#6b7280" }}>회원이 직접 서명을 입력해주세요. 완료 후 닫기 버튼을 눌러주세요.</p>
              </div>
             <button onClick={() => {
                setShowSignIframe(false);
                setEmbeddedUrl("");
                addToast("계약서 서명 완료! ✓", "success");
                setAddStep(4);
              }} style={{
                padding: "8px 16px", borderRadius: 8, border: "1px solid #2563eb",
                background: "#fff", color: "#2563eb", fontSize: 12, fontWeight: 500, cursor: "pointer"
              }}>✓ 서명 완료</button>
            </div>

            {/* iframe */}
            <div style={{ flex: 1, background: "#f9fafb" }}>
              <iframe
                src={embeddedUrl}
                style={{ width: "100%", height: "100%", border: "none" }}
                title="계약서 서명"
                allow="camera"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
// ═══════════════════════════════════════════════════════════════════
// 전표 모달 (영수증)
// ═══════════════════════════════════════════════════════════════════
const ReceiptModal = ({ isOpen, onClose, paymentId, receiptNumber }) => {
  const [receipt, setReceipt] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [receiptModal, setReceiptModal] = React.useState({ open: false, paymentId: null });
  const [showUnpaidModal, setShowUnpaidModal] = useState(false);

  React.useEffect(() => {
    if (!isOpen) return;
    if (!paymentId && !receiptNumber) return;
    
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = receiptNumber
          ? `https://heybiseo.ai.kr/receipt/by-number/${receiptNumber}`
          : `https://heybiseo.ai.kr/receipt/by-payment/${paymentId}`;
        const res = await fetch(url, {
          headers: { Authorization: `Bearer ${LS.get("access_token")}` }
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setReceipt(data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [isOpen, paymentId, receiptNumber]);

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const html = document.getElementById("receipt-content").innerHTML;
    printWindow.document.write(`
      <!DOCTYPE html>
      <html><head><title>전표 ${receipt?.receipt_number || ""}</title>
      <style>
        body { font-family: 'Malgun Gothic', sans-serif; padding: 20px; max-width: 380px; margin: 0 auto; }
        table { width: 100%; border-collapse: collapse; }
        th, td { padding: 6px 4px; text-align: left; }
        .text-right { text-align: right; }
        .border-top { border-top: 1px dashed #999; }
        .border-bottom { border-bottom: 1px dashed #999; }
        h2 { text-align: center; margin: 8px 0; }
        .total { font-size: 16px; font-weight: bold; }
      </style></head><body>${html}<script>window.print();</script></body></html>
    `);
    printWindow.document.close();
  };

  const formatDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")} ${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`;
  };

  const methodLabel = (m) => {
    const map = { cash: "현금", CASH: "현금", card: "카드", CARD: "카드",
      transfer: "계좌이체", TRANSFER: "계좌이체",
      paynix: "카드", PAYNIX: "카드",
      smartro: "카드", SMARTRO: "카드", NANO: "카드" };
    return map[m] || m;
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9999
    }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()}
        style={{
          background: "white", borderRadius: 12, width: "100%", maxWidth: 420,
          maxHeight: "90vh", overflow: "auto", padding: 0
        }}>
        {/* 헤더 */}
        <div style={{
          padding: "14px 20px", borderBottom: "1px solid #E2E8F0",
          display: "flex", justifyContent: "space-between", alignItems: "center"
        }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>🧾 전표</h3>
          <button onClick={onClose} style={{
            background: "transparent", border: "none", fontSize: 22, cursor: "pointer", color: "#94A3B8"
          }}>×</button>
        </div>

        {loading && <div style={{ padding: 40, textAlign: "center", color: "#94A3B8" }}>불러오는 중...</div>}
        
        {error && <div style={{ padding: 40, textAlign: "center", color: "#EF4444" }}>
          ⚠️ 에러: {error}
        </div>}

        {receipt && (
          <>
            {/* 전표 본문 */}
            <div id="receipt-content" style={{
              padding: "20px 24px", fontFamily: "'Malgun Gothic', sans-serif",
              fontSize: 12, lineHeight: 1.6, color: "#1E293B"
            }}>
              {/* 가맹점 헤더 */}
              <div style={{ textAlign: "center", marginBottom: 12 }}>
                <h2 style={{ margin: "4px 0", fontSize: 18 }}>{receipt.store.name}</h2>
                {receipt.store.business_number && <div style={{ fontSize: 11, color: "#64748B" }}>
                  사업자번호: {receipt.store.business_number}
                </div>}
                {receipt.store.owner_name && <div style={{ fontSize: 11, color: "#64748B" }}>
                  대표: {receipt.store.owner_name}
                </div>}
                {receipt.store.address && <div style={{ fontSize: 11, color: "#64748B" }}>
                  {receipt.store.address}
                </div>}
                {receipt.store.phone && <div style={{ fontSize: 11, color: "#64748B" }}>
                  TEL: {receipt.store.phone}
                </div>}
              </div>

              <div style={{ borderTop: "1px dashed #999", margin: "8px 0" }}></div>

              {/* 전표 정보 */}
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span>전표번호:</span>
                <strong>{receipt.receipt_number}</strong>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span>발행일시:</span>
                <span>{formatDate(receipt.issued_at)}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span>회원:</span>
                <span>{receipt.customer.name} {receipt.customer.phone && `(${receipt.customer.phone})`}</span>
              </div>
              {receipt.staff_name && <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span>담당자:</span>
                <span>{receipt.staff_name}</span>
              </div>}

              <div style={{ borderTop: "1px dashed #999", margin: "8px 0" }}></div>

              {/* 상품 리스트 */}
              <table style={{ width: "100%", marginBottom: 8 }}>
                <thead>
                  <tr style={{ borderBottom: "1px solid #ddd" }}>
                    <th style={{ textAlign: "left", padding: "4px 0" }}>품명</th>
                    <th style={{ textAlign: "center", padding: "4px 0", width: 30 }}>수량</th>
                    <th style={{ textAlign: "right", padding: "4px 0" }}>금액</th>
                  </tr>
                </thead>
                <tbody>
                  {receipt.items.map((item, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: "4px 0" }}>{item.name}</td>
                      <td style={{ textAlign: "center", padding: "4px 0" }}>{item.quantity}</td>
                      <td style={{ textAlign: "right", padding: "4px 0" }}>{item.amount.toLocaleString()}원</td>
                    </tr>
                  ))}
                </tbody>
              </table>

                            <div style={{ borderTop: "1px dashed #999", margin: "8px 0" }}></div>

              {/* 미수금 결제건 안내 배너 */}
              {receipt.is_unpaid_payment && (
                <div style={{
                  background: "#fff7ed", border: "1px solid #fed7aa",
                  borderRadius: 6, padding: "6px 10px", marginBottom: 8,
                  fontSize: 11, color: "#c2410c", fontWeight: 600
                }}>
                  💰 미수금 결제건
                  {receipt.original_payment_info && (
                    <span style={{ fontWeight: 400, color: "#9a3412" }}>
                      &nbsp;— 원본 전표: {receipt.original_payment_info.receipt_number}
                      ({new Date(receipt.original_payment_info.paid_at).toLocaleDateString("ko-KR")})
                    </span>
                  )}
                </div>
              )}

              {/* 소계 */}
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span>소계:</span>
                <span>{receipt.summary.subtotal.toLocaleString()}원</span>
              </div>
              {receipt.summary.discount > 0 && (
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4, color: "#EF4444" }}>
                  <span>할인:</span>
                  <span>-{receipt.summary.discount.toLocaleString()}원</span>
                </div>
              )}
              {receipt.summary.unpaid > 0 && (
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4, color: "#F59E0B" }}>
                  <span>미수금:</span>
                  <span>-{receipt.summary.unpaid.toLocaleString()}원</span>
                </div>
              )}
              <div style={{ borderTop: "1px solid #1E293B", margin: "8px 0" }}></div>
              <div style={{
                display: "flex", justifyContent: "space-between",
                fontSize: 16, fontWeight: 700, marginBottom: 8, color: "#3B82F6"
              }}>
                <span>총 결제금액:</span>
                <span>{receipt.summary.total.toLocaleString()}원</span>
              </div>

              {/* 미수잔액 표시 (원본 결제건에서 아직 안 받은 금액) */}
              {!receipt.is_unpaid_payment && receipt.summary.remaining_unpaid > 0 && (
                <div style={{
                  display: "flex", justifyContent: "space-between", marginBottom: 4,
                  color: "#f97316", fontWeight: 600
                }}>
                  <span>미수잔액:</span>
                  <span>{receipt.summary.remaining_unpaid.toLocaleString()}원</span>
                </div>
              )}

              {/* 미수금 납부 완료 표시 */}
              {!receipt.is_unpaid_payment && receipt.summary.unpaid > 0 && receipt.summary.remaining_unpaid === 0 && (
                <div style={{
                  display: "flex", justifyContent: "space-between", marginBottom: 4,
                  color: "#22c55e", fontWeight: 600, fontSize: 11
                }}>
                  <span>미수금 납부:</span>
                  <span>✅ 완납</span>
                </div>
              )}

              {/* 미수금 납부 이력 */}
              {!receipt.is_unpaid_payment && receipt.unpaid_payment_info && (
                <div style={{
                  background: "#f0fdf4", border: "1px solid #bbf7d0",
                  borderRadius: 6, padding: "6px 10px", marginBottom: 4,
                  fontSize: 11, color: "#166534"
                }}>
                  💰 미수금 납부: {receipt.unpaid_payment_info.amount.toLocaleString()}원
                  ({new Date(receipt.unpaid_payment_info.paid_at).toLocaleDateString("ko-KR")}·{
                    receipt.unpaid_payment_info.method === "card" ? "카드" :
                    receipt.unpaid_payment_info.method === "cash" ? "현금" : "계좌이체"
                  })
                </div>
              )}

              <div style={{ borderTop: "1px dashed #999", margin: "8px 0" }}></div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                <span>결제수단:</span>
                <span>{receipt.methods.map(methodLabel).join(", ")}</span>
              </div>

              {receipt.is_pg && receipt.pg_info && (
                <>
                  <div style={{ borderTop: "1px dashed #999", margin: "8px 0" }}></div>
                  <div style={{ fontSize: 10, color: "#64748B" }}>
                    {receipt.pg_info.transaction_id && <div>거래번호: {receipt.pg_info.transaction_id}</div>}
                    {receipt.pg_info.auth_code && <div>승인번호: {receipt.pg_info.auth_code}</div>}
                    {receipt.pg_info.card_last4 && <div>카드: {receipt.pg_info.card_issuer} ****-{receipt.pg_info.card_last4}</div>}
                  </div>
                </>
              )}

              <div style={{ textAlign: "center", marginTop: 16, fontSize: 11, color: "#94A3B8" }}>
                이용해주셔서 감사합니다 🙏
              </div>
            </div>

            {/* 액션 버튼 */}
            <div style={{
              padding: "12px 20px", borderTop: "1px solid #E2E8F0",
              display: "flex", gap: 8
            }}>
              <button onClick={handlePrint} style={{
                flex: 1, padding: "10px", border: "1px solid #3B82F6",
                background: "white", color: "#3B82F6", borderRadius: 8,
                cursor: "pointer", fontWeight: 600
              }}>🖨 인쇄</button>
              <button onClick={onClose} style={{
                flex: 1, padding: "10px", border: "none",
                background: "#3B82F6", color: "white", borderRadius: 8,
                cursor: "pointer", fontWeight: 600
              }}>닫기</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
// ════════════════════════════════════════════════════════════════════════════
//// ════════════════════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════════
// SchedulerPage - 전체화면 통합 스케줄러
// ═══════════════════════════════════════════════════════════════════
function SchedulerPage({ token, addToast, setPage }) {
  const [view, setView] = React.useState("week");        // month | week | day
  const [anchor, setAnchor] = React.useState(new Date()); // 기준 날짜
  const [events, setEvents] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [typeFilter, setTypeFilter] = React.useState("");  // "" | PT | GROUP | CONSULT | ETC
  const [trainerFilter, setTrainerFilter] = React.useState("");
  const [trainers, setTrainers] = React.useState([]);
  const [detailEvent, setDetailEvent] = React.useState(null);
  const [showCreate, setShowCreate] = React.useState(false);
  const [members, setMembers] = React.useState([]);
  const [slotPick, setSlotPick] = React.useState(null);      // 빈칸 클릭 → 일정등록 선택창 { date, hour, trainer_id }
  const [createModal, setCreateModal] = React.useState(null); // 선택 후 생성 모달 { type, date, start_time, end_time, trainer_id }

  const TYPE_COLORS = {
    PT:      { bg: "#EAEFF7", fg: "#56708F", label: "개인 수업" },
    GROUP:   { bg: "#DAF5E9", fg: "#0E9C72", label: "그룹 수업" },
    CONSULT: { bg: "#FBF0D6", fg: "#A9791A", label: "상담" },
    ETC:     { bg: "#EEEEF1", fg: "#6B7280", label: "기타" },
  };

  const fmtDate = (d) => {
    const y = d.getFullYear(), m = String(d.getMonth()+1).padStart(2,"0"), day = String(d.getDate()).padStart(2,"0");
    return `${y}-${m}-${day}`;
  };

  // 기간 계산
  const getRange = () => {
    const a = new Date(anchor);
    if (view === "day") {
      return { start: fmtDate(a), end: fmtDate(a) };
    } else if (view === "week") {
      const day = a.getDay();
      const mon = new Date(a); mon.setDate(a.getDate() - ((day + 6) % 7));
      const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
      return { start: fmtDate(mon), end: fmtDate(sun) };
    } else {
      const first = new Date(a.getFullYear(), a.getMonth(), 1);
      const last = new Date(a.getFullYear(), a.getMonth()+1, 0);
      return { start: fmtDate(first), end: fmtDate(last) };
    }
  };

  const loadEvents = async (silent) => {
    if (!silent) setLoading(true);
    try {
      const { start, end } = getRange();
      let url = `/scheduler/events?start=${start}&end=${end}`;
      if (typeFilter) url += `&type=${typeFilter}`;
      if (trainerFilter) url += `&trainer_id=${trainerFilter}`;
      const res = await api(url, {}, token);
      setEvents(Array.isArray(res) ? res : []);
    } catch (e) {
      setEvents([]);
    }
    if (!silent) setLoading(false);
  };

  const loadTrainers = async () => {
    try {
      const res = await api("/staff/list?tenant_id=1", {}, token).catch(() => []);
      if (Array.isArray(res)) {
        setTrainers(res.filter(s => s.role !== "SUPERADMIN"));
      }
    } catch (e) {}
  };

  const loadMembers = async () => {
    try {
      const res = await api("/members/", {}, token).catch(() => []);
      if (Array.isArray(res)) setMembers(res);
    } catch (e) {}
  };

  React.useEffect(() => { loadTrainers(); loadMembers(); }, []);
  React.useEffect(() => { loadEvents(); }, [view, anchor, typeFilter, trainerFilter]);

  // 빈칸 클릭 → 일정등록 선택창
  const onSlotClick = (date, hour, trainer_id) => setSlotPick({ date, hour, trainer_id });

  // 드래그로 일정 이동 (예약·상담·기타만, 수업은 불가)
  const dragRef = React.useRef(null);
  const handleEventDragStart = (e) => { dragRef.current = e; };
  const handleSlotDrop = async (date, hour, trainerId) => {
    const e = dragRef.current;
    dragRef.current = null;
    if (!e) return;
    const parseHM = (s) => { const [a, b] = (s || "0:0").split(":").map(Number); return (a || 0) * 60 + (b || 0); };
    const fmt = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
    const sMin = parseHM(e.start_time);
    let dur = e.end_time ? (parseHM(e.end_time) - sMin) : 60;
    if (dur <= 0) dur = 60;
    let newStartMin = (hour == null) ? sMin : (hour * 60 + (sMin % 60));
    let newEndMin = newStartMin + dur;
    if (newEndMin > 24 * 60 - 1) newEndMin = 24 * 60 - 1;
    const newStart = fmt(newStartMin);
    // 같은 자리에 떨어뜨리면 무시
    const sameTrainer = (trainerId == null) || (trainerId === e.trainer_id);
    if (e.date === date && e.start_time === newStart && sameTrainer) return;

    // 수업(lesson): 1회성 개인수업만 이동 가능 (그룹·반복수업은 막음)
    if (e.source === "lesson") {
      if (e.type !== "PT" || !e.single_day) {
        addToast("반복 수업은 [수업관리]에서 변경해주세요. (하루짜리 1회성 수업만 드래그 이동 가능)", "error");
        return;
      }
      const [yy, mm, dd] = date.split("-").map(Number);
      const wd = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][new Date(yy, mm - 1, dd).getDay()];
      const lbody = { start_date: date, end_date: date, days_of_week: wd, start_time: newStart + ":00" };
      if (trainerId != null) lbody.trainer_id = trainerId;
      try {
        await api(`/lesson/${e.id}`, { method: "PUT", body: JSON.stringify(lbody) }, token);
        addToast("수업을 옮겼습니다.", "success");
        loadEvents(true);
      } catch (err) {
        addToast("이동 실패: " + (err.message || ""), "error");
      }
      return;
    }

    // 예약·상담·기타
    const body = { source: e.source, id: e.id, date, start_time: newStart, end_time: fmt(newEndMin) };
    if (trainerId != null) body.trainer_id = trainerId;
    try {
      await api("/scheduler/event", { method: "PUT", body: JSON.stringify(body) }, token);
      addToast("일정을 옮겼습니다.", "success");
      loadEvents(true);
    } catch (err) {
      addToast("이동 실패: " + (err.message || ""), "error");
    }
  };
  const chooseType = (type) => {
    const s = slotPick;
    setSlotPick(null);
    if (!s) return;
    const st = `${String(s.hour).padStart(2, "0")}:00`;
    const et = `${String((s.hour + 1) % 24).padStart(2, "0")}:00`;
    if (type === "LESSON") {
      // 개인·그룹 통합 → 스케줄러 그 자리에서 수업 생성 모달 (요일·시간 프리필)
      const [yy, mm, dd] = s.date.split("-").map(Number);
      const wd = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][new Date(yy, mm - 1, dd).getDay()];
      setCreateModal({ type: "LESSON", days_of_week: [wd], start_time: st, trainer_id: s.trainer_id || "", date: s.date });
      return;
    }
    setCreateModal({ type, date: s.date, start_time: st, end_time: et, trainer_id: s.trainer_id || "" });
  };

  // 네비게이션
  const navigate = (dir) => {
    const a = new Date(anchor);
    if (view === "day") a.setDate(a.getDate() + dir);
    else if (view === "week") a.setDate(a.getDate() + dir * 7);
    else a.setMonth(a.getMonth() + dir);
    setAnchor(a);
  };

  // 헤더 타이틀
  const headerTitle = () => {
    const { start, end } = getRange();
    if (view === "day") return start.replace(/-/g, ".");
    if (view === "week") return `${start.replace(/-/g,".")} ~ ${end.slice(8)}`;
    return `${anchor.getFullYear()}년 ${anchor.getMonth()+1}월`;
  };

  const HOURS = Array.from({ length: 18 }, (_, i) => i + 6); // 06:00 ~ 23:00

  return (
    <div style={{ position: "fixed", inset: 0, background: "#fff", zIndex: 9999, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {/* 상단 바 */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 24px", borderBottom: "1px solid #e5e7eb", flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <span style={{ fontSize: 20, fontWeight: 700, color: "#111" }}>{headerTitle()}</span>
          <div style={{ display: "flex", gap: 4 }}>
            <button onClick={() => navigate(-1)} style={navBtnStyle}>‹</button>
            <button onClick={() => setAnchor(new Date())} style={{ ...navBtnStyle, width: "auto", padding: "0 12px" }}>오늘</button>
            <button onClick={() => navigate(1)} style={navBtnStyle}>›</button>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ display: "flex" }}>
            {[["month","월간"],["week","주간"],["day","일간"]].map(([v,l],i) => (
              <button key={v} onClick={() => setView(v)} style={{
                padding: "7px 16px", fontSize: 13, cursor: "pointer",
                border: "1px solid " + (view === v ? "#2563eb" : "#e5e7eb"),
                background: view === v ? "#2563eb" : "#fff",
                color: view === v ? "#fff" : "#6b7280",
                fontWeight: view === v ? 600 : 400,
                borderRadius: i === 0 ? "8px 0 0 8px" : i === 2 ? "0 8px 8px 0" : 0,
                marginLeft: i > 0 ? -1 : 0,
              }}>{l}</button>
            ))}
          </div>
          <button onClick={() => setPage("dashboard")} style={{
            padding: "8px 16px", fontSize: 13, cursor: "pointer", border: "none",
            background: "#f3f4f6", color: "#374151", borderRadius: 8, fontWeight: 500,
          }}>✕ 닫기</button>
        </div>
      </div>

      {/* 필터 바 */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 24px", borderBottom: "1px solid #f3f4f6", flexShrink: 0 }}>
        <div style={{ display: "flex", gap: 4 }}>
          {[["","전체"],["PT","개인 수업"],["GROUP","그룹 수업"],["CONSULT","상담"],["ETC","기타"]].map(([v,l]) => (
            <button key={v} onClick={() => setTypeFilter(v)} style={{
              padding: "7px 14px", fontSize: 13, borderRadius: 8, cursor: "pointer", border: "none",
              background: typeFilter === v ? "#2563eb" : "transparent",
              color: typeFilter === v ? "#fff" : "#6b7280",
              fontWeight: typeFilter === v ? 600 : 400,
            }}>{l}</button>
          ))}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <select value={trainerFilter} onChange={e => setTrainerFilter(e.target.value)} style={{
            padding: "7px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13,
            background: "#fff", color: "#374151", cursor: "pointer",
          }}>
            <option value="">강사 전체</option>
            {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
          <button onClick={() => setShowCreate(true)} style={{
            padding: "8px 14px", fontSize: 13, cursor: "pointer", border: "none",
            background: "#2563eb", color: "#fff", borderRadius: 8, fontWeight: 500,
          }}>+ 기타일정</button>
        </div>
      </div>

      {/* 범례 */}
      <div style={{ display: "flex", gap: 16, padding: "8px 24px", fontSize: 12, color: "#6b7280", flexShrink: 0 }}>
        {Object.entries(TYPE_COLORS).map(([k,v]) => (
          <span key={k} style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <span style={{ width: 10, height: 10, borderRadius: 3, background: v.bg }} />{v.label}
          </span>
        ))}
      </div>

      {/* 본문 (스크롤 영역) */}
      <div style={{ flex: 1, overflow: "auto", padding: "0 24px 24px" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: 60, color: "#9ca3af" }}>불러오는 중...</div>
        ) : view === "week" ? (
          <WeekView events={events} anchor={anchor} hours={HOURS} colors={TYPE_COLORS} onEventClick={setDetailEvent} onSlotClick={onSlotClick} onEventDragStart={handleEventDragStart} onSlotDrop={handleSlotDrop} fmtDate={fmtDate} />
        ) : view === "day" ? (
          <DayView events={events} anchor={anchor} hours={HOURS} colors={TYPE_COLORS} onEventClick={setDetailEvent} onSlotClick={onSlotClick} onEventDragStart={handleEventDragStart} onSlotDrop={handleSlotDrop} trainers={trainers} fmtDate={fmtDate} />
        ) : (
          <MonthView events={events} anchor={anchor} colors={TYPE_COLORS} onEventClick={setDetailEvent} onSlotClick={onSlotClick} fmtDate={fmtDate} />
        )}
      </div>

      {/* 상세 모달 */}
      {detailEvent && (
        <EventDetailModal event={detailEvent} colors={TYPE_COLORS} trainers={trainers} token={token} addToast={addToast}
          onClose={() => setDetailEvent(null)} onSaved={() => { setDetailEvent(null); loadEvents(); }} />
      )}

      {/* 기타일정 생성 모달 (상단 버튼) */}
      {showCreate && (
        <EtcCreateModal trainers={trainers} token={token} addToast={addToast} anchor={anchor} fmtDate={fmtDate}
          onClose={() => setShowCreate(false)} onSaved={() => { setShowCreate(false); loadEvents(); }} />
      )}

      {/* 빈칸 클릭 → 일정등록 선택창 */}
      {slotPick && (
        <SlotPickerModal slot={slotPick} onChoose={chooseType} onClose={() => setSlotPick(null)} />
      )}

      {/* 선택 후 생성 모달 */}
      {createModal?.type === "LESSON" && (
        <SchedulerLessonModal slot={createModal} token={token} addToast={addToast}
          onClose={() => setCreateModal(null)} onSaved={() => { setCreateModal(null); loadEvents(); }} />
      )}
      {createModal?.type === "CONSULT" && (
        <ConsultCreateModal slot={createModal} trainers={trainers} members={members} token={token} addToast={addToast}
          onClose={() => setCreateModal(null)} onSaved={() => { setCreateModal(null); loadEvents(); }} />
      )}
      {createModal?.type === "ETC" && (
        <EtcCreateModal slot={createModal} anchor={anchor} fmtDate={fmtDate} trainers={trainers} token={token} addToast={addToast}
          onClose={() => setCreateModal(null)} onSaved={() => { setCreateModal(null); loadEvents(); }} />
      )}
    </div>
  );
}

const navBtnStyle = {
  width: 32, height: 32, borderRadius: 7, border: "1px solid #e5e7eb",
  background: "#fff", cursor: "pointer", fontSize: 15, color: "#6b7280",
  display: "inline-flex", alignItems: "center", justifyContent: "center",
};

// ─────────────────────────────────────────────
// 주간 뷰
// ─────────────────────────────────────────────
// ─────────────────────────────────────────────
// 일정 박스 (인원 표시 + 호버 시 예약 회원/잔여 팝업)
// ─────────────────────────────────────────────
const CLASS_PALETTE = [
  { bg: "#FCE4EF", fg: "#C93B7E" }, { bg: "#FFEAD9", fg: "#D9772F" }, { bg: "#E3ECFF", fg: "#3B54B8" },
  { bg: "#DAF5E9", fg: "#0E9C72" }, { bg: "#EFE7FD", fg: "#7C5CD6" }, { bg: "#E0F5F7", fg: "#158B9C" },
  { bg: "#FDE8E8", fg: "#C6524F" }, { bg: "#FBF3D4", fg: "#A9821A" },
];
const TYPE_META = {
  PT:      { bg: "#EAEFF7", fg: "#56708F", label: "개인 수업" },
  GROUP:   { bg: "#DAF5E9", fg: "#0E9C72", label: "그룹 수업" },
  CONSULT: { bg: "#FBF0D6", fg: "#A9791A", label: "상담" },
  ETC:     { bg: "#EEEEF1", fg: "#6B7280", label: "기타" },
};
// 그룹수업은 수업(lesson_id)마다 고유 색, 나머지는 유형 색
function eventColor(e) {
  if (e && e.type === "GROUP") {
    const p = CLASS_PALETTE[(Number(e.id) || 0) % CLASS_PALETTE.length];
    return { bg: p.bg, fg: p.fg, label: "그룹 수업" };
  }
  return TYPE_META[e && e.type] || TYPE_META.ETC;
}

function EventHoverCard({ e, pos }) {
  const c = eventColor(e);
  const members = e.reserved_members || [];
  const isGroup = e.type === "GROUP";
  const W = 300;
  const vw = (typeof window !== "undefined") ? window.innerWidth : 1200;
  let left = pos.x + 8;
  if (left + W > vw - 8) left = Math.max(8, pos.left - W - 8);
  return (
    <div style={{ position: "fixed", left, top: pos.y, width: W, maxHeight: 340, overflowY: "auto",
      background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 28px rgba(0,0,0,0.18)", zIndex: 5000, fontSize: 12 }}>
      <div style={{ background: c.fg, color: "#fff", padding: "10px 14px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 11, opacity: 0.9 }}>{e.date} · {e.start_time}~{e.end_time}</span>
          <span style={{ fontSize: 10, background: "rgba(255,255,255,0.25)", padding: "2px 8px", borderRadius: 999, whiteSpace: "nowrap" }}>{c.label}</span>
        </div>
        <div style={{ fontSize: 14, fontWeight: 700, marginTop: 4 }}>{e.title}</div>
        {e.trainer_name ? <div style={{ fontSize: 11, opacity: 0.9, marginTop: 1 }}>{e.trainer_name} 강사</div> : null}
      </div>
      <div style={{ padding: "10px 14px" }}>
        <div style={{ fontWeight: 700, color: "#374151", marginBottom: 6 }}>
          {isGroup ? `예약 회원 (${members.length}명)` : "예약 회원"}
        </div>
        {members.length === 0 ? (
          <div style={{ color: "#9ca3af" }}>예약한 회원이 없어요</div>
        ) : members.map((m, i) => (
          <div key={i} style={{ display: "flex", justifyContent: "space-between", gap: 8, padding: "5px 0", borderTop: i ? "1px solid #f3f4f6" : "none" }}>
            <span style={{ fontWeight: 600, color: "#111", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{m.name}</span>
            <span style={{ color: "#6b7280", whiteSpace: "nowrap" }}>
              {m.total_count != null ? `잔여 ${m.remaining_count != null ? m.remaining_count : 0}/${m.total_count}` : ""}
              {(m.total_count != null && m.days_left != null) ? " · " : ""}
              {m.days_left != null ? `${m.days_left}일 남음` : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function EventBox({ e, colors, onClick, dense, big, onDragStart }) {
  const [pos, setPos] = React.useState(null);
  const c = eventColor(e);
  const isGroup = e.type === "GROUP";
  const cap = (isGroup && (e.capacity != null)) ? `${e.reserved_count || 0}/${e.capacity}` : "";
  // 예약·상담·기타는 드래그 O. 수업(lesson)은 "1회성 개인수업"만 O, 그룹·반복수업은 X
  const movable = (e.source && e.source !== "lesson") || (e.source === "lesson" && e.type === "PT" && !!e.single_day);
  const enter = ev => { const r = ev.currentTarget.getBoundingClientRect(); setPos({ x: r.right, left: r.left, y: r.top }); };
  const leave = () => setPos(null);
  const click = ev => { ev.stopPropagation(); onClick(e); };
  const dragStart = ev => {
    if (!movable) { ev.preventDefault(); return; }
    ev.stopPropagation();
    ev.dataTransfer.effectAllowed = "move";
    try { ev.dataTransfer.setData("text/plain", String(e.id)); } catch (_) {}
    setPos(null);
    if (onDragStart) onDragStart(e);
  };
  const curs = movable ? "grab" : "pointer";
  if (big) {
    return (
      <>
        <div draggable={movable} onDragStart={dragStart} onClick={click} onMouseEnter={enter} onMouseLeave={leave} style={{
          background: c.bg, color: c.fg, cursor: curs, borderRadius: 6, padding: "8px 10px",
          minHeight: 64, display: "flex", flexDirection: "column", justifyContent: "center", gap: 3,
          borderLeft: `3px solid ${c.fg}`, overflow: "hidden",
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 700 }}>
            <span>{e.start_time}{e.end_time ? `~${e.end_time}` : ""}</span>
            {cap ? <span style={{ background: "rgba(255,255,255,0.6)", padding: "1px 7px", borderRadius: 999, fontSize: 11 }}>{cap}</span> : null}
          </div>
          <div style={{ fontSize: 13, fontWeight: 600, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{e.title}</div>
        </div>
        {pos && <EventHoverCard e={e} pos={pos} />}
      </>
    );
  }
  return (
    <>
      <div draggable={movable} onDragStart={dragStart} onClick={click} onMouseEnter={enter} onMouseLeave={leave} style={{
        fontSize: dense ? 10 : 11, padding: dense ? "2px 5px" : "3px 6px", borderRadius: 4, marginBottom: 2,
        background: c.bg, color: c.fg, cursor: curs,
        overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis",
      }}>
        {e.start_time} {cap ? cap + " " : ""}{e.title}
      </div>
      {pos && <EventHoverCard e={e} pos={pos} />}
    </>
  );
}

function MoreEventsPopover({ events, rect, colors, onEventClick, onEventDragStart, onClose }) {
  const W = 230;
  const vw = (typeof window !== "undefined") ? window.innerWidth : 1200;
  const vh = (typeof window !== "undefined") ? window.innerHeight : 800;
  const maxH = 340;
  let left = rect.left;
  if (left + W > vw - 8) left = Math.max(8, vw - W - 8);
  let top = rect.bottom + 4;
  if (top + maxH > vh - 8) top = Math.max(8, rect.top - maxH - 4);
  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 4000 }} />
      <div style={{ position: "fixed", left, top, width: W, maxHeight: maxH, overflowY: "auto",
        background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 28px rgba(0,0,0,0.18)", zIndex: 4001, padding: 8 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6, padding: "0 2px" }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: "#6b7280" }}>전체 일정 ({events.length})</span>
          <span onClick={onClose} style={{ cursor: "pointer", color: "#9ca3af", fontSize: 15, lineHeight: 1 }}>✕</span>
        </div>
        {events.map((e, ei) => (
          <EventBox key={ei} e={e} colors={colors} onClick={(ev) => { onEventClick(ev); onClose(); }} onDragStart={onEventDragStart} />
        ))}
      </div>
    </>
  );
}

function CellEvents({ events, colors, onEventClick, onEventDragStart, dense }) {
  const [rect, setRect] = React.useState(null);
  const LIMIT = 5;
  if (events.length === 1) {
    return <EventBox e={events[0]} colors={colors} onClick={onEventClick} onDragStart={onEventDragStart} big />;
  }
  const shown = events.slice(0, LIMIT);
  const more = events.length - LIMIT;
  return (
    <>
      {shown.map((e, ei) => <EventBox key={ei} e={e} colors={colors} onClick={onEventClick} onDragStart={onEventDragStart} dense={dense} />)}
      {more > 0 && (
        <div onClick={ev => { ev.stopPropagation(); setRect(ev.currentTarget.getBoundingClientRect()); }} style={{
          fontSize: dense ? 10 : 11, padding: "2px 5px", borderRadius: 4, textAlign: "center",
          background: "#eef2ff", color: "#4338ca", cursor: "pointer", fontWeight: 700,
        }}>
          {`${more}개 더보기 ▼`}
        </div>
      )}
      {rect && (
        <MoreEventsPopover events={events} rect={rect} colors={colors} onEventClick={onEventClick} onEventDragStart={onEventDragStart} onClose={() => setRect(null)} />
      )}
    </>
  );
}

function WeekView({ events, anchor, hours, colors, onEventClick, onSlotClick, onEventDragStart, onSlotDrop, fmtDate }) {
  const day = anchor.getDay();
  const mon = new Date(anchor); mon.setDate(anchor.getDate() - ((day + 6) % 7));
  const days = Array.from({ length: 7 }, (_, i) => { const d = new Date(mon); d.setDate(mon.getDate() + i); return d; });
  const dayLabels = ["월","화","수","목","금","토","일"];

  const evByCell = {}; // "YYYY-MM-DD_HH" -> [events]
  events.forEach(e => {
    const h = e.start_time ? e.start_time.slice(0,2) : "00";
    const key = `${e.date}_${h}`;
    (evByCell[key] = evByCell[key] || []).push(e);
  });

  return (
    <div style={{ display: "grid", gridTemplateColumns: "56px repeat(7, 1fr)", border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden", marginTop: 8 }}>
      {/* 헤더 */}
      <div style={{ background: "#f9fafb", borderBottom: "1px solid #e5e7eb" }} />
      {days.map((d, i) => {
        const isToday = fmtDate(d) === fmtDate(new Date());
        const isSun = i === 6;
        return (
          <div key={i} style={{ background: "#f9fafb", borderBottom: "1px solid #e5e7eb", borderLeft: "1px solid #e5e7eb", padding: "8px 4px", textAlign: "center" }}>
            <div style={{ fontSize: 11, color: isSun ? "#ef4444" : "#6b7280" }}>{dayLabels[i]}</div>
            <div style={{ fontSize: 15, fontWeight: 600, color: isToday ? "#2563eb" : isSun ? "#ef4444" : "#111" }}>{d.getDate()}</div>
          </div>
        );
      })}
      {/* 시간대 행 */}
      {hours.map((h, hi) => (
        <React.Fragment key={h}>
          <div style={{ fontSize: 10, color: "#9ca3af", padding: "4px", textAlign: "right", borderBottom: hi < hours.length-1 ? "1px solid #f3f4f6" : "none" }}>{String(h).padStart(2,"0")}:00</div>
          {days.map((d, di) => {
            const key = `${fmtDate(d)}_${String(h).padStart(2,"0")}`;
            const cellEvents = evByCell[key] || [];
            return (
              <div key={di} onClick={() => onSlotClick && onSlotClick(fmtDate(d), h, null)}
                onDragOver={onSlotDrop ? (ev => ev.preventDefault()) : undefined}
                onDrop={onSlotDrop ? (ev => { ev.preventDefault(); onSlotDrop(fmtDate(d), h, undefined); }) : undefined}
                style={{ minHeight: 84, borderBottom: hi < hours.length-1 ? "1px solid #f3f4f6" : "none", borderLeft: "1px solid #f3f4f6", padding: 2, cursor: "pointer" }}>
                <CellEvents events={cellEvents} colors={colors} onEventClick={onEventClick} onEventDragStart={onEventDragStart} dense />
              </div>
            );
          })}
        </React.Fragment>
      ))}
    </div>
  );
}

// ─────────────────────────────────────────────
// 일간 뷰 (강사별 컬럼)
// ─────────────────────────────────────────────
function DayView({ events, anchor, hours, colors, onEventClick, onSlotClick, onEventDragStart, onSlotDrop, trainers, fmtDate }) {
  // 강사 컬럼 + 미배정 컬럼
  const cols = [...trainers.map(t => ({ id: t.id, name: t.name })), { id: null, name: "미배정" }];

  const evByCell = {}; // "trainerId_HH" -> [events]
  events.forEach(e => {
    const h = e.start_time ? e.start_time.slice(0,2) : "00";
    const tid = e.trainer_id == null ? "null" : e.trainer_id;
    const key = `${tid}_${h}`;
    (evByCell[key] = evByCell[key] || []).push(e);
  });

  return (
    <div style={{ display: "grid", gridTemplateColumns: `56px repeat(${cols.length}, 1fr)`, border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden", marginTop: 8 }}>
      <div style={{ background: "#f9fafb", borderBottom: "1px solid #e5e7eb" }} />
      {cols.map((c, i) => (
        <div key={i} style={{ background: "#f9fafb", borderBottom: "1px solid #e5e7eb", borderLeft: "1px solid #e5e7eb", padding: "10px 8px", textAlign: "center", fontSize: 13, fontWeight: 600, color: "#374151" }}>{c.name}</div>
      ))}
      {hours.map((h, hi) => (
        <React.Fragment key={h}>
          <div style={{ fontSize: 10, color: "#9ca3af", padding: "6px 4px", textAlign: "right", borderBottom: hi < hours.length-1 ? "1px solid #f3f4f6" : "none" }}>{String(h).padStart(2,"0")}:00</div>
          {cols.map((col, ci) => {
            const tid = col.id == null ? "null" : col.id;
            const key = `${tid}_${String(h).padStart(2,"0")}`;
            const cellEvents = evByCell[key] || [];
            return (
              <div key={ci} onClick={() => onSlotClick && onSlotClick(fmtDate(anchor), h, col.id)}
                onDragOver={onSlotDrop ? (ev => ev.preventDefault()) : undefined}
                onDrop={onSlotDrop ? (ev => { ev.preventDefault(); onSlotDrop(fmtDate(anchor), h, col.id); }) : undefined}
                style={{ minHeight: 84, borderBottom: hi < hours.length-1 ? "1px solid #f3f4f6" : "none", borderLeft: "1px solid #f3f4f6", padding: 3, cursor: "pointer" }}>
                <CellEvents events={cellEvents} colors={colors} onEventClick={onEventClick} onEventDragStart={onEventDragStart} />
              </div>
            );
          })}
        </React.Fragment>
      ))}
    </div>
  );
}

// ─────────────────────────────────────────────
// 월간 뷰
// ─────────────────────────────────────────────
function MonthView({ events, anchor, colors, onEventClick, onSlotClick, fmtDate }) {
  const year = anchor.getFullYear(), month = anchor.getMonth();
  const first = new Date(year, month, 1);
  const startDay = (first.getDay() + 6) % 7; // 월요일 시작
  const daysInMonth = new Date(year, month+1, 0).getDate();
  const dayLabels = ["월","화","수","목","금","토","일"];

  const evByDate = {};
  events.forEach(e => { (evByDate[e.date] = evByDate[e.date] || []).push(e); });

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", border: "1px solid #e5e7eb", borderRadius: "8px 8px 0 0", overflow: "hidden" }}>
        {dayLabels.map((l, i) => (
          <div key={i} style={{ background: "#f9fafb", padding: 8, textAlign: "center", fontSize: 12, color: i === 6 ? "#ef4444" : "#6b7280", borderLeft: i > 0 ? "1px solid #e5e7eb" : "none" }}>{l}</div>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", border: "1px solid #e5e7eb", borderTop: "none", borderRadius: "0 0 8px 8px", overflow: "hidden" }}>
        {cells.map((d, i) => {
          const dateStr = d ? fmtDate(new Date(year, month, d)) : null;
          const dayEvents = dateStr ? (evByDate[dateStr] || []) : [];
          const isToday = dateStr === fmtDate(new Date());
          // 타입별 집계
          const counts = {};
          dayEvents.forEach(e => { counts[e.type] = (counts[e.type] || 0) + 1; });
          return (
            <div key={i} onClick={() => { if (d && onSlotClick) onSlotClick(dateStr, 9, null); }} style={{ minHeight: 90, borderBottom: "1px solid #f3f4f6", borderLeft: i % 7 > 0 ? "1px solid #f3f4f6" : "none", padding: 5, background: d ? "#fff" : "#fafafa", cursor: d ? "pointer" : "default" }}>
              {d && <div style={{ fontSize: 12, color: isToday ? "#2563eb" : "#6b7280", fontWeight: isToday ? 700 : 400, marginBottom: 3 }}>{d}</div>}
              {Object.entries(counts).map(([type, cnt]) => {
                const c = colors[type] || colors.ETC;
                return (
                  <div key={type} onClick={(ev) => { ev.stopPropagation(); const first = dayEvents.find(e => e.type === type); if (first) onEventClick(first); }} style={{
                    fontSize: 10, padding: "2px 5px", borderRadius: 3, marginBottom: 2,
                    background: c.bg, color: c.fg, cursor: "pointer",
                  }}>{c.label} {cnt}건</div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// 일정 상세 / 수정 모달
// ─────────────────────────────────────────────
function EventDetailModal({ event, colors, trainers, token, addToast, onClose, onSaved }) {
  const [editing, setEditing] = React.useState(false);
  const [form, setForm] = React.useState({
    title: event.title || "",
    date: event.date || "",
    start_time: event.start_time || "",
    end_time: event.end_time || "",
    trainer_id: event.trainer_id || "",
    memo: event.memo || "",
  });
  const c = colors[event.type] || colors.ETC;

  const handleSave = async () => {
    try {
      await api("/scheduler/event", {
        method: "PUT",
        body: JSON.stringify({
          source: event.source,
          id: event.id,
          title: form.title,
          date: form.date,
          start_time: form.start_time,
          end_time: form.end_time,
          trainer_id: form.trainer_id ? Number(form.trainer_id) : null,
          memo: form.memo,
        }),
      }, token);
      addToast("일정이 수정되었습니다.", "success");
      onSaved();
    } catch (e) {
      addToast("수정 실패: " + (e.message || ""), "error");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("이 일정을 삭제하시겠습니까?")) return;
    try {
      await api(`/scheduler/event?source=${event.source}&id=${event.id}`, { method: "DELETE" }, token);
      addToast("일정이 삭제되었습니다.", "success");
      onSaved();
    } catch (e) {
      addToast("삭제 실패: " + (e.message || ""), "error");
    }
  };

  return (
    <div onClick={onClose} style={modalOverlayStyle}>
      <div onClick={e => e.stopPropagation()} style={modalBoxStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
          <span style={{ width: 12, height: 12, borderRadius: 3, background: c.bg }} />
          <span style={{ fontSize: 13, color: c.fg, fontWeight: 600 }}>{c.label}</span>
        </div>

        {!editing ? (
          <>
            <h3 style={{ margin: "0 0 16px", fontSize: 18, color: "#111" }}>{event.title}</h3>
            <div style={detailRowStyle}><span style={detailLabelStyle}>일시</span><span>{event.date} {event.start_time}~{event.end_time}</span></div>
            <div style={detailRowStyle}><span style={detailLabelStyle}>담당강사</span><span>{event.trainer_name || "미배정"}</span></div>
            {event.member_name && <div style={detailRowStyle}><span style={detailLabelStyle}>회원</span><span>{event.member_name}</span></div>}
            {event.status && <div style={detailRowStyle}><span style={detailLabelStyle}>상태</span><span>{event.status}</span></div>}
            {event.memo && <div style={detailRowStyle}><span style={detailLabelStyle}>메모</span><span>{event.memo}</span></div>}
            <div style={{ display: "flex", gap: 8, marginTop: 24 }}>
              <button onClick={() => setEditing(true)} style={btnPrimary}>수정</button>
              <button onClick={handleDelete} style={btnDanger}>삭제</button>
              <button onClick={onClose} style={btnGray}>닫기</button>
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 12 }}>
              <label style={formLabelStyle}>제목</label>
              <input value={form.title} onChange={e => setForm({...form, title: e.target.value})} style={formInputStyle} />
            </div>
            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              <div style={{ flex: 1 }}>
                <label style={formLabelStyle}>날짜</label>
                <input type="date" value={form.date} onChange={e => setForm({...form, date: e.target.value})} style={formInputStyle} />
              </div>
            </div>
            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              <div style={{ flex: 1 }}>
                <label style={formLabelStyle}>시작</label>
                <input type="time" value={form.start_time} onChange={e => setForm({...form, start_time: e.target.value})} style={formInputStyle} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={formLabelStyle}>종료</label>
                <input type="time" value={form.end_time} onChange={e => setForm({...form, end_time: e.target.value})} style={formInputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={formLabelStyle}>담당강사</label>
              <select value={form.trainer_id} onChange={e => setForm({...form, trainer_id: e.target.value})} style={formInputStyle}>
                <option value="">미배정</option>
                {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={formLabelStyle}>메모</label>
              <textarea value={form.memo} onChange={e => setForm({...form, memo: e.target.value})} style={{...formInputStyle, minHeight: 60, resize: "vertical"}} />
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
              <button onClick={handleSave} style={btnPrimary}>저장</button>
              <button onClick={() => setEditing(false)} style={btnGray}>취소</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// 기타일정 생성 모달
// ─────────────────────────────────────────────
function EtcCreateModal({ trainers, token, addToast, anchor, fmtDate, slot, onClose, onSaved }) {
  const [form, setForm] = React.useState({
    title: "",
    date: slot?.date || fmtDate(anchor),
    start_time: slot?.start_time || "09:00",
    end_time: slot?.end_time || "10:00",
    trainer_id: slot?.trainer_id || "",
    memo: "",
  });

  const handleSave = async () => {
    if (!form.title.trim()) { addToast("제목을 입력하세요.", "error"); return; }
    try {
      await api("/scheduler/etc", {
        method: "POST",
        body: JSON.stringify({
          title: form.title,
          date: form.date,
          start_time: form.start_time,
          end_time: form.end_time,
          trainer_id: form.trainer_id ? Number(form.trainer_id) : null,
          memo: form.memo,
        }),
      }, token);
      addToast("기타일정이 등록되었습니다.", "success");
      onSaved();
    } catch (e) {
      addToast("등록 실패: " + (e.message || ""), "error");
    }
  };

  return (
    <div onClick={onClose} style={modalOverlayStyle}>
      <div onClick={e => e.stopPropagation()} style={modalBoxStyle}>
        <h3 style={{ margin: "0 0 20px", fontSize: 18, color: "#111" }}>기타일정 등록</h3>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>제목</label>
          <input value={form.title} onChange={e => setForm({...form, title: e.target.value})} placeholder="예: 청소, 미팅, 휴무" style={formInputStyle} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>날짜</label>
          <input type="date" value={form.date} onChange={e => setForm({...form, date: e.target.value})} style={formInputStyle} />
        </div>
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <div style={{ flex: 1 }}>
            <label style={formLabelStyle}>시작</label>
            <input type="time" value={form.start_time} onChange={e => setForm({...form, start_time: e.target.value})} style={formInputStyle} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={formLabelStyle}>종료</label>
            <input type="time" value={form.end_time} onChange={e => setForm({...form, end_time: e.target.value})} style={formInputStyle} />
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>담당강사 (선택)</label>
          <select value={form.trainer_id} onChange={e => setForm({...form, trainer_id: e.target.value})} style={formInputStyle}>
            <option value="">미배정</option>
            {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>메모</label>
          <textarea value={form.memo} onChange={e => setForm({...form, memo: e.target.value})} style={{...formInputStyle, minHeight: 60, resize: "vertical"}} />
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <button onClick={handleSave} style={btnPrimary}>등록</button>
          <button onClick={onClose} style={btnGray}>취소</button>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// 빈칸 클릭 → 일정등록 선택창
// ─────────────────────────────────────────────
// ─────────────────────────────────────────────
// 스케줄러 전용 수업 생성 모달 (수업관리 모달 복제 — 그 자리에서 바로 생성)
// ─────────────────────────────────────────────
function SchedulerLessonModal({ token, addToast, slot, onClose, onSaved }) {
  const initialForm = {
    trainer_id: slot && slot.trainer_id ? String(slot.trainer_id) : "", name: "", type: "PT", product_id: "", product_ids: [],
    capacity: 1, min_capacity: 0, days_of_week: (slot && slot.days_of_week) || [], start_time: (slot && slot.start_time) || "", duration_minutes: 50, deduction_count: null, announcement: "",
    start_date: (slot && slot.date) || ymdKST(), end_date: "",
    app_booking_enabled: false,
    booking_open_value: 1, booking_open_unit: "WEEK",
    booking_close_value: 1, booking_close_unit: "HOUR",
    cancel_cutoff_value: null, cancel_cutoff_unit: null,
    same_day_change_value: null, same_day_change_unit: null,
    auto_close_value: null, auto_close_unit: null,
    attendance_check_enabled: false,
    attendance_check_value: 0, attendance_check_unit: "MINUTE",
    sms_enabled: false,
    sms_send_value: 10, sms_send_unit: "MINUTE", sms_method: "SMS",
    waitlist_enabled: false, waitlist_sms_enabled: false,
    waitlist_capacity: 0, waitlist_auto_value: null, waitlist_auto_unit: null,
    show_remaining: false,
    seat_assignment: false, seat_rows: 5, seat_cols: 5, seat_disabled_numbers: "[]",
    cross_branch_enabled: false,
    session_fee: "",
  };
  const [form, setForm] = React.useState(initialForm);
  const [trainers, setTrainers] = React.useState([]);
  const [products, setProducts] = React.useState([]);
  const [saving, setSaving] = React.useState(false);
  const [tenantPolicy, setTenantPolicy] = React.useState({ default_cancel_cutoff_value: 24, default_cancel_cutoff_unit: "HOUR", default_deduction_count: 1 });
  const editTarget = null;

  React.useEffect(() => {
    api("/staff/list?tenant_id=1", {}, token).then(d => setTrainers(Array.isArray(d) ? d : [])).catch(() => {});
    api("/membership-plan/list", {}, token).then(d => setProducts(Array.isArray(d) ? d : [])).catch(() => {});
    api("/tenant/1/settings", {}, token).then(d => setTenantPolicy({
      default_cancel_cutoff_value: d.default_cancel_cutoff_value != null ? d.default_cancel_cutoff_value : 24,
      default_cancel_cutoff_unit: d.default_cancel_cutoff_unit || "HOUR",
      default_deduction_count: d.default_deduction_count != null ? d.default_deduction_count : 1,
    })).catch(() => {});
  }, [token]);

  const unitLabel = (u) => ({ HOUR: "시간", DAY: "일", WEEK: "주" }[u] || "시간");
  const dayLabels = { MON: "월", TUE: "화", WED: "수", THU: "목", FRI: "금", SAT: "토", SUN: "일" };
  const dayOrder = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
  const toggleDay = (day) => { setForm(p => ({ ...p, days_of_week: p.days_of_week.includes(day) ? p.days_of_week.filter(d => d !== day) : [...p.days_of_week, day] })); };
  const toggleAllDays = () => { setForm(p => ({ ...p, days_of_week: p.days_of_week.length === 7 ? [] : [...dayOrder] })); };
  const inputStyle = { width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" };
  const labelStyle = { display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 6 };
  const sectionTitle = { fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 12, marginTop: 8 };

  const NumStepper = ({ value, onChange, suffix, min = 0 }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <button onClick={() => onChange(Math.max(min, parseInt(value || 0) - 1))} style={{ width: 36, height: 36, borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer", fontSize: 16 }}>−</button>
      <input type="number" value={value} onChange={e => onChange(e.target.value)} style={{ width: 70, height: 36, textAlign: "center", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none" }} />
      <button onClick={() => onChange(parseInt(value || 0) + 1)} style={{ width: 36, height: 36, borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer", fontSize: 16 }}>+</button>
      {suffix && <span style={{ fontSize: 13, color: "#6b7280" }}>{suffix}</span>}
    </div>
  );

  const ToggleBtn = ({ value, onChange, options }) => (
    <div style={{ display: "flex", gap: 6 }}>
      {options.map(opt => (
        <button key={String(opt.value)} onClick={() => onChange(opt.value)}
          style={{
            padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer",
            border: `1px solid ${value === opt.value ? "#2563eb" : "#e5e7eb"}`,
            background: value === opt.value ? "#2563eb" : "#fff",
            color: value === opt.value ? "#fff" : "#374151"
          }}>{opt.label}</button>
      ))}
    </div>
  );

  const handleSubmit = async () => {
    if (!form.trainer_id) return addToast("담당 강사를 선택하세요", "error");
    if (!form.name) return addToast("수업명을 입력하세요", "error");
    if (form.days_of_week.length === 0) return addToast("요일을 선택하세요", "error");
    if (!form.start_time) return addToast("시작 시간을 입력하세요", "error");
    if (!form.duration_minutes) return addToast("수업 시간을 입력하세요", "error");

    setSaving(true);
    try {
      const payload = {
        trainer_id: parseInt(form.trainer_id),
        name: form.name,
        type: form.type,
        product_id: null,
        product_ids: form.product_ids || [],
        capacity: parseInt(form.capacity) || 1,
        min_capacity: parseInt(form.min_capacity) || 0,
        days_of_week: form.days_of_week.join(","),
        start_time: form.start_time.length === 5 ? form.start_time + ":00" : form.start_time,
        duration_minutes: parseInt(form.duration_minutes),
        deduction_count: form.deduction_count != null ? parseInt(form.deduction_count) : null,
        start_date: form.start_date,
        end_date: form.end_date || null,
        app_booking_enabled: form.app_booking_enabled,
        booking_open_value: form.app_booking_enabled ? parseInt(form.booking_open_value) : null,
        booking_open_unit: form.app_booking_enabled ? form.booking_open_unit : null,
        booking_close_value: form.app_booking_enabled ? parseInt(form.booking_close_value) : null,
        announcement: form.announcement || null,
        booking_close_unit: form.app_booking_enabled ? form.booking_close_unit : null,
        cancel_cutoff_value: form.app_booking_enabled && form.cancel_cutoff_value != null ? parseInt(form.cancel_cutoff_value) : null,
        cancel_cutoff_unit: form.app_booking_enabled && form.cancel_cutoff_unit ? form.cancel_cutoff_unit : null,
        same_day_change_value: form.app_booking_enabled && form.same_day_change_value != null ? parseInt(form.same_day_change_value) : null,
        same_day_change_unit: form.app_booking_enabled && form.same_day_change_unit ? form.same_day_change_unit : null,
        auto_close_value: form.auto_close_value != null ? parseInt(form.auto_close_value) : null,
        auto_close_unit: form.auto_close_unit || null,
        attendance_check_enabled: form.attendance_check_enabled,
        attendance_check_value: parseInt(form.attendance_check_value) || 0,
        attendance_check_unit: form.attendance_check_unit || "MINUTE",
        sms_enabled: form.sms_enabled,
        sms_send_value: parseInt(form.sms_send_value) || 10,
        sms_send_unit: form.sms_send_unit || "MINUTE",
        sms_method: form.sms_method || "SMS",
        waitlist_enabled: form.waitlist_enabled,
        waitlist_sms_enabled: form.waitlist_sms_enabled,
        waitlist_capacity: form.waitlist_enabled ? (parseInt(form.waitlist_capacity) || 0) : 0,
        waitlist_auto_value: form.waitlist_enabled && form.waitlist_auto_value != null ? parseInt(form.waitlist_auto_value) : null,
        waitlist_auto_unit: form.waitlist_enabled && form.waitlist_auto_unit ? form.waitlist_auto_unit : null,
        show_remaining: form.show_remaining,
        seat_assignment: form.seat_assignment,
        seat_rows: parseInt(form.seat_rows) || 5,
        seat_cols: parseInt(form.seat_cols) || 5,
        seat_disabled_numbers: form.seat_disabled_numbers || "[]",
        cross_branch_enabled: form.cross_branch_enabled,
        session_fee: form.session_fee ? parseInt(form.session_fee) : null,
      };
      const _times = [...new Set([form.start_time, ...(form.extra_times || [])].filter(Boolean))];
      for (const _t of _times) {
        const _tt = _t.length === 5 ? _t + ":00" : _t;
        await api("/lesson", { method: "POST", body: JSON.stringify({ ...payload, start_time: _tt }) }, token);
      }
      addToast(`수업이 ${_times.length}개 시간대로 생성되었습니다`, "success");
      onSaved();
    } catch (e) { addToast("저장 실패: " + e.message, "error"); setSaving(false); }
  };

  return (
    <Modal title="수업 생성" onClose={onClose}>

          <div style={sectionTitle}>강사 및 수업 배정</div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>담당 강사</label>
            <select value={form.trainer_id} onChange={e => setForm(p => ({ ...p, trainer_id: e.target.value }))} style={inputStyle}>
              <option value="">강사를 선택해주세요</option>
              {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>수업명</label>
            <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="수업명을 입력해 주세요" style={inputStyle} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>수업 유형</label>
            <ToggleBtn value={form.type} onChange={v => setForm(p => ({ ...p, type: v }))} options={[
              { value: "PT", label: "개인 수업" }, { value: "GROUP", label: "그룹 수업" }
            ]} />
          </div>
          {form.type === "GROUP" && (
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>수업료 (1회, 정산 %용 · 선택)</label>
              <input value={form.session_fee || ""} onChange={e => setForm(p => ({ ...p, session_fee: e.target.value }))} placeholder="예: 100000" type="number" style={inputStyle} />
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>강사 정산이 '수업료의 %' 방식일 때 이 금액에 %를 곱합니다. 고정금액 정산이면 비워도 돼요.</div>
            </div>
          )}

         <div style={sectionTitle}>예약 가능 회원권 (다중 선택)</div>
<div style={{ marginBottom: 14 }}>
  <label style={labelStyle}>이 수업을 예약할 수 있는 회원권을 모두 선택하세요</label>
  {products.length === 0 ? (
    <div style={{ padding: 12, background: "#fff7ed", borderRadius: 8, fontSize: 12, color: "#f97316" }}>
      등록된 상품이 없습니다. 상품관리에서 먼저 등록해주세요.
    </div>
  ) : (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 220, overflowY: "auto", padding: 8, background: "#f9fafb", borderRadius: 10 }}>
      {products.map(p => {
        const selected = (form.product_ids || []).includes(p.id);
        return (
          <div key={p.id}
            onClick={() => {
              setForm(prev => {
                const ids = prev.product_ids || [];
                return {
                  ...prev,
                  product_ids: selected ? ids.filter(x => x !== p.id) : [...ids, p.id]
                };
              });
            }}
            style={{
              display: "flex", alignItems: "center", gap: 10,
              padding: "10px 12px",
              background: selected ? "#eff6ff" : "#fff",
              border: `1.5px solid ${selected ? "#2563eb" : "#e5e7eb"}`,
              borderRadius: 8, cursor: "pointer", fontSize: 13,
              transition: "all 0.15s"
            }}>
            <div style={{
              width: 18, height: 18, borderRadius: 4,
              border: `2px solid ${selected ? "#2563eb" : "#d1d5db"}`,
              background: selected ? "#2563eb" : "#fff",
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0
            }}>
              {selected && <span style={{ color: "#fff", fontSize: 12, fontWeight: "bold" }}>✓</span>}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, color: "#111" }}>{p.name}</div>
              {p.category && <div style={{ fontSize: 11, color: "#6b7280" }}>{p.category}</div>}
            </div>
          </div>
        );
      })}
    </div>
  )}
  {(form.product_ids || []).length > 0 && (
    <div style={{ marginTop: 8, fontSize: 12, color: "#2563eb", fontWeight: 600 }}>
      ✓ {(form.product_ids || []).length}개 선택됨
    </div>
  )}
</div>

          <div style={sectionTitle}>상세 설정</div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>{form.type === "PT" ? "수업 인원" : "최대 수강 정원"}</label>
            {form.type === "PT" ? (
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {[[1, "개인 (1:1)"], [2, "듀엣 (2:1)"], [3, "트리플 (3:1)"]].map(([v, lab]) => (
                  <button key={v} type="button" onClick={() => setForm(p => ({ ...p, capacity: v }))} style={{
                    padding: "8px 16px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                    border: `1px solid ${form.capacity === v ? "#2563eb" : "#e5e7eb"}`,
                    background: form.capacity === v ? "#eff6ff" : "#fff",
                    color: form.capacity === v ? "#2563eb" : "#374151"
                  }}>{lab}</button>
                ))}
              </div>
            ) : (
              <NumStepper value={form.capacity} onChange={v => setForm(p => ({ ...p, capacity: v }))} suffix="명" min={1} />
            )}
          </div>
          {form.type === "GROUP" && (
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>최소 수강 인원 (폐강 기준)</label>
              <NumStepper value={form.min_capacity} onChange={v => setForm(p => ({ ...p, min_capacity: v }))} suffix="명" min={0} />
              {form.min_capacity > 0 && (
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginTop: 10, background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 8, padding: "10px 12px" }}>
                  <span style={{ fontSize: 13, color: "#9a3412" }}>최소 인원 미달 시 수업 시작</span>
                  <NumStepper value={form.auto_close_value ?? 0} onChange={v => setForm(p => ({ ...p, auto_close_value: parseInt(v) || 0 }))} min={0} />
                  <select value={form.auto_close_unit || "HOUR"} onChange={e => setForm(p => ({ ...p, auto_close_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
                    <option value="HOUR">시간</option><option value="MINUTE">분</option>
                  </select>
                  <span style={{ fontSize: 13, color: "#9a3412" }}>전에 자동 폐강</span>
                </div>
              )}
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>0명이면 폐강되지 않습니다.</div>
            </div>
          )}
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>요일 선택</label>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              <button onClick={toggleAllDays} style={{
                padding: "8px 16px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                border: `1px solid ${form.days_of_week.length === 7 ? "#2563eb" : "#e5e7eb"}`,
                background: form.days_of_week.length === 7 ? "#2563eb" : "#fff",
                color: form.days_of_week.length === 7 ? "#fff" : "#374151"
              }}>전체</button>
              {dayOrder.map(d => (
                <button key={d} onClick={() => toggleDay(d)} style={{
                  padding: "8px 16px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                  border: `1px solid ${form.days_of_week.includes(d) ? "#2563eb" : "#e5e7eb"}`,
                  background: form.days_of_week.includes(d) ? "#2563eb" : "#fff",
                  color: form.days_of_week.includes(d) ? "#fff" : "#374151"
                }}>{dayLabels[d]}</button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>수업 시작 시간</label>
            <TimePicker value={form.start_time} onChange={v => setForm(p => ({ ...p, start_time: v }))} />
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
              <span style={{ fontSize: 12, color: "#6b7280" }}>시간 추가</span>
              <div style={{ width: 150 }}>
                <TimePicker value={form._newTime || ""} onChange={v => setForm(p => ({ ...p, _newTime: v }))} placeholder="추가할 시간" />
              </div>
              <button type="button" onClick={() => setForm(p => {
                const t = p._newTime;
                if (!t) return p;
                const cur = p.extra_times || [];
                if (t === p.start_time || cur.includes(t)) return { ...p, _newTime: "" };
                return { ...p, extra_times: [...cur, t], _newTime: "" };
              })} style={{ padding: "8px 14px", borderRadius: 8, border: "1px solid #2563eb", background: "#eff6ff", color: "#2563eb", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ 추가</button>
            </div>
            {(form.extra_times || []).length > 0 && (
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 10, alignItems: "center" }}>
                {form.start_time && (
                  <span style={{ padding: "5px 10px", borderRadius: 20, background: "#e0e7ff", color: "#3730a3", fontSize: 12, fontWeight: 700 }}>{form.start_time} (대표)</span>
                )}
                {(form.extra_times || []).map((t, i) => (
                  <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "5px 10px", borderRadius: 20, background: "#eff6ff", color: "#2563eb", fontSize: 12, fontWeight: 700 }}>
                    {t}
                    <span onClick={() => setForm(p => ({ ...p, extra_times: (p.extra_times || []).filter(x => x !== t) }))} style={{ cursor: "pointer" }}>✕</span>
                  </span>
                ))}
              </div>
            )}
            <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 6 }}>여러 시간대에 같은 수업을 열려면 시간을 추가하세요. 추가한 시간마다 수업이 생성됩니다.</div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>수업 시간</label>
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
              <NumStepper value={form.duration_minutes} onChange={v => setForm(p => ({ ...p, duration_minutes: v }))} suffix="분" />
              {[20, 30, 50].map(m => (
                <button key={m} onClick={() => setForm(p => ({ ...p, duration_minutes: m }))} style={{
                  padding: "6px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                  border: `1px solid ${form.duration_minutes === m ? "#2563eb" : "#e5e7eb"}`,
                  background: form.duration_minutes === m ? "#eff6ff" : "#fff",
                  color: form.duration_minutes === m ? "#2563eb" : "#374151"
                }}>{m}분</button>
              ))}
            </div>
          </div>
          
          <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>운영 시작일</label>
              <input type="date" value={form.start_date} onChange={e => setForm(p => ({ ...p, start_date: e.target.value }))} style={inputStyle} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>운영 종료일 (선택)</label>
              <input type="date" value={form.end_date} onChange={e => setForm(p => ({ ...p, end_date: e.target.value }))} style={inputStyle} />
            </div>
          </div>
          <div style={{ marginBottom: 14 }}>
  <label style={labelStyle}>회원 안내사항 (선택)</label>
  <textarea
    value={form.announcement || ""}
    onChange={e => setForm(p => ({ ...p, announcement: e.target.value }))}
    placeholder="예약 완료 후 회원에게 보여줄 안내사항을 입력하세요&#10;예: 운동복, 양말 지참 부탁드려요&#10;출입 QR은 홈 화면에서 확인 가능해요"
    style={{ ...inputStyle, minHeight: 90, resize: "vertical", fontFamily: "inherit", lineHeight: 1.6 }}
  />
  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
    줄바꿈으로 항목 구분 · 회원앱 예약 완료 화면에 표시됩니다
  </div>
</div>

{/* 앱 예약 섹션 */}
<div style={{ marginTop: 20, marginBottom: 14, padding: "16px 0", borderTop: "1px solid #f3f4f6" }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.app_booking_enabled ? 16 : 0 }}>
    <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>앱 예약</div>
    <ToggleBtn value={form.app_booking_enabled} onChange={v => setForm(p => ({ ...p, app_booking_enabled: v }))} options={[
      { value: true, label: "사용함" }, { value: false, label: "사용안함" }
    ]} />
  </div>

  {form.app_booking_enabled && (
    <div style={{ background: "#f9fafb", borderRadius: 12, padding: 16 }}>
      {/* 예약 가능 시간 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginBottom: 10 }}>예약 가능 시간</div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>예약은 각 일정 시작 시각</span>
          <NumStepper value={form.booking_open_value} onChange={v => setForm(p => ({ ...p, booking_open_value: v }))} min={1} />
          <select value={form.booking_open_unit} onChange={e => setForm(p => ({ ...p, booking_open_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
            <option value="HOUR">시간</option><option value="DAY">일</option><option value="WEEK">주</option>
          </select>
          <span style={{ fontSize: 13, color: "#6b7280" }}>전부터 가능</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>각 일정 시작 시각</span>
          <NumStepper value={form.booking_close_value} onChange={v => setForm(p => ({ ...p, booking_close_value: v }))} min={0} />
          <select value={form.booking_close_unit} onChange={e => setForm(p => ({ ...p, booking_close_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
            <option value="HOUR">시간</option><option value="DAY">일</option><option value="WEEK">주</option>
          </select>
          <span style={{ fontSize: 13, color: "#6b7280" }}>전에 마감</span>
        </div>
      </div>

     {/* 예약 취소 정책 (토글 UX) */}
<div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
  <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginBottom: 10 }}>예약 취소 정책</div>

  {form.cancel_cutoff_value === -1 ? (
    /* 취소 불가 */
    <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 12, padding: "14px 16px" }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: "#dc2626", marginBottom: 8 }}>🚫 이 수업은 예약 취소가 불가능합니다</div>
      <span onClick={() => setForm(p => ({ ...p, cancel_cutoff_value: null, cancel_cutoff_unit: null, deduction_count: null }))}
        style={{ fontSize: 12, color: "#2563eb", cursor: "pointer", textDecoration: "underline" }}>← 취소 가능으로 변경</span>
    </div>
  ) : (form.cancel_cutoff_value == null && form.cancel_cutoff_unit == null && form.deduction_count == null) ? (
    /* 시안 ① 공통 설정 사용 중 */
    <div style={{ background: "#f3f4f6", border: "1px solid #e5e7eb", borderRadius: 12, padding: "14px 16px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, color: "#6b7280", marginBottom: 12 }}>
        🔒 가맹점 공통 설정 사용 중
      </div>
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "11px 13px", marginBottom: 12 }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 6 }}>
          <span style={{ color: "#6b7280" }}>취소 가능 시간</span>
          <span style={{ color: "#111", fontWeight: 600 }}>
            시작 {tenantPolicy.default_cancel_cutoff_value}{unitLabel(tenantPolicy.default_cancel_cutoff_unit)} 전까지
          </span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
          <span style={{ color: "#6b7280" }}>이후 차감</span>
          <span style={{ color: "#111", fontWeight: 600 }}>{tenantPolicy.default_deduction_count}회 (노쇼 포함)</span>
        </div>
      </div>
      <button
        type="button"
        onClick={() => setForm(p => ({
          ...p,
          cancel_cutoff_value: tenantPolicy.default_cancel_cutoff_value,
          cancel_cutoff_unit: tenantPolicy.default_cancel_cutoff_unit,
          deduction_count: tenantPolicy.default_deduction_count
        }))}
        style={{ padding: "7px 14px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", fontSize: 12, fontWeight: 600, color: "#374151", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}
      >
        ✏️ 이 수업만 따로 설정
      </button>
      <button
        type="button"
        onClick={() => setForm(p => ({ ...p, cancel_cutoff_value: -1, cancel_cutoff_unit: null, deduction_count: null }))}
        style={{ marginLeft: 8, padding: "7px 14px", borderRadius: 8, border: "1px solid #fecaca", background: "#fff", fontSize: 12, fontWeight: 600, color: "#dc2626", cursor: "pointer" }}
      >
        🚫 취소 불가로 설정
      </button>
    </div>
  ) : (
    /* 시안 ② 개별 설정 활성화 */
    <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 12, padding: "14px 16px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, color: "#2563eb", marginBottom: 12 }}>
        ✏️ 이 수업 전용 정책
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
        <span style={{ fontSize: 13, color: "#374151" }}>각 일정 시작 시각</span>
        <NumStepper value={form.cancel_cutoff_value ?? 0} onChange={v => setForm(p => ({ ...p, cancel_cutoff_value: parseInt(v) || 0 }))} min={0} />
        <select value={form.cancel_cutoff_unit || "HOUR"} onChange={e => setForm(p => ({ ...p, cancel_cutoff_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
          <option value="HOUR">시간</option><option value="DAY">일</option><option value="WEEK">주</option>
        </select>
        <span style={{ fontSize: 13, color: "#374151" }}>전까지 무료 취소 가능</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        <span style={{ fontSize: 13, color: "#374151" }}>이후 취소 시</span>
        <NumStepper value={form.deduction_count ?? 1} onChange={v => setForm(p => ({ ...p, deduction_count: parseInt(v) || 0 }))} min={0} />
        <span style={{ fontSize: 13, color: "#374151" }}>회 차감 (노쇼 포함)</span>
      </div>
      <span
        onClick={() => setForm(p => ({ ...p, cancel_cutoff_value: null, cancel_cutoff_unit: null, deduction_count: null }))}
        style={{ fontSize: 12, color: "#2563eb", cursor: "pointer", textDecoration: "underline" }}
      >
        ← 가맹점 공통 설정으로 되돌리기
      </span>
    </div>
  )}
</div>

      {/* 당일 예약변경 가능 시간 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginBottom: 10 }}>당일 예약변경 가능 시간</div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>각 일정 시작 시각</span>
          <NumStepper value={form.same_day_change_value ?? 0} onChange={v => setForm(p => ({ ...p, same_day_change_value: parseInt(v) || 0 }))} min={0} />
          <select value={form.same_day_change_unit || "HOUR"} onChange={e => setForm(p => ({ ...p, same_day_change_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
            <option value="HOUR">시간</option><option value="MINUTE">분</option>
          </select>
          <span style={{ fontSize: 13, color: "#6b7280" }}>전까지 당일 예약 변경 가능</span>
        </div>
      </div>

      {/* 출석 처리 시간 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.attendance_check_enabled ? 10 : 0 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>출석 처리 시간</span>
          <ToggleBtn value={form.attendance_check_enabled} onChange={v => setForm(p => ({ ...p, attendance_check_enabled: v }))} options={[
            { value: true, label: "사용함" }, { value: false, label: "사용안함" }
          ]} />
        </div>
        {form.attendance_check_enabled && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span style={{ fontSize: 13, color: "#6b7280" }}>각 일정 시작 시각 기준</span>
            <NumStepper value={form.attendance_check_value} onChange={v => setForm(p => ({ ...p, attendance_check_value: v }))} min={0} />
            <select value={form.attendance_check_unit} onChange={e => setForm(p => ({ ...p, attendance_check_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
              <option value="MINUTE">분</option><option value="HOUR">시간</option>
            </select>
            <span style={{ fontSize: 13, color: "#6b7280" }}>후까지 출석 처리합니다.</span>
          </div>
        )}
      </div>

      {/* 예약 문자 발송 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.sms_enabled ? 10 : 0 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>예약 문자 발송</span>
          <ToggleBtn value={form.sms_enabled} onChange={v => setForm(p => ({ ...p, sms_enabled: v }))} options={[
            { value: true, label: "사용함" }, { value: false, label: "사용안함" }
          ]} />
        </div>
        {form.sms_enabled && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
              <span style={{ fontSize: 13, color: "#6b7280", minWidth: 70 }}>발송 시점</span>
              <span style={{ fontSize: 13, color: "#6b7280" }}>각 일정 시작 시각 기준</span>
              <NumStepper value={form.sms_send_value} onChange={v => setForm(p => ({ ...p, sms_send_value: v }))} min={0} />
              <select value={form.sms_send_unit} onChange={e => setForm(p => ({ ...p, sms_send_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
                <option value="MINUTE">분</option><option value="HOUR">시간</option>
              </select>
              <span style={{ fontSize: 13, color: "#6b7280" }}>전에 발송</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 13, color: "#6b7280", minWidth: 70 }}>발송 방식</span>
              <select value={form.sms_method} onChange={e => setForm(p => ({ ...p, sms_method: e.target.value }))} style={{ ...inputStyle, width: 160 }}>
                <option value="SMS">문자메시지</option>
                <option value="KAKAO">카카오 알림톡</option>
              </select>
            </div>
          </div>
        )}
      </div>

      {/* 예약 대기 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.waitlist_enabled ? 10 : 0 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>예약 대기</span>
          <ToggleBtn value={form.waitlist_enabled} onChange={v => setForm(p => ({ ...p, waitlist_enabled: v }))} options={[
            { value: true, label: "사용함" }, { value: false, label: "사용안함" }
          ]} />
        </div>
        {form.waitlist_enabled && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
              <span style={{ fontSize: 13, color: "#374151", minWidth: 90 }}>대기 가능 인원</span>
              <NumStepper value={form.waitlist_capacity ?? 0} onChange={v => setForm(p => ({ ...p, waitlist_capacity: parseInt(v) || 0 }))} min={0} suffix="명" />
              <span style={{ fontSize: 12, color: "#9ca3af" }}>(0명이면 무제한)</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
              <span style={{ fontSize: 13, color: "#374151", minWidth: 90 }}>자동 예약 마감</span>
              <span style={{ fontSize: 13, color: "#6b7280" }}>공석 시 수업 시작</span>
              <NumStepper value={form.waitlist_auto_value ?? 0} onChange={v => setForm(p => ({ ...p, waitlist_auto_value: parseInt(v) || 0 }))} min={0} />
              <select value={form.waitlist_auto_unit || "HOUR"} onChange={e => setForm(p => ({ ...p, waitlist_auto_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
                <option value="HOUR">시간</option><option value="MINUTE">분</option>
              </select>
              <span style={{ fontSize: 13, color: "#6b7280" }}>전까지 자동 예약</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 0" }}>
              <span style={{ fontSize: 13, color: "#374151" }}>대기 → 예약 전환 시 문자 발송</span>
              <ToggleBtn value={form.waitlist_sms_enabled} onChange={v => setForm(p => ({ ...p, waitlist_sms_enabled: v }))} options={[
                { value: true, label: "사용함" }, { value: false, label: "사용안함" }
              ]} />
            </div>
          </div>
        )}
      </div>

      {/* 잔여 인원 노출 */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>잔여 인원 노출</span>
        <ToggleBtn value={form.show_remaining} onChange={v => setForm(p => ({ ...p, show_remaining: v }))} options={[
          { value: true, label: "사용함" }, { value: false, label: "사용안함" }
        ]} />
      </div>

      {/* 좌석 수업 설정 */}
      <div style={{ marginTop: 10, marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.seat_assignment ? 10 : 0 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>좌석 수업 설정</span>
          <ToggleBtn value={form.seat_assignment} onChange={v => setForm(p => ({ ...p, seat_assignment: v }))} options={[
            { value: true, label: "사용함" }, { value: false, label: "사용안함" }
          ]} />
        </div>
        {form.seat_assignment && (
          <div>
            <div style={{ display: "flex", gap: 16, marginBottom: 12 }}>
              <div>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>좌석 행</div>
                <NumStepper value={form.seat_rows} onChange={v => setForm(p => ({ ...p, seat_rows: Math.max(1, Math.min(10, v)) }))} min={1} />
              </div>
              <div>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>좌석 열</div>
                <NumStepper value={form.seat_cols} onChange={v => setForm(p => ({ ...p, seat_cols: Math.max(1, Math.min(10, v)) }))} min={1} />
              </div>
            </div>
            <div style={{ padding: 12, background: "#fff", borderRadius: 8, border: "1px solid #e5e7eb" }}>
              <div style={{ display: "grid", gridTemplateColumns: `repeat(${form.seat_cols}, 1fr)`, gap: 6 }}>
                {Array.from({ length: (form.seat_rows || 1) * (form.seat_cols || 1) }, (_, i) => {
                  const num = i + 1;
                  const disabledList = (() => {
                    try { return JSON.parse(form.seat_disabled_numbers || "[]"); } catch { return []; }
                  })();
                  const isDisabled = disabledList.includes(num);
                  return (
                    <div
                      key={num}
                      onClick={() => {
                        const cur = (() => {
                          try { return JSON.parse(form.seat_disabled_numbers || "[]"); } catch { return []; }
                        })();
                        const next = cur.includes(num) ? cur.filter(n => n !== num) : [...cur, num];
                        setForm(p => ({ ...p, seat_disabled_numbers: JSON.stringify(next) }));
                      }}
                      style={{
                        padding: "10px 0", textAlign: "center", borderRadius: 6, cursor: "pointer",
                        fontSize: 12, fontWeight: 600,
                        background: isDisabled ? "#e5e7eb" : "#eff6ff",
                        color: isDisabled ? "#9ca3af" : "#2563eb",
                        border: isDisabled ? "1px solid #d1d5db" : "1px solid #bfdbfe",
                        textDecoration: isDisabled ? "line-through" : "none",
                      }}
                    >
                      {num}
                    </div>
                  );
                })}
              </div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 8 }}>좌석 번호를 눌러 이용 불가 좌석을 지정할 수 있습니다.</div>
            </div>
          </div>
        )}
      </div>
    </div>
  )}
</div>

          
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 16 }}>
            <Btn variant="secondary" onClick={onClose}>취소</Btn>
            <Btn onClick={handleSubmit} disabled={saving}>{saving ? "저장 중..." : "수업 생성"}</Btn>
          </div>
    </Modal>
  );
}

function SlotPickerModal({ slot, onChoose, onClose }) {
  const st = `${String(slot.hour).padStart(2, "0")}:00`;
  const rows = [
    { key: "LESSON",  label: "수업 생성",  desc: "개인·그룹 수업 (예약 가능한 수업 만들기)", color: "#2563eb" },
    { key: "CONSULT", label: "상담",       desc: "전화/방문/채팅 등 상담",        color: "#A9791A" },
    { key: "ETC",     label: "기타 일정",  desc: "수업 외 일정",                  color: "#6B7280" },
  ];
  return (
    <div onClick={onClose} style={modalOverlayStyle}>
      <div onClick={e => e.stopPropagation()} style={{ ...modalBoxStyle, width: 380, padding: 0, overflow: "hidden" }}>
        <div style={{ padding: "18px 22px", borderBottom: "1px solid #f3f4f6", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ fontSize: 17, fontWeight: 700, color: "#111" }}>일정 등록</div>
            <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 3 }}>{slot.date} · {st}</div>
          </div>
          <span onClick={onClose} style={{ cursor: "pointer", color: "#9ca3af", fontSize: 18, lineHeight: 1 }}>✕</span>
        </div>
        <div>
          {rows.map(r => (
            <div key={r.key} onClick={() => onChoose(r.key)}
              onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
              onMouseLeave={e => e.currentTarget.style.background = "#fff"}
              style={{ padding: "15px 22px", borderBottom: "1px solid #f7f7f9", cursor: "pointer", display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ width: 10, height: 10, borderRadius: 3, background: r.color, flexShrink: 0 }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>{r.label}</div>
                <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{r.desc}</div>
              </div>
              <span style={{ color: "#d1d5db", fontSize: 18 }}>›</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// 회원 검색 선택 박스
function MemberSearchBox({ members, selected, onSelect, placeholder }) {
  const [q, setQ] = React.useState("");
  const [open, setOpen] = React.useState(false);
  if (selected) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "9px 11px", border: "1px solid #e5e7eb", borderRadius: 8, background: "#f9fafb" }}>
        <span style={{ fontSize: 14, color: "#111", fontWeight: 600 }}>{selected.name} <span style={{ color: "#9ca3af", fontWeight: 400, fontSize: 12 }}>{selected.phone || ""}</span></span>
        <span onClick={() => onSelect(null)} style={{ cursor: "pointer", color: "#9ca3af", fontSize: 13 }}>변경 ✕</span>
      </div>
    );
  }
  const filtered = q ? members.filter(m =>
    (m.name && m.name.includes(q)) || (m.phone && m.phone.includes(q)) || (m.member_number && String(m.member_number).includes(q))
  ).slice(0, 8) : [];
  return (
    <div style={{ position: "relative" }}>
      <input value={q} onChange={e => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
        placeholder={placeholder || "회원 이름/전화 검색"} style={formInputStyle} />
      {open && filtered.length > 0 && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 10, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, marginTop: 4, maxHeight: 200, overflowY: "auto", boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}>
          {filtered.map(m => (
            <div key={m.id} onClick={() => { onSelect(m); setQ(""); setOpen(false); }}
              onMouseEnter={e => e.currentTarget.style.background = "#f3f4f6"}
              onMouseLeave={e => e.currentTarget.style.background = "#fff"}
              style={{ padding: "9px 11px", cursor: "pointer", fontSize: 14, borderBottom: "1px solid #f7f7f9" }}>
              {m.name} <span style={{ color: "#9ca3af", fontSize: 12 }}>{m.phone || ""}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// 개인수업(PT) 생성 모달
// ─────────────────────────────────────────────
function PtCreateModal({ slot, trainers, members, token, addToast, onClose, onSaved }) {
  const [member, setMember] = React.useState(null);
  const [form, setForm] = React.useState({ date: slot.date, start_time: slot.start_time, end_time: slot.end_time, trainer_id: slot.trainer_id || "", memo: "" });
  const [saving, setSaving] = React.useState(false);

  const handleSave = async () => {
    if (!member) { addToast("회원을 선택하세요.", "error"); return; }
    setSaving(true);
    try {
      await api("/reservation", {
        method: "POST",
        body: JSON.stringify({
          member_id: member.id,
          trainer_id: form.trainer_id ? Number(form.trainer_id) : null,
          type: "PT",
          title: `${member.name} 개인수업`,
          date: form.date,
          start_time: form.start_time,
          end_time: form.end_time,
          memo: form.memo,
        }),
      }, token);
      addToast("개인수업이 등록되었습니다.", "success");
      onSaved();
    } catch (e) {
      addToast("등록 실패: " + (e.message || ""), "error");
      setSaving(false);
    }
  };

  return (
    <div onClick={onClose} style={modalOverlayStyle}>
      <div onClick={e => e.stopPropagation()} style={modalBoxStyle}>
        <h3 style={{ margin: "0 0 20px", fontSize: 18, color: "#111" }}>개인수업 등록</h3>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>회원 *</label>
          <MemberSearchBox members={members} selected={member} onSelect={setMember} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>날짜</label>
          <input type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} style={formInputStyle} />
        </div>
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <div style={{ flex: 1 }}>
            <label style={formLabelStyle}>시작</label>
            <input type="time" value={form.start_time} onChange={e => setForm({ ...form, start_time: e.target.value })} style={formInputStyle} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={formLabelStyle}>종료</label>
            <input type="time" value={form.end_time} onChange={e => setForm({ ...form, end_time: e.target.value })} style={formInputStyle} />
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>담당강사 (선택)</label>
          <select value={form.trainer_id} onChange={e => setForm({ ...form, trainer_id: e.target.value })} style={formInputStyle}>
            <option value="">미배정</option>
            {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>메모</label>
          <textarea value={form.memo} onChange={e => setForm({ ...form, memo: e.target.value })} style={{ ...formInputStyle, minHeight: 60, resize: "vertical" }} />
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <button onClick={handleSave} disabled={saving} style={{ ...btnPrimary, opacity: saving ? 0.6 : 1 }}>{saving ? "등록 중..." : "등록"}</button>
          <button onClick={onClose} style={btnGray}>취소</button>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// 상담 생성 모달
// ─────────────────────────────────────────────
function ConsultCreateModal({ slot, trainers, members, token, addToast, onClose, onSaved }) {
  const [member, setMember] = React.useState(null);
  const [form, setForm] = React.useState({ name_manual: "", phone: "", type: "PHONE", date: slot.date, start_time: slot.start_time, end_time: slot.end_time, trainer_id: slot.trainer_id || "", memo: "" });
  const [saving, setSaving] = React.useState(false);
  const TYPE_LABELS = { PHONE: "전화상담", VISIT: "방문상담", ETC: "기타상담" };

  const handleSave = async () => {
    if (!member && !form.name_manual.trim()) { addToast("회원을 선택하거나 이름을 입력하세요.", "error"); return; }
    setSaving(true);
    try {
      await api("/consultation", {
        method: "POST",
        body: JSON.stringify({
          member_id: member ? member.id : null,
          member_name_manual: member ? null : form.name_manual,
          phone: member ? (member.phone || form.phone) : form.phone,
          trainer_id: form.trainer_id ? Number(form.trainer_id) : null,
          type: form.type,
          title: TYPE_LABELS[form.type] || "상담",
          date: form.date,
          start_time: form.start_time,
          end_time: form.end_time,
          memo: form.memo,
        }),
      }, token);
      addToast("상담이 등록되었습니다.", "success");
      onSaved();
    } catch (e) {
      addToast("등록 실패: " + (e.message || ""), "error");
      setSaving(false);
    }
  };

  return (
    <div onClick={onClose} style={modalOverlayStyle}>
      <div onClick={e => e.stopPropagation()} style={modalBoxStyle}>
        <h3 style={{ margin: "0 0 20px", fontSize: 18, color: "#111" }}>상담 등록</h3>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>회원 (등록회원 검색)</label>
          <MemberSearchBox members={members} selected={member} onSelect={setMember} />
        </div>
        {!member && (
          <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <label style={formLabelStyle}>이름 (미등록 직접입력)</label>
              <input value={form.name_manual} onChange={e => setForm({ ...form, name_manual: e.target.value })} placeholder="예: 홍길동" style={formInputStyle} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={formLabelStyle}>연락처</label>
              <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="010-0000-0000" style={formInputStyle} />
            </div>
          </div>
        )}
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>상담 유형</label>
          <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} style={formInputStyle}>
            <option value="PHONE">전화상담</option>
            <option value="VISIT">방문상담</option>
            <option value="ETC">기타상담</option>
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>날짜</label>
          <input type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} style={formInputStyle} />
        </div>
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <div style={{ flex: 1 }}>
            <label style={formLabelStyle}>시작</label>
            <input type="time" value={form.start_time} onChange={e => setForm({ ...form, start_time: e.target.value })} style={formInputStyle} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={formLabelStyle}>종료</label>
            <input type="time" value={form.end_time} onChange={e => setForm({ ...form, end_time: e.target.value })} style={formInputStyle} />
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>담당강사 (선택)</label>
          <select value={form.trainer_id} onChange={e => setForm({ ...form, trainer_id: e.target.value })} style={formInputStyle}>
            <option value="">미배정</option>
            {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={formLabelStyle}>메모</label>
          <textarea value={form.memo} onChange={e => setForm({ ...form, memo: e.target.value })} style={{ ...formInputStyle, minHeight: 60, resize: "vertical" }} />
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <button onClick={handleSave} disabled={saving} style={{ ...btnPrimary, opacity: saving ? 0.6 : 1 }}>{saving ? "등록 중..." : "등록"}</button>
          <button onClick={onClose} style={btnGray}>취소</button>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// 스타일 상수
// ─────────────────────────────────────────────
const modalOverlayStyle = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center" };
const modalBoxStyle = { background: "#fff", borderRadius: 14, padding: 28, width: 420, maxWidth: "90vw", maxHeight: "90vh", overflow: "auto", boxShadow: "0 10px 40px rgba(0,0,0,0.2)" };
const detailRowStyle = { display: "flex", padding: "8px 0", borderBottom: "1px solid #f3f4f6", fontSize: 14, color: "#374151" };
const detailLabelStyle = { width: 80, color: "#9ca3af", flexShrink: 0 };
const formLabelStyle = { display: "block", fontSize: 12, color: "#6b7280", marginBottom: 5, fontWeight: 600 };
const formInputStyle = { width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 14, boxSizing: "border-box" };
const btnPrimary = { padding: "9px 18px", background: "#2563eb", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 14, fontWeight: 600 };
const btnDanger = { padding: "9px 18px", background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 8, cursor: "pointer", fontSize: 14, fontWeight: 600 };
const btnGray = { padding: "9px 18px", background: "#f3f4f6", color: "#374151", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 14 };


// MEMBERS PAGE
// ════════════════════════════════════════════════════════════════════════════
const MembersPage = ({ token, addToast, initialFilter, onInitialFilterConsumed }) => {
  const [dashSummary, setDashSummary] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("latest");
  const [filterBy, setFilterBy] = useState("all");
  // 대시보드 카드로 진입 시 지정된 필터 자동 선택 (예: 만료 7일전 → expiry_soon)
  useEffect(() => {
    if (initialFilter) {
      setFilterBy(initialFilter);
      if (onInitialFilterConsumed) onInitialFilterConsumed();
    }
  }, [initialFilter]);
  const [filterTrainer, setFilterTrainer] = useState("");
  const [filterGender, setFilterGender] = useState("");
  const [filterRoute, setFilterRoute] = useState("");
  const [filterPlan, setFilterPlan] = useState("");
  const [filterAge, setFilterAge] = useState("");
  const [filterMemberType, setFilterMemberType] = useState("");
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [planMemberMap, setPlanMemberMap] = useState({});

  const loadPlanMemberMap = async () => {
    try {
      const ms = await api("/membership/list?tenant_id=1", {}, token).catch(() => []);
      if (Array.isArray(ms)) {
        const map = {};
        ms.forEach(item => {
          if (!item.name || !item.member_id) return;
          const key = item.plan_id ? String(item.plan_id) : item.name;
          if (!map[key]) map[key] = new Set();
          map[key].add(item.member_id);
        });
        setPlanMemberMap(map);
      }
    } catch(e) {}
  };
  const [selectedMember, setSelectedMember] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showWizard, setShowWizard] = useState(false);
  const [receiptModal, setReceiptModal] = useState({ open: false, paymentId: null });
  const [unpaidPayModal, setUnpaidPayModal] = useState({ open: false, payment: null });
  const [showUnpaidCardModal, setShowUnpaidCardModal] = useState(false);
  const [cardPayInfo, setCardPayInfo] = useState({});
  const [unpaidPayMethod, setUnpaidPayMethod] = useState("");
  const [unpaidSaving, setUnpaidSaving] = useState(false);
  const [pgEnabled, setPgEnabled] = useState(null);   // 헬스페이 PG 연동 여부 (미연동이면 카드PG 옵션 숨김)
  useEffect(() => {
    fetch("https://heybiseo.ai.kr/payment/pg-enabled", { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => setPgEnabled(!!(d && d.enabled))).catch(() => setPgEnabled(false));
  }, [token]);
  const [saving, setSaving] = useState(false);
  const [trainers, setTrainers] = useState([]);
  const [plans, setPlans] = useState([]);
  const [memberMemberships, setMemberMemberships] = useState([]);
  const [memberPayments, setMemberPayments] = useState([]);
  const [memberReservations, setMemberReservations] = useState([]);
  const [memberAttendances, setMemberAttendances] = useState([]);
  const [showHoldingModal, setShowHoldingModal] = useState(false);
  const [showPayMethodModal, setShowPayMethodModal] = useState(false);
const [selectedPayMethod, setSelectedPayMethod] = useState("");
  const [holdingMember, setHoldingMember] = useState(null);
  const [holdingForm, setHoldingForm] = useState({ start_date: "", end_date: "" });
  const [activeTab, setActiveTab] = useState("dashboard");
  const [resvView, setResvView] = useState("month");
  const [calYear, setCalYear] = useState(new Date().getFullYear());
  const [calMonth, setCalMonth] = useState(new Date().getMonth());
  const [productSearch, setProductSearch] = useState("");
  const [addStep, setAddStep] = useState(1);
const [selectedPlanForMember, setSelectedPlanForMember] = useState(null);
const [selectedPlansForMember, setSelectedPlansForMember] = useState([]);
const [memberMode, setMemberMode] = useState("existing");  // "existing" | "new"
const [selectedExistingMember, setSelectedExistingMember] = useState(null);
const [memberSearchQuery, setMemberSearchQuery] = useState("");
const [productCategory, setProductCategory] = useState("all");
const [discountAmount, setDiscountAmount] = useState("0");
const [unpaidAmount, setUnpaidAmount] = useState("0");
const [selectedContract, setSelectedContract] = useState(null);
const [contracts, setContracts] = useState([]);
const [templates, setTemplates] = useState([]);
const [modusignTemplates, setModusignTemplates] = useState([]);
const [memoText, setMemoText] = useState("");
const [memberContracts, setMemberContracts] = useState([]);
const [memberMemos, setMemberMemos] = useState([]);
const [memberLockerInfo, setMemberLockerInfo] = useState([]);
const [genderData, setGenderData] = useState(null);
const [visitRouteData, setVisitRouteData] = useState([]);
const [selectedMembership, setSelectedMembership] = useState(null);
const [highlightedMembership, setHighlightedMembership] = useState(null);
const [holdingHistoryModal, setHoldingHistoryModal] = useState({ open: false, membershipId: null, list: [] });
const [showMembershipEdit, setShowMembershipEdit] = useState(false);
const [showMembershipLogs, setShowMembershipLogs] = useState(false);
const [membershipEditForm, setMembershipEditForm] = useState({
  start_date: "", end_date: "", total_count: "", remaining_count: "",
  trainer_id: "", memo: "", reason: ""
});
const [membershipLogs, setMembershipLogs] = useState([]);
const [historyModal, setHistoryModal] = useState({ open: false, editLogs: [], holdingLogs: [] });
const [showCameraModal, setShowCameraModal] = useState(false);
const [showCameraForNewMember, setShowCameraForNewMember] = useState(false);
const [newMemberProfileImage, setNewMemberProfileImage] = useState(null);

  const visitRouteOptions = ["온라인", "지인 소개", "SNS", "현수막", "블로그", "기타"];

  const uploadProfileImage = async (file) => {
  if (!file || !selectedMember) return;
  const formData = new FormData();
  formData.append("file", file);
  try {
    const res = await fetch(`https://heybiseo.ai.kr/members/${selectedMember.id}/profile-image?tenant_id=1`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });
    const text = await res.text();
    const data = JSON.parse(text);
   if (data.profile_image) {
      addToast("프로필 사진이 변경됐습니다", "success");
      await load();
      selectMemberAndLoad({ ...selectedMember, profile_image: data.profile_image, _refresh: Date.now() });
    }
  } catch(e) {
    addToast("업로드 실패: " + e.message, "error");
  }
};

 const resetForm = () => ({
    name: "", phone: "", member_number: "", gender: "", birth_date: "", address: "",
    exercise_purpose: "",
    staff_id: "",
    payment_date: ymdKST(),
    start_date: ymdKST(),
    end_date: ymdKST(new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)),
    membership_type: "", personal: "", group: "",
    clothes_start_date: "", clothes_end_date: "",
    locker_start_date: "", locker_end_date: "", locker_number: "",
    holding_yn: "N", holding_count: "0",
    trainer_id: "", manager_id: "",
    visit_route: "", memo: ""
  });

  const [form, setForm] = useState(resetForm());

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/members/?tenant_id=1", {}, token);
      setMembers(Array.isArray(d) ? d : d.items || []);
    } catch (e) { addToast("회원 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => {
  load();
  loadPlanMemberMap();
  api("/dashboard/summary?tenant_id=1", {}, token).then(d => setDashSummary(d)).catch(() => {});
  api("/staff/list?tenant_id=1", {}, token).then(d => setTrainers(Array.isArray(d) ? d : [])).catch(() => {});
  api("/membership-plan/list?tenant_id=1", {}, token).then(d => setPlans(Array.isArray(d) ? d : [])).catch(() => {});
  api("/sales/gender-stats?tenant_id=1", {}, token).then(d => setGenderData(d)).catch(() => {});
setVisitRouteData([]);
  api("/modusign/list?tenant_id=1", {}, token).then(d => setContracts(Array.isArray(d) ? d : [])).catch(() => {});
  api("/modusign/template-list?tenant_id=1", {}, token).then(d => setTemplates(Array.isArray(d) ? d : [])).catch(() => {});
api("/contract/template/list", {}, token).then(d => setModusignTemplates(Array.isArray(d) ? d.filter(x => x.is_active !== false) : [])).catch(() => {});
}, [load]);

  // sessionStorage openMemberId: 간편모드에서 넘어왔을 때 해당 회원 자동 오픈
  useEffect(() => {
    if (members.length === 0) return;
    const openId = sessionStorage.getItem("openMemberId");
    if (!openId) return;
    sessionStorage.removeItem("openMemberId");
    const target = members.find(m => String(m.id) === String(openId));
    if (target) {
      selectMemberAndLoad(target);
      // 담당회원 팝업의 '결제하기'로 넘어온 경우 결제창까지 자동 오픈
      if (sessionStorage.getItem("openMemberPay") === "1") {
        sessionStorage.removeItem("openMemberPay");
        setTimeout(() => setShowWizard(true), 300);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [members]);

  const today = new Date();
const totalCount = members.length;
  const [memberPage, setMemberPage] = useState(1);
  const MEMBER_PAGE_SIZE = 100;
  useEffect(() => { setMemberPage(1); }, [search, filterBy, filterTrainer, filterGender, filterRoute, filterPlan, filterAge, filterMemberType, sortBy]);
  const newIdSet = new Set((dashSummary?.members?.new_member_ids || []).map(Number));
  const reregIdSet = new Set((dashSummary?.members?.rereg_member_ids || []).map(Number));

 const filtered = members
  .filter(m => {
   const matchSearch = m.name?.includes(search) || m.phone?.includes(search) || m.member_number?.includes(search);
    if (!matchSearch) return false;
    if (filterBy === "active") { if (!m.end_date) return false; const d = (new Date(m.end_date) - today) / (1000*60*60*24); if (!(m.status === "active" && d >= 0)) return false; }
    else if (filterBy === "expired") {
      if (!m.end_date) return false;
      const expEnd = new Date(m.end_date);
      if (expEnd >= today) return false;
    }
    else if (filterBy === "expiry_month") {
      if (!m.end_date) return false;
      const end = new Date(m.end_date);
      if (!(end.getFullYear() === today.getFullYear() && end.getMonth() === today.getMonth())) return false;
    }
    else if (filterBy === "expiry_soon") {
      if (!m.end_date || m.status !== "active") return false;
      const diff = (new Date(m.end_date) - today) / (1000 * 60 * 60 * 24);
      if (!(diff >= 0 && diff <= 7)) return false;
    }
    else if (filterBy === "holding") { if (m.is_holding !== "Y") return false; }
    else if (filterBy === "new_month") { if (!newIdSet.has(Number(m.id))) return false; }
    else if (filterBy === "rereg_month") { if (!reregIdSet.has(Number(m.id))) return false; }
    if (filterTrainer && String(m.trainer_id) !== String(filterTrainer)) return false;
    if (filterGender && m.gender !== filterGender) return false;
    if (filterRoute && m.visit_route !== filterRoute) return false;
    if (filterPlan) {
      const selectedPlan = plans.find(p => String(p.id) === String(filterPlan));
      const byId = planMemberMap[String(filterPlan)];
      const byName = selectedPlan ? planMemberMap[selectedPlan.name] : null;
      const memberSet = byId || byName;
      if (!memberSet || !memberSet.has(m.id)) return false;
    }
    if (filterAge) {
      const birth = m.birth_date ? new Date(m.birth_date) : null;
      const age = birth ? Math.floor((new Date() - birth) / (1000 * 60 * 60 * 24 * 365.25)) : null;
      if (age === null) return false;
      if (filterAge === "10s" && !(age >= 10 && age < 20)) return false;
      if (filterAge === "20s" && !(age >= 20 && age < 30)) return false;
      if (filterAge === "30s" && !(age >= 30 && age < 40)) return false;
      if (filterAge === "40s" && !(age >= 40 && age < 50)) return false;
      if (filterAge === "50s" && !(age >= 50 && age < 60)) return false;
      if (filterAge === "60plus" && !(age >= 60)) return false;
    }
    if (filterMemberType) {
      if (filterMemberType === "new" && !newIdSet.has(Number(m.id))) return false;
      if (filterMemberType === "existing" && newIdSet.has(Number(m.id))) return false;
      if (filterMemberType === "expired") {
        if (!m.end_date) return false;
        if (new Date(m.end_date) >= new Date()) return false;
      }
    }
    return true;
  })
  .sort((a, b) => {
    if (sortBy === "latest") return new Date(b.created_at) - new Date(a.created_at);
    if (sortBy === "name") return a.name?.localeCompare(b.name);
    return 0;
  });

  const memberTotalPages = Math.max(1, Math.ceil(filtered.length / MEMBER_PAGE_SIZE));
  const memberCurPage = Math.min(memberPage, memberTotalPages);
  const pagedMembers = filtered.slice((memberCurPage - 1) * MEMBER_PAGE_SIZE, memberCurPage * MEMBER_PAGE_SIZE);


  const activeCount     = dashSummary?.members?.active          ?? members.filter(m => { if (!m.end_date) return false; const d = (new Date(m.end_date) - today) / (1000*60*60*24); return d >= 0; }).length;
  const expiredCount    = dashSummary?.members?.expired         ?? members.filter(m => { if (!m.end_date) return false; return (new Date(m.end_date) - today) / (1000*60*60*24) < 0; }).length;
  const thisMonthExpiry = dashSummary?.members?.expiry_this_month ?? dashSummary?.expiry_this_month ?? 0;
  const soon7 = dashSummary?.members?.expiry_soon ?? dashSummary?.expiry_soon ?? 0;

  const holdingCount = dashSummary?.members?.holding ?? members.filter(m => m.holding_yn === "Y").length;
  const newThisMonth = dashSummary?.members?.new_this_month ?? 0;
  const reregThisMonth = dashSummary?.members?.rereg_this_month ?? 0;

const statCards = [
  { label: "전체 회원", value: `${totalCount}명`, color: "#2563eb", bg: "#eff6ff", filter: "all" },
  { label: "유효 회원", value: `${activeCount}명`, color: "#22c55e", bg: "#f0fdf4", filter: "active" },
  { label: "이번달 신규", value: `${newThisMonth}명`, color: "#0ea5e9", bg: "#f0f9ff", filter: "new_month" },
  { label: "이번달 재등록", value: `${reregThisMonth}명`, color: "#6366f1", bg: "#eef2ff", filter: "rereg_month" },
  { label: "이번달 만료", value: `${thisMonthExpiry}명`, color: "#f97316", bg: "#fff7ed", filter: "expiry_month" },
  { label: "만료 7일전", value: `${soon7}명`, color: "#ef4444", bg: "#fff0f0", filter: "expiry_soon" },
  { label: "홀딩 회원", value: `${holdingCount}명`, color: "#8b5cf6", bg: "#f5f3ff", filter: "holding" },
];

  const selectMemberAndLoad = (m) => {
    setSelectedMember(m);
    setMemoText(m.memo || "");
    setActiveTab("dashboard");
    setForm({
      name: m.name || "", phone: m.phone || "",
      gender: m.gender || "", address: m.address || "",
      birth_date: m.birth_date || "",
      start_date: m.start_date || ymdKST(),
      end_date: m.end_date || "",
      membership_type: "", personal: "", group: "",
      holding_yn: m.holding_yn || "N",
      holding_count: String(m.holding_count || 0),
      trainer_id: String(m.trainer_id || ""),
      manager_id: String(m.manager_id || ""),
      visit_route: m.visit_route || "",
      memo: m.memo || "",
      clothes_start_date: m.clothes_start_date || "",
      clothes_end_date: m.clothes_end_date || "",
      locker_start_date: m.locker_start_date || "",
      locker_end_date: m.locker_end_date || "",
      locker_number: m.locker_number || "",
    });
   api(`/membership/by-member?member_id=${m.id}`, {}, token)
  .then(d => setMemberMemberships(Array.isArray(d) ? d : []))
  .catch(() => setMemberMemberships([]));
    api(`/payment/list?tenant_id=1&member_id=${m.id}`, {}, token)
  .then(d => setMemberPayments(Array.isArray(d) ? d : d?.items || []))
  .catch(() => setMemberPayments([]));
    api(`/reservation/list?tenant_id=1&member_id=${m.id}`, {}, token)
      .then(d => setMemberReservations(Array.isArray(d) ? d : []))
      .catch(() => setMemberReservations([]));
    api(`/attendance/list?tenant_id=1&member_id=${m.id}`, {}, token)
      .then(d => setMemberAttendances(Array.isArray(d) ? d : []))
      .catch(() => setMemberAttendances([]));
      // 자체 전자계약 + (구)모두싸인 계약 모두 조회
      Promise.all([
        api(`/contract/list?member_id=${m.id}`, {}, token).catch(() => []),
        api(`/modusign/list?tenant_id=1&member_id=${m.id}`, {}, token).catch(() => []),
      ]).then(([self, modu]) => {
        const selfList = (Array.isArray(self) ? self : []).map(c => ({ ...c, _self: true }));
        const moduList = (Array.isArray(modu) ? modu : []).map(c => ({ ...c, _self: false }));
        setMemberContracts([...selfList, ...moduList]);
      }).catch(() => setMemberContracts([]));
      api(`/members/${m.id}/memos?tenant_id=1`, {}, token).then(d => setMemberMemos(Array.isArray(d) ? d : [])).catch(() => {});
      api(`/locker/list?tenant_id=1`, {}, token)
  .then(d => {
    const all = Array.isArray(d) ? d : [];
    setMemberLockerInfo(all.filter(l => l.member_id === m.id));
  }).catch(() => setMemberLockerInfo([]));
  };

  const handleSave = async () => {
    if (!form.name || !form.phone) return addToast("이름과 전화번호는 필수입니다", "error");
    setSaving(true);
    try {
      if (selectedMember) {
        await api(`/members/${selectedMember.id}?tenant_id=1`, {
          method: "PUT",
          body: JSON.stringify({
            name: form.name, phone: form.phone,
            gender: form.gender, address: form.address,
            birth_date: form.birth_date || null,
            start_date: form.start_date || null,
            end_date: form.end_date || null,
            visit_route: form.visit_route, memo: form.memo,
            holding_yn: form.holding_yn,
            holding_count: parseInt(form.holding_count) || 0,
            trainer_id: form.trainer_id ? parseInt(form.trainer_id) : null,
            manager_id: form.manager_id ? parseInt(form.manager_id) : null,
            clothes_start_date: form.clothes_start_date || null,
            clothes_end_date: form.clothes_end_date || null,
            locker_start_date: form.locker_start_date || null,
            locker_end_date: form.locker_end_date || null,
            locker_number: form.locker_number || null,
          })
        }, token);
        addToast("수정됐습니다", "success");
        setSelectedMember(null);
      } else {
        const result = await api("/members/", {
          method: "POST",
          body: JSON.stringify({
            name: form.name, phone: form.phone, tenant_id: 1,
            gender: form.gender, address: form.address,
            birth_date: form.birth_date || null,
            start_date: form.start_date, end_date: form.end_date,
            visit_route: form.visit_route, memo: form.memo,
            holding_yn: form.holding_yn, holding_count: parseInt(form.holding_count) || 0,
            trainer_id: form.trainer_id ? parseInt(form.trainer_id) : null,
            manager_id: form.manager_id ? parseInt(form.manager_id) : null,
            clothes_start_date: form.clothes_start_date || null,
            clothes_end_date: form.clothes_end_date || null,
            locker_start_date: form.locker_start_date || null,
            locker_end_date: form.locker_end_date || null,
            locker_number: form.locker_number || null,
          })
        }, token);
        const newMember = result.member || result;  // 호환성: 새 형식이면 .member, 구 형식이면 result
        const memberId = newMember.id;
        // 회원번호 변경 알림
        if (result.number_changed && result.message) {
          addToast(result.message, "info");
        } else if (result.member_number) {
          addToast(`회원번호 ${result.member_number}로 등록됐어요`, "success");
        }
        
        // 프로필 이미지 업로드 (있으면)
        if (newMemberProfileImage) {
          try {
            const imgFormData = new FormData();
            imgFormData.append("file", newMemberProfileImage);
            await fetch(`https://heybiseo.ai.kr/members/${memberId}/profile-image?tenant_id=1`, {
              method: "POST",
              headers: { Authorization: `Bearer ${token}` },
              body: imgFormData
            });
          } catch(e) { console.error("프로필 이미지 업로드 실패:", e); }
        }
        
        const selectedPlans = [form.membership_type, form.personal, form.group].filter(Boolean);
        for (const planId of selectedPlans) {
          const plan = plans.find(p => String(p.id) === String(planId));
          if (plan) {
            await api("/membership/by-plan", {
              method: "POST",
              body: JSON.stringify({
                tenant_id: 1, member_id: memberId,
                plan_id: parseInt(planId), start_date: form.start_date,
                total_count: plan.sessions || null,
                trainer_id: form.trainer_id ? parseInt(form.trainer_id) : null,
              })
            }, token);
          }
        }
       
        setShowAddModal(false);
      }
      setForm(resetForm());
      load();
    } catch (e) { addToast("저장 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      await api(`/members/${id}?tenant_id=1`, { method: "DELETE" }, token);
      addToast("삭제됐습니다", "success");
      if (selectedMember?.id === id) setSelectedMember(null);
      load();
    } catch (e) { addToast("삭제 실패: " + e.message, "error"); }
  };

  const handleExcel = () => {
    const headers = ["번호", "이름", "성별", "전화번호", "상태", "등록일"];
    const rows = filtered.map((m, i) => [
      String(i + 1).padStart(4, "0"), m.name, m.gender || "-", m.phone || "-", m.status || "-", m.created_at?.slice(0, 10) || "-"
    ]);
    const csv = [headers, ...rows].map(r => r.join(",")).join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "회원목록.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  const holdingBadge = (m) => {
    const yn = m.holding_yn;
    const count = m.holding_count || 0;
    const used = m.holding_used || 0;
    const left = count - used;
    if (yn !== "Y") return { label: "사용불가", color: "#ef4444", bg: "#fef2f2", sub: "해당사항 없음" };
    if (left <= 0) return { label: "소진", color: "#6b7280", bg: "#f3f4f6", sub: `잔여 횟수:0회 남음(${count}/${count})` };
    if (used > 0) return { label: "진행중", color: "#22c55e", bg: "#f0fdf4", sub: `잔여 횟수:${left}회 남음(${used}/${count})` };
    return { label: "사용 가능", color: "#2563eb", bg: "#eff6ff", sub: `잔여 횟수:${left}회 남음(${used}/${count})` };
  };

  // D-Day 계산
  const getDDay = (endDate) => {
    if (!endDate) return { label: "기간 미설정", color: "#6b7280", bg: "#f3f4f6" };
    const diff = Math.ceil((new Date(endDate) - new Date()) / (1000 * 60 * 60 * 24));
    if (diff < 0) return { label: `만료 ${Math.abs(diff)}일`, color: "#dc2626", bg: "#fee2e2" };
    if (diff === 0) return { label: "D-Day", color: "#dc2626", bg: "#fee2e2" };
    if (diff <= 7) return { label: `D-${diff}`, color: "#dc2626", bg: "#fee2e2" };
    if (diff <= 30) return { label: `D-${diff}`, color: "#d97706", bg: "#fef3c7" };
    return { label: `D-${diff}`, color: "#059669", bg: "#d1fae5" };
  };

  const membershipPlans = plans.filter(p => p.category === "membership");
  const ptPlans = plans.filter(p => p.category === "pt");
  const gxPlans = plans.filter(p => p.category === "gx");
  const paymentTotal = memberPayments.reduce((sum, p) => sum + Number(p.amount || 0), 0);

  const TABS = [
    { id: "dashboard", label: "대시보드" },
    { id: "membership", label: "상품내역" },
    { id: "payment", label: "결제내역" },
    { id: "reservation", label: "예약내역" },
    { id: "attendance", label: "출석내역" },
    { id: "edit", label: "정보수정" },
    { id: "memo", label: "메모" },
  ];

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
        <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>회원 관리</h2>
      </div>

      {/* 스탯 카드 */}
     <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 10, marginBottom: 8 }}>
  {statCards.map((c, i) => {
    const clickable = !!c.filter;
    const isSelected = clickable && filterBy === c.filter;
    return (
      <div key={i} onClick={() => clickable && setFilterBy(c.filter)} style={{
        background: isSelected ? c.color : c.bg,
        borderRadius: 12, padding: "14px 12px",
        border: `2px solid ${isSelected ? c.color : c.color + "22"}`,
        cursor: clickable ? "pointer" : "default", transition: "all .15s"
      }}>
        <div style={{ color: isSelected ? "rgba(255,255,255,0.85)" : "#6b7280", fontSize: 12, marginBottom: 6, whiteSpace: "nowrap" }}>{c.label}</div>
        <div style={{ color: isSelected ? "#fff" : c.color, fontSize: 24, fontWeight: 800, whiteSpace: "nowrap" }}>{c.value}</div>
      </div>
    );
  })}
</div>
      <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>
        전체 <b style={{ color: "#111" }}>{totalCount.toLocaleString()}</b>명 중 <b style={{ color: "#2563eb" }}>{filtered.length.toLocaleString()}</b>명 표시
      </div>

      {/* 검색 + 정렬 + 버튼 (한 줄) */}
      <div style={{ display: "flex", gap: 10, marginBottom: 16, alignItems: "center" }}>
        <div style={{ position: "relative", flex: 1, maxWidth: 400 }}>
          <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}><Icon name="search" size={16} /></span>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="회원이름, 전화번호, 회원번호로 검색"
            style={{ width: "100%", padding: "10px 12px 10px 36px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" }} />
        </div>
        {/* 필터 버튼 */}
        {(() => {
          const activeFilters = [filterTrainer, filterGender, filterRoute, filterPlan, filterAge, filterMemberType].filter(Boolean).length;
          return (
            <button onClick={() => setShowFilterPanel(p => !p)} style={{
              display: "flex", alignItems: "center", gap: 6, padding: "10px 14px",
              borderRadius: 8, border: `1.5px solid ${showFilterPanel || activeFilters > 0 ? "#2563eb" : "#e5e7eb"}`,
              background: showFilterPanel || activeFilters > 0 ? "#eff6ff" : "#fff",
              color: showFilterPanel || activeFilters > 0 ? "#2563eb" : "#374151",
              fontSize: 13, fontWeight: 600, cursor: "pointer"
            }}>
              <Icon name="settings" size={14} color={showFilterPanel || activeFilters > 0 ? "#2563eb" : "#6b7280"} />
              필터
              {activeFilters > 0 && (
                <span style={{ background: "#2563eb", color: "#fff", fontSize: 10, fontWeight: 700, padding: "1px 6px", borderRadius: 10 }}>{activeFilters}</span>
              )}
            </button>
          );
        })()}
        <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{
          padding: "10px 16px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, color: "#374151", background: "#fff", cursor: "pointer"
        }}>
          <option value="latest">최신순</option>
          <option value="name">이름순</option>
        </select>
        <button onClick={handleExcel} style={{
          marginLeft: "auto",
          display: "flex", alignItems: "center", gap: 6, padding: "10px 18px",
          background: "#22c55e", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer"
        }}>
          <Icon name="check" size={14} color="#fff" /> 엑셀 다운로드
        </button>
        <button onClick={() => { setSelectedMember(null); setForm(resetForm()); setAddStep(1); setSelectedPlanForMember(null); setSelectedContract(null); setShowAddModal(true); }} style={{
          display: "flex", alignItems: "center", gap: 6, padding: "10px 18px",
          background: "#2563eb", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer"
        }}>
          <Icon name="members" size={14} color="#fff" /> 신규 회원 등록
        </button>
      </div>

      {/* 필터 패널 */}
      {showFilterPanel && (
        <div style={{ background: "#f9fafb", borderRadius: 10, padding: "14px 16px", marginBottom: 14, border: "0.5px solid #e5e7eb" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 10 }}>
            <div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 600 }}>회원권</div>
              <select value={filterPlan} onChange={e => setFilterPlan(e.target.value)}
                style={{ width: "100%", padding: "8px 10px", borderRadius: 7, border: `1.5px solid ${filterPlan ? "#2563eb" : "#e5e7eb"}`, fontSize: 12, background: filterPlan ? "#eff6ff" : "#fff", color: filterPlan ? "#1d4ed8" : "#374151", cursor: "pointer" }}>
                <option value="">전체</option>
                {plans.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 600 }}>담당강사</div>
              <select value={filterTrainer} onChange={e => setFilterTrainer(e.target.value)}
                style={{ width: "100%", padding: "8px 10px", borderRadius: 7, border: `1.5px solid ${filterTrainer ? "#2563eb" : "#e5e7eb"}`, fontSize: 12, background: filterTrainer ? "#eff6ff" : "#fff", color: filterTrainer ? "#1d4ed8" : "#374151", cursor: "pointer" }}>
                <option value="">전체</option>
                {trainers.filter(t => t.role !== "SUPERADMIN").map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 600 }}>성별</div>
              <select value={filterGender} onChange={e => setFilterGender(e.target.value)}
                style={{ width: "100%", padding: "8px 10px", borderRadius: 7, border: `1.5px solid ${filterGender ? "#2563eb" : "#e5e7eb"}`, fontSize: 12, background: filterGender ? "#eff6ff" : "#fff", color: filterGender ? "#1d4ed8" : "#374151", cursor: "pointer" }}>
                <option value="">전체</option>
                <option value="male">남성</option>
                <option value="female">여성</option>
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 600 }}>방문경로</div>
              <select value={filterRoute} onChange={e => setFilterRoute(e.target.value)}
                style={{ width: "100%", padding: "8px 10px", borderRadius: 7, border: `1.5px solid ${filterRoute ? "#2563eb" : "#e5e7eb"}`, fontSize: 12, background: filterRoute ? "#eff6ff" : "#fff", color: filterRoute ? "#1d4ed8" : "#374151", cursor: "pointer" }}>
                <option value="">전체</option>
                {visitRouteOptions.map(v => <option key={v} value={v}>{v}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 600 }}>나이대</div>
              <select value={filterAge} onChange={e => setFilterAge(e.target.value)}
                style={{ width: "100%", padding: "8px 10px", borderRadius: 7, border: `1.5px solid ${filterAge ? "#2563eb" : "#e5e7eb"}`, fontSize: 12, background: filterAge ? "#eff6ff" : "#fff", color: filterAge ? "#1d4ed8" : "#374151", cursor: "pointer" }}>
                <option value="">전체</option>
                <option value="10s">10대</option>
                <option value="20s">20대</option>
                <option value="30s">30대</option>
                <option value="40s">40대</option>
                <option value="50s">50대</option>
                <option value="60plus">60대 이상</option>
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 600 }}>회원 구분</div>
              <select value={filterMemberType} onChange={e => setFilterMemberType(e.target.value)}
                style={{ width: "100%", padding: "8px 10px", borderRadius: 7, border: `1.5px solid ${filterMemberType ? "#2563eb" : "#e5e7eb"}`, fontSize: 12, background: filterMemberType ? "#eff6ff" : "#fff", color: filterMemberType ? "#1d4ed8" : "#374151", cursor: "pointer" }}>
                <option value="">전체</option>
                <option value="new">신규 (이번달 등록)</option>
                <option value="existing">기존</option>
                <option value="expired">만료자</option>
              </select>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button onClick={() => { setFilterTrainer(""); setFilterGender(""); setFilterRoute(""); setFilterPlan(""); setFilterAge(""); setFilterMemberType(""); }}
              style={{ padding: "6px 14px", background: "none", border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12, color: "#6b7280", cursor: "pointer" }}>
              초기화
            </button>
          </div>
        </div>
      )}

      {/* 테이블 */}
      <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
        <div style={{ maxHeight: "calc(100vh - 340px)", overflowY: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f9fafb", position: "sticky", top: 0, zIndex: 1 }}>
              {["번호", "회원번호", "이름/성별", "상태", "나이", "전화번호", "가입일자 ~ 마감일자", "담당자", "관리"].map(h => (
                <th key={h} style={{ padding: "12px 16px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>로딩 중...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={9} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>등록된 회원이 없습니다</td></tr>
            ) : pagedMembers.map((m, i) => {
              const hb = holdingBadge(m);
              return (
                <tr key={m.id}
                  style={{ borderBottom: "1px solid #f9fafb", cursor: "pointer" }}
                  onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                  onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}
                  onClick={() => selectMemberAndLoad(m)}>
                  <td style={{ padding: "14px 16px", color: "#374151" }}>{String((memberCurPage - 1) * MEMBER_PAGE_SIZE + i + 1).padStart(4, "0")}</td>
                  <td style={{ padding: "14px 16px" }}>
                    {m.member_number ? (
                      <span style={{
                        display: "inline-block", background: "#eff6ff", color: "#2563eb",
                        padding: "4px 10px", borderRadius: 6, fontSize: 12, fontWeight: 700,
                        fontFamily: "monospace", letterSpacing: 0.5
                      }}>{m.member_number}</span>
                    ) : (
                      <span style={{ color: "#9ca3af", fontSize: 12 }}>—</span>
                    )}
                  </td>
                  <td style={{ padding: "14px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ width: 32, height: 32, borderRadius: "50%", background: m.gender === "female" ? "#fce7f3" : "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 }}>
                        {m.profile_image
                          ? <img src={`https://heybiseo.ai.kr/${String(m.profile_image).replace(/^\//, "")}`} alt="" loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          : <Icon name="members" size={16} color={m.gender === "female" ? "#ec4899" : "#2563eb"} />}
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, color: "#111" }}>{m.name}</div>
                        <div style={{ fontSize: 11, color: "#9ca3af" }}>{m.gender === "male" ? "남성" : m.gender === "female" ? "여성" : "-"}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "14px 16px" }}>
  {(() => {
    if (m.is_holding === "Y") return <Badge label="홀딩" color="#8b5cf6" />;
    if (m.status === "active") {
      if (!m.end_date) return <Badge label="만료" color="#9ca3af" />;
      const diff = (new Date(m.end_date) - new Date()) / (1000 * 60 * 60 * 24);
      if (diff < 0) return <Badge label="만료" color="#9ca3af" />;
      if (diff <= 7) return <Badge label="임박" color="#eab308" />;
      return <Badge label="활성" color="#22c55e" />;
    }
    if (m.status === "pending") return <Badge label="예정" color="#2563eb" />;
    return <Badge label="만료" color="#9ca3af" />;
  })()}
</td>
                  <td style={{ padding: "14px 16px", color: "#374151" }}>
                    {m.birth_date ? `${new Date().getFullYear() - new Date(m.birth_date).getFullYear()}세` : "-"}
                  </td>
                  <td style={{ padding: "14px 16px", color: "#374151" }}>{m.phone || "-"}</td>
                 <td style={{ padding: "14px 16px", color: "#374151" }}>
                    <div style={{ fontSize: 12 }}>
                      {m.start_date || m.created_at?.slice(0, 10)} ~ {m.end_date || <span style={{ color: "#9ca3af" }}>미설정</span>}
                    </div>
                    {(() => {
                      const dd = getDDay(m.end_date);
                      return (
                        <span style={{
                          display: "inline-block", marginTop: 4,
                          background: dd.bg, color: dd.color,
                          padding: "2px 8px", borderRadius: 4,
                          fontSize: 10, fontWeight: 600
                        }}>{dd.label}</span>
                      );
                    })()}
                  </td>
                  
                 <td style={{ padding: "14px 16px", color: "#374151", fontSize: 12 }}>
                    {(() => {
                      const trainer = trainers.find(t => t.id === m.trainer_id);
                      return trainer?.name || <span style={{ color: "#9ca3af" }}>미배정</span>;
                    })()}
                  </td>
                  <td style={{ padding: "14px 16px" }}>
                    <button onClick={e => { e.stopPropagation(); selectMemberAndLoad(m); }} style={{
                      background: "none", border: "none", cursor: "pointer",
                      color: "#2563eb", fontSize: 13, fontWeight: 600, padding: "4px 8px"
                    }}>
                      수정
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
        {memberTotalPages > 1 && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, padding: "16px 0 4px" }}>
            <button onClick={() => setMemberPage(p => Math.max(1, p - 1))} disabled={memberCurPage <= 1}
              style={{ padding: "7px 14px", borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", cursor: memberCurPage <= 1 ? "default" : "pointer", color: memberCurPage <= 1 ? "#d1d5db" : "#374151", fontSize: 13, fontWeight: 600 }}>← 이전</button>
            <span style={{ fontSize: 13, color: "#6b7280" }}><b style={{ color: "#2563eb" }}>{memberCurPage}</b> / {memberTotalPages} 페이지</span>
            <button onClick={() => setMemberPage(p => Math.min(memberTotalPages, p + 1))} disabled={memberCurPage >= memberTotalPages}
              style={{ padding: "7px 14px", borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", cursor: memberCurPage >= memberTotalPages ? "default" : "pointer", color: memberCurPage >= memberTotalPages ? "#d1d5db" : "#374151", fontSize: 13, fontWeight: 600 }}>다음 →</button>
          </div>
        )}
      </div>

      {/* ── 회원 대시보드 모달 ── */}
      {selectedMember && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "#f3f6fb", borderRadius: 20, width: "100%", maxWidth: 1100, maxHeight: "90vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 24px 80px rgba(0,0,0,0.2)" }}>

            {/* 모달 헤더 */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 24px", background: "#fff", borderBottom: "1px solid #f0f0f0" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 36, height: 36, borderRadius: "50%", background: selectedMember.gender === "female" ? "#fce7f3" : "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon name="members" size={18} color={selectedMember.gender === "female" ? "#ec4899" : "#2563eb"} />
                </div>
                <div>
                  <span style={{ fontWeight: 700, fontSize: 16, color: "#111" }}>{selectedMember.name}</span>
                  <span style={{ marginLeft: 8, fontSize: 12, color: "#9ca3af" }}>{selectedMember.phone}</span>
                </div>
                <Badge label={selectedMember.status === "active" ? "활성" : "등록"} color={selectedMember.status === "active" ? "#22c55e" : "#9ca3af"} />
              </div>
              <div style={{ display: "flex", gap: 8 }}>
  <button onClick={async () => {
  if (selectedMember.holding_yn === "Y") {
      try {
        await api(`/members/${selectedMember.id}?tenant_id=1`, {
          method: "PUT",
          body: JSON.stringify({ holding_yn: "N", is_holding: "N" })
        }, token);
        addToast("홀딩이 해제됐습니다", "success");
        load();
        selectMemberAndLoad({ ...selectedMember, holding_yn: "N", is_holding: "N" });
      } catch(e) { addToast("홀딩 해제 실패: " + e.message, "error"); }
    } else {
      // 활성 상품에서 홀딩 설정 확인
      const activeMembership = highlightedMembership || memberMemberships.find(m => m.status === "ACTIVE");
      if (!activeMembership) {
        addToast("활성 상품이 없습니다", "error"); return;
      }
      if (activeMembership.status !== "ACTIVE") {
        addToast("선택한 상품이 활성 상태가 아닙니다", "error"); return;
      }
      if (activeMembership.holding_yn !== "Y") {
        addToast("이 상품은 홀딩이 불가능합니다", "error"); return;
      }
      const holdingCount = activeMembership.holding_count || 0;
      const holdingUsed = selectedMember.holding_used || 0;
      if (holdingUsed >= holdingCount) {
        addToast(`홀딩 횟수를 모두 사용했습니다 (${holdingUsed}/${holdingCount}회)`, "error"); return;
      }
      setHoldingMember(selectedMember);
      setHoldingForm({ start_date: ymdKST(), end_date: "", checkedIds: undefined });
      setShowHoldingModal(true);
    }
  }} style={{
    background: selectedMember.holding_yn === "Y" ? "#f5f3ff" : "#fff7ed",
    border: `1px solid ${selectedMember.holding_yn === "Y" ? "#8b5cf6" : "#f97316"}`,
    borderRadius: 8, padding: "8px 14px", cursor: "pointer",
    fontSize: 12, fontWeight: 700,
    color: selectedMember.holding_yn === "Y" ? "#8b5cf6" : "#f97316"
  }}>
{selectedMember.holding_yn === "Y" ? "🔓 홀딩 해제" : "⏸ 홀딩"}
  </button>
  <button onClick={() => setShowWizard(true)} style={{
    background: "#eff6ff",
    border: "1px solid #2563eb",
    borderRadius: 8, padding: "8px 14px", cursor: "pointer",
    fontSize: 12, fontWeight: 700,
    color: "#2563eb"
  }}>
    💳 결제하기
  </button>
  <button onClick={() => setSelectedMember(null)} style={{ background: "#f3f4f6", border: "none", borderRadius: 8, padding: "8px 10px", cursor: "pointer", fontSize: 18, color: "#6b7280" }}>×</button>
</div>
            </div>

            {/* 모달 바디 */}
            <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>

              {/* 왼쪽 프로필 패널 */}
              <div style={{ width: 240, background: "#fff", borderRight: "1px solid #f0f0f0", overflowY: "auto", padding: 20, flexShrink: 0 }}>
                {/* 프로필 사진 */}
<div style={{ width: 120, height: 120, margin: "0 auto 12px" }}>
  <div style={{ width: 120, height: 120, borderRadius: 8, border: "1px solid #e5e7eb", background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
    {selectedMember.profile_image ? (
      <img src={`https://heybiseo.ai.kr/${selectedMember.profile_image}?v=${selectedMember._refresh || 0}`} alt="프로필"
        style={{ width: "100%", height: "100%", objectFit: "cover" }} />
    ) : (
      <Icon name="members" size={36} color="#9ca3af" />
    )}
  </div>
</div>

{/* 사진 업로드 버튼 그룹 */}
<div style={{ display: "flex", gap: 4, justifyContent: "center", marginBottom: 12, whiteSpace: "nowrap" }}>
  <button
    onClick={() => setShowCameraModal(true)}
    style={{
      padding: "5px 8px", fontSize: 11, fontWeight: 500,
      borderRadius: 6, border: "1px solid #d1d5db",
      background: "#fff", cursor: "pointer", color: "#374151",
      whiteSpace: "nowrap", flexShrink: 0
    }}
  >
    📷 촬영
  </button>
  <label htmlFor="profile-upload" style={{
    padding: "5px 8px", fontSize: 11, fontWeight: 500,
    borderRadius: 6, border: "1px solid #d1d5db",
    background: "#fff", cursor: "pointer", color: "#374151",
    whiteSpace: "nowrap", flexShrink: 0
  }}>
    📁 파일선택
  </label>
  <input id="profile-upload" type="file" accept="image/*" style={{ display: "none" }}
    onChange={async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      await uploadProfileImage(file);
      e.target.value = "";
    }}
  />
  {selectedMember.profile_image && (
    <button
      onClick={async () => {
        if (!window.confirm("프로필 사진을 제거하시겠습니까?")) return;
        try {
          await api(`/members/${selectedMember.id}?tenant_id=1`, {
            method: "PUT",
            body: JSON.stringify({ profile_image: null })
          }, token);
          addToast("프로필 사진이 제거됐습니다", "success");
          load();
          selectMemberAndLoad({ ...selectedMember, profile_image: null });
        } catch(e) { addToast("제거 실패: " + e.message, "error"); }
      }}
      title="제거"
      style={{
        padding: "5px 9px", fontSize: 13, fontWeight: 600,
        borderRadius: 6, border: "1px solid #fecaca",
        background: "#fff", cursor: "pointer", color: "#ef4444",
        flexShrink: 0
      }}
    >
      ✕
    </button>
  )}
</div>

{/* GREET 얼굴 등록 */}
<div style={{ display: "flex", gap: 4, justifyContent: "center", marginBottom: 12 }}>
  <button onClick={async () => {
    try {
      await api(`/greet/register-member/${selectedMember.id}`, { method: "POST" }, token);
      addToast("GREET 얼굴 등록 완료", "success");
    } catch (e) { addToast("GREET 등록 실패: " + (e.message || ""), "error"); }
  }} style={{ padding: "6px 10px", fontSize: 11, fontWeight: 600, borderRadius: 6, border: "1px solid #10b981", background: "#fff", color: "#10b981", cursor: "pointer", flexShrink: 0 }}>
    🟢 GREET 얼굴 등록
  </button>
  <button onClick={async () => {
    if (!window.confirm("GREET 얼굴 등록을 해제할까요?")) return;
    try {
      await api(`/greet/unregister-member/${selectedMember.id}`, { method: "DELETE" }, token);
      addToast("GREET 등록 해제 완료", "success");
    } catch (e) { addToast("해제 실패: " + (e.message || ""), "error"); }
  }} style={{ padding: "6px 10px", fontSize: 11, fontWeight: 600, borderRadius: 6, border: "1px solid #d1d5db", background: "#fff", color: "#6b7280", cursor: "pointer", flexShrink: 0 }}>
    해제
  </button>
</div>
                <div style={{ textAlign: "center", marginBottom: 16 }}>
                  <div style={{ fontWeight: 700, fontSize: 16, color: "#111" }}>{selectedMember.name}</div>
                  <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>
                    {selectedMember.gender === "male" ? "남성" : selectedMember.gender === "female" ? "여성" : "-"}
                  </div>
                </div>

                {/* 기본 정보 */}
               {[
                  { label: "상태", value: <Badge label={selectedMember.status === "active" ? "활성" : "등록"} color={selectedMember.status === "active" ? "#22c55e" : "#9ca3af"} /> },
                  { label: "생년월일", value: selectedMember.birth_date || "-" },
                  { label: "연락처", value: selectedMember.phone || "-" },
                  { label: "주소", value: selectedMember.address || "미입력" },
                  { label: "담당 강사", value: trainers.find(t => t.id === selectedMember.trainer_id)?.name || "미배정" },
                  { label: "방문경로", value: selectedMember.visit_route || "선택 안함" },
                  { label: "메모", value: (
  <div style={{ position: "relative", display: "inline-block", width: "100%" }}
    onMouseEnter={e => e.currentTarget.querySelector('.memo-tooltip').style.display = 'block'}
    onMouseLeave={e => e.currentTarget.querySelector('.memo-tooltip').style.display = 'none'}>
    <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 160, cursor: selectedMember.memo ? "pointer" : "default" }}>
      {selectedMember.memo || "-"}
    </div>
    {selectedMember.memo && selectedMember.memo.length > 20 && (
      <div className="memo-tooltip" style={{
        display: "none", position: "absolute", left: 0, top: "100%", zIndex: 100,
        background: "#111", color: "#fff", fontSize: 11, padding: "6px 10px",
        borderRadius: 8, width: 200, whiteSpace: "pre-wrap", lineHeight: 1.6,
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
      }}>
        {selectedMember.memo}
      </div>
    )}
  </div>
)},
{ label: "이용약관", value: selectedMember.terms_agreed_at
                    ? <span style={{ color: "#16a34a", fontWeight: 600 }}>✓ {selectedMember.terms_agreed_at.slice(0, 10)}</span>
                    : <span style={{ color: "#dc2626", fontWeight: 600 }}>✗ 미동의</span> },
                  { label: "개인정보", value: selectedMember.privacy_agreed_at
                    ? <span style={{ color: "#16a34a", fontWeight: 600 }}>✓ {selectedMember.privacy_agreed_at.slice(0, 10)}</span>
                    : <span style={{ color: "#dc2626", fontWeight: 600 }}>✗ 미동의</span> },
                  { label: "마케팅", value: selectedMember.marketing_agreed_at
                    ? <span style={{ color: "#16a34a", fontWeight: 600 }}>✓ {selectedMember.marketing_agreed_at.slice(0, 10)}</span>
                    : <span style={{ color: "#9ca3af" }}>선택 안함</span> },
                ].map((item, i) => (
                  <div key={i} style={{ marginBottom: 12 }}>
                    <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 3 }}>{item.label}</div>
                    <div style={{ fontSize: 13, color: "#374151", fontWeight: 500 }}>{item.value}</div>
                  </div>
                ))}

                {/* 계약서 */}
<div style={{ background: "#f9fafb", borderRadius: 10, padding: "10px 12px", marginTop: 8 }}>
  <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}>계약서</div>
  {(() => {
    const myContracts = (memberContracts || []).filter(c => c.member_id === selectedMember.id);
    return myContracts.length > 0 ? myContracts.map((c, i) => (
    <div key={i}
      onClick={async () => {
        // 자체 전자계약: 서명 페이지 열기 (서명 전이면 서명 화면, 완료면 열람)
        if (c._self) {
          if (c.token) window.open(`${API_BASE}/contract/sign/${c.token}`, "_blank");
          else addToast("계약서 링크가 없습니다", "error");
          return;
        }
        if (c.status !== "SIGNED") return;
        try {
          const res = await api(`/modusign/document/${c.modusign_doc_id}`, {}, token);
          console.log("Modusign document:", res);
          const url = res?.file?.downloadUrl
                   || res?.documentDownloadUrl
                   || res?.downloadUrl
                   || res?.viewUrl
                   || res?.document?.downloadUrl
                   || res?.document?.file?.downloadUrl;
          if (url) {
            window.open(url, '_blank');
          } else {
            addToast("PDF URL을 찾지 못했습니다 (콘솔 확인)", "error");
          }
        } catch(e) {
          addToast("계약서 조회 실패: " + e.message, "error");
        }
      }}
      style={{
        marginBottom: 6, padding: "6px 8px", background: "#fff",
        borderRadius: 8, border: "1px solid #e5e7eb",
        cursor: (c._self || c.status === "SIGNED") ? "pointer" : "default",
        transition: "all 0.15s"
      }}
      onMouseEnter={e => {
        if (c._self || c.status === "SIGNED") {
          e.currentTarget.style.borderColor = "#22c55e";
          e.currentTarget.style.background = "#f0fdf4";
        }
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = "#e5e7eb";
        e.currentTarget.style.background = "#fff";
      }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: "#111" }}>
        {c.title}
        {(c._self || c.status === "SIGNED") && <span style={{ marginLeft: 4, fontSize: 9, color: c.status === "SIGNED" ? "#22c55e" : "#f97316" }}>{c.status === "SIGNED" ? "👀 보기" : "✍️ 서명하기"}</span>}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 3 }}>
        <span style={{ fontSize: 10, color: c.status === "SIGNED" ? "#22c55e" : "#f97316", fontWeight: 600 }}>
          {c.status === "SIGNED" ? "✓ 서명완료" : "⏳ 서명대기"}
        </span>
        <span style={{ fontSize: 10, color: "#9ca3af" }}>{c.created_at?.slice(0, 10)}</span>
      </div>
    </div>
 )) : (
    <div style={{ fontSize: 11, color: "#9ca3af" }}>계약서 없음</div>
  );
  })()}
</div>
              </div>

              {/* 오른쪽 탭 영역 */}
              <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                {/* 탭 */}
                <div style={{ display: "flex", borderBottom: "1px solid #f0f0f0", background: "#fff", padding: "0 20px" }}>
                  {TABS.map(tab => (
                    <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{
                      padding: "14px 16px", border: "none", background: "none", cursor: "pointer",
                      fontSize: 13, fontWeight: activeTab === tab.id ? 700 : 400,
                      color: activeTab === tab.id ? "#2563eb" : "#6b7280",
                      borderBottom: activeTab === tab.id ? "2px solid #2563eb" : "2px solid transparent",
                      marginBottom: -1
                    }}>{tab.label}</button>
                  ))}
                </div>

                {/* 탭 내용 */}
                <div style={{ flex: 1, overflowY: "auto", padding: 20 }}>

                  {/* 대시보드 탭 */}
                  {activeTab === "dashboard" && (
                    <div>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                     {/* 이용권 */}
<div style={{ background: "#fff", borderRadius: 14, padding: 18, border: "1px solid #f3f4f6" }}>
  <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 12 }}>
    유효 상품 <span style={{ color: "#2563eb" }}>{memberMemberships.filter(m => m.status === "ACTIVE").length}</span>
    &nbsp; 만료 상품 {memberMemberships.filter(m => m.status !== "ACTIVE").length}
  </div>
  {memberMemberships.length === 0 ? (
    <div style={{ color: "#9ca3af", fontSize: 13, textAlign: "center", padding: 20 }}>이용권 없음</div>
  ) : (
    <div style={{ maxHeight: 380, overflowY: "auto", paddingRight: 4, marginRight: -4 }}>
      {(() => {
        const catLabel = (c) => c === "pt" ? "개인 (PT)" : c === "gx" ? "그룹 (GX)" : c === "membership" ? "회원권" : "기타";
        const catRank = (c) => c === "pt" ? 0 : c === "gx" ? 1 : c === "membership" ? 2 : 3;
        const sortedMs = [...memberMemberships].sort((a, b) => {
          const r = catRank(a.category) - catRank(b.category);
          if (r !== 0) return r;
          return (a.status === "ACTIVE" ? 0 : 1) - (b.status === "ACTIVE" ? 0 : 1);
        });
        return sortedMs.map((ms, i) => {
   const showHeader = i === 0 || sortedMs[i - 1].category !== ms.category;
   const isActive = ms.status === "ACTIVE";
    const isHolding = ms.status === "HOLDING";
    const statusLabel = isHolding ? "홀딩" : (isActive ? "활성" : "만료");
    const statusColor = isHolding ? "#8b5cf6" : (isActive ? "#2563eb" : "#9ca3af");
    const isSelected = highlightedMembership ? highlightedMembership.id === ms.id : i === 0;
    return (
      <React.Fragment key={i}>
        {showHeader && (
          <div style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", margin: i === 0 ? "2px 0 8px" : "16px 0 8px" }}>{catLabel(ms.category)}</div>
        )}
      <div onClick={async (e) => {
        e.stopPropagation();
        if (activeTab === "products") {
          setSelectedMembership(ms);
          setShowMembershipEdit(true);
        } else {
          setHighlightedMembership(ms);
          try {
            const [logs, hold] = await Promise.all([
              api(`/membership/${ms.id}/logs`, {}, token).catch(() => []),
              api(`/membership/holding-history/${ms.id}?tenant_id=1`, {}, token).catch(() => []),
            ]);
            setHistoryModal({ open: true, editLogs: Array.isArray(logs) ? logs : [], holdingLogs: Array.isArray(hold) ? hold : [] });
          } catch (err) { addToast("이력 조회 실패", "error"); }
        }
      }} style={{
        border: `2px solid ${isSelected ? "#2563eb" : "#e5e7eb"}`,
        borderRadius: 12, padding: "14px 16px", marginBottom: 10,
        background: isSelected ? "#f0f6ff" : "#f9fafb",
        cursor: "pointer"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
          <span style={{
            background: statusColor,
            color: "#fff", fontSize: 10, fontWeight: 700,
            padding: "2px 8px", borderRadius: 20
          }}>{statusLabel}</span>
          <span style={{ fontWeight: 700, fontSize: 14, color: "#111" }}>{ms.plan_name || ms.name}</span>
        </div>
        <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: ms.sessions_remaining != null ? 6 : 0 }}>
          {ms.start_date} - {ms.end_date}
          {ms.days_remaining != null && <span style={{ marginLeft: 8 }}>| {ms.days_remaining}일 남음</span>}
          {ms.holding_extension_days > 0 && (
            <span
              style={{ marginLeft: 8, background: "#f5f3ff", color: "#8b5cf6", padding: "1px 8px", borderRadius: 4, fontWeight: 600, fontSize: 11 }}
              title="회원권 홀딩으로 기간이 연장되었습니다"
            >
              🔄 홀딩 +{ms.holding_extension_days}일
            </span>
          )}
          {ms.edit_extend_days > 0 && (
            <span style={{ marginLeft: 8, background: "#fff7ed", color: "#f97316", padding: "1px 8px", borderRadius: 4, fontWeight: 700, fontSize: 11 }} title="회원권 수정으로 기간이 연장되었습니다">✏️ +{ms.edit_extend_days}일 연장</span>
          )}
          {ms.edit_add_count > 0 && (
            <span style={{ marginLeft: 8, background: "#ecfdf5", color: "#059669", padding: "1px 8px", borderRadius: 4, fontWeight: 700, fontSize: 11 }} title="회원권 수정으로 횟수가 추가되었습니다">✏️ +{ms.edit_add_count}회 추가</span>
          )}
        </div>
        {ms.remaining_count != null && (
  <div style={{ fontSize: 13, color: "#374151" }}>
    잔여횟수 <span style={{ color: "#2563eb", fontWeight: 700 }}>{ms.remaining_count}회 남음</span>
    <span style={{ color: "#9ca3af" }}> | 총 {ms.total_count}회</span>
  </div>
)}
      </div>
      </React.Fragment>
   );
        });
      })()}
    </div>
  )}
</div>

                        {/* 결제 통계 */}
                        <div style={{ background: "#fff", borderRadius: 14, padding: 18, border: "1px solid #f3f4f6" }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 12 }}>결제 내역 통계</div>
                          <div style={{ fontSize: 13, color: "#374151", marginBottom: 6 }}>
                            총 누적 결제: <span style={{ fontWeight: 700, color: "#2563eb" }}>{paymentTotal.toLocaleString()}원</span>
                          </div>
                          <div style={{ fontSize: 13, color: "#374151", marginBottom: 6 }}>
                            결제 건수: <span style={{ fontWeight: 600 }}>{memberPayments.filter(p => p.status === "approved").length}건</span>
                          </div>
                          <div style={{ fontSize: 13, color: "#374151" }}>
                            환불: <span style={{ fontWeight: 600, color: "#ef4444" }}>{memberPayments.filter(p => p.status === "cancelled").length}건</span>
                          </div>
                        </div>
                      </div>

                      {/* 락커 정보 */}
{memberLockerInfo.length > 0 && (
  <div style={{ background: "#fff", borderRadius: 14, padding: 18, border: "1px solid #f3f4f6", marginBottom: 16 }}>
    <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 12 }}>🔒 락커 현황</div>
    {memberLockerInfo.map((l, i) => {
      const today = ymdKST();
      const isExpired = l.end_date < today;
      const isExpiring = !isExpired && l.end_date <= ymdKST(new Date(Date.now() + 7 * 24 * 3600 * 1000));
      const statusColor = isExpired ? '#EF4444' : isExpiring ? '#D97706' : '#16A34A';
      const statusLabel = isExpired ? '만료' : isExpiring ? '임박' : '사용중';
      return (
        <div key={i} style={{ padding: "10px 14px", background: "#f8fafc", borderRadius: 10, marginBottom: 8, border: `1px solid ${statusColor}22` }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#111" }}>
              락커 {String(l.number).padStart(3, '0')} <span style={{ fontSize: 11, color: "#9ca3af" }}>({l.zone_name})</span>
            </div>
            <span style={{ fontSize: 11, fontWeight: 700, color: statusColor, background: statusColor + '15', padding: "2px 8px", borderRadius: 20 }}>{statusLabel}</span>
          </div>
          <div style={{ fontSize: 12, color: "#6b7280" }}>
            {l.start_date} ~ {l.end_date}
            {l.password && <span style={{ marginLeft: 8 }}>🔑 {l.password}</span>}
          </div>
        </div>
      );
    })}
  </div>
)}

{/* 락커 미배정 (결제는 했지만 배정 안 된 경우) */}
{(() => {
  const lockerPlanIds = plans.filter(p => p.category === 'locker').map(p => p.id);
const lockerPayments = memberPayments.filter(p => p.status === 'approved' && lockerPlanIds.includes(p.plan_id));
  const hasLocker = memberLockerInfo.length > 0;
  if (lockerPayments.length > 0 && !hasLocker) {
    return (
      <div style={{ background: "#fffbeb", borderRadius: 14, padding: 16, border: "1px solid #D97706", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 20 }}>⏳</span>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#D97706" }}>락커 배정 대기 중</div>
          <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>락커 상품 결제 완료 — 아직 락커 번호가 배정되지 않았습니다</div>
        </div>
      </div>
    );
  }
  return null;
})()}

                      {/* 예약/출석 요약 */}
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                        <div style={{ background: "#fff", borderRadius: 14, padding: 18, border: "1px solid #f3f4f6" }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 12 }}>최근 예약</div>
                          {memberReservations.length === 0 ? (
                            <div style={{ color: "#9ca3af", fontSize: 13 }}>예약 없음</div>
                          ) : (
                            <div style={{ maxHeight: 250, overflowY: "auto" }}>
                              {memberReservations.map((r, i) => (
                                <div key={i} style={{ padding: "8px 0", borderBottom: i < memberReservations.length - 1 ? "1px solid #f3f4f6" : "none" }}>
                                  <div style={{ fontSize: 12, fontWeight: 600, color: "#111" }}>{r.title}</div>
                                  <div style={{ fontSize: 11, color: "#9ca3af" }}>{r.date} {r.start_time?.slice(0,5)}</div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div style={{ background: "#fff", borderRadius: 14, padding: 18, border: "1px solid #f3f4f6" }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 12 }}>출석 현황</div>
                          {(() => {
  const now = new Date();
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const monthCount = memberAttendances.filter(a => new Date(a.check_in) >= firstDayOfMonth).length;
  return (
    <>
      <div style={{ fontSize: 28, fontWeight: 800, color: "#2563eb" }}>{monthCount}회</div>
      <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>{now.getMonth() + 1}월 방문 횟수</div>
    </>
  );
})()}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* 상품내역 탭 */}
                  {activeTab === "membership" && (
                    <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", border: "1px solid #f3f4f6" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                        <thead>
                          <tr style={{ background: "#f9fafb" }}>
                            {["상품명", "시작일", "종료일", "잔여횟수", "상태"].map(h => (
                              <th key={h} style={{ padding: "10px 16px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {memberMemberships.length === 0 ? (
                            <tr><td colSpan={5} style={{ textAlign: "center", padding: 30, color: "#9ca3af" }}>상품 내역 없음</td></tr>
                          ) : (() => {
                            const catLabel = (c) => c === "pt" ? "개인 (PT)" : c === "gx" ? "그룹 (GX)" : c === "membership" ? "회원권" : "기타";
                            const catRank = (c) => c === "pt" ? 0 : c === "gx" ? 1 : c === "membership" ? 2 : 3;
                            const sortedMs = [...memberMemberships].sort((a, b) => {
                              const r = catRank(a.category) - catRank(b.category);
                              if (r !== 0) return r;
                              return (a.status === "ACTIVE" ? 0 : 1) - (b.status === "ACTIVE" ? 0 : 1);
                            });
                            return sortedMs.map((ms, i) => {
                              const showHeader = i === 0 || sortedMs[i - 1].category !== ms.category;
                              return (
                            <React.Fragment key={i}>
                              {showHeader && (
                                <tr style={{ background: "#f3f6fb" }}>
                                  <td colSpan={5} style={{ padding: "8px 16px", fontWeight: 700, fontSize: 12, color: "#374151" }}>{catLabel(ms.category)}</td>
                                </tr>
                              )}
                            <tr onClick={() => setSelectedMembership(ms)} style={{ borderBottom: "1px solid #f9fafb", cursor: "pointer" }}
  onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
  onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
                              <td style={{ padding: "12px 16px", fontWeight: 600, color: "#111" }}>{ms.plan_name || ms.name}</td>
                              <td style={{ padding: "12px 16px", color: "#374151" }}>{ms.start_date}</td>
                              <td style={{ padding: "12px 16px", color: "#374151" }}>{ms.end_date}</td>
                              <td style={{ padding: "12px 16px", color: "#2563eb", fontWeight: 600 }}>{ms.remaining_count != null ? `${ms.remaining_count}회` : "-"}</td>
                              <td style={{ padding: "12px 16px" }}>
                               <Badge label={ms.status === "HOLDING" ? "홀딩" : (ms.status === "ACTIVE" ? "활성" : "만료")} color={ms.status === "HOLDING" ? "#8b5cf6" : (ms.status === "ACTIVE" ? "#22c55e" : "#9ca3af")} />
                              </td>
                            </tr>
                            </React.Fragment>
                              );
                            });
                          })()}
                        </tbody>
                      </table>
                    </div>
                  )}

                 
                  {/* 결제내역 탭 */}
{activeTab === "payment" && (
  <div>
    {/* 상단 통계 카드 */}
    <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 16 }}>
      {[
        { label: "누적 결제 건수", value: `${memberPayments.filter(p => p.status === "approved").length}건`, color: "#2563eb" },
        { label: "누적 결제 금액", value: `${memberPayments.filter(p => p.status === "approved").reduce((s, p) => s + Number(p.amount || 0), 0).toLocaleString()}원`, color: "#2563eb" },
        { label: "미수금", value: `${memberPayments.reduce((s, p) => s + Number(p.unpaid_amount || 0), 0).toLocaleString()}원`, color: "#f97316" },
        { label: "환불 금액", value: `${memberPayments.filter(p => p.status === "cancelled").reduce((s, p) => s + Number(p.amount || 0), 0).toLocaleString()}원`, color: "#ef4444" },
      ].map((c, i) => (
        <div key={i} style={{ background: "#f9fafb", borderRadius: 12, padding: "14px 16px", border: "1px solid #f3f4f6" }}>
          <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 6 }}>{c.label}</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: c.color }}>{c.value}</div>
        </div>
      ))}
    </div>

    {/* 테이블 */}
    <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", border: "1px solid #f3f4f6" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ background: "#f9fafb" }}>
            {["No", "결제일시", "상품", "금액", "결제수단", "상태", "전표"].map(h => (
              <th key={h} style={{ padding: "10px 16px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {memberPayments.length === 0 ? (
            <tr><td colSpan={7} style={{ textAlign: "center", padding: 30, color: "#9ca3af" }}>결제 내역 없음</td></tr>
          ) : memberPayments.map((p, i) => (
            <tr key={i} style={{ borderBottom: "1px solid #f9fafb" }}
              onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
              onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
              <td style={{ padding: "12px 16px", color: "#9ca3af" }}>{i + 1}</td>
              <td style={{ padding: "12px 16px", color: "#374151" }}>
                {p.created_at ? (() => {
                  const s = p.created_at.endsWith("Z") || p.created_at.includes("+") ? p.created_at : p.created_at.replace(" ", "T") + "+09:00";
                  const d = new Date(s);
                  return d.toLocaleString("ko-KR", { timeZone: "Asia/Seoul", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false });
                })() : "-"}
              </td>
              <td style={{ padding: "12px 16px", fontWeight: 600, color: "#111" }}>{p.plan_name || "-"}</td>
              <td style={{ padding: "12px 16px", fontWeight: 700, color: p.status === "cancelled" ? "#ef4444" : "#111" }}>
                {p.status === "cancelled" && <span style={{ fontSize: 11, marginRight: 2 }}>-</span>}
                {Number(p.amount || 0).toLocaleString()}원
              </td>
              <td style={{ padding: "12px 16px", color: "#374151" }}>
                {["card","SMARTRO","PAYNIX","NANO"].includes(p.method) ? "카드" : p.method === "cash" ? "현금" : p.method === "transfer" ? "계좌이체" : "-"}
              </td>
              <td style={{ padding: "12px 16px" }}>
                <Badge
                  label={p.status === "approved" ? "결제완료" : p.status === "cancelled" ? "환불" : p.status === "pending" ? "미납" : p.status || "-"}
                  color={p.status === "approved" ? "#22c55e" : p.status === "cancelled" ? "#ef4444" : "#f97316"}
                />
              </td>
             <td style={{ padding: "12px 16px" }}>
                <span style={{ display: "flex", gap: 4 }}>
                  <button onClick={(e) => {
                    e.stopPropagation();
                    if (Number(p.unpaid_amount || 0) > 0) {
                      setUnpaidPayModal({ open: true, payment: p });
                    }
                  }} style={{ padding: "3px 8px", borderRadius: 4, border: "1px solid #f97316", background: Number(p.unpaid_amount || 0) > 0 ? "#fff7ed" : "#f9fafb", color: Number(p.unpaid_amount || 0) > 0 ? "#f97316" : "#d1d5db", fontSize: 10, cursor: Number(p.unpaid_amount || 0) > 0 ? "pointer" : "default", fontWeight: 600, display: Number(p.unpaid_amount || 0) > 0 ? "inline-block" : "none" }}>
                    미수금 {Number(p.unpaid_amount || 0).toLocaleString()}원
                  </button>
                  <button onClick={(e) => {
                    e.stopPropagation();
                    setReceiptModal({ open: true, paymentId: p.id });
                  }} style={{ padding: "3px 8px", borderRadius: 4, border: "1px solid #3B82F6", background: "#fff", color: "#3B82F6", fontSize: 10, cursor: "pointer", fontWeight: 600 }}>🧾 전표</button>
                  {p.transactionId && (
                    <button onClick={(e) => {
                      e.stopPropagation();
                      let url = "";
                      if (p.method === "SMARTRO") url = `https://pay.smartropay.co.kr/receipt/${p.transactionId}`;
                      else if (p.method === "card" || p.method === "PAYNIX") url = `https://wpay.mostpns.co.kr/receipt/${p.transactionId}`;
                      if (url) window.open(url, "_blank", "width=420,height=600");
                    }} style={{ padding: "3px 8px", borderRadius: 4, border: "0.5px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: 10, cursor: "pointer" }}>PG</button>
                  )}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {memberPayments.length > 0 && (
        <div style={{ padding: "10px 16px", borderTop: "1px solid #f3f4f6", display: "flex", justifyContent: "flex-end" }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#111" }}>합계: {paymentTotal.toLocaleString()}원</span>
        </div>
      )}
    </div>
  </div>
)}

                  {/* 예약내역 탭 */}
{activeTab === "reservation" && (() => {
  const now = new Date();

  const firstDay = new Date(calYear, calMonth, 1).getDay();
  const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
  const calDays = [];
  for (let i = 0; i < firstDay; i++) calDays.push(null);
  for (let i = 1; i <= daysInMonth; i++) calDays.push(i);

  const monthStr = `${calYear}-${String(calMonth + 1).padStart(2, "0")}`;
  const monthResvs = memberReservations.filter(r => r.date?.startsWith(monthStr));
  const showCount = monthResvs.filter(r => r.status === "COMPLETED").length;
  const noshowCount = monthResvs.filter(r => r.status === "NOSHOW").length;
  const pendingCount = monthResvs.filter(r => r.status === "RESERVED").length;
  const dayNames = ["일", "월", "화", "수", "목", "금", "토"];

  return (
    <div>
      {/* 뷰 전환 버튼 */}
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {[{ id: "month", label: "월별보기" }, { id: "all", label: "전체보기" }].map(v => (
          <button key={v.id} onClick={() => setResvView(v.id)} style={{
            padding: "8px 20px", borderRadius: 8, border: "1px solid #e5e7eb", cursor: "pointer",
            fontSize: 13, fontWeight: resvView === v.id ? 700 : 500,
            background: resvView === v.id ? "#2563eb" : "#fff",
            color: resvView === v.id ? "#fff" : "#374151"
          }}>{v.label}</button>
        ))}
      </div>

      {/* 월별보기 */}
      {resvView === "month" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 220px", gap: 16 }}>
          {/* 달력 */}
          <div style={{ background: "#fff", borderRadius: 14, padding: 20, border: "1px solid #f3f4f6" }}>
            {/* 월 네비게이션 */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
              <button onClick={() => { if (calMonth === 0) { setCalMonth(11); setCalYear(y => y - 1); } else setCalMonth(m => m - 1); }}
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#374151" }}>‹</button>
              <span style={{ fontSize: 16, fontWeight: 700, color: "#111" }}>{calYear}년 {calMonth + 1}월</span>
              <button onClick={() => { if (calMonth === 11) { setCalMonth(0); setCalYear(y => y + 1); } else setCalMonth(m => m + 1); }}
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#374151" }}>›</button>
            </div>

            {/* 요일 헤더 */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", marginBottom: 8 }}>
              {dayNames.map((d, i) => (
                <div key={d} style={{ textAlign: "center", fontSize: 12, fontWeight: 600,
                  color: i === 0 ? "#ef4444" : i === 6 ? "#2563eb" : "#9ca3af", padding: "4px 0" }}>{d}</div>
              ))}
            </div>

            {/* 날짜 */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2 }}>
              {calDays.map((d, i) => {
                if (!d) return <div key={i} />;
                const dateStr = `${calYear}-${String(calMonth + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
                const dayResvs = memberReservations.filter(r => r.date === dateStr);
                const isToday = dateStr === ymdKST(now);
                const col = i % 7;
                return (
                  <div key={i} style={{ minHeight: 52, padding: 4, borderRadius: 8, background: isToday ? "#eff6ff" : "transparent", border: isToday ? "1px solid #2563eb" : "1px solid transparent" }}>
                    <div style={{ fontSize: 12, fontWeight: isToday ? 700 : 400,
                      color: isToday ? "#2563eb" : col === 0 ? "#ef4444" : col === 6 ? "#2563eb" : "#374151",
                      marginBottom: 2 }}>{d}</div>
                    {dayResvs.slice(0, 2).map((r, j) => {
                      const color = r.status === "COMPLETED" ? "#22c55e" : r.status === "CANCELLED" ? "#ef4444" : r.status === "NOSHOW" ? "#f97316" : "#2563eb";
                      return (
                        <div key={j} style={{ background: color + "20", color, fontSize: 9, fontWeight: 600, borderRadius: 3, padding: "1px 4px", marginBottom: 1, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                          {r.start_time?.slice(0, 5)} {r.title}
                        </div>
                      );
                    })}
                    {dayResvs.length > 2 && <div style={{ fontSize: 9, color: "#9ca3af" }}>+{dayResvs.length - 2}</div>}
                  </div>
                );
              })}
            </div>
          </div>

          {/* 오른쪽 통계 */}
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{ background: "#fff", borderRadius: 14, padding: 16, border: "1px solid #f3f4f6" }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 12 }}>이달 예약 건수</div>
              <div style={{ fontSize: 24, fontWeight: 800, color: "#2563eb", marginBottom: 16 }}>{monthResvs.length}건</div>
              {[
                { label: "SHOW", value: showCount, color: "#22c55e", bg: "#f0fdf4" },
                { label: "NOSHOW", value: noshowCount, color: "#ef4444", bg: "#fff0f0" },
                { label: "미처리", value: pendingCount, color: "#9ca3af", bg: "#f3f4f6" },
              ].map((s, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                  <span style={{ background: s.bg, color: s.color, fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 6 }}>{s.label}</span>
                  <span style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>{s.value}건</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* 전체보기 */}
      {resvView === "all" && (
        <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", border: "1px solid #f3f4f6" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#f9fafb" }}>
                {["날짜", "시간", "수업명", "강사", "상태"].map(h => (
                  <th key={h} style={{ padding: "10px 16px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {memberReservations.length === 0 ? (
                <tr><td colSpan={5} style={{ textAlign: "center", padding: 30, color: "#9ca3af" }}>예약 내역 없음</td></tr>
              ) : memberReservations.map((r, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #f9fafb" }}
                  onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                  onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
                  <td style={{ padding: "12px 16px", color: "#374151" }}>{r.date}</td>
                  <td style={{ padding: "12px 16px", color: "#374151" }}>{r.start_time?.slice(0,5)}</td>
                  <td style={{ padding: "12px 16px", fontWeight: 600, color: "#111" }}>{r.title}</td>
                  <td style={{ padding: "12px 16px", color: "#374151" }}>{r.trainer_name || "-"}</td>
                  <td style={{ padding: "12px 16px" }}>
                    <Badge
                      label={r.status === "RESERVED" ? "예정" : r.status === "COMPLETED" ? "완료" : r.status === "NOSHOW" ? "결석" : "취소"}
                      color={r.status === "RESERVED" ? "#2563eb" : r.status === "COMPLETED" ? "#22c55e" : r.status === "NOSHOW" ? "#f97316" : "#ef4444"}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
})()}

                  {/* 출석내역 탭 */}
{activeTab === "attendance" && (() => {
  const now = new Date();
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const monthAttendances = memberAttendances.filter(a => new Date(a.check_in) >= firstDayOfMonth);
  return (
    <div>
      {/* 통계 카드 */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, marginBottom: 16 }}>
        <div style={{ background: "#eff6ff", borderRadius: 12, padding: "14px 16px", border: "1px solid #2563eb22" }}>
          <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 6 }}>이번달 방문</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#2563eb" }}>{monthAttendances.length}회</div>
        </div>
        <div style={{ background: "#f0fdf4", borderRadius: 12, padding: "14px 16px", border: "1px solid #22c55e22" }}>
          <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 6 }}>총 방문</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#22c55e" }}>{memberAttendances.length}회</div>
        </div>
        <div style={{ background: "#fff7ed", borderRadius: 12, padding: "14px 16px", border: "1px solid #f9731622" }}>
          <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 6 }}>최근 방문일</div>
          <div style={{ fontSize: 16, fontWeight: 800, color: "#f97316" }}>
            {memberAttendances.length > 0 ? new Date(memberAttendances[0].check_in + "Z").toLocaleDateString("ko-KR", { timeZone: "Asia/Seoul" }) : "-"}
          </div>
        </div>
      </div>

      {/* 테이블 */}
      <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", border: "1px solid #f3f4f6" }}>
        <div style={{ padding: "12px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 12, color: "#9ca3af" }}>
          {now.getFullYear()}년 {now.getMonth() + 1}월 출석 현황
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f9fafb" }}>
              {["No", "날짜", "입장시간"].map(h => (
                <th key={h} style={{ padding: "10px 16px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {monthAttendances.length === 0 ? (
              <tr><td colSpan={3} style={{ textAlign: "center", padding: 30, color: "#9ca3af" }}>이번달 출석 내역 없음</td></tr>
            ) : monthAttendances.map((a, i) => (
              <tr key={i} style={{ borderBottom: "1px solid #f9fafb" }}
                onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
                <td style={{ padding: "12px 16px", color: "#9ca3af" }}>{i + 1}</td>
                <td style={{ padding: "12px 16px", color: "#374151" }}>
                  {a.check_in ? new Date(a.check_in + "Z").toLocaleDateString("ko-KR", { timeZone: "Asia/Seoul" }) : "-"}
                </td>
                <td style={{ padding: "12px 16px", color: "#374151" }}>
                  {a.check_in ? new Date(a.check_in + "Z").toLocaleTimeString("ko-KR", { timeZone: "Asia/Seoul", hour: "2-digit", minute: "2-digit", hour12: false }) : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
})()}
                  {/* 정보수정 탭 */}
                  {activeTab === "edit" && (
                    <div style={{ background: "#fff", borderRadius: 14, padding: 20, border: "1px solid #f3f4f6" }}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                        <Input label="이름" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
                        <Input label="전화번호" value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} />
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                        <Select label="성별" value={form.gender} onChange={e => setForm(p => ({ ...p, gender: e.target.value }))}>
                          <option value="">선택</option>
                          <option value="male">남성</option>
                          <option value="female">여성</option>
                        </Select>
                        <Input label="생년월일" value={form.birth_date} onChange={e => setForm(p => ({ ...p, birth_date: e.target.value }))} type="date" />
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", gap: 8, alignItems: "end", marginBottom: 12 }}>
                        <Input label="가입일" value={form.start_date} onChange={e => setForm(p => ({ ...p, start_date: e.target.value }))} type="date" />
                        <span style={{ color: "#9ca3af", paddingBottom: 10 }}>—</span>
                        <Input label="만기일" value={form.end_date} onChange={e => setForm(p => ({ ...p, end_date: e.target.value }))} type="date" />
                      </div>
                      <div style={{ marginBottom: 12 }}>
                        <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>주소</label>
                        <input value={form.address} onChange={e => setForm(p => ({ ...p, address: e.target.value }))}
                          style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 12px", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                        <Select label="담당 트레이너" value={form.trainer_id} onChange={e => setForm(p => ({ ...p, trainer_id: e.target.value }))}>
                          <option value="">선택안함</option>
                          {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                        </Select>
                        <Select label="방문경로" value={form.visit_route} onChange={e => setForm(p => ({ ...p, visit_route: e.target.value }))}>
                          <option value="">선택안함</option>
                          {visitRouteOptions.map(v => <option key={v} value={v}>{v}</option>)}
                        </Select>
                      </div>
                      <div style={{ marginBottom: 16 }}>
                        <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>특이사항</label>
                        <textarea value={form.memo} onChange={e => setForm(p => ({ ...p, memo: e.target.value }))}
                          rows={3} style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 12px", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "none", fontFamily: "inherit" }} />
                      </div>
                      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                        <Btn variant="secondary" onClick={() => setSelectedMember(null)}>취소</Btn>
                        <Btn onClick={handleSave} disabled={saving}>{saving ? "저장 중..." : "저장"}</Btn>
                      </div>
                    </div>
                  )}

                  {/* 메모 탭 */}
{activeTab === "memo" && (
  <div>
    {/* 메모 작성 */}
    <div style={{ background: "#fff", borderRadius: 14, padding: 20, border: "1px solid #f3f4f6", marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 12 }}>메모 작성</div>
      <textarea
        value={memoText}
        onChange={e => setMemoText(e.target.value)}
        placeholder="회원에 대한 메모를 입력하세요"
        rows={4}
        style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "12px", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "vertical", fontFamily: "inherit", lineHeight: 1.7, color: "#111" }}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
        <button onClick={async () => {
          if (!memoText.trim()) return addToast("메모를 입력해주세요", "error");
          try {
            await api(`/members/${selectedMember.id}/memos?tenant_id=1`, {
              method: "POST",
              body: JSON.stringify({ content: memoText })
            }, token);
            addToast("메모가 저장됐습니다", "success");
            setMemoText("");
            api(`/members/${selectedMember.id}/memos?tenant_id=1`, {}, token).then(d => setMemberMemos(Array.isArray(d) ? d : [])).catch(() => {});
          } catch(e) { addToast("저장 실패: " + e.message, "error"); }
        }} style={{
          padding: "10px 24px", background: "#2563eb", color: "#fff", border: "none",
          borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer"
        }}>저장</button>
      </div>
    </div>

    {/* 메모 리스트 */}
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {memberMemos.length === 0 ? (
        <div style={{ background: "#fff", borderRadius: 14, padding: 40, border: "1px solid #f3f4f6", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>
          작성된 메모가 없습니다
        </div>
      ) : memberMemos.map((memo, i) => (
        <div key={memo.id} style={{ background: "#fff", borderRadius: 14, padding: "14px 16px", border: "1px solid #f3f4f6", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, color: "#374151", lineHeight: 1.7, whiteSpace: "pre-wrap" }}>{memo.content}</div>
            <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 6 }}>{memo.created_at?.slice(0, 16)}</div>
          </div>
          <button onClick={async () => {
            if (!window.confirm("삭제하시겠습니까?")) return;
            try {
              await api(`/members/${selectedMember.id}/memos/${memo.id}?tenant_id=1`, { method: "DELETE" }, token);
              addToast("삭제됐습니다", "success");
              api(`/members/${selectedMember.id}/memos?tenant_id=1`, {}, token).then(d => setMemberMemos(Array.isArray(d) ? d : [])).catch(() => {});
            } catch(e) { addToast("삭제 실패: " + e.message, "error"); }
          }} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", marginLeft: 10, flexShrink: 0 }}>
            <Icon name="x" size={14} color="#9ca3af" />
          </button>
        </div>
      ))}
    </div>
  </div>
)}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

<PaymentWizard
       open={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSuccess={() => { load(); if (selectedMember) selectMemberAndLoad(selectedMember); }}
        defaultMember={null}
        token={token}
        addToast={addToast}
        plans={plans}
        trainers={trainers}
        modusignTemplates={modusignTemplates}
        visitRouteOptions={visitRouteOptions}
        members={members}
      />
       <PaymentWizard
        open={showWizard}
        onClose={() => setShowWizard(false)}
        onSuccess={load}
        defaultMember={selectedMember}
        token={token}
        addToast={addToast}
        plans={plans}
        trainers={trainers}
        modusignTemplates={modusignTemplates}
        visitRouteOptions={visitRouteOptions}
        members={members}
      />

{/* 상품 상세 모달 */}
{selectedMembership && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <div style={{ background: "#fff", borderRadius: 20, padding: 32, width: 480, boxShadow: "0 24px 80px rgba(0,0,0,0.2)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: "#111" }}>상품 상세</div>
        <button onClick={() => setSelectedMembership(null)} style={{ background: "#f3f4f6", border: "none", borderRadius: 8, padding: "8px 10px", cursor: "pointer", fontSize: 18, color: "#6b7280" }}>×</button>
      </div>
      <div style={{ background: "#eff6ff", borderRadius: 12, padding: "16px 20px", marginBottom: 16 }}>
        <div style={{ fontSize: 11, color: "#2563eb", fontWeight: 600, marginBottom: 4 }}>상품명</div>
        <div style={{ fontSize: 20, fontWeight: 800, color: "#111" }}>{selectedMembership.plan_name || selectedMembership.name}</div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
        {[
          { label: "상태", value: <span style={{ background: selectedMembership.status === "ACTIVE" ? "#dcfce7" : "#f3f4f6", color: selectedMembership.status === "ACTIVE" ? "#16a34a" : "#9ca3af", padding: "2px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700 }}>{selectedMembership.status === "ACTIVE" ? "활성" : "만료"}</span> },
          { label: "잔여 일수", value: selectedMembership.days_remaining != null ? `${selectedMembership.days_remaining}일` : "-" },
          { label: "시작일", value: selectedMembership.start_date || "-" },
          { label: "종료일", value: (
            <span>
              {selectedMembership.end_date || "-"}
              {selectedMembership.edit_extend_days > 0 && (
                <span style={{ marginLeft: 6, background: "#fff7ed", color: "#f97316", padding: "1px 7px", borderRadius: 4, fontWeight: 700, fontSize: 11 }}>+{selectedMembership.edit_extend_days}일 연장</span>
              )}
            </span>
          ) },
          { label: "잔여 횟수", value: selectedMembership.remaining_count != null ? `${selectedMembership.remaining_count}회` : "무제한" },
          { label: "전체 횟수", value: (
            <span>
              {selectedMembership.total_count != null ? `${selectedMembership.total_count}회` : "무제한"}
              {selectedMembership.edit_add_count > 0 && (
                <span style={{ marginLeft: 6, background: "#ecfdf5", color: "#059669", padding: "1px 7px", borderRadius: 4, fontWeight: 700, fontSize: 11 }}>+{selectedMembership.edit_add_count}회 추가</span>
              )}
            </span>
          ) },
          { label: "홀딩 가능", value: selectedMembership.holding_yn === "Y" ? "가능" : "불가" },
          { label: "홀딩 사용", value: `${selectedMembership.holding_used ?? 0} / ${selectedMembership.holding_count ?? 0}회` },
        ].map((item, i) => (
          <div key={i} style={{ background: "#f9fafb", borderRadius: 10, padding: "12px 14px" }}>
            <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>{item.label}</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: "#111" }}>{item.value}</div>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={async () => {
          try {
            const logs = await api(`/membership/${selectedMembership.id}/logs`, {}, token);
            setMembershipLogs(Array.isArray(logs) ? logs : []);
            setShowMembershipLogs(true);
          } catch(e) { addToast("이력 로드 실패: " + e.message, "error"); }
        }} style={{ flex: 1, padding: 14, border: "1px solid #e5e7eb", borderRadius: 10, background: "#fff", color: "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>📋 이력보기</button>
        <button onClick={() => {
          setMembershipEditForm({
            start_date: selectedMembership.start_date || "", end_date: selectedMembership.end_date || "",
            total_count: selectedMembership.total_count ?? "", remaining_count: selectedMembership.remaining_count ?? "",
            trainer_id: String(selectedMembership.trainer_id || ""), memo: selectedMembership.memo || "", reason: ""
          });
          setShowMembershipEdit(true);
        }} style={{ flex: 1, padding: 14, border: "none", borderRadius: 10, background: "#f97316", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>✏️ 수정</button>
        <button onClick={() => setSelectedMembership(null)} style={{ flex: 1, padding: 14, border: "none", borderRadius: 10, background: "#2563eb", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>닫기</button>
      </div>
    </div>
  </div>
)}

{/* 회원권 수정 모달 */}
{showMembershipEdit && selectedMembership && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 2500, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
    <div style={{ background: "#fff", borderRadius: 20, width: "100%", maxWidth: 560, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 24px 80px rgba(0,0,0,0.2)" }}>
      <div style={{ background: "#f97316", borderRadius: "20px 20px 0 0", padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}>회원권 수정</div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.9)", marginTop: 2 }}>{selectedMembership.plan_name || selectedMembership.name}</div>
        </div>
        <button onClick={() => setShowMembershipEdit(false)} style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: 8, padding: "6px 10px", cursor: "pointer", fontSize: 18, color: "#fff" }}>×</button>
      </div>
      <div style={{ padding: 24 }}>
        <div style={{ background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 10, padding: "10px 14px", marginBottom: 20, fontSize: 12, color: "#9a3412" }}>
          ⚠️ 수정 내역은 기록되며, <strong>수정 사유</strong>는 반드시 입력해야 합니다.
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
          <div>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>시작일</label>
            <input type="date" value={membershipEditForm.start_date} onChange={e => setMembershipEditForm(p => ({ ...p, start_date: e.target.value }))} style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
          </div>
          <div>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>종료일</label>
            <input type="date" value={membershipEditForm.end_date} onChange={e => setMembershipEditForm(p => ({ ...p, end_date: e.target.value }))} style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
          <div>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>전체 횟수</label>
            <input type="number" value={membershipEditForm.total_count} onChange={e => setMembershipEditForm(p => ({ ...p, total_count: e.target.value }))} placeholder="무제한은 비워두세요" style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
          </div>
          <div>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>잔여 횟수</label>
            <input type="number" value={membershipEditForm.remaining_count} onChange={e => setMembershipEditForm(p => ({ ...p, remaining_count: e.target.value }))} placeholder="무제한은 비워두세요" style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
          </div>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>담당 트레이너</label>
          <select value={membershipEditForm.trainer_id} onChange={e => setMembershipEditForm(p => ({ ...p, trainer_id: e.target.value }))} style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" }}>
            <option value="">선택 안함</option>
            {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>메모</label>
          <textarea value={membershipEditForm.memo} onChange={e => setMembershipEditForm(p => ({ ...p, memo: e.target.value }))} rows={2} style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "vertical", fontFamily: "inherit" }} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: "block", color: "#ef4444", fontSize: 12, fontWeight: 700, marginBottom: 5 }}>수정 사유 * (필수)</label>
          <textarea value={membershipEditForm.reason} onChange={e => setMembershipEditForm(p => ({ ...p, reason: e.target.value }))} placeholder="수정 사유를 반드시 입력해주세요 (예: 회원 요청으로 1개월 연장)" rows={3} style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #fca5a5", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "vertical", fontFamily: "inherit", background: "#fff7ed" }} />
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={() => setShowMembershipEdit(false)} style={{ flex: 1, padding: 14, border: "1px solid #e5e7eb", borderRadius: 10, background: "#fff", fontSize: 14, cursor: "pointer" }}>취소</button>
          <button onClick={async () => {
            if (!membershipEditForm.reason.trim()) return addToast("수정 사유를 입력해주세요", "error");
            try {
              const body = { reason: membershipEditForm.reason.trim() };
              if (membershipEditForm.start_date) body.start_date = membershipEditForm.start_date;
              if (membershipEditForm.end_date) body.end_date = membershipEditForm.end_date;
              if (membershipEditForm.total_count !== "") body.total_count = parseInt(membershipEditForm.total_count);
              if (membershipEditForm.remaining_count !== "") body.remaining_count = parseInt(membershipEditForm.remaining_count);
              if (membershipEditForm.trainer_id !== "") body.trainer_id = parseInt(membershipEditForm.trainer_id) || null;
              body.memo = membershipEditForm.memo;
              await api(`/membership/${selectedMembership.id}/with-log`, { method: "PUT", body: JSON.stringify(body) }, token);
              addToast("수정됐습니다. 이력이 기록됐습니다.", "success");
              setShowMembershipEdit(false);
              setSelectedMembership({ ...selectedMembership, ...body });
              if (selectedMember) {
                api(`/membership/by-member?member_id=${selectedMember.id}`, {}, token).then(d => setMemberMemberships(Array.isArray(d) ? d : [])).catch(() => {});
              }
            } catch(e) { addToast("수정 실패: " + e.message, "error"); }
          }} style={{ flex: 2, padding: 14, border: "none", borderRadius: 10, background: "#f97316", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>저장하기</button>
        </div>
      </div>
    </div>
  </div>
)}

{/* 회원권 이력 모달 */}
{showMembershipLogs && selectedMembership && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 2500, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
    <div style={{ background: "#fff", borderRadius: 20, width: "100%", maxWidth: 680, maxHeight: "90vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 24px 80px rgba(0,0,0,0.2)" }}>
      <div style={{ background: "#2563eb", borderRadius: "20px 20px 0 0", padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}>회원권 수정 이력</div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.9)", marginTop: 2 }}>{selectedMembership.plan_name || selectedMembership.name}</div>
        </div>
        <button onClick={() => setShowMembershipLogs(false)} style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: 8, padding: "6px 10px", cursor: "pointer", fontSize: 18, color: "#fff" }}>×</button>
      </div>
      <div style={{ flex: 1, overflowY: "auto", padding: 24 }}>
        {membershipLogs.length === 0 ? (
          <div style={{ textAlign: "center", padding: 60, color: "#9ca3af", fontSize: 13 }}>📋 수정 이력이 없습니다</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {(() => {
              const groups = {};
              membershipLogs.forEach(log => {
                const key = `${log.created_at}_${log.reason}_${log.staff_id}`;
                if (!groups[key]) groups[key] = { created_at: log.created_at, staff_name: log.staff_name, reason: log.reason, changes: [] };
                groups[key].changes.push(log);
              });
              const groupList = Object.values(groups).sort((a, b) => b.created_at.localeCompare(a.created_at));
              return groupList.map((g, i) => (
                <div key={i} style={{ background: "#f9fafb", borderRadius: 12, padding: 16, border: "1px solid #f3f4f6" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, paddingBottom: 10, borderBottom: "1px solid #e5e7eb" }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#111" }}>👤 {g.staff_name}</div>
                    <div style={{ fontSize: 11, color: "#9ca3af" }}>{g.created_at?.slice(0, 19)}</div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 10 }}>
                    {g.changes.map((c, j) => (
                      <div key={j} style={{ display: "grid", gridTemplateColumns: "80px 1fr auto 1fr", gap: 8, alignItems: "center", fontSize: 12 }}>
                        <span style={{ color: "#6b7280", fontWeight: 600 }}>{c.field_label}</span>
                        <span style={{ background: "#fee2e2", color: "#991b1b", padding: "4px 8px", borderRadius: 6, textAlign: "center" }}>{c.before_value || "(없음)"}</span>
                        <span style={{ color: "#6b7280" }}>→</span>
                        <span style={{ background: "#dcfce7", color: "#166534", padding: "4px 8px", borderRadius: 6, textAlign: "center" }}>{c.after_value || "(없음)"}</span>
                      </div>
                    ))}
                  </div>
                  <div style={{ background: "#fefce8", borderRadius: 8, padding: "10px 12px", fontSize: 12, color: "#374151" }}>📝 <strong>사유:</strong> {g.reason}</div>
                </div>
              ));
            })()}
          </div>
        )}
      </div>
      <div style={{ padding: 16, borderTop: "1px solid #f3f4f6", background: "#fff" }}>
        <button onClick={() => setShowMembershipLogs(false)} style={{ width: "100%", padding: 12, border: "1px solid #e5e7eb", borderRadius: 10, background: "#fff", fontSize: 14, cursor: "pointer", color: "#374151" }}>닫기</button>
      </div>
    </div>
  </div>
)}

      {/* 홀딩 모달 */}
      {showHoldingModal && holdingMember && (() => {
        // 홀딩 가능한 회원권: ACTIVE + 만료 미도래
        const today = ymdKST();
        const holdableMemberships = memberMemberships.filter(ms =>
          ms.status === "ACTIVE" && ms.end_date && ms.end_date >= today
        );
        // 홀딩 일수 계산
        const holdingDays = holdingForm.start_date && holdingForm.end_date
          ? Math.max(0, Math.floor((new Date(holdingForm.end_date) - new Date(holdingForm.start_date)) / (1000 * 60 * 60 * 24)))
          : 0;
        // 체크된 회원권 state (모달 열릴 때 전체 선택)
        const checkedIds = holdingForm.checkedIds || holdableMemberships.map(ms => ms.id);
        const setCheckedIds = (ids) => setHoldingForm(p => ({ ...p, checkedIds: ids }));
        // 연장 후 만료일 계산
        const calcNewEndDate = (endDate) => {
          if (!endDate || holdingDays <= 0) return null;
          const d = new Date(endDate);
          d.setDate(d.getDate() + holdingDays);
          return ymdKST(d);
        };
        return (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
            <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 500, boxShadow: "0 20px 60px rgba(0,0,0,0.15)", overflow: "hidden" }}>
              {/* 헤더 */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f3f4f6" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 36, height: 36, borderRadius: "50%", background: "#fff7ed", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <span style={{ fontSize: 18 }}>⏸</span>
                  </div>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>홀딩 처리</div>
                    <div style={{ fontSize: 12, color: "#9ca3af" }}>{holdingMember.name} 회원</div>
                  </div>
                </div>
                <button onClick={() => setShowHoldingModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", padding: 4 }}>
                  <Icon name="x" size={18} />
                </button>
              </div>

              <div style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: 20 }}>
                {/* 홀딩 기간 */}
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 10 }}>홀딩 기간</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    <div>
                      <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 5 }}>시작일</div>
                      <input type="date" value={holdingForm.start_date}
                        onChange={e => setHoldingForm(p => ({ ...p, start_date: e.target.value, checkedIds: undefined }))}
                        style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 5 }}>종료일</div>
                      <input type="date" value={holdingForm.end_date}
                        onChange={e => setHoldingForm(p => ({ ...p, end_date: e.target.value, checkedIds: undefined }))}
                        style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                    </div>
                  </div>
                  {holdingDays > 0 && (
                    <div style={{ marginTop: 8, padding: "8px 12px", background: "#eff6ff", borderRadius: 8, fontSize: 12, color: "#2563eb" }}>
                      홀딩 기간 {holdingDays}일 — 선택된 회원권의 만료일이 {holdingDays}일 연장됩니다
                    </div>
                  )}
                </div>

                {/* 회원권 선택 */}
                <div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>홀딩할 회원권 선택</div>
                    <span
                      onClick={() => setCheckedIds(holdableMemberships.map(ms => ms.id))}
                      style={{ fontSize: 12, color: "#2563eb", cursor: "pointer" }}>전체 선택</span>
                  </div>
                  {holdableMemberships.length === 0 ? (
                    <div style={{ padding: "20px", textAlign: "center", color: "#9ca3af", fontSize: 13, background: "#f9fafb", borderRadius: 8 }}>
                      활성 회원권이 없습니다
                    </div>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 280, overflowY: "auto" }}>
                      {holdableMemberships.map(ms => {
                        const isChecked = checkedIds.includes(ms.id);
                        const newEnd = calcNewEndDate(ms.end_date);
                        return (
                          <label key={ms.id} style={{
                            display: "flex", alignItems: "center", gap: 12,
                            padding: "12px 14px", borderRadius: 10, cursor: "pointer",
                            border: `1px solid ${isChecked ? "#bfdbfe" : "#f3f4f6"}`,
                            background: isChecked ? "#eff6ff" : "#fafafa"
                          }}>
                            <input type="checkbox" checked={isChecked}
                              onChange={() => setCheckedIds(
                                isChecked ? checkedIds.filter(id => id !== ms.id) : [...checkedIds, ms.id]
                              )}
                              style={{ width: 16, height: 16, accentColor: "#2563eb", flexShrink: 0 }} />
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
                                <span style={{ background: "#2563eb", color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 20 }}>활성</span>
                                <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>{ms.plan_name || ms.name}</span>
                              </div>
                              <span style={{ fontSize: 12, color: "#6b7280" }}>
                                {ms.start_date} ~ {ms.end_date}
                                {ms.sessions_remaining != null && ` | 잔여 ${ms.sessions_remaining}회`}
                              </span>
                            </div>
                            <div style={{ fontSize: 12, color: isChecked && newEnd ? "#2563eb" : "#9ca3af", fontWeight: isChecked && newEnd ? 600 : 400, whiteSpace: "nowrap", flexShrink: 0 }}>
                              {isChecked && newEnd ? `→ ${newEnd}` : "변경 없음"}
                            </div>
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* 버튼 */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 10 }}>
                  <button onClick={() => setShowHoldingModal(false)} style={{ padding: "13px 0", borderRadius: 10, border: "1px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>취소</button>
                  <button onClick={async () => {
                    if (!holdingForm.start_date || !holdingForm.end_date) { addToast("홀딩 기간을 입력해주세요", "error"); return; }
                    if (checkedIds.length === 0) { addToast("홀딩할 회원권을 1개 이상 선택해주세요", "error"); return; }
                    try {
                      await api(`/members/${holdingMember.id}?tenant_id=1`, { method: "PUT", body: JSON.stringify({
                        holding_yn: "Y", is_holding: "Y",
                        holding_start_date: holdingForm.start_date,
                        holding_end_date: holdingForm.end_date,
                        holding_used: (holdingMember.holding_used || 0) + 1,
                        target_membership_ids: checkedIds,
                      })}, token);
                      addToast("홀딩이 설정됐습니다", "success");
                      setShowHoldingModal(false);
                      load();
                      if (holdingMember) selectMemberAndLoad({ ...holdingMember, is_holding: "Y", holding_yn: "Y" });
                    } catch (e) { addToast("홀딩 설정 실패: " + e.message, "error"); }
                  }} style={{ padding: "13px 0", borderRadius: 10, border: "none", background: "#f97316", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>홀딩 처리</button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* 회원 통계 */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginTop: 24 }}>
        <div style={{ background: "#fff", borderRadius: 14, padding: 24, border: "1px solid #f3f4f6" }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 20 }}>헬스장 방문 남녀 통계</div>
          <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
            <div style={{ width: 160, height: 160, flexShrink: 0 }}>
              <svg viewBox="0 0 100 100" style={{ width: 160, height: 160 }}>
                {genderData && genderData.total > 0 && (() => {
                  const malePct = genderData.male_percent / 100;
                  const maleAngle = malePct * 360;
                  const maleRad = (maleAngle - 90) * Math.PI / 180;
                  const x = 50 + 40 * Math.cos(maleRad);
                  const y = 50 + 40 * Math.sin(maleRad);
                  const largeArc = maleAngle > 180 ? 1 : 0;
                  return (<>
                    <path d={`M50,50 L50,10 A40,40 0 ${largeArc},1 ${x},${y} Z`} fill="#2563eb" />
                    <path d={`M50,50 L${x},${y} A40,40 0 ${1 - largeArc},1 50,10 Z`} fill="#ec4899" />
                  </>);
                })()}
              </svg>
            </div>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                <div style={{ width: 12, height: 12, borderRadius: "50%", background: "#2563eb" }} />
                <span style={{ fontSize: 13 }}>남자: {Number(genderData?.male || 0).toLocaleString()}명</span>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#2563eb" }}>({genderData?.male_percent || 0}%)</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ width: 12, height: 12, borderRadius: "50%", background: "#ec4899" }} />
                <span style={{ fontSize: 13 }}>여자: {Number(genderData?.female || 0).toLocaleString()}명</span>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#ec4899" }}>({genderData?.female_percent || 0}%)</span>
              </div>
            </div>
          </div>
        </div>
        <div style={{ background: "#fff", borderRadius: 14, padding: 24, border: "1px solid #f3f4f6" }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 20 }}>나이대별 통계</div>
          {(() => {
            const buckets = [["10대", 10, 19], ["20대", 20, 29], ["30대", 30, 39], ["40대", 40, 49], ["50대", 50, 59], ["60대+", 60, 200]];
            const counts = buckets.map(() => 0);
            (members || []).forEach(m => {
              if (!m.birth_date) return;
              const b = new Date(m.birth_date);
              if (isNaN(b.getTime())) return;
              const age = Math.floor((Date.now() - b.getTime()) / (1000 * 60 * 60 * 24 * 365.25));
              const idx = buckets.findIndex(bk => age >= bk[1] && age <= bk[2]);
              if (idx >= 0) counts[idx]++;
            });
            const total = counts.reduce((a, b) => a + b, 0);
            const maxC = Math.max(...counts, 1);
            if (total === 0) {
              return <div style={{ color: "#9ca3af", fontSize: 13, textAlign: "center", padding: "60px 0" }}>데이터 없음</div>;
            }
            return (
              <div style={{ height: 160, display: "flex", alignItems: "flex-end", gap: 12 }}>
                {buckets.map((bk, i) => (
                  <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", height: "100%", justifyContent: "flex-end" }}>
                    <span style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 700 }}>{counts[i] > 0 ? `${counts[i]}명` : ""}</span>
                    <div style={{ width: "100%", background: "#6366f1", borderRadius: "3px 3px 0 0", height: `${(counts[i] / maxC) * 80}%`, minHeight: counts[i] > 0 ? 6 : 0 }} />
                    <span style={{ fontSize: 10, color: "#9ca3af", marginTop: 4, textAlign: "center" }}>{bk[0]}</span>
                  </div>
                ))}
              </div>
            );
          })()}
        </div>
      </div>

      <CameraCaptureModal
        isOpen={showCameraModal}
        onClose={() => setShowCameraModal(false)}
        onCapture={(file) => uploadProfileImage(file)}
      />
      <CameraCaptureModal
        isOpen={showCameraForNewMember}
        onClose={() => setShowCameraForNewMember(false)}
        onCapture={(file) => setNewMemberProfileImage(file)}
      />
      {holdingHistoryModal.open && (
  <div onClick={() => setHoldingHistoryModal({ open: false, membershipId: null, list: [] })} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.4)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 24, width: 600, maxHeight: "80vh", overflow: "auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>🔄 홀딩 이력</h3>
        <button onClick={() => setHoldingHistoryModal({ open: false, membershipId: null, list: [] })} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#9ca3af" }}>×</button>
      </div>
      {holdingHistoryModal.list.length === 0 ? (
        <div style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>이력 없음</div>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f9fafb" }}>
              {["시작일", "종료일", "일수", "등록자", "등록일"].map(h => (
                <th key={h} style={{ padding: "10px 12px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {holdingHistoryModal.list.map(h => (
              <tr key={h.id} style={{ borderBottom: "1px solid #f9fafb" }}>
                <td style={{ padding: "10px 12px", color: "#111" }}>{h.start_date}</td>
                <td style={{ padding: "10px 12px", color: "#111" }}>{h.end_date}</td>
                <td style={{ padding: "10px 12px", color: "#8b5cf6", fontWeight: 700 }}>+{h.days}일</td>
                <td style={{ padding: "10px 12px", color: "#374151" }}>{h.staff_name}</td>
                <td style={{ padding: "10px 12px", color: "#9ca3af", fontSize: 12 }}>{h.created_at?.slice(0, 16) || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>
)}
      {historyModal.open && (
  <div onClick={() => setHistoryModal({ open: false, editLogs: [], holdingLogs: [] })} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.4)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 24, width: 640, maxHeight: "82vh", overflow: "auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>📋 회원권 이력</h3>
        <button onClick={() => setHistoryModal({ open: false, editLogs: [], holdingLogs: [] })} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#9ca3af" }}>×</button>
      </div>
      {historyModal.editLogs.length === 0 && historyModal.holdingLogs.length === 0 ? (
        <div style={{ textAlign: "center", padding: 50, color: "#9ca3af", fontSize: 14 }}>이력이 없습니다</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 22 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 800, color: "#f97316", marginBottom: 10 }}>✏️ 수정 이력</div>
            {historyModal.editLogs.length === 0 ? (
              <div style={{ color: "#9ca3af", fontSize: 12, padding: "6px 0" }}>수정 이력이 없습니다</div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {(() => {
                  const groups = {};
                  historyModal.editLogs.forEach(log => {
                    const key = `${log.created_at}_${log.reason}_${log.staff_id}`;
                    if (!groups[key]) groups[key] = { created_at: log.created_at, staff_name: log.staff_name, reason: log.reason, changes: [] };
                    groups[key].changes.push(log);
                  });
                  return Object.values(groups).sort((a, b) => (b.created_at || "").localeCompare(a.created_at || "")).map((g, i) => (
                    <div key={i} style={{ background: "#f9fafb", borderRadius: 10, padding: 14, border: "1px solid #f3f4f6" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8, paddingBottom: 8, borderBottom: "1px solid #e5e7eb" }}>
                        <span style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>👤 {g.staff_name || "-"}</span>
                        <span style={{ fontSize: 11, color: "#9ca3af" }}>{g.created_at?.slice(0, 19)}</span>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 8 }}>
                        {g.changes.map((c, j) => (
                          <div key={j} style={{ display: "grid", gridTemplateColumns: "72px 1fr auto 1fr", gap: 8, alignItems: "center", fontSize: 12 }}>
                            <span style={{ color: "#6b7280", fontWeight: 600 }}>{c.field_label}</span>
                            <span style={{ background: "#fee2e2", color: "#991b1b", padding: "3px 8px", borderRadius: 6, textAlign: "center" }}>{c.before_value || "(없음)"}</span>
                            <span style={{ color: "#6b7280" }}>→</span>
                            <span style={{ background: "#dcfce7", color: "#166534", padding: "3px 8px", borderRadius: 6, textAlign: "center" }}>{c.after_value || "(없음)"}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ background: "#fefce8", borderRadius: 8, padding: "8px 10px", fontSize: 12, color: "#374151" }}>📝 <strong>사유:</strong> {g.reason}</div>
                    </div>
                  ));
                })()}
              </div>
            )}
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 800, color: "#8b5cf6", marginBottom: 10 }}>🔄 홀딩 이력</div>
            {historyModal.holdingLogs.length === 0 ? (
              <div style={{ color: "#9ca3af", fontSize: 12, padding: "6px 0" }}>홀딩 이력이 없습니다</div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead><tr style={{ background: "#f9fafb" }}>{["시작일", "종료일", "일수", "등록자", "등록일"].map(h => (<th key={h} style={{ padding: "9px 10px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>))}</tr></thead>
                <tbody>
                  {historyModal.holdingLogs.map(h => (
                    <tr key={h.id} style={{ borderBottom: "1px solid #f9fafb" }}>
                      <td style={{ padding: "9px 10px", color: "#111" }}>{h.start_date}</td>
                      <td style={{ padding: "9px 10px", color: "#111" }}>{h.end_date}</td>
                      <td style={{ padding: "9px 10px", color: "#8b5cf6", fontWeight: 700 }}>+{h.days}일</td>
                      <td style={{ padding: "9px 10px", color: "#374151" }}>{h.staff_name}</td>
                      <td style={{ padding: "9px 10px", color: "#9ca3af", fontSize: 12 }}>{h.created_at?.slice(0, 16) || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  </div>
)}
      {/* 미수금 나노 카드결제 모달 */}
      <CardPaymentModal
        isOpen={showUnpaidCardModal}
        onClose={() => setShowUnpaidCardModal(false)}
        orderInfo={cardPayInfo}
        token={token}
        onSuccess={async (nanoResult) => {
          setShowUnpaidCardModal(false);
          const meta = cardPayInfo._meta;
          if (!meta) return;
          try {
            const unpaidAmt = meta.totalPrice;
            await api("/payment", { method: "POST", body: JSON.stringify({
              tenant_id: 1,
              member_id: meta.memberId,
              plan_id: meta.planList[0]?.id,
              amount: unpaidAmt,
              original_amount: unpaidAmt,
              discount_amount: 0,
              unpaid_amount: 0,
              method: "card",
              pg_method: nanoResult.pg_method || "nano",
              status: "approved",
              payment_type: "미수금",
              payment_group_id: meta.paymentGroupId,
              transactionId: nanoResult.tranNo || null,
              authCd: nanoResult.apprNo || null,
              cardIssuer: nanoResult.cardTxt || null,
            })}, token);
            if (meta.originalPaymentId) {
              await api(`/payment/${meta.originalPaymentId}`, { method: "PUT", body: JSON.stringify({ unpaid_amount: 0 })}, token);
            }
            addToast("미수금 카드 결제가 완료됐습니다 💳", "success");
            api(`/payment/list?tenant_id=1&member_id=${meta.memberId}`, {}, token)
              .then(d => setMemberPayments(Array.isArray(d) ? d : d?.items || []));
          } catch(e) {
            addToast("미수금 결제 저장 실패: " + e.message, "error");
          }
        }}
      />
      {/* 미수금 결제 모달 */}
      {unpaidPayModal.open && unpaidPayModal.payment && (
        <div style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 9999, padding: 16
        }}>
          <div style={{
            background: "#fff", borderRadius: 16, width: "100%", maxWidth: 400,
            boxShadow: "0 20px 60px rgba(0,0,0,0.25)", overflow: "hidden"
          }}>
            <div style={{
              padding: "18px 20px 14px", borderBottom: "1px solid #f3f4f6",
              display: "flex", alignItems: "center", justifyContent: "space-between"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{
                  width: 32, height: 32, borderRadius: 8, background: "#f97316",
                  display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16
                }}>💰</div>
                <div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>미수금 결제</div>
                  <div style={{ fontSize: 11, color: "#9ca3af" }}>미납 금액을 결제합니다</div>
                </div>
              </div>
              <button onClick={() => { setUnpaidPayModal({ open: false, payment: null }); setUnpaidPayMethod(""); }}
                style={{ background: "none", border: "none", fontSize: 20, color: "#9ca3af", cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ padding: "16px 20px", display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={{
                background: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)",
                borderRadius: 12, padding: "16px 18px", color: "#fff"
              }}>
                <div style={{ fontSize: 11, opacity: 0.75, marginBottom: 2 }}>결제 상품</div>
                <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}>
                  {unpaidPayModal.payment.plan_name || "-"}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                  <div>
                    <div style={{ fontSize: 11, opacity: 0.75 }}>회원</div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{unpaidPayModal.payment.member_name || "-"}</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 11, opacity: 0.75 }}>미수금액</div>
                    <div style={{ fontSize: 22, fontWeight: 800 }}>
                      {Number(unpaidPayModal.payment.unpaid_amount || 0).toLocaleString()}
                      <span style={{ fontSize: 14, marginLeft: 2 }}>원</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 8 }}>결제수단 선택</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
                  {[
                    ...(pgEnabled ? [{ id: "card_nano", label: "💳 카드(PG)", desc: "헬스페이 승인" }] : []),
                    { id: "card", label: "✏️ 카드(수기)", desc: "단말기 직접" },
                    { id: "cash", label: "💵 현금", desc: "즉시 저장" },
                    { id: "transfer", label: "🏦 계좌이체", desc: "즉시 저장" },
                  ].map(m => (
                    <button key={m.id} onClick={() => setUnpaidPayMethod(m.id)}
                      style={{
                        padding: "10px 6px", borderRadius: 10, cursor: "pointer",
                        border: unpaidPayMethod === m.id ? "2px solid #f97316" : "1.5px solid #e5e7eb",
                        background: unpaidPayMethod === m.id ? "#fff7ed" : "#fff",
                        transition: "all 0.15s"
                      }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: unpaidPayMethod === m.id ? "#f97316" : "#374151" }}>{m.label}</div>
                      <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 2 }}>{m.desc}</div>
                    </button>
                  ))}
                </div>
              </div>
              {pgEnabled === false && (
                <div style={{ background: "#eef4ff", border: "1px solid #c7dbff", borderRadius: 10, padding: "10px 12px", marginBottom: 12, fontSize: 11, color: "#6b7280", lineHeight: 1.5 }}>
                  💳 <b style={{ color: "#2563eb" }}>헬스페이 PG</b>를 연동하면 앱에서 카드 즉시 승인 + 무이자 할부까지 지원돼요. 연동 문의 ☎ 02-6672-7942
                </div>
              )}
              <button
                disabled={!unpaidPayMethod || unpaidSaving}
                onClick={async () => {
                  if (!unpaidPayMethod) return;
                  setUnpaidSaving(true);
                  try {
                    const p = unpaidPayModal.payment;
                    const unpaidAmt = Number(p.unpaid_amount || 0);
                    if (unpaidPayMethod === "card_nano") {
                      // 나노 PG 카드결제 → CardPaymentModal로 넘김
                      setUnpaidPayModal({ open: false, payment: null });
                      setUnpaidPayMethod("");
                      // cardPayInfo에 미수금 정보 세팅 후 카드모달 오픈
                      setCardPayInfo({
                        memberId: p.member_id,
                        memberName: p.member_name,
                        memberPhone: p.member_phone || "",
                        memberEmail: "",
                        goodsName: p.plan_name,
                        reqPayAmt: String(unpaidAmt),
                        _meta: {
                          planList: [{ id: p.plan_id, name: p.plan_name, card_price: unpaidAmt }],
                          memberId: p.member_id,
                          totalPrice: unpaidAmt,
                          discount: 0,
                          unpaid: 0,
                          memberMode: "existing",
                          paymentGroupId: p.payment_group_id,
                          paymentDate: ymdKST(),
                          originalPaymentId: p.id,
                        }
                      });
                      setShowUnpaidCardModal(true);
                      setUnpaidSaving(false);
                      return;
                    }
                    await api("/payment", { method: "POST", body: JSON.stringify({
                      tenant_id: 1,
                      member_id: p.member_id,
                      plan_id: p.plan_id,
                      amount: unpaidAmt,
                      original_amount: unpaidAmt,
                      discount_amount: 0,
                      unpaid_amount: 0,
                      method: unpaidPayMethod,
                      pg_method: unpaidPayMethod === "card" ? "manual" : null,
                      status: "approved",
                      payment_type: "미수금",
                      payment_group_id: p.payment_group_id,
                      payer_name: p.member_name,
                      goods_name: p.plan_name,
                    })}, token);
                    await api(`/payment/${p.id}`, { method: "PUT", body: JSON.stringify({
                      unpaid_amount: 0,
                    })}, token);
                    addToast("미수금 결제가 완료됐습니다 💰", "success");
                    setUnpaidPayModal({ open: false, payment: null });
                    setUnpaidPayMethod("");
                    api(`/payment/list?tenant_id=1&member_id=${p.member_id}`, {}, token)
                      .then(d => setMemberPayments(Array.isArray(d) ? d : d?.items || []));
                  } catch(e) {
                    addToast("미수금 결제 실패: " + e.message, "error");
                  } finally {
                    setUnpaidSaving(false);
                  }
                }}
                style={{
                  width: "100%", padding: "14px",
                  background: !unpaidPayMethod || unpaidSaving ? "#9ca3af" : "#f97316",
                  color: "#fff", border: "none", borderRadius: 10,
                  fontSize: 15, fontWeight: 700,
                  cursor: !unpaidPayMethod || unpaidSaving ? "not-allowed" : "pointer",
                  transition: "background 0.15s"
                }}>
                {unpaidSaving ? "처리 중..." : unpaidPayMethod
                  ? `💰 ${Number(unpaidPayModal.payment.unpaid_amount || 0).toLocaleString()}원 결제`
                  : "결제수단을 선택해주세요"}
              </button>
            </div>
          </div>
        </div>
      )}
      <ReceiptModal
        isOpen={receiptModal.open}
        onClose={() => setReceiptModal({ open: false, paymentId: null })}
        paymentId={receiptModal.paymentId}
      />
    </div>
    
  );
};
// ── Other Pages ──
const AttendancePage = ({ token, addToast }) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(ymdKST());

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/attendance/list?tenant_id=1", {}, token);
      setRecords(Array.isArray(d) ? d : d.items || []);
    } catch (e) { addToast("출입 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const today = new Date();
  const thisMonth = today.getMonth();
  const thisYear = today.getFullYear();

  // 통계
  const monthRecords = records.filter(r => {
    const d = new Date(r.check_in);
    return d.getMonth() === thisMonth && d.getFullYear() === thisYear;
  });
  const todayRecords = records.filter(r => r.check_in?.slice(0, 10) === ymdKST(today));
  const todayValid = todayRecords.filter(r => r.memberships?.length > 0);
  const todayInvalid = todayRecords.filter(r => !r.memberships || r.memberships.length === 0);

  // 날짜 필터
  const filtered = records.filter(r => r.check_in?.slice(0, 10) === selectedDate);

  // 날짜 옵션 생성 (최근 30일)
  const dateOptions = Array.from({ length: 30 }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const str = ymdKST(d);
    const dayNames = ["일", "월", "화", "수", "목", "금", "토"];
    const dayName = dayNames[d.getDay()];
    return { value: str, label: `${str} (${dayName})` };
  });

  const expiringSoon = records.filter(r => {
    if (!r.memberships || r.memberships.length === 0) return false;
    const endDate = r.memberships[0]?.end_date;
    if (!endDate) return false;
    const days = Math.floor((new Date(endDate) - new Date()) / (1000 * 60 * 60 * 24));
    return days >= 0 && days <= 30;
  });
  const statCards = [
    { label: "이달 방문 회원", value: `${monthRecords.length}명`, color: "#2563eb", bg: "#eff6ff" },
    { label: "금일 입장", value: `${todayRecords.length}명`, color: "#22c55e", bg: "#f0fdf4" },
    { label: "이달 만료 예정자", value: `${expiringSoon.length}명`, color: "#f97316", bg: "#fff7ed" },
  ];

  const handleCancel = async (id) => {
    if (!window.confirm("출입 기록을 취소하시겠습니까?")) return;
    try {
      await api(`/attendance/${id}/check-out?tenant_id=1`, { method: "PUT", body: JSON.stringify({ memo: "취소" }) }, token);
      addToast("취소됐습니다", "success");
      load();
    } catch (e) { addToast("취소 실패: " + e.message, "error"); }
  };

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}>
        <span style={{ color: "#9ca3af", fontSize: 18 }}>‹</span>
        <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>출입관리</h2>
      </div>

      {/* 상단 카드 */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14, marginBottom: 24 }}>
        {statCards.map((c, i) => (
          <div key={i} style={{ background: c.bg, borderRadius: 14, padding: "20px 24px", border: `1px solid ${c.color}22` }}>
            <div style={{ color: "#6b7280", fontSize: 13, marginBottom: 8 }}>{c.label}</div>
            <div style={{ color: c.color, fontSize: 28, fontWeight: 800 }}>{c.value}</div>
          </div>
        ))}
      </div>

      {/* 날짜 선택 + 테이블 (통합 박스) */}
      <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
        {/* 날짜 선택 */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "16px 20px", borderBottom: "1px solid #f3f4f6" }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>날짜 선택:</span>
          <select value={selectedDate} onChange={e => setSelectedDate(e.target.value)} style={{
            padding: "8px 16px", borderRadius: 8, border: "1px solid #e5e7eb",
            fontSize: 13, color: "#374151", background: "#fff", cursor: "pointer"
          }}>
            {dateOptions.map(d => (
              <option key={d.value} value={d.value}>{d.label}</option>
            ))}
          </select>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f9fafb" }}>
              {["날짜", "시간", "이름", "전화번호", "회원번호", "만료일", "남은기간", "회원상태", "관리"].map(h => (
                <th key={h} style={{ padding: "12px 16px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 12, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>로딩 중...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={9} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>출입 기록이 없습니다</td></tr>
            ) : filtered.map((r, i) => {
              const isValid = r.memberships?.length > 0;
              const days = r.end_date ? Math.floor((new Date(r.end_date) - new Date()) / (1000 * 60 * 60 * 24)) : null;
              const isExpired = days !== null && days < 0;
              const isExpiringSoon = days !== null && days >= 0 && days <= 7;
              return (
                <tr key={i} style={{ borderBottom: "1px solid #f3f4f6" }}
                  onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                  onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
                  <td style={{ padding: "14px 16px", color: "#6b7280", fontSize: 13 }}>{r.check_in?.slice(0, 10) || "-"}</td>
                  <td style={{ padding: "14px 16px", color: "#374151", fontFamily: "monospace", fontSize: 13 }}>{r.check_in?.slice(11, 16) || "-"}</td>
                  <td style={{ padding: "14px 16px", fontWeight: 700, color: "#111", fontSize: 14 }}>{r.member_name || "-"}</td>
                  <td style={{ padding: "14px 16px", color: "#374151" }}>{r.phone || "-"}</td>
                  <td style={{ padding: "14px 16px" }}>
                    {r.member_number
                      ? <span style={{ display: "inline-block", background: "#eff6ff", color: "#2563eb", padding: "4px 10px", borderRadius: 6, fontSize: 12, fontWeight: 700, fontFamily: "monospace", letterSpacing: 0.5 }}>{r.member_number}</span>
                      : <span style={{ color: "#9ca3af", fontSize: 12 }}>—</span>}
                  </td>
                  <td style={{ padding: "14px 16px", color: isExpired ? "#ef4444" : isExpiringSoon ? "#f97316" : "#374151", fontWeight: isExpired || isExpiringSoon ? 600 : 400 }}>
                    {r.end_date || "-"}
                  </td>
                  <td style={{ padding: "14px 16px" }}>
                    {days === null
                      ? <span style={{ color: "#d1d5db" }}>-</span>
                      : isExpired
                      ? <span style={{ color: "#ef4444", fontWeight: 700 }}>만료</span>
                      : <span style={{ color: days <= 7 ? "#f97316" : "#374151", fontWeight: days <= 7 ? 700 : 400 }}>D-{days}</span>
                    }
                  </td>
                  <td style={{ padding: "14px 16px" }}>
                    <span style={{
                      background: isValid ? "#dcfce7" : "#f3f4f6",
                      color: isValid ? "#16a34a" : "#6b7280",
                      padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600
                    }}>{isValid ? "활성" : "비회원"}</span>
                  </td>
                  <td style={{ padding: "14px 16px" }}>
                    <button onClick={() => handleCancel(r.id)} style={{
                      background: "none", border: "none", color: "#ef4444",
                      fontSize: 12, fontWeight: 600, cursor: "pointer", padding: "4px 8px",
                      borderRadius: 6, border: "1px solid #fecaca"
                    }}>취소</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const PaymentPage = ({ token, addToast }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("all");
  const [methodFilter, setMethodFilter] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [startDate, setStartDate] = useState(ymdKST().slice(0, 8) + "01");
  const [endDate, setEndDate] = useState(ymdKST());
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [showAddModal, setShowAddModal] = useState(false);
  const [showWizard, setShowWizard] = useState(false);
  const [editTarget, setEditTarget] = useState(null);
  const [saving, setSaving] = useState(false);
  const [members, setMembers] = useState([]);
  const [staff, setStaff] = useState([]);
  const [plans, setPlans] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [modusignTemplates, setModusignTemplates] = useState([]);
  const visitRouteOptions = ["온라인", "지인 소개", "SNS", "현수막", "블로그", "기타"];
  const [showPayFilterPanel, setShowPayFilterPanel] = useState(false);
  const [filterPayStaff, setFilterPayStaff] = useState("");
  const [filterPayPlan, setFilterPayPlan] = useState("");
  const [filterPayMemberType, setFilterPayMemberType] = useState("");
 const [form, setForm] = useState({
    member_id: "", member_search: "", plan_id: "", staff_id: "",
    amount: "", method: "card", status: "approved", memo: ""
  });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/payment/list?tenant_id=1", {}, token);
      setItems(Array.isArray(d) ? d : d.items || []);
    } catch (e) { addToast("결제 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => {
    load();
    api("/members/?tenant_id=1", {}, token).then(d => setMembers(Array.isArray(d) ? d : [])).catch(() => {});
    api("/staff/list?tenant_id=1", {}, token).then(d => setStaff(Array.isArray(d) ? d : [])).catch(() => {});
    api("/membership-plan/list?tenant_id=1", {}, token).then(d => setPlans(Array.isArray(d) ? d : [])).catch(() => {});
    api("/staff/list?tenant_id=1", {}, token).then(d => setTrainers(Array.isArray(d) ? d.filter(s => s.role !== "SUPERADMIN") : [])).catch(() => {});
    api("/contract/template/list", {}, token).then(d => setModusignTemplates(Array.isArray(d) ? d.filter(x => x.is_active !== false) : [])).catch(() => {});
  }, [load]);

  // 월 이동
  const moveMonth = (dir) => {
    const d = new Date(currentMonth);
    d.setMonth(d.getMonth() + dir);
    setCurrentMonth(d);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const lastDay = new Date(y, d.getMonth() + 1, 0).getDate();
    setStartDate(`${y}-${m}-01`);
    setEndDate(`${y}-${m}-${lastDay}`);
  };

  // 필터링
  const filtered = items.filter(item => {
    const matchTab = activeTab === "all" ? true :
      activeTab === "payment" ? item.status === "approved" :
      activeTab === "refund" ? item.status === "cancelled" :
      activeTab === "unpaid" ? (item.status === "pending" || (item.unpaid_amount && Number(item.unpaid_amount) > 0)) : true;
   const matchMethod = methodFilter
  ? (methodFilter === "card"
      ? ["card", "SMARTRO", "PAYNIX", "NANO"].includes(item.method)
      : item.method === methodFilter)
  : true;
    const itemDate = item.created_at?.slice(0, 10);
    const matchDate = (!startDate || itemDate >= startDate) && (!endDate || itemDate <= endDate);
    const matchSearch = searchKeyword
      ? item.member_name?.includes(searchKeyword) || item.staff_name?.includes(searchKeyword)
      : true;
    const matchPayStaff = filterPayStaff ? item.staff_name === filterPayStaff : true;
    const matchPayPlan = filterPayPlan ? item.plan_name === filterPayPlan : true;
    const matchPayMemberType = filterPayMemberType ? (() => {
      const member = members.find(m => m.id === item.member_id);
      if (!member) return false;
      const daysSince = (new Date() - new Date(member.created_at)) / (1000 * 60 * 60 * 24);
      if (filterPayMemberType === "new") return daysSince < 30;
      if (filterPayMemberType === "existing") return daysSince >= 30;
      return true;
    })() : true;
    return matchTab && matchMethod && matchDate && matchSearch && matchPayStaff && matchPayPlan && matchPayMemberType;
  });

  // 통계
 const totalRevenue = filtered.filter(i => i.status === "approved").reduce((s, i) => s + Number(i.amount || 0), 0);
const totalRefund = filtered.filter(i => i.status === "cancelled").reduce((s, i) => s + Number(i.amount || 0), 0);
const cardTotal = filtered.filter(i => (i.method === "card" || i.method === "SMARTRO" || i.method === "PAYNIX" || i.method === "NANO") && i.status === "approved").reduce((s, i) => s + Number(i.amount || 0), 0);
const cashTotal = filtered.filter(i => i.method === "cash" && i.status === "approved").reduce((s, i) => s + Number(i.amount || 0), 0);
const transferTotal = filtered.filter(i => i.method === "transfer" && i.status === "approved").reduce((s, i) => s + Number(i.amount || 0), 0);
const cardCount = filtered.filter(i => (i.method === "card" || i.method === "SMARTRO" || i.method === "PAYNIX" || i.method === "NANO") && i.status === "approved").length;
const cashCount = filtered.filter(i => i.method === "cash" && i.status === "approved").length;
const transferCount = filtered.filter(i => i.method === "transfer" && i.status === "approved").length;
const refundCount = filtered.filter(i => i.status === "cancelled").length;

  const statCards = activeTab === "unpaid" ? [
    { label: "매출", value: "0원", sub: "미납 탭", color: "#fff", valueColor: "#fff", subColor: "rgba(255,255,255,0.8)", bg: "#2563eb" },
    { label: "환불", value: "0원", sub: "환불 0건", color: "#ef4444", valueColor: "#ef4444", subColor: "#9ca3af", bg: "#fff0f0" },
    { label: "카드 결제", value: "0원", sub: "0건", color: "#2563eb", valueColor: "#2563eb", subColor: "#9ca3af", bg: "#f0f4ff" },
    { label: "현금 결제", value: "0원", sub: "0건", color: "#22c55e", valueColor: "#22c55e", subColor: "#9ca3af", bg: "#f0fdf4" },
    { label: "계좌이체", value: "0원", sub: "0건", color: "#8b5cf6", valueColor: "#8b5cf6", subColor: "#9ca3af", bg: "#f5f3ff" },
  ] : [
    { label: "매출", value: `${totalRevenue.toLocaleString()}원`, sub: "전달 대비 1.8% 증가", color: "#fff", valueColor: "#fff", subColor: "rgba(255,255,255,0.8)", bg: "#2563eb" },
    { label: "환불", value: `${totalRefund.toLocaleString()}원`, sub: `환불 ${refundCount}건`, color: "#ef4444", valueColor: "#ef4444", subColor: "#9ca3af", bg: "#fff0f0" },
    { label: "카드 결제", value: `${cardTotal.toLocaleString()}원`, sub: `${cardCount}건`, color: "#2563eb", valueColor: "#2563eb", subColor: "#9ca3af", bg: "#f0f4ff" },
    { label: "현금 결제", value: `${cashTotal.toLocaleString()}원`, sub: `${cashCount}건`, color: "#22c55e", valueColor: "#22c55e", subColor: "#9ca3af", bg: "#f0fdf4" },
    { label: "계좌이체", value: `${transferTotal.toLocaleString()}원`, sub: `${transferCount}건`, color: "#8b5cf6", valueColor: "#8b5cf6", subColor: "#9ca3af", bg: "#f5f3ff" },
  ];

  const handleExcel = () => {
    const headers = ["결제일시", "회원명", "상품", "담당자", "금액", "결제방법", "구분"];
    const rows = filtered.map(i => [
      i.created_at?.slice(0, 16).replace("T", " "),
      i.member_name || "-", i.plan_name || "-", i.staff_name || "-",
      `${Number(i.amount || 0).toLocaleString()}원`,
      i.method === "cash" ? "현금" : i.method === "transfer" ? "계좌이체" : "카드",
      i.status === "approved" ? "결제" : i.status === "cancelled" ? "환불" : "미납"
    ]);
    const csv = [headers, ...rows].map(r => r.join(",")).join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "결제내역.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  const handleAddPayment = async () => {
    if (!form.member_id || !form.amount) return addToast("회원과 금액은 필수입니다", "error");
    setSaving(true);
    try {
      await api("/payment", {
        method: "POST",
        body: JSON.stringify({
  tenant_id: 1,
  member_id: form.member_id && form.member_id !== "0" ? parseInt(form.member_id) : null,
  plan_id: form.plan_id ? parseInt(form.plan_id) : null,
  staff_id: form.staff_id ? parseInt(form.staff_id) : null,
  amount: parseInt(form.amount),
  method: form.method,
  payment_type: form.payment_type || "신규",
  status: form.status,
  memo: form.memo,
  payer_name: form.member_search || null
})
      }, token);
      addToast("결제가 등록되었습니다", "success");
      setShowAddModal(false);
      setForm({ member_id: "", member_search: "", plan_id: "", staff_id: "", amount: "", method: "card", status: "approved", memo: "", payment_type: "신규" });
      load();
    } catch (e) { addToast("등록 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };
  const handleEditPayment = async () => {
  if (!editTarget) return;
  setSaving(true);
  try {
    await api(`/payment/${editTarget.id}?tenant_id=1`, {
      method: "PUT",
      body: JSON.stringify({
        method: form.method,
        payment_type: form.payment_type || "신규",
        status: form.status,
        memo: form.memo,
      })
    }, token);
    addToast("수정됐습니다", "success");
    setShowAddModal(false);
    setEditTarget(null);
    setForm({ member_id: "", member_search: "", plan_id: "", staff_id: "", amount: "", method: "card", status: "approved", memo: "" });
    load();
  } catch (e) { addToast("수정 실패: " + e.message, "error"); }
  finally { setSaving(false); }
};

  const statusBadge = (s) => {
    const map = { approved: { label: "결제", color: "#22c55e" }, cancelled: { label: "환불", color: "#ef4444" }, pending: { label: "미납", color: "#9ca3af" } };
    const m = map[s] || { label: s || "—", color: "#9ca3af" };
    return <Badge label={m.label} color={m.color} />;
  };

  const methodLabel = (m) => {
  const map = {
    card: { label: "카드", color: "#2563eb" },
    SMARTRO: { label: "카드", color: "#2563eb" },
    PAYNIX: { label: "카드", color: "#2563eb" },
    NANO: { label: "카드", color: "#2563eb" },
    cash: { label: "현금", color: "#22c55e" },
    transfer: { label: "계좌이체", color: "#f97316" }
    };
    const meta = map[m];
    if (!meta) return <span style={{ color: "#9ca3af" }}>—</span>;
    return <span style={{ color: meta.color, fontWeight: 600 }}>{meta.label}</span>;
  };

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ color: "#9ca3af", fontSize: 18 }}>‹</span>
          <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>결제내역</h2>
        </div>
      </div>

      {/* 상단 통계 카드 */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
        {statCards.map((c, i) => (
          <div key={i} style={{
            flex: i === 0 ? 1.5 : 1, borderRadius: 14, padding: "20px 24px",
            background: c.bg, border: `1px solid ${c.color}22`
          }}>
            <div style={{ fontSize: 13, color: i === 0 ? "rgba(255,255,255,0.85)" : "#6b7280", marginBottom: 8 }}>{c.label}</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: c.valueColor, marginBottom: 4 }}>{c.value}</div>
            <div style={{ fontSize: 12, color: c.subColor }}>{c.sub}</div>
          </div>
        ))}
      </div>

      {/* 필터 + 버튼 */}
      <div style={{ background: "#fff", borderRadius: 14, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20, flexWrap: "wrap" }}>
          {/* 월 네비게이션 */}
          <div style={{ display: "flex", alignItems: "center", gap: 6, border: "1px solid #e5e7eb", borderRadius: 8, padding: "6px 12px" }}>
            <button onClick={() => moveMonth(-1)} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151", fontSize: 16 }}>‹</button>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#374151", minWidth: 80, textAlign: "center" }}>
              {currentMonth.getFullYear()}년 {currentMonth.getMonth() + 1}월
            </span>
            <button onClick={() => moveMonth(1)} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151", fontSize: 16 }}>›</button>
          </div>

          {/* 탭 */}
          {[{ id: "all", label: "전체" }, { id: "payment", label: "결제" }, { id: "refund", label: "환불" }, { id: "unpaid", label: "미납" }].map(t => (
            <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
              padding: "8px 18px", borderRadius: 20, border: `1px solid ${activeTab === t.id ? "#2563eb" : "#e5e7eb"}`,
              background: activeTab === t.id ? "#2563eb" : "#fff",
              color: activeTab === t.id ? "#fff" : "#374151",
              fontSize: 13, fontWeight: activeTab === t.id ? 700 : 500, cursor: "pointer"
            }}>{t.label}</button>
          ))}

          {/* 결제수단 */}
          <select value={methodFilter} onChange={e => setMethodFilter(e.target.value)} style={{
            padding: "8px 14px", borderRadius: 8, border: "1px solid #e5e7eb",
            fontSize: 13, color: "#374151", background: "#fff", cursor: "pointer"
          }}>
            <option value="">전체 수단</option>
            <option value="card">카드</option>
            <option value="cash">현금</option>
            <option value="transfer">계좌이체</option>
          </select>

          {/* 날짜 */}
          <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)}
            style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, color: "#374151" }} />
          <span style={{ color: "#9ca3af" }}>—</span>
          <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)}
    style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, color: "#374151" }} />
<div style={{ position: "relative", display: "flex", gap: 0 }}>
  <input
    value={searchKeyword}
    onChange={e => setSearchKeyword(e.target.value)}
    onKeyDown={e => e.key === "Enter" && load()}
    placeholder="회원명/담당자를 입력해주세요"
    style={{
      padding: "8px 12px", borderRadius: "8px 0 0 8px",
      border: "1px solid #e5e7eb", borderRight: "none",
      fontSize: 13, outline: "none", width: 220, color: "#374151"
    }}
  />
  <button onClick={load} style={{
    padding: "8px 16px", borderRadius: "0 8px 8px 0",
    border: "1px solid #e5e7eb", background: "#fff",
    color: "#374151", fontSize: 13, fontWeight: 600, cursor: "pointer"
  }}>검색</button>
</div>

          {/* 버튼들 */}
          <div style={{ marginLeft: "auto", display: "flex", gap: 10 }}>
            {(() => {
              const activeFilters = [filterPayStaff, filterPayPlan, filterPayMemberType].filter(Boolean).length;
              return (
                <button onClick={() => setShowPayFilterPanel(p => !p)} style={{
                  display: "flex", alignItems: "center", gap: 6, padding: "9px 14px",
                  borderRadius: 8, border: `1.5px solid ${showPayFilterPanel || activeFilters > 0 ? "#2563eb" : "#e5e7eb"}`,
                  background: showPayFilterPanel || activeFilters > 0 ? "#eff6ff" : "#fff",
                  color: showPayFilterPanel || activeFilters > 0 ? "#2563eb" : "#374151",
                  fontSize: 13, fontWeight: 600, cursor: "pointer"
                }}>
                  <Icon name="settings" size={14} color={showPayFilterPanel || activeFilters > 0 ? "#2563eb" : "#6b7280"} />
                  필터
                  {activeFilters > 0 && (
                    <span style={{ background: "#2563eb", color: "#fff", fontSize: 10, fontWeight: 700, padding: "1px 6px", borderRadius: 10 }}>{activeFilters}</span>
                  )}
                </button>
              );
            })()}
            <button onClick={handleExcel} style={{
              display: "flex", alignItems: "center", gap: 6, padding: "9px 18px",
              background: "#22c55e", color: "#fff", border: "none", borderRadius: 8,
              fontSize: 13, fontWeight: 600, cursor: "pointer"
            }}>
              <Icon name="check" size={14} color="#fff" /> 엑셀 다운로드
            </button>
            <button onClick={() => setShowWizard(true)} style={{
              display: "flex", alignItems: "center", gap: 6, padding: "9px 18px",
              background: "#2563eb", color: "#fff", border: "none", borderRadius: 8,
              fontSize: 13, fontWeight: 600, cursor: "pointer"
            }}>
              <Icon name="plus" size={14} color="#fff" /> 추가 결제 등록
            </button>
          </div>
        </div>

        {/* 결제 필터 패널 */}
        {showPayFilterPanel && (
          <div style={{ background: "#f9fafb", borderRadius: 10, padding: "14px 16px", marginBottom: 14, border: "0.5px solid #e5e7eb" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 10 }}>
              <div>
                <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 600 }}>상담사 (매출귀속)</div>
                <select value={filterPayStaff} onChange={e => setFilterPayStaff(e.target.value)}
                  style={{ width: "100%", padding: "8px 10px", borderRadius: 7, border: `1.5px solid ${filterPayStaff ? "#2563eb" : "#e5e7eb"}`, fontSize: 12, background: filterPayStaff ? "#eff6ff" : "#fff", color: filterPayStaff ? "#1d4ed8" : "#374151", cursor: "pointer" }}>
                  <option value="">전체</option>
                  {staff.filter(s => s.role !== "SUPERADMIN").map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                </select>
              </div>
              <div>
                <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 600 }}>상품명</div>
                <select value={filterPayPlan} onChange={e => setFilterPayPlan(e.target.value)}
                  style={{ width: "100%", padding: "8px 10px", borderRadius: 7, border: `1.5px solid ${filterPayPlan ? "#2563eb" : "#e5e7eb"}`, fontSize: 12, background: filterPayPlan ? "#eff6ff" : "#fff", color: filterPayPlan ? "#1d4ed8" : "#374151", cursor: "pointer" }}>
                  <option value="">전체</option>
                  {[...new Set(items.map(i => i.plan_name).filter(Boolean))].sort().map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
              <div>
                <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4, fontWeight: 600 }}>회원 구분</div>
                <select value={filterPayMemberType} onChange={e => setFilterPayMemberType(e.target.value)}
                  style={{ width: "100%", padding: "8px 10px", borderRadius: 7, border: `1.5px solid ${filterPayMemberType ? "#2563eb" : "#e5e7eb"}`, fontSize: 12, background: filterPayMemberType ? "#eff6ff" : "#fff", color: filterPayMemberType ? "#1d4ed8" : "#374151", cursor: "pointer" }}>
                  <option value="">전체</option>
                  <option value="new">신규 (가입 1개월 미만)</option>
                  <option value="existing">기존 (가입 1개월 이상)</option>
                </select>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button onClick={() => { setFilterPayStaff(""); setFilterPayPlan(""); setFilterPayMemberType(""); }}
                style={{ padding: "6px 14px", background: "none", border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12, color: "#6b7280", cursor: "pointer" }}>
                초기화
              </button>
            </div>
          </div>
        )}

                {/* 테이블 */}
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr>
              {["결제 일시", "회원명", "상품", "담당자", "금액", "결제 방법", "구분", "전표 / 환불"].map(h => (
                <th key={h} style={{
                  padding: "10px 16px", textAlign: "left",
                  color: "#9ca3af", fontWeight: 600, fontSize: 12,
                  borderBottom: "1px solid #f3f4f6"
                }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>로딩 중...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={8} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>결제 내역이 없습니다</td></tr>
            ) : filtered.map((item, i) => (
  <tr key={i} style={{
    borderBottom: "1px solid #f9fafb",
    background: item.status === "cancelled" ? "#fff5f5" : "transparent",
    opacity: item.status === "cancelled" ? 0.8 : 1
  }}
    onMouseEnter={e => e.currentTarget.style.background = item.status === "cancelled" ? "#ffe4e4" : "#f9fafb"}
    onMouseLeave={e => e.currentTarget.style.background = item.status === "cancelled" ? "#fff5f5" : "transparent"}>
    <td style={{ padding: "14px 16px", color: "#6b7280" }}>
      {item.created_at ? (() => {
        const _s = item.created_at.endsWith("Z") || item.created_at.includes("+") ? item.created_at : item.created_at.replace(" ", "T") + "+09:00";
        const d = new Date(_s);
        return d.toLocaleString("ko-KR", { timeZone: "Asia/Seoul", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false });
      })() : "-"}
    </td>
    <td style={{ padding: "14px 16px", fontWeight: 600, color: "#111" }}>{item.member_name || item.payerName || "—"}</td>
    <td style={{ padding: "14px 16px", color: "#374151" }}>{item.plan_name || "—"}</td>
    <td style={{ padding: "14px 16px", color: "#374151" }}>{item.staff_name || "—"}</td>
    <td style={{ padding: "14px 16px", fontWeight: 700, color: item.status === "cancelled" ? "#ef4444" : (activeTab === "unpaid" || (item.unpaid_amount && Number(item.unpaid_amount) > 0 && item.status !== "cancelled")) ? "#f97316" : "#111" }}>
      {item.status === "cancelled" && <span style={{ fontSize: 11, marginRight: 4 }}>-</span>}
      {activeTab === "unpaid"
        ? (item.status === "pending"
            ? Number(item.amount || 0).toLocaleString()
            : Number(item.unpaid_amount || 0).toLocaleString())
        : Number(item.amount || 0).toLocaleString()}원
    </td>
    <td style={{ padding: "14px 16px", color: "#374151" }}>{methodLabel(item.method)}</td>
    <td style={{ padding: "14px 16px" }}>{statusBadge(item.status)}</td>
    <td style={{ padding: "14px 16px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* 전표 버튼 */}
        {item.transactionId && (
          <button
            onClick={() => {
              if (item.method === 'SMARTRO') {
                window.open(`https://pay.smartropay.co.kr/receipt/${item.transactionId}`, "_blank");
              } else {
                window.open(`https://wpay.mostpns.co.kr/receipt/${item.transactionId}`, "_blank");
              }
            }}
            style={{
              padding: "4px 10px", borderRadius: 6, border: "1px solid #e5e7eb",
              background: "#f9fafb", color: "#374151", fontSize: 11, fontWeight: 600,
              cursor: "pointer", textAlign: "center"
            }}>
            🧾 전표
          </button>
        )}

        {/* 환불 버튼 또는 환불완료 배지 */}
        {item.status === "approved" ? (
          <button
            onClick={async () => {
              if (!window.confirm(`${Number(item.amount).toLocaleString()}원을 환불하시겠습니까?`)) return;
              try {
                if (item.transactionId) {
                  const transactionDay = item.created_at?.slice(0, 10)?.replace(/-/g, "") || "";
                  await api("/payment/cancel", {
                    method: "POST",
                    body: JSON.stringify({
                      tenant_id: 1,
                      payment_id: item.id,
                      rootTransactionId: item.transactionId,
                      rootTransactionDay: transactionDay,
                      rootTrackId: item.trackId || "",
                      amount: String(item.amount),
                    })
                  }, token);
                } else {
                  await api(`/payment/${item.id}?tenant_id=1`, {
                    method: "PUT",
                    body: JSON.stringify({ status: "cancelled" })
                  }, token);
                }
                addToast("환불 처리됐습니다", "success");
                load();
              } catch(e) { addToast("환불 실패: " + e.message, "error"); }
            }}
            style={{
              padding: "4px 10px", borderRadius: 6, border: "1px solid #fecaca",
              background: "#fff0f0", color: "#ef4444", fontSize: 11, fontWeight: 600,
              cursor: "pointer", textAlign: "center"
            }}>
            💸 환불
          </button>
        ) : item.status === "cancelled" ? (
          <span style={{
            padding: "4px 10px", borderRadius: 6,
            background: "#f3f4f6", color: "#9ca3af",
            fontSize: 11, fontWeight: 600, textAlign: "center"
          }}>
            ✓ 환불완료
          </span>
        ) : null}
      </div>
    </td>
  </tr>
))}
          </tbody>
        </table>
      </div>

<PaymentWizard
        open={showWizard}
        onClose={() => setShowWizard(false)}
        onSuccess={load}
        defaultMember={null}
        token={token}
        addToast={addToast}
        plans={plans}
        trainers={trainers}
        modusignTemplates={modusignTemplates}
        visitRouteOptions={visitRouteOptions}
        members={members}
      />
     
    </div>
  );
};

// 그룹수업 정산 모달 (월·강사별: 출석 인원 → 만석/미달 → 강사 몫)
function GroupSettlementModal({ staff, token, addToast, onClose }) {
  const now = new Date();
  const [ym, setYm] = React.useState({ year: now.getFullYear(), month: now.getMonth() + 1 });
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const fmtWon = n => (n || 0).toLocaleString() + "원";
  const load = React.useCallback(async () => {
    setLoading(true);
    try {
      const d = await api(`/staff/${staff.id}/group-settlement?year=${ym.year}&month=${ym.month}`, {}, token);
      setData(d);
    } catch (e) { addToast("정산 조회 실패: " + (e.message || ""), "error"); setData(null); }
    setLoading(false);
  }, [staff.id, ym.year, ym.month, token]);
  React.useEffect(() => { load(); }, [load]);
  const shift = (dir) => setYm(p => {
    let y = p.year, m = p.month + dir;
    if (m < 1) { m = 12; y -= 1; }
    if (m > 12) { m = 1; y += 1; }
    return { year: y, month: m };
  });
  const [showGroup, setShowGroup] = React.useState(false);
  const navBtn = { width: 34, height: 34, borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer", fontSize: 16, color: "#6b7280" };
  const incLabel = (d) => {
    if (!d) return "";
    if (d.incentive_type === "per_session") return `개인수업 ${d.pt_sessions}회 × ${(d.incentive_value || 0).toLocaleString()}원`;
    if (d.incentive_type === "revenue_rate") return `매출 ${fmtWon(d.revenue)} × ${d.incentive_value || 0}%`;
    if (d.incentive_type === "fee_rate") return `수업료(매출) ${fmtWon(d.revenue)} × ${d.incentive_value || 0}%`;
    return "-";
  };
  const groupLabel = data ? (
    data.group_pay_type === "amount" ? `고정금액 (만석 ${(data.group_full_value || 0).toLocaleString()}원 / 미달 ${(data.group_partial_value || 0).toLocaleString()}원)`
    : data.group_pay_type === "rate" ? `수업료의 % (만석 ${data.group_full_value}% / 미달 ${data.group_partial_value}%)`
    : "미설정 (급여설정에서 설정)"
  ) : "";
  const Row = ({ label, sub, amount, muted }) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 2px", borderBottom: "1px solid #f3f4f6" }}>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: muted ? "#9ca3af" : "#111" }}>{label}</div>
        {sub ? <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>{sub}</div> : null}
      </div>
      <div style={{ fontSize: 15, fontWeight: 700, color: muted ? "#9ca3af" : "#374151", whiteSpace: "nowrap" }}>{fmtWon(amount)}</div>
    </div>
  );
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, padding: 24, width: 640, maxWidth: "94vw", maxHeight: "88vh", overflow: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <h3 style={{ margin: 0, fontSize: 18, color: "#111" }}>{staff.name} · 월 급여 정산</h3>
          <span onClick={onClose} style={{ cursor: "pointer", color: "#9ca3af", fontSize: 20 }}>✕</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, marginBottom: 16 }}>
          <button onClick={() => shift(-1)} style={navBtn}>‹</button>
          <span style={{ fontSize: 16, fontWeight: 700, minWidth: 120, textAlign: "center" }}>{ym.year}년 {ym.month}월</span>
          <button onClick={() => shift(1)} style={navBtn}>›</button>
        </div>
        {loading || !data ? (
          <div style={{ textAlign: "center", padding: 30, color: "#9ca3af" }}>불러오는 중...</div>
        ) : (
          <>
            <div style={{ background: "linear-gradient(135deg,#4f46e5,#db2777)", borderRadius: 14, padding: "18px 22px", marginBottom: 16, color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 14, fontWeight: 600, opacity: 0.95 }}>{ym.month}월 총 지급액</span>
              <span style={{ fontSize: 26, fontWeight: 800 }}>{fmtWon(data.grand_total)}</span>
            </div>
            <div>
              <Row label="기본급" amount={data.base_salary} />
              <Row label="개인수업 인센티브" sub={incLabel(data)} amount={data.pt_incentive} />
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 2px", borderBottom: "1px solid #f3f4f6" }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: "#111" }}>그룹수업 정산
                    {data.group_occurrences > 0 && (
                      <span onClick={() => setShowGroup(v => !v)} style={{ fontSize: 11, color: "#2563eb", cursor: "pointer", marginLeft: 6 }}>{showGroup ? "접기 ▲" : `세부 ${data.group_occurrences}회차 ▼`}</span>
                    )}
                  </div>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>{groupLabel}</div>
                </div>
                <div style={{ fontSize: 15, fontWeight: 700, color: "#374151", whiteSpace: "nowrap" }}>{fmtWon(data.group_total)}</div>
              </div>
              {showGroup && data.group_rows && data.group_rows.length > 0 && (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, margin: "6px 0 10px", background: "#fafafa" }}>
                  <thead><tr style={{ color: "#9ca3af", fontSize: 10 }}>{["날짜", "시간", "수업", "출석/정원", "구분", "정산액"].map(h => <th key={h} style={{ textAlign: "left", padding: "6px 8px" }}>{h}</th>)}</tr></thead>
                  <tbody>
                    {data.group_rows.map((r, i) => (
                      <tr key={i} style={{ borderTop: "1px solid #f3f4f6" }}>
                        <td style={{ padding: "6px 8px", whiteSpace: "nowrap" }}>{r.date.slice(5)}</td>
                        <td style={{ padding: "6px 8px" }}>{r.start_time}</td>
                        <td style={{ padding: "6px 8px", fontWeight: 600, color: "#111" }}>{r.lesson_name}</td>
                        <td style={{ padding: "6px 8px" }}>{r.attended}/{r.capacity}</td>
                        <td style={{ padding: "6px 8px" }}><span style={{ background: r.is_full ? "#dcfce7" : "#fef3c7", color: r.is_full ? "#166534" : "#92400e", padding: "1px 7px", borderRadius: 999, fontSize: 10, fontWeight: 700 }}>{r.is_full ? "만석" : "미달"}</span></td>
                        <td style={{ padding: "6px 8px", fontWeight: 700, color: "#db2777", whiteSpace: "nowrap" }}>{fmtWon(r.amount)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              <Row label="보너스" sub={data.bonus_target > 0 ? (data.revenue >= data.bonus_target ? `목표 ${fmtWon(data.bonus_target)} 달성 → 매출 ${data.bonus_rate}%` : `목표 ${fmtWon(data.bonus_target)} 미달`) : "미설정"} amount={data.bonus} />
              <Row label="이 달 매출 (참고)" sub="담당 강사로 등록된 결제 합계 · 급여 합산 아님" amount={data.revenue} muted />
            </div>
            <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 12, lineHeight: 1.6 }}>
              💡 총 지급액 = 기본급 + 개인수업 인센티브 + 그룹수업 정산 + 보너스<br />
              출석 인원 = 취소 제외 예약(노쇼 포함) · 매출은 '판매 담당 강사'로 등록된 결제 기준
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// 직원 등록 //
const StaffPage = ({ token, addToast, setPage, setSimpleMode }) => {
  const [staff, setStaff] = useState([]);
  const [quickMember, setQuickMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [settleStaff, setSettleStaff] = useState(null);   // 그룹수업 정산 모달 대상
  const [editTarget, setEditTarget] = useState(null);
  const [saving, setSaving] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteFinal, setDeleteFinal] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [showStaffMembersModal, setShowStaffMembersModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [staffMembers, setStaffMembers] = useState([]);
  const [staffMembersLoading, setStaffMembersLoading] = useState(false);
  const [staffMembersSearch, setStaffMembersSearch] = useState("");
  const [tempCredential, setTempCredential] = useState(null); // 임시 비번 표시 모달
  // JWT에서 본인 staff_id 추출
  const currentStaffId = (() => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.staff_id || payload.sub || null;
    } catch {
      return null;
    }
  })();
  const [form, setForm] = useState({
    name: "", phone: "", email: "", position: "", join_date: "",
    color: "", work_schedules: [{ days: [], start: "", end: "" }], booking_schedules: [{ days: [], start: "", end: "" }], memo: "", role: "TRAINER",
    base_salary: "", incentive_type: "per_session", incentive_value: "", bonus_target: "", bonus_rate: "",
    group_pay_type: "", group_full_value: "", group_partial_value: "",
    slogan: "", certifications: "", bio: ""
  });

  const COLORS = [
    "#2563eb", "#16a34a", "#7c3aed", "#38bdf8", "#4ade80", "#fbbf24",
    "#f87171", "#f472b6", "#a78bfa", "#9ca3af", "#ef4444", "#ec4899",
    "#d946ef", "#f97316", "#22c55e", "#4f46e5", "#92400e", "#14b8a6",
    "#1e3a5f", "#eab308", "#06b6d4", "#db2777", "#84cc16", "#15803d"
  ];

  const DAYS = ["월", "화", "수", "목", "금", "토", "일"];

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/staff/list?tenant_id=1", {}, token);
      setStaff(Array.isArray(d) ? d : d.items || []);
    } catch (e) { addToast("직원 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { load(); }, [load]);

 const resetForm = () => setForm({
    name: "", phone: "", email: "", position: "", join_date: "",
    color: "", work_schedules: [{ days: [], start: "", end: "" }], booking_schedules: [{ days: [], start: "", end: "" }], memo: "", role: "TRAINER",
    base_salary: "", incentive_type: "per_session", incentive_value: "", bonus_target: "", bonus_rate: "",
    group_pay_type: "", group_full_value: "", group_partial_value: "",
    slogan: "", certifications: "", bio: ""
  });

  const handleCreate = async () => {
    if (!form.name || !form.phone) return addToast("이름과 전화번호는 필수입니다", "error");
    if (!form.email) return addToast("이메일은 필수입니다 (로그인 아이디)", "error");
    const phoneDigits = form.phone.replace(/\D/g, "");
    if (phoneDigits.length < 4) return addToast("휴대폰 번호를 정확히 입력해주세요", "error");

    setSaving(true);
    try {
      const res = await api("/staff", {
        method: "POST",
        body: JSON.stringify({
          tenant_id: 1,
          name: form.name,
          phone: form.phone,
          email: form.email,
          position: form.position,
          join_date: form.join_date,
          color: form.color,
          work_schedules: JSON.stringify(form.work_schedules),
          booking_schedules: JSON.stringify(form.booking_schedules),
          memo: form.memo,
          role: form.role,
          base_salary: form.base_salary ? Number(form.base_salary) : 0,
          incentive_type: form.incentive_type || "per_session",
          incentive_value: form.incentive_value ? Number(form.incentive_value) : 0,
          bonus_target: form.bonus_target ? Number(form.bonus_target) : 0,
          bonus_rate: form.bonus_rate ? Number(form.bonus_rate) : 0,
          group_pay_type: form.group_pay_type || null,
          group_full_value: form.group_full_value ? Number(form.group_full_value) : 0,
          group_partial_value: form.group_partial_value ? Number(form.group_partial_value) : 0,
          slogan: form.slogan,
          certifications: form.certifications,
          bio: form.bio
        })
      }, token);

      // 임시 비번 모달 띄우기
      setTempCredential({
        email: form.email,
        password: res.temp_password
      });

      setShowModal(false);
      resetForm();
      load();
    } catch (e) { addToast("등록 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };
const handleEdit = async () => {
  if (!form.name || !form.phone) return addToast("이름과 전화번호는 필수입니다", "error");
  setSaving(true);
 try {
    await api(`/staff/${editTarget.id}?tenant_id=1`, {
      method: "PUT",
      body: JSON.stringify({
        name: form.name,
        phone: form.phone,
        email: form.email,
        position: form.position,
        join_date: form.join_date,
        color: form.color,
        work_schedules: JSON.stringify(form.work_schedules),
        booking_schedules: JSON.stringify(form.booking_schedules),
        memo: form.memo,
        role: form.role,
        base_salary: parseInt(form.base_salary) || 0,
        incentive_type: form.incentive_type || "per_session",
        incentive_value: parseInt(form.incentive_value) || 0,
        bonus_target: parseInt(form.bonus_target) || 0,
        bonus_rate: parseInt(form.bonus_rate) || 0,
        group_pay_type: form.group_pay_type || null,
        group_full_value: parseInt(form.group_full_value) || 0,
        group_partial_value: parseInt(form.group_partial_value) || 0,
        slogan: form.slogan,
        certifications: form.certifications,
        bio: form.bio
      })
    }, token);
    addToast("수정됐습니다", "success");
    setShowModal(false);
    setEditTarget(null);
    resetForm();
    load();
  } catch (e) { addToast("수정 실패: " + e.message, "error"); }
  finally { setSaving(false); }
};
  const toggleDay = (day) => {
    setForm(p => ({
      ...p,
      work_days: p.work_days.includes(day)
        ? p.work_days.filter(d => d !== day)
        : [...p.work_days, day]
    }));
  };
  const handleStaffClick = async (s) => {
    setSelectedStaff(s);
    setShowStaffMembersModal(true);
    setStaffMembersLoading(true);
    try {
      const d = await api(`/members/?staff_id=${s.id}`, {}, token);
      setStaffMembers(Array.isArray(d) ? d : []);
    } catch (e) { addToast("회원 로드 실패: " + e.message, "error"); }
    finally { setStaffMembersLoading(false); }
  };

  const handleDelete = async (staffId) => {
    setDeleting(true);
    try {
      await api(`/staff/${staffId}`, { method: "DELETE" }, token);
      addToast("직원이 삭제되었습니다", "success");
      setDeleteFinal(null);
      load();
    } catch (e) {
      addToast("삭제 실패: " + e.message, "error");
    } finally {
      setDeleting(false);
    }
  };

  // 통계
 const totalCount = staff.length;
  const activeCount = staff.filter(s => s.is_active).length;
  const offCount = staff.filter(s => !s.is_active).length;
  const leaveCount = staff.filter(s => s.position?.includes("휴가") || s.memo?.includes("휴가")).length;

  const statCards = [
    { label: "전체 직원", value: `${totalCount}명`, color: "#2563eb", bg: "#eff6ff" },
    { label: "근무자", value: `${activeCount}명`, color: "#22c55e", bg: "#f0fdf4" },
    { label: "휴무자", value: `${offCount}명`, color: "#f97316", bg: "#fff7ed" },
    { label: "휴가자", value: `${leaveCount}명`, color: "#8b5cf6", bg: "#f5f3ff" },
  ];

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ color: "#9ca3af", fontSize: 18 }}>‹</span>
          <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>직원관리</h2>
        </div>
        <button onClick={() => setShowModal(true)} style={{
          display: "flex", alignItems: "center", gap: 6, padding: "10px 20px",
          background: "#2563eb", color: "#fff", border: "none", borderRadius: 10,
          fontSize: 14, fontWeight: 700, cursor: "pointer"
        }}>
          <Icon name="members" size={14} color="#fff" /> 신규 직원 등록
        </button>
      </div>



      {/* 테이블 */}
      <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f9fafb" }}>
              {["이름", "직급", "전화번호", "이메일", "근무 요일", "근무 시간", "작업"].map(h => (
                <th key={h} style={{ padding: "12px 16px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 12, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>로딩 중...</td></tr>
            ) : staff.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>등록된 직원이 없습니다</td></tr>
           ) : staff.map((s, i) => (
              <tr key={i} onClick={() => handleStaffClick(s)} style={{ borderBottom: "1px solid #f9fafb", cursor: "pointer" }}
                onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
                <td style={{ padding: "14px 16px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{
                      width: 10, height: 10, borderRadius: "50%",
                      background: s.color || "#9ca3af", flexShrink: 0
                    }} />
                    <span style={{ fontWeight: 700, color: "#111", fontSize: 15 }}>{s.name}</span>
                  </div>
                </td>
                <td style={{ padding: "14px 16px", color: "#374151" }}>
  {s.position || ({ TRAINER: "트레이너", MANAGER: "관리자", RECEPTION: "리셉션", OWNER: "오너", SUPERADMIN: "슈퍼관리자", STAFF: "스태프" }[s.role]) || "-"}
</td>
                <td style={{ padding: "14px 16px", color: "#374151" }}>{s.phone || "-"}</td>
                <td style={{ padding: "14px 16px", color: "#374151" }}>{s.email || "-"}</td>
                <td style={{ padding: "14px 16px", color: "#374151" }}>
                  {s.work_schedules ? (() => {
                    try {
                      const sc = JSON.parse(s.work_schedules);
                      return sc.map((x, i) => <div key={i}>{x.days.join("·")}</div>);
                    } catch { return s.work_days?.replace(/,/g, "·") || "-"; }
                  })() : s.work_days?.replace(/,/g, "·") || "-"}
                </td>
                <td style={{ padding: "14px 16px", color: "#374151" }}>
                  {s.work_schedules ? (() => {
                    try {
                      const sc = JSON.parse(s.work_schedules);
                      return sc.map((x, i) => <div key={i}>{x.start && x.end ? `${x.start}-${x.end}` : "-"}</div>);
                    } catch { return s.work_start && s.work_end ? `${s.work_start}-${s.work_end}` : "-"; }
                  })() : s.work_start && s.work_end ? `${s.work_start}-${s.work_end}` : "-"}
                </td>
<td style={{ padding: "14px 16px" }}>
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <button onClick={e => {
                      e.stopPropagation();
                      setEditTarget(s);
                      setForm({
                        name: s.name || "",
                        phone: s.phone || "",
                        email: s.email || "",
                        position: s.position || "",
                        join_date: s.join_date || "",
                        color: s.color || "",
                        role: s.role || "TRAINER",
                        work_schedules: s.work_schedules ? JSON.parse(s.work_schedules) : [{ days: [], start: "", end: "" }],
                        booking_schedules: s.booking_schedules ? JSON.parse(s.booking_schedules) : [{ days: [], start: "", end: "" }],
                        memo: s.memo || "",
                        base_salary: String(s.base_salary || ""),
                        incentive_type: s.incentive_type || "per_session",
                        incentive_value: String(s.incentive_value || ""),
                        bonus_target: String(s.bonus_target || ""),
                        bonus_rate: String(s.bonus_rate || ""),
                        group_pay_type: s.group_pay_type || "",
                        group_full_value: String(s.group_full_value || ""),
                        group_partial_value: String(s.group_partial_value || ""),
                        slogan: s.slogan || "",
                        certifications: s.certifications || "",
                        bio: s.bio || ""
                      });
                      setShowModal(true);
                    }} style={{ background: "none", border: "none", color: "#2563eb", fontSize: 13, fontWeight: 600, cursor: "pointer", padding: 0 }}>편집</button>

                    <span style={{ color: "#e5e7eb" }}>|</span>
                    <button onClick={e => { e.stopPropagation(); setSettleStaff(s); }}
                      style={{ background: "none", border: "none", color: "#db2777", fontSize: 13, fontWeight: 600, cursor: "pointer", padding: 0 }}>정산</button>

                    {String(currentStaffId) !== String(s.id) && (
                      <>
                        <span style={{ color: "#e5e7eb" }}>|</span>
                        <button onClick={e => { e.stopPropagation(); setDeleteTarget(s); }}
                          style={{ background: "none", border: "none", color: "#ef4444", fontSize: 13, fontWeight: 600, cursor: "pointer", padding: 0 }}>삭제</button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {settleStaff && (
        <GroupSettlementModal staff={settleStaff} token={token} addToast={addToast} onClose={() => setSettleStaff(null)} />
      )}

      {tempCredential && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.5)", display: "flex",
          alignItems: "center", justifyContent: "center", zIndex: 1000
        }}>
          <div style={{
            background: "#fff", borderRadius: 16, padding: 32, maxWidth: 480, width: "90%",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
              <div style={{
                width: 44, height: 44, borderRadius: "50%", background: "#dcfce7",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 22, color: "#16a34a", fontWeight: 700
              }}>✓</div>
              <div>
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#111" }}>스태프 등록 완료</h3>
                <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6b7280" }}>아래 정보를 스태프에게 전달해주세요</p>
              </div>
            </div>

            <div style={{
              background: "#f9fafb", borderRadius: 10, padding: 16, marginBottom: 16,
              border: "1px solid #f3f4f6"
            }}>
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>아이디 (이메일)</div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{
                    flex: 1, padding: "10px 12px", background: "#fff", borderRadius: 8,
                    border: "1px solid #e5e7eb", fontSize: 14, fontFamily: "monospace", color: "#111"
                  }}>{tempCredential.email}</div>
                  <button onClick={() => {
                    navigator.clipboard.writeText(tempCredential.email);
                    addToast("복사됐습니다", "success");
                  }} style={{
                    padding: "10px 14px", background: "#fff", border: "1px solid #e5e7eb",
                    borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, color: "#374151"
                  }}>복사</button>
                </div>
              </div>

              <div>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>임시 비밀번호</div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{
                    flex: 1, padding: "10px 12px", background: "#fff", borderRadius: 8,
                    border: "1px solid #e5e7eb", fontSize: 16, fontFamily: "monospace",
                    fontWeight: 700, color: "#2563eb", letterSpacing: 1
                  }}>{tempCredential.password}</div>
                  <button onClick={() => {
                    navigator.clipboard.writeText(tempCredential.password);
                    addToast("복사됐습니다", "success");
                  }} style={{
                    padding: "10px 14px", background: "#2563eb", border: "none",
                    borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, color: "#fff"
                  }}>복사</button>
                </div>
              </div>
            </div>

            <div style={{
              background: "#fef9c3", borderRadius: 8, padding: "10px 12px", marginBottom: 16,
              fontSize: 12, color: "#854d0e", lineHeight: 1.5
            }}>
              💡 첫 로그인 시 스태프 본인이 비밀번호를 변경하게 됩니다.<br/>
              이 창을 닫으면 임시 비밀번호는 다시 볼 수 없으니 미리 복사하거나 전달해주세요.
            </div>

            <button onClick={() => setTempCredential(null)} style={{
              width: "100%", padding: "12px", background: "#2563eb", color: "#fff",
              border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: "pointer"
            }}>확인</button>
          </div>
        </div>
      )}

{/* 삭제 1차 확인 */}
      {deleteTarget && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 380, textAlign: "center" }}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>⚠️</div>
            <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 8 }}>{deleteTarget.name}님을 삭제하시겠습니까?</div>
            <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 24 }}>
              이 직원의 계정과 관련 데이터에 접근할 수 없게 됩니다.
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setDeleteTarget(null)} style={{
                flex: 1, padding: "12px 0", borderRadius: 8, border: "1px solid #d1d5db",
                background: "#fff", color: "#374151", fontSize: 14, fontWeight: 600, cursor: "pointer"
              }}>취소</button>
              <button onClick={() => {
                setDeleteFinal(deleteTarget);
                setDeleteTarget(null);
              }} style={{
                flex: 1, padding: "12px 0", borderRadius: 8, border: "none",
                background: "#ef4444", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer"
              }}>계속</button>
            </div>
          </div>
        </div>
      )}

      {/* 삭제 2차 최종 확인 */}
      {deleteFinal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 380, textAlign: "center" }}>
            <div style={{ fontSize: 36, marginBottom: 12 }}>🚨</div>
            <div style={{ fontSize: 17, fontWeight: 700, color: "#ef4444", marginBottom: 8 }}>최종 확인</div>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>{deleteFinal.name}님을 정말 삭제하시겠습니까?</div>
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 24, lineHeight: 1.6, textAlign: "left", background: "#f9fafb", padding: 12, borderRadius: 8 }}>
              • 이 작업은 되돌릴 수 없습니다<br/>
              • 매출/수업 기록은 그대로 유지됩니다<br/>
              • 해당 직원은 더 이상 로그인할 수 없습니다
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setDeleteFinal(null)} disabled={deleting} style={{
                flex: 1, padding: "12px 0", borderRadius: 8, border: "1px solid #d1d5db",
                background: "#fff", color: "#374151", fontSize: 14, fontWeight: 600,
                cursor: deleting ? "not-allowed" : "pointer", opacity: deleting ? 0.5 : 1
              }}>취소</button>
              <button onClick={() => handleDelete(deleteFinal.id)} disabled={deleting} style={{
                flex: 1, padding: "12px 0", borderRadius: 8, border: "none",
                background: "#ef4444", color: "#fff", fontSize: 14, fontWeight: 700,
                cursor: deleting ? "not-allowed" : "pointer", opacity: deleting ? 0.7 : 1
              }}>{deleting ? "삭제 중..." : "삭제하기"}</button>
            </div>
          </div>
        </div>
      )}

      {/* 직원 담당 회원 모달 */}
      {showStaffMembersModal && selectedStaff && (
        <div onClick={() => setShowStaffMembersModal(false)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000,
          display: "flex", alignItems: "center", justifyContent: "center", padding: 20
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", borderRadius: 16, padding: 20, width: "100%", maxWidth: 580,
            maxHeight: "80vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.15)"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 700, color: "#111" }}>{selectedStaff.name} 강사 · 담당 회원</div>
                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>
                  {selectedStaff.position || ({ TRAINER: "트레이너", MANAGER: "관리자", RECEPTION: "리셉션" }[selectedStaff.role]) || "-"} · {selectedStaff.phone || "-"}
                </div>
              </div>
              <button onClick={() => setShowStaffMembersModal(false)} style={{
                background: "#f3f4f6", border: "none", borderRadius: 6, padding: "4px 10px",
                cursor: "pointer", fontSize: 14, color: "#6b7280"
              }}>×</button>
            </div>

            {(() => {
              const today = new Date();
              const total = staffMembers.length;
              const expiring = staffMembers.filter(m => {
                if (!m.end_date) return false;
                const days = Math.ceil((new Date(m.end_date) - today) / 86400000);
                return days >= 0 && days <= 30;
              }).length;
              const active = total - expiring;
              return (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 14 }}>
                  <div style={{ background: "#eff6ff", borderRadius: 8, padding: "10px 12px" }}>
                    <div style={{ fontSize: 11, color: "#6b7280" }}>총 회원</div>
                    <div style={{ fontSize: 18, fontWeight: 700, color: "#2563eb" }}>{total}명</div>
                  </div>
                  <div style={{ background: "#f0fdf4", borderRadius: 8, padding: "10px 12px" }}>
                    <div style={{ fontSize: 11, color: "#6b7280" }}>활성</div>
                    <div style={{ fontSize: 18, fontWeight: 700, color: "#16a34a" }}>{active}명</div>
                  </div>
                  <div style={{ background: "#fff7ed", borderRadius: 8, padding: "10px 12px" }}>
                    <div style={{ fontSize: 11, color: "#6b7280" }}>만료 임박</div>
                    <div style={{ fontSize: 18, fontWeight: 700, color: "#f97316" }}>{expiring}명</div>
                  </div>
                </div>
              );
            })()}

            <input value={staffMembersSearch} onChange={e => setStaffMembersSearch(e.target.value)}
              placeholder="🔍 회원 이름 검색"
              style={{ width: "100%", padding: "8px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, outline: "none", marginBottom: 12, boxSizing: "border-box" }} />

            <div style={{ maxHeight: 280, overflowY: "auto", border: "0.5px solid #e5e7eb", borderRadius: 8 }}>
              {staffMembersLoading ? (
                <div style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>로딩 중...</div>
              ) : (() => {
                const filtered = staffMembers.filter(m =>
                  !staffMembersSearch || m.name?.includes(staffMembersSearch) || m.phone?.includes(staffMembersSearch)
                );
                if (filtered.length === 0) {
                  return <div style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>담당 회원이 없습니다</div>;
                }
                return (
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                    <thead style={{ background: "#f9fafb", position: "sticky", top: 0 }}>
                      <tr>
                        <th style={{ padding: "8px 10px", textAlign: "left", color: "#6b7280", fontWeight: 600, fontSize: 11 }}>회원명</th>
                        <th style={{ padding: "8px 10px", textAlign: "left", color: "#6b7280", fontWeight: 600, fontSize: 11 }}>만료일</th>
                        <th style={{ padding: "8px 10px", textAlign: "center", color: "#6b7280", fontWeight: 600, fontSize: 11 }}>상태</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filtered.map((m, i) => {
                        const today = new Date();
                        const days = m.end_date ? Math.ceil((new Date(m.end_date) - today) / 86400000) : null;
                        const expired = days !== null && days < 0;
                        const expiring = days !== null && days >= 0 && days <= 30;
                        const status = expired ? { bg: "#fef2f2", color: "#dc2626", label: "만료" } :
                                       expiring ? { bg: "#fff7ed", color: "#f97316", label: `D-${days}` } :
                                       { bg: "#f0fdf4", color: "#16a34a", label: "활성" };
                        return (
                          <tr key={i} onClick={() => setQuickMember(m)} style={{ borderTop: "0.5px solid #f3f4f6", cursor: "pointer" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                            onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
                            <td style={{ padding: "9px 10px", color: "#111", fontWeight: 600 }}>
                              {m.name}
                              <div style={{ fontSize: 11, color: "#9ca3af", fontWeight: 400 }}>{m.phone || "-"}</div>
                            </td>
                            <td style={{ padding: "9px 10px", color: expiring ? "#f97316" : "#374151", fontWeight: expiring ? 500 : 400 }}>
                              {m.end_date || "-"}
                            </td>
                            <td style={{ padding: "9px 10px", textAlign: "center" }}>
                              <span style={{ background: status.bg, color: status.color, padding: "2px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600 }}>
                                {status.label}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                );
              })()}
            </div>
          </div>
        </div>
      )}

      {/* 담당회원 요약 팝업 (간편모드 회원검색과 동일) */}
      {quickMember && (
        <MemberQuickPopup
          member={quickMember}
          trainers={staff}
          onClose={() => setQuickMember(null)}
          onPay={(m) => {
            setQuickMember(null);
            setShowStaffMembersModal(false);
            sessionStorage.setItem("openMemberId", String(m.id));
            sessionStorage.setItem("openMemberPay", "1");
            if (setSimpleMode) setSimpleMode(false);
            if (setPage) setPage("members");
          }}
          onDetail={(m) => {
            setQuickMember(null);
            setShowStaffMembersModal(false);
            sessionStorage.setItem("openMemberId", String(m.id));
            if (setSimpleMode) setSimpleMode(false);
            if (setPage) setPage("members");
          }}
        />
      )}

      {/* 신규 직원 등록 모달 */}
      {showModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 560, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.15)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
              <h3 style={{ color: "#111", margin: 0, fontSize: 18, fontWeight: 700 }}>{editTarget ? "직원 정보 수정" : "신규 직원 등록"}</h3>
              <button onClick={() => { setShowModal(false); setEditTarget(null); resetForm(); }} style={{ background: "#f3f4f6", border: "none", color: "#6b7280", cursor: "pointer", borderRadius: 8, padding: "6px 8px" }}>
                <Icon name="x" size={16} />
              </button>
            </div>

            {/* 기본 정보 */}
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 12 }}>기본 정보</div>
            {!editTarget && (
              <div style={{ display: "flex", gap: 10, alignItems: "flex-start", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "12px 14px", marginBottom: 12 }}>
                <span style={{ fontSize: 16, marginTop: 1 }}>🔑</span>
                <div style={{ fontSize: 12, color: "#1e40af", lineHeight: 1.6 }}>
                  등록을 완료하면 이 직원의 <b>임시 비밀번호</b>가 발급됩니다. 등록 직후 화면에 <b>한 번만</b> 표시되니 <b>복사해서 직원에게 전달</b>해 주세요. 직원은 <b>전화번호 + 임시 비밀번호</b>로 로그인 후 비밀번호를 변경할 수 있습니다.
                </div>
              </div>
            )}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
              <Input label="이름 *" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="직원 이름" />
              <Input label="전화번호 *" value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} placeholder="010-0000-0000" />
            </div>
            <Input label="이메일" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} placeholder="example@gym.com" />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>역할 *</label>
                <select value={form.role || "STAFF"} onChange={e => setForm(p => ({ ...p, role: e.target.value }))}
                  style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", background: "#f9fafb", color: "#111" }}>
                  <option value="MANAGER">관리자</option>
                  <option value="TRAINER">트레이너</option>
                  <option value="RECEPTION">리셉션</option>
                </select>
              </div>
              <Input label="입사일" value={form.join_date} onChange={e => setForm(p => ({ ...p, join_date: e.target.value }))} type="date" />
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <Input label="직급 (표시용)" value={form.position} onChange={e => setForm(p => ({ ...p, position: e.target.value }))} placeholder="수석 트레이너" />
            </div>

            <div style={{ borderTop: "1px solid #f3f4f6", margin: "16px 0" }} />

            {/* 강사 프로필 (회원앱 노출) */}
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 4 }}>강사 프로필 <span style={{ fontSize: 11, fontWeight: 400, color: "#9ca3af" }}>(회원앱 강사진에 노출)</span></div>
            <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 12 }}>회원이 보는 강사 소개예요. 슬로건과 자격사항을 채우면 강사진 카드에서 펼쳐 볼 수 있어요.</div>
            <div style={{ marginBottom: 12 }}>
              <Input label="슬로건 (한 줄 소개)" value={form.slogan} onChange={e => setForm(p => ({ ...p, slogan: e.target.value }))} placeholder="예: 통증 없는 바른 자세를 만들어 드립니다" />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>자격사항 (한 줄에 하나씩)</label>
              <textarea value={form.certifications} onChange={e => setForm(p => ({ ...p, certifications: e.target.value }))}
                placeholder={"예)\n생활스포츠지도사 2급\nGYROTONIC 국제 자격\n필라테스 지도자 과정 수료"}
                rows={4} style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", resize: "vertical", fontFamily: "inherit", boxSizing: "border-box" }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>소개 (선택)</label>
              <textarea value={form.bio} onChange={e => setForm(p => ({ ...p, bio: e.target.value }))}
                placeholder="강사를 소개하는 문구를 자유롭게 적어주세요"
                rows={3} style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", resize: "vertical", fontFamily: "inherit", boxSizing: "border-box" }} />
            </div>

            <div style={{ borderTop: "1px solid #f3f4f6", margin: "16px 0" }} />

            {/* 고유 색상 지정 */}
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 12 }}>고유 색상 지정</div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <span style={{ fontSize: 12, color: "#6b7280" }}>색상 지정</span>
              <button onClick={() => setForm(p => ({ ...p, color: "" }))} style={{ background: "none", border: "none", color: "#6b7280", fontSize: 12, cursor: "pointer" }}>선택 해제</button>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
              {COLORS.map((c, i) => (
                <div key={i} onClick={() => setForm(p => ({ ...p, color: c }))} style={{
                  width: 32, height: 32, borderRadius: "50%", background: c, cursor: "pointer",
                  border: form.color === c ? "3px solid #111" : "3px solid transparent",
                  boxShadow: form.color === c ? "0 0 0 2px #fff inset" : "none"
                }} />
              ))}
            </div>

            <div style={{ borderTop: "1px solid #f3f4f6", margin: "16px 0" }} />

            {/* 급여 설정 */}
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 12 }}>급여 설정</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
              <Input label="기본급 (원)" value={form.base_salary} onChange={e => setForm(p => ({ ...p, base_salary: e.target.value }))} placeholder="2000000" type="number" />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>인센티브 방식</label>
              <select value={form.incentive_type} onChange={e => setForm(p => ({ ...p, incentive_type: e.target.value }))}
                style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", background: "#f9fafb", color: "#111" }}>
                <option value="per_session">수업 1회당 고정 단가</option>
                <option value="revenue_rate">매출의 N%</option>
                <option value="fee_rate">수업료의 N%</option>
              </select>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
              <Input
                label={form.incentive_type === "per_session" ? "수업당 단가 (원)" : "인센티브율 (%)"}
                value={form.incentive_value}
                onChange={e => setForm(p => ({ ...p, incentive_value: e.target.value }))}
                placeholder={form.incentive_type === "per_session" ? "30000" : "30"}
                type="number"
              />
            </div>
            <div style={{ background: "#fff7fb", borderRadius: 10, padding: 14, border: "1px solid #fbcfe8", marginBottom: 12 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>그룹수업 정산 (출석 인원 기준)</div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 10 }}>출석(취소 제외) 인원이 정원을 채우면 '만석', 아니면 '미달'로 강사 몫을 계산해요.</div>
              <div style={{ marginBottom: 10 }}>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>정산 방식</label>
                <select value={form.group_pay_type} onChange={e => setForm(p => ({ ...p, group_pay_type: e.target.value }))}
                  style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", background: "#fff", color: "#111" }}>
                  <option value="">사용 안 함</option>
                  <option value="amount">고정 금액 (원)</option>
                  <option value="rate">수업료의 % (수업별 수업료 × %)</option>
                </select>
              </div>
              {form.group_pay_type && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <Input
                    label={form.group_pay_type === "amount" ? "만석 시 강사 몫 (원)" : "만석 시 강사 몫 (%)"}
                    value={form.group_full_value}
                    onChange={e => setForm(p => ({ ...p, group_full_value: e.target.value }))}
                    placeholder={form.group_pay_type === "amount" ? "50000" : "50"} type="number" />
                  <Input
                    label={form.group_pay_type === "amount" ? "미달 시 강사 몫 (원)" : "미달 시 강사 몫 (%)"}
                    value={form.group_partial_value}
                    onChange={e => setForm(p => ({ ...p, group_partial_value: e.target.value }))}
                    placeholder={form.group_pay_type === "amount" ? "30000" : "30"} type="number" />
                </div>
              )}
              {form.group_pay_type === "rate" && (
                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 8 }}>💡 % 방식은 각 그룹수업에 '수업료(1회)'를 입력해야 계산돼요. (수업관리/스케줄러 수업 생성 시 입력)</div>
              )}
            </div>

            <div style={{ background: "#f8faff", borderRadius: 10, padding: 14, border: "1px solid #e0e7ff", marginBottom: 8 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 10 }}>보너스 설정</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <Input label="목표 매출 (원)" value={form.bonus_target} onChange={e => setForm(p => ({ ...p, bonus_target: e.target.value }))} placeholder="10000000" type="number" />
                <Input label="보너스 지급률 (%)" value={form.bonus_rate} onChange={e => setForm(p => ({ ...p, bonus_rate: e.target.value }))} placeholder="1" type="number" />
              </div>
              <div style={{ fontSize: 11, color: "#6b7280", marginTop: 8 }}>
                💡 목표 매출 달성 시 전체 매출의 {form.bonus_rate || 0}% 지급
              </div>
            </div>

            <div style={{ borderTop: "1px solid #f3f4f6", margin: "16px 0" }} />

            {/* 근무 정보 */}
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 12 }}>근무 정보</div>
            {form.work_schedules.map((sched, idx) => (
              <div key={idx} style={{ background: "#f9fafb", borderRadius: 10, padding: 14, marginBottom: 10, border: "1px solid #e5e7eb" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: "#374151" }}>스케줄 {idx + 1}</span>
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <button onClick={() => {
                      const updated = form.work_schedules.map((s, i) => i === idx ? { ...s, days: [...DAYS] } : s);
                      setForm(p => ({ ...p, work_schedules: updated }));
                    }} style={{ background: "none", border: "none", color: "#2563eb", fontSize: 11, cursor: "pointer" }}>전체선택</button>
                    <span style={{ color: "#e5e7eb" }}>|</span>
                    <button onClick={() => {
                      const updated = form.work_schedules.map((s, i) => i === idx ? { ...s, days: [] } : s);
                      setForm(p => ({ ...p, work_schedules: updated }));
                    }} style={{ background: "none", border: "none", color: "#6b7280", fontSize: 11, cursor: "pointer" }}>해제</button>
                    {form.work_schedules.length > 1 && (
                      <>
                        <span style={{ color: "#e5e7eb" }}>|</span>
                        <button onClick={() => {
                          setForm(p => ({ ...p, work_schedules: p.work_schedules.filter((_, i) => i !== idx) }));
                        }} style={{ background: "none", border: "none", color: "#ef4444", fontSize: 11, cursor: "pointer" }}>삭제</button>
                      </>
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                  {DAYS.map(d => (
                    <button key={d} onClick={() => {
                      const updated = form.work_schedules.map((s, i) => {
                        if (i !== idx) return s;
                        return { ...s, days: s.days.includes(d) ? s.days.filter(x => x !== d) : [...s.days, d] };
                      });
                      setForm(p => ({ ...p, work_schedules: updated }));
                    }} style={{
                      flex: 1, padding: "8px 0", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer",
                      border: `1px solid ${sched.days.includes(d) ? "#2563eb" : "#e5e7eb"}`,
                      background: sched.days.includes(d) ? "#eff6ff" : "#fff",
                      color: sched.days.includes(d) ? "#2563eb" : "#374151"
                    }}>{d}</button>
                  ))}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4 }}>시작 시간</label>
                    <TimePicker value={sched.start} onChange={v => {
                     const updated = form.work_schedules.map((s, i) => i === idx ? { ...s, start: v } : s);
                      setForm(p => ({ ...p, work_schedules: updated }));
                    }} style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4 }}>종료 시간</label>
                    <TimePicker value={sched.end} onChange={v => {
  const updated = form.work_schedules.map((s, i) => i === idx ? { ...s, end: v } : s);
                      setForm(p => ({ ...p, work_schedules: updated }));
                    }} style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                  </div>
                </div>
              </div>
            ))}
            <div style={{ background: "#eef2ff", borderRadius: 8, padding: "10px 12px", marginBottom: 10, fontSize: 12, color: "#374151" }}>
              <span style={{ fontWeight: 700, color: "#4338ca" }}>✓ 현재 근무 설정: </span>
              {form.work_schedules.filter(s => s.days && s.days.length).map(s => `${s.days.join("·")} ${s.start || "--:--"}~${s.end || "--:--"}`).join("  /  ") || "아직 선택 안 됨"}
              <div style={{ fontSize: 11, color: "#6b7280", marginTop: 3 }}>아래 “저장하기”를 누르면 이대로 저장됩니다.</div>
            </div>
            <button onClick={() => setForm(p => ({ ...p, work_schedules: [...p.work_schedules, { days: [], start: "", end: "" }] }))}
              style={{ width: "100%", padding: "10px 0", borderRadius: 10, border: "2px dashed #d1d5db", background: "none", color: "#6b7280", fontSize: 13, fontWeight: 600, cursor: "pointer", marginBottom: 16 }}>
              + 스케줄 추가
            </button>

            <div style={{ borderTop: "1px solid #f3f4f6", margin: "16px 0" }} />

            {/* 예약 가능 시간 (근무시간과 별개) */}
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 4 }}>예약 가능 시간</div>
            <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 12 }}>
              💡 회원이 PT 예약할 수 있는 시간대입니다. 근무시간과 별개로 설정할 수 있어요. (비워두면 근무시간 기준으로 예약 가능)
            </div>
            {form.booking_schedules.map((sched, idx) => (
              <div key={idx} style={{ background: "#f0f9ff", borderRadius: 10, padding: 14, marginBottom: 10, border: "1px solid #bae6fd" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: "#374151" }}>예약 {idx + 1}</span>
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <button onClick={() => {
                      const updated = form.booking_schedules.map((s, i) => i === idx ? { ...s, days: [...DAYS] } : s);
                      setForm(p => ({ ...p, booking_schedules: updated }));
                    }} style={{ background: "none", border: "none", color: "#2563eb", fontSize: 11, cursor: "pointer" }}>전체선택</button>
                    <span style={{ color: "#e5e7eb" }}>|</span>
                    <button onClick={() => {
                      const updated = form.booking_schedules.map((s, i) => i === idx ? { ...s, days: [] } : s);
                      setForm(p => ({ ...p, booking_schedules: updated }));
                    }} style={{ background: "none", border: "none", color: "#6b7280", fontSize: 11, cursor: "pointer" }}>해제</button>
                    {form.booking_schedules.length > 1 && (
                      <>
                        <span style={{ color: "#e5e7eb" }}>|</span>
                        <button onClick={() => {
                          setForm(p => ({ ...p, booking_schedules: p.booking_schedules.filter((_, i) => i !== idx) }));
                        }} style={{ background: "none", border: "none", color: "#ef4444", fontSize: 11, cursor: "pointer" }}>삭제</button>
                      </>
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                  {DAYS.map(d => (
                    <button key={d} onClick={() => {
                      const updated = form.booking_schedules.map((s, i) => {
                        if (i !== idx) return s;
                        return { ...s, days: s.days.includes(d) ? s.days.filter(x => x !== d) : [...s.days, d] };
                      });
                      setForm(p => ({ ...p, booking_schedules: updated }));
                    }} style={{
                      flex: 1, padding: "8px 0", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer",
                      border: `1px solid ${sched.days.includes(d) ? "#2563eb" : "#e5e7eb"}`,
                      background: sched.days.includes(d) ? "#eff6ff" : "#fff",
                      color: sched.days.includes(d) ? "#2563eb" : "#374151"
                    }}>{d}</button>
                  ))}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4 }}>시작 시간</label>
                    <TimePicker value={sched.start} onChange={v => {
                      const updated = form.booking_schedules.map((s, i) => i === idx ? { ...s, start: v } : s);
                      setForm(p => ({ ...p, booking_schedules: updated }));
                    }} style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4 }}>종료 시간</label>
                    <TimePicker value={sched.end} onChange={v => {
                      const updated = form.booking_schedules.map((s, i) => i === idx ? { ...s, end: v } : s);
                      setForm(p => ({ ...p, booking_schedules: updated }));
                    }} style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                  </div>
                </div>
              </div>
            ))}
            <div style={{ background: "#f0f9ff", borderRadius: 8, padding: "10px 12px", marginBottom: 10, fontSize: 12, color: "#374151" }}>
              <span style={{ fontWeight: 700, color: "#0284c7" }}>✓ 현재 예약 설정: </span>
              {form.booking_schedules.filter(s => s.days && s.days.length).map(s => `${s.days.join("·")} ${s.start || "--:--"}~${s.end || "--:--"}`).join("  /  ") || "미설정 (근무시간 기준으로 예약 가능)"}
              <div style={{ fontSize: 11, color: "#6b7280", marginTop: 3 }}>아래 “저장하기”를 누르면 이대로 저장됩니다.</div>
            </div>
            <button onClick={() => setForm(p => ({ ...p, booking_schedules: [...p.booking_schedules, { days: [], start: "", end: "" }] }))}
              style={{ width: "100%", padding: "10px 0", borderRadius: 10, border: "2px dashed #bae6fd", background: "none", color: "#0284c7", fontSize: 13, fontWeight: 600, cursor: "pointer", marginBottom: 16 }}>
              + 예약 시간 추가
            </button>

            <div style={{ marginBottom: 14 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>메모</label>
              <textarea value={form.memo} onChange={e => setForm(p => ({ ...p, memo: e.target.value }))}
                placeholder="추가 정보 입력 (선택)" rows={3}
                style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, color: "#111", padding: "10px 12px", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "vertical", fontFamily: "inherit" }} />
            </div>

            {/* 버튼 (하단 고정) */}
            <div style={{
              position: "sticky", bottom: -28, background: "#fff",
              marginLeft: -28, marginRight: -28, marginTop: 12,
              paddingLeft: 28, paddingRight: 28, paddingTop: 14, paddingBottom: 28,
              borderTop: "1px solid #eef0f3",
              display: "grid", gridTemplateColumns: "1fr 2fr", gap: 10
            }}>
              <button onClick={() => { setShowModal(false); setEditTarget(null); resetForm(); }} style={{
                padding: "14px 0", borderRadius: 10, border: "1px solid #e5e7eb",
                background: "#fff", color: "#374151", fontSize: 14, fontWeight: 600, cursor: "pointer"
              }}>취소</button>
              <button onClick={editTarget ? handleEdit : handleCreate} disabled={saving} style={{
                padding: "14px 0", borderRadius: 10, border: "none",
                background: "#2563eb", color: "#fff", fontSize: 14, fontWeight: 700,
                cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.7 : 1
              }}>{saving ? "저장 중..." : editTarget ? "저장하기" : "직원 등록"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
    
  );
};

// ════════════════════════════════════════════════════════════════════════════
// CONSULT PAGE (상담관리)
// ════════════════════════════════════════════════════════════════════════════
const ConsultPage = ({ token, addToast, autoOpenAdd, onAutoOpenConsumed, focusConsultId, onFocusConsumed }) => {
  const [consultations, setConsultations] = useState([]);
  const [statsMonth, setStatsMonth] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [calendarMonth, setCalendarMonth] = useState(new Date());
  const [viewMode, setViewMode] = useState("grid");
  const [periodMode, setPeriodMode] = useState("day");
  const [trainers, setTrainers] = useState([]);
  const [members, setMembers] = useState([]);
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedConsult, setSelectedConsult] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  useEffect(() => {
    if (autoOpenAdd) {
      setShowAddModal(true);
      if (onAutoOpenConsumed) onAutoOpenConsumed();
    }
  }, [autoOpenAdd]);
  useEffect(() => {
    if (focusConsultId && consultations.length) {
      const found = consultations.find(c => c.id === focusConsultId);
      if (found) setSelectedConsult(found);
      if (onFocusConsumed) onFocusConsumed();
    }
  }, [focusConsultId, consultations]);
  const [saving, setSaving] = useState(false);
  const [showChangeModal, setShowChangeModal] = useState(false);
const [changeTarget, setChangeTarget] = useState(null);
const [changeForm, setChangeForm] = useState({ date: "", start_time: "", end_time: "", trainer_id: "", reason: "" });
const [consultLogs, setConsultLogs] = useState([]);
const [showLogs, setShowLogs] = useState(false);
const [consultTab, setConsultTab] = useState("schedule"); // schedule | journal
const [showJournalModal, setShowJournalModal] = useState(false);
const [showSettingsModal, setShowSettingsModal] = useState(false);
const [journalTarget, setJournalTarget] = useState(null);
const [journals, setJournals] = useState([]);
const [journalSettings, setJournalSettings] = useState({
  exercise_goals: ["다이어트","체형교정","근력증진","바디프로필","재활"],
  exercise_experiences: ["1개월","3개월","6개월~1년","1~3년","3년이상"],
  desired_programs: ["헬스","개인PT","그룹GX"],
  inquiry_routes: ["워크인","SMS문의","네이버 예약","SNS문의","기타"],
  visit_routes: ["SNS","소셜 검색","지인 소개","전단지","간판","기타"],
});
const [journalForm, setJournalForm] = useState({
  exercise_goal: [], exercise_experience: [], desired_program: [],
  inquiry_route: [], visit_route: [], content: "", summary: "", result: ""
});
const [settingsEdit, setSettingsEdit] = useState(null);
const [newItemText, setNewItemText] = useState("");
const [plans, setPlans] = useState([]);
  const [bizHours, setBizHours] = React.useState({ startHour: 9, endHour: 20 });
const [showJournalPayConfirm, setShowJournalPayConfirm] = useState(false);
const [showJournalPaymentWizard, setShowJournalPaymentWizard] = useState(false);

const [journalFilter, setJournalFilter] = useState("all");
  const [form, setForm] = useState({
    member_id: "", member_search: "", member_name_manual: "", phone: "",
    trainer_id: "", type: "PT", title: "",
    date: ymdKST(),
    start_time: "09:00", end_time: "10:00", memo: ""
  });

  const TYPE_COLORS = { PT: "#fce7f3", GROUP: "#dcfce7", MEMBERSHIP: "#fef9c3", TRIAL: "#dbeafe" };
  const TYPE_LABELS = { PT: "개인PT 상담", GROUP: "그룹GX 상담", MEMBERSHIP: "회원권 상담", TRIAL: "체험 상담" };
  const TYPE_DOT = { PT: "#ec4899", GROUP: "#22c55e", MEMBERSHIP: "#eab308", TRIAL: "#3b82f6" };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/consultation/list?tenant_id=1", {}, token);
      setConsultations(Array.isArray(d) ? d : []);
    } catch (e) { addToast("상담 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token]);

  // 빈칸 클릭 → 상담 추가 모달 (날짜·시간 프리필)
  const openAddAt = (dateStr, timeStr) => {
    const [h, m] = timeStr.split(":").map(Number);
    const em = h * 60 + m + 60;
    const et = `${String(Math.floor(em / 60) % 24).padStart(2, "0")}:${String(em % 60).padStart(2, "0")}`;
    setForm({ member_id: "", member_search: "", member_name_manual: "", phone: "", trainer_id: "", type: "PT", title: "", date: dateStr, start_time: timeStr, end_time: et, memo: "" });
    setShowAddModal(true);
  };
  // 드래그로 상담 이동
  const dragConsultRef = React.useRef(null);
  const handleConsultDrop = async (dateStr, timeStr) => {
    const r = dragConsultRef.current;
    dragConsultRef.current = null;
    if (!r) return;
    const parseHM = s => { const [a, b] = (s || "0:0").split(":").map(Number); return (a || 0) * 60 + (b || 0); };
    const sMin = parseHM(r.start_time ? r.start_time.slice(0, 5) : "");
    let dur = r.end_time ? (parseHM(r.end_time.slice(0, 5)) - sMin) : 60;
    if (dur <= 0) dur = 60;
    const nMin = parseHM(timeStr);
    let eMin = nMin + dur;
    if (eMin > 24 * 60 - 1) eMin = 24 * 60 - 1;
    const fmt = m => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
    if (r.date === dateStr && (r.start_time ? r.start_time.slice(0, 5) : "") === timeStr) return;
    try {
      await api(`/consultation/${r.id}`, { method: "PUT", body: JSON.stringify({ date: dateStr, start_time: timeStr, end_time: fmt(eMin) }) }, token);
      addToast("상담을 옮겼습니다.", "success");
      load();
    } catch (e) { addToast("이동 실패: " + (e.message || ""), "error"); }
  };

  useEffect(() => {
    load();
    api("/staff/list?tenant_id=1", {}, token).then(d => setTrainers(Array.isArray(d) ? d : [])).catch(() => {});
    api("/members/?tenant_id=1", {}, token).then(d => setMembers(Array.isArray(d) ? d : [])).catch(() => {});
api("/consultation-journal/settings?tenant_id=1", {}, token).then(d => setJournalSettings(d)).catch(() => {});
api("/consultation-journal/list?tenant_id=1", {}, token).then(d => setJournals(Array.isArray(d) ? d : [])).catch(() => {});
api("/membership-plan/list?tenant_id=1", {}, token).then(d => setPlans(Array.isArray(d) ? d : [])).catch(() => {});
    // 영업시간 로드
    api("/tenant/1/settings", {}, token).then(d => {
      if (!d?.business_hours) return;
      try {
        const today = new Date();
        const dayKeys = ["sun","mon","tue","wed","thu","fri","sat"];
        const dayKey = dayKeys[today.getDay()];
        const bh = typeof d.business_hours === "string" ? JSON.parse(d.business_hours) : d.business_hours;
        const day = bh[dayKey];
        if (day && !day.closed) {
          const sh = parseInt(day.open?.split(":")[0] || 9);
          const eh = parseInt(day.close?.split(":")[0] || 20);
          setBizHours({ startHour: sh, endHour: eh });
        }
      } catch(e) { console.error("영업시간 파싱 오류:", e); }
    }).catch(() => {});
  }, [load]);

  const selectedDateStr = ymdKST(selectedDate);
  const todayStr = ymdKST();

  const getWeekDates = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const sunday = new Date(d);
    sunday.setDate(d.getDate() - day);
    return Array.from({ length: 7 }, (_, i) => {
      const dt = new Date(sunday);
      dt.setDate(sunday.getDate() + i);
      return ymdKST(dt);
    });
  };
  const weekDates = getWeekDates(selectedDate);

  const shiftDate = (date, mode, dir) => {
    const d = new Date(date);
    if (mode === "month") d.setMonth(d.getMonth() + dir);
    else if (mode === "week") d.setDate(d.getDate() + dir * 7);
    else d.setDate(d.getDate() + dir);
    return d;
  };

  const filteredConsults = consultations.filter(r => {
    const matchDate = periodMode === "month"
      ? (r.date && r.date.slice(0, 7) === selectedDateStr.slice(0, 7))
      : periodMode === "week" ? weekDates.includes(r.date) : r.date === selectedDateStr;
    const matchTrainer = selectedTrainers.length === 0 || selectedTrainers.includes(r.trainer_id);
    const matchSearch = searchKeyword ?r.member_name?.includes(searchKeyword) || r.trainer_name?.includes(searchKeyword) || r.phone?.includes(searchKeyword) : true;
    return matchDate && matchTrainer && matchSearch;
  });

  const todayConsults = consultations.filter(r => r.date === todayStr);
  const todayCompleted = todayConsults.filter(r => r.status === "COMPLETED").length;
  const todayReserved = todayConsults.filter(r => r.status === "RESERVED").length;
  const todayCancelled = todayConsults.filter(r => r.status === "CANCELLED").length;
  const todayNoshow = todayConsults.filter(r => r.status === "NOSHOW").length;

  const getDaysInMonth = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const days = [];
    for (let i = 0; i < firstDay; i++) days.push(null);
    for (let i = 1; i <= daysInMonth; i++) days.push(i);
    return days;
  };

  const calYear = calendarMonth.getFullYear();
  const calMonth = calendarMonth.getMonth();
  const calDays = getDaysInMonth(calYear, calMonth);
  const dayNames = ["일", "월", "화", "수", "목", "금", "토"];
  const hours = Array.from({ length: bizHours.endHour - bizHours.startHour + 1 }, (_, i) => i + bizHours.startHour);
  const timeSlots = [];
  for (let h = bizHours.startHour; h <= bizHours.endHour; h++) {
    timeSlots.push({ hour: h, minute: 0 });
    timeSlots.push({ hour: h, minute: 30 });
  }

  const handleStatusChange = async (id, status) => {
    try {
      await api(`/consultation/${id}?tenant_id=1`, { method: "PUT", body: JSON.stringify({ status }) }, token);
      addToast("변경됐습니다", "success");
      load();
      setSelectedConsult(null);
    } catch (e) { addToast("처리 실패: " + e.message, "error"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      await api(`/consultation/${id}?tenant_id=1`, { method: "DELETE" }, token);
      addToast("삭제됐습니다", "success");
      load();
      setSelectedConsult(null);
    } catch (e) { addToast("삭제 실패: " + e.message, "error"); }
  };

  const handleCreate = async () => {
    if (!form.date) return addToast("날짜는 필수입니다", "error");
    if (!form.member_id && !form.member_name_manual) return addToast("상담자명은 필수입니다", "error");
    setSaving(true);
    try {
      await api("/consultation", {
        method: "POST",
        body: JSON.stringify({
          tenant_id: 1,
          member_id: form.member_id ? parseInt(form.member_id) : null,
          member_name_manual: form.member_id ? null : form.member_name_manual,
          phone: form.phone,
          trainer_id: form.trainer_id ? parseInt(form.trainer_id) : null,
          type: form.type,
          title: form.title || TYPE_LABELS[form.type],
          date: form.date,
          start_time: form.start_time,
          end_time: form.end_time,
          memo: form.memo
        })
      }, token);
      addToast("상담이 등록됐습니다", "success");
      setShowAddModal(false);
      setForm({ member_id: "", member_search: "", member_name_manual: "", phone: "", trainer_id: "", type: "PT", title: "", date: ymdKST(), start_time: "09:00", end_time: "10:00", memo: "" });
      load();
    } catch (e) { addToast("등록 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };
const handleChange = async () => {
  if (!changeForm.reason) return addToast("변경 사유를 입력해주세요", "error");
  setSaving(true);
  try {
    await api(`/consultation/${changeTarget.id}/change?tenant_id=1`, {
      method: "POST",
      body: JSON.stringify({
        date: changeForm.date || undefined,
        start_time: changeForm.start_time || undefined,
        end_time: changeForm.end_time || undefined,
        trainer_id: changeForm.trainer_id ? parseInt(changeForm.trainer_id) : undefined,
        reason: changeForm.reason,
      })
    }, token);
    addToast("변경됐습니다", "success");
    setShowChangeModal(false);
    setChangeTarget(null);
    setSelectedConsult(null);
    load();
  } catch (e) { addToast("변경 실패: " + e.message, "error"); }
  finally { setSaving(false); }
};

const loadLogs = async (id) => {
  try {
    const d = await api(`/consultation/${id}/logs?tenant_id=1`, {}, token);
    setConsultLogs(Array.isArray(d) ? d : []);
    setShowLogs(true);
  } catch (e) { addToast("이력 로드 실패", "error"); }
};
  const statusBadge = (s) => {
    const map = {
      RESERVED: { label: "예정", color: "#f97316" },
      COMPLETED: { label: "완료", color: "#22c55e" },
      CANCELLED: { label: "취소", color: "#ef4444" },
      NOSHOW: { label: "노쇼", color: "#8b5cf6" }
    };
    const m = map[s] || { label: s, color: "#9ca3af" };
    return <Badge label={m.label} color={m.color} />;
  };

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>상담 관리</h2>
          <span style={{ color: "#9ca3af" }}>|</span>
          <div style={{ display: "flex", gap: 4 }}>
            {[{ id: "schedule", label: "상담 일정 관리" }, { id: "journal", label: "상담 일지 관리" }].map(tab => (
              <button key={tab.id} onClick={() => setConsultTab(tab.id)} style={{
                padding: "6px 14px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 700,
                background: consultTab === tab.id ? "#2563eb" : "#f3f4f6",
                color: consultTab === tab.id ? "#fff" : "#6b7280"
              }}>{tab.label}</button>
            ))}
          </div>
        </div>
        {consultTab === "schedule" && (
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => {
              setJournalTarget({
                member_name: "", phone: "", date: ymdKST(),
                start_time: new Date().toTimeString().slice(0, 5), trainer_name: "", type: ""
              });
              setJournalForm({ exercise_goal: [], exercise_experience: [], desired_program: [], inquiry_route: [], visit_route: [], content: "", summary: "", result: "" });
              setShowJournalModal(true);
            }} style={{
              display: "flex", alignItems: "center", gap: 6, padding: "10px 20px",
              background: "#16a34a", color: "#fff", border: "none", borderRadius: 10,
              fontSize: 14, fontWeight: 700, cursor: "pointer"
            }}>
              📋 일지 작성
            </button>
            <button onClick={() => setShowAddModal(true)} style={{
              display: "flex", alignItems: "center", gap: 6, padding: "10px 20px",
              background: "#2563eb", color: "#fff", border: "none", borderRadius: 10,
              fontSize: 14, fontWeight: 700, cursor: "pointer"
            }}>
              <Icon name="plus" size={14} color="#fff" /> 상담 일정 추가
            </button>
          </div>
        )}
      </div>

      {/* 상단 통계 카드 5개 */}
      <div style={{ display: consultTab === "schedule" ? "grid" : "none", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 20 }}>
        {[
          { label: "금일 전체 상담", value: `${todayConsults.length}건`, color: "#2563eb", bg: "#eff6ff" },
          { label: "완료", value: `${todayCompleted}건`, color: "#22c55e", bg: "#f0fdf4" },
          { label: "예정", value: `${todayReserved}건`, color: "#f97316", bg: "#fff7ed" },
          { label: "취소", value: `${todayCancelled}건`, color: "#ef4444", bg: "#fff0f0" },
        ].map((c, i) => (
          <div key={i} style={{ background: c.bg, borderRadius: 14, padding: "16px 20px", border: `1px solid ${c.color}22` }}>
            <div style={{ color: "#6b7280", fontSize: 12, marginBottom: 6 }}>{c.label}</div>
            <div style={{ color: c.color, fontSize: 26, fontWeight: 800 }}>{c.value}</div>
          </div>
        ))}
      </div>

     {/* 메인 레이아웃 */}
      <div style={{ display: consultTab === "schedule" ? "grid" : "none", gridTemplateColumns: "1fr 300px", gap: 16 }}>

        {/* 왼쪽 - 메인 */}
        <div style={{ background: "#fff", borderRadius: 14, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
          {/* 상단 필터 */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ display: "flex", border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}>
                {[["month", "월간"], ["week", "주간"], ["day", "일간"]].map(([mode, label]) => (
                  <button key={mode} onClick={() => setPeriodMode(mode)} style={{
                    padding: "6px 16px", border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600,
                    background: periodMode === mode ? "#2563eb" : "#fff",
                    color: periodMode === mode ? "#fff" : "#374151"
                  }}>{label}</button>
                ))}
              </div>
              {/* 이전 / 오늘 / 다음 */}
              <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
                <button onClick={() => setSelectedDate(shiftDate(selectedDate, periodMode, -1))} title="이전"
                  style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, width: 30, height: 30, cursor: "pointer", color: "#374151", fontSize: 15 }}>‹</button>
                <button onClick={() => setSelectedDate(new Date())}
                  style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0 10px", height: 30, cursor: "pointer", color: "#374151", fontSize: 12, fontWeight: 600 }}>오늘</button>
                <button onClick={() => setSelectedDate(shiftDate(selectedDate, periodMode, 1))} title="다음"
                  style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, width: 30, height: 30, cursor: "pointer", color: "#374151", fontSize: 15 }}>›</button>
              </div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>
                상담 일정 목록 <span style={{ color: "#9ca3af", fontSize: 13, fontWeight: 400 }}>
                  {periodMode === "month" ? `${selectedDate.getFullYear()}년 ${selectedDate.getMonth() + 1}월`
                    : periodMode === "week" ? `${weekDates[0]} ~ ${weekDates[6]}` : selectedDateStr}
                </span>
              </div>
            </div>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: 8, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}><Icon name="search" size={14} /></span>
                <input value={searchKeyword} onChange={e => setSearchKeyword(e.target.value)}
                  placeholder="이름 또는 연락처로 검색"
                  style={{ padding: "6px 10px 6px 28px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", width: 180 }} />
              </div>
              <div style={{ display: "flex", border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}>
                <button onClick={() => setViewMode("list")} style={{
                  padding: "6px 12px", border: "none", cursor: "pointer",
                  background: viewMode === "list" ? "#2563eb" : "#fff",
                  color: viewMode === "list" ? "#fff" : "#374151"
                }}>≡</button>
                <button onClick={() => setViewMode("grid")} style={{
                  padding: "6px 12px", border: "none", cursor: "pointer",
                  background: viewMode === "grid" ? "#2563eb" : "#fff",
                  color: viewMode === "grid" ? "#fff" : "#374151"
                }}>⊞</button>
              </div>
            </div>
          </div>

          {/* 그리드 뷰 - 타임라인 */}
          {viewMode === "grid" && periodMode === "day" && (
            <div style={{ overflowY: "auto", maxHeight: 500 }}>
             {timeSlots.map(({ hour, minute }) => {
                const timeStr = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
                const label = minute === 0 ? (hour < 12 ? `오전 ${hour}` : hour === 12 ? "오후 12" : `오후 ${hour - 12}`) : "";
                const slotConsults = filteredConsults.filter(r => r.start_time?.slice(0, 5) === timeStr);
                return (
                  <div key={timeStr} style={{ display: "flex", gap: 12, minHeight: 30, borderTop: minute === 0 ? "1px solid #f3f4f6" : "1px dashed #f9fafb" }}>
                    <div style={{ width: 48, color: "#9ca3af", fontSize: 12, paddingTop: 4, flexShrink: 0 }}>{label}</div>
                    <div onClick={() => openAddAt(selectedDateStr, timeStr)}
                      onDragOver={ev => ev.preventDefault()}
                      onDrop={ev => { ev.preventDefault(); handleConsultDrop(selectedDateStr, timeStr); }}
                      style={{ flex: 1, display: "flex", gap: 8, padding: "2px 0", flexWrap: "wrap", cursor: "pointer", minHeight: 26 }}>
                      {slotConsults.map((r, j) => (
                        <div key={j} draggable
                          onDragStart={ev => { ev.stopPropagation(); dragConsultRef.current = r; try { ev.dataTransfer.effectAllowed = "move"; ev.dataTransfer.setData("text/plain", String(r.id)); } catch (_) {} }}
                          onClick={ev => { ev.stopPropagation(); setSelectedConsult(r); }} style={{
                          background: TYPE_COLORS[r.type] || "#f3f4f6",
                          borderRadius: 8, padding: "6px 10px", fontSize: 12, cursor: "grab",
                          minWidth: 160, flex: 1, maxWidth: 240,
                          border: selectedConsult?.id === r.id ? "2px solid #2563eb" : "1px solid transparent"
                        }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 4, fontWeight: 700, color: "#374151", marginBottom: 2 }}>
                            <div style={{ width: 8, height: 8, borderRadius: "50%", background: TYPE_DOT[r.type] || "#9ca3af" }} />
                            {r.trainer_name ? `${r.trainer_name}님` : "담당자 없음"}
                          </div>
                          <div style={{ color: "#6b7280", fontSize: 11 }}>{r.start_time?.slice(0, 5)}~{r.end_time?.slice(0, 5)}</div>
                          <div style={{ color: "#6b7280", fontSize: 11 }}>{r.member_name}-{TYPE_LABELS[r.type]}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
              <div style={{ display: "flex", gap: 16, marginTop: 12, paddingTop: 12, borderTop: "1px solid #f3f4f6" }}>
                {Object.entries(TYPE_LABELS).map(([type, label]) => (
                  <div key={type} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <div style={{ width: 12, height: 12, borderRadius: 3, background: TYPE_COLORS[type] }} />
                    <span style={{ fontSize: 11, color: "#9ca3af" }}>{label}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* 주간 그리드 뷰 */}
          {viewMode === "grid" && periodMode === "week" && (
            <div style={{ overflowY: "auto", maxHeight: 500 }}>
              <div style={{ display: "grid", gridTemplateColumns: "48px repeat(7, 1fr)", gap: 2 }}>
                <div style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}></div>
                {weekDates.map((dateStr, i) => {
                  const d = new Date(dateStr);
                  const isToday = dateStr === todayStr;
                  const isSelected = dateStr === selectedDateStr;
                  return (
                   <div key={dateStr} onClick={() => setSelectedDate(d)} style={{
                      textAlign: "center", padding: "8px 0", cursor: "pointer",
                      background: isSelected ? "#2563eb" : isToday ? "#eff6ff" : "#fff",
                      borderRadius: 6,
                      color: isSelected ? "#fff" : i === 0 ? "#ef4444" : i === 6 ? "#2563eb" : "#374151",
                      fontWeight: isSelected || isToday ? 700 : 600,
                      fontSize: 12,
                      position: "sticky", top: 0, zIndex: 2
                    }}>
                      <div>{dayNames[i]}</div>
                      <div style={{ fontSize: 14, marginTop: 2 }}>{d.getDate()}</div>
                    </div>
                  );
                })}
               {timeSlots.map(({ hour, minute }) => {
                  const timeStr = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
                  const label = minute === 0 ? (hour < 12 ? `오전 ${hour}` : hour === 12 ? "오후 12" : `오후 ${hour - 12}`) : "";
                  return (
                    <div key={timeStr} style={{ display: "contents" }}>
                      <div style={{ color: "#9ca3af", fontSize: 11, padding: "4px 4px 0 0", textAlign: "right", borderTop: minute === 0 ? "1px solid #f3f4f6" : "1px dashed #f9fafb" }}>{label}</div>
                     {weekDates.map(dateStr => {
                        const cellConsults = filteredConsults.filter(r =>
                          r.date === dateStr && r.start_time?.slice(0, 5) === timeStr
                        );
                        const cellIsToday = dateStr === todayStr;
                        return (
                          <div key={dateStr + timeStr}
                            onClick={() => openAddAt(dateStr, timeStr)}
                            onDragOver={ev => ev.preventDefault()}
                            onDrop={ev => { ev.preventDefault(); handleConsultDrop(dateStr, timeStr); }}
                            style={{
                            minHeight: 24, borderTop: minute === 0 ? "1px solid #f3f4f6" : "1px dashed #f9fafb", borderLeft: "1px solid #f3f4f6", padding: 2,
                            display: "flex", flexDirection: "column", gap: 2, cursor: "pointer",
                            background: cellIsToday ? "#f9fbff" : "transparent"
                          }}>
                            {cellConsults.slice(0, 3).map((r, j) => (
                              <div key={j} draggable
                                onDragStart={ev => { ev.stopPropagation(); dragConsultRef.current = r; try { ev.dataTransfer.effectAllowed = "move"; ev.dataTransfer.setData("text/plain", String(r.id)); } catch (_) {} }}
                                onClick={ev => { ev.stopPropagation(); setSelectedConsult(r); }} style={{
                                background: TYPE_COLORS[r.type] || "#f3f4f6",
                                borderRadius: 4, padding: "3px 5px", cursor: "grab",
                                border: selectedConsult?.id === r.id ? "2px solid #2563eb" : "1px solid transparent"
                              }}>
                                <div style={{ fontWeight: 700, color: "#374151", fontSize: 10 }}>{r.start_time?.slice(0, 5)}</div>
                                <div style={{ color: "#6b7280", fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.member_name}</div>
                              </div>
                            ))}
                            {cellConsults.length > 3 && (
                              <div onClick={ev => { ev.stopPropagation(); setSelectedDate(new Date(dateStr)); setPeriodMode("day"); }} style={{
                                background: "#eff6ff", color: "#2563eb", borderRadius: 4, padding: "2px 5px",
                                fontSize: 10, fontWeight: 600, cursor: "pointer", textAlign: "center"
                              }}>
                                + {cellConsults.length - 3} 더보기
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
              <div style={{ display: "flex", gap: 16, marginTop: 12, paddingTop: 12, borderTop: "1px solid #f3f4f6" }}>
                {Object.entries(TYPE_LABELS).map(([type, label]) => (
                  <div key={type} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <div style={{ width: 12, height: 12, borderRadius: 3, background: TYPE_COLORS[type] }} />
                    <span style={{ fontSize: 11, color: "#9ca3af" }}>{label}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* 월간 달력 뷰 */}
          {viewMode === "grid" && periodMode === "month" && (
            <div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 3, marginBottom: 4 }}>
                {dayNames.map((d, i) => (
                  <div key={d} style={{ textAlign: "center", fontSize: 11, fontWeight: 600, padding: 4, color: i === 0 ? "#ef4444" : i === 6 ? "#2563eb" : "#9ca3af" }}>{d}</div>
                ))}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 3 }}>
                {getDaysInMonth(selectedDate.getFullYear(), selectedDate.getMonth()).map((day, i) => {
                  if (day === null) return <div key={`e${i}`} />;
                  const dStr = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
                  const dayConsults = filteredConsults.filter(r => r.date === dStr).sort((a, b) => (a.start_time || "").localeCompare(b.start_time || ""));
                  const isToday = dStr === todayStr;
                  return (
                    <div key={dStr} onClick={() => { setSelectedDate(new Date(dStr)); setPeriodMode("day"); }} style={{
                      minHeight: 84, border: `1px solid ${isToday ? "#2563eb" : "#f3f4f6"}`, borderRadius: 8, padding: 5,
                      cursor: "pointer", background: isToday ? "#eff6ff" : "#fff", overflow: "hidden"
                    }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: isToday ? "#2563eb" : "#374151", marginBottom: 3 }}>{day}</div>
                      {dayConsults.slice(0, 3).map((r, j) => (
                        <div key={j} style={{ fontSize: 9.5, background: TYPE_COLORS[r.type] || "#f3f4f6", color: "#374151", borderRadius: 3, padding: "1px 4px", marginBottom: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {r.start_time?.slice(0, 5)} {r.member_name}
                        </div>
                      ))}
                      {dayConsults.length > 3 && <div style={{ fontSize: 9, color: "#9ca3af", fontWeight: 600 }}>+{dayConsults.length - 3}건</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* 리스트 뷰 */}
          {viewMode === "list" && (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr>
                  {["시간대", "상담자명", "전화번호", "담당자명", "상담 유형", "상태", "관리"].map(h => (
                    <th key={h} style={{ padding: "8px 12px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredConsults.length === 0 ? (
                  <tr><td colSpan={7} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>상담 일정이 없습니다</td></tr>
                ) : [...filteredConsults].sort((a, b) => periodMode === "month"
                    ? `${a.date} ${a.start_time || ""}`.localeCompare(`${b.date} ${b.start_time || ""}`)
                    : (a.start_time || "").localeCompare(b.start_time || "")).map((r, i) => (
                  <tr key={i} style={{ borderBottom: "1px solid #f9fafb", background: selectedConsult?.id === r.id ? "#f0f4ff" : "transparent", cursor: "pointer" }}
                    onClick={() => setSelectedConsult(r)}
                    onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                    onMouseLeave={e => e.currentTarget.style.background = selectedConsult?.id === r.id ? "#f0f4ff" : "transparent"}>
                    <td style={{ padding: "12px", color: "#2563eb", fontWeight: 700, whiteSpace: "nowrap" }}>{periodMode === "month" ? `${r.date?.slice(5)} ${r.start_time?.slice(0, 5)}` : r.start_time?.slice(0, 5)}</td>
                    <td style={{ padding: "12px", color: "#111", fontWeight: 600 }}>{r.member_name}</td>
                    <td style={{ padding: "12px", color: "#374151" }}>{r.phone || "-"}</td>
                    <td style={{ padding: "12px", color: "#374151" }}>{r.trainer_name || "-"}</td>
                    <td style={{ padding: "12px" }}>
                      <span style={{ background: TYPE_COLORS[r.type], color: TYPE_DOT[r.type], fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>
                        {TYPE_LABELS[r.type]}
                      </span>
                    </td>
                    <td style={{ padding: "12px" }}>{statusBadge(r.status)}</td>
                    <td style={{ padding: "12px" }}>
                      <div style={{ display: "flex", gap: 6 }}>
  <button onClick={e => {
    e.stopPropagation();
    setJournalTarget(r);
    setJournalForm({ exercise_goal: [], exercise_experience: [], desired_program: [], inquiry_route: [], visit_route: [], content: r.memo || "", summary: "", result: "" });
    setShowJournalModal(true);
  }} style={{ background: "#f0fdf4", border: "none", borderRadius: 6, padding: "3px 8px", fontSize: 11, cursor: "pointer", color: "#16a34a", fontWeight: 600 }}>📋 일지 작성</button>
  <button onClick={e => {
    e.stopPropagation();
    setChangeTarget(r);

    setChangeForm({ date: r.date, start_time: r.start_time?.slice(0,5), end_time: r.end_time?.slice(0,5), trainer_id: String(r.trainer_id || ""), reason: "" });
    setShowChangeModal(true);
  }} style={{ background: "#eff6ff", border: "none", borderRadius: 6, padding: "3px 8px", fontSize: 11, cursor: "pointer", color: "#2563eb", fontWeight: 600 }}>변경</button>
  <button onClick={e => { e.stopPropagation(); handleDelete(r.id); }}
    style={{ background: "#fff0f0", border: "none", borderRadius: 6, padding: "3px 8px", fontSize: 11, cursor: "pointer", color: "#ef4444", fontWeight: 600 }}>삭제</button>
</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* 오른쪽 - 달력 + 상세 */}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

          {/* 달력 */}
          <div style={{ background: "#fff", borderRadius: 14, padding: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
              <button onClick={() => setCalendarMonth(new Date(calYear, calMonth - 1))} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151", fontSize: 16 }}>‹</button>
              <span style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>{calYear}년 {calMonth + 1}월</span>
              <button onClick={() => setCalendarMonth(new Date(calYear, calMonth + 1))} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151", fontSize: 16 }}>›</button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2 }}>
              {dayNames.map((d, i) => (
                <div key={d} style={{ textAlign: "center", fontSize: 10, color: i === 0 ? "#ef4444" : i === 6 ? "#2563eb" : "#9ca3af", padding: "2px 0", fontWeight: 600 }}>{d}</div>
              ))}
              {calDays.map((d, i) => {
                if (!d) return <div key={i} />;
                const dateStr = `${calYear}-${String(calMonth + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
                const isSelected = dateStr === selectedDateStr;
                const isToday = dateStr === todayStr;
                const hasConsult = consultations.some(r => r.date === dateStr);
                const col = i % 7;
                return (
                  <div key={i} onClick={() => setSelectedDate(new Date(dateStr))} style={{
                    textAlign: "center", fontSize: 12, padding: "5px 2px", borderRadius: 6, cursor: "pointer",
                    background: isSelected ? "#2563eb" : "transparent",
                    color: isSelected ? "#fff" : isToday ? "#2563eb" : col === 0 ? "#ef4444" : col === 6 ? "#2563eb" : "#374151",
                    fontWeight: isSelected || isToday ? 700 : 400,
                  }}>
                    {d}
                    {hasConsult && !isSelected && <div style={{ width: 4, height: 4, background: "#2563eb", borderRadius: "50%", margin: "0 auto" }} />}
                  </div>
                );
              })}
            </div>

            {/* 담당자 필터 */}
            <div style={{ marginTop: 12, paddingTop: 12, borderTop: "1px solid #f3f4f6" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>담당자 선택</span>
                <button onClick={() => setSelectedTrainers([])} style={{ background: "none", border: "none", color: "#2563eb", fontSize: 11, cursor: "pointer" }}>전체</button>
              </div>
              {trainers.map(t => (
                <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                  <input type="checkbox" id={`ct-${t.id}`}
                    checked={selectedTrainers.includes(t.id)}
                    onChange={e => {
                      if (e.target.checked) setSelectedTrainers(p => [...p, t.id]);
                      else setSelectedTrainers(p => p.filter(id => id !== t.id));
                    }} />
                  <label htmlFor={`ct-${t.id}`} style={{ fontSize: 12, color: "#374151", cursor: "pointer" }}>{t.name}</label>
                </div>
              ))}
            </div>
          </div>

          {/* 선택된 상담 상세 */}
          {selectedConsult && (
            <div style={{ background: "#fff", borderRadius: 14, padding: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
  <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>{selectedConsult.member_name}님</div>
  <div style={{ display: "flex", gap: 8 }}>
    <button onClick={() => {
      setChangeTarget(selectedConsult);
      setChangeForm({
        date: selectedConsult.date,
        start_time: selectedConsult.start_time?.slice(0,5),
        end_time: selectedConsult.end_time?.slice(0,5),
        trainer_id: String(selectedConsult.trainer_id || ""),
        reason: ""
      });
      setShowChangeModal(true);
    }} style={{
      background: "#eff6ff", border: "none", borderRadius: 6,
      padding: "5px 12px", fontSize: 12, cursor: "pointer",
      color: "#2563eb", fontWeight: 600
    }}>
      변경
    </button>
    <button onClick={() => handleDelete(selectedConsult.id)}
      style={{ background: "none", border: "none", cursor: "pointer", color: "#ef4444" }}>
      <Icon name="x" size={18} color="#ef4444" />
    </button>
  </div>
</div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 3 }}>전화번호: {selectedConsult.phone || "-"}</div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 3 }}>상담유형: {TYPE_LABELS[selectedConsult.type]}</div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 3 }}>담당자: {selectedConsult.trainer_name || "-"}</div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 12 }}>시간대: {selectedConsult.start_time?.slice(0, 5)} ~ {selectedConsult.end_time?.slice(0, 5)}</div>

              <div style={{ background: "#fefce8", borderRadius: 8, padding: 12, marginBottom: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>상담 메모</div>
                <div style={{ fontSize: 12, color: "#6b7280" }}>{selectedConsult.memo || "메모가 없습니다"}</div>
              </div>
<button onClick={() => {
  setJournalTarget(selectedConsult);
  setJournalForm({ exercise_goal: [], exercise_experience: [], desired_program: [], inquiry_route: [], visit_route: [], content: selectedConsult.memo || "", summary: "", result: "" });
  setShowJournalModal(true);
}} style={{
  width: "100%", padding: "8px 0", borderRadius: 8, border: "none",
  background: "#f0fdf4", color: "#16a34a", fontSize: 12, fontWeight: 700, cursor: "pointer", marginBottom: 8
}}>📋 일지 작성</button>
<button onClick={() => loadLogs(selectedConsult.id)} style={{
  width: "100%", padding: "8px 0", borderRadius: 8, border: "1px solid #e5e7eb",
  background: "#fff", color: "#374151", fontSize: 12, fontWeight: 600, cursor: "pointer", marginBottom: 10
}}>📋 변경 이력 보기</button>

              <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 8 }}>상태 변경</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                <button onClick={() => handleStatusChange(selectedConsult.id, "COMPLETED")} style={{
                  padding: "8px 0", borderRadius: 8, border: "none",
                  background: "#f0fdf4", color: "#22c55e", fontSize: 13, fontWeight: 600, cursor: "pointer"
                }}>완료</button>
                <button onClick={() => handleStatusChange(selectedConsult.id, "CANCELLED")} style={{
                  padding: "8px 0", borderRadius: 8, border: "none",
                  background: "#fff0f0", color: "#ef4444", fontSize: 13, fontWeight: 600, cursor: "pointer"
                }}>취소</button>
                
              </div>
            </div>
          )}
        </div>
      </div>

{/* 일지 작성 모달 */}
{showJournalModal && journalTarget && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
    <div style={{ background: "#fff", borderRadius: 20, width: "100%", maxWidth: 600, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 24px 80px rgba(0,0,0,0.2)" }}>
      {/* 헤더 */}
      <div style={{ background: "#2563eb", borderRadius: "20px 20px 0 0", padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}>상담 일지 작성</div>
        <button onClick={() => setShowJournalModal(false)} style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", fontSize: 20 }}>×</button>
      </div>

      <div style={{ padding: 24 }}>
        {/* 기본 정보 */}
        <div style={{ background: "#f9fafb", borderRadius: 12, padding: 16, marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 12 }}>기본 정보</div>
          {journalTarget.id ? (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            {[
              { label: "상담자명", value: journalTarget.member_name || journalTarget.member_name_manual },
              { label: "전화번호", value: journalTarget.phone },
              { label: "상담 날짜", value: journalTarget.date },
              { label: "상담 시간", value: journalTarget.start_time?.slice(0, 5) || journalTarget.time },
              { label: "담당자", value: journalTarget.trainer_name },
              { label: "상담 유형", value: TYPE_LABELS[journalTarget.type] || journalTarget.consult_type },
            ].map((item, i) => (
              <div key={i}>
                <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 2 }}>{item.label}</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>{item.value || "-"}</div>
              </div>
            ))}
          </div>
) : (
  // 워크인 손님 - 직접 입력
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
    <div>
      <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>상담자명 *</div>
      <input value={journalTarget.member_name || ""} onChange={e => setJournalTarget(p => ({ ...p, member_name: e.target.value }))}
        placeholder="이름 입력" style={{ width: "100%", padding: "8px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, outline: "none", boxSizing: "border-box" }} />
    </div>
    <div>
      <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>전화번호</div>
      <input value={journalTarget.phone || ""} onChange={e => setJournalTarget(p => ({ ...p, phone: e.target.value }))}
        placeholder="010-0000-0000" style={{ width: "100%", padding: "8px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, outline: "none", boxSizing: "border-box" }} />
    </div>
    <div>
      <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>담당자</div>
      <select value={journalTarget.trainer_name || ""} onChange={e => setJournalTarget(p => ({ ...p, trainer_name: e.target.value }))}
        style={{ width: "100%", padding: "8px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, outline: "none" }}>
        <option value="">선택안함</option>
        {trainers.map(t => <option key={t.id} value={t.name}>{t.name}</option>)}
      </select>
    </div>
    <div>
      <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>상담 유형</div>
      <select value={journalTarget.type || ""} onChange={e => setJournalTarget(p => ({ ...p, type: e.target.value }))}
        style={{ width: "100%", padding: "8px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, outline: "none" }}>
        <option value="">선택안함</option>
        <option value="PT">개인PT 상담</option>
        <option value="GROUP">그룹GX 상담</option>
        <option value="MEMBERSHIP">회원권 상담</option>
        <option value="TRIAL">체험 상담</option>
      </select>
    </div>
  </div>
)}
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>상담 내용</div>
            <textarea value={journalForm.content} onChange={e => setJournalForm(p => ({ ...p, content: e.target.value }))}
              placeholder="상담 내용 간단 기재 요망" rows={3}
              style={{ width: "100%", padding: "10px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, resize: "vertical", boxSizing: "border-box", fontFamily: "inherit", outline: "none" }} />
          </div>
        </div>

        {/* 상담 상세 */}
        <div style={{ background: "#f9fafb", borderRadius: 12, padding: 16, marginBottom: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#111" }}>상담 상세</div>
            <button onClick={() => setShowSettingsModal(true)}
              style={{ display: "flex", alignItems: "center", gap: 4, padding: "5px 12px", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 12, cursor: "pointer", color: "#374151" }}>
              ⚙ 설정
            </button>
          </div>

          {[
            { key: "exercise_goal", label: "운동 목적", items: journalSettings.exercise_goals },
            { key: "exercise_experience", label: "운동 경험", items: journalSettings.exercise_experiences },
            { key: "desired_program", label: "희망 프로그램", items: journalSettings.desired_programs },
            { key: "inquiry_route", label: "문의 경로", items: journalSettings.inquiry_routes },
            { key: "visit_route", label: "방문 경로", items: journalSettings.visit_routes },
          ].map(({ key, label, items }) => (
            <div key={key} style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 8 }}>{label}</div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {items.map(item => {
                  const selected = journalForm[key]?.includes(item);
                  return (
                    <button key={item} onClick={() => {
                      setJournalForm(p => ({
                        ...p,
                        [key]: selected ? p[key].filter(v => v !== item) : [...(p[key] || []), item]
                      }));
                    }} style={{
                      padding: "6px 14px", borderRadius: 99, fontSize: 12, cursor: "pointer",
                      border: `1.5px solid ${selected ? "#2563eb" : "#e5e7eb"}`,
                      background: selected ? "#eff6ff" : "#fff",
                      color: selected ? "#2563eb" : "#374151",
                      fontWeight: selected ? 700 : 400
                    }}>{item}</button>
                  );
                })}
              </div>
            </div>
          ))}

          {/* 상담 요약 */}
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>상담 요약</div>
            <textarea value={journalForm.summary} onChange={e => setJournalForm(p => ({ ...p, summary: e.target.value }))}
              placeholder="상담 중 파악한 특이사항, 고민, 선호 시간대 등을 자유롭게 작성해주세요." rows={4}
              maxLength={500}
              style={{ width: "100%", padding: "10px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, resize: "vertical", boxSizing: "border-box", fontFamily: "inherit", outline: "none" }} />
            <div style={{ textAlign: "right", fontSize: 11, color: "#9ca3af" }}>{journalForm.summary?.length || 0} / 500자</div>
          </div>
        </div>

        {/* 결과 버튼 */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
          {[
            { key: "success", label: "✓ 성공", color: "#22c55e", bg: "#f0fdf4" },
            { key: "failed", label: "✗ 실패", color: "#ef4444", bg: "#fff0f0" },
            { key: "pending", label: "⏳ 보류", color: "#f97316", bg: "#fff7ed" },
          ].map(({ key, label, color, bg }) => (
            <button key={key} onClick={() => setJournalForm(p => ({ ...p, result: key }))}
              style={{
                padding: "12px 0", borderRadius: 10, border: `2px solid ${journalForm.result === key ? color : "#e5e7eb"}`,
                background: journalForm.result === key ? bg : "#fff",
                color: journalForm.result === key ? color : "#9ca3af",
                fontSize: 14, fontWeight: 700, cursor: "pointer"
              }}>{label}</button>
          ))}
        </div>

        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={() => setShowJournalModal(false)}
            style={{ flex: 1, padding: 14, border: "1px solid #e5e7eb", borderRadius: 10, background: "#fff", fontSize: 14, cursor: "pointer" }}>취소</button>
         <button onClick={async () => {
            if (!journalForm.result) { addToast("결과를 선택해주세요", "error"); return; }
            try {
              // 기존 일지인지 신규 일지인지 판단
              const isExisting = !!journalTarget.id && !!journalTarget.result;
              
              if (isExisting) {
                // 기존 일지: 상태만 PATCH로 업데이트
                await api(`/consultation-journal/${journalTarget.id}/result`, {
                  method: "PATCH",
                  body: JSON.stringify({ result: journalForm.result })
                }, token);
              } else {
                // 신규 일지: POST로 저장
                await api("/consultation-journal", {
                  method: "POST",
                  body: JSON.stringify({
                    tenant_id: 1,
                    consultation_id: journalTarget.id,
                    member_name: journalTarget.member_name || journalTarget.member_name_manual,
                    phone: journalTarget.phone,
                    date: journalTarget.date,
                    time: journalTarget.start_time?.slice(0, 5) || journalTarget.time,
                    trainer_name: journalTarget.trainer_name,
                    consult_type: TYPE_LABELS[journalTarget.type] || journalTarget.consult_type,
                    content: journalForm.content,
                    exercise_goal: journalForm.exercise_goal?.join(","),
                    exercise_experience: journalForm.exercise_experience?.join(","),
                    desired_program: journalForm.desired_program?.join(","),
                    inquiry_route: journalForm.inquiry_route?.join(","),
                    visit_route: journalForm.visit_route?.join(","),
                    summary: journalForm.summary,
                    result: journalForm.result,
                  })
                }, token);
              }
              
              if (journalForm.result === "success") {
                // 성공 시 결제 확인 모달로 이동
                setShowJournalModal(false);
                setShowJournalPayConfirm(true);
              } else {
                addToast("일지가 저장됐습니다", "success");
                setShowJournalModal(false);
                api("/consultation-journal/list?tenant_id=1", {}, token).then(d => setJournals(Array.isArray(d) ? d : [])).catch(() => {});
              }
            } catch(e) { addToast("저장 실패: " + e.message, "error"); }
          }} style={{ flex: 2, padding: 14, border: "none", borderRadius: 10, background: "#2563eb", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
            저장하기
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{/* 성공 시 상품 선택 모달 */}
{/* 일지 성공 - 결제 확인 모달 */}
{showJournalPayConfirm && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
    <div style={{ background: "#fff", borderRadius: 20, width: "100%", maxWidth: 400, padding: 28, boxShadow: "0 24px 80px rgba(0,0,0,0.2)" }}>
      <div style={{ fontSize: 18, fontWeight: 700, color: "#111", marginBottom: 8, textAlign: "center" }}>🎉 상담 성공!</div>
      <div style={{ fontSize: 14, color: "#6b7280", marginBottom: 24, textAlign: "center", lineHeight: 1.5 }}>
        일지가 저장됐습니다.<br />지금 결제를 진행하시겠습니까?
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <button onClick={() => {
          setShowJournalPayConfirm(false);
          setShowJournalPaymentWizard(true);
        }}
          style={{ width: "100%", padding: 14, border: "none", borderRadius: 12, background: "#2563eb", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer" }}>
          💳 결제하기
        </button>
        <button onClick={() => {
          setShowJournalPayConfirm(false);
          addToast("일지가 저장됐습니다. 나중에 결제 메뉴에서 결제하세요.", "success");
          api("/consultation-journal/list?tenant_id=1", {}, token).then(d => setJournals(Array.isArray(d) ? d : [])).catch(() => {});
        }}
          style={{ width: "100%", padding: 14, border: "1px solid #e5e7eb", borderRadius: 12, background: "#fff", color: "#374151", fontSize: 15, fontWeight: 600, cursor: "pointer" }}>
          저장만 하기
        </button>
      </div>
    </div>
  </div>
)}

{/* 일지 성공 - 결제 위자드 (4단계) */}
<PaymentWizard
  open={showJournalPaymentWizard}
  onClose={() => setShowJournalPaymentWizard(false)}
  onSuccess={() => {
    setShowJournalPaymentWizard(false);
    api("/consultation-journal/list?tenant_id=1", {}, token).then(d => setJournals(Array.isArray(d) ? d : [])).catch(() => {});
  }}
  defaultMember={null}
  token={token}
  addToast={addToast}
  plans={plans}
  trainers={trainers}
  modusignTemplates={[]}
  visitRouteOptions={["온라인", "지인 소개", "SNS", "현수막", "블로그", "기타"]}
  members={members}
/>

{/* 설정 모달 */}
{showSettingsModal && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
    <div style={{ background: "#fff", borderRadius: 20, width: "100%", maxWidth: 680, maxHeight: "90vh", overflow: "hidden", display: "flex", boxShadow: "0 24px 80px rgba(0,0,0,0.2)" }}>
      {/* 좌측 메뉴 */}
      <div style={{ width: 160, background: "#f9fafb", padding: 16, borderRight: "1px solid #f3f4f6" }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 16 }}>상담 항목 설정</div>
        {[
          { key: "exercise_goals", label: "운동 목적" },
          { key: "exercise_experiences", label: "운동 경험" },
          { key: "desired_programs", label: "희망 프로그램" },
          { key: "inquiry_routes", label: "문의 경로" },
          { key: "visit_routes", label: "방문 경로" },
        ].map(({ key, label }) => (
          <button key={key} onClick={() => { setSettingsEdit(key); setNewItemText(""); }}
            style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 13, textAlign: "left", marginBottom: 4,
              background: settingsEdit === key ? "#2563eb" : "transparent",
              color: settingsEdit === key ? "#fff" : "#374151",
              fontWeight: settingsEdit === key ? 700 : 400
            }}>{label}</button>
        ))}
      </div>

      {/* 우측 내용 */}
      <div style={{ flex: 1, padding: 24, overflowY: "auto" }}>
        {!settingsEdit ? (
          <div style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>왼쪽 메뉴에서 항목을 선택해주세요</div>
        ) : (
          <>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 16 }}>
              {settingsEdit === "exercise_goals" ? "운동 목적" : settingsEdit === "exercise_experiences" ? "운동 경험" : settingsEdit === "desired_programs" ? "희망 프로그램" : settingsEdit === "inquiry_routes" ? "문의 경로" : "방문 경로"} 관리
            </div>

            {/* 새 항목 추가 */}
            <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
              <input value={newItemText} onChange={e => setNewItemText(e.target.value)}
                placeholder="새 항목 입력"
                style={{ flex: 1, padding: "10px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, outline: "none" }} />
              <button onClick={() => {
                if (!newItemText.trim()) return;
                setJournalSettings(p => ({ ...p, [settingsEdit]: [...(p[settingsEdit] || []), newItemText.trim()] }));
                setNewItemText("");
              }} style={{ padding: "10px 16px", background: "#2563eb", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>+ 추가</button>
            </div>

            {/* 항목 목록 */}
            {(journalSettings[settingsEdit] || []).map((item, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", background: "#f9fafb", borderRadius: 8, marginBottom: 8 }}>
                <span style={{ fontSize: 13, color: "#111" }}>{item}</span>
                <div style={{ display: "flex", gap: 8 }}>
                  <button onClick={() => setJournalSettings(p => ({ ...p, [settingsEdit]: p[settingsEdit].filter((_, j) => j !== i) }))}
                    style={{ background: "none", border: "none", cursor: "pointer", color: "#ef4444", fontSize: 16 }}>🗑</button>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>

    {/* 설정 모달 하단 버튼 */}
    <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }} />
    <div style={{ display: "flex", gap: 10, padding: 20 }}>
      <button onClick={() => setShowSettingsModal(false)}
        style={{ padding: "12px 24px", border: "1px solid #e5e7eb", borderRadius: 10, background: "#fff", cursor: "pointer", fontSize: 14 }}>취소</button>
      <button onClick={async () => {
        try {
          await api("/consultation-journal/settings", {
            method: "POST",
            body: JSON.stringify({ ...journalSettings, tenant_id: 1 })
          }, token);
          addToast("설정이 저장됐습니다", "success");
          setShowSettingsModal(false);
        } catch(e) { addToast("저장 실패: " + e.message, "error"); }
      }} style={{ padding: "12px 24px", border: "none", borderRadius: 10, background: "#2563eb", color: "#fff", cursor: "pointer", fontSize: 14, fontWeight: 700 }}>저장하기</button>
    </div>
  </div>
)}

{/* 변경 모달 */}
{showChangeModal && changeTarget && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
    <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 480, boxShadow: "0 20px 60px rgba(0,0,0,0.15)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#111" }}>일정 변경 - {changeTarget.member_name}님</h3>
        <button onClick={() => setShowChangeModal(false)} style={{ background: "#f3f4f6", border: "none", borderRadius: 8, padding: "6px 8px", cursor: "pointer", fontSize: 16, color: "#6b7280" }}>×</button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
        <Input label="날짜" value={changeForm.date} onChange={e => setChangeForm(p => ({ ...p, date: e.target.value }))} type="date" />
        <Select label="담당자" value={changeForm.trainer_id} onChange={e => setChangeForm(p => ({ ...p, trainer_id: e.target.value }))}>
          <option value="">선택안함</option>
          {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
        </Select>
      </div>
     <div style={{ marginBottom: 12 }}>
        <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>변경 시간</label>
        <TimePicker value={changeForm.start_time} onChange={v => {
          const [h, m] = v.split(":").map(Number);
          const endH = (h + 1) % 24;
          const endTime = `${String(endH).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
          setChangeForm(p => ({ ...p, start_time: v, end_time: endTime }));
        }} />
      </div>

      <div style={{ marginBottom: 20 }}>
        <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>변경 사유 *</label>
        <textarea value={changeForm.reason} onChange={e => setChangeForm(p => ({ ...p, reason: e.target.value }))}
          placeholder="변경 사유를 입력해주세요" rows={3}
          style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "none", fontFamily: "inherit" }} />
      </div>

      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <Btn variant="secondary" onClick={() => setShowChangeModal(false)}>취소</Btn>
        <Btn onClick={handleChange} disabled={saving}>{saving ? "저장 중..." : "변경하기"}</Btn>
      </div>
    </div>
  </div>
)}

{/* 변경 이력 모달 */}
{showLogs && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
    <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 560, maxHeight: "80vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px rgba(0,0,0,0.15)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#111" }}>변경 이력</h3>
        <button onClick={() => setShowLogs(false)} style={{ background: "#f3f4f6", border: "none", borderRadius: 8, padding: "6px 8px", cursor: "pointer", fontSize: 16, color: "#6b7280" }}>×</button>
      </div>
      <div style={{ flex: 1, overflowY: "auto" }}>
        {consultLogs.length === 0 ? (
          <div style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>변경 이력이 없습니다</div>
        ) : consultLogs.map((log, i) => (
          <div key={i} style={{ padding: "14px 0", borderBottom: "1px solid #f3f4f6" }}>
            <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 8 }}>{log.created_at?.slice(0, 16)}</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", gap: 8, marginBottom: 8, alignItems: "center" }}>
              <div style={{ background: "#f9fafb", borderRadius: 8, padding: "8px 12px", fontSize: 12 }}>
                <div style={{ color: "#9ca3af", marginBottom: 4 }}>변경 전</div>
                <div style={{ color: "#374151" }}>{log.before_date}</div>
                <div style={{ color: "#374151" }}>{log.before_start_time?.slice(0,5)} ~ {log.before_end_time?.slice(0,5)}</div>
                <div style={{ color: "#374151" }}>{log.before_trainer_name || "-"}</div>
              </div>
              <div style={{ color: "#9ca3af", fontSize: 16 }}>→</div>
              <div style={{ background: "#eff6ff", borderRadius: 8, padding: "8px 12px", fontSize: 12 }}>
                <div style={{ color: "#2563eb", marginBottom: 4 }}>변경 후</div>
                <div style={{ color: "#374151" }}>{log.after_date}</div>
                <div style={{ color: "#374151" }}>{log.after_start_time?.slice(0,5)} ~ {log.after_end_time?.slice(0,5)}</div>
                <div style={{ color: "#374151" }}>{log.after_trainer_name || "-"}</div>
              </div>
            </div>
            {log.reason && (
              <div style={{ background: "#fefce8", borderRadius: 8, padding: "8px 12px", fontSize: 12, color: "#374151" }}>
                📝 사유: {log.reason}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  </div>
)}
      {/* 상담 일정 추가 모달 */}
      {showAddModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 560, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.15)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 22 }}>
              <h3 style={{ color: "#111", margin: 0, fontSize: 16, fontWeight: 700 }}>상담 일정 추가</h3>
              <button onClick={() => setShowAddModal(false)} style={{ background: "#f3f4f6", border: "none", color: "#6b7280", cursor: "pointer", borderRadius: 8, padding: "6px 8px" }}>×</button>
            </div>

            {/* 날짜 + 시간 */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
              <Input label="상담 날짜 *" value={form.date} onChange={e => setForm(p => ({ ...p, date: e.target.value }))} type="date" />
              <div>
  <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>상담 시간 *</label>
  <TimePicker value={form.start_time} onChange={v => {
    const [h, m] = v.split(":").map(Number);
    const endH = (h + 1) % 24;
    const endTime = `${String(endH).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    setForm(p => ({ ...p, start_time: v, end_time: endTime }));
  }} />
</div>
            </div>

            {/* 상담자명 + 전화번호 */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
              <div style={{ position: "relative" }}>
                <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>상담자명 *</label>
                <input value={form.member_search} onChange={e => {
                  setForm(p => ({ ...p, member_search: e.target.value, member_id: "", member_name_manual: e.target.value }));
                }}
                  placeholder="이름 검색 또는 직접 입력"
                  style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#f9fafb" }} />
                {form.member_search && !form.member_id && members.filter(m => m.name?.includes(form.member_search)).length > 0 && (
                  <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 100, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 4px 16px rgba(0,0,0,0.1)", maxHeight: 160, overflowY: "auto" }}>
                    {members.filter(m => m.name?.includes(form.member_search)).map(m => (
                      <div key={m.id} onClick={() => setForm(p => ({ ...p, member_id: String(m.id), member_search: m.name, member_name_manual: m.name, phone: m.phone || "" }))}
                        style={{ padding: "10px 16px", cursor: "pointer", fontSize: 13, color: "#374151", borderBottom: "1px solid #f3f4f6" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                        onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "#fff" }}>
                        {m.name} <span style={{ color: "#9ca3af", fontSize: 11 }}>{m.phone}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <Input label="전화번호 *" value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} placeholder="010-0000-0000" />
            </div>

            {/* 담당자 */}
            <div style={{ marginBottom: 12 }}>
              <Select label="담당자명 *" value={form.trainer_id} onChange={e => setForm(p => ({ ...p, trainer_id: e.target.value }))}>
                <option value="">담당자를 선택해주세요</option>
                {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
              </Select>
            </div>

            {/* 상담 유형 */}
            <div style={{ marginBottom: 12 }}>
              <Select label="상담 유형" value={form.type} onChange={e => setForm(p => ({ ...p, type: e.target.value }))}>
                <option value="PT">개인PT 상담</option>
                <option value="GROUP">그룹GX 상담</option>
                <option value="MEMBERSHIP">회원권 상담</option>
                <option value="TRIAL">체험 상담</option>
              </Select>
            </div>

            {/* 상담 메모 */}
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>상담 메모</label>
              <textarea value={form.memo} onChange={e => setForm(p => ({ ...p, memo: e.target.value }))}
                placeholder="상담 내용이나 특이사항을 입력하세요" rows={4}
                style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, color: "#111", padding: "10px 12px", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "vertical", fontFamily: "inherit" }} />
            </div>

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <Btn variant="secondary" onClick={() => setShowAddModal(false)}>취소</Btn>
              <Btn onClick={handleCreate} disabled={saving}>{saving ? "저장 중..." : "저장하기"}</Btn>
            </div>
          </div>
        </div>
         )}


      {/* 상담 일지 관리 탭 */}
      {consultTab === "journal" && (
        <div style={{ background: "#fff", borderRadius: 14, padding: 20, border: "1px solid #f3f4f6", marginBottom: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>상담 일지 목록</div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>전체 상담 이력 관리 · 필터로 상태별 조회</div>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              {[
                { key: "all", label: "전체" },
                { key: "success", label: "성공" },
                { key: "pending", label: "보류" },
                { key: "failed", label: "실패" },
                { key: "cancelled", label: "취소" },
              ].map(f => (
                <button key={f.key} onClick={() => setJournalFilter(f.key)} style={{
                  padding: "6px 14px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 12, cursor: "pointer",
                  background: journalFilter === f.key ? "#2563eb" : "#fff",
                  color: journalFilter === f.key ? "#fff" : "#374151",
                  fontWeight: journalFilter === f.key ? 700 : 400
                }}>
                  {f.label}
                </button>
              ))}
              <button onClick={async () => {
                const filtered = journalFilter === "all" ? journals : journals.filter(j => j.result === journalFilter);
                const resultLabel = (r) => r === "success" ? "성공" : r === "pending" ? "보류" : r === "failed" ? "실패" : r === "cancelled" ? "취소" : r;
                const csv = [["상담날짜","시간","상담자명","전화번호","담당자","상담유형","문의경로","방문경로","결과","상담요약"],
                  ...filtered.map(j => [j.date, j.time, j.member_name, j.phone, j.trainer_name, j.consult_type, j.inquiry_route, j.visit_route, resultLabel(j.result), j.summary])
                ].map(r => r.join(",")).join("\n");
                const blob = new Blob(["\uFEFF" + csv], { type: "text/csv" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a"); a.href = url; a.download = "상담일지.csv"; a.click();
              }} style={{ padding: "6px 14px", borderRadius: 8, border: "none", background: "#22c55e", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                📊 엑셀 다운로드
              </button>
            </div>
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#f9fafb" }}>
                {["상담 날짜", "상담 시간", "상담자명", "전화번호", "담당자명", "상담 유형", "상태", "일지 작성"].map(h => (
                  <th key={h} style={{ padding: "10px 16px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(() => {
                const filtered = journalFilter === "all" ? journals : journals.filter(j => j.result === journalFilter);
                if (filtered.length === 0) {
                  return <tr><td colSpan={8} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>상담 일지 내역이 없습니다</td></tr>;
                }
                return filtered.map((j, i) => {
                  const statusStyle = 
                    j.result === "success" ? { bg: "#f0fdf4", color: "#16a34a", label: "✓ 성공" } :
                    j.result === "pending" ? { bg: "#fff7ed", color: "#f97316", label: "⏳ 보류" } :
                    j.result === "failed" ? { bg: "#fff0f0", color: "#ef4444", label: "✗ 실패" } :
                    j.result === "cancelled" ? { bg: "#f3f4f6", color: "#6b7280", label: "✕ 취소" } :
                    { bg: "#f3f4f6", color: "#6b7280", label: j.result || "-" };
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #f9fafb" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                      onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
                      <td style={{ padding: "12px 16px", color: "#374151" }}>{j.date}</td>
                      <td style={{ padding: "12px 16px", color: "#374151" }}>{j.time}</td>
                      <td style={{ padding: "12px 16px", fontWeight: 600, color: "#111" }}>{j.member_name}</td>
                      <td style={{ padding: "12px 16px", color: "#374151" }}>{j.phone}</td>
                      <td style={{ padding: "12px 16px", color: "#374151" }}>{j.trainer_name}</td>
                      <td style={{ padding: "12px 16px", color: "#374151" }}>{j.consult_type}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{ background: statusStyle.bg, color: statusStyle.color, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700 }}>
                          {statusStyle.label}
                        </span>
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        <button onClick={() => {
                          setJournalTarget(j);
                          setJournalForm({ exercise_goal: j.exercise_goal ? j.exercise_goal.split(",") : [], exercise_experience: j.exercise_experience ? j.exercise_experience.split(",") : [], desired_program: j.desired_program ? j.desired_program.split(",") : [], inquiry_route: j.inquiry_route ? j.inquiry_route.split(",") : [], visit_route: j.visit_route ? j.visit_route.split(",") : [], content: j.content || "", summary: j.summary || "", result: j.result || "" });
                          setShowJournalModal(true);
                        }} style={{ padding: "4px 12px", background: "#eff6ff", border: "none", borderRadius: 6, fontSize: 11, color: "#2563eb", fontWeight: 600, cursor: "pointer" }}>
                          📋 일지 보기
                        </button>
                      </td>
                    </tr>
                  );
                });
              })()}
            </tbody>
          </table>
        </div>
      )}
    

 {/* 하단 통계 섹션 */}
      {consultTab === "schedule" && (
        <div style={{ marginTop: 24, background: "#fff", border: "1px solid #f3f4f6", borderRadius: 12, overflow: "hidden" }}>

          {/* 헤더 + 월 선택기 */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", borderBottom: "1px solid #f3f4f6" }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>상담 통계</div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, border: "1px solid #e5e7eb", borderRadius: 6, padding: "4px 10px" }}>
              <button onClick={() => {
                const d = new Date(statsMonth);
                d.setMonth(d.getMonth() - 1);
                setStatsMonth(d);
              }} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151", fontSize: 14, padding: 0 }}>‹</button>
              <span style={{ fontSize: 12, fontWeight: 600, color: "#374151", minWidth: 80, textAlign: "center" }}>
                {statsMonth.getFullYear()}년 {statsMonth.getMonth() + 1}월
              </span>
              <button onClick={() => {
                const d = new Date(statsMonth);
                d.setMonth(d.getMonth() + 1);
                setStatsMonth(d);
              }} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151", fontSize: 14, padding: 0 }}>›</button>
            </div>
          </div>

          {/* 2x2 grid */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>

            {/* 섹션1: 전체 상담 전환율 */}
            <div style={{ padding: "16px 18px", borderRight: "1px solid #f3f4f6", borderBottom: "1px solid #f3f4f6" }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 2 }}>전체 상담 전환율</div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 12 }}>이달의 상담 전환율</div>
              {(() => {
                const monthStr = `${statsMonth.getFullYear()}-${String(statsMonth.getMonth() + 1).padStart(2, "0")}`;
                const monthData = journals.filter(j => j.date?.startsWith(monthStr));
                const success = monthData.filter(j => j.result === "success").length;
                const fail = monthData.filter(j => j.result === "failed").length;
                const pending = monthData.filter(j => j.result === "pending").length;
                const total = success + fail + pending || 1;
                const successPct = Math.round(success / total * 100);
                const failPct = Math.round(fail / total * 100);
                const pendingPct = 100 - successPct - failPct;
                const segments = [
                  { label: "성공", count: success, pct: successPct, color: "#5A8AFE" },
                  { label: "실패", count: fail, pct: failPct, color: "#FF6B6B" },
                  { label: "보류", count: pending, pct: pendingPct, color: "#FFD166" },
                ];
                let cumulative = 0;
                const r = 50, cx = 65, cy = 65, strokeWidth = 20;
                const circumference = 2 * Math.PI * r;
                return (
                  <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                    <svg width={130} height={130} viewBox="0 0 130 130">
                      <circle cx={cx} cy={cy} r={r} fill="none" stroke="#f3f4f6" strokeWidth={strokeWidth} />
                      {segments.map((seg, i) => {
                        const rotation = -90 + cumulative * 3.6;
                        cumulative += seg.pct;
                        return (
                          <circle key={i} cx={cx} cy={cy} r={r} fill="none"
                            stroke={seg.color} strokeWidth={strokeWidth}
                            strokeDasharray={`${(seg.pct / 100) * circumference} ${circumference}`}
                            strokeDashoffset={0}
                            transform={`rotate(${rotation} ${cx} ${cy})`}
                            style={{ transition: "all 0.5s" }}
                          />
                        );
                      })}
                      <text x={cx} y={cy - 4} textAnchor="middle" fontSize={10} fill="#9ca3af">성공</text>
                      <text x={cx} y={cy + 10} textAnchor="middle" fontSize={18} fontWeight={700} fill="#111">{successPct}%</text>
                    </svg>
                    <div style={{ flex: 1 }}>
                      {segments.map((seg, i) => (
                        <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <div style={{ width: 8, height: 8, borderRadius: "50%", background: seg.color }} />
                            <span style={{ fontSize: 12, color: "#374151" }}>{seg.label}</span>
                          </div>
                          <span style={{ fontSize: 12, fontWeight: 700, color: "#111" }}>{seg.count}건</span>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>

            {/* 섹션2: 상담 직원별 전환율 */}
            <div style={{ padding: "16px 18px", borderBottom: "1px solid #f3f4f6" }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 2 }}>상담 직원별 전환율</div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 12 }}>이달의 직원별 상담 전환율</div>
              {(() => {
                const monthStr = `${statsMonth.getFullYear()}-${String(statsMonth.getMonth() + 1).padStart(2, "0")}`;
                const monthData = journals.filter(j => j.date?.startsWith(monthStr));
                const trainerMap = {};
                monthData.forEach(j => {
                  const name = j.trainer_name || "미배정";
                  if (!trainerMap[name]) trainerMap[name] = { success: 0, fail: 0, pending: 0 };
                  if (j.result === "success") trainerMap[name].success++;
                  else if (j.result === "failed") trainerMap[name].fail++;
                  else trainerMap[name].pending++;
                });
                const trainers = Object.entries(trainerMap);
                if (trainers.length === 0) return <div style={{ color: "#9ca3af", fontSize: 12 }}>데이터 없음</div>;
                return (
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {trainers.map(([name, d], i) => {
                      const total = d.success + d.fail + d.pending || 1;
                      const sPct = Math.round(d.success / total * 100);
                      const fPct = Math.round(d.fail / total * 100);
                      const pPct = 100 - sPct - fPct;
                      return (
                        <div key={i}>
                          <div style={{ fontSize: 11, color: "#374151", fontWeight: 600, marginBottom: 3 }}>{name}</div>
                          <div style={{ display: "flex", height: 18, borderRadius: 4, overflow: "hidden" }}>
                            {sPct > 0 && <div style={{ width: `${sPct}%`, background: "#5A8AFE", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#fff", fontWeight: 700 }}>{sPct}%</div>}
                            {fPct > 0 && <div style={{ width: `${fPct}%`, background: "#FF6B6B", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#fff", fontWeight: 700 }}>{fPct}%</div>}
                            {pPct > 0 && <div style={{ width: `${pPct}%`, background: "#FFD166", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#fff", fontWeight: 700 }}>{pPct}%</div>}
                          </div>
                        </div>
                      );
                    })}
                    <div style={{ display: "flex", gap: 14, marginTop: 4 }}>
                      {[["성공", "#5A8AFE"], ["실패", "#FF6B6B"], ["보류", "#FFD166"]].map(([label, color]) => (
                        <div key={label} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <div style={{ width: 8, height: 8, borderRadius: 2, background: color }} />
                          <span style={{ fontSize: 10, color: "#9ca3af" }}>{label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>

            {/* 섹션3: 상담 문의 경로 */}
            <div style={{ padding: "16px 18px", borderRight: "1px solid #f3f4f6" }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 2 }}>상담 문의 경로</div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 12 }}>이달의 상담 문의 경로 (일지 기반)</div>
              {(() => {
                const monthStr = `${statsMonth.getFullYear()}-${String(statsMonth.getMonth() + 1).padStart(2, "0")}`;
                const monthData = journals.filter(j => j.date?.startsWith(monthStr));
                const routeMap = {};
                monthData.forEach(j => {
                  if (!j.inquiry_route) return;
                  j.inquiry_route.split(",").forEach(r => {
                    const route = r.trim();
                    if (route) routeMap[route] = (routeMap[route] || 0) + 1;
                  });
                });
                const routes = Object.entries(routeMap).sort((a, b) => b[1] - a[1]);
                const maxVal = routes[0]?.[1] || 1;
                const totalCount = Object.values(routeMap).reduce((a, b) => a + b, 0);
                if (routes.length === 0) return <div style={{ color: "#9ca3af", fontSize: 12 }}>데이터 없음 (일지에서 문의경로를 선택하세요)</div>;
                return (
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {routes.map(([name, count], i) => {
                      const pct = Math.round(count / totalCount * 100);
                      const isMax = count === maxVal;
                      return (
                        <div key={i}>
                          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                            <span style={{ fontSize: 11, color: isMax ? "#5A8AFE" : "#374151", fontWeight: isMax ? 700 : 400 }}>{name}</span>
                            <span style={{ fontSize: 11, color: "#9ca3af" }}>{pct}% ({count}건)</span>
                          </div>
                          <div style={{ height: 6, background: "#f3f4f6", borderRadius: 3, overflow: "hidden" }}>
                            <div style={{ height: "100%", width: `${pct}%`, background: isMax ? "#5A8AFE" : "#93B4FF", borderRadius: 3, transition: "width 0.5s" }} />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>

            {/* 섹션4: 상담 방문 경로 */}
            <div style={{ padding: "16px 18px" }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 2 }}>상담 방문 경로</div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 12 }}>이달의 상담 방문 경로 (일지 기반)</div>
              {(() => {
                const monthStr = `${statsMonth.getFullYear()}-${String(statsMonth.getMonth() + 1).padStart(2, "0")}`;
                const monthData = journals.filter(j => j.date?.startsWith(monthStr));
                const routeMap = {};
                monthData.forEach(j => {
                  if (!j.visit_route) return;
                  j.visit_route.split(",").forEach(r => {
                    const route = r.trim();
                    if (!route) return;
                    if (!routeMap[route]) routeMap[route] = { total: 0, success: 0 };
                    routeMap[route].total++;
                    if (j.result === "success") routeMap[route].success++;
                  });
                });
                const routes = Object.entries(routeMap).sort((a, b) => b[1].total - a[1].total);
                if (routes.length === 0) return <div style={{ color: "#9ca3af", fontSize: 12 }}>데이터 없음 (일지에서 방문경로를 선택하세요)</div>;
                const maxTotal = Math.max(...routes.map(([_, d]) => d.total), 1);
                return (
                  <div style={{ display: "flex", alignItems: "flex-end", gap: 10, height: 120, paddingBottom: 16 }}>
                    {routes.map(([name, d], i) => {
                      const heightPct = Math.round(d.total / maxTotal * 90);
                      return (
                        <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", height: "100%", justifyContent: "flex-end" }}>
                          <span style={{ fontSize: 10, fontWeight: 700, color: "#5A8AFE", marginBottom: 3 }}>{d.total}건</span>
                          <div style={{ width: "100%", background: "#5A8AFE", borderRadius: "3px 3px 0 0", height: `${Math.max(heightPct, 5)}%`, minHeight: 4, transition: "height 0.5s" }} />
                          <span style={{ fontSize: 10, color: "#9ca3af", marginTop: 4, textAlign: "center", wordBreak: "keep-all" }}>{name}</span>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>

          </div>
        </div>
      )}
         </div>      
  );             
};               

// ════════════════════════════════════════════════════════════════════════════
// SALES PAGE (매출통계)
// ════════════════════════════════════════════════════════════════════════════
const SalesPage = ({ token, addToast }) => {
  const [summary, setSummary] = useState(null);
  const [insights, setInsights] = useState(null);
  const [dailyData, setDailyData] = useState([]);
  const [weeklyData, setWeeklyData] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [trainerData, setTrainerData] = useState([]);
  const [genderData, setGenderData] = useState(null);
  const [visitRouteData, setVisitRouteData] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [periodTab, setPeriodTab] = useState("daily");
  const [viewMode, setViewMode] = useState("list");
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(ymdKST().slice(0, 8) + "01");
  const [endDate, setEndDate] = useState(ymdKST());
  const [goalAmount, setGoalAmount] = useState(10000000);
  const [showGoalModal, setShowGoalModal] = useState(false);
  const [goalInput, setGoalInput] = useState("10000000");
  const [expandedRows, setExpandedRows] = useState([]);
  const [receiptModal, setReceiptModal] = React.useState({ open: false, paymentId: null });
  const [showUnpaidModal, setShowUnpaidModal] = useState(false);
  const year = currentMonth.getFullYear();
  const month = currentMonth.getMonth() + 1;

  const pctText = (v) => v == null ? "–" : `${v >= 0 ? "▲" : "▼"} ${Math.abs(v)}%`;
  const pctColor = (v) => v == null ? "#9ca3af" : (v >= 0 ? "#16a34a" : "#ef4444");
  const pctBg = (v) => v == null ? "#f3f4f6" : (v >= 0 ? "#ecfdf5" : "#fef2f2");
  const wonStr = (n) => `${Number(n || 0).toLocaleString()}원`;

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [sum, ins, daily, weekly, monthly, products, top, trainers, gender, visitRoute, payments] = await Promise.all([
        api(`/sales/summary?tenant_id=1&year=${year}&month=${month}`, {}, token),
        api(`/sales/insights?tenant_id=1`, {}, token),
        api(`/sales/daily?tenant_id=1&year=${year}&month=${month}`, {}, token),
        api(`/sales/weekly?tenant_id=1&year=${year}&month=${month}`, {}, token),
        api(`/sales/monthly?tenant_id=1&year=${year}`, {}, token),
        api(`/sales/by-product?tenant_id=1&year=${year}&month=${month}`, {}, token),
        api(`/sales/top-products?tenant_id=1&year=${year}&month=${month}`, {}, token),
        api(`/sales/by-trainer?tenant_id=1&year=${year}&month=${month}`, {}, token),
        api(`/sales/gender-stats?tenant_id=1`, {}, token),
        api(`/sales/visit-route?tenant_id=1`, {}, token),
        api(`/payment/list?tenant_id=1`, {}, token),
      ]);
      setSummary(sum);
      setInsights(ins && !ins.error ? ins : null);
      setDailyData(Array.isArray(daily) ? daily : []);
      setWeeklyData(Array.isArray(weekly) ? weekly : []);
      setMonthlyData(Array.isArray(monthly) ? monthly : []);
      setProductData(Array.isArray(products) ? products : []);
      setTopProducts(Array.isArray(top) ? top : []);
      setTrainerData(Array.isArray(trainers) ? trainers : []);
      setGenderData(gender);
      setVisitRouteData([]);
      setPaymentList(Array.isArray(payments) ? payments : []);
    } catch (e) { addToast("데이터 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token, year, month]);

  useEffect(() => { load(); }, [load]);

  // 목표 매출 로드 (백엔드 저장값, 앱·웹 공유)
  useEffect(() => {
    api(`/dashboard/sales-goal`, {}, token)
      .then(r => { if (r && Number(r.goal) > 0) { setGoalAmount(Number(r.goal)); setGoalInput(String(r.goal)); } })
      .catch(() => {});
  }, [token]);

  const moveMonth = (dir) => {
    const d = new Date(currentMonth);
    d.setMonth(d.getMonth() + dir);
    setCurrentMonth(d);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
    setStartDate(`${y}-${m}-01`);
    setEndDate(`${y}-${m}-${String(lastDay).padStart(2, "0")}`);
  };

  // 날짜 범위 필터링된 결제 목록
  const filteredPayments = paymentList.filter(p => {
    const d = p.created_at?.slice(0, 10);
    return d >= startDate && d <= endDate;
  });

  const filteredTotal = filteredPayments.filter(p => p.status === 'approved').reduce((s, p) => s + Number(p.amount || 0), 0);
  const filteredRefund = filteredPayments.filter(p => p.status === 'cancelled').reduce((s, p) => s + Number(p.amount || 0), 0);
  const filteredUnpaid = filteredPayments.reduce((s, p) => { if (p.status === 'pending') return s + Number(p.amount || 0); if (p.unpaid_amount && Number(p.unpaid_amount) > 0) return s + Number(p.unpaid_amount); return s; }, 0);
  const filteredNet = filteredTotal - filteredRefund;

  // 주차 계산 헬퍼
const getWeekKey = (dateStr) => {
  const d = new Date(dateStr);
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const weekOfMonth = Math.ceil(d.getDate() / 7);
  return `${year}-${String(month).padStart(2, "0")} ${weekOfMonth}주차`;
};

// periodTab에 따라 그룹화
const groupedRows = (() => {
  const groups = {};
  filteredPayments.forEach(p => {
    let key;
    if (periodTab === "daily") key = p.created_at?.slice(0, 10);
    else if (periodTab === "weekly") key = getWeekKey(p.created_at?.slice(0, 10));
    else key = p.created_at?.slice(0, 7); // monthly: 2026-04
    
    if (!key) return;
    if (!groups[key]) groups[key] = { key, payments: [], revenue: 0, refund: 0, count: 0 };
    groups[key].payments.push(p);
    groups[key].count++;
    if (p.status === "approved") groups[key].revenue += Number(p.amount || 0);
    if (p.status === "cancelled") groups[key].refund += Number(p.amount || 0);
  });
  return Object.values(groups).sort((a, b) => b.key.localeCompare(a.key));
})();

// 합계
const sumRow = {
  count: filteredPayments.length,
  revenue: filteredTotal,
  refund: filteredRefund,
  net: filteredTotal - filteredRefund
};

const formatGroupLabel = (key) => {
  if (periodTab === "daily") return key;
  if (periodTab === "weekly") return key;
  if (periodTab === "monthly") {
    const [y, m] = key.split("-");
    return `${y}년 ${parseInt(m)}월`;
  }
  return key;
};

  const chartData = periodTab === "daily" ? dailyData : periodTab === "weekly" ? weeklyData : monthlyData;
  const chartLabels = periodTab === "daily" ? chartData.map(d => `${d.day}일`) :
    periodTab === "weekly" ? chartData.map(d => d.week) : chartData.map(d => d.month);
  const chartValues = chartData.map(d => d.revenue);
  const maxVal = Math.max(...chartValues, 1);

  const CATEGORY_NAMES = { membership: "회원권", pt: "개인PT", gx: "그룹GX", locker: "락커", etc: "기타" };
  const CATEGORY_COLORS = ["#2563eb", "#ef4444", "#f97316", "#9ca3af", "#8b5cf6"];
  const totalProduct = productData.reduce((s, d) => s + d.amount, 0);

  const achieveRate = summary?.total ? Math.round(summary.total / goalAmount * 100) : 0;

  const statusLabel = (status) => {
    if (status === 'approved') return { label: '결제', color: '#2563eb', bg: '#eff6ff' };
    if (status === 'cancelled') return { label: '환불', color: '#ef4444', bg: '#fff0f0' };
    if (status === 'pending') return { label: '미납', color: '#f97316', bg: '#fff7ed' };
    return { label: status, color: '#9ca3af', bg: '#f3f4f6' };
  };

  const methodLabel = (method) => {
    if (!method) return '-';
    if (method === 'card' || method === 'SMARTRO' || method === 'PAYNIX' || method === 'NANO') return '카드';
    if (method === 'cash') return '현금';
    if (method === 'transfer') return '계좌이체';
    return method;
  };

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}>
        <span style={{ color: "#9ca3af", fontSize: 18 }}>‹</span>
        <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>매출통계</h2>
      </div>

      {/* 매출 인사이트 (증감 비교 + 월말 예상) */}
      {insights && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 14, fontWeight: 800, color: "#111827", marginBottom: 12 }}>📊 오늘의 매출 인사이트</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
            {/* 오늘 */}
            <div style={{ background: "#fff", borderRadius: 14, padding: "16px 18px", border: "1px solid #eef2f7" }}>
              <div style={{ color: "#6b7280", fontSize: 12, marginBottom: 6 }}>오늘 매출</div>
              <div style={{ color: "#111827", fontSize: 22, fontWeight: 800, marginBottom: 10 }}>{wonStr(insights.today?.revenue)}</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 6, background: pctBg(insights.today?.dod_pct), color: pctColor(insights.today?.dod_pct), fontWeight: 700 }}>전일 {pctText(insights.today?.dod_pct)}</span>
                <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 6, background: pctBg(insights.today?.vs_weekday_pct), color: pctColor(insights.today?.vs_weekday_pct), fontWeight: 700 }}>{insights.today?.weekday_name}요일 평균 {pctText(insights.today?.vs_weekday_pct)}</span>
              </div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 8 }}>최근 12주 {insights.today?.weekday_name}요일 평균 {wonStr(insights.today?.weekday_avg)}</div>
            </div>
            {/* 이번주 */}
            <div style={{ background: "#fff", borderRadius: 14, padding: "16px 18px", border: "1px solid #eef2f7" }}>
              <div style={{ color: "#6b7280", fontSize: 12, marginBottom: 6 }}>이번주 매출 (월~오늘)</div>
              <div style={{ color: "#111827", fontSize: 22, fontWeight: 800, marginBottom: 10 }}>{wonStr(insights.week?.revenue)}</div>
              <div style={{ display: "flex", gap: 6 }}>
                <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 6, background: pctBg(insights.week?.wow_pct), color: pctColor(insights.week?.wow_pct), fontWeight: 700 }}>전주 동기 {pctText(insights.week?.wow_pct)}</span>
              </div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 8 }}>전주 동기간 {wonStr(insights.week?.prev_week)}</div>
            </div>
            {/* 이번달 누적 */}
            <div style={{ background: "#fff", borderRadius: 14, padding: "16px 18px", border: "1px solid #eef2f7" }}>
              <div style={{ color: "#6b7280", fontSize: 12, marginBottom: 6 }}>이번달 누적 (1~{insights.month?.days_elapsed}일)</div>
              <div style={{ color: "#111827", fontSize: 22, fontWeight: 800, marginBottom: 10 }}>{wonStr(insights.month?.mtd)}</div>
              <div style={{ display: "flex", gap: 6 }}>
                <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 6, background: pctBg(insights.month?.mtd_vs_lastmtd_pct), color: pctColor(insights.month?.mtd_vs_lastmtd_pct), fontWeight: 700 }}>전월 동기 {pctText(insights.month?.mtd_vs_lastmtd_pct)}</span>
              </div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 8 }}>전월 1~{insights.month?.days_elapsed}일 {wonStr(insights.month?.last_month_mtd)}</div>
            </div>
          </div>
          {/* 월말 예상매출 하이라이트 */}
          <div style={{ background: "linear-gradient(135deg,#1d4ed8,#2563eb)", borderRadius: 14, padding: "18px 22px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
            <div>
              <div style={{ color: "rgba(255,255,255,0.85)", fontSize: 12, marginBottom: 4 }}>{insights.month?.label} 월말 예상 매출 (현재 페이스 기준)</div>
              <div style={{ color: "#fff", fontSize: 26, fontWeight: 900 }}>{wonStr(insights.month?.forecast)}</div>
              <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 11, marginTop: 4 }}>{insights.month?.days_elapsed}/{insights.month?.days_in_month}일 진행 · 누적 {wonStr(insights.month?.mtd)}</div>
            </div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <div style={{ background: "rgba(255,255,255,0.15)", borderRadius: 10, padding: "10px 14px" }}>
                <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 11, marginBottom: 2 }}>전월 전체 대비</div>
                <div style={{ color: "#fff", fontSize: 15, fontWeight: 800 }}>{pctText(insights.month?.forecast_vs_lastfull_pct)}</div>
                <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 10 }}>전월 {wonStr(insights.month?.last_month_full)}</div>
              </div>
              <div style={{ background: "rgba(255,255,255,0.15)", borderRadius: 10, padding: "10px 14px" }}>
                <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 11, marginBottom: 2 }}>최근 3개월 평균 대비</div>
                <div style={{ color: "#fff", fontSize: 15, fontWeight: 800 }}>{pctText(insights.month?.forecast_vs_avg3m_pct)}</div>
                <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 10 }}>평균 {wonStr(insights.month?.avg_3m)}</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 상단 카드 6개 */}
      <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr 1fr 1fr 1fr 1fr", gap: 12, marginBottom: 24 }}>
        {/* 매출 */}
        <div style={{ background: "#2563eb", borderRadius: 14, padding: "18px 20px" }}>
          <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 12, marginBottom: 6 }}>매출</div>
          <div style={{ color: "#fff", fontSize: 22, fontWeight: 800, marginBottom: 4 }}>{Number(summary?.total || 0).toLocaleString()}원</div>
          <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 11 }}>
            {summary?.prev_month_revenue > 0
              ? `+${Math.round((summary.total - summary.prev_month_revenue) / summary.prev_month_revenue * 100)}% 전달대비 →`
              : "전달 데이터 없음"}
          </div>
        </div>
        {/* 신규 매출 */}
        <div style={{ background: "#fff", borderRadius: 14, padding: "18px 20px", border: "1px solid #f3f4f6" }}>
          <div style={{ color: "#6b7280", fontSize: 12, marginBottom: 6 }}>신규 매출</div>
          <div style={{ color: "#111", fontSize: 18, fontWeight: 800, marginBottom: 4 }}>{Number(summary?.new_member || 0).toLocaleString()}원</div>
          <div style={{ color: "#9ca3af", fontSize: 11 }}>+{summary?.prev_month_revenue > 0 ? Math.round((summary.new_member || 0) / summary.prev_month_revenue * 100) : 0}% 전달대비 →</div>
        </div>
        {/* 재등록 매출 */}
        <div style={{ background: "#fff", borderRadius: 14, padding: "18px 20px", border: "1px solid #f3f4f6" }}>
          <div style={{ color: "#6b7280", fontSize: 12, marginBottom: 6 }}>재등록 매출</div>
          <div style={{ color: "#111", fontSize: 18, fontWeight: 800, marginBottom: 4 }}>{Number(summary?.re_register || 0).toLocaleString()}원</div>
          <div style={{ color: "#9ca3af", fontSize: 11 }}>+{summary?.prev_month_revenue > 0 ? Math.round((summary.re_register || 0) / summary.prev_month_revenue * 100) : 0}% 전달대비 →</div>
        </div>
        {/* 환불 */}
        <div style={{ background: "#fff0f0", borderRadius: 14, padding: "18px 20px", border: "1px solid #fca5a522" }}>
          <div style={{ color: "#ef4444", fontSize: 12, marginBottom: 6 }}>환불</div>
          <div style={{ color: "#ef4444", fontSize: 18, fontWeight: 800, marginBottom: 4 }}>{Number(summary?.refund || 0).toLocaleString()}원</div>
          <div style={{ color: "#9ca3af", fontSize: 11 }}>환불 {summary?.refund_count || 0}건</div>
        </div>
        {/* 미수금 */}
        <div onClick={() => setShowUnpaidModal(true)} style={{ background: "#fff", borderRadius: 14, padding: "18px 20px", border: "2px solid #fed7aa", cursor: "pointer", position: "relative" }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = "#f97316"; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = "#fed7aa"; }}>
          <span style={{ position: "absolute", top: 8, right: 10, fontSize: 10, background: "#fff7ed", color: "#f97316", padding: "2px 7px", borderRadius: 20, fontWeight: 700 }}>클릭</span>
          <div style={{ color: "#f97316", fontSize: 12, marginBottom: 6, fontWeight: 600 }}>미수금</div>
          {(() => {
            const allUnpaid = paymentList.filter(p => p.status === "pending" || (p.unpaid_amount && Number(p.unpaid_amount) > 0));
            const allUnpaidAmt = allUnpaid.reduce((s, p) => s + (p.status === "pending" ? Number(p.amount||0) : Number(p.unpaid_amount||0)), 0);
            return (<>
              <div style={{ color: "#f97316", fontSize: 18, fontWeight: 800, marginBottom: 4 }}>{allUnpaidAmt.toLocaleString()}원</div>
              <div style={{ color: "#9ca3af", fontSize: 11 }}>미납 {allUnpaid.length}건</div>
            </>);
          })()}
        </div>
        {/* 목표 달성률 */}
        <div style={{ background: "#f0fdf4", borderRadius: 14, padding: "18px 20px", border: "1px solid #86efac22" }}>
          <div style={{ color: "#16a34a", fontSize: 12, marginBottom: 6 }}>이달 목표 달성률</div>
          <div style={{ color: "#16a34a", fontSize: 18, fontWeight: 800, marginBottom: 4 }}>{achieveRate}%</div>
          <div style={{ color: "#9ca3af", fontSize: 11 }}>목표: {Number(goalAmount).toLocaleString()}원</div>
        </div>
      </div>

      {/* 매출 통계 자료 */}
      <div style={{ background: "#fff", borderRadius: 14, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6", marginBottom: 20 }}>
        {/* 툴바 */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button onClick={() => moveMonth(-1)} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151", fontSize: 18 }}>‹</button>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>{year}년 {month}월</span>
            <button onClick={() => moveMonth(1)} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151", fontSize: 18 }}>›</button>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
            {["daily", "weekly", "monthly"].map((t, i) => (
              <button key={t} onClick={() => setPeriodTab(t)} style={{
                padding: "6px 14px", borderRadius: 8,
                border: `1px solid ${periodTab === t ? "#2563eb" : "#e5e7eb"}`,
                background: periodTab === t ? "#2563eb" : "#fff",
                color: periodTab === t ? "#fff" : "#374151",
                fontSize: 13, fontWeight: periodTab === t ? 700 : 500, cursor: "pointer"
              }}>{["일간", "주간", "월간"][i]}</button>
            ))}
            {/* 날짜 범위 */}
            <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)}
              style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: "6px 10px", fontSize: 12, color: "#374151" }} />
            <span style={{ color: "#9ca3af" }}>~</span>
            <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)}
              style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: "6px 10px", fontSize: 12, color: "#374151" }} />
            <button onClick={load} style={{ padding: "6px 14px", borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: 13, cursor: "pointer" }}>조회</button>
            <button onClick={() => { setGoalInput(String(goalAmount)); setShowGoalModal(true); }}
              style={{ padding: "6px 14px", borderRadius: 8, border: "none", background: "#2563eb", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
              목표 매출액 설정
            </button>
            <div style={{ display: "flex", border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}>
              {["chart", "list"].map((v, i) => (
                <button key={v} onClick={() => setViewMode(v)} style={{
                  padding: "6px 14px", border: "none", cursor: "pointer", fontSize: 13,
                  background: viewMode === v ? "#2563eb" : "#fff",
                  color: viewMode === v ? "#fff" : "#374151", fontWeight: viewMode === v ? 700 : 500
                }}>{["그래프", "리스트"][i]}</button>
              ))}
            </div>
          </div>
        </div>

        {viewMode === "chart" ? (
          <>
            <div style={{ display: "flex", gap: 16, marginBottom: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div style={{ width: 12, height: 12, background: "#2563eb", borderRadius: 2 }} />
                <span style={{ fontSize: 12, color: "#6b7280" }}>매출</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div style={{ width: 24, height: 2, background: "#ef4444" }} />
                <span style={{ fontSize: 12, color: "#6b7280" }}>목표선</span>
              </div>
            </div>
            <div style={{ overflowX: "auto" }}>
              <div style={{ position: "relative", height: 200, minWidth: periodTab === "daily" ? 600 : 300 }}>
                <div style={{ position: "absolute", left: 0, right: 0, top: "30%", borderTop: "2px dashed #ef4444", zIndex: 1 }} />
                <div style={{ display: "flex", alignItems: "flex-end", height: "100%", gap: 4 }}>
                  {chartValues.map((v, i) => (
                    <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", height: "100%", justifyContent: "flex-end", minWidth: periodTab === "daily" ? 18 : 40 }}>
                      <div style={{ width: "100%", background: "#2563eb", borderRadius: "3px 3px 0 0", height: `${(v / maxVal) * 70}%`, minHeight: v > 0 ? 4 : 0 }} />
                      <span style={{ fontSize: 9, color: "#9ca3af", marginTop: 4 }}>{chartLabels[i]}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
      {/* 결제 내역 그룹화 테이블 */}
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
              <thead>
                <tr style={{ borderBottom: "1px solid #f3f4f6" }}>
                  <th style={{ padding: "8px 10px", width: 30 }}></th>
                  <th style={{ padding: "8px 10px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11 }}>
                    {periodTab === "daily" ? "날짜" : periodTab === "weekly" ? "주차" : "월"}
                  </th>
                  <th style={{ padding: "8px 10px", textAlign: "right", color: "#9ca3af", fontWeight: 600, fontSize: 11 }}>건수</th>
                  <th style={{ padding: "8px 10px", textAlign: "right", color: "#9ca3af", fontWeight: 600, fontSize: 11 }}>매출</th>
                  <th style={{ padding: "8px 10px", textAlign: "right", color: "#9ca3af", fontWeight: 600, fontSize: 11 }}>환불</th>
                  <th style={{ padding: "8px 10px", textAlign: "right", color: "#9ca3af", fontWeight: 600, fontSize: 11 }}>순매출</th>
                </tr>
              </thead>
              <tbody>
                {groupedRows.length === 0 && (
                  <tr><td colSpan={6} style={{ textAlign: "center", padding: 30, color: "#9ca3af" }}>데이터 없음</td></tr>
                )}
                {groupedRows.map((group, i) => {
                  const isExpanded = expandedRows.includes(group.key);
                  const net = group.revenue - group.refund;
                  return (
                    <React.Fragment key={i}>
                      <tr style={{ borderBottom: "1px solid #f9fafb", cursor: "pointer", background: isExpanded ? "#f9fafb" : "transparent" }}
                        onClick={() => {
                          if (isExpanded) setExpandedRows(p => p.filter(k => k !== group.key));
                          else setExpandedRows(p => [...p, group.key]);
                        }}
                        onMouseEnter={e => { if (!isExpanded) e.currentTarget.style.background = "#fafbfc"; }}
                        onMouseLeave={e => { if (!isExpanded) e.currentTarget.style.background = "transparent"; }}>
                        <td style={{ padding: "10px", color: isExpanded ? "#2563eb" : "#9ca3af", fontWeight: 500 }}>
                          {isExpanded ? "▼" : "▶"}
                        </td>
                        <td style={{ padding: "10px", fontWeight: 500 }}>{formatGroupLabel(group.key)}</td>
                        <td style={{ padding: "10px", textAlign: "right" }}>{group.count}건</td>
                        <td style={{ padding: "10px", textAlign: "right", color: "#2563eb", fontWeight: 500 }}>{group.revenue.toLocaleString()}원</td>
                        <td style={{ padding: "10px", textAlign: "right", color: "#ef4444" }}>{group.refund.toLocaleString()}원</td>
                        <td style={{ padding: "10px", textAlign: "right", fontWeight: 500 }}>{net.toLocaleString()}원</td>
                      </tr>
                      {isExpanded && (
                        <tr>
                          <td colSpan={6} style={{ padding: 0, background: "#fafbfc" }}>
                            <div style={{ padding: "8px 20px 12px 40px", borderLeft: "2px solid #2563eb" }}>
  <div style={{ fontSize: 11, color: "#9ca3af", padding: "8px 0", borderBottom: "0.5px solid #e5e7eb", display: "grid", gridTemplateColumns: "30px repeat(7, 1fr)", alignItems: "center", textAlign: "center" }}>
    <span></span>
    <span>시간</span>
    <span style={{ borderLeft: "0.5px solid #e5e7eb" }}>회원명</span>
    <span style={{ borderLeft: "0.5px solid #e5e7eb" }}>상품</span>
    <span style={{ borderLeft: "0.5px solid #e5e7eb" }}>담당자</span>
    <span style={{ borderLeft: "0.5px solid #e5e7eb" }}>금액</span>
    <span style={{ borderLeft: "0.5px solid #e5e7eb" }}>방법</span>
    <span style={{ borderLeft: "0.5px solid #e5e7eb" }}>구분</span>
  </div>
 {(() => {
    // payment_group_id로 묶기
    const groups = {};
    group.payments.forEach(p => {
      const key = p.payment_group_id || `solo_${p.id}`;
      if (!groups[key]) groups[key] = [];
      groups[key].push(p);
    });
    const groupedList = Object.values(groups);
    
    return groupedList.map((purchaseItems, gIdx) => {
      const isMulti = purchaseItems.length > 1;
      const totalAmount = purchaseItems.reduce((sum, p) => sum + Number(p.amount || 0), 0);
      const first = purchaseItems[0];
      const purchaseKey = `${group.key}_${first.payment_group_id || first.id}`;
      const isPurchaseExpanded = expandedRows.includes(purchaseKey);
      const s = statusLabel(first.status);
      const productLabel = isMulti
        ? `${first.plan_name || first.prodName || "-"} 외 ${purchaseItems.length - 1}건`
        : (first.plan_name || first.prodName || "-");
      
      const showAmount = isMulti ? totalAmount : Number(first.amount || 0);
      
      // 전표 버튼 컴포넌트 (재사용)
      const ReceiptButtons = () => (
        <span style={{ display: "flex", gap: 4, justifyContent: "center" }}>
          <button onClick={(e) => {
            e.stopPropagation();
            setReceiptModal({ open: true, paymentId: first.id });
          }} style={{ padding: "3px 8px", borderRadius: 4, border: "1px solid #3B82F6", background: "#fff", color: "#3B82F6", fontSize: 10, cursor: "pointer", fontWeight: 600 }}>🧾 전표</button>
          {first.transactionId && (
            <button onClick={(e) => {
              e.stopPropagation();
              let url = "";
              if (first.method === "SMARTRO") url = `https://pay.smartropay.co.kr/receipt/${first.transactionId}`;
              else if (first.method === "card" || first.method === "PAYNIX") url = `https://wpay.mostpns.co.kr/receipt/${first.transactionId}`;
              if (url) window.open(url, "_blank", "width=420,height=600");
            }} style={{ padding: "3px 8px", borderRadius: 4, border: "0.5px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: 10, cursor: "pointer" }}>PG</button>
          )}
        </span>
      );
      
      return (
        <React.Fragment key={gIdx}>
          {/* 메인 행 */}
          <div style={{ fontSize: 12, padding: "10px 0", display: "grid", gridTemplateColumns: "30px repeat(7, 1fr)", borderBottom: gIdx < groupedList.length - 1 ? "0.5px solid #f3f4f6" : "none", alignItems: "center", textAlign: "center", cursor: isMulti ? "pointer" : "default", background: isPurchaseExpanded ? "#f0f7ff" : "transparent" }}
            onClick={() => {
              if (!isMulti) return;
              if (isPurchaseExpanded) setExpandedRows(p => p.filter(k => k !== purchaseKey));
              else setExpandedRows(p => [...p, purchaseKey]);
            }}>
            <span style={{ color: isMulti ? (isPurchaseExpanded ? "#2563eb" : "#9ca3af") : "transparent", fontSize: 10 }}>
              {isMulti ? (isPurchaseExpanded ? "▼" : "▶") : ""}
            </span>
            <span style={{ color: "#374151" }}>{first.created_at?.slice(11, 16)}</span>
            <span style={{ fontWeight: 500 }}>{first.member_name || first.payerName || "-"}</span>
            <span style={{ color: "#374151" }}>{productLabel}</span>
            <span style={{ color: "#374151" }}>{first.staff_name || "-"}</span>
            <span style={{ fontWeight: 500 }}>{showAmount.toLocaleString()}원</span>
            <span style={{ color: "#374151" }}>{methodLabel(first.method)}</span>
            <span style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6 }}>
              <span style={{ color: s.color, fontWeight: 600 }}>{s.label}</span>
              <ReceiptButtons />
            </span>
          </div>
          
          {/* 그룹 결제 - 펼친 세부 상품들 */}
          {isMulti && isPurchaseExpanded && (
            <>
              {purchaseItems.map((p, j) => (
                <div key={j} style={{ fontSize: 11, padding: "6px 0", display: "grid", gridTemplateColumns: "30px repeat(7, 1fr)", borderBottom: "0.5px dashed #f3f4f6", alignItems: "center", textAlign: "center", background: "#f9fafb" }}>
                  <span></span>
                  <span style={{ color: "#9ca3af" }}>└</span>
                  <span style={{ color: "#9ca3af" }}>-</span>
                  <span style={{ color: "#374151" }}>{p.plan_name || p.prodName || "-"}</span>
                  <span style={{ color: "#9ca3af" }}>-</span>
                  <span style={{ fontWeight: 500 }}>{Number(p.amount || 0).toLocaleString()}원</span>
                  <span style={{ color: "#9ca3af" }}>-</span>
                  <span style={{ color: "#9ca3af", fontSize: 10 }}>-</span>
                </div>
              ))}
            </>
          )}
        </React.Fragment>
      );
    });
  })()}
</div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
                {groupedRows.length > 0 && (
                  <tr style={{ borderTop: "1px solid #e5e7eb", background: "#f9fafb" }}>
                    <td style={{ padding: "10px" }}></td>
                    <td style={{ padding: "10px", fontWeight: 700 }}>합계</td>
                    <td style={{ padding: "10px", textAlign: "right", fontWeight: 700 }}>{sumRow.count}건</td>
                    <td style={{ padding: "10px", textAlign: "right", color: "#2563eb", fontWeight: 700 }}>{sumRow.revenue.toLocaleString()}원</td>
                    <td style={{ padding: "10px", textAlign: "right", color: "#ef4444", fontWeight: 700 }}>{sumRow.refund.toLocaleString()}원</td>
                    <td style={{ padding: "10px", textAlign: "right", fontWeight: 700 }}>{sumRow.net.toLocaleString()}원</td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* 하단 요약바 */}
            <div style={{ marginTop: 16, padding: "14px 20px", background: "#f8fafc", borderRadius: 10, display: "flex", gap: 0, alignItems: "center", fontSize: 13 }}>
              {[
                { label: "매출", value: `${filteredTotal.toLocaleString()}원`, color: "#111" },
                { label: "환불", value: `${filteredRefund.toLocaleString()}원`, color: "#ef4444" },
                { label: "미수금", value: `${filteredUnpaid.toLocaleString()}원`, color: "#f97316" },
                { label: "총 매출", value: `${filteredNet.toLocaleString()}원`, color: "#2563eb" },
                { label: "목표액", value: `${Number(goalAmount).toLocaleString()}원`, color: "#111" },
                { label: "달성률", value: `${filteredNet > 0 ? Math.round(filteredNet / goalAmount * 100) : 0}%`, color: "#16a34a" },
              ].map((item, i, arr) => (
                <div key={i} style={{ flex: 1, textAlign: "center", borderRight: i < arr.length - 1 ? "1px solid #e5e7eb" : "none", padding: "0 12px" }}>
                  <div style={{ color: "#9ca3af", fontSize: 11, marginBottom: 3 }}>{item.label}</div>
                  <div style={{ color: item.color, fontWeight: 700, fontSize: 14 }}>{item.value}</div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* 상품별 + 트레이너별 */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
        {/* 상품 판매 매출 */}
        <div style={{ background: "#fff", borderRadius: 14, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>상품별 판매 매출</div>
            <div style={{ display: "flex", alignItems: "center", gap: 6, border: "1px solid #e5e7eb", borderRadius: 8, padding: "4px 10px" }}>
              <button onClick={() => moveMonth(-1)} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151" }}>‹</button>
              <span style={{ fontSize: 12, color: "#374151" }}>{year}년 {month}월</span>
              <button onClick={() => moveMonth(1)} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151" }}>›</button>
            </div>
          </div>
          <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
            <div style={{ position: "relative", width: 130, height: 130, flexShrink: 0 }}>
              <svg viewBox="0 0 100 100" style={{ width: 130, height: 130, transform: "rotate(-90deg)" }}>
                {(() => {
                  let offset = 0;
                  return productData.map((d, i) => {
                    const pct = totalProduct > 0 ? d.amount / totalProduct : 0;
                    const dash = pct * 251.2;
                    const el = (
                      <circle key={i} cx="50" cy="50" r="40" fill="none"
                        stroke={CATEGORY_COLORS[i % CATEGORY_COLORS.length]} strokeWidth="18"
                        strokeDasharray={`${dash} ${251.2 - dash}`}
                        strokeDashoffset={-offset} />
                    );
                    offset += dash;
                    return el;
                  });
                })()}
              </svg>
              <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <div style={{ fontSize: 9, color: "#9ca3af" }}>총계</div>
                <div style={{ fontSize: 10, fontWeight: 800, color: "#111" }}>{Number(totalProduct).toLocaleString()}원</div>
              </div>
            </div>
            <div style={{ flex: 1 }}>
              {productData.map((d, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                  <div style={{ width: 10, height: 10, borderRadius: "50%", background: CATEGORY_COLORS[i % CATEGORY_COLORS.length], flexShrink: 0 }} />
                  <span style={{ fontSize: 12, color: "#374151", flex: 1 }}>{CATEGORY_NAMES[d.category] || d.category}</span>
                  <span style={{ fontSize: 11, color: "#9ca3af" }}>{d.percent}%</span>
                  <span style={{ fontSize: 11, fontWeight: 600 }}>{Number(d.amount).toLocaleString()}원</span>
                </div>
              ))}
              {productData.length === 0 && <div style={{ color: "#9ca3af", fontSize: 13 }}>데이터 없음</div>}
            </div>
          </div>
          <div style={{ marginTop: 16, borderTop: "1px solid #f3f4f6", paddingTop: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 10 }}>TOP 5 인기 구매 상품</div>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
              <thead>
                <tr>{["순위", "구매상품", "판매수", "금액"].map(h => (
                  <th key={h} style={{ padding: "6px 8px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
                ))}</tr>
              </thead>
              <tbody>
                {[...Array(5)].map((_, i) => {
                  const p = topProducts[i];
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #f9fafb" }}>
                      <td style={{ padding: "8px", color: "#9ca3af" }}>{i + 1}</td>
                      <td style={{ padding: "8px", color: "#111", fontWeight: p ? 600 : 400 }}>{p?.name || "-"}</td>
                      <td style={{ padding: "8px" }}>{p?.count || "-"}</td>
                      <td style={{ padding: "8px" }}>{p ? `${Number(p.amount).toLocaleString()}원` : "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* 트레이너별 매출 */}
        <div style={{ background: "#fff", borderRadius: 14, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>트레이너별 매출</div>
            <div style={{ display: "flex", alignItems: "center", gap: 6, border: "1px solid #e5e7eb", borderRadius: 8, padding: "4px 10px" }}>
              <button onClick={() => moveMonth(-1)} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151" }}>‹</button>
              <span style={{ fontSize: 12, color: "#374151" }}>{year}년 {month}월</span>
              <button onClick={() => moveMonth(1)} style={{ background: "none", border: "none", cursor: "pointer", color: "#374151" }}>›</button>
            </div>
          </div>
          <div style={{ height: 140, display: "flex", alignItems: "flex-end", gap: 8, marginBottom: 20 }}>
            {trainerData.slice(0, 6).map((t, i) => {
              const maxT = Math.max(...trainerData.map(d => d.amount), 1);
              return (
                <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", height: "100%", justifyContent: "flex-end" }}>
                  <div style={{ width: "100%", background: "#2563eb", borderRadius: "3px 3px 0 0", height: `${(t.amount / maxT) * 80}%`, minHeight: t.amount > 0 ? 4 : 0 }} />
                  <span style={{ fontSize: 9, color: "#9ca3af", marginTop: 4, textAlign: "center" }}>{t.name}</span>
                </div>
              );
            })}
            {trainerData.length === 0 && <div style={{ color: "#9ca3af", fontSize: 13, width: "100%", textAlign: "center" }}>데이터 없음</div>}
          </div>
          <div style={{ borderTop: "1px solid #f3f4f6", paddingTop: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 10 }}>우수 매출 트레이너</div>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
              <thead>
                <tr>{["순위", "트레이너", "금액", "실적 %"].map(h => (
                  <th key={h} style={{ padding: "6px 8px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
                ))}</tr>
              </thead>
              <tbody>
                {[...Array(5)].map((_, i) => {
                  const t = trainerData[i];
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #f9fafb" }}>
                      <td style={{ padding: "8px", color: "#9ca3af" }}>{i + 1}</td>
                      <td style={{ padding: "8px", fontWeight: t ? 600 : 400 }}>{t?.name || "-"}</td>
                      <td style={{ padding: "8px" }}>{t ? `${Number(t.amount).toLocaleString()}원` : "-"}</td>
                      <td style={{ padding: "8px", color: "#2563eb", fontWeight: 600 }}>{t ? `${t.percent}%` : "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* 목표 매출액 설정 모달 */}

      {showUnpaidModal && (() => {
        const unpaidList = paymentList.filter(p =>
          p.status === "pending" || (p.unpaid_amount && Number(p.unpaid_amount) > 0)
        );
        const totalUnpaid = unpaidList.reduce((s, p) => {
          if (p.status === "pending") return s + Number(p.amount || 0);
          return s + Number(p.unpaid_amount || 0);
        }, 0);
        return (
          <div onClick={() => setShowUnpaidModal(false)} style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000,
            display: "flex", alignItems: "center", justifyContent: "center", padding: 24
          }}>
            <div onClick={e => e.stopPropagation()} style={{
              background: "#fff", borderRadius: 16, width: "100%", maxWidth: 900,
              maxHeight: "85vh", display: "flex", flexDirection: "column",
              boxShadow: "0 20px 60px rgba(0,0,0,0.15)", overflow: "hidden"
            }}>
              <div style={{ padding: "20px 28px", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: "#111" }}>미수금 현황</div>
                  <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 3 }}>총 {unpaidList.length}건 · 합계 {totalUnpaid.toLocaleString()}원</div>
                </div>
                <button onClick={() => setShowUnpaidModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: 22, lineHeight: 1 }}>×</button>
              </div>
              <div style={{ padding: "12px 28px", background: "#fff7ed", borderBottom: "1px solid #fed7aa", flexShrink: 0, display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 22, fontWeight: 800, color: "#f97316" }}>{totalUnpaid.toLocaleString()}원</span>
                <span style={{ fontSize: 13, color: "#9ca3af" }}>미수금 합계</span>
              </div>
              <div style={{ overflowY: "auto", flex: 1 }}>
                {unpaidList.length === 0 ? (
                  <div style={{ textAlign: "center", padding: 48, color: "#9ca3af", fontSize: 14 }}>미수금이 없습니다</div>
                ) : (
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, whiteSpace: "nowrap" }}>
                    <thead>
                      <tr style={{ background: "#f9fafb" }}>
                        {["날짜", "회원명", "상품", "결제금액", "미수금", "구분"].map(h => (
                          <th key={h} style={{ padding: "11px 20px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 12, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {unpaidList.map((p, i) => {
                        const unpaidAmt = p.status === "pending" ? Number(p.amount || 0) : Number(p.unpaid_amount || 0);
                        return (
                          <tr key={i} style={{ borderBottom: "1px solid #f9fafb" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#fafafa"}
                            onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent"; }}>
                            <td style={{ padding: "13px 20px", color: "#6b7280" }}>{p.created_at?.slice(0, 10) || "-"}</td>
                            <td style={{ padding: "13px 20px", fontWeight: 700, color: "#111" }}>{p.member_name || p.payerName || "-"}</td>
                            <td style={{ padding: "13px 20px", color: "#374151" }}>{p.prodName || p.plan_name || "-"}</td>
                            <td style={{ padding: "13px 20px", color: "#374151" }}>{Number(p.amount || 0).toLocaleString()}원</td>
                            <td style={{ padding: "13px 20px", fontWeight: 700, color: "#f97316" }}>{unpaidAmt.toLocaleString()}원</td>
                            <td style={{ padding: "13px 20px" }}>
                              <span style={{
                                background: p.status === "pending" ? "#fee2e2" : "#fff7ed",
                                color: p.status === "pending" ? "#ef4444" : "#f97316",
                                padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600
                              }}>
                                {p.status === "pending" ? "미납" : "일부미납"}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        );
      })()}

      {showGoalModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: 340 }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>목표 매출액 설정</div>
            <input type="number" value={goalInput} onChange={e => setGoalInput(e.target.value)}
              style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 14px", fontSize: 14, marginBottom: 16 }}
              placeholder="목표 금액 입력" />
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setShowGoalModal(false)}
                style={{ flex: 1, padding: "10px", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff", cursor: "pointer", fontSize: 14 }}>취소</button>
              <button onClick={async () => {
                  const g = Number(goalInput) || 0;
                  setGoalAmount(g);
                  setShowGoalModal(false);
                  try {
                    await api(`/dashboard/sales-goal`, { method: "PUT", body: JSON.stringify({ goal: g }) }, token);
                    addToast("목표 매출이 저장되었습니다. 앱에도 반영됩니다.", "success");
                  } catch (e) {
                    addToast("목표 저장 실패: " + e.message, "error");
                  }
                }}
                style={{ flex: 1, padding: "10px", border: "none", borderRadius: 8, background: "#2563eb", color: "#fff", cursor: "pointer", fontSize: 14, fontWeight: 700 }}>저장</button>
            </div>
          </div>
        </div>
      )}
      <ReceiptModal
        isOpen={receiptModal.open}
        onClose={() => setReceiptModal({ open: false, paymentId: null })}
        paymentId={receiptModal.paymentId}
      />
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// CONTRACT PAGE (전자계약)
// ════════════════════════════════════════════════════════════════════════════
const ContractPage = ({ token, addToast }) => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    member_id: "", member_search: "", member_phone: "",
    product_name: "", amount: "", start_date: "", end_date: "", manager: "",
    items: [], discount: "", final_price: ""
  });
  const [conn, setConn] = useState({ connected: false, email: null });
  const [connForm, setConnForm] = useState({ email: "", api_key: "" });
  const [connecting, setConnecting] = useState(false);

  const [plans, setPlans] = useState([]);                  // 등록된 상품(회원권) 목록
  const [staffs, setStaffs] = useState([]);                // 담당자 선택용 직원 목록

  // ── 계약서 양식(자체 템플릿) 관리 ──
  const [myTemplates, setMyTemplates] = useState([]);      // 저장된 양식 목록
  const [showTplModal, setShowTplModal] = useState(false); // 양식 편집기 모달
  const [tplSaving, setTplSaving] = useState(false);
  const [editingTpl, setEditingTpl] = useState(null);      // 편집 중인 양식 (null=신규)
  const [tplForm, setTplForm] = useState({
    name: "", category: "구매계약서", title: "",
    fields: ["이름", "연락처", "성별", "주소", "담당자"],
    terms: "", show_product: true, show_payment: true,
    consents: [{ label: "개인정보 수집 및 이용에 동의합니다.", detail: "수집 항목: 성명, 연락처, 주소, 생년월일\n수집 목적: 회원 관리, 시설 이용 및 서비스 제공, 공지사항 전달\n보유 기간: 회원 탈퇴 후 3년까지 (관계 법령에 따름)\n※ 동의를 거부할 수 있으나, 거부 시 회원 가입 및 서비스 이용이 제한됩니다.", required: true }],
    signers: [{ label: "신청인 (회원)", role: "회원", position: "bottom" }],
  });

  const TEMPLATE_ID = "b4e71c80-3319-11f1-8bea-99bff38164d8";

  // 양식 목록 불러오기
  const loadTemplates = useCallback(async () => {
    try {
      const d = await api("/contract/template/list", {}, token);
      setMyTemplates(Array.isArray(d) ? d : []);
    } catch (e) { setMyTemplates([]); }
  }, [token]);

  // 양식 편집기 열기 (신규/수정)
  const openTplEditor = (tpl) => {
    if (tpl) {
      let parsed = {};
      try { parsed = JSON.parse(tpl.sections || "{}"); } catch (e) {}
      setEditingTpl(tpl);
      setTplForm({
        name: tpl.name || "",
        category: tpl.category || "구매계약서",
        title: parsed.title || tpl.name || "",
        fields: parsed.fields || ["이름", "연락처", "성별", "주소", "담당자"],
        terms: tpl.content || "",
        show_product: parsed.show_product !== false,
        show_payment: parsed.show_payment !== false,
        consents: parsed.consents || [{ label: "개인정보 수집 및 이용에 동의합니다.", required: true }],
        signers: parsed.signers || [{ label: "신청인 (회원)", role: "회원" }],
      });
    } else {
      setEditingTpl(null);
      setTplForm({
        name: "", category: "구매계약서", title: "",
        fields: ["이름", "연락처", "성별", "주소", "담당자"],
        terms: "", show_product: true, show_payment: true,
        consents: [{ label: "개인정보 수집 및 이용에 동의합니다.", detail: "수집 항목: 성명, 연락처, 주소, 생년월일\n수집 목적: 회원 관리, 시설 이용 및 서비스 제공, 공지사항 전달\n보유 기간: 회원 탈퇴 후 3년까지 (관계 법령에 따름)\n※ 동의를 거부할 수 있으나, 거부 시 회원 가입 및 서비스 이용이 제한됩니다.", required: true }],
        signers: [{ label: "신청인 (회원)", role: "회원", position: "bottom" }],
      });
    }
    setShowTplModal(true);
  };

  // 양식 저장
  const saveTemplate = async () => {
    if (!tplForm.name.trim()) return addToast("양식 이름을 입력하세요", "error");
    setTplSaving(true);
    try {
      const sections = JSON.stringify({
        title: tplForm.title || tplForm.name,
        fields: tplForm.fields,
        show_product: tplForm.show_product,
        show_payment: tplForm.show_payment,
        consents: tplForm.consents,
        signers: tplForm.signers,
      });
      const body = JSON.stringify({
        name: tplForm.name.trim(),
        category: tplForm.category,
        content: tplForm.terms || "",
        sections,
      });
      if (editingTpl) {
        await api(`/contract/template/${editingTpl.id}`, { method: "PUT", body }, token);
        addToast("양식이 수정되었습니다 ✅", "success");
      } else {
        await api("/contract/template", { method: "POST", body }, token);
        addToast("양식이 저장되었습니다 ✅", "success");
      }
      setShowTplModal(false);
      loadTemplates();
    } catch (e) { addToast("저장 실패: " + e.message, "error"); }
    finally { setTplSaving(false); }
  };

  // 양식 삭제(비활성화)
  const deleteTemplate = async (tpl) => {
    if (!window.confirm(`'${tpl.name}' 양식을 삭제할까요?`)) return;
    try {
      await api(`/contract/template/${tpl.id}`, { method: "PUT", body: JSON.stringify({ is_active: false }) }, token);
      addToast("삭제되었습니다", "success");
      loadTemplates();
    } catch (e) { addToast("삭제 실패: " + e.message, "error"); }
  };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      // 자체 전자계약 + (구)모두싸인 문서 모두 표시
      const [self, modu] = await Promise.all([
        api("/contract/list", {}, token).catch(() => []),
        api("/modusign/documents", {}, token).catch(() => []),
      ]);
      const selfList = (Array.isArray(self) ? self : []).map(c => ({
        id: c.id,
        title: c.title,
        status: c.status === "SIGNED" ? "COMPLETED" : "ON_GOING",
        _self: true,
        _token: c.token,
        _member_name: c.member_name,
        createdAt: c.created_at,
        updatedAt: c.signed_at || c.created_at,
        participants: c.member_name ? [{ name: c.member_name }] : [],
      }));
      const moduList = Array.isArray(modu) ? modu : (modu.documents || []);
      setContracts([...selfList, ...moduList]);
    } catch (e) { setContracts([]); }
    finally { setLoading(false); }
  }, [token]);

  const loadConn = useCallback(async () => {
    try { const c = await api("/modusign/connection", {}, token); setConn(c || { connected: false }); } catch (e) {}
  }, [token]);

  useEffect(() => {
    load();
    loadConn();
    loadTemplates();
    api("/members/?tenant_id=1", {}, token).then(d => setMembers(Array.isArray(d) ? d : [])).catch(() => {});
    api("/membership-plan/list?tenant_id=1", {}, token).then(d => setPlans(Array.isArray(d) ? d : [])).catch(() => {});
    api("/staff/list?tenant_id=1", {}, token)
      .then(d => setStaffs(Array.isArray(d) ? d.filter(x => x.role !== "SUPERADMIN") : []))
      .catch(() => {});
  }, [load, loadConn, loadTemplates]);

  const connectModusign = async () => {
    if (!connForm.email.trim() || !connForm.api_key.trim()) return addToast("이메일과 API 키를 입력하세요", "error");
    setConnecting(true);
    try {
      await api("/modusign/connect", { method: "POST", body: JSON.stringify({ email: connForm.email.trim(), api_key: connForm.api_key.trim() }) }, token);
      addToast("모두싸인이 연동되었습니다 ✅", "success");
      setConnForm({ email: "", api_key: "" });
      loadConn(); load();
    } catch (e) { addToast("연동 실패: " + e.message, "error"); }
    finally { setConnecting(false); }
  };

  const disconnectModusign = async () => {
    if (!window.confirm("모두싸인 연동을 해제할까요? 해제하면 서명 요청을 보낼 수 없습니다.")) return;
    try {
      await api("/modusign/disconnect", { method: "POST" }, token);
      addToast("연동이 해제되었습니다", "success");
      loadConn();
    } catch (e) { addToast("해제 실패: " + e.message, "error"); }
  };

  // ── 금액 유틸 & 상품 목록 조작 ──────────────────────────────
  const wonToNum = (v) => Number(String(v || "").replace(/[^0-9]/g, "")) || 0;
  const numToWon = (n) => (n ? n.toLocaleString() + "원" : "");

  // 상품 목록이 바뀌면 총금액/최종금액을 다시 계산
  const recalc = (items, discount) => {
    const total = items.reduce((a, x) => a + wonToNum(x.price), 0);
    const disc = wonToNum(discount);
    return { amount: numToWon(total), final_price: numToWon(Math.max(total - disc, 0)) };
  };

  const setItems = (next, discountOverride) => {
    setForm(p => {
      const disc = discountOverride !== undefined ? discountOverride : p.discount;
      return { ...p, items: next, discount: disc, ...recalc(next, disc) };
    });
  };

  // 등록된 상품(회원권)을 목록에 추가
  const addPlanItem = (planId) => {
    const plan = plans.find(x => String(x.id) === String(planId));
    if (!plan) return;
    const price = Number(plan.card_price || plan.cash_price || plan.price || 0);
    const dur = plan.duration_value
      ? `${plan.duration_value}${plan.duration_unit === "day" ? "일" : "개월"}` : "";
    const sess = plan.sessions ? `${plan.sessions}회` : "";
    setForm(p => {
      const next = [...p.items, { name: plan.name, period: dur, count: sess, price: numToWon(price) }];
      // 이용기간이 비어 있으면 첫 상품 기준으로 자동 계산
      let sd = p.start_date, ed = p.end_date;
      if (!sd) sd = new Date().toISOString().slice(0, 10);
      if (!p.end_date && plan.duration_value) {
        const base = new Date(sd);
        if (plan.duration_unit === "day") base.setDate(base.getDate() + Number(plan.duration_value));
        else base.setMonth(base.getMonth() + Number(plan.duration_value));
        ed = base.toISOString().slice(0, 10);
      }
      return { ...p, items: next, start_date: sd, end_date: ed, ...recalc(next, p.discount) };
    });
  };

  const addBlankItem = () => setItems([...form.items, { name: "", period: "", count: "", price: "" }]);
  const removeItem = (i) => setItems(form.items.filter((_, idx) => idx !== i));
  const updateItem = (i, key, val) =>
    setItems(form.items.map((x, idx) => (idx === i ? { ...x, [key]: val } : x)));

  // 서버로 보낼 상품 배열 (빈 행 제외)
  const buildProducts = () => form.items
    .filter(x => (x.name || "").trim())
    .map(x => ({ name: x.name, period: x.period || "", count: x.count || "", price: x.price || "" }));

  // 계약서 PDF 미리보기 (새 창)
  const previewContractPdf = async () => {
    if (!form.use_template) return addToast("계약서 양식을 선택하세요", "error");
    try {
      const res = await fetch(`${API_BASE}/contract-pdf/preview`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          template_id: Number(form.use_template),
          member_id: form.member_id ? Number(form.member_id) : null,
          member_name: form.member_search || "홍길동",
          member_phone: form.member_phone || "010-0000-0000",
          products: buildProducts(),
          total_price: form.amount || "",
          discount: form.discount || "",
          final_price: form.final_price || form.amount || "",
          pay_method: form.pay_method || "",
          start_date: form.start_date || "",
          end_date: form.end_date || "",
          manager: form.manager || "",
        }),
      });
      if (!res.ok) {
        let msg = "미리보기 실패";
        try { const j = await res.json(); msg = j.detail || msg; } catch (e) {}
        return addToast(msg, "error");
      }
      const blob = await res.blob();
      window.open(URL.createObjectURL(blob), "_blank");
    } catch (e) { addToast("미리보기 실패: " + e.message, "error"); }
  };

  const handleRequest = async () => {
    if (!form.member_id) return addToast("회원을 선택해주세요", "error");
    if (!form.member_phone) return addToast("회원 연락처가 없습니다", "error");

    // ── 자체 전자계약으로 발송 (회원앱 푸시 → 앱 미사용 회원은 문자) ──
    if (!form.use_template) return addToast("계약서 양식을 선택해주세요", "error");
    {
      setSaving(true);
      try {
        await api("/contract-pdf/send-self", {
          method: "POST",
          body: JSON.stringify({
            template_id: Number(form.use_template),
            member_id: Number(form.member_id),
            member_name: form.member_search,
            member_phone: form.member_phone,
            products: buildProducts(),
            total_price: form.amount || "",
            discount: form.discount || "",
            final_price: form.final_price || form.amount || "",
            pay_method: form.pay_method || "",
            start_date: form.start_date || "",
            end_date: form.end_date || "",
            manager: form.manager || "",
          })
        }, token);
        addToast("✍️ 서명 요청을 보냈습니다!", "success");
        setShowModal(false);
        setForm({ member_id: "", member_search: "", member_phone: "", product_name: "", amount: "", start_date: "", end_date: "", use_template: "", pay_method: "", plan_id: "", manager: "", items: [], discount: "", final_price: "" });
        load();
      } catch (e) { addToast("서명 요청 실패: " + e.message, "error"); }
      finally { setSaving(false); }
    }
  };

  const statusBadge = (s) => {
    const map = {
      COMPLETED: { label: "서명 완료", color: "#22c55e" },
      ON_GOING: { label: "서명 진행 중", color: "#f97316" },
      ON_PROCESSING: { label: "처리 중", color: "#6b7280" },
      ABORTED: { label: "취소", color: "#ef4444" },
    };
    const m = map[s] || { label: s || "대기", color: "#9ca3af" };
    return <Badge label={m.label} color={m.color} />;
  };

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>전자계약</h2>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => openTplEditor(null)} style={{
            display: "flex", alignItems: "center", gap: 6, padding: "10px 16px",
            background: "#fff", color: "#374151", border: "1px solid #e5e7eb", borderRadius: 8,
            fontSize: 13, fontWeight: 700, cursor: "pointer"
          }}>
            📄 계약서 양식 만들기
          </button>
          <button onClick={() => {
            setForm({ member_id: "", member_search: "", member_phone: "", product_name: "", amount: "", start_date: "", end_date: "", use_template: "", pay_method: "", plan_id: "", manager: "", items: [], discount: "", final_price: "" });
            setShowModal(true);
          }} style={{
            display: "flex", alignItems: "center", gap: 6, padding: "10px 18px",
            background: "#2563eb", color: "#fff", border: "none", borderRadius: 8,
            fontSize: 13, fontWeight: 700, cursor: "pointer"
          }}>
            <Icon name="plus" size={14} color="#fff" /> 서명 요청
          </button>
        </div>
      </div>

      {/* 저장된 계약서 양식 목록 */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "14px 18px", marginBottom: 20 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", marginBottom: 10 }}>
          저장된 계약서 양식 {myTemplates.length > 0 && <span style={{ color: "#2563eb" }}>({myTemplates.length})</span>}
        </div>
        {myTemplates.length === 0 ? (
          <div style={{ fontSize: 12.5, color: "#9ca3af", padding: "8px 0" }}>
            아직 저장된 양식이 없습니다. <b style={{ color: "#2563eb", cursor: "pointer" }} onClick={() => openTplEditor(null)}>계약서 양식 만들기</b>를 눌러 매장에 맞는 계약서를 만들어보세요.
          </div>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {myTemplates.map(t => (
              <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 8, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 12px" }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{t.name}</span>
                <span style={{ fontSize: 11, color: "#9ca3af" }}>{t.category}</span>
                <button onClick={() => openTplEditor(t)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 12, color: "#2563eb", fontWeight: 600, padding: 0 }}>편집</button>
                <button onClick={() => deleteTemplate(t)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 12, color: "#ef4444", fontWeight: 600, padding: 0 }}>삭제</button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 모두싸인 연동 상태 / 설정 — 자체 전자계약 전환으로 숨김 (SHOW_MODUSIGN=true 로 되살릴 수 있음) */}
      {SHOW_MODUSIGN && (conn.connected ? (
        <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 12, padding: "12px 18px", marginBottom: 20, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
          <div style={{ fontSize: 13, color: "#166534", fontWeight: 700 }}>✅ 모두싸인 연동됨 <span style={{ color: "#374151", fontWeight: 500 }}>· {conn.email}</span></div>
          <button onClick={disconnectModusign} style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "7px 14px", fontSize: 12, cursor: "pointer", color: "#6b7280", fontWeight: 600 }}>연동 해제</button>
        </div>
      ) : (
        <div style={{ background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 12, padding: "18px 20px", marginBottom: 20 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#c2410c", marginBottom: 6 }}>✍️ 모두싸인 연동이 필요합니다</div>
          <div style={{ fontSize: 12.5, color: "#9a3412", lineHeight: 1.7, marginBottom: 14 }}>
            전자계약(서명 요청)을 이용하려면 매장의 <b>모두싸인 계정</b>을 연동해야 합니다. 모두싸인 로그인 후 <b>설정 → 워크스페이스 관리 → API KEY</b>에서 발급받은 <b>API 키</b>와 <b>가입 이메일</b>을 입력하세요. <span style={{ color: "#b45309" }}>API 메뉴는 이용 승인이 필요해 모두싸인 고객센터 문의 후 표시되며, 모두싸인은 각 매장이 직접 가입·결제하는 유료 서비스입니다.</span>
          </div>
          <div style={{ display: "grid", gap: 10, maxWidth: 460 }}>
            <input value={connForm.email} onChange={e => setConnForm(p => ({ ...p, email: e.target.value }))} placeholder="모두싸인 계정 이메일" autoComplete="off" style={{ padding: "11px 12px", border: "1.5px solid #e5e7eb", borderRadius: 9, fontSize: 14, boxSizing: "border-box" }} />
            <input value={connForm.api_key} onChange={e => setConnForm(p => ({ ...p, api_key: e.target.value }))} placeholder="API 키" type="password" autoComplete="new-password" style={{ padding: "11px 12px", border: "1.5px solid #e5e7eb", borderRadius: 9, fontSize: 14, boxSizing: "border-box" }} />
            <button onClick={connectModusign} disabled={connecting} style={{ background: connecting ? "#93c5fd" : "#2563eb", color: "#fff", border: "none", borderRadius: 9, padding: "12px", fontSize: 14, fontWeight: 700, cursor: connecting ? "not-allowed" : "pointer" }}>{connecting ? "연동 확인 중..." : "모두싸인 연동하기"}</button>
          </div>
        </div>
      ))}

      {/* 검색 */}
      <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
        <div style={{ position: "relative", flex: 1 }}>
          <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}>
            <Icon name="search" size={16} />
          </span>
          <input value={searchKeyword} onChange={e => setSearchKeyword(e.target.value)}
            placeholder="회원명으로 검색..."
            style={{ width: "100%", padding: "10px 12px 10px 36px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" }} />
        </div>
        <button onClick={load} style={{ padding: "10px 16px", borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", fontSize: 13, cursor: "pointer", color: "#374151" }}>새로고침</button>
      </div>

      {/* 계약서 목록 */}
      <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr>
              {["계약서 제목", "요청자", "상태", "요청일", "완료일", "모두싸인"].map(h => (
                <th key={h} style={{ padding: "12px 16px", textAlign: "left", color: "#9ca3af", fontWeight: 600, fontSize: 11, borderBottom: "1px solid #f3f4f6" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>로딩 중...</td></tr>
            ) : contracts.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign: "center", padding: 60, color: "#9ca3af" }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>📄</div>
                <div>서명 요청 내역이 없습니다</div>
                <div style={{ fontSize: 12, marginTop: 6 }}>우측 상단 버튼을 눌러 서명 요청을 시작하세요</div>
              </td></tr>
            ) : contracts
              .filter(c => searchKeyword ? (c.title?.includes(searchKeyword) || c._member_name?.includes(searchKeyword) || c.requester?.name?.includes(searchKeyword)) : true)
              .map((c, i) => (
              <tr key={i} style={{ borderBottom: "1px solid #f9fafb" }}
                onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
                <td style={{ padding: "14px 16px", fontWeight: 600, color: "#111" }}>{c.title || "-"}</td>
                <td style={{ padding: "14px 16px", color: "#374151" }}>
                  {c._self ? (c._member_name || "-") : (c.requester?.name || c.requester?.email || "-")}
                </td>
                <td style={{ padding: "14px 16px" }}>{statusBadge(c.status)}</td>
                <td style={{ padding: "14px 16px", color: "#6b7280" }}>{c.createdAt?.slice(0, 10) || "-"}</td>
                <td style={{ padding: "14px 16px", color: "#6b7280" }}>
                  {c.status === "COMPLETED" ? c.updatedAt?.slice(0, 10) : "-"}
                </td>
                <td style={{ padding: "14px 16px" }}>
                  {c._self ? (
                    <button onClick={() => window.open(`${API_BASE}/contract/sign/${c._token}`, "_blank")}
                      style={{ background: c.status === "COMPLETED" ? "#f0fdf4" : "#fff7ed", border: "none",
                               color: c.status === "COMPLETED" ? "#16a34a" : "#c2410c",
                               padding: "4px 10px", borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
                      {c.status === "COMPLETED" ? "계약서 보기" : "서명 페이지"}
                    </button>
                  ) : (
                    <button onClick={() => window.open(`https://app.modusign.co.kr`, "_blank")}
                      style={{ background: "#eff6ff", border: "none", color: "#2563eb", padding: "4px 10px", borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
                      모두싸인 확인
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 서명 요청 모달 */}
      {showModal && (
        <Modal title="전자계약 서명 요청" onClose={() => setShowModal(false)}>
          {/* 회원 선택 */}
          <div style={{ marginBottom: 14, position: "relative" }}>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>회원 *</label>
            <div style={{ position: "relative" }}>
              <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}><Icon name="search" size={14} /></span>
              <input value={form.member_search} onChange={e => setForm(p => ({ ...p, member_search: e.target.value, member_id: "", member_phone: "" }))}
                placeholder="이름으로 검색..."
                style={{ width: "100%", padding: "10px 12px 10px 32px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#f9fafb" }} />
            </div>
            {form.member_search && !form.member_id && members.filter(m => m.name?.includes(form.member_search)).length > 0 && (
              <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 100, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 4px 16px rgba(0,0,0,0.1)", maxHeight: 180, overflowY: "auto" }}>
                {members.filter(m => m.name?.includes(form.member_search)).map(m => (
                  <div key={m.id} onClick={() => setForm(p => ({ ...p, member_id: String(m.id), member_search: m.name, member_phone: m.phone || "" }))}
                    style={{ padding: "10px 16px", cursor: "pointer", fontSize: 13, color: "#374151", borderBottom: "1px solid #f3f4f6" }}
                    onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                    onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "#fff" }}>
                    {m.name} <span style={{ color: "#9ca3af", fontSize: 11 }}>{m.phone}</span>
                  </div>
                ))}
              </div>
            )}
            {form.member_id && (
              <div style={{ marginTop: 6, padding: "8px 12px", background: "#eff6ff", borderRadius: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 13, color: "#2563eb", fontWeight: 600 }}>✓ {form.member_search} ({form.member_phone})</span>
                <button onClick={() => setForm(p => ({ ...p, member_id: "", member_search: "", member_phone: "" }))} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: 16 }}>×</button>
              </div>
            )}
          </div>

          {/* 계약서 양식 선택 */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>
              사용할 계약서 <span style={{ color: "#9ca3af", fontWeight: 400 }}>(내가 만든 양식)</span>
            </label>
            <select value={form.use_template}
              onChange={e => setForm(p => ({ ...p, use_template: e.target.value }))}
              style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" }}>
              <option value="">기본 계약서 (모두싸인 템플릿 · 사용 안 함)</option>
              {myTemplates.map(t => (
                <option key={t.id} value={t.id}>{t.name}</option>
              ))}
            </select>
            {form.use_template && (
              <div style={{ marginTop: 6, display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 11.5, color: "#2563eb" }}>✓ 내 양식으로 계약서가 생성되어 발송됩니다</span>
                <button type="button" onClick={previewContractPdf}
                  style={{ background: "#fff", border: "1px solid #d1d5db", borderRadius: 6, padding: "4px 10px", fontSize: 11.5, fontWeight: 600, color: "#374151", cursor: "pointer" }}>
                  📄 미리보기
                </button>
              </div>
            )}
          </div>

          {/* 상품 (여러 개 선택 가능) */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>
              상품 <span style={{ color: "#9ca3af", fontWeight: 400 }}>(회원권 · 수강권 · 락커 등 여러 개 추가 가능)</span>
            </label>

            {/* 등록된 상품에서 추가 */}
            <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
              <select
                value=""
                onChange={e => { if (e.target.value) addPlanItem(e.target.value); e.target.value = ""; }}
                style={{ flex: 1, padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" }}>
                <option value="">+ 등록된 상품에서 추가</option>
                {plans.map(pl => {
                  const price = Number(pl.card_price || pl.cash_price || pl.price || 0);
                  const dur = pl.duration_value ? `${pl.duration_value}${pl.duration_unit === "day" ? "일" : "개월"}` : "";
                  const sess = pl.sessions ? `${pl.sessions}회` : "";
                  const meta = [dur, sess].filter(Boolean).join(" · ");
                  return (
                    <option key={pl.id} value={pl.id}>
                      {pl.name}{meta ? ` (${meta})` : ""} — {price.toLocaleString()}원
                    </option>
                  );
                })}
              </select>
              <button type="button" onClick={addBlankItem}
                style={{ padding: "10px 14px", background: "#fff", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 12.5, fontWeight: 700, color: "#374151", cursor: "pointer", whiteSpace: "nowrap" }}>
                직접 입력
              </button>
            </div>

            {/* 담은 상품 목록 */}
            {form.items.length === 0 ? (
              <div style={{ padding: "14px 12px", background: "#fafbfc", border: "1px dashed #e5e7eb", borderRadius: 8, textAlign: "center", fontSize: 12, color: "#9ca3af" }}>
                추가된 상품이 없습니다
              </div>
            ) : (
              <div style={{ border: "1px solid #eef0f3", borderRadius: 8, overflow: "hidden" }}>
                {form.items.map((it, i) => (
                  <div key={i} style={{ display: "flex", gap: 6, alignItems: "center", padding: "8px 10px", borderTop: i ? "1px solid #f3f4f6" : "none", background: "#fff" }}>
                    <input value={it.name} onChange={e => updateItem(i, "name", e.target.value)} placeholder="상품명"
                      style={{ flex: 2.2, minWidth: 0, padding: "8px 10px", borderRadius: 6, border: "1px solid #e5e7eb", fontSize: 12.5, outline: "none" }} />
                    <input value={it.period} onChange={e => updateItem(i, "period", e.target.value)} placeholder="기간"
                      style={{ flex: 1, minWidth: 0, padding: "8px 10px", borderRadius: 6, border: "1px solid #e5e7eb", fontSize: 12.5, outline: "none" }} />
                    <input value={it.count} onChange={e => updateItem(i, "count", e.target.value)} placeholder="횟수"
                      style={{ flex: 1, minWidth: 0, padding: "8px 10px", borderRadius: 6, border: "1px solid #e5e7eb", fontSize: 12.5, outline: "none" }} />
                    <input value={it.price} onChange={e => updateItem(i, "price", e.target.value)} placeholder="금액"
                      style={{ flex: 1.3, minWidth: 0, padding: "8px 10px", borderRadius: 6, border: "1px solid #e5e7eb", fontSize: 12.5, outline: "none", textAlign: "right" }} />
                    <button type="button" onClick={() => removeItem(i)} title="삭제"
                      style={{ background: "#fff", border: "1px solid #fecaca", color: "#ef4444", borderRadius: 6, width: 28, height: 30, fontSize: 14, fontWeight: 700, cursor: "pointer", flexShrink: 0 }}>×</button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* 금액 */}
          <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>총 상품 금액</label>
              <input value={form.amount} onChange={e => setForm(p => ({ ...p, amount: e.target.value }))} placeholder="자동 계산"
                style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>할인 금액</label>
              <input value={form.discount}
                onChange={e => setForm(p => ({ ...p, discount: e.target.value, ...recalc(p.items, e.target.value) }))}
                placeholder="예: 50,000원"
                style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>최종 결제금액</label>
              <input value={form.final_price} onChange={e => setForm(p => ({ ...p, final_price: e.target.value }))} placeholder="자동 계산"
                style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, fontWeight: 700, color: "#111", outline: "none", boxSizing: "border-box" }} />
            </div>
          </div>

          {form.use_template && (
            <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>결제수단</label>
                <select value={form.pay_method} onChange={e => setForm(p => ({ ...p, pay_method: e.target.value }))}
                  style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" }}>
                  <option value="">선택 안 함</option>
                  <option value="카드">카드</option>
                  <option value="현금">현금</option>
                  <option value="계좌이체">계좌이체</option>
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>담당자</label>
                <select value={form.manager} onChange={e => setForm(p => ({ ...p, manager: e.target.value }))}
                  style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" }}>
                  <option value="">선택 안 함</option>
                  {staffs.map(st => (
                    <option key={st.id} value={st.name}>{st.name}</option>
                  ))}
                </select>
              </div>
            </div>
          )}
          <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>이용 시작일</label>
              <input type="date" value={form.start_date} onChange={e => setForm(p => ({ ...p, start_date: e.target.value }))}
                style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>이용 종료일</label>
              <input type="date" value={form.end_date} onChange={e => setForm(p => ({ ...p, end_date: e.target.value }))}
                style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
            </div>
          </div>

          <div style={{ background: "#fef3c7", border: "1px solid #fde68a", borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: "#92400e" }}>
            📱 회원앱을 쓰는 회원에게는 앱 알림으로, 앱을 쓰지 않는 회원에게는 문자로 서명 링크가 발송됩니다
          </div>

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="secondary" onClick={() => setShowModal(false)}>취소</Btn>
            <Btn onClick={handleRequest} disabled={saving}>
              {saving ? "발송 중..." : "✍️ 서명 요청 발송"}
            </Btn>
          </div>
        </Modal>
      )}

      {/* ══ 계약서 양식 편집기 ══ */}
      {showTplModal && (
        <Modal title={editingTpl ? "계약서 양식 편집" : "계약서 양식 만들기"} onClose={() => setShowTplModal(false)} width={900}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>

            {/* ── 좌: 편집 ── */}
            <div>
              <Input label="양식 이름 *" value={tplForm.name}
                onChange={e => setTplForm(p => ({ ...p, name: e.target.value }))}
                placeholder="예: 헬스 회원권 계약서" />

              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>분류</label>
                <select value={tplForm.category} onChange={e => setTplForm(p => ({ ...p, category: e.target.value }))}
                  style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" }}>
                  <option>구매계약서</option>
                  <option>이용약관 동의서</option>
                  <option>개인정보 동의서</option>
                  <option>기타</option>
                </select>
              </div>

              <Input label="계약서 제목" value={tplForm.title}
                onChange={e => setTplForm(p => ({ ...p, title: e.target.value }))}
                placeholder="예: 헤이비서 짐 상품 구매 계약서" />

              {/* 고객 정보 항목 선택 */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 6 }}>
                  고객 기본 정보 항목 <span style={{ color: "#9ca3af", fontWeight: 400 }}>(회원 선택 시 자동 입력)</span>
                </label>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {["이름", "연락처", "성별", "생년월일", "주소", "담당자", "이메일"].map(f => {
                    const on = tplForm.fields.includes(f);
                    return (
                      <button key={f} type="button"
                        onClick={() => setTplForm(p => ({ ...p, fields: on ? p.fields.filter(x => x !== f) : [...p.fields, f] }))}
                        style={{
                          padding: "6px 12px", borderRadius: 100, fontSize: 12, fontWeight: 600, cursor: "pointer",
                          border: on ? "1px solid #2563eb" : "1px solid #e5e7eb",
                          background: on ? "#eff6ff" : "#fff", color: on ? "#2563eb" : "#9ca3af"
                        }}>
                        {on ? "✓ " : "+ "}{f}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* 섹션 표시 여부 */}
              <div style={{ marginBottom: 14, display: "flex", gap: 16 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12.5, color: "#374151", cursor: "pointer", fontWeight: 600 }}>
                  <input type="checkbox" checked={tplForm.show_product}
                    onChange={e => setTplForm(p => ({ ...p, show_product: e.target.checked }))}
                    style={{ width: 15, height: 15, accentColor: "#2563eb", cursor: "pointer" }} />
                  구매 상품 정보
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12.5, color: "#374151", cursor: "pointer", fontWeight: 600 }}>
                  <input type="checkbox" checked={tplForm.show_payment}
                    onChange={e => setTplForm(p => ({ ...p, show_payment: e.target.checked }))}
                    style={{ width: 15, height: 15, accentColor: "#2563eb", cursor: "pointer" }} />
                  결제 정보
                </label>
              </div>

              {/* 약관 */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>이용 약관 · 계약 조항</label>
                <textarea value={tplForm.terms}
                  onChange={e => setTplForm(p => ({ ...p, terms: e.target.value }))}
                  placeholder={"제1조 (회원모집)\n  레슨 정상가 금액 개인레슨 1회: 99,000원\n\n제2조 (회원준수사항)\n  1. 수업 예약 후 당일취소 및 수업변경 시 횟수 차감됩니다.\n\n제3조 (회원해지)\n  환불규정: ..."}
                  style={{ width: "100%", minHeight: 160, padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 12.5, outline: "none", boxSizing: "border-box", resize: "vertical", lineHeight: 1.7, fontFamily: "inherit" }} />
              </div>

              {/* 동의 체크 항목 */}
              <div style={{ marginBottom: 16, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <label style={{ color: "#374151", fontSize: 12, fontWeight: 700 }}>☑ 동의 항목 <span style={{ color: "#9ca3af", fontWeight: 400 }}>(회원이 체크)</span></label>
                  <button type="button" onClick={() => setTplForm(p => ({ ...p, consents: [...p.consents, { label: "", detail: "", required: true }] }))}
                    style={{ background: "#fff", border: "1px solid #d1d5db", borderRadius: 6, padding: "4px 10px", fontSize: 11.5, fontWeight: 600, color: "#2563eb", cursor: "pointer" }}>+ 항목 추가</button>
                </div>
                {tplForm.consents.length === 0 && <div style={{ fontSize: 11.5, color: "#9ca3af" }}>동의 항목이 없습니다.</div>}
                {tplForm.consents.map((c, i) => (
                  <div key={i} style={{ marginBottom: 10, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: 10 }}>
                    <div style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 6 }}>
                      <input value={c.label}
                        onChange={e => setTplForm(p => ({ ...p, consents: p.consents.map((x, xi) => xi === i ? { ...x, label: e.target.value } : x) }))}
                        placeholder="동의 제목 (예: 개인정보 수집 및 이용에 동의합니다.)"
                        style={{ flex: 1, padding: "8px 10px", borderRadius: 6, border: "1px solid #e5e7eb", fontSize: 12, outline: "none", boxSizing: "border-box", fontWeight: 600 }} />
                      <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11.5, color: "#6b7280", cursor: "pointer", whiteSpace: "nowrap" }}>
                        <input type="checkbox" checked={c.required}
                          onChange={e => setTplForm(p => ({ ...p, consents: p.consents.map((x, xi) => xi === i ? { ...x, required: e.target.checked } : x) }))}
                          style={{ width: 14, height: 14, accentColor: "#2563eb", cursor: "pointer" }} />필수
                      </label>
                      <button type="button" onClick={() => setTplForm(p => ({ ...p, consents: p.consents.filter((_, xi) => xi !== i) }))}
                        style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", fontSize: 15, padding: "0 4px" }}>×</button>
                    </div>
                    <textarea value={c.detail || ""}
                      onChange={e => setTplForm(p => ({ ...p, consents: p.consents.map((x, xi) => xi === i ? { ...x, detail: e.target.value } : x) }))}
                      placeholder={"동의 상세 내용 (회원에게 표시됩니다)\n예) 수집 항목: 성명, 연락처, 주소\n수집 목적: 회원 관리 및 서비스 제공\n보유 기간: 탈퇴 후 3년"}
                      style={{ width: "100%", minHeight: 70, padding: "8px 10px", borderRadius: 6, border: "1px solid #e5e7eb", fontSize: 11.5, outline: "none", boxSizing: "border-box", resize: "vertical", lineHeight: 1.6, fontFamily: "inherit", color: "#4b5563" }} />
                  </div>
                ))}
              </div>

              {/* 서명란 */}
              <div style={{ marginBottom: 6, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <label style={{ color: "#374151", fontSize: 12, fontWeight: 700 }}>✍️ 서명란 <span style={{ color: "#9ca3af", fontWeight: 400 }}>(여러 개 가능)</span></label>
                  <button type="button" onClick={() => setTplForm(p => ({ ...p, signers: [...p.signers, { label: "", role: "회원", position: "bottom" }] }))}
                    style={{ background: "#fff", border: "1px solid #d1d5db", borderRadius: 6, padding: "4px 10px", fontSize: 11.5, fontWeight: 600, color: "#2563eb", cursor: "pointer" }}>+ 서명란 추가</button>
                </div>
                {tplForm.signers.map((s, i) => (
                  <div key={i} style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 6, flexWrap: "wrap" }}>
                    <input value={s.label}
                      onChange={e => setTplForm(p => ({ ...p, signers: p.signers.map((x, xi) => xi === i ? { ...x, label: e.target.value } : x) }))}
                      placeholder="예: 환불 규정 확인 서명 / 신청인 (회원)"
                      style={{ flex: "1 1 150px", minWidth: 120, padding: "8px 10px", borderRadius: 6, border: "1px solid #e5e7eb", fontSize: 12, outline: "none", boxSizing: "border-box" }} />
                    <select value={s.position || "bottom"}
                      onChange={e => setTplForm(p => ({ ...p, signers: p.signers.map((x, xi) => xi === i ? { ...x, position: e.target.value } : x) }))}
                      title="계약서에서 서명란이 들어갈 위치"
                      style={{ padding: "8px 6px", borderRadius: 6, border: "1px solid #e5e7eb", fontSize: 11, outline: "none", background: "#fff", cursor: "pointer" }}>
                      <option value="terms">약관 뒤</option>
                      <option value="consent">동의 항목 뒤</option>
                      <option value="bottom">맨 아래</option>
                    </select>
                    <select value={s.role}
                      onChange={e => setTplForm(p => ({ ...p, signers: p.signers.map((x, xi) => xi === i ? { ...x, role: e.target.value } : x) }))}
                      style={{ padding: "8px 6px", borderRadius: 6, border: "1px solid #e5e7eb", fontSize: 11, outline: "none", background: "#fff", cursor: "pointer" }}>
                      <option value="회원">회원</option>
                      <option value="담당자">담당자</option>
                    </select>
                    <button type="button" onClick={() => setTplForm(p => ({ ...p, signers: p.signers.filter((_, xi) => xi !== i) }))}
                      style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", fontSize: 15, padding: "0 4px" }}>×</button>
                  </div>
                ))}
                <div style={{ fontSize: 10.5, color: "#9ca3af", marginTop: 6, lineHeight: 1.5 }}>
                  💡 서명란 이름이 계약서에 표시되고, 회원이 서명 화면에서 그 자리에 직접 서명합니다.<br />
                  위치는 <b>약관 뒤 / 동의 항목 뒤 / 맨 아래</b> 중에서 고를 수 있어요. (예: 환불 확인 서명 → 약관 뒤)
                </div>
              </div>
            </div>

            {/* ── 우: 미리보기 ── */}
            <div style={{ background: "#eef0f3", borderRadius: 10, padding: 14, maxHeight: 560, overflowY: "auto" }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", marginBottom: 8 }}>미리보기</div>
              <div style={{ background: "#fff", borderRadius: 6, padding: "20px 18px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                <div style={{ background: "#eef0f3", borderRadius: 6, textAlign: "center", fontSize: 14, fontWeight: 800, color: "#333", padding: 10, marginBottom: 16 }}>
                  {tplForm.title || tplForm.name || "계약서 제목"}
                </div>

                <div style={{ borderLeft: "3px solid #2563eb", paddingLeft: 7, fontSize: 12, fontWeight: 800, color: "#111827", marginBottom: 8 }}>고객 기본 정보</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginBottom: 16 }}>
                  {tplForm.fields.map(f => (
                    <div key={f} style={{ display: "flex", gap: 8, fontSize: 11, border: "1px solid #eef0f3", borderRadius: 5, padding: "7px 9px" }}>
                      <span style={{ color: "#111", fontWeight: 700, minWidth: 40 }}>{f}</span>
                      <span style={{ color: "#b6bcc6" }}>자동 입력</span>
                    </div>
                  ))}
                </div>

                {tplForm.show_product && (
                  <>
                    <div style={{ borderLeft: "3px solid #2563eb", paddingLeft: 7, fontSize: 12, fontWeight: 800, color: "#111827", marginBottom: 8 }}>구매한 상품 정보</div>
                    <div style={{ background: "#f9fafb", borderRadius: 6, padding: 12, marginBottom: 16, fontSize: 11, color: "#374151", lineHeight: 1.8 }}>
                      <b style={{ color: "#111" }}>(상품명 자동 입력)</b><br />
                      이용기간 · 이용횟수 자동 입력
                    </div>
                  </>
                )}

                {tplForm.show_payment && (
                  <>
                    <div style={{ borderLeft: "3px solid #2563eb", paddingLeft: 7, fontSize: 12, fontWeight: 800, color: "#111827", marginBottom: 8 }}>결제 정보</div>
                    <div style={{ fontSize: 11, color: "#374151", lineHeight: 2, marginBottom: 16 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #f3f4f6" }}><span>총 상품 금액</span><span style={{ color: "#b6bcc6" }}>자동</span></div>
                      <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #f3f4f6" }}><span>총 할인금액</span><span style={{ color: "#b6bcc6" }}>자동</span></div>
                      <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 800, color: "#111" }}><span>총 결제 금액</span><span style={{ color: "#2563eb" }}>자동</span></div>
                    </div>
                  </>
                )}

                <div style={{ borderLeft: "3px solid #2563eb", paddingLeft: 7, fontSize: 12, fontWeight: 800, color: "#111827", marginBottom: 8 }}>이용 약관</div>
                <div style={{ fontSize: 10.5, color: "#555", lineHeight: 1.7, background: "#fafbfc", borderRadius: 6, padding: 12, whiteSpace: "pre-wrap", minHeight: 50, marginBottom: 14 }}>
                  {tplForm.terms || <span style={{ color: "#c4cad4" }}>약관을 입력하면 여기에 표시됩니다.</span>}
                </div>

                {/* 약관 뒤 서명란 */}
                {tplForm.signers.filter(s => s.label.trim() && s.position === "terms").map((s, i) => (
                  <div key={"tsig" + i} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 8, marginBottom: 10, background: "#fafbfc", border: "1px solid #eef0f3", borderRadius: 5, padding: "8px 10px" }}>
                    <span style={{ fontSize: 10.5, color: "#333", fontWeight: 700 }}>{s.label}</span>
                    <span style={{ borderBottom: "1.5px solid #333", width: 90, height: 20, display: "inline-block" }}></span>
                    <span style={{ fontSize: 10, color: "#888" }}>(서명)</span>
                  </div>
                ))}

                {tplForm.consents.filter(c => c.label.trim()).length > 0 && (
                  <>
                    <div style={{ borderLeft: "3px solid #2563eb", paddingLeft: 7, fontSize: 12, fontWeight: 800, color: "#111827", marginBottom: 8 }}>동의 항목</div>
                    <div style={{ marginBottom: 14 }}>
                      {tplForm.consents.filter(c => c.label.trim()).map((c, i) => (
                        <div key={i} style={{ border: "1px solid #eef0f3", borderRadius: 5, padding: "8px 10px", marginBottom: 5 }}>
                          {c.detail && c.detail.trim() && (
                            <div style={{ fontSize: 9.5, color: "#6b7280", lineHeight: 1.6, whiteSpace: "pre-wrap", background: "#fafbfc", borderRadius: 4, padding: "7px 8px", marginBottom: 6 }}>
                              {c.detail}
                            </div>
                          )}
                          <div style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 10.5, color: "#374151" }}>
                            <span style={{ width: 12, height: 12, border: "1.5px solid #555", borderRadius: 2, flexShrink: 0, display: "inline-block" }}></span>
                            <span>{c.label}</span>
                            {c.required && <span style={{ color: "#ef4444", fontSize: 9.5, fontWeight: 700 }}>필수</span>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}

                {/* 동의 항목 뒤 서명란 */}
                {tplForm.signers.filter(s => s.label.trim() && s.position === "consent").map((s, i) => (
                  <div key={"csig" + i} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 8, marginBottom: 10, background: "#fafbfc", border: "1px solid #eef0f3", borderRadius: 5, padding: "8px 10px" }}>
                    <span style={{ fontSize: 10.5, color: "#333", fontWeight: 700 }}>{s.label}</span>
                    <span style={{ borderBottom: "1.5px solid #333", width: 90, height: 20, display: "inline-block" }}></span>
                    <span style={{ fontSize: 10, color: "#888" }}>(서명)</span>
                  </div>
                ))}

                <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid #eef0f3" }}>
                  <div style={{ fontSize: 10.5, color: "#666", textAlign: "center", marginBottom: 12 }}>
                    위의 내용에 약관을 확인하고 이에 동의합니다. &nbsp;&nbsp; 202__년 __월 __일
                  </div>
                  {tplForm.signers.filter(s => s.label.trim() && (s.position === "bottom" || !s.position)).map((s, i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 8, marginBottom: 10 }}>
                      <span style={{ fontSize: 10.5, color: "#333", fontWeight: 700 }}>{s.label}</span>
                      <span style={{ borderBottom: "1.5px solid #333", width: 100, height: 22, display: "inline-block" }}></span>
                      <span style={{ fontSize: 10, color: "#888" }}>(서명)</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 18 }}>
            <Btn variant="secondary" onClick={() => setShowTplModal(false)}>취소</Btn>
            <Btn onClick={saveTemplate} disabled={tplSaving}>
              {tplSaving ? "저장 중..." : (editingTpl ? "수정 저장" : "양식 저장")}
            </Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// PRODUCTS PAGE (상품관리)
// ════════════════════════════════════════════════════════════════════════════
const ProductsPage = ({ token, addToast }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [editTarget, setEditTarget] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [saving, setSaving] = useState(false);
  const [bannerUrl, setBannerUrl] = useState(null);
 const [form, setForm] = useState({
  name: "", category: "membership", 
  price: "", event_price: "",
  duration: "", sessions: "",
  start_date: "", end_date: "",
  description: ""
});

  const CATEGORIES = [
    { id: "all",        label: "전체 상품", tabLabel: "전체",      color: "#2563eb", bg: "#2563eb",    textColor: "#fff",    icon: "🛍️" },
    { id: "membership", label: "회원권",    tabLabel: "상품",      color: "#22c55e", bg: "#f0fdf4",    textColor: "#22c55e", icon: "🎫" },
    { id: "pt",         label: "개인",      tabLabel: "개인",      color: "#8b5cf6", bg: "#f5f3ff",    textColor: "#8b5cf6", icon: "👤" },
    { id: "gx",         label: "그룹",      tabLabel: "그룹",      color: "#f97316", bg: "#fff7ed",    textColor: "#f97316", icon: "👥" },
    { id: "locker", label: "락커", tabLabel: "락커", color: "#ec4899", bg: "#fdf2f8", textColor: "#ec4899", icon: "🔒" },
{ id: "clothes", label: "운동복", tabLabel: "운동복", color: "#f97316", bg: "#fff7ed", textColor: "#f97316", icon: "👕" },
  ];

  const BADGE_META = {
    membership: { label: "회원권",     color: "#22c55e", bg: "#f0fdf4" },
    pt:         { label: "개인",       color: "#8b5cf6", bg: "#f5f3ff" },
    gx:         { label: "그룹",       color: "#f97316", bg: "#fff7ed" },
    locker:  { label: "락커",   color: "#ec4899", bg: "#fdf2f8" },
    clothes: { label: "운동복", color: "#f97316", bg: "#fff7ed" },
    etc:        { label: "기타",       color: "#9ca3af", bg: "#f3f4f6" },
  };

  const resetForm = () => setForm({
  name: "", category: "membership",
  price: "", event_price: "",
  cash_price: "", card_price: "",
  duration: "", sessions: "",
  duration_value: "", duration_unit: "day",
  daily_entry_yn: "N",
  holding_yn: "N", holding_days: "", holding_count: "",
  transfer_yn: "N", transfer_count: "", transfer_unlimited: "N",
  cancel_count: "", group_capacity: "", image_url: "",
  is_featured: "N",
  entry_days: "", entry_start_time: "", entry_end_time: "",
  start_date: "", end_date: "",
  description: "",
  badge: "", short_desc: "",
  is_monthly_recommend: "N", event_start: "", event_end: ""
});
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/membership-plan/list?tenant_id=1", {}, token);
      setProducts(Array.isArray(d) ? d : d.items || []);
    } catch (e) { addToast("상품 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    api(`/membership-plan/shop-banner?tenant_id=1`, {}, token)
      .then(r => setBannerUrl(r && r.banner_url ? r.banner_url : null))
      .catch(() => {});
  }, [token]);

  const uploadBanner = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await fetch("https://heybiseo.ai.kr/membership-plan/shop-banner", {
        method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd,
      });
      const data = JSON.parse(await res.text());
      if (data.banner_url) { setBannerUrl(data.banner_url); addToast("상단 배너가 등록됐습니다", "success"); }
      else addToast("배너 업로드 실패", "error");
    } catch (e) { addToast("배너 업로드 실패: " + e.message, "error"); }
  };

  const deleteBanner = async () => {
    try {
      await fetch("https://heybiseo.ai.kr/membership-plan/shop-banner", {
        method: "DELETE", headers: { Authorization: `Bearer ${token}` },
      });
      setBannerUrl(null);
      addToast("배너가 삭제됐습니다 (앱에서 배너 숨김)", "success");
    } catch (e) { addToast("배너 삭제 실패: " + e.message, "error"); }
  };

  const openCreate = () => { setEditTarget(null); resetForm(); setShowModal(true); };
const openEdit = (p) => {
  setEditTarget(p);
  setForm({
    name: p.name || "", category: p.category || "membership",
    price: String(p.price || ""), event_price: String(p.event_price || ""),
    cash_price: String(p.cash_price || ""), card_price: String(p.card_price || ""),
    duration: String(p.duration || ""), sessions: String(p.sessions || ""),
    duration_value: String(p.duration_value || ""), duration_unit: p.duration_unit || "day",
    daily_entry_yn: p.daily_entry_yn || "N",
    holding_yn: p.holding_yn || "N",
    holding_days: String(p.holding_days || ""), holding_count: String(p.holding_count || ""),
    transfer_yn: p.transfer_yn || "N",
    transfer_count: String(p.transfer_count || ""), transfer_unlimited: p.transfer_unlimited || "N",
    cancel_count: String(p.cancel_count || ""), group_capacity: String(p.group_capacity || ""), image_url: p.image_url || "",
    is_featured: p.is_featured ? "Y" : "N",
    entry_days: p.entry_days || "", entry_start_time: p.entry_start_time || "", entry_end_time: p.entry_end_time || "",
    start_date: p.start_date || "", end_date: p.end_date || "",
    description: p.description || "",
    badge: p.badge || "", short_desc: p.short_desc || "",
    is_monthly_recommend: p.is_monthly_recommend ? "Y" : "N",
    event_start: p.event_start || "", event_end: p.event_end || ""
  });
  setShowModal(true);
};

  const uploadPlanImage = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await fetch("https://heybiseo.ai.kr/membership-plan/upload-image", {
        method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd,
      });
      const data = JSON.parse(await res.text());
      if (data.url) { setForm(p => ({ ...p, image_url: data.url })); addToast("상품 사진이 업로드됐습니다", "success"); }
      else addToast("업로드 실패", "error");
    } catch (e) { addToast("업로드 실패: " + e.message, "error"); }
  };

  const handleSave = async () => {
    if (!form.name || (!form.cash_price && !form.card_price)) return addToast("상품명과 가격은 필수입니다", "error");
    setSaving(true);
    try {
    const body = {
  name: form.name, category: form.category,
  price: form.card_price ? Number(form.card_price) : form.cash_price ? Number(form.cash_price) : Number(form.price || 0),
  cash_price: form.cash_price ? Number(form.cash_price) : null,
  card_price: form.card_price ? Number(form.card_price) : null,
  duration: form.duration_value ? Number(form.duration_value) : null,
  duration_value: form.duration_value ? Number(form.duration_value) : null,
  duration_unit: form.duration_unit,
  sessions: form.sessions ? Number(form.sessions) : null,
  description: form.description, tenant_id: 1,
  daily_entry_yn: form.daily_entry_yn,
  holding_yn: form.holding_yn,
  holding_days: form.holding_days ? Number(form.holding_days) : 0,
  holding_count: form.holding_count ? Number(form.holding_count) : 0,
  transfer_yn: form.transfer_yn,
  transfer_count: form.transfer_count ? Number(form.transfer_count) : 0,
  transfer_unlimited: form.transfer_unlimited,
  cancel_count: form.cancel_count ? Number(form.cancel_count) : 0,
  group_capacity: form.group_capacity ? Number(form.group_capacity) : null,
  image_url: form.image_url || null,
  is_featured: form.is_featured === "Y",
  entry_days: form.entry_days,
  entry_start_time: form.entry_start_time,
  entry_end_time: form.entry_end_time,
  badge: form.badge || null,
  short_desc: form.short_desc || null,
  is_monthly_recommend: form.is_monthly_recommend === "Y",
  event_start: form.event_start || null,
  event_end: form.event_end || null,
};
      if (editTarget) {
        await api(`/membership-plan/${editTarget.id}?tenant_id=1`, { method: "PUT", body: JSON.stringify(body) }, token);
        addToast("상품이 수정되었습니다", "success");
      } else {
        await api("/membership-plan", { method: "POST", body: JSON.stringify(body) }, token);
        addToast("상품이 등록되었습니다", "success");
      }
      setShowModal(false); resetForm(); load();
    } catch (e) { addToast((editTarget ? "수정" : "등록") + " 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("이 상품을 삭제하시겠습니까?")) return;
    try {
      await api(`/membership-plan/${id}`, { method: "DELETE" }, token);
      addToast("삭제되었습니다", "success");
      load();
    } catch (e) { addToast("삭제 실패: " + e.message, "error"); }
  };

  const getCount = (id) => id === "all" ? products.length : products.filter(p => (p.category || "membership") === id).length;

  const filtered = activeTab === "all"
    ? products
    : products.filter(p => (p.category || "membership") === activeTab);

  const formatDuration = (p) => {
    if (p.sessions) return `${p.sessions}회`;
    if (p.duration_value) return `${p.duration_value}${p.duration_unit === "month" ? "개월" : "일"}`;
    if (p.duration) return `${p.duration}일`;
    return "—";
  };

  const needsSessions = ["pt", "gx"].includes(form.category);
  const needsDuration = ["membership"].includes(form.category);

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}>
        <span style={{ color: "#9ca3af", fontSize: 18, cursor: "pointer" }}>‹</span>
        <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>상품관리</h2>
      </div>

      {/* 회원앱 상단 배너 */}
      <div style={{ background: "#fff", borderRadius: 14, padding: 18, marginBottom: 20, border: "1px solid #f3f4f6", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#111" }}>회원앱 상단 배너</div>
            <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>권장 1080×360 (3:1) · JPG/PNG · 2MB 이하 · 안 올리면 앱에서 배너 영역이 숨겨집니다</div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <label htmlFor="shop-banner-upload" style={{ padding: "8px 14px", fontSize: 13, fontWeight: 600, borderRadius: 8, border: "1px solid #2563eb", background: "#2563eb", color: "#fff", cursor: "pointer" }}>{bannerUrl ? "배너 교체" : "배너 업로드"}</label>
            <input id="shop-banner-upload" type="file" accept="image/*" style={{ display: "none" }}
              onChange={e => { const f = e.target.files[0]; if (f) uploadBanner(f); e.target.value = ""; }} />
            {bannerUrl && <button type="button" onClick={deleteBanner} style={{ padding: "8px 14px", fontSize: 13, fontWeight: 600, borderRadius: 8, border: "1px solid #fca5a5", background: "#fff", color: "#dc2626", cursor: "pointer" }}>삭제</button>}
          </div>
        </div>
        {bannerUrl
          ? <img src={`https://heybiseo.ai.kr${bannerUrl}`} alt="상단 배너" style={{ width: "100%", maxHeight: 160, objectFit: "cover", borderRadius: 10, border: "1px solid #eef0f3" }} />
          : <div style={{ width: "100%", height: 90, borderRadius: 10, border: "1px dashed #d1d5db", background: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", color: "#9ca3af", fontSize: 13 }}>등록된 배너가 없습니다 (앱에서 미표시)</div>}
      </div>

      {/* 상단 카운트 카드 */}
<div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
  {CATEGORIES.map((c) => {
    const count = getCount(c.id);
    const isAll = c.id === "all";
    const bgColor = isAll ? "#eff6ff" : c.bg;
    const textColor = isAll ? "#2563eb" : c.color;
    return (
      <div key={c.id} onClick={() => setActiveTab(c.id)} style={{
        flex: 1, borderRadius: 14, padding: "20px 24px", cursor: "pointer",
        background: bgColor,
        border: `1px solid ${textColor}22`,
        transition: "all .15s"
      }}>
        <div style={{ color: "#6b7280", fontSize: 13, marginBottom: 8 }}>{c.label}</div>
        <div style={{ color: textColor, fontSize: 28, fontWeight: 800 }}>
          {count}<span style={{ fontSize: 16, fontWeight: 700 }}>개</span>
        </div>
      </div>
    );
  })}
</div>

      {/* 탭 + 테이블 + 카드 */}
<div style={{ display: "flex", gap: 16 }}>
  
  {/* 탭 + 테이블 */}
  <div style={{ flex: 1, background: "#fff", borderRadius: 14, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>

   {/* 탭 + 신규 상품 등록 */}
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20, gap: 10, flexWrap: "wrap" }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {CATEGORIES.map(c => {
          const active = activeTab === c.id;
          return (
            <button key={c.id} onClick={() => setActiveTab(c.id)} style={{
              padding: "8px 20px", borderRadius: 20,
              border: `1px solid ${active ? "#2563eb" : "#e5e7eb"}`,
              background: active ? "#2563eb" : "#fff",
              color: active ? "#fff" : "#374151",
              fontSize: 13, fontWeight: active ? 700 : 500, cursor: "pointer"
            }}>{c.tabLabel}</button>
          );
        })}
      </div>
      <button onClick={openCreate} style={{
        display: "flex", alignItems: "center", gap: 6, padding: "10px 20px",
        background: "#2563eb", color: "#fff", border: "none", borderRadius: 10,
        fontSize: 14, fontWeight: 700, cursor: "pointer"
      }}>
        <Icon name="plus" size={14} color="#fff" /> 신규 상품 등록
      </button>
    </div>

    {/* 테이블 */}
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
      <thead>
        <tr>
          {["카테고리", "상품명", "가격", "기간", "횟수", "설명", "작업"].map(h => (
            <th key={h} style={{
              padding: "10px 16px", textAlign: "left",
              color: "#9ca3af", fontWeight: 600, fontSize: 12,
              borderBottom: "1px solid #f3f4f6"
            }}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr><td colSpan={7} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>로딩 중...</td></tr>
        ) : filtered.length === 0 ? (
          <tr><td colSpan={7} style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>등록된 상품이 없습니다</td></tr>
        ) : filtered.map((p, i) => {
          const meta = BADGE_META[p.category || "membership"] || BADGE_META.etc;
          return (
            <tr key={p.id}
              style={{ borderBottom: "1px solid #f9fafb", cursor: "pointer", background: selectedPlan?.id === p.id ? "#f0f4ff" : "transparent" }}
              onMouseEnter={e => e.currentTarget.style.background = selectedPlan?.id === p.id ? "#f0f4ff" : "#f9fafb"}
              onMouseLeave={e => e.currentTarget.style.background = selectedPlan?.id === p.id ? "#f0f4ff" : "transparent"}
              onClick={() => setSelectedPlan(p)}>
              <td style={{ padding: "14px 16px" }}>
                <span style={{
                  background: meta.bg, color: meta.color,
                  fontSize: 12, fontWeight: 600, padding: "4px 12px",
                  borderRadius: 20, border: `1px solid ${meta.color}33`,
                  whiteSpace: "nowrap"
                }}>{meta.label}</span>
              </td>
              <td style={{ padding: "14px 16px", fontWeight: 600, color: "#111" }}>
                <div>{p.name}</div>
                {p.holding_yn === "Y" ? (
                  <div style={{ fontSize: 11, color: "#8b5cf6", fontWeight: 600, marginTop: 3 }}>
                    ⏸ 홀딩 {p.holding_count || 0}회 · 1회 {p.holding_days || 0}일
                  </div>
                ) : (
                  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 3 }}>홀딩 불가</div>
                )}
              </td>
              <td style={{ padding: "14px 16px", fontWeight: 700, color: "#111" }}>
                {Number(p.price || 0).toLocaleString()}원
              </td>
              <td style={{ padding: "14px 16px", color: "#374151" }}>{p.duration_value ? `${p.duration_value}${p.duration_unit === "month" ? "개월" : p.duration_unit === "year" ? "년" : "일"}` : p.duration ? `${p.duration}일` : "—"}</td>
              <td style={{ padding: "14px 16px", color: "#374151" }}>{p.sessions ? `${p.sessions}회` : "—"}</td>
              <td style={{ padding: "14px 16px", color: "#6b7280" }}>{p.description || "—"}</td>
              <td style={{ padding: "14px 16px" }}>
                <div style={{ display: "flex", gap: 10 }}>
                  <button onClick={e => { e.stopPropagation(); openEdit(p); }} style={{
                    background: "none", border: "none", cursor: "pointer", padding: 4, color: "#2563eb"
                  }}>✏️</button>
                  <button onClick={e => { e.stopPropagation(); handleDelete(p.id); }} style={{
                    background: "none", border: "none", cursor: "pointer", padding: 4, color: "#ef4444"
                  }}>🗑️</button>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>

  {/* 오른쪽 상품 카드 */}
  {selectedPlan && (
    <div style={{ width: 280, flexShrink: 0 }}>
      <div style={{ border: "2px solid #2563eb", borderRadius: 16, overflow: "hidden", boxShadow: "0 4px 20px rgba(37,99,235,0.1)", position: "sticky", top: 80 }}>
        {/* 카드 헤더 */}
        <div style={{ background: "#2563eb", padding: "14px 16px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)" }}>
              {selectedPlan.category === "membership" ? "회원권" : selectedPlan.category === "pt" ? "개인PT" : selectedPlan.category === "gx" ? "그룹GX" : selectedPlan.category === "locker" ? "운동복&락커" : "기타"}
            </div>
            <button onClick={() => setSelectedPlan(null)} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: 16 }}>×</button>
          </div>
          <div style={{ fontSize: 18, fontWeight: 800, color: "#fff", marginTop: 4 }}>{selectedPlan.name}</div>
        </div>

        {/* 카드 바디 */}
        <div style={{ padding: 16 }}>
          {/* 기간/횟수 */}
          <div style={{ display: "flex", gap: 16, marginBottom: 14, paddingBottom: 14, borderBottom: "1px solid #f3f4f6" }}>
            <div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 3 }}>이용기간</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>
                {selectedPlan.duration_value ? `${selectedPlan.duration_value}${selectedPlan.duration_unit === "day" ? "일" : "개월"}` : selectedPlan.duration ? `${selectedPlan.duration}일` : "-"}
              </div>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 3 }}>이용횟수</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>
                {selectedPlan.sessions ? `${selectedPlan.sessions}회` : "무제한"}
              </div>
            </div>
          </div>

          {/* 요일 */}
          {selectedPlan.entry_days && (
            <div style={{ marginBottom: 14, paddingBottom: 14, borderBottom: "1px solid #f3f4f6" }}>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}>입장 가능 요일</div>
              <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                {selectedPlan.entry_days.split(",").filter(Boolean).map(d => (
                  <span key={d} style={{ background: "#eff6ff", color: "#2563eb", fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 6 }}>{d}</span>
                ))}
              </div>
              {selectedPlan.entry_start_time && selectedPlan.entry_end_time && (
                <div style={{ fontSize: 12, color: "#374151", marginTop: 6 }}>{selectedPlan.entry_start_time} ~ {selectedPlan.entry_end_time}</div>
              )}
            </div>
          )}

          {/* 옵션 뱃지 */}
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 14 }}>
            {selectedPlan.holding_yn === "Y" ? (
              <span style={{ background: "#f5f3ff", color: "#8b5cf6", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>
                홀딩 {selectedPlan.holding_count || 0}회 · 1회 {selectedPlan.holding_days || 0}일
              </span>
            ) : (
              <span style={{ background: "#f3f4f6", color: "#9ca3af", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>
                홀딩 불가
              </span>
            )}
            {selectedPlan.transfer_yn === "Y" && (
              <span style={{ background: "#f0fdf4", color: "#22c55e", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>
                양도가능 {selectedPlan.transfer_unlimited === "Y" ? "무제한" : selectedPlan.transfer_count ? `${selectedPlan.transfer_count}회` : ""}
              </span>
            )}
            {selectedPlan.daily_entry_yn === "Y" && (
              <span style={{ background: "#eff6ff", color: "#2563eb", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>다회 입장</span>
            )}
          </div>

          {/* 가격 */}
          <div style={{ background: "#f9fafb", borderRadius: 10, padding: "12px 14px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <span style={{ fontSize: 12, color: "#9ca3af" }}>정상가</span>
              <span style={{ fontSize: 18, fontWeight: 800, color: "#111" }}>
                {selectedPlan.cash_price ? Number(selectedPlan.cash_price).toLocaleString() : Number(selectedPlan.price || 0).toLocaleString()}원
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 12, color: "#9ca3af" }}>이벤트가</span>
              <span style={{ fontSize: 18, fontWeight: 800, color: "#2563eb" }}>
                {selectedPlan.card_price ? Number(selectedPlan.card_price).toLocaleString() : Number(selectedPlan.price || 0).toLocaleString()}원
              </span>
            </div>
          </div>

          {/* 설명 */}
          {selectedPlan.description && (
            <div style={{ marginTop: 12, fontSize: 12, color: "#6b7280", lineHeight: 1.6 }}>
              {selectedPlan.description}
            </div>
          )}

          {/* 수정 버튼 */}
          <button onClick={() => { openEdit(selectedPlan); setSelectedPlan(null); }} style={{
            width: "100%", marginTop: 14, padding: "10px 0", borderRadius: 10,
            border: "none", background: "#2563eb", color: "#fff",
            fontSize: 13, fontWeight: 700, cursor: "pointer"
          }}>✏️ 수정하기</button>
        </div>
      </div>
    </div>
  )}
</div>
      {/* 등록/수정 모달 */}
{showModal && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
    <div style={{ background: "#f3f6fb", borderRadius: 20, width: "100%", maxWidth: 1000, maxHeight: "90vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 24px 80px rgba(0,0,0,0.2)" }}>
      
      {/* 모달 헤더 */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 24px", background: "#fff", borderBottom: "1px solid #f0f0f0" }}>
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#111" }}>{editTarget ? "상품 수정" : "신규 상품 등록"}</h3>
        <button onClick={() => { setShowModal(false); resetForm(); }} style={{ background: "#f3f4f6", border: "none", borderRadius: 8, padding: "8px 10px", cursor: "pointer", fontSize: 18, color: "#6b7280" }}>×</button>
      </div>

      {/* 모달 바디 */}
      <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>

        {/* 왼쪽 입력 폼 */}
        <div style={{ flex: 1, overflowY: "auto", padding: 24, display: "flex", flexDirection: "column", gap: 20 }}>

          {/* 파트 1 - 기본정보 */}
          <div style={{ background: "#fff", borderRadius: 14, padding: 20, border: "1px solid #f3f4f6" }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 16, paddingBottom: 10, borderBottom: "1px solid #f3f4f6" }}>
              📋 기본 정보
            </div>
            <Select label="상품 유형 *" value={form.category} onChange={e => setForm(p => ({ ...p, category: e.target.value }))}>
              <option value="membership">회원권</option>
              <option value="pt">개인 (PT)</option>
              <option value="gx">그룹 (GX)</option>
              <option value="locker">락커</option>
              <option value="clothes">운동복</option>
              <option value="etc">기타</option>
            </Select>
            <Input label="상품명 *" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="예: 3개월 회원권" />
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>상품 사진 <span style={{ color: "#9ca3af", fontWeight: 400 }}>(선택 · 없으면 아이콘으로 표시)</span></label>
              <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 8 }}>권장 500×500px (정사각형 1:1) · JPG/PNG · 2MB 이하 · 정사각형으로 잘려 표시되니 중요한 내용은 가운데에 넣어주세요</div>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 64, height: 64, borderRadius: 10, border: "1px solid #e5e7eb", background: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 }}>
                  {form.image_url
                    ? <img src={`https://heybiseo.ai.kr${form.image_url}`} alt="상품 사진" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    : <span style={{ fontSize: 22, color: "#cbd5e1" }}>🏋</span>}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  <label htmlFor="plan-image-upload" style={{ padding: "8px 12px", fontSize: 12, fontWeight: 600, borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", color: "#374151", cursor: "pointer", textAlign: "center" }}>📁 사진 선택</label>
                  <input id="plan-image-upload" type="file" accept="image/*" style={{ display: "none" }}
                    onChange={e => { const f = e.target.files[0]; if (f) uploadPlanImage(f); e.target.value = ""; }} />
                  {form.image_url && <button type="button" onClick={() => setForm(p => ({ ...p, image_url: "" }))} style={{ padding: "6px 10px", fontSize: 11, borderRadius: 8, border: "1px solid #fca5a5", background: "#fff", color: "#dc2626", cursor: "pointer" }}>사진 제거</button>}
                </div>
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
              <div>
                <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>정상가</label>
                <div style={{ position: "relative" }}>
                  <input type="number" value={form.cash_price} onChange={e => setForm(p => ({ ...p, cash_price: e.target.value }))}
                    placeholder="0" style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 36px 10px 12px", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                  <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "#6b7280", fontSize: 13 }}>원</span>
                </div>
              </div>
              <div>
                <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>이벤트가</label>
                <div style={{ position: "relative" }}>
                  <input type="number" value={form.card_price} onChange={e => setForm(p => ({ ...p, card_price: e.target.value }))}
                    placeholder="0" style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 36px 10px 12px", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                  <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "#6b7280", fontSize: 13 }}>원</span>
                </div>
              </div>
            </div>
            <div>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>상품 설명</label>
              <textarea value={form.description} onChange={e => setForm(p => ({ ...p, description: e.target.value }))}
                placeholder="상품 설명 입력" rows={3}
                style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "none", fontFamily: "inherit" }} />
            </div>
          </div>

          {/* 파트 2 - 기간 및 이용 설정 */}
          <div style={{ background: "#fff", borderRadius: 14, padding: 20, border: "1px solid #f3f4f6" }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 16, paddingBottom: 10, borderBottom: "1px solid #f3f4f6" }}>
              ⚙️ 기간 및 이용 설정
            </div>

            {/* 기간 설정 */}
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 8 }}>이용 기간</label>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input type="number" value={form.duration_value} onChange={e => setForm(p => ({ ...p, duration_value: e.target.value }))}
                  placeholder="0" style={{ width: 80, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none" }} />
                <div style={{ display: "flex", gap: 4 }}>
                  {["day", "month"].map(u => (
                    <button key={u} onClick={() => setForm(p => ({ ...p, duration_unit: u }))} style={{
                      padding: "8px 16px", borderRadius: 8, border: `1px solid ${form.duration_unit === u ? "#2563eb" : "#e5e7eb"}`,
                      background: form.duration_unit === u ? "#2563eb" : "#fff",
                      color: form.duration_unit === u ? "#fff" : "#374151",
                      fontSize: 13, fontWeight: 600, cursor: "pointer"
                    }}>{u === "day" ? "일" : "월"}</button>
                  ))}
                </div>
                <span style={{ fontSize: 13, color: "#9ca3af" }}>
                  {form.duration_value ? `${form.duration_value}${form.duration_unit === "day" ? "일" : "개월"}` : ""}
                </span>
              </div>
            </div>

            {/* 횟수 설정 */}
            <div style={{ marginBottom: 16, display: "flex", gap: 24, flexWrap: "wrap", alignItems: "flex-start" }}>
              <div>
                <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 8 }}>이용 횟수</label>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <input type="number" value={form.sessions} onChange={e => setForm(p => ({ ...p, sessions: e.target.value }))}
                    placeholder="무제한" style={{ width: 80, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none" }} />
                  <span style={{ fontSize: 13, color: "#9ca3af" }}>회 (미입력 시 무제한)</span>
                </div>
              </div>
              {(form.category === "pt" || form.category === "gx") && (
                <div>
                  <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 8 }}>취소 가능 횟수</label>
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <input type="number" value={form.cancel_count} onChange={e => setForm(p => ({ ...p, cancel_count: e.target.value }))}
                      placeholder="0" style={{ width: 80, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none" }} />
                    <span style={{ fontSize: 13, color: "#9ca3af" }}>회</span>
                  </div>
                </div>
              )}
              {form.category === "gx" && (
                <div>
                  <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 8 }}>그룹 정원 (1:N)</label>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    <span style={{ fontSize: 13, color: "#374151", fontWeight: 700 }}>1 :</span>
                    <input type="number" value={form.group_capacity} onChange={e => setForm(p => ({ ...p, group_capacity: e.target.value }))}
                      placeholder="예: 5" style={{ width: 70, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none" }} />
                    <span style={{ fontSize: 13, color: "#9ca3af" }}>명</span>
                  </div>
                </div>
              )}
            </div>

            {/* 일일 입장 가능 여부 */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, padding: "12px 16px", background: "#f9fafb", borderRadius: 10 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>일일 다회 입장 가능 여부</div>
                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>하루에 여러 번 입장 가능 여부</div>
              </div>
              <button onClick={() => setForm(p => ({ ...p, daily_entry_yn: p.daily_entry_yn === "Y" ? "N" : "Y" }))} style={{
                width: 48, height: 26, borderRadius: 13, border: "none", cursor: "pointer",
                background: form.daily_entry_yn === "Y" ? "#2563eb" : "#d1d5db", position: "relative", transition: "all .2s"
              }}>
                <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, transition: "all .2s", left: form.daily_entry_yn === "Y" ? 25 : 3 }} />
              </button>
            </div>

            {/* 홀딩 가능 여부 */}
            <div style={{ marginBottom: 16, padding: "12px 16px", background: "#f9fafb", borderRadius: 10 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: form.holding_yn === "Y" ? 12 : 0 }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>홀딩 가능 여부</div>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>수업 일시 중단 가능 여부</div>
                </div>
                <button onClick={() => setForm(p => ({ ...p, holding_yn: p.holding_yn === "Y" ? "N" : "Y" }))} style={{
                  width: 48, height: 26, borderRadius: 13, border: "none", cursor: "pointer",
                  background: form.holding_yn === "Y" ? "#2563eb" : "#d1d5db", position: "relative", transition: "all .2s"
                }}>
                  <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, transition: "all .2s", left: form.holding_yn === "Y" ? 25 : 3 }} />
                </button>
              </div>
              {form.holding_yn === "Y" && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <div>
                    <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>일수 제한</label>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <input type="number" value={form.holding_days} onChange={e => setForm(p => ({ ...p, holding_days: e.target.value }))}
                        placeholder="0" style={{ width: 70, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", fontSize: 13, outline: "none" }} />
                      <span style={{ fontSize: 13, color: "#9ca3af" }}>일</span>
                    </div>
                  </div>
                  <div>
                    <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>횟수 제한</label>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <input type="number" value={form.holding_count} onChange={e => setForm(p => ({ ...p, holding_count: e.target.value }))}
                        placeholder="0" style={{ width: 70, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", fontSize: 13, outline: "none" }} />
                      <span style={{ fontSize: 13, color: "#9ca3af" }}>회</span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* 양도 가능 여부 */}
            <div style={{ marginBottom: 16, padding: "12px 16px", background: "#f9fafb", borderRadius: 10 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: form.transfer_yn === "Y" ? 12 : 0 }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>양도 가능 여부</div>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>타인에게 회원권 양도 가능 여부</div>
                </div>
                <button onClick={() => setForm(p => ({ ...p, transfer_yn: p.transfer_yn === "Y" ? "N" : "Y" }))} style={{
                  width: 48, height: 26, borderRadius: 13, border: "none", cursor: "pointer",
                  background: form.transfer_yn === "Y" ? "#2563eb" : "#d1d5db", position: "relative", transition: "all .2s"
                }}>
                  <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, transition: "all .2s", left: form.transfer_yn === "Y" ? 25 : 3 }} />
                </button>
              </div>
              {form.transfer_yn === "Y" && (
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <input type="number" value={form.transfer_count} onChange={e => setForm(p => ({ ...p, transfer_count: e.target.value }))}
                      placeholder="0" disabled={form.transfer_unlimited === "Y"}
                      style={{ width: 70, background: form.transfer_unlimited === "Y" ? "#f3f4f6" : "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", fontSize: 13, outline: "none" }} />
                    <span style={{ fontSize: 13, color: "#9ca3af" }}>회</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <button onClick={() => setForm(p => ({ ...p, transfer_unlimited: p.transfer_unlimited === "Y" ? "N" : "Y" }))} style={{
                      width: 40, height: 22, borderRadius: 11, border: "none", cursor: "pointer",
                      background: form.transfer_unlimited === "Y" ? "#2563eb" : "#d1d5db", position: "relative", transition: "all .2s"
                    }}>
                      <div style={{ width: 16, height: 16, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, transition: "all .2s", left: form.transfer_unlimited === "Y" ? 21 : 3 }} />
                    </button>
                    <span style={{ fontSize: 13, color: "#374151" }}>무제한</span>
                  </div>
                </div>
              )}
            </div>

            {/* 매장 추천 노출 */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, padding: "12px 16px", background: "#f9fafb", borderRadius: 10 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>매장 추천 노출</div>
                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>설정 시 우선 순위로 상단에 노출됩니다</div>
              </div>
              <button onClick={() => setForm(p => ({ ...p, is_featured: p.is_featured === "Y" ? "N" : "Y" }))} style={{
                width: 48, height: 26, borderRadius: 13, border: "none", cursor: "pointer",
                background: form.is_featured === "Y" ? "#2563eb" : "#d1d5db", position: "relative", transition: "all .2s"
              }}>
                <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, transition: "all .2s", left: form.is_featured === "Y" ? 25 : 3 }} />
              </button>
            </div>

            {/* 회원앱 표시 설정 (배민 스타일 리스트) */}
            <div style={{ padding: "12px 16px", background: "#f0f7ff", borderRadius: 10, marginBottom: 16, border: "1px solid #dbeafe" }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#1d4ed8", marginBottom: 6 }}>📱 회원앱 표시 설정</div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 12 }}>💡 할인 표시는 위 <b>기본 정보의 정상가·이벤트가 차이</b>로 자동 계산되어 앱에 취소선 + 할인액으로 표시됩니다.</div>

              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>상품 뱃지</div>
                <select value={form.badge} onChange={e => setForm(p => ({ ...p, badge: e.target.value }))}
                  style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "9px 10px", fontSize: 13, outline: "none", background: "#fff", boxSizing: "border-box" }}>
                  <option value="">없음</option>
                  {["매장추천", "이달의 행사", "이벤트상품", "신상품", "BEST", "한정수량"].map(b => <option key={b} value={b}>{b}</option>)}
                </select>
                <div style={{ fontSize: 10.5, color: "#9ca3af", marginTop: 3 }}>앱 상품명 위에 뱃지로 표시됩니다</div>
              </div>

              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>한 줄 설명 <span style={{ color: "#9ca3af", fontWeight: 400 }}>({(form.short_desc || "").length}/15자)</span></div>
                <input value={form.short_desc} maxLength={15} onChange={e => setForm(p => ({ ...p, short_desc: e.target.value.slice(0, 15) }))}
                  placeholder="예) 이달 한정 특가!"
                  style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "9px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                <div style={{ fontSize: 10.5, color: "#9ca3af", marginTop: 3 }}>앱 상품명 아래 작은 글씨로 표시됩니다 (최대 15자)</div>
              </div>

              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: form.is_monthly_recommend === "Y" ? 10 : 0 }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "#111" }}>이달의 추천 상품</div>
                  <div style={{ fontSize: 10.5, color: "#9ca3af", marginTop: 2 }}>회원앱 상품 리스트 하단 프로모션 배너에 강조됩니다</div>
                </div>
                <button onClick={() => setForm(p => ({ ...p, is_monthly_recommend: p.is_monthly_recommend === "Y" ? "N" : "Y" }))} style={{
                  width: 48, height: 26, borderRadius: 13, border: "none", cursor: "pointer",
                  background: form.is_monthly_recommend === "Y" ? "#2563eb" : "#d1d5db", position: "relative", transition: "all .2s"
                }}>
                  <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, transition: "all .2s", left: form.is_monthly_recommend === "Y" ? 25 : 3 }} />
                </button>
              </div>
              {form.is_monthly_recommend === "Y" && (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>이벤트 시작일</div>
                    <input type="date" value={form.event_start} onChange={e => setForm(p => ({ ...p, event_start: e.target.value }))}
                      style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", fontSize: 13, outline: "none", background: "#fff", boxSizing: "border-box" }} />
                  </div>
                  <span style={{ color: "#9ca3af", marginTop: 18 }}>~</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>이벤트 종료일</div>
                    <input type="date" value={form.event_end} onChange={e => setForm(p => ({ ...p, event_end: e.target.value }))}
                      style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", fontSize: 13, outline: "none", background: "#fff", boxSizing: "border-box" }} />
                  </div>
                </div>
              )}
            </div>

            {/* 입장 가능 요일 및 시간대 */}
            <div style={{ padding: "12px 16px", background: "#f9fafb", borderRadius: 10 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginBottom: 12 }}>입장 가능 요일 및 시간대</div>
              <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
                {["월", "화", "수", "목", "금", "토", "일"].map(d => {
                  const selected = (form.entry_days || "").includes(d);
                  return (
                    <button key={d} onClick={() => {
                      const days = form.entry_days ? form.entry_days.split(",").filter(Boolean) : [];
                      if (selected) {
                        setForm(p => ({ ...p, entry_days: days.filter(x => x !== d).join(",") }));
                      } else {
                        setForm(p => ({ ...p, entry_days: [...days, d].join(",") }));
                      }
                    }} style={{
                      width: 36, height: 36, borderRadius: "50%", border: `1px solid ${selected ? "#2563eb" : "#e5e7eb"}`,
                      background: selected ? "#2563eb" : "#fff",
                      color: selected ? "#fff" : "#374151",
                      fontSize: 12, fontWeight: 600, cursor: "pointer"
                    }}>{d}</button>
                  );
                })}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <TimePicker value={form.entry_start_time} onChange={v => setForm(p => ({ ...p, entry_start_time: v }))}
                  style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", background: "#fff" }} />
                <span style={{ color: "#9ca3af" }}>~</span>
                <TimePicker value={form.entry_end_time} onChange={v => setForm(p => ({ ...p, entry_end_time: v }))}
                  style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", background: "#fff" }} />
              </div>
            </div>
          </div>

          {/* 저장 버튼 */}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button onClick={() => { setShowModal(false); resetForm(); }} style={{
              padding: "12px 24px", borderRadius: 10, border: "1px solid #e5e7eb",
              background: "#fff", color: "#374151", fontSize: 14, fontWeight: 600, cursor: "pointer"
            }}>취소</button>
            <button onClick={handleSave} disabled={saving} style={{
              padding: "12px 32px", borderRadius: 10, border: "none",
              background: "#2563eb", color: "#fff", fontSize: 14, fontWeight: 700,
              cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.7 : 1
            }}>{saving ? "저장 중..." : editTarget ? "수정하기" : "등록하기"}</button>
          </div>
        </div>

        {/* 오른쪽 미리보기 카드 */}
        <div style={{ width: 300, background: "#fff", borderLeft: "1px solid #f0f0f0", padding: 24, overflowY: "auto", flexShrink: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 16 }}>미리보기</div>
          
          {/* 카드 */}
          <div style={{ border: "2px solid #2563eb", borderRadius: 16, overflow: "hidden", boxShadow: "0 4px 20px rgba(37,99,235,0.1)" }}>
            {/* 카드 헤더 */}
            <div style={{ background: "#2563eb", padding: "14px 16px" }}>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", marginBottom: 4 }}>
                {form.category === "membership" ? "회원권" : form.category === "pt" ? "개인PT" : form.category === "gx" ? (form.group_capacity ? `그룹GX 1:${form.group_capacity}` : "그룹GX") : form.category === "locker" ? "운동복&락커" : "기타"}
              </div>
              <div style={{ fontSize: 18, fontWeight: 800, color: "#fff" }}>{form.name || "상품명"}</div>
            </div>

            {/* 카드 바디 */}
            <div style={{ padding: "16px" }}>
              {/* 기간/횟수 */}
              <div style={{ display: "flex", gap: 16, marginBottom: 14, paddingBottom: 14, borderBottom: "1px solid #f3f4f6" }}>
                <div>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 3 }}>이용기간</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>
                    {form.duration_value ? `${form.duration_value}${form.duration_unit === "day" ? "일" : "개월"}` : "-"}
                  </div>
                </div>
                <div>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 3 }}>이용횟수</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>
                    {form.sessions ? `${form.sessions}회` : "무제한"}
                  </div>
                </div>
              </div>

              {/* 요일 */}
              {form.entry_days && (
                <div style={{ marginBottom: 14, paddingBottom: 14, borderBottom: "1px solid #f3f4f6" }}>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}>입장 가능 요일</div>
                  <div style={{ display: "flex", gap: 4 }}>
                    {(form.entry_days || "").split(",").filter(Boolean).map(d => (
                      <span key={d} style={{ background: "#eff6ff", color: "#2563eb", fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 6 }}>{d}</span>
                    ))}
                  </div>
                  {form.entry_start_time && form.entry_end_time && (
                    <div style={{ fontSize: 12, color: "#374151", marginTop: 4 }}>{form.entry_start_time} ~ {form.entry_end_time}</div>
                  )}
                </div>
              )}

              {/* 옵션 뱃지 */}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 14 }}>
                {form.holding_yn === "Y" && <span style={{ background: "#f5f3ff", color: "#8b5cf6", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>홀딩가능</span>}
                {form.transfer_yn === "Y" && <span style={{ background: "#f0fdf4", color: "#22c55e", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>양도가능</span>}
                {form.daily_entry_yn === "Y" && <span style={{ background: "#eff6ff", color: "#2563eb", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>다회 입장</span>}
              </div>

              {/* 가격 */}
              <div style={{ background: "#f9fafb", borderRadius: 10, padding: "12px 14px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                  <span style={{ fontSize: 12, color: "#9ca3af" }}>정상가</span>
                  <span style={{ fontSize: 16, fontWeight: 800, color: "#111" }}>
                    {form.cash_price ? Number(form.cash_price).toLocaleString() : "0"}원
                  </span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: 12, color: "#9ca3af" }}>이벤트가</span>
                  <span style={{ fontSize: 16, fontWeight: 800, color: "#2563eb" }}>
                    {form.card_price ? Number(form.card_price).toLocaleString() : "0"}원
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* 설명 */}
          {form.description && (
            <div style={{ marginTop: 12, padding: "12px 14px", background: "#f9fafb", borderRadius: 10, fontSize: 12, color: "#6b7280", lineHeight: 1.6 }}>
              {form.description}
            </div>
          )}

          {/* ── 회원앱에서 보이는 모습 (배민 스타일 목업) ── */}
          {(() => {
            const sale = Number(form.card_price || form.cash_price || 0);
            const strike = Number(form.cash_price || 0) > sale ? Number(form.cash_price) : 0;
            const discountAmt = strike > 0 ? strike - sale : 0;
            const discountRate = strike > 0 ? Math.floor((discountAmt * 100) / strike) : 0;
            const monthly = sale > 0 ? Math.floor(sale / 3) : 0;
            const catMeta = {
              membership: { icon: "🎫", label: "회원권", bg: "#E6F1FB", chipBg: "#E1F5EE", chipColor: "#0F6E56" },
              pt: { icon: "👤", label: "개인PT", bg: "#E1F5EE", chipBg: "#EEEDFE", chipColor: "#3C3489" },
              gx: { icon: "👥", label: "그룹GX", bg: "#FAEEDA", chipBg: "#FAEEDA", chipColor: "#854F0B" },
              locker: { icon: "🔒", label: "락커", bg: "#F1EFE8", chipBg: "#F1EFE8", chipColor: "#444441" },
              clothes: { icon: "👕", label: "운동복", bg: "#F1EFE8", chipBg: "#F1EFE8", chipColor: "#444441" },
            }[form.category] || { icon: "🎫", label: "회원권", bg: "#E6F1FB", chipBg: "#E1F5EE", chipColor: "#0F6E56" };
            const badgeMeta = {
              "매장추천": { border: "#F59E0B", color: "#B45309", bg: "#FFFBEB" },
              "이달의 행사": { border: "#60A5FA", color: "#1D4ED8", bg: "#EFF6FF" },
              "이벤트상품": { border: "#F87171", color: "#B91C1C", bg: "#FEF2F2" },
              "신상품": { border: "#34D399", color: "#047857", bg: "#ECFDF5" },
              "BEST": { border: "#A78BFA", color: "#6D28D9", bg: "#F5F3FF" },
              "한정수량": { border: "#9CA3AF", color: "#374151", bg: "#F9FAFB" },
            }[form.badge];
            return (
              <div style={{ marginTop: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#1d4ed8", marginBottom: 8 }}>📱 회원앱에서 보이는 모습</div>
                {/* 앱 상품 카드 목업 */}
                <div style={{ display: "flex", alignItems: "center", background: "#fff", border: "1px solid #EFF0F3", borderRadius: 12, padding: 12 }}>
                  <div style={{ width: 48, height: 48, borderRadius: 8, background: catMeta.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0, overflow: "hidden" }}>{form.image_url ? <img src={`https://heybiseo.ai.kr${form.image_url}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : catMeta.icon}</div>
                  <div style={{ marginLeft: 10, minWidth: 0, flex: 1 }}>
                    <div style={{ display: "flex", gap: 4, alignItems: "center", flexWrap: "wrap" }}>
                      {badgeMeta && (
                        <span style={{ fontSize: 9.5, fontWeight: 800, color: badgeMeta.color, background: badgeMeta.bg, border: `1px solid ${badgeMeta.border}`, borderRadius: 4, padding: "1px 5px" }}>{form.badge}</span>
                      )}
                      {form.is_featured === "Y" && (
                        <span style={{ fontSize: 9.5, fontWeight: 800, color: "#fff", background: "#F59E0B", borderRadius: 4, padding: "1px 5px" }}>추천</span>
                      )}
                      <span style={{ fontSize: 9.5, fontWeight: 600, color: catMeta.chipColor, background: catMeta.chipBg, borderRadius: 999, padding: "1px 7px" }}>{form.category === "gx" && form.group_capacity ? `${catMeta.label} 1:${form.group_capacity}` : catMeta.label}</span>
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 800, color: "#111827", marginTop: 3, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{form.name || "상품명"}</div>
                    {form.short_desc && <div style={{ fontSize: 10.5, color: "#9CA3AF", marginTop: 1 }}>{form.short_desc}</div>}
                    <div style={{ display: "flex", alignItems: "baseline", gap: 5, marginTop: 3 }}>
                      {strike > 0 && <span style={{ fontSize: 11, color: "#B4B2A9", textDecoration: "line-through" }}>{strike.toLocaleString()}원</span>}
                      <span style={{ fontSize: 15, fontWeight: 800, color: "#111827" }}>{sale.toLocaleString()}원</span>
                    </div>
                    {discountAmt > 0 && <div style={{ fontSize: 11, fontWeight: 800, color: "#2563EB", marginTop: 1 }}>{discountAmt.toLocaleString()}원 할인 ({discountRate}%)</div>}
                    {monthly > 0 && <div style={{ fontSize: 10, color: "#6B7280", marginTop: 2 }}>3개월 할부 시 월 {monthly.toLocaleString()}원</div>}
                  </div>
                  <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#E5E7EB", flexShrink: 0, marginLeft: 6 }} />
                </div>
                {/* 하단 프로모션 배너 목업 (이달의 추천 시) */}
                {form.is_monthly_recommend === "Y" && (
                  <div style={{ display: "flex", alignItems: "center", gap: 6, background: "#14213D", borderRadius: 999, padding: "9px 14px", marginTop: 8 }}>
                    <span style={{ fontSize: 9.5, fontWeight: 800, color: "#14213D", background: "#FBBF24", borderRadius: 4, padding: "1px 5px", flexShrink: 0 }}>이달의 추천</span>
                    <span style={{ fontSize: 11, fontWeight: 700, color: "#fff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", flex: 1 }}>{form.name || "상품명"}</span>
                    <span style={{ fontSize: 10.5, fontWeight: 800, color: "#FBBF24", flexShrink: 0 }}>
                      {discountRate > 0 ? `${discountRate}% 할인` : ""}{form.event_end ? `${discountRate > 0 ? " · " : ""}~${form.event_end.slice(5).replace("-", "/")}까지` : ""}{discountRate === 0 && !form.event_end ? "자세히 보기" : ""} ›
                    </span>
                  </div>
                )}
                <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 6 }}>※ 회원앱 상품 리스트에 위와 같이 표시됩니다{form.is_monthly_recommend === "Y" ? " (하단 배너 포함)" : ""}</div>
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// LESSONS PAGE (강사 수업 관리)
// ════════════════════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════════
// 시간 선택 그리드 팝업 (직접 타이핑 + 30분 슬롯 클릭)
// ═══════════════════════════════════════════════════════════════════
const TimePicker = ({ value, onChange, intervalMinutes = 30, startHour = 6, endHour = 24, placeholder = "HH:MM" }) => {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");
  const wrapRef = useRef(null);

  useEffect(() => { setInputValue(value || ""); }, [value]);

  // 바깥 클릭 시 닫기
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  // 슬롯 생성 (startHour ~ endHour, intervalMinutes 간격)
  const slots = [];
  for (let h = startHour; h < endHour; h++) {
    for (let m = 0; m < 60; m += intervalMinutes) {
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      slots.push(`${hh}:${mm}`);
    }
  }

  // HH:MM 형식 검증
  const isValidTime = (v) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(v);

  const handleInputChange = (e) => {
    let v = e.target.value.replace(/[^\d:]/g, "");
    // 자동 콜론: 숫자만 2개 입력 시 ":" 자동 추가
    if (v.length === 2 && !v.includes(":") && inputValue.length < 2) v = v + ":";
    if (v.length > 5) v = v.slice(0, 5);
    setInputValue(v);
    if (isValidTime(v)) onChange(v);
  };

  const handleBlur = () => {
    if (isValidTime(inputValue)) onChange(inputValue);
    else setInputValue(value || "");
  };

  const handleSlotClick = (slot) => {
    setInputValue(slot);
    onChange(slot);
    setOpen(false);
  };

  return (
    <div ref={wrapRef} style={{ position: "relative", display: "inline-block", width: 140 }}>
      <div style={{ display: "flex", alignItems: "center", border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff", overflow: "hidden" }}>
        <input
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setOpen(true)}
          onBlur={handleBlur}
          placeholder={placeholder}
          maxLength={5}
          style={{ flex: 1, padding: "10px 12px", border: "none", outline: "none", fontSize: 13, minWidth: 0, background: "transparent" }}
        />
        <button
          type="button"
          onClick={() => setOpen(o => !o)}
          style={{ padding: "0 10px", height: 36, border: "none", background: "#f9fafb", cursor: "pointer", color: "#6b7280", borderLeft: "1px solid #e5e7eb" }}
          title="시간 선택"
        >🕐</button>
      </div>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 1000,
          background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)", padding: 8,
          width: 280, maxHeight: 300, overflowY: "auto"
        }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 4 }}>
            {slots.map(slot => {
              const selected = slot === inputValue;
              return (
                <button
                  key={slot}
                  type="button"
                  onClick={() => handleSlotClick(slot)}
                  style={{
                    padding: "8px 0", borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: "pointer",
                    border: `1px solid ${selected ? "#2563eb" : "#e5e7eb"}`,
                    background: selected ? "#2563eb" : "#fff",
                    color: selected ? "#fff" : "#374151"
                  }}
                >{slot}</button>
              );
            })}
          </div>
          <div style={{ fontSize: 11, color: "#9ca3af", textAlign: "center", marginTop: 8, paddingTop: 8, borderTop: "1px solid #f3f4f6" }}>
            직접 타이핑도 가능합니다 (예: 14:25)
          </div>
        </div>
      )}
    </div>
  );
};
const LessonsPage = ({ token, addToast }) => {
  const [lessons, setLessons] = useState([]);
  const [stats, setStats] = useState({ total_today: 0, completed_today: 0, cancelled_today: 0, no_show_today: 0 });
  const [loading, setLoading] = useState(true);
  const [trainers, setTrainers] = useState([]);
  const [products, setProducts] = useState([]);
  const [trainerFilter, setTrainerFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("newest");
  const [showModal, setShowModal] = useState(false);
  const [editTarget, setEditTarget] = useState(null);
  const [holidayTarget, setHolidayTarget] = useState(null);
  const [holidayForm, setHolidayForm] = useState({ date: "", reason: "" });
  const [tenantPolicy, setTenantPolicy] = useState({
  default_cancel_cutoff_value: 24,
  default_cancel_cutoff_unit: "HOUR",
  default_deduction_count: 1
});

useEffect(() => {
  api(`/tenant/1/settings`, {}, token).then(d => {
    setTenantPolicy({
      default_cancel_cutoff_value: d.default_cancel_cutoff_value ?? 24,
      default_cancel_cutoff_unit: d.default_cancel_cutoff_unit ?? "HOUR",
      default_deduction_count: d.default_deduction_count ?? 1
    });
  }).catch(() => {});
}, [token]);

  const unitLabel = (u) => ({ HOUR: "시간", DAY: "일", WEEK: "주" }[u] || "시간");
  const [holidayList, setHolidayList] = useState([]);
  const [actionPopup, setActionPopup] = useState(null);
  const [saving, setSaving] = useState(false);

  const initialForm = {
    trainer_id: "", name: "", type: "PT", product_id: "", product_ids: [],
    capacity: 1, min_capacity: 0, days_of_week: [], start_time: "", duration_minutes: 50, deduction_count: null,announcement: "",
    start_date: ymdKST(), end_date: "",
    app_booking_enabled: false,
    booking_open_value: 1, booking_open_unit: "WEEK",
    booking_close_value: 1, booking_close_unit: "HOUR",
    cancel_cutoff_value: null, cancel_cutoff_unit: null, deduction_count: null,
    same_day_change_value: null, same_day_change_unit: null,
    auto_close_value: null, auto_close_unit: null,
    announcement: "",
    attendance_check_enabled: false,
    attendance_check_value: 0, attendance_check_unit: "MINUTE",
    sms_enabled: false,
    sms_send_value: 10, sms_send_unit: "MINUTE", sms_method: "SMS",
    waitlist_enabled: false, waitlist_sms_enabled: false,
    waitlist_capacity: 0, waitlist_auto_value: null, waitlist_auto_unit: null,
    show_remaining: false,
    seat_assignment: false, seat_rows: 5, seat_cols: 5, seat_disabled_numbers: "[]",
    cross_branch_enabled: false,
    session_fee: "",
  };
  const [form, setForm] = useState(initialForm);

  const dayLabels = { MON: "월", TUE: "화", WED: "수", THU: "목", FRI: "금", SAT: "토", SUN: "일" };
  const dayOrder = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
  const unitLabels = { HOUR: "시간", DAY: "일", WEEK: "주" };

  const loadAll = useCallback(async () => {
    setLoading(true);
    try {
  const [lessonsRes, statsRes] = await Promise.all([
        api("/lesson/list", {}, token),
        api("/lesson/stats", {}, token),
      ]);
      setLessons(Array.isArray(lessonsRes) ? lessonsRes : []);
      setStats(statsRes || {});
    } catch (e) { addToast("로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token, addToast]);

  useEffect(() => {
    loadAll();
    api("/staff/list?tenant_id=1", {}, token).then(d => setTrainers(Array.isArray(d) ? d : [])).catch(() => {});
    api("/membership-plan/list", {}, token).then(d => setProducts(Array.isArray(d) ? d : [])).catch(() => {});
  }, [loadAll]);

  const filtered = lessons
    .filter(l => {
      const matchTrainer = trainerFilter ? l.trainer_id === parseInt(trainerFilter) : true;
      const matchName = nameFilter ? l.name === nameFilter : true;
      const matchSearch = search ? (l.trainer_name?.includes(search) || l.name?.includes(search)) : true;
      return matchTrainer && matchName && matchSearch;
    })
    .sort((a, b) => sort === "name" ? (a.name || "").localeCompare(b.name || "") : new Date(b.created_at) - new Date(a.created_at));

  const openCreate = () => {
    setEditTarget(null);
    setForm(initialForm);
    setShowModal(true);
  };

  const openEdit = (lesson) => {
    setEditTarget(lesson);
    setForm({
      trainer_id: String(lesson.trainer_id || ""),
      name: lesson.name || "",
      type: lesson.type || "PT",
      product_id: lesson.product_id ? String(lesson.product_id) : "",
      product_ids: lesson.product_ids || [],
      capacity: lesson.capacity || 1,
      min_capacity: lesson.min_capacity ?? 0,
      days_of_week: lesson.days_of_week ? lesson.days_of_week.split(",") : [],
      start_time: lesson.start_time?.slice(0, 5) || "",
      announcement: lesson.announcement || "",
      duration_minutes: lesson.duration_minutes || 50,
      deduction_count: lesson.deduction_count,
      start_date: lesson.start_date || ymdKST(),
      end_date: lesson.end_date || "",
      app_booking_enabled: !!lesson.app_booking_enabled,
      booking_open_value: lesson.booking_open_value || 1,
      booking_open_unit: lesson.booking_open_unit || "WEEK",
      booking_close_value: lesson.booking_close_value || 1,
      booking_close_unit: lesson.booking_close_unit || "HOUR",
      cancel_cutoff_value: lesson.cancel_cutoff_value,
      cancel_cutoff_unit: lesson.cancel_cutoff_unit,
      attendance_check_enabled: !!lesson.attendance_check_enabled,
      attendance_check_value: lesson.attendance_check_value ?? 0,
      attendance_check_unit: lesson.attendance_check_unit || "MINUTE",
      sms_enabled: !!lesson.sms_enabled,
      sms_send_value: lesson.sms_send_value ?? 10,
      sms_send_unit: lesson.sms_send_unit || "MINUTE",
      sms_method: lesson.sms_method || "SMS",
      waitlist_enabled: !!lesson.waitlist_enabled,
      waitlist_sms_enabled: !!lesson.waitlist_sms_enabled,
      waitlist_capacity: lesson.waitlist_capacity ?? 0,
      waitlist_auto_value: lesson.waitlist_auto_value,
      waitlist_auto_unit: lesson.waitlist_auto_unit,
      same_day_change_value: lesson.same_day_change_value,
      same_day_change_unit: lesson.same_day_change_unit,
      auto_close_value: lesson.auto_close_value,
      auto_close_unit: lesson.auto_close_unit,
      show_remaining: !!lesson.show_remaining,
      seat_assignment: !!lesson.seat_assignment,
      seat_rows: lesson.seat_rows || 5,
      seat_cols: lesson.seat_cols || 5,
      seat_disabled_numbers: lesson.seat_disabled_numbers || "[]",
      cross_branch_enabled: !!lesson.cross_branch_enabled,
      session_fee: lesson.session_fee != null ? String(lesson.session_fee) : "",
      cancel_cutoff_value: null,
      cancel_cutoff_unit: null,
      deduction_count: null,
    });
    setShowModal(true);
  };

  const handleSubmit = async () => {
    if (!form.trainer_id) return addToast("담당 강사를 선택하세요", "error");
    if (!form.name) return addToast("수업명을 입력하세요", "error");
    if (form.days_of_week.length === 0) return addToast("요일을 선택하세요", "error");
    if (!form.start_time) return addToast("시작 시간을 입력하세요", "error");
    if (!form.duration_minutes) return addToast("수업 시간을 입력하세요", "error");

    setSaving(true);
    try {
      const payload = {
        trainer_id: parseInt(form.trainer_id),
        name: form.name,
        type: form.type,
        product_id: null,  // 단일 product_id는 더 이상 사용 안 함
        product_ids: form.product_ids || [],
        capacity: parseInt(form.capacity) || 1,
        min_capacity: parseInt(form.min_capacity) || 0,
        days_of_week: form.days_of_week.join(","),
        start_time: form.start_time.length === 5 ? form.start_time + ":00" : form.start_time,
        duration_minutes: parseInt(form.duration_minutes),
        deduction_count: form.deduction_count != null ? parseInt(form.deduction_count) : null,
        start_date: form.start_date,
        end_date: form.end_date || null,
        app_booking_enabled: form.app_booking_enabled,
        booking_open_value: form.app_booking_enabled ? parseInt(form.booking_open_value) : null,
        booking_open_unit: form.app_booking_enabled ? form.booking_open_unit : null,
        booking_close_value: form.app_booking_enabled ? parseInt(form.booking_close_value) : null,
        announcement: form.announcement || null,
        booking_close_unit: form.app_booking_enabled ? form.booking_close_unit : null,
        cancel_cutoff_value: form.app_booking_enabled && form.cancel_cutoff_value != null ? parseInt(form.cancel_cutoff_value) : null,
        cancel_cutoff_unit: form.app_booking_enabled && form.cancel_cutoff_unit ? form.cancel_cutoff_unit : null,
        // 당일 예약변경 가능 시간
        same_day_change_value: form.app_booking_enabled && form.same_day_change_value != null ? parseInt(form.same_day_change_value) : null,
        same_day_change_unit: form.app_booking_enabled && form.same_day_change_unit ? form.same_day_change_unit : null,
        // 폐강 (최소인원 미달 자동삭제)
        auto_close_value: form.auto_close_value != null ? parseInt(form.auto_close_value) : null,
        auto_close_unit: form.auto_close_unit || null,
        // 출석 처리 시간
        attendance_check_enabled: form.attendance_check_enabled,
        attendance_check_value: parseInt(form.attendance_check_value) || 0,
        attendance_check_unit: form.attendance_check_unit || "MINUTE",
        // 예약 문자 발송
        sms_enabled: form.sms_enabled,
        sms_send_value: parseInt(form.sms_send_value) || 10,
        sms_send_unit: form.sms_send_unit || "MINUTE",
        sms_method: form.sms_method || "SMS",
        // 예약 대기
        waitlist_enabled: form.waitlist_enabled,
        waitlist_sms_enabled: form.waitlist_sms_enabled,
        waitlist_capacity: form.waitlist_enabled ? (parseInt(form.waitlist_capacity) || 0) : 0,
        waitlist_auto_value: form.waitlist_enabled && form.waitlist_auto_value != null ? parseInt(form.waitlist_auto_value) : null,
        waitlist_auto_unit: form.waitlist_enabled && form.waitlist_auto_unit ? form.waitlist_auto_unit : null,
        // 잔여 인원 노출
        show_remaining: form.show_remaining,
        // 좌석 수업
        seat_assignment: form.seat_assignment,
        seat_rows: parseInt(form.seat_rows) || 5,
        seat_cols: parseInt(form.seat_cols) || 5,
        seat_disabled_numbers: form.seat_disabled_numbers || "[]",
        // 타지점 예약
        cross_branch_enabled: form.cross_branch_enabled,
        session_fee: form.session_fee ? parseInt(form.session_fee) : null,
      };
      if (editTarget) {
        await api(`/lesson/${editTarget.id}`, { method: "PUT", body: JSON.stringify(payload) }, token);
        addToast("수업이 수정되었습니다", "success");
      } else {
        const _times = [...new Set([form.start_time, ...(form.extra_times || [])].filter(Boolean))];
        for (const _t of _times) {
          const _tt = _t.length === 5 ? _t + ":00" : _t;
          await api("/lesson", { method: "POST", body: JSON.stringify({ ...payload, start_time: _tt }) }, token);
        }
        addToast(`수업이 ${_times.length}개 시간대로 생성되었습니다`, "success");
      }
      setShowModal(false);
      loadAll();
    } catch (e) { addToast("저장 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };

  const handleClose = async (lesson) => {
    if (!window.confirm(`"${lesson.name}" 수업을 폐강하시겠습니까?\n\n향후 예약된 회원은 자동 취소되며 푸시 알림이 발송됩니다.`)) return;
    try {
      await api(`/lesson/${lesson.id}`, { method: "DELETE" }, token);
      addToast("수업이 폐강되었습니다", "success");
      setActionPopup(null);
      loadAll();
    } catch (e) { addToast("폐강 실패: " + e.message, "error"); }
  };

  const handleSuspendToggle = async (lesson) => {
    const newStatus = lesson.status === "ACTIVE" ? "SUSPENDED" : "ACTIVE";
    const action = newStatus === "SUSPENDED" ? "일시 중단" : "재개";
    if (!window.confirm(`"${lesson.name}" 수업을 ${action}하시겠습니까?`)) return;
    try {
      await api(`/lesson/${lesson.id}`, { method: "PUT", body: JSON.stringify({ status: newStatus }) }, token);
      addToast(`수업이 ${action}되었습니다`, "success");
      setActionPopup(null);
      loadAll();
    } catch (e) { addToast("실패: " + e.message, "error"); }
  };

  const openHoliday = async (lesson) => {
    setHolidayTarget(lesson);
    setHolidayForm({ date: "", reason: "" });
    setActionPopup(null);
    try {
      const list = await api(`/lesson/${lesson.id}/holiday`, {}, token);
      setHolidayList(Array.isArray(list) ? list : []);
    } catch (e) { setHolidayList([]); }
  };

  const handleHolidayCreate = async () => {
    if (!holidayForm.date) return addToast("날짜를 선택하세요", "error");
    try {
      await api(`/lesson/${holidayTarget.id}/holiday`, {
        method: "POST",
        body: JSON.stringify({ date: holidayForm.date, reason: holidayForm.reason || null })
      }, token);
      addToast("휴강이 등록되었습니다", "success");
      setHolidayForm({ date: "", reason: "" });
      const list = await api(`/lesson/${holidayTarget.id}/holiday`, {}, token);
      setHolidayList(Array.isArray(list) ? list : []);
      loadAll();
    } catch (e) { addToast("휴강 실패: " + e.message, "error"); }
  };

  const handleHolidayDelete = async (hid) => {
    if (!window.confirm("휴강을 취소하시겠습니까?")) return;
    try {
      await api(`/lesson/${holidayTarget.id}/holiday/${hid}`, { method: "DELETE" }, token);
      addToast("휴강이 취소되었습니다", "success");
      const list = await api(`/lesson/${holidayTarget.id}/holiday`, {}, token);
      setHolidayList(Array.isArray(list) ? list : []);
    } catch (e) { addToast("실패: " + e.message, "error"); }
  };

  const toggleDay = (day) => {
    setForm(p => ({
      ...p,
      days_of_week: p.days_of_week.includes(day)
        ? p.days_of_week.filter(d => d !== day)
        : [...p.days_of_week, day]
    }));
  };
  const toggleAllDays = () => {
    setForm(p => ({ ...p, days_of_week: p.days_of_week.length === 7 ? [] : [...dayOrder] }));
  };

  const inputStyle = { width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box", background: "#fff" };
  const labelStyle = { display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 6 };
  const sectionTitle = { fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 12, marginTop: 8 };

  const NumStepper = ({ value, onChange, suffix, min = 0 }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <button onClick={() => onChange(Math.max(min, parseInt(value || 0) - 1))} style={{ width: 36, height: 36, borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer", fontSize: 16 }}>−</button>
      <input type="number" value={value} onChange={e => onChange(e.target.value)} style={{ width: 70, height: 36, textAlign: "center", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none" }} />
      <button onClick={() => onChange(parseInt(value || 0) + 1)} style={{ width: 36, height: 36, borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", cursor: "pointer", fontSize: 16 }}>+</button>
      {suffix && <span style={{ fontSize: 13, color: "#6b7280" }}>{suffix}</span>}
    </div>
  );

  const ToggleBtn = ({ value, onChange, options }) => (
    <div style={{ display: "flex", gap: 6 }}>
      {options.map(opt => (
        <button key={String(opt.value)} onClick={() => onChange(opt.value)}
          style={{
            padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer",
            border: `1px solid ${value === opt.value ? "#2563eb" : "#e5e7eb"}`,
            background: value === opt.value ? "#2563eb" : "#fff",
            color: value === opt.value ? "#fff" : "#374151"
          }}>{opt.label}</button>
      ))}
    </div>
  );

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
        <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>강사 수업 관리</h2>
      </div>

      <div style={{ background: "#fff", borderRadius: 14, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
        <div style={{ display: "flex", gap: 12, marginBottom: 16, alignItems: "center" }}>
          <select value={trainerFilter} onChange={e => setTrainerFilter(e.target.value)} style={{ ...inputStyle, width: 160 }}>
            <option value="">담당강사명</option>
            {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
          <select value={nameFilter} onChange={e => setNameFilter(e.target.value)} style={{ ...inputStyle, width: 160 }}>
            <option value="">수업명</option>
            {[...new Set(lessons.map(l => l.name))].map(n => <option key={n} value={n}>{n}</option>)}
          </select>
          <div style={{ position: "relative", flex: 1 }}>
            <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}><Icon name="search" size={14} /></span>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="강사 또는 수업명을 기입해주세요"
              style={{ ...inputStyle, paddingLeft: 32 }} />
          </div>
          <select value={sort} onChange={e => setSort(e.target.value)} style={{ ...inputStyle, width: 140 }}>
            <option value="newest">최신순</option>
            <option value="name">이름순</option>
          </select>
          <Btn onClick={openCreate}><Icon name="plus" size={14} /> 강사 수업 생성</Btn>
        </div>

        <Table loading={loading} columns={[
          { key: "id", label: "번호", render: (v, row, i) => i + 1 },
          { key: "trainer_name", label: "담당 강사" },
          { key: "name", label: "수업명" },
          { key: "type", label: "상품명", render: (v, row) => {
            const tc = v === "PT" ? { bg: "#ede9fe", color: "#7c3aed" } : { bg: "#fff7ed", color: "#f97316" };
            return <span style={{ background: tc.bg, color: tc.color, padding: "4px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600 }}>
              {row.product_name || (v === "PT" ? "개인 수업" : "그룹 수업")}
            </span>;
          }},
          { key: "capacity", label: "수강 정원", render: v => `${v}명` },
          { key: "duration_minutes", label: "수업 시간", render: (v, row) => `${row.start_time?.slice(0,5)} (${v}분)` },
          { key: "days_of_week", label: "수업 요일", render: v => {
            if (!v) return "-";
            return dayOrder.filter(d => v.split(",").includes(d)).map(d => dayLabels[d]).join(" ");
          }},
          { key: "status", label: "상태", render: v => {
            const map = { ACTIVE: { label: "운영중", color: "#22c55e", bg: "#f0fdf4" }, SUSPENDED: { label: "중단", color: "#f59e0b", bg: "#fffbeb" }, CLOSED: { label: "폐강", color: "#9ca3af", bg: "#f3f4f6" } };
            const m = map[v] || map.ACTIVE;
            return <span style={{ background: m.bg, color: m.color, padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700, border: `1px solid ${m.color}33` }}>{m.label}</span>;
          }},
          { key: "id", label: "관리", render: (v, row) => (
            <div style={{ display: "flex", gap: 6 }}>
              <button onClick={() => openEdit(row)} style={{ padding: "5px 12px", borderRadius: 6, border: "1px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: 12, cursor: "pointer" }}>수정</button>
              <button onClick={() => openHoliday(row)} style={{ padding: "5px 12px", borderRadius: 6, border: "1px solid #fde68a", background: "#fffbeb", color: "#d97706", fontSize: 12, cursor: "pointer" }}>휴강</button>
              {row.status !== "CLOSED" && (
                <button onClick={() => handleSuspendToggle(row)} style={{ padding: "5px 12px", borderRadius: 6, border: "1px solid #e5e7eb", background: "#fff", color: row.status === "SUSPENDED" ? "#22c55e" : "#f59e0b", fontSize: 12, cursor: "pointer" }}>
                  {row.status === "SUSPENDED" ? "재개" : "중단"}
                </button>
              )}
              <button onClick={() => handleClose(row)} style={{ padding: "5px 12px", borderRadius: 6, border: "1px solid #fecaca", background: "#fff0f0", color: "#ef4444", fontSize: 12, cursor: "pointer" }}>폐강</button>
            </div>
          )},
        ]} data={filtered} emptyMsg="등록된 수업이 없습니다" />
      </div>

      {/* 수업 생성/수정 모달 */}
      {showModal && (
        <Modal title={editTarget ? "수업 수정" : "수업 생성"} onClose={() => setShowModal(false)}>
          <div style={sectionTitle}>강사 및 수업 배정</div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>담당 강사</label>
            <select value={form.trainer_id} onChange={e => setForm(p => ({ ...p, trainer_id: e.target.value }))} style={inputStyle}>
              <option value="">강사를 선택해주세요</option>
              {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>수업명</label>
            <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="수업명을 입력해 주세요" style={inputStyle} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>수업 유형</label>
            <ToggleBtn value={form.type} onChange={v => setForm(p => ({ ...p, type: v }))} options={[
              { value: "PT", label: "개인 수업" }, { value: "GROUP", label: "그룹 수업" }
            ]} />
          </div>
          {form.type === "GROUP" && (
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>수업료 (1회, 정산 %용 · 선택)</label>
              <input value={form.session_fee || ""} onChange={e => setForm(p => ({ ...p, session_fee: e.target.value }))} placeholder="예: 100000" type="number" style={inputStyle} />
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>강사 정산이 '수업료의 %' 방식일 때 이 금액에 %를 곱합니다. 고정금액 정산이면 비워도 돼요.</div>
            </div>
          )}

         <div style={sectionTitle}>예약 가능 회원권 (다중 선택)</div>
<div style={{ marginBottom: 14 }}>
  <label style={labelStyle}>이 수업을 예약할 수 있는 회원권을 모두 선택하세요</label>
  {products.length === 0 ? (
    <div style={{ padding: 12, background: "#fff7ed", borderRadius: 8, fontSize: 12, color: "#f97316" }}>
      등록된 상품이 없습니다. 상품관리에서 먼저 등록해주세요.
    </div>
  ) : (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 220, overflowY: "auto", padding: 8, background: "#f9fafb", borderRadius: 10 }}>
      {products.map(p => {
        const selected = (form.product_ids || []).includes(p.id);
        return (
          <div key={p.id}
            onClick={() => {
              setForm(prev => {
                const ids = prev.product_ids || [];
                return {
                  ...prev,
                  product_ids: selected ? ids.filter(x => x !== p.id) : [...ids, p.id]
                };
              });
            }}
            style={{
              display: "flex", alignItems: "center", gap: 10,
              padding: "10px 12px",
              background: selected ? "#eff6ff" : "#fff",
              border: `1.5px solid ${selected ? "#2563eb" : "#e5e7eb"}`,
              borderRadius: 8, cursor: "pointer", fontSize: 13,
              transition: "all 0.15s"
            }}>
            <div style={{
              width: 18, height: 18, borderRadius: 4,
              border: `2px solid ${selected ? "#2563eb" : "#d1d5db"}`,
              background: selected ? "#2563eb" : "#fff",
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0
            }}>
              {selected && <span style={{ color: "#fff", fontSize: 12, fontWeight: "bold" }}>✓</span>}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, color: "#111" }}>{p.name}</div>
              {p.category && <div style={{ fontSize: 11, color: "#6b7280" }}>{p.category}</div>}
            </div>
          </div>
        );
      })}
    </div>
  )}
  {(form.product_ids || []).length > 0 && (
    <div style={{ marginTop: 8, fontSize: 12, color: "#2563eb", fontWeight: 600 }}>
      ✓ {(form.product_ids || []).length}개 선택됨
    </div>
  )}
</div>

          <div style={sectionTitle}>상세 설정</div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>{form.type === "PT" ? "수업 인원" : "최대 수강 정원"}</label>
            {form.type === "PT" ? (
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {[[1, "개인 (1:1)"], [2, "듀엣 (2:1)"], [3, "트리플 (3:1)"]].map(([v, lab]) => (
                  <button key={v} type="button" onClick={() => setForm(p => ({ ...p, capacity: v }))} style={{
                    padding: "8px 16px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                    border: `1px solid ${form.capacity === v ? "#2563eb" : "#e5e7eb"}`,
                    background: form.capacity === v ? "#eff6ff" : "#fff",
                    color: form.capacity === v ? "#2563eb" : "#374151"
                  }}>{lab}</button>
                ))}
              </div>
            ) : (
              <NumStepper value={form.capacity} onChange={v => setForm(p => ({ ...p, capacity: v }))} suffix="명" min={1} />
            )}
          </div>
          {form.type === "GROUP" && (
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>최소 수강 인원 (폐강 기준)</label>
              <NumStepper value={form.min_capacity} onChange={v => setForm(p => ({ ...p, min_capacity: v }))} suffix="명" min={0} />
              {form.min_capacity > 0 && (
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginTop: 10, background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 8, padding: "10px 12px" }}>
                  <span style={{ fontSize: 13, color: "#9a3412" }}>최소 인원 미달 시 수업 시작</span>
                  <NumStepper value={form.auto_close_value ?? 0} onChange={v => setForm(p => ({ ...p, auto_close_value: parseInt(v) || 0 }))} min={0} />
                  <select value={form.auto_close_unit || "HOUR"} onChange={e => setForm(p => ({ ...p, auto_close_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
                    <option value="HOUR">시간</option><option value="MINUTE">분</option>
                  </select>
                  <span style={{ fontSize: 13, color: "#9a3412" }}>전에 자동 폐강</span>
                </div>
              )}
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>0명이면 폐강되지 않습니다.</div>
            </div>
          )}
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>요일 선택</label>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              <button onClick={toggleAllDays} style={{
                padding: "8px 16px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                border: `1px solid ${form.days_of_week.length === 7 ? "#2563eb" : "#e5e7eb"}`,
                background: form.days_of_week.length === 7 ? "#2563eb" : "#fff",
                color: form.days_of_week.length === 7 ? "#fff" : "#374151"
              }}>전체</button>
              {dayOrder.map(d => (
                <button key={d} onClick={() => toggleDay(d)} style={{
                  padding: "8px 16px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                  border: `1px solid ${form.days_of_week.includes(d) ? "#2563eb" : "#e5e7eb"}`,
                  background: form.days_of_week.includes(d) ? "#2563eb" : "#fff",
                  color: form.days_of_week.includes(d) ? "#fff" : "#374151"
                }}>{dayLabels[d]}</button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>수업 시작 시간</label>
            <TimePicker value={form.start_time} onChange={v => setForm(p => ({ ...p, start_time: v }))} />
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
              <span style={{ fontSize: 12, color: "#6b7280" }}>시간 추가</span>
              <div style={{ width: 150 }}>
                <TimePicker value={form._newTime || ""} onChange={v => setForm(p => ({ ...p, _newTime: v }))} placeholder="추가할 시간" />
              </div>
              <button type="button" onClick={() => setForm(p => {
                const t = p._newTime;
                if (!t) return p;
                const cur = p.extra_times || [];
                if (t === p.start_time || cur.includes(t)) return { ...p, _newTime: "" };
                return { ...p, extra_times: [...cur, t], _newTime: "" };
              })} style={{ padding: "8px 14px", borderRadius: 8, border: "1px solid #2563eb", background: "#eff6ff", color: "#2563eb", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ 추가</button>
            </div>
            {(form.extra_times || []).length > 0 && (
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 10, alignItems: "center" }}>
                {form.start_time && (
                  <span style={{ padding: "5px 10px", borderRadius: 20, background: "#e0e7ff", color: "#3730a3", fontSize: 12, fontWeight: 700 }}>{form.start_time} (대표)</span>
                )}
                {(form.extra_times || []).map((t, i) => (
                  <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "5px 10px", borderRadius: 20, background: "#eff6ff", color: "#2563eb", fontSize: 12, fontWeight: 700 }}>
                    {t}
                    <span onClick={() => setForm(p => ({ ...p, extra_times: (p.extra_times || []).filter(x => x !== t) }))} style={{ cursor: "pointer" }}>✕</span>
                  </span>
                ))}
              </div>
            )}
            <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 6 }}>여러 시간대에 같은 수업을 열려면 시간을 추가하세요. 추가한 시간마다 수업이 생성됩니다.</div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>수업 시간</label>
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
              <NumStepper value={form.duration_minutes} onChange={v => setForm(p => ({ ...p, duration_minutes: v }))} suffix="분" />
              {[20, 30, 50].map(m => (
                <button key={m} onClick={() => setForm(p => ({ ...p, duration_minutes: m }))} style={{
                  padding: "6px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                  border: `1px solid ${form.duration_minutes === m ? "#2563eb" : "#e5e7eb"}`,
                  background: form.duration_minutes === m ? "#eff6ff" : "#fff",
                  color: form.duration_minutes === m ? "#2563eb" : "#374151"
                }}>{m}분</button>
              ))}
            </div>
          </div>
          
          <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>운영 시작일</label>
              <input type="date" value={form.start_date} onChange={e => setForm(p => ({ ...p, start_date: e.target.value }))} style={inputStyle} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>운영 종료일 (선택)</label>
              <input type="date" value={form.end_date} onChange={e => setForm(p => ({ ...p, end_date: e.target.value }))} style={inputStyle} />
            </div>
          </div>
          <div style={{ marginBottom: 14 }}>
  <label style={labelStyle}>회원 안내사항 (선택)</label>
  <textarea
    value={form.announcement || ""}
    onChange={e => setForm(p => ({ ...p, announcement: e.target.value }))}
    placeholder="예약 완료 후 회원에게 보여줄 안내사항을 입력하세요&#10;예: 운동복, 양말 지참 부탁드려요&#10;출입 QR은 홈 화면에서 확인 가능해요"
    style={{ ...inputStyle, minHeight: 90, resize: "vertical", fontFamily: "inherit", lineHeight: 1.6 }}
  />
  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
    줄바꿈으로 항목 구분 · 회원앱 예약 완료 화면에 표시됩니다
  </div>
</div>

{/* 앱 예약 섹션 */}
<div style={{ marginTop: 20, marginBottom: 14, padding: "16px 0", borderTop: "1px solid #f3f4f6" }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.app_booking_enabled ? 16 : 0 }}>
    <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>앱 예약</div>
    <ToggleBtn value={form.app_booking_enabled} onChange={v => setForm(p => ({ ...p, app_booking_enabled: v }))} options={[
      { value: true, label: "사용함" }, { value: false, label: "사용안함" }
    ]} />
  </div>

  {form.app_booking_enabled && (
    <div style={{ background: "#f9fafb", borderRadius: 12, padding: 16 }}>
      {/* 예약 가능 시간 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginBottom: 10 }}>예약 가능 시간</div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>예약은 각 일정 시작 시각</span>
          <NumStepper value={form.booking_open_value} onChange={v => setForm(p => ({ ...p, booking_open_value: v }))} min={1} />
          <select value={form.booking_open_unit} onChange={e => setForm(p => ({ ...p, booking_open_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
            <option value="HOUR">시간</option><option value="DAY">일</option><option value="WEEK">주</option>
          </select>
          <span style={{ fontSize: 13, color: "#6b7280" }}>전부터 가능</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>각 일정 시작 시각</span>
          <NumStepper value={form.booking_close_value} onChange={v => setForm(p => ({ ...p, booking_close_value: v }))} min={0} />
          <select value={form.booking_close_unit} onChange={e => setForm(p => ({ ...p, booking_close_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
            <option value="HOUR">시간</option><option value="DAY">일</option><option value="WEEK">주</option>
          </select>
          <span style={{ fontSize: 13, color: "#6b7280" }}>전에 마감</span>
        </div>
      </div>

     {/* 예약 취소 정책 (토글 UX) */}
<div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
  <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginBottom: 10 }}>예약 취소 정책</div>

  {form.cancel_cutoff_value === -1 ? (
    /* 취소 불가 */
    <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 12, padding: "14px 16px" }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: "#dc2626", marginBottom: 8 }}>🚫 이 수업은 예약 취소가 불가능합니다</div>
      <span onClick={() => setForm(p => ({ ...p, cancel_cutoff_value: null, cancel_cutoff_unit: null, deduction_count: null }))}
        style={{ fontSize: 12, color: "#2563eb", cursor: "pointer", textDecoration: "underline" }}>← 취소 가능으로 변경</span>
    </div>
  ) : (form.cancel_cutoff_value == null && form.cancel_cutoff_unit == null && form.deduction_count == null) ? (
    /* 시안 ① 공통 설정 사용 중 */
    <div style={{ background: "#f3f4f6", border: "1px solid #e5e7eb", borderRadius: 12, padding: "14px 16px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, color: "#6b7280", marginBottom: 12 }}>
        🔒 가맹점 공통 설정 사용 중
      </div>
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "11px 13px", marginBottom: 12 }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 6 }}>
          <span style={{ color: "#6b7280" }}>취소 가능 시간</span>
          <span style={{ color: "#111", fontWeight: 600 }}>
            시작 {tenantPolicy.default_cancel_cutoff_value}{unitLabel(tenantPolicy.default_cancel_cutoff_unit)} 전까지
          </span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
          <span style={{ color: "#6b7280" }}>이후 차감</span>
          <span style={{ color: "#111", fontWeight: 600 }}>{tenantPolicy.default_deduction_count}회 (노쇼 포함)</span>
        </div>
      </div>
      <button
        type="button"
        onClick={() => setForm(p => ({
          ...p,
          cancel_cutoff_value: tenantPolicy.default_cancel_cutoff_value,
          cancel_cutoff_unit: tenantPolicy.default_cancel_cutoff_unit,
          deduction_count: tenantPolicy.default_deduction_count
        }))}
        style={{ padding: "7px 14px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", fontSize: 12, fontWeight: 600, color: "#374151", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}
      >
        ✏️ 이 수업만 따로 설정
      </button>
      <button
        type="button"
        onClick={() => setForm(p => ({ ...p, cancel_cutoff_value: -1, cancel_cutoff_unit: null, deduction_count: null }))}
        style={{ marginLeft: 8, padding: "7px 14px", borderRadius: 8, border: "1px solid #fecaca", background: "#fff", fontSize: 12, fontWeight: 600, color: "#dc2626", cursor: "pointer" }}
      >
        🚫 취소 불가로 설정
      </button>
    </div>
  ) : (
    /* 시안 ② 개별 설정 활성화 */
    <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 12, padding: "14px 16px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 600, color: "#2563eb", marginBottom: 12 }}>
        ✏️ 이 수업 전용 정책
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
        <span style={{ fontSize: 13, color: "#374151" }}>각 일정 시작 시각</span>
        <NumStepper value={form.cancel_cutoff_value ?? 0} onChange={v => setForm(p => ({ ...p, cancel_cutoff_value: parseInt(v) || 0 }))} min={0} />
        <select value={form.cancel_cutoff_unit || "HOUR"} onChange={e => setForm(p => ({ ...p, cancel_cutoff_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
          <option value="HOUR">시간</option><option value="DAY">일</option><option value="WEEK">주</option>
        </select>
        <span style={{ fontSize: 13, color: "#374151" }}>전까지 무료 취소 가능</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        <span style={{ fontSize: 13, color: "#374151" }}>이후 취소 시</span>
        <NumStepper value={form.deduction_count ?? 1} onChange={v => setForm(p => ({ ...p, deduction_count: parseInt(v) || 0 }))} min={0} />
        <span style={{ fontSize: 13, color: "#374151" }}>회 차감 (노쇼 포함)</span>
      </div>
      <span
        onClick={() => setForm(p => ({ ...p, cancel_cutoff_value: null, cancel_cutoff_unit: null, deduction_count: null }))}
        style={{ fontSize: 12, color: "#2563eb", cursor: "pointer", textDecoration: "underline" }}
      >
        ← 가맹점 공통 설정으로 되돌리기
      </span>
    </div>
  )}
</div>

      {/* 당일 예약변경 가능 시간 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginBottom: 10 }}>당일 예약변경 가능 시간</div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>각 일정 시작 시각</span>
          <NumStepper value={form.same_day_change_value ?? 0} onChange={v => setForm(p => ({ ...p, same_day_change_value: parseInt(v) || 0 }))} min={0} />
          <select value={form.same_day_change_unit || "HOUR"} onChange={e => setForm(p => ({ ...p, same_day_change_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
            <option value="HOUR">시간</option><option value="MINUTE">분</option>
          </select>
          <span style={{ fontSize: 13, color: "#6b7280" }}>전까지 당일 예약 변경 가능</span>
        </div>
      </div>

      {/* 출석 처리 시간 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.attendance_check_enabled ? 10 : 0 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>출석 처리 시간</span>
          <ToggleBtn value={form.attendance_check_enabled} onChange={v => setForm(p => ({ ...p, attendance_check_enabled: v }))} options={[
            { value: true, label: "사용함" }, { value: false, label: "사용안함" }
          ]} />
        </div>
        {form.attendance_check_enabled && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span style={{ fontSize: 13, color: "#6b7280" }}>각 일정 시작 시각 기준</span>
            <NumStepper value={form.attendance_check_value} onChange={v => setForm(p => ({ ...p, attendance_check_value: v }))} min={0} />
            <select value={form.attendance_check_unit} onChange={e => setForm(p => ({ ...p, attendance_check_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
              <option value="MINUTE">분</option><option value="HOUR">시간</option>
            </select>
            <span style={{ fontSize: 13, color: "#6b7280" }}>후까지 출석 처리합니다.</span>
          </div>
        )}
      </div>

      {/* 예약 문자 발송 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.sms_enabled ? 10 : 0 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>예약 문자 발송</span>
          <ToggleBtn value={form.sms_enabled} onChange={v => setForm(p => ({ ...p, sms_enabled: v }))} options={[
            { value: true, label: "사용함" }, { value: false, label: "사용안함" }
          ]} />
        </div>
        {form.sms_enabled && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
              <span style={{ fontSize: 13, color: "#6b7280", minWidth: 70 }}>발송 시점</span>
              <span style={{ fontSize: 13, color: "#6b7280" }}>각 일정 시작 시각 기준</span>
              <NumStepper value={form.sms_send_value} onChange={v => setForm(p => ({ ...p, sms_send_value: v }))} min={0} />
              <select value={form.sms_send_unit} onChange={e => setForm(p => ({ ...p, sms_send_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
                <option value="MINUTE">분</option><option value="HOUR">시간</option>
              </select>
              <span style={{ fontSize: 13, color: "#6b7280" }}>전에 발송</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 13, color: "#6b7280", minWidth: 70 }}>발송 방식</span>
              <select value={form.sms_method} onChange={e => setForm(p => ({ ...p, sms_method: e.target.value }))} style={{ ...inputStyle, width: 160 }}>
                <option value="SMS">문자메시지</option>
                <option value="KAKAO">카카오 알림톡</option>
              </select>
            </div>
          </div>
        )}
      </div>

      {/* 예약 대기 */}
      <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.waitlist_enabled ? 10 : 0 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>예약 대기</span>
          <ToggleBtn value={form.waitlist_enabled} onChange={v => setForm(p => ({ ...p, waitlist_enabled: v }))} options={[
            { value: true, label: "사용함" }, { value: false, label: "사용안함" }
          ]} />
        </div>
        {form.waitlist_enabled && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
              <span style={{ fontSize: 13, color: "#374151", minWidth: 90 }}>대기 가능 인원</span>
              <NumStepper value={form.waitlist_capacity ?? 0} onChange={v => setForm(p => ({ ...p, waitlist_capacity: parseInt(v) || 0 }))} min={0} suffix="명" />
              <span style={{ fontSize: 12, color: "#9ca3af" }}>(0명이면 무제한)</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
              <span style={{ fontSize: 13, color: "#374151", minWidth: 90 }}>자동 예약 마감</span>
              <span style={{ fontSize: 13, color: "#6b7280" }}>공석 시 수업 시작</span>
              <NumStepper value={form.waitlist_auto_value ?? 0} onChange={v => setForm(p => ({ ...p, waitlist_auto_value: parseInt(v) || 0 }))} min={0} />
              <select value={form.waitlist_auto_unit || "HOUR"} onChange={e => setForm(p => ({ ...p, waitlist_auto_unit: e.target.value }))} style={{ ...inputStyle, width: 90 }}>
                <option value="HOUR">시간</option><option value="MINUTE">분</option>
              </select>
              <span style={{ fontSize: 13, color: "#6b7280" }}>전까지 자동 예약</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 0" }}>
              <span style={{ fontSize: 13, color: "#374151" }}>대기 → 예약 전환 시 문자 발송</span>
              <ToggleBtn value={form.waitlist_sms_enabled} onChange={v => setForm(p => ({ ...p, waitlist_sms_enabled: v }))} options={[
                { value: true, label: "사용함" }, { value: false, label: "사용안함" }
              ]} />
            </div>
          </div>
        )}
      </div>

      {/* 잔여 인원 노출 */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>잔여 인원 노출</span>
        <ToggleBtn value={form.show_remaining} onChange={v => setForm(p => ({ ...p, show_remaining: v }))} options={[
          { value: true, label: "사용함" }, { value: false, label: "사용안함" }
        ]} />
      </div>

      {/* 좌석 수업 설정 */}
      <div style={{ marginTop: 10, marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: form.seat_assignment ? 10 : 0 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>좌석 수업 설정</span>
          <ToggleBtn value={form.seat_assignment} onChange={v => setForm(p => ({ ...p, seat_assignment: v }))} options={[
            { value: true, label: "사용함" }, { value: false, label: "사용안함" }
          ]} />
        </div>
        {form.seat_assignment && (
          <div>
            <div style={{ display: "flex", gap: 16, marginBottom: 12 }}>
              <div>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>좌석 행</div>
                <NumStepper value={form.seat_rows} onChange={v => setForm(p => ({ ...p, seat_rows: Math.max(1, Math.min(10, v)) }))} min={1} />
              </div>
              <div>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>좌석 열</div>
                <NumStepper value={form.seat_cols} onChange={v => setForm(p => ({ ...p, seat_cols: Math.max(1, Math.min(10, v)) }))} min={1} />
              </div>
            </div>
            <div style={{ padding: 12, background: "#fff", borderRadius: 8, border: "1px solid #e5e7eb" }}>
              <div style={{ display: "grid", gridTemplateColumns: `repeat(${form.seat_cols}, 1fr)`, gap: 6 }}>
                {Array.from({ length: (form.seat_rows || 1) * (form.seat_cols || 1) }, (_, i) => {
                  const num = i + 1;
                  const disabledList = (() => {
                    try { return JSON.parse(form.seat_disabled_numbers || "[]"); } catch { return []; }
                  })();
                  const isDisabled = disabledList.includes(num);
                  return (
                    <div
                      key={num}
                      onClick={() => {
                        const cur = (() => {
                          try { return JSON.parse(form.seat_disabled_numbers || "[]"); } catch { return []; }
                        })();
                        const next = cur.includes(num) ? cur.filter(n => n !== num) : [...cur, num];
                        setForm(p => ({ ...p, seat_disabled_numbers: JSON.stringify(next) }));
                      }}
                      style={{
                        padding: "10px 0", textAlign: "center", borderRadius: 6, cursor: "pointer",
                        fontSize: 12, fontWeight: 600,
                        background: isDisabled ? "#e5e7eb" : "#eff6ff",
                        color: isDisabled ? "#9ca3af" : "#2563eb",
                        border: isDisabled ? "1px solid #d1d5db" : "1px solid #bfdbfe",
                        textDecoration: isDisabled ? "line-through" : "none",
                      }}
                    >
                      {num}
                    </div>
                  );
                })}
              </div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 8 }}>좌석 번호를 눌러 이용 불가 좌석을 지정할 수 있습니다.</div>
            </div>
          </div>
        )}
      </div>
    </div>
  )}
</div>

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 16 }}>
            <Btn variant="secondary" onClick={() => setShowModal(false)}>취소</Btn>
            <Btn onClick={handleSubmit} disabled={saving}>{saving ? "저장 중..." : (editTarget ? "수정 완료" : "수업 생성")}</Btn>
          </div>
        </Modal>
      )}

      {/* 휴강 모달 */}
      {holidayTarget && (
        <Modal title={`휴강 관리 - ${holidayTarget.name}`} onClose={() => setHolidayTarget(null)}>
          <div style={{ marginBottom: 16, padding: 12, background: "#fffbeb", borderRadius: 8, fontSize: 12, color: "#d97706" }}>
            ⚠️ 휴강 등록 시 해당 날짜에 예약된 회원은 자동 취소되며 푸시 알림이 발송됩니다.
          </div>
          <div style={{ display: "flex", gap: 10, marginBottom: 14, alignItems: "flex-end" }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>휴강 날짜</label>
              <input type="date" value={holidayForm.date} onChange={e => setHolidayForm(p => ({ ...p, date: e.target.value }))} style={inputStyle} />
            </div>
            <div style={{ flex: 2 }}>
              <label style={labelStyle}>사유 (선택)</label>
              <input value={holidayForm.reason} onChange={e => setHolidayForm(p => ({ ...p, reason: e.target.value }))} placeholder="예: 강사 개인 사정" style={inputStyle} />
            </div>
            <Btn onClick={handleHolidayCreate}>휴강 등록</Btn>
          </div>
          <div style={{ marginTop: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#111", marginBottom: 8 }}>등록된 휴강일 ({holidayList.length}개)</div>
            {holidayList.length === 0 ? (
              <div style={{ padding: 20, textAlign: "center", color: "#9ca3af", fontSize: 12 }}>등록된 휴강이 없습니다</div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 200, overflowY: "auto" }}>
                {holidayList.map(h => (
                  <div key={h.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#f9fafb", borderRadius: 8 }}>
                    <div>
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>{h.date}</span>
                      {h.reason && <span style={{ fontSize: 12, color: "#6b7280", marginLeft: 8 }}>· {h.reason}</span>}
                    </div>
                    <button onClick={() => handleHolidayDelete(h.id)} style={{ padding: "4px 10px", borderRadius: 6, border: "1px solid #fecaca", background: "#fff0f0", color: "#ef4444", fontSize: 11, cursor: "pointer" }}>휴강 취소</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};
// ════════════════════════════════════════════════════════════════════════════
// CLASSES PAGE (수업관리)
// ════════════════════════════════════════════════════════════════════════════
const ClassesPage = ({ token, addToast, subPage = "member" }) => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState("list"); // list | calendar
  const [calendarMode, setCalendarMode] = useState("day"); // day | week | month
  const [search, setSearch] = useState("");
  const [trainerFilter, setTrainerFilter] = useState("");
  const [trainers, setTrainers] = useState([]);
  const [listDateMode, setListDateMode] = useState("all");
  const [listDate, setListDate] = useState(ymdKST());
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [actionPopup, setActionPopup] = useState(null);
  const [confirmAction, setConfirmAction] = useState(null); // { row, status }
  const [confirmAgree, setConfirmAgree] = useState(false);
const [showEditModal, setShowEditModal] = useState(false);
const [editTarget, setEditTarget] = useState(null);
const [editForm, setEditForm] = useState({ date: "", start_time: "", end_time: "", memo: "" });
  const [memberMembershipsForClass, setMemberMembershipsForClass] = useState([]);
  const [trainerDaySchedules, setTrainerDaySchedules] = useState([]);
const [loadingSchedules, setLoadingSchedules] = useState(false);
const [availableTimes, setAvailableTimes] = useState([]);
  const [members, setMembers] = useState([]);
  const [form, setForm] = useState({
  name: "", category: "membership",
  price: "", event_price: "",
  cash_price: "", card_price: "",
  duration: "", sessions: "",
  duration_value: "", duration_unit: "day",
  daily_entry_yn: "N",
  holding_yn: "N", holding_days: "", holding_count: "",
  transfer_yn: "N", transfer_count: "", transfer_unlimited: "N",
  cancel_count: "", group_capacity: "", image_url: "",
  is_featured: "N",
  entry_days: "", entry_start_time: "", entry_end_time: "",
  start_date: "", end_date: "",
  description: ""
});

  const today = new Date();

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/reservation/list?tenant_id=1", {}, token);
      setClasses(Array.isArray(d) ? d : []);
    } catch (e) { addToast("수업 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => {
    load();
    api("/staff/list?tenant_id=1", {}, token).then(d => setTrainers(Array.isArray(d) ? d : [])).catch(() => {});
    api("/members/?tenant_id=1", {}, token).then(d => setMembers(Array.isArray(d) ? d : [])).catch(() => {});
  }, [load]);

  const todayStr = ymdKST(today);
  const todayClasses = classes.filter(c => c.date === todayStr);
  const statCards = [
    { label: "금일 전체 수업수", value: `${todayClasses.length}건`, color: "#2563eb", bg: "#eff6ff" },
    { label: "금일 수업 완료", value: `${todayClasses.filter(c => c.status === "COMPLETED").length}건`, color: "#22c55e", bg: "#f0fdf4" },
    { label: "금일 수업 취소", value: `${todayClasses.filter(c => c.status === "CANCELLED").length}명`, color: "#f97316", bg: "#fff7ed" },
    { label: "사전 미고지 결석", value: `${todayClasses.filter(c => c.status === "NOSHOW").length}명`, color: "#ef4444", bg: "#fff0f0" },
  ];

  const filtered = classes.filter(c => {
    const matchTrainer = trainerFilter ? c.trainer_name?.includes(trainerFilter) : true;
    const matchSearch = search ? (c.trainer_name?.includes(search) || c.member_name?.includes(search)) : true;
    return matchTrainer && matchSearch;
  }).sort((a, b) => {
    // 최신순 (날짜 + 시작시간 내림차순)
    const ka = `${a.date || ""} ${a.start_time || ""}`;
    const kb = `${b.date || ""} ${b.start_time || ""}`;
    return kb.localeCompare(ka);
  });

  const handleCreate = async () => {
    if (!form.member_id || !form.title) return addToast("회원과 수업명은 필수입니다", "error");
    setSaving(true);
    try {
      await api("/reservation", {
        method: "POST",
        body: JSON.stringify({
          tenant_id: 1,
          member_id: parseInt(form.member_id),
          trainer_id: form.trainer_id ? parseInt(form.trainer_id) : null,
          membership_id: form.membership_id ? parseInt(form.membership_id) : null,
          type: form.type || "PT",
          title: form.title || "개인 수업",
          date: form.date,
          start_time: form.start_time,
          end_time: form.end_time || (() => {
            const [h, m] = form.start_time.split(":").map(Number);
            return `${String(h + 1).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
          })(),
          memo: form.memo || null,
        })
      }, token);
      addToast("수업이 등록되었습니다", "success");
      setShowModal(false);
      load();
    } catch (e) { addToast("등록 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      await api(`/reservation/${id}`, { method: "DELETE" }, token);
      addToast("삭제되었습니다", "success");
      load();
    } catch (e) { addToast("삭제 실패: " + e.message, "error"); }
  };
  const handleStatusChange = async (id, status) => {
  try {
    await api(`/reservation/${id}?tenant_id=1`, {
      method: "PUT",
      body: JSON.stringify({ status })
    }, token);
    addToast("변경됐습니다", "success");
    setActionPopup(null);
    load();
  } catch (e) { addToast("실패: " + e.message, "error"); }
};

const loadAvailability = useCallback(async (trainerId, date) => {
  if (!trainerId || !date) { setTrainerDaySchedules([]); setAvailableTimes([]); return; }
  setLoadingSchedules(true);
  try {
    const [schedRes, workRes] = await Promise.all([
      api(`/reservation/list?trainer_id=${trainerId}&date=${date}&tenant_id=1`, {}, token),
      api(`/staff/${trainerId}/work-schedule?date=${date}`, {}, token)
    ]);
    setTrainerDaySchedules(Array.isArray(schedRes) ? schedRes : []);
    setAvailableTimes(workRes.available_times || []);
  } catch (e) { setTrainerDaySchedules([]); setAvailableTimes([]); }
  setLoadingSchedules(false);
}, [token]);

// 일정 변경 모달: 강사/날짜 있으면 가용시간 자동 로드
useEffect(() => {
  if (showEditModal && editForm.trainer_id && editForm.date) {
    loadAvailability(editForm.trainer_id, editForm.date);
  }
}, [showEditModal, editForm.trainer_id, editForm.date, loadAvailability]);

const handleEditSubmit = async () => {
  if (!editTarget) return;
  setSaving(true);
  try {
    await api(`/reservation/${editTarget.id}?tenant_id=1`, {
      method: "PUT",
      body: JSON.stringify({
        trainer_id: editForm.trainer_id ? parseInt(editForm.trainer_id) : undefined,
        date: editForm.date || undefined,
        start_time: editForm.start_time || undefined,
        end_time: editForm.end_time || undefined,
        memo: editForm.memo || undefined,
      })
    }, token);
    addToast("수정됐습니다", "success");
    setShowEditModal(false);
    setEditTarget(null);
    load();
  } catch (e) { addToast("수정 실패: " + e.message, "error"); }
  finally { setSaving(false); }
};

  const typeColor = type => ({ PT: { bg: "#dbeafe", color: "#2563eb" }, GROUP: { bg: "#dcfce7", color: "#16a34a" } }[type] || { bg: "#f3f4f6", color: "#6b7280" });

  // 달력 모드 - 주간
  const getWeekDays = () => {
    const days = [];
    const start = new Date(today);
    start.setDate(today.getDate() - today.getDay() + 1);
    for (let i = 0; i < 7; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      days.push(d);
    }
    return days;
  };

  // 달력 모드 - 월
  const getMonthDays = () => {
    const year = today.getFullYear();
    const month = today.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const days = [];
    for (let i = 0; i < firstDay; i++) days.push(null);
    for (let i = 1; i <= daysInMonth; i++) days.push(new Date(year, month, i));
    return days;
  };

  const weekDays = getWeekDays();
  const monthDays = getMonthDays();
  const dayNames = ["월", "화", "수", "목", "금", "토", "일"];


// 강사 수업관리는 별도 컴포넌트로 분기
   if (subPage === "trainer") return <LessonsPage token={token} addToast={addToast} />;

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
        <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>
  {subPage === "trainer" ? "강사 수업 관리" : "회원 수업 관리"}
</h2>
      </div>

      {/* 스탯 카드 */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14, marginBottom: 20 }}>
        {statCards.map((c, i) => (
          <div key={i} style={{ background: c.bg, borderRadius: 14, padding: "20px 24px", border: `1px solid ${c.color}22` }}>
            <div style={{ color: "#6b7280", fontSize: 13, marginBottom: 8 }}>{c.label}</div>
            <div style={{ color: c.color, fontSize: 28, fontWeight: 800 }}>{c.value}</div>
          </div>
        ))}
      </div>

      {/* 뷰 모드 탭 */}
      <div style={{ background: "#fff", borderRadius: 14, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div style={{ display: "flex", gap: 8 }}>
            {[{ id: "list", label: "≡ 리스트" }, { id: "calendar", label: "⊞ 달력" }].map(v => (
              <button key={v.id} onClick={() => setViewMode(v.id)} style={{
                padding: "8px 20px", borderRadius: 8, border: "1px solid #e5e7eb", cursor: "pointer", fontSize: 13, fontWeight: 600,
                background: viewMode === v.id ? "#2563eb" : "#fff",
                color: viewMode === v.id ? "#fff" : "#374151"
              }}>{v.label}</button>
            ))}
          </div>

          {viewMode === "calendar" && (
            <div style={{ display: "flex", gap: 8 }}>
              {[{ id: "day", label: "금일" }, { id: "week", label: "주간" }, { id: "month", label: "월" }].map(v => (
                <button key={v.id} onClick={() => setCalendarMode(v.id)} style={{
                  padding: "6px 16px", borderRadius: 8, border: "1px solid #e5e7eb", cursor: "pointer", fontSize: 12, fontWeight: 600,
                  background: calendarMode === v.id ? "#2563eb" : "#fff",
                  color: calendarMode === v.id ? "#fff" : "#374151"
                }}>{v.label}</button>
              ))}
            </div>
          )}
        </div>

        {/* 리스트 모드 */}
        {viewMode === "list" && (
              <>
            {/* 일간/주간 필터 */}
            <div style={{ display: "flex", gap: 8, marginBottom: 12, alignItems: "center" }}>
              {[{ id: "all", label: "전체" }, { id: "day", label: "일간" }, { id: "week", label: "주간" }].map(v => (
                <button key={v.id} onClick={() => setListDateMode(v.id)} style={{
                  padding: "6px 16px", borderRadius: 8, border: "1px solid #e5e7eb", cursor: "pointer", fontSize: 12, fontWeight: 600,
                  background: listDateMode === v.id ? "#2563eb" : "#fff",
                  color: listDateMode === v.id ? "#fff" : "#374151"
                }}>{v.label}</button>
              ))}
              {(listDateMode === "day" || listDateMode === "week") && (
                <input type="date" value={listDate} onChange={e => setListDate(e.target.value)}
                  style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, marginLeft: 8 }} />
              )}
              {listDateMode === "week" && (() => {
                const base = new Date(listDate);
                const start = new Date(base); start.setDate(base.getDate() - base.getDay());
                const end = new Date(start); end.setDate(start.getDate() + 6);
                return <span style={{ fontSize: 12, color: "#6b7280", marginLeft: 8 }}>
                  ({ymdKST(start).slice(5, 10)} ~ {ymdKST(end).slice(5, 10)})
                </span>;
              })()}
            </div>
            <div style={{ display: "flex", gap: 12, marginBottom: 16, alignItems: "center" }}>
              <select value={trainerFilter} onChange={e => setTrainerFilter(e.target.value)} style={{
                padding: "8px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, color: "#374151", background: "#fff", cursor: "pointer"
              }}>
                <option value="">담당강사명 전체</option>
                {trainers.map(t => <option key={t.id} value={t.name}>{t.name}</option>)}
              </select>
              <div style={{ position: "relative", flex: 1 }}>
                <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}><Icon name="search" size={14} /></span>
                <input value={search} onChange={e => setSearch(e.target.value)} placeholder="담당강사명으로 검색..."
                  style={{ width: "100%", padding: "8px 10px 8px 32px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
              </div>
              <Btn onClick={() => setShowModal(true)}><Icon name="plus" size={14} /> {subPage === "trainer" ? "강사 수업 추가" : "회원 수업 추가"}</Btn>
            </div>
            <Table loading={loading} columns={[
              { key: "date", label: "요일", render: v => v },
              { key: "start_time", label: "시간대", render: v => v?.slice(0, 5) },
              { key: "trainer_name", label: "담당 강사" },
              { key: "type", label: "수업명", render: (v, row) => {
                const tc = typeColor(v);
                return <span style={{ background: tc.bg, color: tc.color, padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600 }}>{row.title || v}</span>;
              }},
              { key: "id", label: "인원수", render: () => "1/1명" },
              { key: "member_name", label: "수강생" },
              { key: "status", label: "상태", render: v => {
  const map = {
    RESERVED:  { label: "예정", color: "#2563eb", bg: "#eff6ff" },
    SCHEDULED: { label: "예정", color: "#2563eb", bg: "#eff6ff" },
    COMPLETED: { label: "완료", color: "#22c55e", bg: "#f0fdf4" },
    CANCELLED: { label: "취소", color: "#ef4444", bg: "#fff0f0" },
    NOSHOW:    { label: "결석", color: "#f97316", bg: "#fff7ed" },
  };
  const m = map[v] || { label: "예정", color: "#2563eb", bg: "#eff6ff" };
  return (
    <span style={{
      background: m.bg, color: m.color, padding: "3px 10px",
      borderRadius: 20, fontSize: 12, fontWeight: 700,
      border: `1px solid ${m.color}33`
    }}>{m.label}</span>
  );
}},
{ key: "id", label: "관리", render: (v, row) => (
  <div style={{ position: "relative" }}>
    <button
      onClick={e => {
  e.stopPropagation();
  // 수업 시간이 이미 지난 건은 상태 변경 불가
  const t = (row.end_time || row.start_time || "").slice(0, 5) || "23:59";
  const classDt = row.date ? new Date(`${row.date}T${t}:00`) : null;
  if (classDt && !isNaN(classDt.getTime()) && classDt.getTime() < Date.now()) {
    window.alert("일정이 지난 수업은 상태를 변경할 수 없습니다.");
    return;
  }
  const rect = e.currentTarget.getBoundingClientRect();
  const popupHeight = 180;
  const isNearBottom = rect.bottom + popupHeight > window.innerHeight;
  setActionPopup(actionPopup?.id === row.id ? null : {
    id: row.id, row,
    top: isNearBottom ? rect.top - popupHeight : rect.bottom + 4,
    right: window.innerWidth - rect.right
  });
}}
      style={{
        background: "#f3f4f6", border: "1px solid #e5e7eb",
        borderRadius: 8, padding: "6px 12px", cursor: "pointer", fontSize: 13
      }}>
      ⚙️
    </button>
    {actionPopup?.id === row.id && (
      <div style={{
        position: "fixed", 
top: "50%", left: "50%", 
transform: "translate(-50%, -50%)",
zIndex: 9999,
background: "#fff", borderRadius: 16, padding: 16,
boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
border: "1px solid #f3f4f6", minWidth: 200
      }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 11, color: "#9ca3af", padding: "4px 10px", marginBottom: 4 }}>상태 변경</div>
        {[
          { status: "COMPLETED", label: "✅ 완료 처리", color: "#22c55e", hover: "#f0fdf4" },
          { status: "RESERVED",  label: "✏️ 일정 변경", color: "#2563eb", hover: "#eff6ff", isEdit: true },
          { status: "CANCELLED", label: "✕ 예약 취소",  color: "#ef4444", hover: "#fff0f0" },
        ].map(item => (
          <div key={item.status}
            onClick={() => {
              if (item.isEdit) {
                setEditTarget(row);
                setEditForm({
                  trainer_id: row.trainer_id ? String(row.trainer_id) : "",
                  date: row.date || "",
                  start_time: row.start_time?.slice(0,5) || "",
                  end_time: row.end_time?.slice(0,5) || "",
                  memo: row.memo || ""
                });
                setShowEditModal(true);
                setActionPopup(null);
              } else {
                setConfirmAction({ row, status: item.status });
                setConfirmAgree(false);
                setActionPopup(null);
              }
            }}
            style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px",
              borderRadius: 8, cursor: "pointer", fontSize: 13,
              color: item.color, fontWeight: 600 }}
            onMouseEnter={e => e.currentTarget.style.background = item.hover}
            onMouseLeave={e => { if(e.currentTarget) e.currentTarget.style.background = "transparent" }}>
            {item.label}
          </div>
        ))}
      </div>
    )}
  </div>
)},
            ]} data={(() => {
              if (listDateMode === "all") return filtered;
              if (listDateMode === "day") return filtered.filter(r => r.date === listDate);
              if (listDateMode === "week") {
                const base = new Date(listDate);
                const start = new Date(base); start.setDate(base.getDate() - base.getDay());
                const end = new Date(start); end.setDate(start.getDate() + 6);
                return filtered.filter(r => {
                  const d = new Date(r.date);
                  return d >= start && d <= end;
                });
              }
              return filtered;
            })()} emptyMsg="등록된 수업이 없습니다" pageSize={50} />
          </>
        )}

        {/* 달력 모드 - 금일 */}
        {viewMode === "calendar" && calendarMode === "day" && (
          <div>
            <div style={{ textAlign: "center", fontWeight: 700, fontSize: 15, marginBottom: 16, color: "#111" }}>
              {today.getFullYear()}년 {today.getMonth() + 1}월 {today.getDate()}일
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              {Array.from({ length: 13 }, (_, i) => i + 7).map(hour => {
                const hourStr = `${String(hour).padStart(2, "0")}:00`;
                const slotClasses = filtered.filter(c => c.date === todayStr && c.start_time?.slice(0, 5) === hourStr);
                return (
                  <div key={hour} style={{ display: "flex", gap: 12, minHeight: 48, borderTop: "1px solid #f3f4f6" }}>
                    <div style={{ width: 48, color: "#9ca3af", fontSize: 12, paddingTop: 8, flexShrink: 0 }}>{hourStr}</div>
                    <div style={{ flex: 1, display: "flex", gap: 8, padding: "4px 0" }}>
                      {slotClasses.map((c, j) => {
                        const tc = typeColor(c.type);
                        return (
                          <div key={j} style={{ background: tc.bg, borderRadius: 8, padding: "6px 12px", fontSize: 12, minWidth: 140 }}>
                            <div style={{ fontWeight: 700, color: tc.color }}>{c.title}</div>
                            <div style={{ color: "#6b7280", fontSize: 11 }}>{c.trainer_name} · {c.member_name}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* 달력 모드 - 주간 */}
        {viewMode === "calendar" && calendarMode === "week" && (
          <div style={{ overflowX: "auto" }}>
            <div style={{ display: "grid", gridTemplateColumns: "48px repeat(7, 1fr)", gap: 0, minWidth: 700 }}>
              <div />
              {weekDays.map((d, i) => (
                <div key={i} style={{ textAlign: "center", padding: "8px 0", fontWeight: 600, fontSize: 13, color: d.toDateString() === today.toDateString() ? "#2563eb" : "#374151", borderBottom: "1px solid #f3f4f6" }}>
                  {dayNames[i]}<br />
                  <span style={{ fontSize: 18, fontWeight: 800 }}>{d.getDate()}</span>
                </div>
              ))}
              {Array.from({ length: 13 }, (_, i) => i + 7).map(hour => (
                <>
                  <div key={`h${hour}`} style={{ color: "#9ca3af", fontSize: 11, paddingTop: 8, textAlign: "right", paddingRight: 8 }}>{String(hour).padStart(2, "0")}:00</div>
                  {weekDays.map((d, di) => {
                    const dStr = ymdKST(d);
                    const hourStr = `${String(hour).padStart(2, "0")}:00`;
                    const slotClasses = filtered.filter(c => c.date === dStr && c.start_time?.slice(0, 5) === hourStr);
                    return (
                      <div key={`${hour}-${di}`} style={{ borderLeft: "1px solid #f3f4f6", borderTop: "1px solid #f3f4f6", minHeight: 48, padding: 4 }}>
                        {slotClasses.map((c, j) => {
                          const tc = typeColor(c.type);
                          return (
                            <div key={j} style={{ background: tc.bg, borderRadius: 6, padding: "4px 6px", fontSize: 11, marginBottom: 2 }}>
                              <div style={{ fontWeight: 700, color: tc.color }}>{c.title}</div>
                              <div style={{ color: "#6b7280" }}>{c.trainer_name}</div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </>
              ))}
            </div>
          </div>
        )}

        {/* 달력 모드 - 월 */}
        {viewMode === "calendar" && calendarMode === "month" && (
          <div>
            <div style={{ textAlign: "center", fontWeight: 700, fontSize: 15, marginBottom: 16, color: "#111" }}>
              {today.getFullYear()}년 {today.getMonth() + 1}월
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4 }}>
              {dayNames.map(d => (
                <div key={d} style={{ textAlign: "center", fontSize: 12, fontWeight: 600, color: "#9ca3af", padding: "8px 0" }}>{d}</div>
              ))}
              {monthDays.map((d, i) => {
                if (!d) return <div key={i} />;
                const dStr = ymdKST(d);
                const dayClasses = filtered.filter(c => c.date === dStr);
                const isToday = d.toDateString() === today.toDateString();
                return (
                  <div key={i} style={{ minHeight: 80, border: "1px solid #f3f4f6", borderRadius: 8, padding: 6, background: isToday ? "#eff6ff" : "#fff" }}>
                    <div style={{ fontSize: 13, fontWeight: isToday ? 800 : 500, color: isToday ? "#2563eb" : "#374151", marginBottom: 4 }}>{d.getDate()}</div>
                    {dayClasses.slice(0, 3).map((c, j) => {
                      const tc = typeColor(c.type);
                      return (
                        <div key={j} style={{ background: tc.bg, color: tc.color, fontSize: 10, fontWeight: 600, borderRadius: 4, padding: "2px 6px", marginBottom: 2, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                          {c.start_time?.slice(0, 5)} {c.title}
                        </div>
                      );
                    })}
                    {dayClasses.length > 3 && <div style={{ fontSize: 10, color: "#9ca3af" }}>+{dayClasses.length - 3}개</div>}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
       {/* 팝업 바깥 클릭 시 닫기 */}
{actionPopup && (
  <div style={{
    position: "fixed", inset: 0, zIndex: 998,
    background: "rgba(0,0,0,0.3)"
  }}
    onClick={() => setActionPopup(null)} />
)}

{/* 상태 변경 확인 모달 */}
{confirmAction && (() => {
  const name = confirmAction.row.member_name || "고객";
  const isCancel = confirmAction.status === "CANCELLED";
  const title = isCancel ? "예약 취소" : "완료 처리";
  const message = isCancel
    ? <><b>{name}</b> 고객님의 예약을 취소하면 <b>수업 횟수가 1회 복원(추가)</b>되며, 이용을 위해서는 <b>다시 예약을 진행</b>하셔야 합니다.</>
    : <><b>{name}</b> 고객님의 수업을 <b>완료 처리</b>합니다. 완료 처리 후에는 되돌릴 수 없습니다.</>;
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1100, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={() => setConfirmAction(null)}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, padding: 24, width: "100%", maxWidth: 400, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <div style={{ fontSize: 17, fontWeight: 800, color: isCancel ? "#dc2626" : "#16a34a", marginBottom: 12 }}>
          {isCancel ? "⚠️ 예약 취소" : "✅ 완료 처리"}
        </div>
        <div style={{ fontSize: 13.5, color: "#374151", lineHeight: 1.7, background: "#f9fafb", borderRadius: 10, padding: "14px 16px", marginBottom: 16 }}>
          {message}
        </div>
        <label style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 13, color: "#374151", cursor: "pointer", marginBottom: 18 }}>
          <input type="checkbox" checked={confirmAgree} onChange={e => setConfirmAgree(e.target.checked)} style={{ marginTop: 2, flexShrink: 0, width: 16, height: 16, cursor: "pointer" }} />
          <span>위 내용을 확인했으며 <b>{title}</b>을(를) 진행합니다.</span>
        </label>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={() => setConfirmAction(null)} style={{ flex: 1, padding: "12px 0", borderRadius: 10, border: "1px solid #e5e7eb", background: "#fff", color: "#6b7280", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>닫기</button>
          <button disabled={!confirmAgree}
            onClick={() => { const { row, status } = confirmAction; setConfirmAction(null); handleStatusChange(row.id, status); }}
            style={{ flex: 1, padding: "12px 0", borderRadius: 10, border: "none", background: confirmAgree ? (isCancel ? "#ef4444" : "#2563eb") : "#cbd5e1", color: "#fff", fontSize: 14, fontWeight: 700, cursor: confirmAgree ? "pointer" : "not-allowed" }}>
            변경하기
          </button>
        </div>
      </div>
    </div>
  );
})()}

{/* 일정 변경 모달 */}
{showEditModal && editTarget && (
  <Modal title="일정 변경" onClose={() => { setShowEditModal(false); setEditTarget(null); }}>
    {/* 담당 강사 */}
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>담당 강사 *</label>
      <select value={editForm.trainer_id || ""} onChange={e => setEditForm(p => ({ ...p, trainer_id: e.target.value, start_time: "" }))}
        style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", background: "#f9fafb", boxSizing: "border-box" }}>
        <option value="">강사님을 선택하세요</option>
        {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
      </select>
    </div>
    {/* 날짜 */}
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>날짜 *</label>
      <input type="date" value={editForm.date || ""} onChange={e => setEditForm(p => ({ ...p, date: e.target.value }))}
        style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", background: "#f9fafb", boxSizing: "border-box" }} />
    </div>
    {/* 시작 시간 - 시간표 그리드 */}
    {editForm.date && editForm.trainer_id ? (() => {
      const origDur = (() => {
        const s = (editTarget.start_time || "").slice(0, 5), en = (editTarget.end_time || "").slice(0, 5);
        if (!s || !en) return 60;
        const [sh, sm] = s.split(":").map(Number); const [eh, em] = en.split(":").map(Number);
        const d = (eh * 60 + em) - (sh * 60 + sm); return d > 0 ? d : 60;
      })();
      return (
        <div style={{ marginBottom: 14 }}>
          <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 8 }}>
            시작 시간 *{loadingSchedules && <span style={{ fontWeight: 400, color: "#9ca3af", marginLeft: 8 }}>불러오는 중...</span>}
          </label>
          <div style={{ display: "flex", gap: 12, marginBottom: 10 }}>
            {[["#f9fafb","#e5e7eb","가능"], ["#fee2e2","#fca5a5","예약됨"], ["#2563eb","#2563eb","선택"]].map(([bg, border, lb]) => (
              <div key={lb} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: "#6b7280" }}>
                <div style={{ width: 12, height: 12, borderRadius: 3, background: bg, border: `1.5px solid ${border}` }} />{lb}
              </div>
            ))}
          </div>
          {availableTimes.length === 0 && !loadingSchedules && (
            <div style={{ marginBottom: 8, padding: "10px 12px", background: "#fee2e2", borderRadius: 8, fontSize: 12, color: "#ef4444", fontWeight: 600, textAlign: "center" }}>🚫 해당 날짜는 강사 휴무일입니다</div>
          )}
          {availableTimes.length > 0 && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6, maxHeight: 220, overflowY: "auto", padding: "2px 2px 8px" }}>
              {availableTimes.map(timeStr => {
                const isBooked = trainerDaySchedules.some(s => String(s.id) !== String(editTarget.id) && (s.start_time || "").substring(0, 5) === timeStr && s.status !== "CANCELLED");
                const isSelected = (editForm.start_time || "").slice(0, 5) === timeStr;
                return (
                  <div key={timeStr}
                    onClick={() => { if (!isBooked) setEditForm(p => {
                      const [h, mn] = timeStr.split(":").map(Number);
                      const endMins = h * 60 + mn + origDur;
                      const eh = String(Math.floor(endMins / 60) % 24).padStart(2, "0");
                      const em2 = String(endMins % 60).padStart(2, "0");
                      return { ...p, start_time: timeStr, end_time: `${eh}:${em2}` };
                    }); }}
                    title={isBooked ? "이미 예약된 시간" : timeStr}
                    style={{ padding: "8px 4px", borderRadius: 8, textAlign: "center", fontSize: 12, fontWeight: 500,
                      cursor: isBooked ? "not-allowed" : "pointer",
                      background: isSelected ? "#2563eb" : isBooked ? "#fee2e2" : "#f9fafb",
                      color: isSelected ? "#fff" : isBooked ? "#ef4444" : "#374151",
                      border: `1.5px solid ${isSelected ? "#2563eb" : isBooked ? "#fca5a5" : "#e5e7eb"}` }}>
                    {timeStr}
                    {isBooked && <div style={{ fontSize: 9, color: "#ef4444", marginTop: 1 }}>예약됨</div>}
                  </div>
                );
              })}
            </div>
          )}
          {editForm.start_time && (
            <div style={{ marginTop: 8, padding: "8px 12px", background: "#eff6ff", borderRadius: 8, fontSize: 12, color: "#2563eb", fontWeight: 600 }}>✓ 선택된 시간: {(editForm.start_time || "").slice(0, 5)}{editForm.end_time ? ` ~ ${(editForm.end_time || "").slice(0, 5)}` : ""}</div>
          )}
        </div>
      );
    })() : editForm.date && !editForm.trainer_id ? (
      <div style={{ marginBottom: 14, padding: 12, background: "#fffbeb", borderRadius: 8, fontSize: 12, color: "#d97706" }}>⚠️ 담당 강사를 먼저 선택하면 가능한 시간을 확인할 수 있어요</div>
    ) : null}
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>메모</label>
      <textarea value={editForm.memo}
        onChange={e => setEditForm(p => ({ ...p, memo: e.target.value }))}
        rows={3} style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb",
          borderRadius: 8, color: "#111", padding: "10px 12px", fontSize: 13,
          outline: "none", boxSizing: "border-box", resize: "vertical", fontFamily: "inherit" }} />
    </div>
    <div style={{ background: "#eff6ff", borderRadius: 8, padding: "10px 14px", marginBottom: 14, fontSize: 12, color: "#2563eb" }}>
      📱 변경 시 회원앱에 알림이 발송됩니다.
    </div>
    <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
      <Btn variant="secondary" onClick={() => { setShowEditModal(false); setEditTarget(null); }}>취소</Btn>
      <Btn onClick={handleEditSubmit} disabled={saving}>{saving ? "저장 중..." : "변경하기"}</Btn>
    </div>
  </Modal>
)}
      {/* 신규 수업 등록 모달 */}
      {showModal && (
        <Modal title="회원 수업 추가" onClose={() => setShowModal(false)}>
          {/* 회원 검색 */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>회원 검색</label>
            <div style={{ position: "relative" }}>
              <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}><Icon name="search" size={14} /></span>
              <input value={form.member_search || ""} onChange={e => {
                setForm(p => ({ ...p, member_search: e.target.value, member_id: "", membership_id: "" }));
              }} placeholder="회원 이름 검색"
                style={{ width: "100%", padding: "10px 10px 10px 32px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
              {form.member_search && !form.member_id && members.filter(m => m.name?.includes(form.member_search)).length > 0 && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 100, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, boxShadow: "0 4px 16px rgba(0,0,0,0.1)", maxHeight: 160, overflowY: "auto" }}>
                  {members.filter(m => m.name?.includes(form.member_search)).map(m => (
                    <div key={m.id} onClick={async () => {
                      setForm(p => ({ ...p, member_id: String(m.id), member_search: m.name }));
                      try {
                        const memberships = await api(`/membership/by-member?member_id=${m.id}&tenant_id=1`, {}, token);
                        setMemberMembershipsForClass(Array.isArray(memberships) ? memberships.filter(ms => ms.status === "ACTIVE") : []);
                      } catch(e) { setMemberMembershipsForClass([]); }
                    }} style={{ padding: "10px 16px", cursor: "pointer", fontSize: 13, color: "#374151", borderBottom: "1px solid #f3f4f6" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                      onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                      {m.name} <span style={{ color: "#9ca3af", fontSize: 11 }}>{m.phone}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* 상품 선택 */}
          {form.member_id && (
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>상품 선택</label>
              {memberMembershipsForClass.length === 0 ? (
                <div style={{ padding: 12, background: "#fff7ed", borderRadius: 8, fontSize: 12, color: "#f97316" }}>활성 상품이 없습니다</div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {memberMembershipsForClass.map(ms => (
                    <div key={ms.id} onClick={() => setForm(p => ({ ...p, membership_id: String(ms.id), title: ms.plan_name || ms.name, type: ms.type || "PT" }))}
                      style={{ padding: "10px 14px", border: `2px solid ${form.membership_id === String(ms.id) ? "#2563eb" : "#e5e7eb"}`, borderRadius: 10, cursor: "pointer", background: form.membership_id === String(ms.id) ? "#eff6ff" : "#fff" }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: "#111" }}>{ms.plan_name || ms.name}</div>
                      <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>
                        잔여 {ms.remaining_count != null ? `${ms.remaining_count}회` : "무제한"} | {ms.end_date}까지
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* 담당 강사 */}
          <Select label="담당 강사" value={form.trainer_id} onChange={async e => {
            const trainerId = e.target.value;
            setForm(p => ({ ...p, trainer_id: trainerId, start_time: "" }));
            if (trainerId && form.date) {
              setLoadingSchedules(true);
              try {
                const [schedRes, workRes] = await Promise.all([
                  api(`/reservation/list?trainer_id=${trainerId}&date=${form.date}&tenant_id=1`, {}, token),
                  api(`/staff/${trainerId}/work-schedule?date=${form.date}`, {}, token)
                ]);
                setTrainerDaySchedules(Array.isArray(schedRes) ? schedRes : []);
                setAvailableTimes(workRes.available_times || []);
              } catch(e) { setTrainerDaySchedules([]); setAvailableTimes([]); }
              setLoadingSchedules(false);
            }
          }}>
            <option value="">강사님을 선택하세요</option>
            {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </Select>

          {/* 날짜 */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>날짜 *</label>
            <input type="date" value={form.date} onChange={async e => {
              const date = e.target.value;
              setForm(p => ({ ...p, date, start_time: "" }));
              if (form.trainer_id && date) {
                setLoadingSchedules(true);
                try {
                  const [schedRes, workRes] = await Promise.all([
                    api(`/reservation/list?trainer_id=${form.trainer_id}&date=${date}&tenant_id=1`, {}, token),
                    api(`/staff/${form.trainer_id}/work-schedule?date=${date}`, {}, token)
                  ]);
                  setTrainerDaySchedules(Array.isArray(schedRes) ? schedRes : []);
                  setAvailableTimes(workRes.available_times || []);
                } catch(e) { setTrainerDaySchedules([]); setAvailableTimes([]); }
                setLoadingSchedules(false);
              }
            }} style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
          </div>

          {/* 시작 시간 - 시간표 그리드 */}
          {form.date && form.trainer_id ? (
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 8 }}>
                시작 시간 *
                {loadingSchedules && <span style={{ fontWeight: 400, color: "#9ca3af", marginLeft: 8 }}>불러오는 중...</span>}
              </label>
              <div style={{ display: "flex", gap: 12, marginBottom: 10 }}>
                {[["#f9fafb","#e5e7eb","가능"], ["#fee2e2","#fca5a5","예약됨"], ["#2563eb","#2563eb","선택"]].map(([bg, border, label]) => (
                  <div key={label} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: "#6b7280" }}>
                    <div style={{ width: 12, height: 12, borderRadius: 3, background: bg, border: `1.5px solid ${border}` }} />
                    {label}
                  </div>
                ))}
              </div>
            {availableTimes.length === 0 && !loadingSchedules && form.trainer_id && form.date && (
                <div style={{ marginBottom: 8, padding: "10px 12px", background: "#fee2e2", borderRadius: 8, fontSize: 12, color: "#ef4444", fontWeight: 600, textAlign: "center" }}>
                  🚫 해당 날짜는 강사 휴무일입니다
                </div>
              )}
              {availableTimes.length > 0 && <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6, maxHeight: 220, overflowY: "auto", padding: "2px 2px 8px" }}>
                {(availableTimes.length > 0 ? availableTimes : Array.from({ length: 34 }, (_, i) => {
                  const totalMins = 360 + i * 30;
                  const h = String(Math.floor(totalMins / 60)).padStart(2, "0");
                  const m = String(totalMins % 60).padStart(2, "0");
                  return `${h}:${m}`;
                })).map(timeStr => {
                  const isBooked = trainerDaySchedules.some(s =>
                    (s.start_time || "").substring(0, 5) === timeStr && s.status !== "CANCELLED"
                  );
                  const isSelected = form.start_time === timeStr;
                  return (
                    <div key={timeStr}
                      onClick={() => { if (!isBooked) setForm(p => ({ ...p, start_time: timeStr })); }}
                      title={isBooked ? "이미 예약된 시간" : timeStr}
                      style={{
                        padding: "8px 4px", borderRadius: 8, textAlign: "center", fontSize: 12, fontWeight: 500,
                        cursor: isBooked ? "not-allowed" : "pointer",
                        background: isSelected ? "#2563eb" : isBooked ? "#fee2e2" : "#f9fafb",
                        color: isSelected ? "#fff" : isBooked ? "#ef4444" : "#374151",
                        border: `1.5px solid ${isSelected ? "#2563eb" : isBooked ? "#fca5a5" : "#e5e7eb"}`,
                        transition: "all 0.15s"
                      }}>
                      {timeStr}
                      {isBooked && <div style={{ fontSize: 9, color: "#ef4444", marginTop: 1 }}>예약됨</div>}
                    </div>
                  );
                })}
              </div>}
              {form.start_time && (
                <div style={{ marginTop: 8, padding: "8px 12px", background: "#eff6ff", borderRadius: 8, fontSize: 12, color: "#2563eb", fontWeight: 600 }}>
                  ✓ 선택된 시간: {form.start_time}
                </div>
              )}
            </div>
          ) : form.date && !form.trainer_id ? (
            <div style={{ marginBottom: 14, padding: 12, background: "#fffbeb", borderRadius: 8, fontSize: 12, color: "#d97706" }}>
              ⚠️ 담당 강사를 먼저 선택하면 가능한 시간을 확인할 수 있어요
            </div>
          ) : null}

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <Btn variant="secondary" onClick={() => setShowModal(false)}>취소</Btn>
            <Btn onClick={handleCreate} disabled={saving}>{saving ? "저장 중..." : "저장"}</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};
const LeadsPage = ({ token, addToast }) => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/lead/list?tenant_id=1", {}, token);
      setLeads(Array.isArray(d) ? d : d.items || []);
    } catch (e) { addToast("리드 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token]);
  useEffect(() => { load(); }, [load]);
  const statusColor = s => ({ new: "#3b82f6", contacted: "#f97316", converted: "#22c55e", lost: "#ef4444" }[s] || "#9ca3af");
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>리드 관리</h2>
        <Btn variant="secondary" onClick={load}><Icon name="refresh" size={14} />새로고침</Btn>
      </div>
      <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f3f4f6" }}>
        <Table loading={loading} columns={[
          { key: "name", label: "이름" },
          { key: "phone", label: "연락처" },
          { key: "source", label: "유입경로" },
          { key: "status", label: "상태", render: v => <Badge label={v || "신규"} color={statusColor(v)} /> },
          { key: "created_at", label: "등록일", render: v => v?.slice(0, 10) },
        ]} data={leads} emptyMsg="등록된 리드가 없습니다" />
      </div>
    </div>
  );
};

// ═══════════════ SMS(알리고) 탭 컴포넌트 ═══════════════
// ═══════════════ 통합 발송(타기팅) 탭 컴포넌트 ═══════════════
const BroadcastTab = ({ token, addToast }) => {
  const [options, setOptions] = useState([]);
  const [plans, setPlans] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [target, setTarget] = useState("all");
  const [planId, setPlanId] = useState("");
  const [trainerId, setTrainerId] = useState("");
  const [count, setCount] = useState(null);
  const [smsAvailable, setSmsAvailable] = useState(null);
  const [counting, setCounting] = useState(false);
  const [channels, setChannels] = useState({ push: true, sms: false });
  const [title, setTitle] = useState("");
  const [contentText, setContentText] = useState("");
  const [sending, setSending] = useState(false);
  const [smsConnected, setSmsConnected] = useState(false);
  // 직접 선택
  const [allMembers, setAllMembers] = useState([]);
  const [memberSearch, setMemberSearch] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const d = await api("/targeting/options", {}, token);
        setOptions(d.options || []);
        setPlans(d.plans || []);
        setTrainers(d.trainers || []);
      } catch (e) {}
      try {
        const s = await api("/aligo/balance", {}, token);
        setSmsConnected(!!s.sender_number);
      } catch (e) {}
      loadLogs();
    })();
  }, [token]);

  const loadLogs = async () => {
    try {
      const d = await api("/targeting/broadcast-logs", {}, token);
      setLogs(d.logs || []);
    } catch (e) { setLogs([]); }
  };

  // 직접 선택 시 전체 회원 로드
  useEffect(() => {
    if (target === "custom" && allMembers.length === 0) {
      (async () => {
        try {
          const d = await api("/members/?tenant_id=1", {}, token);
          setAllMembers(Array.isArray(d) ? d : (d.members || []));
        } catch (e) { setAllMembers([]); }
      })();
    }
  }, [target, token, allMembers.length]);

  // 대상 인원 조회
  const refreshCount = useCallback(async () => {
    if (target === "custom") {
      setCount(selectedIds.length);
      const sel = allMembers.filter(m => selectedIds.includes(m.id) && m.phone);
      setSmsAvailable(sel.length);
      return;
    }
    setCounting(true);
    try {
      const body = { target };
      if (target === "plan") body.plan_id = planId ? Number(planId) : null;
      if (target === "trainer") body.trainer_id = trainerId ? Number(trainerId) : null;
      const d = await api("/targeting/members", { method: "POST", body: JSON.stringify(body) }, token);
      setCount(d.count);
      setSmsAvailable(d.sms_available);
    } catch (e) {
      setCount(null); setSmsAvailable(null);
    } finally {
      setCounting(false);
    }
  }, [target, planId, trainerId, token, selectedIds, allMembers]);

  useEffect(() => { refreshCount(); }, [refreshCount]);

  const toggleMember = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const filteredMembers = allMembers.filter(m => {
    if (!memberSearch) return true;
    const kw = memberSearch.toLowerCase();
    return (m.name || "").toLowerCase().includes(kw) || (m.phone || "").includes(kw);
  });

  const allFilteredSelected = filteredMembers.length > 0 && filteredMembers.every(m => selectedIds.includes(m.id));
  const toggleAll = () => {
    if (allFilteredSelected) {
      const fids = filteredMembers.map(m => m.id);
      setSelectedIds(prev => prev.filter(x => !fids.includes(x)));
    } else {
      const fids = filteredMembers.map(m => m.id);
      setSelectedIds(prev => [...new Set([...prev, ...fids])]);
    }
  };

  const handleSend = async () => {
    if (!channels.push && !channels.sms) return addToast("발송 채널을 선택하세요", "error");
    if (!contentText.trim()) return addToast("내용을 입력하세요", "error");
    if (channels.push && !title.trim()) return addToast("앱 푸시 제목을 입력하세요", "error");
    if (channels.sms && !smsConnected) return addToast("발신번호가 설정되지 않았습니다. [문자(SMS)] 탭에서 확인하세요.", "error");
    if (!count) return addToast("발송 대상이 없습니다", "error");

    const ch = [];
    if (channels.push) ch.push("push");
    if (channels.sms) ch.push("sms");
    if (!window.confirm(`${count}명에게 발송하시겠습니까?`)) return;

    setSending(true);
    try {
      const body = { target, channels: ch, title: title || contentText.slice(0, 20), content: contentText };
      if (target === "plan") body.plan_id = planId ? Number(planId) : null;
      if (target === "trainer") body.trainer_id = trainerId ? Number(trainerId) : null;
      if (target === "custom") body.member_ids = selectedIds;
      const d = await api("/targeting/broadcast", { method: "POST", body: JSON.stringify(body) }, token);
      let msg = `발송 완료 (대상 ${d.target_count}명)`;
      if (d.push) msg += ` · 푸시 ${d.push.sent}명`;
      if (d.sms) {
        if (d.sms.error) msg += ` · 문자 실패: ${d.sms.error}`;
        else msg += ` · 문자 ${d.sms.requested}건`;
      }
      addToast(msg, "success");
      setTitle(""); setContentText("");
      loadLogs();
    } catch (e) {
      addToast("발송 실패: " + e.message, "error");
    } finally {
      setSending(false);
    }
  };

  const labelStyle = { fontSize: 13, fontWeight: 700, color: "#555", marginBottom: 6 };
  const selectStyle = { width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14, marginBottom: 8, boxSizing: "border-box" };
  const smsBytes = new Blob([contentText]).size;

  return (
    <>
    <div style={{ display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: 20, alignItems: "start" }}>
      {/* ── 왼쪽: 발송 폼 ── */}
      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #f3f4f6", padding: "20px 24px" }}>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>알림 발송</div>

        {/* ① 대상 */}
        <div style={{ marginBottom: 16 }}>
          <div style={labelStyle}>① 받는 대상</div>
          <select value={target} onChange={e => { setTarget(e.target.value); setPlanId(""); setTrainerId(""); }} style={selectStyle}>
            {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>

          {target === "plan" && (
            <select value={planId} onChange={e => setPlanId(e.target.value)} style={selectStyle}>
              <option value="">회원권을 선택하세요</option>
              {plans.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          )}
          {target === "trainer" && (
            <select value={trainerId} onChange={e => setTrainerId(e.target.value)} style={selectStyle}>
              <option value="">강사를 선택하세요</option>
              {trainers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          )}

          {/* 직접 선택 회원 피커 */}
          {target === "custom" && (
            <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden", marginBottom: 8 }}>
              <div style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", display: "flex", gap: 8, alignItems: "center" }}>
                <span style={{ color: "#9ca3af" }}>🔍</span>
                <input type="text" value={memberSearch} onChange={e => setMemberSearch(e.target.value)} placeholder="이름 / 전화번호로 검색" style={{ border: "none", flex: 1, height: 26, padding: 0, outline: "none", fontSize: 13 }} />
              </div>
              <div style={{ padding: "7px 12px", background: "#f8f9fa", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                  <input type="checkbox" checked={allFilteredSelected} onChange={toggleAll} /> 전체 선택
                </label>
                <span style={{ color: "#2563eb", fontWeight: 600 }}>{selectedIds.length}명 선택됨</span>
              </div>
              <div style={{ maxHeight: 200, overflowY: "auto" }}>
                {filteredMembers.length === 0 ? (
                  <div style={{ padding: 20, textAlign: "center", color: "#9ca3af", fontSize: 13 }}>회원이 없습니다</div>
                ) : filteredMembers.map(m => (
                  <label key={m.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderBottom: "1px solid #f5f5f5", cursor: "pointer" }}>
                    <input type="checkbox" checked={selectedIds.includes(m.id)} onChange={() => toggleMember(m.id)} />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 14 }}>{m.name}</div>
                      <div style={{ fontSize: 12, color: "#9ca3af" }}>{m.phone || "전화번호 없음"}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          )}

          <div style={{ background: "#eff6ff", borderRadius: 8, padding: "8px 12px", fontSize: 12, color: "#2563eb" }}>
            👥 {counting ? "계산 중..." : <>대상 <b>{count ?? 0}명</b> · 문자 가능 <b>{smsAvailable ?? 0}명</b></>}
          </div>
        </div>

        {/* ② 채널 */}
        <div style={{ marginBottom: 16 }}>
          <div style={labelStyle}>② 발송 채널</div>
          <div style={{ display: "flex", gap: 8 }}>
            <label style={{ flex: 1, display: "flex", alignItems: "center", gap: 6, border: channels.push ? "1px solid #93c5fd" : "1px solid #e5e7eb", background: channels.push ? "#eff6ff" : "#fff", borderRadius: 8, padding: "10px 12px", cursor: "pointer", fontSize: 13 }}>
              <input type="checkbox" checked={channels.push} onChange={e => setChannels(c => ({ ...c, push: e.target.checked }))} />
              <span style={{ color: channels.push ? "#2563eb" : "#374151" }}>🔔 앱 푸시</span>
            </label>
            <label style={{ flex: 1, display: "flex", alignItems: "center", gap: 6, border: channels.sms ? "1px solid #93c5fd" : "1px solid #e5e7eb", background: channels.sms ? "#eff6ff" : "#fff", borderRadius: 8, padding: "10px 12px", cursor: "pointer", fontSize: 13, opacity: smsConnected ? 1 : 0.6 }}>
              <input type="checkbox" checked={channels.sms} onChange={e => setChannels(c => ({ ...c, sms: e.target.checked }))} />
              <span style={{ color: channels.sms ? "#2563eb" : "#374151" }}>💬 문자{!smsConnected && " (미연결)"}</span>
            </label>
          </div>
        </div>

        {/* ③ 내용 */}
        <div style={{ marginBottom: 16 }}>
          <div style={labelStyle}>③ 내용</div>
          {channels.push && (
            <input type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="제목 (앱 푸시 제목)" style={selectStyle} />
          )}
          <textarea value={contentText} onChange={e => setContentText(e.target.value)} placeholder="내용을 입력하세요" style={{ width: "100%", minHeight: 80, padding: "10px 12px", border: "1px solid #ddd", borderRadius: 8, fontSize: 14, resize: "vertical", boxSizing: "border-box" }} />
          {channels.sms && (
            <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>
              문자 길이: {smsBytes}byte {smsBytes > 90 ? "(LMS로 발송)" : "(SMS)"}
            </div>
          )}
        </div>

        <button onClick={handleSend} disabled={sending} style={{ width: "100%", background: sending ? "#93c5fd" : "#2563eb", color: "#fff", border: "none", borderRadius: 8, padding: 11, fontSize: 14, fontWeight: 700, cursor: sending ? "default" : "pointer" }}>
          {sending ? "발송 중..." : `${count ?? 0}명에게 발송하기`}
        </button>
      </div>

      {/* ── 오른쪽: 미리보기 ── */}
      <div>
        <div style={{ fontSize: 13, color: "#888", marginBottom: 10, textAlign: "center" }}>미리보기</div>
        <div style={{ width: 260, background: "#0b0b14", borderRadius: 38, padding: 10, boxShadow: "0 10px 30px rgba(0,0,0,0.25)", margin: "0 auto" }}>
          <div style={{ position: "relative", background: "linear-gradient(180deg,#dfe6f0,#eef1f6)", borderRadius: 30, overflow: "hidden", height: 460 }}>
            {/* 상태바 */}
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 30, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 18px 0", fontSize: 11, fontWeight: 600, color: "#1a1a2e", zIndex: 3 }}>
              <span>9:41</span>
              <span style={{ display: "flex", gap: 4, alignItems: "center" }}>
                <span style={{ fontSize: 11 }}>●●●</span>
                <span style={{ fontSize: 11 }}>📶</span>
                <span style={{ fontSize: 11 }}>🔋</span>
              </span>
            </div>
            {/* 노치 */}
            <div style={{ position: "absolute", top: 7, left: "50%", transform: "translateX(-50%)", width: 90, height: 20, background: "#0b0b14", borderRadius: "0 0 14px 14px", zIndex: 4 }}></div>

            {/* 화면 내용 (스크롤) */}
            <div style={{ position: "absolute", top: 36, left: 0, right: 0, bottom: 0, overflowY: "auto", padding: "10px 12px 16px" }}>
              {/* 잠금화면 시계 */}
              <div style={{ textAlign: "center", color: "#1a1a2e", marginBottom: 18, marginTop: 4 }}>
                <div style={{ fontSize: 12, opacity: 0.7 }}>{new Date().toLocaleDateString("ko-KR", { month: "long", day: "numeric", weekday: "long" })}</div>
                <div style={{ fontSize: 38, fontWeight: 300, letterSpacing: 1, lineHeight: 1.1 }}>9:41</div>
              </div>

              {channels.push && (
                <div style={{ background: "rgba(255,255,255,0.85)", borderRadius: 16, padding: "11px 13px", marginBottom: 9 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
                    <div style={{ width: 20, height: 20, borderRadius: 6, background: "#2563eb", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 11, fontWeight: 700 }}>H</div>
                    <span style={{ fontSize: 11, color: "#444", fontWeight: 600 }}>헤이비서</span>
                    <span style={{ fontSize: 10, color: "#999", marginLeft: "auto" }}>지금</span>
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#111", marginBottom: 2 }}>{title || "제목을 입력하세요"}</div>
                  <div style={{ fontSize: 12, color: "#555", lineHeight: 1.4, display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{contentText || "내용을 입력하세요"}</div>
                </div>
              )}

              {channels.sms && (
                <div style={{ background: "rgba(255,255,255,0.85)", borderRadius: 16, padding: "11px 13px", marginBottom: 9 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
                    <div style={{ width: 20, height: 20, borderRadius: 6, background: "#22c55e", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 11 }}>💬</div>
                    <span style={{ fontSize: 11, color: "#444", fontWeight: 600 }}>메시지</span>
                    <span style={{ fontSize: 10, color: "#999", marginLeft: "auto" }}>지금</span>
                  </div>
                  <div style={{ fontSize: 12, color: "#555", lineHeight: 1.45, whiteSpace: "pre-wrap", wordBreak: "break-all" }}>[헤이비서] {contentText || "내용을 입력하세요"}</div>
                </div>
              )}

              {!channels.push && !channels.sms && (
                <div style={{ textAlign: "center", color: "#1a1a2e", opacity: 0.5, fontSize: 12, marginTop: 30 }}>채널을 선택하세요</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* HIST 발송 내역 */}
    <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #f3f4f6", padding: "20px 24px", marginTop: 20 }}>
      <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 14 }}>발송 내역</div>
      {logs.length === 0 ? (
        <div style={{ padding: 24, textAlign: "center", color: "#9ca3af", fontSize: 13 }}>발송 내역이 없습니다</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10, maxHeight: 460, overflowY: "auto", paddingRight: 4 }}>
          {logs.map(log => (
            <div key={log.id} style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: "12px 14px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                  <span style={{ fontSize: 14, fontWeight: 600 }}>{log.title || "(제목 없음)"}</span>
                  <span style={{ background: "#eff6ff", color: "#2563eb", fontSize: 11, padding: "2px 8px", borderRadius: 6 }}>{log.target_label}</span>
                </div>
                <span style={{ fontSize: 12, color: "#9ca3af" }}>{(log.created_at || "").slice(0, 16).replace("T", " ")}</span>
              </div>
              <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 8, whiteSpace: "pre-wrap" }}>{log.content}</div>
              <div style={{ display: "flex", gap: 12, fontSize: 12, color: "#9ca3af" }}>
                <span>👥 대상 {log.target_count}명</span>
                {log.channels.includes("push") && <span style={{ color: "#2563eb" }}>🔔 푸시 {log.push_sent}</span>}
                {log.channels.includes("sms") && <span style={{ color: "#22c55e" }}>💬 문자 {log.sms_sent}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
    </>
  );
};


const HEYBISEO_SMS_ACCOUNT = "국민은행 95457939455 (예금주: 김채빈)";
const HEYBISEO_SMS_CONTACT = "02-6672-7942";

const SmsTab = ({ token, addToast }) => {
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState({ sender_number: null, balance: 0, price_sms: 20, price_lms: 40, est_sms_count: 0 });
  const [logs, setLogs] = useState([]);
  const [senderReq, setSenderReq] = useState({ exists: false });
  const [reqForm, setReqForm] = useState({ sender_number: "", biz: null, telecom: null, consent: false });
  const [submitting, setSubmitting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/aligo/balance", {}, token);
      setInfo(d);
    } catch (e) { /* ignore */ }
    try {
      const l = await api("/aligo/charge-logs", {}, token);
      setLogs(l.logs || []);
    } catch (e) { /* ignore */ }
    try {
      const r = await api("/aligo/sender-request/my", {}, token);
      setSenderReq(r || { exists: false });
    } catch (e) { /* ignore */ }
    setLoading(false);
  }, [token]);

  const submitSenderReq = async () => {
    const sn = (reqForm.sender_number || "").replace(/[^0-9]/g, "");
    if (sn.length < 9 || sn.length > 11) return addToast("발신번호를 정확히 입력하세요", "error");
    if (!reqForm.biz) return addToast("사업자등록증 파일을 첨부하세요", "error");
    if (!reqForm.telecom) return addToast("통신서비스 이용증명원 파일을 첨부하세요", "error");
    if (!reqForm.consent) return addToast("개인정보 수집·이용 및 제3자 제공에 동의해주세요", "error");
    const fd = new FormData();
    fd.append("sender_number", sn);
    fd.append("consent", "true");
    fd.append("biz_doc", reqForm.biz);
    fd.append("telecom_doc", reqForm.telecom);
    setSubmitting(true);
    try {
      const res = await fetch("https://heybiseo.ai.kr/aligo/sender-request", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: fd,
      });
      const j = await res.json();
      if (!res.ok) throw new Error(j.detail || "신청 실패");
      addToast("발신번호 등록 신청이 접수됐습니다", "success");
      setReqForm({ sender_number: "", biz: null, telecom: null, consent: false });
      load();
    } catch (e) {
      addToast(e.message || "신청 중 오류가 발생했습니다", "error");
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => { load(); }, [load]);

  const fmtPhone = (n) => {
    if (!n) return "";
    const d = String(n).replace(/[^0-9]/g, "");
    if (d.length === 11) return d.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    if (d.length === 10) return d.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    return n;
  };

  if (loading) {
    return <div style={{ padding: 40, textAlign: "center", color: "#888" }}>불러오는 중...</div>;
  }

  const card = { background: "#fff", borderRadius: 12, border: "1px solid #eee", padding: "24px 28px", maxWidth: 560 };
  const lbl = { display: "block", fontWeight: 700, fontSize: 13, margin: "12px 0 6px" };
  const inp = { width: "100%", padding: "11px 12px", border: "1.5px solid #e5e7eb", borderRadius: 9, fontSize: 14, boxSizing: "border-box" };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {/* 문자서비스 이용 방법 안내 */}
      <div style={{ ...card, background: "#f0f7ff", border: "1px solid #cfe2ff" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
          <span style={{ fontSize: 20 }}>📖</span>
          <span style={{ fontSize: 16, fontWeight: 700 }}>문자서비스 이용 방법</span>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {[
            { t: "발신번호 등록", d: <>문자를 보내려면 <b>발신번호가 먼저 등록</b>되어야 합니다. 발신번호는 <b>사업자(대표자) 본인 명의로 가입된 번호</b>여야 하며, 사업자등록증과 <b>통신서비스 이용증명원</b>을 헤이비서로 보내주시면 등록해 드립니다. (1~2 영업일 소요) <span style={{ color: "#dc2626" }}>발신번호가 없으면 문자 발송이 불가합니다.</span></> },
            { t: "충전 (계좌이체)", d: <>아래 계좌로 원하는 금액을 입금하신 뒤 헤이비서로 알려주시면, 확인 후 그 금액만큼 잔액이 충전됩니다.<br /><span style={{ display: "inline-block", background: "#fff", border: "1px solid #dbeafe", borderRadius: 6, padding: "4px 10px", marginTop: 6, fontWeight: 700, color: "#111" }}>{HEYBISEO_SMS_ACCOUNT}</span> <span style={{ color: "#666" }}>· 문의 {HEYBISEO_SMS_CONTACT}</span></> },
            { t: "문자 발송", d: <><b>수동 발송</b> 탭에서 개별·공지 발송, <b>자동 발송 설정</b> 탭에서 만료·생일 등 자동 발송, <b>통합 발송</b>에서 조건별 대량 발송이 가능합니다. 발송 화면에서 <b>‘문자’ 채널</b>을 선택하면 문자로도 나갑니다.</> },
            { t: "요금 차감", d: <>발송할 때마다 잔액에서 차감됩니다. <b>단문(SMS) {info.price_sms || 20}원</b>, <b>장문(LMS·본문 90byte 초과) {info.price_lms || 40}원</b>. 잔액이 부족하면 발송이 실패하니 미리 충전해 주세요.</> },
          ].map((s, i) => (
            <div key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
              <div style={{ flexShrink: 0, width: 26, height: 26, borderRadius: "50%", background: "#2563eb", color: "#fff", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{i + 1}</div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#111", marginBottom: 3 }}>{s.t}</div>
                <div style={{ fontSize: 13, color: "#555", lineHeight: 1.7 }}>{s.d}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 발신번호 등록 신청 / 상태 */}
      {info.sender_number ? (
        <div style={{ ...card, background: "#f0fdf4", border: "1px solid #bbf7d0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, fontWeight: 700, color: "#166534" }}>
            ✅ 발신번호 등록 완료 — <span style={{ color: "#111" }}>{fmtPhone(info.sender_number)}</span>
          </div>
        </div>
      ) : senderReq.exists && senderReq.status === "pending" ? (
        <div style={{ ...card, background: "#fffbeb", border: "1px solid #fde68a" }}>
          <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>⏳ 발신번호 등록 신청 확인 중</div>
          <div style={{ fontSize: 13, color: "#92732e", lineHeight: 1.7 }}>
            신청하신 발신번호 <b>{fmtPhone(senderReq.sender_number)}</b> 를 확인하고 있습니다. 등록 완료되면 문자 발송이 가능합니다. (보통 1~2 영업일)<br />
            <span style={{ color: "#b0975a" }}>신청일: {senderReq.created_at}</span>
          </div>
        </div>
      ) : (
        <>
        {senderReq.exists && senderReq.status === "rejected" && (
          <div style={{ ...card, background: "#fef2f2", border: "1px solid #fca5a5" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 15, fontWeight: 700, color: "#b91c1c", marginBottom: 8 }}>❌ 발신번호 등록 신청이 반려되었습니다</div>
            {senderReq.reject_reason ? (
              <div style={{ fontSize: 13, color: "#7f1d1d", background: "#fff", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 12px", marginBottom: 8 }}><b>반려 사유:</b> {senderReq.reject_reason}</div>
            ) : null}
            <div style={{ fontSize: 13, color: "#991b1b", lineHeight: 1.6 }}>서류를 확인하신 후 아래에서 다시 신청해 주세요.</div>
          </div>
        )}
        <div style={card}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <span style={{ fontSize: 20 }}>📮</span>
            <span style={{ fontSize: 16, fontWeight: 700 }}>발신번호 등록 신청</span>
          </div>
          <div style={{ fontSize: 13, color: "#666", marginBottom: 8, lineHeight: 1.6 }}>
            문자 발송에 사용할 발신번호와 서류 2종을 제출하면 헤이비서가 발신번호를 등록해 드립니다.
          </div>
          <label style={lbl}>발신번호</label>
          <input value={reqForm.sender_number} onChange={e => setReqForm(p => ({ ...p, sender_number: e.target.value }))} placeholder="예) 02-1234-5678 또는 010-1234-5678" style={inp} />
          <div style={{ fontSize: 11.5, color: "#dc2626", fontWeight: 600, margin: "6px 0 0", lineHeight: 1.6 }}>※ 발신번호는 반드시 <b>사업자(대표자) 본인 명의로 가입된 번호</b>여야 등록됩니다.</div>
          <label style={lbl}>사업자등록증 (PDF/JPG/PNG)</label>
          <input type="file" accept=".pdf,.jpg,.jpeg,.png,image/*,application/pdf" onChange={e => setReqForm(p => ({ ...p, biz: (e.target.files && e.target.files[0]) || null }))} style={inp} />
          <label style={lbl}>통신서비스 이용증명원 (PDF/JPG/PNG)</label>
          <input type="file" accept=".pdf,.jpg,.jpeg,.png,image/*,application/pdf" onChange={e => setReqForm(p => ({ ...p, telecom: (e.target.files && e.target.files[0]) || null }))} style={inp} />
          <div style={{ fontSize: 11.5, color: "#dc2626", fontWeight: 600, margin: "6px 0 14px", lineHeight: 1.6 }}>※ 그 번호가 신청 사업자 명의임을 증명하는 서류입니다. 주민등록번호가 보이면 가려서 제출하세요.</div>
          <label style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 12.5, color: "#374151", lineHeight: 1.6, cursor: "pointer" }}>
            <input type="checkbox" checked={reqForm.consent} onChange={e => setReqForm(p => ({ ...p, consent: e.target.checked }))} style={{ marginTop: 2, flexShrink: 0 }} />
            <span>(필수) 발신번호 등록을 위해 제출 서류의 개인정보 <b>수집·이용</b> 및 발신번호 등록기관(알리고)에 <b>제3자 제공</b>하는 것에 동의합니다. 서류는 <b>등록 완료 즉시 파기</b>됩니다.</span>
          </label>
          <button onClick={submitSenderReq} disabled={submitting || !reqForm.consent} style={{ marginTop: 16, width: "100%", background: (submitting || !reqForm.consent) ? "#cbd5e1" : "#2563eb", color: "#fff", border: "none", borderRadius: 10, padding: "13px", fontSize: 15, fontWeight: 700, cursor: (submitting || !reqForm.consent) ? "not-allowed" : "pointer" }}>
            {submitting ? "신청 중..." : "발신번호 등록 신청하기"}
          </button>
        </div>
        </>
      )}

      {/* 잔액 / 발신번호 / 단가 */}
      <div style={card}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
          <span style={{ fontSize: 22 }}>📱</span>
          <span style={{ fontSize: 17, fontWeight: 700 }}>문자(SMS) 발송 서비스</span>
        </div>

        <div style={{ background: "#f8f9fa", borderRadius: 8, padding: 16, marginBottom: 14 }}>
          <div style={{ fontSize: 13, color: "#888", marginBottom: 4 }}>충전 잔액</div>
          <div style={{ fontSize: 28, fontWeight: 700 }}>{Number(info.balance || 0).toLocaleString()}원</div>
          <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>단문 약 {Number(info.est_sms_count || 0).toLocaleString()}건 발송 가능</div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
          <div style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: "10px 14px" }}>
            <div style={{ fontSize: 12, color: "#888" }}>단문(SMS)</div>
            <div style={{ fontSize: 16, fontWeight: 700 }}>{info.price_sms || 20}원 / 건</div>
          </div>
          <div style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: "10px 14px" }}>
            <div style={{ fontSize: 12, color: "#888" }}>장문(LMS·90byte 초과)</div>
            <div style={{ fontSize: 16, fontWeight: 700 }}>{info.price_lms || 40}원 / 건</div>
          </div>
        </div>

        {info.sender_number ? (
          <div style={{ fontSize: 13, color: "#555" }}>발신번호 <b style={{ color: "#111" }}>{fmtPhone(info.sender_number)}</b></div>
        ) : (
          <div style={{ background: "#fef9e7", borderRadius: 8, padding: "12px 14px", display: "flex", gap: 10, alignItems: "flex-start" }}>
            <span style={{ fontSize: 18, marginTop: 1 }}>⚠️</span>
            <div style={{ fontSize: 13, color: "#92732e", lineHeight: 1.6 }}>발신번호가 아직 등록되지 않았습니다. 통신서비스 이용증명원을 제출하면 헤이비서가 발신번호를 등록해 드립니다. ({HEYBISEO_SMS_CONTACT})</div>
          </div>
        )}
      </div>

      {/* 충전 안내 */}
      <div style={card}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>💳 충전 안내</div>
        <div style={{ fontSize: 13, color: "#555", lineHeight: 1.8 }}>
          1. 아래 계좌로 충전할 금액을 입금합니다.<br />
          2. 입금 후 헤이비서로 알려주세요. ({HEYBISEO_SMS_CONTACT})<br />
          3. 확인되면 잔액에 반영됩니다.
        </div>
        <div style={{ background: "#f8f9fa", borderRadius: 8, padding: "12px 14px", marginTop: 10, fontSize: 14, fontWeight: 600 }}>{HEYBISEO_SMS_ACCOUNT}</div>
      </div>

      {/* 충전 내역 */}
      <div style={card}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 12 }}>🧾 충전 내역</div>
        {logs.length === 0 ? (
          <div style={{ fontSize: 13, color: "#9ca3af" }}>충전 내역이 없습니다.</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {logs.map(l => (
              <div key={l.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f3f4f6", paddingBottom: 8 }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: l.amount >= 0 ? "#166534" : "#dc2626" }}>{l.amount >= 0 ? "+" : ""}{Number(l.amount).toLocaleString()}원</div>
                  <div style={{ fontSize: 12, color: "#9ca3af" }}>{l.memo || ""}{l.created_at ? " · " + l.created_at : ""}</div>
                </div>
                <div style={{ fontSize: 13, color: "#555" }}>잔액 {Number(l.balance_after || 0).toLocaleString()}원</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};


const NoticePage = ({ token, addToast }) => {
  const [tab, setTab] = useState("manual");
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ title: "", content: "", is_important: false });

  // 자동 발송 관련
  const [rules, setRules] = useState([]);
  const [showRuleModal, setShowRuleModal] = useState(false);
  const [editRule, setEditRule] = useState(null);
  const [ruleForm, setRuleForm] = useState({ name: "", trigger_type: "expiry_before", trigger_value: 7, send_time: "10:00", title: "", body: "" });

  const tenantId = (() => { try { return JSON.parse(atob(token.split('.')[1])).tenant_id; } catch { return 1; } })();

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api("/notice/list", {}, token);
      setNotices(Array.isArray(d) ? d : []);
    } catch (e) { addToast("공지사항 로드 실패: " + e.message, "error"); }
    finally { setLoading(false); }
  }, [token]);

  const loadRules = useCallback(async () => {
    try {
      const d = await api(`/push-rules/${tenantId}`, {}, token);
      setRules(Array.isArray(d) ? d : []);
    } catch (e) { console.error(e); }
  }, [token, tenantId]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (tab === "auto") loadRules(); }, [tab, loadRules]);

  const handleCreate = async () => {
    if (!form.title || !form.content) return addToast("제목과 내용을 입력하세요", "error");
    setSaving(true);
    try {
      await api("/notice", { method: "POST", body: JSON.stringify({ title: form.title, content: form.content, is_pinned: form.is_important }) }, token);
      addToast("공지사항이 등록되고 푸시가 발송됐습니다", "success");
      setShowModal(false);
      setForm({ title: "", content: "", is_important: false });
      load();
    } catch (e) { addToast("등록 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };

  const triggerOptions = [
    { value: "expiry_before", label: "만료 N일 전" },
    { value: "birthday", label: "생일 당일" },
    { value: "new_register", label: "신규 등록" },
    { value: "inactive_days", label: "N일 미방문" },
    { value: "anniversary_month", label: "등록 N개월 기념" },
  ];

  const triggerLabel = v => triggerOptions.find(o => o.value === v)?.label || v;
  const needsValue = v => ["expiry_before", "inactive_days", "anniversary_month"].includes(v);

  const sampleRules = [
    { trigger_type: "expiry_before", trigger_value: 7, name: "만료 7일 전 알림", title: "회원권 만료 안내", body: "{이름}님, 회원권이 7일 후 만료됩니다. 지금 연장하세요!" },
    { trigger_type: "birthday", trigger_value: 0, name: "생일 축하", title: "🎂 생일을 축하합니다!", body: "{이름}님, 생일을 축하드립니다! 오늘 하루도 건강하게 보내세요 🎉" },
    { trigger_type: "new_register", trigger_value: 0, name: "신규 등록 환영", title: "환영합니다!", body: "{이름}님, {시설명}에 오신 것을 환영합니다! 즐거운 운동 시작하세요 💪" },
    { trigger_type: "inactive_days", trigger_value: 14, name: "14일 미방문 알림", title: "보고싶어요 😢", body: "{이름}님, 마지막 방문 후 14일이 지났어요. 오늘 운동하러 오세요!" },
    { trigger_type: "anniversary_month", trigger_value: 3, name: "3개월 기념", title: "3개월 축하드려요! 🏆", body: "{이름}님, 등록 3개월이 됐어요! 꾸준히 운동하신 것을 축하드립니다 🎊" },
  ];

  const openRuleModal = (preset = null) => {
    if (preset) {
      setRuleForm({ name: preset.name, trigger_type: preset.trigger_type, trigger_value: preset.trigger_value, send_time: "10:00", title: preset.title, body: preset.body });
      setEditRule(null);
    } else {
      setRuleForm({ name: "", trigger_type: "expiry_before", trigger_value: 7, send_time: "10:00", title: "", body: "" });
      setEditRule(null);
    }
    setShowRuleModal(true);
  };

  const saveRule = async () => {
    if (!ruleForm.name || !ruleForm.title || !ruleForm.body) return addToast("규칙명, 제목, 내용을 입력하세요", "error");
    try {
      if (editRule) {
        await api(`/push-rules/${editRule.id}`, { method: "PUT", body: JSON.stringify(ruleForm) }, token);
        addToast("수정되었습니다.");
      } else {
        await api(`/push-rules/${tenantId}`, { method: "POST", body: JSON.stringify(ruleForm) }, token);
        addToast("규칙이 추가되었습니다.");
      }
      setShowRuleModal(false);
      loadRules();
    } catch (e) { addToast("저장 실패: " + e.message, "error"); }
  };

  const deleteRule = async (id) => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    await api(`/push-rules/${id}`, { method: "DELETE" }, token);
    addToast("삭제되었습니다.");
    loadRules();
  };

  const toggleRule = async (rule) => {
    await api(`/push-rules/${rule.id}`, { method: "PUT", body: JSON.stringify({ is_active: rule.is_active ? 0 : 1 }) }, token);
    loadRules();
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h2 style={{ color: "#111", margin: 0, fontSize: 20, fontWeight: 700 }}>앱 푸시</h2>
        {tab === "auto" && <Btn onClick={() => openRuleModal()}><Icon name="plus" size={14} />규칙 추가</Btn>}
      </div>

      {/* 탭 */}
      <div style={{ display: "flex", gap: 4, marginBottom: 20, borderBottom: "1px solid #f0f0f0" }}>
        {[{ id: "manual", label: "수동 발송" }, { id: "auto", label: "자동 발송 설정" }, { id: "sms", label: "문자(SMS)" }].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            background: "none", border: "none", padding: "10px 18px", fontSize: 13,
            fontWeight: tab === t.id ? 700 : 400, color: tab === t.id ? "#2563eb" : "#6b7280",
            cursor: "pointer", borderBottom: tab === t.id ? "2px solid #2563eb" : "2px solid transparent", marginBottom: -1
          }}>{t.label}</button>
        ))}
      </div>

      {/* 수동 발송 탭 */}
      {tab === "sms" && <SmsTab token={token} addToast={addToast} />}
      {tab === "manual" && (
        <BroadcastTab token={token} addToast={addToast} />
      )}

      {/* 자동 발송 탭 */}
      {tab === "auto" && (
        <div>
          {/* 샘플 규칙 */}
          {rules.length === 0 && (
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 12 }}>💡 샘플 규칙으로 빠르게 시작하세요</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                {sampleRules.map((s, i) => (
                  <button key={i} onClick={() => openRuleModal(s)} style={{
                    background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 10,
                    padding: "8px 14px", fontSize: 12, color: "#0369a1", cursor: "pointer", fontWeight: 600
                  }}>+ {s.name}</button>
                ))}
              </div>
            </div>
          )}

          {/* 규칙 목록 */}
          {rules.length === 0 ? (
            <div style={{ background: "#fff", borderRadius: 14, padding: 40, textAlign: "center", color: "#9ca3af", fontSize: 14, border: "1px solid #f3f4f6" }}>
              등록된 자동 발송 규칙이 없습니다
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {rules.map(rule => (
                <div key={rule.id} style={{ background: "#fff", borderRadius: 12, padding: "16px 20px", border: "1px solid #f3f4f6", boxShadow: "0 1px 4px rgba(0,0,0,0.04)", display: "flex", alignItems: "center", gap: 16 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                      <span style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>{rule.name}</span>
                      <span style={{ fontSize: 11, background: "#eff6ff", color: "#2563eb", padding: "2px 8px", borderRadius: 20, fontWeight: 600 }}>{triggerLabel(rule.trigger_type)}{needsValue(rule.trigger_type) ? ` (${rule.trigger_value})` : ""}</span>
                    </div>
                    <div style={{ fontSize: 12, color: "#6b7280" }}>제목: {rule.title}</div>
                    <div style={{ fontSize: 12, color: "#9ca3af" }}>내용: {rule.body?.slice(0, 50)}{rule.body?.length > 50 ? "..." : ""}</div>
                    <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>발송 시간: {rule.send_time}</div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <button onClick={() => toggleRule(rule)} style={{
                      background: rule.is_active ? "#22c55e" : "#e5e7eb", border: "none", borderRadius: 20,
                      width: 44, height: 24, cursor: "pointer", position: "relative", transition: "all .2s"
                    }}>
                      <div style={{ width: 18, height: 18, borderRadius: "50%", background: "#fff", position: "absolute", top: 3, left: rule.is_active ? 23 : 3, transition: "all .2s" }} />
                    </button>
                    <button onClick={() => { setEditRule(rule); setRuleForm({ name: rule.name, trigger_type: rule.trigger_type, trigger_value: rule.trigger_value, send_time: rule.send_time, title: rule.title, body: rule.body }); setShowRuleModal(true); }}
                      style={{ background: "none", border: "1px solid #e5e7eb", borderRadius: 7, padding: "4px 10px", fontSize: 12, cursor: "pointer", color: "#374151" }}>수정</button>
                    <button onClick={() => deleteRule(rule.id)}
                      style={{ background: "none", border: "1px solid #fecaca", borderRadius: 7, padding: "4px 10px", fontSize: 12, cursor: "pointer", color: "#ef4444" }}>삭제</button>
                  </div>
                </div>
              ))}
              {/* 샘플 추가 버튼 (규칙 있을 때) */}
              <div style={{ marginTop: 8 }}>
                <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 8 }}>샘플로 추가:</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {sampleRules.map((s, i) => (
                    <button key={i} onClick={() => openRuleModal(s)} style={{
                      background: "#f8faff", border: "1px solid #e0e7ff", borderRadius: 8,
                      padding: "6px 12px", fontSize: 11, color: "#4f46e5", cursor: "pointer"
                    }}>+ {s.name}</button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* 수동 발송 모달 */}
      {showModal && (
        <Modal title="공지사항 등록" onClose={() => setShowModal(false)}>
          <Input label="제목 *" value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} placeholder="공지사항 제목" />
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", color: "#374151", fontSize: 12, fontWeight: 600, marginBottom: 5 }}>내용 *</label>
            <textarea value={form.content} onChange={e => setForm(p => ({ ...p, content: e.target.value }))} placeholder="공지사항 내용을 입력하세요" rows={5}
              style={{ width: "100%", background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, color: "#111", padding: "10px 12px", fontSize: 13, outline: "none", boxSizing: "border-box", resize: "vertical", fontFamily: "inherit" }} />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
            <input type="checkbox" id="is_important" checked={form.is_important} onChange={e => setForm(p => ({ ...p, is_important: e.target.checked }))} />
            <label htmlFor="is_important" style={{ fontSize: 13, color: "#374151", cursor: "pointer" }}>중요 공지사항으로 설정</label>
          </div>
          <div style={{ background: "#eff6ff", borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: "#2563eb" }}>
            📱 등록 시 모든 회원에게 앱 푸시 알림이 발송됩니다.
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="secondary" onClick={() => setShowModal(false)}>취소</Btn>
            <Btn onClick={handleCreate} disabled={saving}>{saving ? "등록 중..." : "등록 + 푸시발송"}</Btn>
          </div>
        </Modal>
      )}

      {/* 규칙 추가/수정 모달 */}
      {showRuleModal && (
        <Modal title={editRule ? "규칙 수정" : "자동 발송 규칙 추가"} onClose={() => setShowRuleModal(false)}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div>
              <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>규칙 이름 *</label>
              <input value={ruleForm.name} onChange={e => setRuleForm(p => ({ ...p, name: e.target.value }))} placeholder="예: 만료 7일 전 알림"
                style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none" }} />
            </div>
            <div>
              <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>트리거 *</label>
              <select value={ruleForm.trigger_type} onChange={e => setRuleForm(p => ({ ...p, trigger_type: e.target.value }))}
                style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none" }}>
                {triggerOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>
            {needsValue(ruleForm.trigger_type) && (
              <div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>
                  {ruleForm.trigger_type === "expiry_before" ? "며칠 전" : ruleForm.trigger_type === "inactive_days" ? "미방문 일수" : "개월 수"}
                </label>
                <input type="number" value={ruleForm.trigger_value} min={1} onChange={e => setRuleForm(p => ({ ...p, trigger_value: parseInt(e.target.value) }))}
                  style={{ width: 100, border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none" }} />
              </div>
            )}
            <div>
              <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>발송 시간</label>
              <TimePicker value={ruleForm.send_time} onChange={v => setRuleForm(p => ({ ...p, send_time: v }))}
                style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none" }} />
            </div>
            <div>
              <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>푸시 제목 *</label>
              <input value={ruleForm.title} onChange={e => setRuleForm(p => ({ ...p, title: e.target.value }))} placeholder="푸시 알림 제목"
                style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none" }} />
            </div>
            <div>
              <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5 }}>푸시 내용 *</label>
              <textarea value={ruleForm.body} onChange={e => setRuleForm(p => ({ ...p, body: e.target.value }))} rows={3}
                placeholder="사용 가능한 변수: {이름}, {만료일}, {시설명}"
                style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", resize: "vertical", fontFamily: "inherit" }} />
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>변수: {"{이름}"} {"{만료일}"} {"{시설명}"}</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 20 }}>
            <Btn variant="secondary" onClick={() => setShowRuleModal(false)}>취소</Btn>
            <Btn onClick={saveRule}>{editRule ? "수정 완료" : "규칙 추가"}</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};
// ════════════════════════════════════════════════════════════════════════════
// LOGIN
// ════════════════════════════════════════════════════════════════════════════
// 요금제 만료 배너
const PLAN_BANNER_CFG = {
  ok:        null,
  trial:     { bg: "#dbeafe", border: "#3b82f6", text: "#1d4ed8", icon: "ℹ️" },
  info:      { bg: "#fef3c7", border: "#f59e0b", text: "#92400e", icon: "⚠️" },
  warning:   { bg: "#ffedd5", border: "#f97316", text: "#7c2d12", icon: "⚠️" },
  danger:    { bg: "#fee2e2", border: "#ef4444", text: "#991b1b", icon: "🚨" },
  grace:     { bg: "#fee2e2", border: "#ef4444", text: "#991b1b", icon: "🚨" },
  suspended: { bg: "#f3e8ff", border: "#9333ea", text: "#581c87", icon: "🔒" },
  cancelled: { bg: "#f1f5f9", border: "#94a3b8", text: "#475569", icon: "❌" },
};

const PlanBanner = ({ subscription }) => {
  const [showPopup, setShowPopup] = React.useState(false);

  const level = React.useMemo(() => {
    if (!subscription) return "ok";
    const { status, end } = subscription;
    if (status === "SUSPENDED") return "suspended";
    if (status === "CANCELLED") return "cancelled";
    if (status === "GRACE") return "grace";
    if (end) {
      const days = Math.ceil((new Date(end) - new Date()) / 86400000);
      if (days <= 7)  return "danger";
      if (days <= 14) return "warning";
      if (days <= 30) return "info";
      return "ok";
    }
    if (status === "TRIAL") return "trial";
    return "ok";
  }, [subscription]);

  const daysLeft = React.useMemo(() => {
    if (!subscription?.end) return null;
    return Math.ceil((new Date(subscription.end) - new Date()) / 86400000);
  }, [subscription]);

  React.useEffect(() => {
    if (level === "danger" && daysLeft !== null && daysLeft <= 7) {
      const key = "plan_popup_" + new Date().toDateString();
      if (!sessionStorage.getItem(key)) {
        setShowPopup(true);
        sessionStorage.setItem(key, "1");
      }
    }
  }, [level, daysLeft]);

  const cfg = PLAN_BANNER_CFG[level];
  if (!cfg) return null;

  const planLabel = { TRIAL:"체험판", BASIC:"베이직", PRO:"프로", ENTERPRISE:"엔터프라이즈" }[subscription?.plan] || subscription?.plan || "";

  const getMessage = () => {
    if (level === "suspended") return "서비스가 정지되었습니다. 고객센터(02-6672-7942)로 문의해 주세요.";
    if (level === "cancelled") return "서비스가 해지되었습니다. 고객센터로 문의해 주세요.";
    if (level === "grace")     return `유예 기간 중입니다. 빠른 결제 갱신이 필요합니다. (만료일: ${subscription?.end})`;
    if (level === "trial") {
      if (daysLeft !== null && daysLeft >= 0) return `체험판 사용 중 — ${daysLeft}일 후 만료됩니다.`;
      return "체험판 사용 중입니다.";
    }
    if (daysLeft !== null && daysLeft >= 0)
      return `[${planLabel}] 이용권이 ${daysLeft}일 후 만료됩니다. (만료일: ${subscription?.end})`;
    if (daysLeft !== null && daysLeft < 0)
      return `[${planLabel}] 이용권이 만료되었습니다. 갱신이 필요합니다.`;
    return "이용권 만료가 임박했습니다.";
  };

  return (
    <>
      {showPopup && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", border: `2px solid ${cfg.border}`, borderRadius: 16, padding: 32, maxWidth: 400, width: "90%", textAlign: "center", fontFamily: "inherit" }}>
            <div style={{ fontSize: 44, marginBottom: 14 }}>🚨</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#111", marginBottom: 10 }}>이용권 만료 임박</div>
            <div style={{ color: "#6b7280", fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>
              이용권이 <strong style={{ color: cfg.border }}>{daysLeft}일 후</strong> 만료됩니다.<br />
              만료 후에는 서비스 이용이 제한될 수 있습니다.<br />
              고객센터(02-6672-7942)로 갱신 문의 바랍니다.
            </div>
            <button onClick={() => setShowPopup(false)}
              style={{ background: cfg.border, color: "#fff", border: "none", borderRadius: 8, padding: "10px 32px", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
              확인
            </button>
          </div>
        </div>
      )}
      <div style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 200,
        background: cfg.bg, borderBottom: `2px solid ${cfg.border}`,
        padding: "8px 24px", display: "flex", alignItems: "center", gap: 10,
        fontSize: 13, color: cfg.text, fontWeight: 600,
      }}>
        <span style={{ fontSize: 15 }}>{cfg.icon}</span>
        <span>{getMessage()}</span>
        {level === "suspended" && (
          <span style={{ marginLeft: "auto", fontSize: 12, opacity: 0.75 }}>모든 기능이 잠금 처리됩니다.</span>
        )}
      </div>
    </>
  );
};

// 정지 화면
const SuspendedScreen = () => (
  <div style={{
    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
    minHeight: "60vh", gap: 20, padding: 40, textAlign: "center"
  }}>
    <div style={{ fontSize: 64 }}>🔒</div>
    <div style={{ fontSize: 22, fontWeight: 800, color: "#111" }}>서비스가 정지되었습니다</div>
    <div style={{ fontSize: 14, color: "#6b7280", lineHeight: 1.8, maxWidth: 400 }}>
      이용권 만료 또는 기타 사유로 서비스가 정지되었습니다.<br />
      사용을 재개하려면 고객센터로 문의해 주세요.
    </div>
    <div style={{
      background: "#f3e8ff", border: "1px solid #d8b4fe", borderRadius: 12,
      padding: "16px 28px", fontSize: 15, fontWeight: 700, color: "#7c3aed"
    }}>
      고객센터: 02-6672-7942
    </div>
    <div style={{ fontSize: 12, color: "#9ca3af" }}>
      운영시간: 매일 10:00 – 20:00
    </div>
  </div>
);

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
  if (!username || !password) return setError("아이디와 비밀번호를 입력해주세요");
  setLoading(true);
  setError("");
  try {
    const res = await fetch(`${API_BASE}/auth/login?email=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`, { method: "POST" });
    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch(e) {
      throw new Error("서버 응답 오류");
    }
    if (!res.ok) throw new Error(data.detail || "로그인 실패");
    onLogin(data);
  } catch (e) {
    setError(e.message);
  } finally {
    setLoading(false);
  }
};

  return (
    <div style={{ minHeight: "100vh", background: "#f0f4ff", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Pretendard', 'Noto Sans KR', sans-serif" }}>
      <div style={{ width: "100%", maxWidth: 400, padding: 20 }}>
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -0.5 }}>
  <span style={{ color: "#2563eb" }}>Hey</span><span style={{ color: "#111" }}>비서</span>
</div>
          <div style={{ color: "#9ca3af", fontSize: 13, marginTop: 6 }}>관리자 대시보드</div>
        </div>
        <div style={{ background: "#fff", borderRadius: 18, padding: 32, boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}>
          <Input label="아이디" value={username} onChange={e => setUsername(e.target.value)} placeholder="email@example.com" onKeyDown={e => e.key === "Enter" && handleLogin()} />
          <Input label="비밀번호" value={password} onChange={e => setPassword(e.target.value)} type="password" placeholder="••••••••" onKeyDown={e => e.key === "Enter" && handleLogin()} />
          {error && <div style={{ color: "#ef4444", fontSize: 12, marginBottom: 12, padding: "8px 12px", background: "#fff0f0", borderRadius: 8 }}>{error}</div>}
          <button onClick={handleLogin} disabled={loading} style={{
            width: "100%", background: "#2563eb", color: "#fff", border: "none", borderRadius: 10, padding: "13px 0",
            fontSize: 14, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1, marginTop: 4
          }}>{loading ? "로그인 중..." : "로그인"}</button>
        </div>
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// NAV CONFIG
// ════════════════════════════════════════════════════════════════════════════
const NAV = [
  { id: "dashboard",  label: "대시보드", icon: "dashboard" },
  { id: "classes",    label: "수업관리", icon: "calendar", children: [
    { id: "classes_member", label: "회원 수업 관리" },
    { id: "classes_trainer", label: "강사 수업 관리" },
  ]},
  { id: "members",    label: "회원관리", icon: "members" },
  { id: "consult",    label: "상담관리", icon: "lead" },
  { id: "payment",    label: "결제/환불", icon: "payment" },
  { id: "sales",      label: "매출통계", icon: "sales" },
  { id: "analytics",  label: "통계분석", icon: "sales" },
  { id: "products",   label: "상품관리", icon: "plan" },
  { id: "lockers",    label: "락커관리", icon: "door" },
  { id: "attendance", label: "출입관리", icon: "door" },
  { id: "staff",      label: "직원관리", icon: "staff" },
{ id: "notices",    label: "앱 푸시", icon: "bell" },

];

const NAV_BOTTOM = [
  { id: "contract",   label: "전자계약", icon: "plan" },
  { id: "aiReport",  label: "Hey비서 리포트", icon: "bell" },
];

// 대표(OWNER) 전용 페이지 — 다른 직원 계정에는 노출/접근 불가
const OWNER_ONLY = ["sales", "analytics"];

// ─── SETTINGS PAGE ────────────────────────────────────────────────
// ════════════════════════════════════════════════════════════════
// 구독 관리 탭 컴포넌트
// ════════════════════════════════════════════════════════════════
const PLAN_MONTHLY = { BASIC: 29700, PRO: 69500 };
const MONTH_OPTIONS = [1, 3, 6, 12];
const calcSubAmount = (plan, months) => {
  const base = PLAN_MONTHLY[plan] || 0;
  return months === 12 ? Math.round(base * 12 * 0.9) : base * months;
};
const PLAN_LABELS = { BASIC: "베이직", PRO: "프로" };
const STATUS_LABELS = { TRIAL: "체험판", ACTIVE: "활성", EXPIRED: "만료", CANCELLED: "해지", SUSPENDED: "정지", GRACE: "유예" };
const STATUS_COLORS = { TRIAL: "#f59e0b", ACTIVE: "#10b981", EXPIRED: "#ef4444", CANCELLED: "#6b7280", SUSPENDED: "#9333ea", GRACE: "#ef4444" };

const SubscriptionTab = ({ token, addToast }) => {
  const [status, setStatus] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [mode, setMode] = React.useState("default"); // default / change_plan / renew
  const [selectedPlan, setSelectedPlan] = React.useState("BASIC");
  const [selectedMonths, setSelectedMonths] = React.useState(1);
  const [payMethod, setPayMethod] = React.useState("card");
  const [cardForm, setCardForm] = React.useState({ buyer_name: "", buyer_phone: "", card_number: "", card_expiry: "", card_pw: "", birth_or_biz: "" });
  const [depositorName, setDepositorName] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [transferResult, setTransferResult] = React.useState(null);
  const [successResult, setSuccessResult] = React.useState(null); // 결제 완료 팝업

  const loadStatus = () => {
    setLoading(true);
    api("/subscription/status", {}, token)
      .then(d => { setStatus(d); setLoading(false); if (d.plan === "PRO" || d.plan === "BASIC") setSelectedPlan(d.plan); })
      .catch(e => { console.error(e); setLoading(false); });
  };

  React.useEffect(() => { loadStatus(); }, [token]);

  const amount = calcSubAmount(selectedPlan, selectedMonths);
  const planLabel = PLAN_LABELS[selectedPlan] || selectedPlan;
  const cycleLabel = selectedMonths + "개월";

  const handleCardPay = async () => {
    if (!cardForm.buyer_name || !cardForm.buyer_phone || !cardForm.card_number || !cardForm.card_expiry || !cardForm.card_pw || !cardForm.birth_or_biz) {
      return addToast("모든 카드 정보를 입력해 주세요.", "error");
    }
    setSaving(true);
    try {
      const d = await api("/subscription/card-pay", {
        method: "POST",
        body: JSON.stringify({ plan: selectedPlan, months: selectedMonths, ...cardForm })
      }, token);
      setSuccessResult({ plan: planLabel, cycle: cycleLabel, amount, end_date: d.end_date, method: "카드" });
      setCardForm({ buyer_name: "", buyer_phone: "", card_number: "", card_expiry: "", card_pw: "", birth_or_biz: "" });
      setMode("default");
      loadStatus();
    } catch (e) { addToast("결제 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };

  const handleTransferRequest = async () => {
    if (!depositorName.trim()) return addToast("입금자명을 입력해 주세요.", "error");
    setSaving(true);
    try {
      const d = await api("/subscription/transfer-request", {
        method: "POST",
        body: JSON.stringify({ plan: selectedPlan, months: selectedMonths, depositor_name: depositorName })
      }, token);
      setTransferResult(d);
      addToast("계좌이체 신청이 접수되었습니다.", "success");
    } catch (e) { addToast("신청 실패: " + e.message, "error"); }
    finally { setSaving(false); }
  };

  const inputStyle = { width: "100%", boxSizing: "border-box", fontSize: 13, padding: "8px 12px", border: "1px solid #e5e7eb", borderRadius: 8, outline: "none" };
  const labelStyle = { fontSize: 11, color: "#6b7280", marginBottom: 6, display: "block" };
  const cardStyle = { background: "#fff", border: "1px solid #f0f0f0", borderRadius: 12, padding: "20px 24px", marginBottom: 16 };

  const curStatus = status?.subscription_status || "TRIAL";
  const isSuspended = curStatus === "SUSPENDED" || curStatus === "CANCELLED";

  // ── 플랜 선택 + 결제 폼 (공통) ───────────────────────────────
  const PaymentSection = ({ title, borderColor, showChangeBadge }) => (
    <>
      <div style={{ ...cardStyle, border: `2px solid ${borderColor || "#2563eb"}` }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#374151" }}>{title}</div>
          {showChangeBadge && <span style={{ fontSize: 11, background: "#dbeafe", color: "#1d4ed8", padding: "3px 10px", borderRadius: 20 }}>즉시 적용</span>}
        </div>

        {/* 플랜 선택 - 플랜변경 시 현재 플랜 표시 */}
        {mode === "change_plan" ? (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
            <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, padding: "16px 18px", opacity: 0.5 }}>
              <div style={{ fontSize: 11, background: "#f3f4f6", color: "#6b7280", padding: "2px 8px", borderRadius: 20, display: "inline-block", marginBottom: 8 }}>현재 플랜</div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>{PLAN_LABELS[status?.plan] || status?.plan}</div>
            </div>
            {["BASIC","PRO"].filter(p => p !== status?.plan).map(p => (
              <div key={p} onClick={() => setSelectedPlan(p)} style={{
                border: `2px solid ${p === "BASIC" ? "#2563eb" : "#7c3aed"}`,
                borderRadius: 12, padding: "16px 18px", cursor: "pointer", position: "relative",
                background: p === "BASIC" ? "#eff6ff" : "#faf5ff"
              }}>
                <div style={{ fontSize: 11, background: p === "BASIC" ? "#dbeafe" : "#ede9fe", color: p === "BASIC" ? "#1d4ed8" : "#6d28d9", padding: "2px 8px", borderRadius: 20, display: "inline-block", marginBottom: 8 }}>변경 플랜</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>{PLAN_LABELS[p]}</div>
                <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 8 }}>{p === "BASIC" ? "CRM 전용 · 앱 미포함" : "CRM + 회원앱 포함"}</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: p === "BASIC" ? "#2563eb" : "#7c3aed" }}>
                  {PLAN_MONTHLY[p].toLocaleString()}
                  <span style={{ fontSize: 11, fontWeight: 400, color: "#9ca3af" }}>원/월</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
            {[
              { id: "BASIC", desc: "CRM 전용 · 앱 미포함", color: "#2563eb", bg: "#eff6ff", selBg: "#dbeafe" },
              { id: "PRO",   desc: "CRM + 회원앱 포함",   color: "#7c3aed", bg: "#faf5ff", selBg: "#ede9fe" },
            ].map(p => (
              <div key={p.id} onClick={() => { if (mode !== "renew") setSelectedPlan(p.id); }} style={{
                border: selectedPlan === p.id ? `2px solid ${p.color}` : "1px solid #e5e7eb",
                borderRadius: 12, padding: "16px 18px", cursor: "pointer", position: "relative",
                background: selectedPlan === p.id ? p.bg : "#fff"
              }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>{PLAN_LABELS[p.id]}</div>
                <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 10 }}>{p.desc}</div>
                <div style={{ fontSize: 18, fontWeight: 700, color: p.color }}>
                  {PLAN_MONTHLY[p.id].toLocaleString()}
                  <span style={{ fontSize: 11, fontWeight: 400, color: "#9ca3af" }}>원/월</span>
                </div>
                {selectedPlan === p.id && (
                  <div style={{ position: "absolute", top: 10, right: 10, background: p.selBg, color: p.color, fontSize: 10, padding: "2px 8px", borderRadius: 20, fontWeight: 700 }}>선택됨</div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* 결제 개월수 */}
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          {MONTH_OPTIONS.map(m => (
            <button key={m} onClick={() => setSelectedMonths(m)} style={{
              flex: 1, padding: "9px 0", border: selectedMonths === m ? "2px solid #2563eb" : "1px solid #e5e7eb",
              borderRadius: 8, fontSize: 13, fontWeight: selectedMonths === m ? 700 : 400,
              color: selectedMonths === m ? "#2563eb" : "#6b7280",
              background: selectedMonths === m ? "#eff6ff" : "#fff", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", gap: 6
            }}>
              {m}개월
              {m === 12 && <span style={{ fontSize: 11, color: "#16a34a", background: "#dcfce7", padding: "2px 7px", borderRadius: 20 }}>10% 할인</span>}
            </button>
          ))}
        </div>

        {/* 결제 금액 */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, padding: "10px 14px", background: "#f9fafb", borderRadius: 8 }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>{planLabel} · {selectedMonths}개월</span>
          <span style={{ fontSize: 16, fontWeight: 800, color: "#111" }}>{amount.toLocaleString()}원</span>
        </div>

        {/* 결제 수단 */}
        <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 10 }}>결제 수단</div>
        <div style={{ display: "flex", gap: 8 }}>
          {[{ id: "card", label: "💳 카드 결제" }, { id: "transfer", label: "🏦 계좌이체" }].map(m => (
            <button key={m.id} onClick={() => setPayMethod(m.id)} style={{
              flex: 1, padding: "10px 0", border: payMethod === m.id ? "2px solid #2563eb" : "1px solid #e5e7eb",
              borderRadius: 8, fontSize: 13, fontWeight: payMethod === m.id ? 700 : 400,
              color: payMethod === m.id ? "#2563eb" : "#6b7280",
              background: payMethod === m.id ? "#eff6ff" : "#fff", cursor: "pointer"
            }}>{m.label}</button>
          ))}
        </div>
      </div>

      {/* 카드 결제 폼 */}
      {payMethod === "card" && (
        <div style={cardStyle}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 16 }}>💳 카드 정보 입력</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
            {[
              ["카드번호", "card_number", "text", "0000 0000 0000 0000"],
              ["유효기간 (MMYY)", "card_expiry", "text", "0125"],
              ["비밀번호 앞 2자리", "card_pw", "password", "••"],
              ["생년월일 6자리 (법인: 사업자번호)", "birth_or_biz", "text", "900101"],
              ["구매자 성함", "buyer_name", "text", "홍길동"],
              ["연락처", "buyer_phone", "text", "010-0000-0000"],
            ].map(([label, key, type, ph]) => (
              <div key={key}>
                <label style={labelStyle}>{label}</label>
                <input type={type} placeholder={ph} value={cardForm[key]}
                  onChange={e => setCardForm(f => ({ ...f, [key]: e.target.value }))} style={inputStyle} />
              </div>
            ))}
          </div>
          <div style={{ background: "#f8faff", borderRadius: 8, padding: "12px 14px", fontSize: 12, color: "#6b7280", marginBottom: 14, lineHeight: 1.7 }}>
            결제 금액: <strong style={{ color: "#374151" }}>{amount.toLocaleString()}원</strong> ({planLabel} {cycleLabel}) · 부가세 별도<br/>
            결제 즉시 이용권이 활성화됩니다.
          </div>
          <button onClick={handleCardPay} disabled={saving} style={{
            width: "100%", padding: "13px 0", background: "#2563eb", color: "#fff", border: "none",
            borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.7 : 1
          }}>{saving ? "결제 중..." : `${amount.toLocaleString()}원 결제하기`}</button>
        </div>
      )}

      {/* 계좌이체 */}
      {payMethod === "transfer" && (
        <div style={cardStyle}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 16 }}>🏦 계좌이체 신청</div>
          {transferResult ? (
            <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: "16px 18px" }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#166534", marginBottom: 8 }}>✅ 신청이 접수되었습니다</div>
              <div style={{ fontSize: 13, color: "#166534", lineHeight: 1.8 }}>
                입금 은행: <strong>{transferResult.bank}</strong><br/>
                계좌번호: <strong>{transferResult.account}</strong><br/>
                예금주: <strong>{transferResult.holder}</strong><br/>
                입금액: <strong>{(transferResult.amount || 0).toLocaleString()}원</strong><br/>
                입금자명: <strong>{transferResult.depositor_name}</strong>
              </div>
              <div style={{ marginTop: 12, fontSize: 12, color: "#6b7280" }}>입금 확인 후 1~2 영업일 내 서비스가 활성화됩니다.</div>
            </div>
          ) : (
            <>
              <div style={{ background: "#f8faff", borderRadius: 10, padding: "14px 16px", marginBottom: 14, lineHeight: 2.2 }}>
                {[
                  ["은행", status?.transfer_bank || "기업은행"],
                  ["계좌번호", status?.transfer_account || "-"],
                  ["예금주", status?.transfer_holder || "헤이비서(주)"],
                  ["입금액", `${amount.toLocaleString()}원 (${planLabel} ${cycleLabel})`],
                ].map(([k, v]) => (
                  <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
                    <span style={{ color: "#9ca3af" }}>{k}</span>
                    <span style={{ fontWeight: 700, color: k === "입금액" ? "#2563eb" : "#374151" }}>{v}</span>
                  </div>
                ))}
              </div>
              <label style={labelStyle}>입금자명</label>
              <input type="text" placeholder="입금자 성함을 정확히 입력해 주세요" value={depositorName}
                onChange={e => setDepositorName(e.target.value)} style={{ ...inputStyle, marginBottom: 12 }} />
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 14, lineHeight: 1.7 }}>
                신청 후 입금 확인까지 1~2 영업일 소요됩니다. 확인 즉시 서비스가 활성화됩니다.
              </div>
              <button onClick={handleTransferRequest} disabled={saving} style={{
                width: "100%", padding: "13px 0", background: "#f8faff", color: "#374151",
                border: "1px solid #e5e7eb", borderRadius: 10, fontSize: 14, fontWeight: 700,
                cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.7 : 1
              }}>{saving ? "신청 중..." : "계좌이체 신청하기"}</button>
            </>
          )}
        </div>
      )}
    </>
  );

  if (loading) return <div style={{ padding: 40, textAlign: "center", color: "#9ca3af" }}>로딩 중...</div>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>

      {/* 결제 완료 팝업 */}
      {successResult && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", border: "1px solid #f0f0f0", borderRadius: 16, padding: 32, maxWidth: 380, width: "90%", textAlign: "center", fontFamily: "inherit" }}>
            <div style={{ width: 60, height: 60, background: "#dcfce7", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 28 }}>✅</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#111", marginBottom: 6 }}>결제가 완료됐습니다</div>
            <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 24 }}>서비스가 즉시 활성화되었습니다.</div>
            <div style={{ background: "#f8faff", borderRadius: 10, padding: 16, marginBottom: 20, textAlign: "left", lineHeight: 2.2 }}>
              {[
                ["플랜", `${successResult.plan} ${successResult.cycle}`],
                ["결제 금액", `${successResult.amount.toLocaleString()}원`],
                ["만료일", successResult.end_date],
                ["결제 수단", successResult.method],
              ].map(([k, v]) => (
                <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
                  <span style={{ color: "#9ca3af" }}>{k}</span>
                  <span style={{ fontWeight: 700, color: k === "결제 금액" ? "#2563eb" : "#374151" }}>{v}</span>
                </div>
              ))}
            </div>
            <button onClick={() => setSuccessResult(null)} style={{
              width: "100%", padding: "13px 0", background: "#2563eb", color: "#fff", border: "none",
              borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: "pointer"
            }}>확인</button>
          </div>
        </div>
      )}

      {/* 현재 구독 현황 */}
      <div style={{ ...cardStyle }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 16 }}>현재 구독 현황</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
          {[
            ["플랜", { TRIAL: "체험판", BASIC: "베이직", PRO: "프로" }[status?.plan] || status?.plan || "-"],
            ["상태", STATUS_LABELS[curStatus] || curStatus],
            ["만료일", status?.subscription_end ? (status?.subscription_status === "TRIAL" ? status.subscription_end + " (체험)" : status.subscription_end) : "미설정"],
          ].map(([k, v]) => (
            <div key={k} style={{ background: "#f8faff", borderRadius: 8, padding: "14px 16px" }}>
              <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 6 }}>{k}</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: k === "상태" ? (STATUS_COLORS[curStatus] || "#374151") : "#374151" }}>{v}</div>
            </div>
          ))}
        </div>
        {status?.days_left !== null && status?.days_left !== undefined && status.days_left <= 30 && curStatus === "ACTIVE" && (
          <div style={{ marginTop: 12, fontSize: 12, color: status.days_left <= 7 ? "#ef4444" : "#f59e0b", fontWeight: 600 }}>
            {status.days_left <= 0 ? "⚠️ 이용권이 만료되었습니다. 갱신이 필요합니다." : `⚠️ ${status.days_left}일 후 만료됩니다.`}
          </div>
        )}

        {/* ACTIVE 상태 버튼 */}
        {curStatus === "ACTIVE" && (
          <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
            <button onClick={() => { const c = mode === "change_plan" ? "default" : "change_plan"; setMode(c); if (c === "change_plan") setSelectedPlan(status?.plan === "PRO" ? "BASIC" : "PRO"); setTransferResult(null); }} style={{
              flex: 1, padding: "11px 0", border: "1px solid #2563eb", borderRadius: 10,
              fontSize: 13, fontWeight: 700, color: "#2563eb", background: mode === "change_plan" ? "#eff6ff" : "#fff", cursor: "pointer"
            }}>플랜 변경</button>
            <button onClick={() => { const r = mode === "renew" ? "default" : "renew"; setMode(r); if (r === "renew" && (status?.plan === "PRO" || status?.plan === "BASIC")) setSelectedPlan(status.plan); setTransferResult(null); }} style={{
              flex: 1, padding: "11px 0", border: "none", borderRadius: 10,
              fontSize: 13, fontWeight: 700, color: "#fff", background: "#2563eb", cursor: "pointer"
            }}>구독 연장</button>
          </div>
        )}
      </div>

      {/* 정지/해지 상태 */}
      {isSuspended && (
        <div style={{ ...cardStyle, textAlign: "center", padding: "40px 24px" }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#374151", marginBottom: 8 }}>서비스가 정지되었습니다</div>
          <div style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.8, marginBottom: 24 }}>
            이용권 만료 또는 기타 사유로 서비스가 정지되었습니다.<br/>
            재개를 원하시면 고객센터로 문의해 주세요.
          </div>
          <div style={{ background: "#f3e8ff", border: "1px solid #d8b4fe", borderRadius: 10, padding: "14px 24px", fontSize: 15, fontWeight: 700, color: "#7c3aed", display: "inline-block" }}>
            고객센터: 02-6672-7942
          </div>
          <div style={{ marginTop: 12, fontSize: 12, color: "#9ca3af" }}>운영시간: 매일 10:00 – 20:00</div>
        </div>
      )}

      {/* 만료 경고 배너 */}
      {(curStatus === "EXPIRED" || curStatus === "GRACE") && (
        <div style={{ background: "#fee2e2", border: "1px solid #ef4444", borderRadius: 10, padding: "14px 18px", marginBottom: 16, fontSize: 13, color: "#991b1b", fontWeight: 600 }}>
          ⚠️ 이용권이 만료되었습니다. 갱신하시면 즉시 서비스가 재개됩니다.
        </div>
      )}

      {/* TRIAL / EXPIRED / GRACE → 구독 신청/갱신 폼 */}
      {(curStatus === "TRIAL" || curStatus === "EXPIRED" || curStatus === "GRACE") && (
        PaymentSection({
          title: curStatus === "TRIAL" ? "구독 신청" : "구독 갱신",
          borderColor: curStatus === "TRIAL" ? "#2563eb" : "#ef4444",
        })
      )}

      {/* ACTIVE + 플랜 변경 */}
      {curStatus === "ACTIVE" && mode === "change_plan" && (
        PaymentSection({ title: "플랜 변경", borderColor: "#2563eb", showChangeBadge: true })
      )}

      {/* ACTIVE + 구독 연장 */}
      {curStatus === "ACTIVE" && mode === "renew" && (
        PaymentSection({ title: "구독 연장", borderColor: "#10b981" })
      )}
    </div>
  );
};


// ============ 헤이비서 이용가이드 모달 ============
function GuideModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, width: "min(1040px, 96vw)", height: "92vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderBottom: "1px solid #eef1f6", flexShrink: 0 }}>
          <div style={{ fontSize: 16, fontWeight: 800, color: "#14203a" }}>📘 헤이비서 이용가이드</div>
          <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
            <a href="/guide.html" target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, fontWeight: 600, color: "#2563eb", textDecoration: "none" }}>새 창으로 열기 ↗</a>
            <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 24, cursor: "pointer", color: "#9ca3af", lineHeight: 1 }}>×</button>
          </div>
        </div>
        <iframe src="/guide.html" title="헤이비서 이용가이드" style={{ flex: 1, width: "100%", border: "none" }} />
        <div style={{ padding: "10px 20px", borderTop: "1px solid #eef1f6", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
          <button onClick={onClose} style={{ padding: "9px 20px", borderRadius: 9, border: "none", background: "#2563eb", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>닫기</button>
        </div>
      </div>
    </div>
  );
}

const SettingsPage = ({ token, addToast, tab, setTab, onOpenGuide }) => {
  const [saving, setSaving] = useState(false);
  const [tenantId, setTenantId] = useState(null);
  const [form, setForm] = useState({
    name: "", business_number: "", owner_name: "", phone: "", address: "", logo_image: "",
    business_hours: JSON.stringify({
      mon: { open: "09:00", close: "22:00", closed: false },
      tue: { open: "09:00", close: "22:00", closed: false },
      wed: { open: "09:00", close: "22:00", closed: false },
      thu: { open: "09:00", close: "22:00", closed: false },
      fri: { open: "09:00", close: "22:00", closed: false },
      sat: { open: "09:00", close: "18:00", closed: false },
      sun: { open: "09:00", close: "18:00", closed: true },
    }),
    holidays: "",
    refund_policy: "",
    app_contract_template_id: null,
    payment_methods: JSON.stringify({ card: true, cash: true, transfer: true }),
    bank_account: "",
    expiry_alert_days: 7,
    alert_time: "10:00",
  });
  const [hold, setHold] = useState({ exclude_categories: [], all_categories: [], default_holding_count: 2, default_holding_days: 30 });
  // 회원앱 자체 결제 후 자동 발송할 계약서 양식 선택용
  const [contractTemplates, setContractTemplates] = useState([]);
  useEffect(() => {
    if (!token) return;
    api("/contract/template/list", {}, token)
      .then(d => setContractTemplates(Array.isArray(d) ? d.filter(x => x.is_active !== false) : []))
      .catch(() => {});
  }, [token]);
  const [savingHold, setSavingHold] = useState(false);

  useEffect(() => {
    if (!token) return;
    const payload = JSON.parse(atob(token.split('.')[1]));
    setTenantId(payload.tenant_id);
    fetch(`${API_BASE}/tenant/${payload.tenant_id}/settings`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => setForm(f => ({ ...f, ...d })));
  }, [token]);

  const save = async () => {
    setSaving(true);
    await fetch(`${API_BASE}/tenant/${tenantId}/settings`, {
      method: "PUT", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(form)
    });
    setSaving(false);
    addToast("저장되었습니다.");
  };

  useEffect(() => {
    if (!token) return;
    fetch(`${API_BASE}/holding/settings`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => setHold(h => ({ ...h, ...d }))).catch(() => {});
  }, [token]);

  const saveHold = async () => {
    setSavingHold(true);
    try {
      await fetch(`${API_BASE}/holding/settings`, {
        method: "PUT", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          exclude_categories: hold.exclude_categories || [],
          default_holding_count: Number(hold.default_holding_count) || 0,
          default_holding_days: Number(hold.default_holding_days) || 0,
        })
      });
      addToast("홀딩 설정이 저장되었습니다.");
    } catch (e) { addToast("저장 실패: " + e.message, "error"); }
    setSavingHold(false);
  };

 const bh = (() => { 
    try { 
      const parsed = JSON.parse(form.business_hours); 
      return (parsed && typeof parsed === 'object') ? parsed : {}; 
    } catch { return {}; } 
  })();
  const pm = (() => { try { return JSON.parse(form.payment_methods); } catch { return {}; } })();
  const dayLabels = { mon:"월", tue:"화", wed:"수", thu:"목", fri:"금", sat:"토", sun:"일" };

  const tabs = [
    { id: "basic", label: "기본 정보" },
    { id: "hours", label: "운영 설정" },
    { id: "payment", label: "결제 설정" },
    { id: "alert", label: "알림 설정" },
    { id: "permissions", label: "권한 관리" },
    { id: "subscription", label: "구독 관리" },
    { id: "holding", label: "홀딩 설정" },
    { id: "account", label: "계정 설정" },
  ];

  return (
    <div style={{ padding: "32px 40px", maxWidth: 960 }}>
      <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 24 }}>설정</div>

      {/* 탭 */}
      <div style={{ display: "flex", gap: 2, marginBottom: 28, borderBottom: "1px solid #f0f0f0", paddingBottom: 0 }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            background: "none", border: "none", padding: "10px 16px", fontSize: 13, fontWeight: tab === t.id ? 700 : 400,
            color: tab === t.id ? "#2563eb" : "#6b7280", cursor: "pointer",
            borderBottom: tab === t.id ? "2px solid #2563eb" : "2px solid transparent", marginBottom: -1,
            whiteSpace: "nowrap"   // 탭 글자가 두 줄로 깨지지 않게
          }}>{t.label}</button>
        ))}
      </div>

      {/* 기본 정보 */}
      {tab === "basic" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <button type="button" onClick={onOpenGuide}
            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "16px 18px", borderRadius: 12, border: "1px solid #dbe6fb", background: "linear-gradient(135deg, #f0f6ff, #eaf2fe)", cursor: "pointer", textAlign: "left" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: 22 }}>📘</span>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#14203a" }}>헤이비서 이용가이드</div>
                <div style={{ fontSize: 12, color: "#5c6883", marginTop: 2 }}>상품·회원 등록부터 예약·결제·출입까지 사용법을 확인하세요.</div>
              </div>
            </div>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#2563eb", whiteSpace: "nowrap" }}>보기 →</span>
          </button>
          {[
            ["시설명", "name", "text"],
            ["사업자번호", "business_number", "text"],
            ["대표자명", "owner_name", "text"],
            ["연락처", "phone", "text"],
            ["주소", "address", "text"],
          ].map(([label, key, type]) => (
            <div key={key}>
              <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>{label}</div>
              <input value={form[key] || ""} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                type={type} style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none" }} />
            </div>
          ))}
        </div>
      )}

      {/* 홀딩 설정 */}
      {tab === "holding" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 22 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 4 }}>홀딩 제외 카테고리</div>
            <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 12 }}>켠 카테고리의 상품은 홀딩 신청 시 정지되지 않습니다. (예: 락커·운동복)</div>
            <div style={{ border: "1px solid #f0f0f0", borderRadius: 10, overflow: "hidden" }}>
              {(hold.all_categories && hold.all_categories.length ? hold.all_categories : ["membership","pt","gx","locker","clothes","general"]).map(c => {
                const labels = { membership:"회원권", pt:"PT(개인)", gx:"그룹수업", locker:"락커", clothes:"운동복", general:"일반" };
                const on = (hold.exclude_categories || []).includes(c);
                return (
                  <div key={c} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 14px", borderBottom:"1px solid #f9fafb" }}>
                    <span style={{ fontSize: 14, color:"#374151" }}>{labels[c] || c}</span>
                    <button onClick={() => setHold(h => ({ ...h, exclude_categories: on ? (h.exclude_categories||[]).filter(x=>x!==c) : [ ...(h.exclude_categories||[]), c ] }))}
                      style={{ width: 44, height: 24, borderRadius: 12, border:"none", cursor:"pointer", background: on ? "#2563eb" : "#d1d5db", position:"relative", flexShrink:0 }}>
                      <span style={{ position:"absolute", top: 2, left: on ? 22 : 2, width: 20, height: 20, borderRadius:"50%", background:"#fff" }} />
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>기본 홀딩 한도</div>
            <div style={{ fontSize: 11, color:"#9ca3af", marginBottom: 10 }}>홀딩 횟수·일수는 보통 상품마다 설정합니다. 아래는 상품에 값이 없을 때만 적용되는 가맹점 기본값이에요.</div>
            <div style={{ display:"flex", gap: 12 }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:12, fontWeight:600, color:"#374151", marginBottom:6 }}>기본 횟수</div>
                <input type="number" value={hold.default_holding_count} onChange={e=>setHold(h=>({...h, default_holding_count: e.target.value}))} style={{ width:"100%", border:"1px solid #e5e7eb", borderRadius:8, padding:"10px 12px", fontSize:14, outline:"none" }} />
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:12, fontWeight:600, color:"#374151", marginBottom:6 }}>기본 일수</div>
                <input type="number" value={hold.default_holding_days} onChange={e=>setHold(h=>({...h, default_holding_days: e.target.value}))} style={{ width:"100%", border:"1px solid #e5e7eb", borderRadius:8, padding:"10px 12px", fontSize:14, outline:"none" }} />
              </div>
            </div>
          </div>
          <button onClick={saveHold} disabled={savingHold} style={{ background:"#2563eb", color:"#fff", border:"none", borderRadius:8, padding:"12px", fontSize:14, fontWeight:700, cursor:"pointer", alignSelf:"flex-start", paddingLeft:24, paddingRight:24 }}>
            {savingHold ? "저장 중..." : "홀딩 설정 저장"}
          </button>
        </div>
      )}


            {/* 출석패드 바로가기 */}
      {tab === "basic" && (
        <div style={{ marginTop: 8, padding: "20px 24px", background: "#f8faff", borderRadius: 12, border: "1px solid #dbeafe" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <span style={{ fontSize: 20 }}>🖥️</span>
            <span style={{ fontSize: 14, fontWeight: 700, color: "#1d4ed8" }}>출석패드 바로가기</span>
          </div>
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 14, lineHeight: 1.8 }}>
            태블릿이나 PC에서 출석패드를 바로가기로 등록하는 방법:<br/>
            <span style={{ color: "#374151", fontWeight: 600 }}>① 아래 버튼 클릭 → 출석패드 새 탭으로 열림</span><br/>
            <span style={{ color: "#374151", fontWeight: 600 }}>② 크롬 우측 상단 ⋮ → 저장 및 공유 → 바로가기 만들기</span><br/>
            <span style={{ color: "#374151", fontWeight: 600 }}>③ 바탕화면에 아이콘 생성 완료</span>
          </div>
          <button onClick={async () => {
            try {
              const payload = JSON.parse(atob(token.split('.')[1]));
              const tid = payload.tenant_id;
              const res = await fetch(`${API_BASE}/tenant/${tid}/kiosk-token`, { headers: { Authorization: `Bearer ${token}` } });
              const d = await res.json();
              if (d.kiosk_token) {
                window.open(`${window.location.origin}/kiosk?tid=${tid}&token=${d.kiosk_token}`, '_blank');
              } else {
                alert('키오스크 토큰을 불러올 수 없습니다.');
              }
            } catch {
              alert('오류가 발생했습니다.');
            }
          }} style={{
            display: "flex", alignItems: "center", gap: 8,
            padding: "11px 22px", borderRadius: 10, border: "none",
            background: "#2563eb", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer"
          }}>
            🖥️ 출석패드 열기
          </button>
        </div>
      )}

    {/* 운영 설정 */}
      {tab === "hours" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>영업시간</div>
          {Object.entries(dayLabels).map(([key, label]) => {
            const day = (bh[key] && typeof bh[key] === 'object') ? bh[key] : { open: "09:00", close: "22:00", closed: false };
            return (
              <div key={key} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", background: "#f8faff", borderRadius: 10 }}>
                <div style={{ width: 24, fontSize: 13, fontWeight: 700, color: ["sat","sun"].includes(key) ? "#ef4444" : "#374151" }}>{label}</div>
                <div style={{ opacity: day.closed ? 0.4 : 1, pointerEvents: day.closed ? "none" : "auto" }}>
                  <TimePicker
                    value={day.open}
                    onChange={v => { const nb = { ...bh, [key]: { ...day, open: v } }; setForm(f => ({ ...f, business_hours: JSON.stringify(nb) })); }}
                  />
                </div>
                <span style={{ color: "#9ca3af" }}>~</span>
                <div style={{ opacity: day.closed ? 0.4 : 1, pointerEvents: day.closed ? "none" : "auto" }}>
                  <TimePicker
                    value={day.close}
                    onChange={v => { const nb = { ...bh, [key]: { ...day, close: v } }; setForm(f => ({ ...f, business_hours: JSON.stringify(nb) })); }}
                  />
                </div>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "#6b7280", marginLeft: "auto", cursor: "pointer" }}>
                  <input type="checkbox" checked={day.closed}
                    onChange={e => { const nb = { ...bh, [key]: { ...day, closed: e.target.checked } }; setForm(f => ({ ...f, business_hours: JSON.stringify(nb) })); }} />
                  휴무
                </label>
              </div>
            );
          })}
          {/* 예약 취소 정책 (가맹점 기본값) */}
          <div style={{ marginTop: 16, padding: "16px 18px", background: "#f8faff", borderRadius: 10 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>
              예약 취소 정책 (가맹점 기본값)
            </div>
            <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 14 }}>
              모든 수업에 자동 적용돼요. 수업별로 다르게 설정도 가능해요.
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
              <span style={{ fontSize: 13, color: "#374151" }}>수업 시작</span>
              <input
                type="number"
                min="0"
                value={form.default_cancel_cutoff_value ?? 24}
                onChange={e => setForm(f => ({ ...f, default_cancel_cutoff_value: e.target.value === "" ? null : parseInt(e.target.value) }))}
                style={{ width: 64, border: "1px solid #e5e7eb", borderRadius: 8, padding: "6px 10px", fontSize: 13, outline: "none", textAlign: "center" }}
              />
              <select
                value={form.default_cancel_cutoff_unit || "HOUR"}
                onChange={e => setForm(f => ({ ...f, default_cancel_cutoff_unit: e.target.value }))}
                style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: "6px 10px", fontSize: 13, outline: "none", background: "white" }}
              >
                <option value="HOUR">시간</option>
                <option value="DAY">일</option>
                <option value="WEEK">주</option>
              </select>
              <span style={{ fontSize: 13, color: "#374151" }}>전까지 무료 취소 가능</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <span style={{ fontSize: 13, color: "#374151" }}>이후 취소 시</span>
              <input
                type="number"
                min="0"
                value={form.default_deduction_count ?? 1}
                onChange={e => setForm(f => ({ ...f, default_deduction_count: e.target.value === "" ? 0 : parseInt(e.target.value) }))}
                style={{ width: 64, border: "1px solid #e5e7eb", borderRadius: 8, padding: "6px 10px", fontSize: 13, outline: "none", textAlign: "center" }}
              />
              <span style={{ fontSize: 13, color: "#374151" }}>회 차감 (노쇼 포함)</span>
            </div>
          </div>

          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>공휴일/휴무일 메모</div>
            <textarea value={form.holidays || ""} onChange={e => setForm(f => ({ ...f, holidays: e.target.value }))}
              placeholder="예: 매월 마지막 주 일요일 휴무"
              style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", resize: "vertical", minHeight: 80 }} />
          </div>

          <div style={{ marginTop: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>환불 · 중도해지 규정</div>
            <textarea value={form.refund_policy || ""} onChange={e => setForm(f => ({ ...f, refund_policy: e.target.value }))}
              placeholder={"예)\n· 이용 시작 전 취소 시 전액 환불됩니다.\n· 이용 시작 후에는 이용한 기간(횟수)을 제외한 잔액에서 위약금 10%를 공제하고 환불합니다.\n· 이벤트·할인 상품은 정상가 기준으로 정산됩니다."}
              style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", resize: "vertical", minHeight: 120, lineHeight: 1.6 }} />
            <div style={{ fontSize: 11, color: "#6b7280", marginTop: 6, lineHeight: 1.6 }}>
              회원이 <b>회원앱에서 직접 결제할 때</b> 이 내용을 보고 동의해야 결제가 진행됩니다.
              비워두면 일반 안내문이 대신 표시되니, 매장 규정을 직접 적어두시는 걸 권합니다.
            </div>
          </div>

          <div style={{ marginTop: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>회원앱 결제 시 자동 발송할 계약서</div>
            <select
              value={form.app_contract_template_id || ""}
              onChange={e => setForm(f => ({ ...f, app_contract_template_id: e.target.value ? parseInt(e.target.value) : null }))}
              style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 13, outline: "none", background: "#fff", cursor: "pointer" }}>
              <option value="">사용 안 함 (계약서 발송 안 함)</option>
              {contractTemplates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
            <div style={{ fontSize: 11, color: "#6b7280", marginTop: 6, lineHeight: 1.6 }}>
              회원이 회원앱에서 직접 결제를 마치면 이 양식으로 계약서가 자동 생성되어 회원에게 서명 요청이 갑니다.
              회원은 앱 <b>마이 → 내 계약서</b>에서 확인·서명합니다. 양식은 <b>전자계약</b> 메뉴에서 만듭니다.
            </div>
          </div>
        </div>
      )}

      {/* 결제 설정 */}
      {tab === "payment" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 4 }}>사용할 결제 수단</div>
          {[
            ["card", "카드"],
            ["cash", "현금"],
            ["transfer", "계좌이체"],
          ].map(([key, label]) => (
            <label key={key} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 16px", background: "#f8faff", borderRadius: 10, cursor: "pointer" }}>
              <input type="checkbox" checked={pm[key] || false}
                onChange={e => { const np = { ...pm, [key]: e.target.checked }; setForm(f => ({ ...f, payment_methods: JSON.stringify(np) })); }}
                style={{ width: 16, height: 16 }} />
              <span style={{ fontSize: 14, fontWeight: 500 }}>{label}</span>
            </label>
          ))}
          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>계좌이체 계좌번호</div>
            <input value={form.bank_account || ""} onChange={e => setForm(f => ({ ...f, bank_account: e.target.value }))}
              placeholder="예: 국민은행 123-456-789012 홍길동"
              style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none" }} />
          </div>
        </div>
      )}

      {/* 알림 설정 */}
      {tab === "alert" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>회원권 만료 알림 (며칠 전)</div>
            <input type="number" value={form.expiry_alert_days || 7} min={1} max={30}
              onChange={e => setForm(f => ({ ...f, expiry_alert_days: parseInt(e.target.value) }))}
              style={{ width: 120, border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none" }} />
            <span style={{ fontSize: 13, color: "#6b7280", marginLeft: 8 }}>일 전 문자 발송</span>
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 6 }}>알림 발송 시간</div>
            <TimePicker value={form.alert_time || "10:00"} onChange={v => setForm(f => ({ ...f, alert_time: v }))}
              style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none" }} />
          </div>
        </div>
      )}

{/* 권한 관리 */}
      {tab === "permissions" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {["MANAGER", "TRAINER", "RECEPTION"].map(r => {
            const rp = (() => { try { return JSON.parse(form.role_permissions || "{}"); } catch { return {}; } })();
            const rolePerms = rp[r] || {};
            const roleLabel = { MANAGER: "관리자", TRAINER: "트레이너", RECEPTION: "리셉션" }[r];
            const menuItems = [
              { id: "dashboard", label: "대시보드" },
              { id: "classes", label: "수업관리" },
              { id: "members", label: "회원관리" },
              { id: "consult", label: "상담관리" },
              { id: "payment", label: "결제/환불" },
              { id: "products", label: "상품관리" },
              { id: "lockers", label: "락커관리" },
              { id: "attendance", label: "출입관리" },
              { id: "staff", label: "직원관리" },
              { id: "notices", label: "앱 푸시" },
              { id: "contract", label: "전자계약" },
              // 끄면 '담당 회원'의 계약서만 보임 (회원관리와 동일 판정). 매니저는 기본 켜짐.
              { id: "contract_all", label: "전자계약 전체 조회" },
              { id: "settings", label: "설정" },
            ];
            return (
              <div key={r} style={{ background: "#f8faff", borderRadius: 12, padding: 20, border: "1px solid #e0e7ff" }}>
                <div style={{ fontSize: 14, fontWeight: 800, color: "#374151", marginBottom: 14 }}>🔑 {roleLabel}</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                  {menuItems.map(m => (
                    <label key={m.id} style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13 }}>
                      <input type="checkbox"
                        checked={m.id === "contract_all"
                          ? (rolePerms[m.id] ?? (r === "MANAGER"))
                          : (rolePerms[m.id] !== false)}
                        onChange={e => {
                          const newRp = { ...rp, [r]: { ...rolePerms, [m.id]: e.target.checked } };
                          setForm(f => ({ ...f, role_permissions: JSON.stringify(newRp) }));
                        }}
                        style={{ width: 15, height: 15 }} />
                      {m.label}
                    </label>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* 계정 설정 */}

      {/* 구독 관리 탭 */}
      {tab === "subscription" && (
        <SubscriptionTab token={token} addToast={addToast} />
      )}

      {tab === "account" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ padding: 16, background: "#fff7ed", borderRadius: 10, border: "1px solid #fed7aa", fontSize: 13, color: "#92400e" }}>
            비밀번호 변경 기능은 준비 중입니다.
          </div>
        </div>
      )}

      {/* 저장 버튼 */}
      {tab !== "account" && tab !== "subscription" && (
        <button onClick={save} disabled={saving} style={{
          marginTop: 28, background: "#2563eb", color: "#fff", border: "none", borderRadius: 10,
          padding: "13px 32px", fontSize: 14, fontWeight: 700, cursor: "pointer", opacity: saving ? 0.7 : 1
        }}>{saving ? "저장 중..." : "저장하기"}</button>
      )}
    </div>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// APP ROOT
// ════════════════════════════════════════════════════════════════════════════
// ============ 카메라 촬영 모달 ============
function CameraCaptureModal({ isOpen, onClose, onCapture }) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [error, setError] = useState(null);
  const [facingMode, setFacingMode] = useState('user');

  useEffect(() => {
    if (!isOpen) return;

    async function startCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: facingMode, width: { ideal: 1920 }, height: { ideal: 1080 } },
          audio: false
        });
        streamRef.current = stream;
        if (videoRef.current) videoRef.current.srcObject = stream;
        setError(null);
      } catch (err) {
        console.error("카메라 접근 실패:", err);
        setError("카메라 접근이 거부되었거나 사용 가능한 카메라가 없습니다. 브라우저 권한을 확인해주세요.");
      }
    }
    startCamera();

    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
    };
  }, [isOpen, facingMode]);

  const handleCapture = () => {
    const video = videoRef.current;
    if (!video || !video.videoWidth) return;
    const vw = video.videoWidth, vh = video.videoHeight;
    // 가이드 원 영역(가운데 세로형)만 잘라서 확대 → 얼굴이 크게 담겨 GREET 얼굴인식 통과
    const cropH = Math.round(vh * 0.85);
    const cropW = Math.round(cropH * 0.75);        // 3:4 세로 비율
    const sx = Math.round((vw - cropW) / 2);
    const sy = Math.round((vh - cropH) / 2);
    const outW = Math.max(cropW, 800);             // 최소 800px 보장
    const scale = outW / cropW;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(cropW * scale);
    canvas.height = Math.round(cropH * scale);
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, sx, sy, cropW, cropH, 0, 0, canvas.width, canvas.height);
    setCapturedImage(canvas.toDataURL('image/jpeg', 0.92));
  };

  const handleRetake = () => setCapturedImage(null);

  const handleConfirm = async () => {
    if (!capturedImage) return;
    const res = await fetch(capturedImage);
    const blob = await res.blob();
    const file = new File([blob], `capture_${Date.now()}.jpg`, { type: 'image/jpeg' });
    onCapture(file);
    handleClose();
  };

  const handleClose = () => {
    setCapturedImage(null);
    setError(null);
    onClose();
  };

  const toggleCamera = () => {
    setFacingMode(prev => prev === 'user' ? 'environment' : 'user');
    setCapturedImage(null);
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.7)', zIndex: 2000,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#fff', borderRadius: 12, padding: 20,
        width: 520, maxWidth: '90vw', maxHeight: '90vh',
        display: 'flex', flexDirection: 'column'
      }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16
        }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: '#111' }}>프로필 사진 촬영</div>
          <button onClick={handleClose} style={{
            background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#9ca3af'
          }}>×</button>
        </div>

        <div style={{
          background: '#000', borderRadius: 8, overflow: 'hidden', position: 'relative',
          aspectRatio: '4/3', display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 16, minHeight: 300
        }}>
          {error ? (
            <div style={{ color: '#fff', padding: 20, textAlign: 'center', fontSize: 13 }}>{error}</div>
          ) : capturedImage ? (
            <img src={capturedImage} alt="촬영된 사진"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <video ref={videoRef} autoPlay playsInline muted
              style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          )}
          {!capturedImage && !error && (
            <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
              <div style={{
                position: 'absolute', left: '50%', top: '45%', transform: 'translate(-50%,-50%)',
                width: '52%', height: '82%', border: '3px dashed rgba(255,255,255,0.95)',
                borderRadius: '50%', boxShadow: '0 0 0 9999px rgba(0,0,0,0.35)'
              }} />
              <div style={{
                position: 'absolute', left: 0, right: 0, bottom: 8, textAlign: 'center',
                color: '#fff', fontSize: 13, fontWeight: 700, textShadow: '0 1px 4px rgba(0,0,0,0.9)'
              }}>얼굴을 원 안에 꽉 차게 맞춰주세요</div>
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          {!capturedImage ? (
            <>
              <button onClick={toggleCamera} style={{
                padding: '10px 16px', borderRadius: 8, border: '1px solid #d1d5db',
                background: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500
              }}>🔄 카메라 전환</button>
              <button onClick={handleCapture} disabled={!!error} style={{
                padding: '10px 28px', borderRadius: 8, border: 'none',
                background: error ? '#9ca3af' : '#2563eb', color: '#fff',
                cursor: error ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600
              }}>📷 촬영</button>
            </>
          ) : (
            <>
              <button onClick={handleRetake} style={{
                padding: '10px 16px', borderRadius: 8, border: '1px solid #d1d5db',
                background: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500
              }}>다시 찍기</button>
              <button onClick={handleConfirm} style={{
                padding: '10px 28px', borderRadius: 8, border: 'none',
                background: '#22c55e', color: '#fff', cursor: 'pointer',
                fontSize: 14, fontWeight: 600
              }}>✓ 이 사진 사용</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}


// ════════════════════════════════════════════════════════════════════════════
// KIOSK PAGE — /kiosk?tid=X&token=Y
// JWT 불필요, kiosk_token으로 가맹점 인증
// URL 예시: https://heybiseo.ai.kr/kiosk?tid=2&token=abc123...
// ════════════════════════════════════════════════════════════════════════════

const KioskPage = () => {
  const params = new URLSearchParams(window.location.search);
  const tid = params.get("tid") || "1";
  const kioskToken = params.get("token") || "";

  const [input, setInput] = useState("");
  const [phase, setPhase] = useState("idle"); // idle | loading | success | error | error_membership
  const [result, setResult] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [resetTimer, setResetTimer] = useState(null);

  const PAD = [
    ["7","8","9"],
    ["4","5","6"],
    ["1","2","3"],
    ["←","0","입장"],
  ];

  // 키보드 입력 지원
  useEffect(() => {
    const handler = (e) => {
      if (phase !== "idle") return;
      if (e.key >= "0" && e.key <= "9") handleKey(e.key);
      if (e.key === "Backspace") handleKey("←");
      if (e.key === "Enter") handleKey("입장");
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input, phase]);

  const scheduleReset = (ms = 4000) => {
    if (resetTimer) clearTimeout(resetTimer);
    const t = setTimeout(() => {
      setPhase("idle");
      setInput("");
      setResult(null);
      setErrorMsg("");
    }, ms);
    setResetTimer(t);
  };

  const forceEntry = async () => {
    setPhase("loading");
    try {
      const res = await fetch(`${API_BASE}/attendance/kiosk-checkin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          member_number: input,
          tenant_id: parseInt(tid),
          kiosk_token: kioskToken,
          force_entry: true,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        setErrorMsg(data.detail || "입장 처리에 실패했습니다.");
        setPhase("error");
        scheduleReset(4000);
        return;
      }
      setResult(data);
      setPhase("success");
      scheduleReset(4000);
    } catch {
      setErrorMsg("서버 연결 오류입니다.");
      setPhase("error");
      scheduleReset(4000);
    }
  };

  const handleKey = (key) => {
    if (phase !== "idle") return;
    if (key === "←") {
      setInput(p => p.slice(0, -1));
    } else if (key === "입장") {
      if (input.length < 1) return;
      submitCheckin(input);
    } else {
      if (input.length >= 10) return;
      setInput(p => p + key);
    }
  };

  const submitCheckin = async (memberNumber) => {
    setPhase("loading");
    try {
      const res = await fetch(`${API_BASE}/attendance/kiosk-checkin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          member_number: memberNumber,
          tenant_id: parseInt(tid),
          kiosk_token: kioskToken,
        }),
      });
      const data = await res.json();
      if (res.status === 409) {
        // 홀딩 중 안내 화면
        setResult({ member_name: data.member_name, member_number: memberNumber });
        setPhase("holding");
        // 자동 초기화는 하지 않음 — 버튼 누를 때까지 대기
        return;
      }
      if (!res.ok) {
        setErrorMsg(data.detail || "출석 처리에 실패했습니다.");
        setPhase("error");
        scheduleReset(4000);
        return;
      }
      if (!data.has_valid_membership) {
        setResult(data);
        setErrorMsg("유효한 회원권이 없습니다.\n프론트 데스크에 문의해 주세요.");
        setPhase("error_membership");
        scheduleReset(5000);
        return;
      }
      setResult(data);
      setPhase("success");
      scheduleReset(4000);
    } catch {
      setErrorMsg("서버 연결 오류입니다.\n잠시 후 다시 시도해 주세요.");
      setPhase("error");
      scheduleReset(4000);
    }
  };

  // 현재 시각
  const [clock, setClock] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setClock(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const timeStr = clock.toLocaleTimeString("ko-KR", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  const dateStr = clock.toLocaleDateString("ko-KR", { year: "numeric", month: "long", day: "numeric", weekday: "long" });

  // 가맹점 정보 (tenant_name, ad_image)
  const [kioskInfo, setKioskInfo] = useState({ tenant_name: "", ad_image_url: null });
  useEffect(() => {
    fetch(`${API_BASE}/tenant/${tid}/kiosk-info`)
      .then(r => r.json())
      .then(d => setKioskInfo(d))
      .catch(() => {});
  }, [tid]);

  // 입장 성공 시 도어벨 "띵동" + "○○○님 반갑습니다" 음성
  const playWelcome = (name) => {
    // 1) 띵동 차임 (Web Audio)
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (AC) {
        const ctx = new AC();
        if (ctx.state === "suspended") ctx.resume();
        const t0 = ctx.currentTime;
        const ding = (freq, start, dur) => {
          const o = ctx.createOscillator();
          const g = ctx.createGain();
          o.type = "sine";
          o.frequency.value = freq;
          o.connect(g); g.connect(ctx.destination);
          g.gain.setValueAtTime(0.0001, t0 + start);
          g.gain.exponentialRampToValueAtTime(0.6, t0 + start + 0.02);
          g.gain.exponentialRampToValueAtTime(0.0001, t0 + start + dur);
          o.start(t0 + start);
          o.stop(t0 + start + dur + 0.05);
        };
        ding(784.0, 0, 0.55);      // 딩 (G5)
        ding(587.33, 0.32, 0.75);  // 동 (D5)
        setTimeout(() => { try { ctx.close(); } catch (e) {} }, 1600);
      }
    } catch (e) {}
    // 2) 환영 음성 (한국어 TTS) — 띵동 뒤에
    try {
      const synth = window.speechSynthesis;
      if (synth) {
        setTimeout(() => {
          try {
            synth.cancel();
            const u = new SpeechSynthesisUtterance(`${name || "회원"}님 반갑습니다`);
            u.lang = "ko-KR";
            u.rate = 1.0;
            u.pitch = 1.05;
            synth.speak(u);
          } catch (e) {}
        }, 850);
      }
    } catch (e) {}
  };

  useEffect(() => {
    if (phase === "success" && result) {
      playWelcome(result.member_name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phase]);

  // ── 홀딩 화면 ──
  if (phase === "holding") {
    return (
      <div style={{
        position: "fixed", inset: 0,
        background: "linear-gradient(135deg, #78350f 0%, #d97706 100%)",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        fontFamily: "'Pretendard', -apple-system, sans-serif", color: "#fff",
        textAlign: "center", padding: 32
      }}>
        <div style={{ fontSize: 96, marginBottom: 24, lineHeight: 1 }}>⏸️</div>
        <div style={{ fontSize: 40, fontWeight: 900, marginBottom: 12 }}>홀딩 기간 중</div>
        <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 8, opacity: 0.9 }}>
          {result?.member_name} 회원님
        </div>
        <div style={{ fontSize: 17, opacity: 0.8, lineHeight: 1.8, marginBottom: 48 }}>
          현재 홀딩 처리 중입니다.<br />
          홀딩을 해제하고 입장하시려면<br />
          아래 버튼을 눌러주세요.
        </div>
        <div style={{ display: "flex", gap: 16 }}>
          <button
            onClick={() => { setPhase("idle"); setInput(""); setResult(null); }}
            style={{
              padding: "18px 40px", fontSize: 18, fontWeight: 700,
              borderRadius: 16, border: "2px solid rgba(255,255,255,0.5)",
              background: "rgba(255,255,255,0.15)", color: "#fff",
              cursor: "pointer", backdropFilter: "blur(10px)"
            }}
          >
            취소
          </button>
          <button
            onClick={forceEntry}
            style={{
              padding: "18px 48px", fontSize: 20, fontWeight: 900,
              borderRadius: 16, border: "none",
              background: "#fff", color: "#d97706",
              cursor: "pointer",
              boxShadow: "0 8px 24px rgba(0,0,0,0.2)"
            }}
          >
            🚪 입장하기
          </button>
        </div>
        <div style={{ marginTop: 32, fontSize: 13, opacity: 0.5 }}>
          아무것도 누르지 않으면 출석이 기록되지 않습니다
        </div>
      </div>
    );
  }

  // ── 성공 화면 ──
  if (phase === "success" && result) {
    const mainMs = result.memberships && result.memberships[0];
    return (
      <div style={{
        position: "fixed", inset: 0,
        background: "linear-gradient(135deg, #14532d 0%, #15803d 100%)",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        fontFamily: "'Pretendard', -apple-system, sans-serif", color: "#fff",
        textAlign: "center", padding: 32
      }}>
        <div style={{ fontSize: 96, marginBottom: 24, lineHeight: 1 }}>✅</div>
        <div style={{ fontSize: 48, fontWeight: 900, marginBottom: 12 }}>출석 완료!</div>
        <div style={{ fontSize: 32, fontWeight: 700, marginBottom: 6, opacity: 0.95 }}>
          {result.member_name} 회원님
        </div>
        <div style={{ fontSize: 18, opacity: 0.65, marginBottom: 40 }}>
          회원번호 {result.member_number}
        </div>
        {mainMs && (
          <div style={{
            background: "rgba(255,255,255,0.15)", borderRadius: 20,
            padding: "24px 48px", backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.25)"
          }}>
            <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 6 }}>{mainMs.name}</div>
            {mainMs.end_date && (
              <div style={{ fontSize: 15, opacity: 0.8 }}>만료일: {mainMs.end_date}</div>
            )}
            {mainMs.remaining_count != null && (
              <div style={{ fontSize: 15, opacity: 0.8 }}>잔여 횟수: {mainMs.remaining_count}회</div>
            )}
          </div>
        )}
        <div style={{ marginTop: 48, fontSize: 14, opacity: 0.45 }}>잠시 후 자동으로 초기화됩니다</div>
      </div>
    );
  }

  // ── 오류 화면 (회원 없음 / 회원권 만료) ──
  if ((phase === "error" || phase === "error_membership") && errorMsg) {
    const isMembershipError = phase === "error_membership";
    return (
      <div style={{
        position: "fixed", inset: 0,
        background: isMembershipError
          ? "linear-gradient(135deg, #78350f 0%, #b45309 100%)"
          : "linear-gradient(135deg, #7f1d1d 0%, #b91c1c 100%)",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        fontFamily: "'Pretendard', -apple-system, sans-serif", color: "#fff",
        textAlign: "center", padding: 32
      }}>
        <div style={{ fontSize: 96, marginBottom: 24, lineHeight: 1 }}>
          {isMembershipError ? "⚠️" : "❌"}
        </div>
        <div style={{ fontSize: 40, fontWeight: 900, marginBottom: 12 }}>
          {isMembershipError ? "회원권 만료" : "입장 불가"}
        </div>
        {isMembershipError && result && (
          <div style={{ fontSize: 26, fontWeight: 700, marginBottom: 8, opacity: 0.9 }}>
            {result.member_name} 회원님
          </div>
        )}
        <div style={{ fontSize: 18, opacity: 0.8, lineHeight: 1.8, whiteSpace: "pre-line" }}>
          {errorMsg}
        </div>
        <div style={{ marginTop: 48, fontSize: 14, opacity: 0.45 }}>잠시 후 자동으로 초기화됩니다</div>
      </div>
    );
  }

  // ── 메인 키오스크 화면 ──
  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "linear-gradient(135deg, #eff6ff 0%, #f0f9ff 100%)",
      display: "flex", fontFamily: "'Pretendard', -apple-system, sans-serif",
      overflow: "hidden"
    }}>
      {/* 좌측: 가맹점명 + 광고/시계 */}
      <div style={{
        flex: 1, display: "flex", flexDirection: "column",
        background: "#1a3a6b",
        color: "#fff", overflow: "hidden", position: "relative"
      }}>
        {/* 상단 가맹점명 */}
        <div style={{ padding: "28px 36px 0", flexShrink: 0 }}>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", letterSpacing: 1.5, marginBottom: 4 }}>POWERED BY HEYBISEO</div>
          <div style={{ fontSize: 24, fontWeight: 700, color: "#fff" }}>{kioskInfo.tenant_name || "헤이비서"}</div>
        </div>

        {/* 중앙: 광고 이미지 or 시계 */}
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "24px 36px" }}>
          {kioskInfo.ad_image_url ? (
            <img
              src={`${API_BASE.replace("/api", "")}${kioskInfo.ad_image_url}`}
              alt="광고"
              style={{ width: "100%", maxHeight: 340, objectFit: "contain", borderRadius: 16 }}
            />
          ) : (
            <div style={{
              background: "rgba(255,255,255,0.08)", borderRadius: 20,
              padding: "28px 40px", textAlign: "center",
              border: "1px solid rgba(255,255,255,0.15)", width: "100%"
            }}>
              <div style={{ fontSize: 56, fontWeight: 700, lineHeight: 1, marginBottom: 10, letterSpacing: -1 }}>{timeStr}</div>
              <div style={{ fontSize: 16, opacity: 0.65 }}>{dateStr}</div>
            </div>
          )}
        </div>

        {/* 하단 안내 */}
        <div style={{ padding: "0 36px 28px", textAlign: "center", flexShrink: 0 }}>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", lineHeight: 1.8 }}>
            회원번호를 입력하고 입장 버튼을 눌러주세요
          </div>
        </div>
      </div>

      {/* 우측: 키패드 (화면 절반) */}
      <div style={{
        flex: 1, display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        padding: "40px 44px", gap: 22, position: "relative"
      }}>
        {/* 로딩 오버레이 */}
        {phase === "loading" && (
          <div style={{
            position: "absolute", inset: 0, background: "rgba(255,255,255,0.65)",
            display: "flex", alignItems: "center", justifyContent: "center",
            borderRadius: 0, zIndex: 10
          }}>
            <div style={{ fontSize: 18, color: "#2563eb", fontWeight: 700 }}>처리 중...</div>
          </div>
        )}

        {/* 입력 디스플레이 */}
        <div style={{
          width: "100%", background: "#fff", borderRadius: 20,
          boxShadow: "0 4px 24px rgba(30,58,95,0.12)",
          border: "2px solid #dbeafe",
          padding: "22px 28px", minHeight: 86,
          display: "flex", alignItems: "center", justifyContent: "center",
          flexWrap: "wrap", gap: 6
        }}>
          {input
            ? input.split("").map((c, i) => (
                <span key={i} style={{ fontSize: 40, fontWeight: 800, color: "#1e3a5f", letterSpacing: 2 }}>{c}</span>
              ))
            : <span style={{ fontSize: 18, color: "#9ca3af", fontWeight: 400 }}>회원번호를 입력하세요</span>
          }
        </div>

        {/* 숫자 키패드 */}
        <div style={{
          display: "grid", gridTemplateColumns: "repeat(3, 1fr)",
          gridTemplateRows: "repeat(4, 1fr)", gap: 16, width: "100%", flex: 1
        }}>
          {PAD.flat().map((key) => {
            const isEnter = key === "입장";
            const isBack = key === "←";
            const press = () => handleKey(key);
            return (
              <button
                key={key}
                onClick={press}
                style={{
                  width: "100%", height: "100%", minHeight: 96,
                  borderRadius: 22,
                  border: "none",
                  fontSize: isEnter ? 30 : isBack ? 34 : 44,
                  fontWeight: 800,
                  cursor: "pointer",
                  background: isEnter
                    ? "linear-gradient(135deg, #1d4ed8, #2563eb)"
                    : isBack
                    ? "#f1f5f9"
                    : "#fff",
                  color: isEnter ? "#fff" : isBack ? "#64748b" : "#1e3a5f",
                  boxShadow: isEnter
                    ? "0 6px 20px rgba(37,99,235,0.40)"
                    : "0 2px 10px rgba(30,58,95,0.09)",
                  transition: "transform 0.08s",
                  userSelect: "none",
                  WebkitUserSelect: "none",
                  touchAction: "manipulation",
                }}
                onMouseDown={e => { e.currentTarget.style.transform = "scale(0.95)"; }}
                onMouseUp={e => { e.currentTarget.style.transform = "scale(1)"; }}
                onTouchStart={e => { e.currentTarget.style.transform = "scale(0.95)"; }}
                // 터치는 여기서만 처리하고 유령 클릭(중복 입력)을 막는다
                onTouchEnd={e => { e.preventDefault(); e.currentTarget.style.transform = "scale(1)"; press(); }}
              >
                {key}
              </button>
            );
          })}
        </div>

        {/* 안내 문구 */}
        <div style={{ fontSize: 13, color: "#9ca3af", textAlign: "center", lineHeight: 1.7 }}>
          회원번호 입력 후 입장 버튼 또는 Enter 키를 눌러주세요
        </div>
      </div>
    </div>
  );
};

// ── 출입 알림 팝업: 얼굴인식/터치패드 출석 발생 시 "○○○ 회원님 입장하셨습니다" 2초 표시 ──
function EntryAlert({ token }) {
  const [entry, setEntry] = useState(null);   // { name }
  const lastIdRef = useRef(null);
  const initedRef = useRef(false);
  const hideTimer = useRef(null);

  useEffect(() => {
    if (!token) return;
    let stopped = false;
    const poll = async () => {
      try {
        const d = new Date();
        const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        const res = await fetch(`${API_BASE}/attendance/list?target_date=${today}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const raw = await res.json();
        const list = Array.isArray(raw) ? raw : [];
        const maxId = list.length ? Math.max(...list.map(a => a.id || 0)) : 0;
        if (!initedRef.current) {
          // 첫 조회는 기준선만 잡음 (오늘 0건이어도 기준선을 잡아야 이후 첫 입장이 감지됨)
          lastIdRef.current = maxId;
          initedRef.current = true;
          return;
        }
        if (list.length === 0) return;
        const fresh = list.filter(a => (a.id || 0) > (lastIdRef.current || 0));
        if (fresh.length > 0) {
          lastIdRef.current = maxId;
          const newest = fresh.reduce((p, c) => ((c.id || 0) > (p.id || 0) ? c : p), fresh[0]);
          setEntry({ name: newest.member_name || "회원" });
          if (hideTimer.current) clearTimeout(hideTimer.current);
          hideTimer.current = setTimeout(() => setEntry(null), 2000);
        }
      } catch (e) {}
    };
    poll();
    const iv = setInterval(() => { if (!stopped) poll(); }, 3000);
    return () => { stopped = true; clearInterval(iv); if (hideTimer.current) clearTimeout(hideTimer.current); };
  }, [token]);

  if (!entry) return null;
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 10000,
      display: "flex", alignItems: "center", justifyContent: "center",
      pointerEvents: "none",
    }}>
      <style>{`@keyframes entryPop{0%{transform:scale(0.82);opacity:0}100%{transform:scale(1);opacity:1}}`}</style>
      <div style={{
        background: "linear-gradient(135deg, #15803d, #22c55e)",
        color: "#fff", padding: "34px 56px", borderRadius: 24,
        boxShadow: "0 20px 60px rgba(0,0,0,0.32)", textAlign: "center",
        animation: "entryPop 0.22s ease-out",
      }}>
        <div style={{ fontSize: 40, marginBottom: 10 }}>🚪</div>
        <div style={{ fontSize: 30, fontWeight: 800, letterSpacing: -0.5 }}>
          {entry.name} 회원님 입장하셨습니다
        </div>
      </div>
    </div>
  );
}

export default function App() {
  // ─── Auth state with localStorage persistence ───
  const [token, setTokenState] = useState(() => LS.get('access_token'));
  const [subscription, setSubscriptionState] = useState(() => {
  try {
    const saved = LS.get('subscription');
    if (saved && saved.startsWith('{')) return JSON.parse(saved);
  } catch {}
  return { plan: "TRIAL", status: "TRIAL", end: null };
});
  const [role, setRoleState] = useState(() => LS.get('role') || "OWNER");
  const [permissions, setPermissionsState] = useState(() => {
  try {
  const saved = LS.get('permissions');
    if (saved && saved.startsWith('{')) return JSON.parse(saved);
  } catch {}
  return null;
});

  const setToken = (v) => {
    setTokenState(v);
    if (v) LS.set('access_token', v);
    else LS.remove('access_token');
  };
  const setSubscription = (v) => {
    setSubscriptionState(v);
    if (v) LS.set('subscription', JSON.stringify(v));
    else LS.remove('subscription');
  };
  const setRole = (v) => {
    setRoleState(v);
    if (v) LS.set('role', v);
    else LS.remove('role');
  };
  const setPermissions = (v) => {
    setPermissionsState(v);
    if (v) LS.set('permissions', JSON.stringify(v));
    else LS.remove('permissions');
  };

  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);
  const [withdrawConfirm, setWithdrawConfirm] = useState("");
  const [withdrawStep, setWithdrawStep] = useState(false);
  const [subLive, setSubLive] = useState(null);
  const [settingsTab, setSettingsTab] = useState("basic");
  const [showGuide, setShowGuide] = useState(false);
  // 대표(OWNER) 첫 로그인 시 이용가이드 자동 표시 (한 번 닫으면 다시 안 뜸)
  useEffect(() => {
    if (token && role === "OWNER" && !LS.get("hb_guide_seen")) setShowGuide(true);
  }, [token, role]);
  const closeGuide = () => { setShowGuide(false); LS.set("hb_guide_seen", "1"); };
  const [dashboardData, setDashboardData] = useState(null);
  const [simpleMode, setSimpleMode] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [page, setPage] = useState("dashboard");
  const [membersInitialFilter, setMembersInitialFilter] = useState(null);
  const [quickResvModal, setQuickResvModal] = useState(false);
  const [consultAutoOpen, setConsultAutoOpen] = useState(false);
  const [consultFocusId, setConsultFocusId] = useState(null);
  const [toasts, setToasts] = useState([]);

  const addToast = (msg, type = "success") => {
    const id = Date.now();
    setToasts(p => [...p, { id, msg, type }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), 3500);
  };
  const removeToast = id => setToasts(p => p.filter(t => t.id !== id));

  // ── 키오스크 페이지: JWT 없이 접근 가능 (/kiosk?tid=X&token=Y) ──
  if (window.location.pathname === "/kiosk") return <KioskPage />;

    if (!token) return <LoginPage onLogin={d => { setToken(d.access_token); setSubscription({ plan: d.plan || "TRIAL", status: d.subscription_status || "TRIAL", end: d.subscription_end || null, tenant_id: d.tenant_id || null }); setRole(d.role || "OWNER"); setPermissions(d.permissions || null); addToast("로그인 성공!"); }} />;
  const pageProps = { token, addToast };
  const pages = {
    dashboard:  <DashboardPage token={token} addToast={addToast} dashboardData={dashboardData} setDashboardData={setDashboardData} setPage={setPage} setMembersInitialFilter={setMembersInitialFilter} setQuickResvModal={setQuickResvModal} permissions={permissions} />,
    classes:    <ClassesPage {...pageProps} />,
    classes_member: <ClassesPage {...pageProps} subPage="member" />,
    classes_trainer: <ClassesPage {...pageProps} subPage="trainer" />,
    members:    <MembersPage {...pageProps} initialFilter={membersInitialFilter} onInitialFilterConsumed={() => setMembersInitialFilter(null)} />,
    consult:    <ConsultPage {...pageProps} autoOpenAdd={consultAutoOpen} onAutoOpenConsumed={() => setConsultAutoOpen(false)} focusConsultId={consultFocusId} onFocusConsumed={() => setConsultFocusId(null)} />,
    payment:    <PaymentPage {...pageProps} />,
    sales:      <SalesPage {...pageProps} />,
    products:   <ProductsPage {...pageProps} />,
    attendance: <AttendancePage {...pageProps} />,
    staff:      <StaffPage {...pageProps} setPage={setPage} setSimpleMode={setSimpleMode} />,
    contract:   <ContractPage {...pageProps} />,
    notices:    <NoticePage {...pageProps} />,
    scheduler:  <SchedulerPage token={token} addToast={addToast} setPage={setPage} />,
    lockers:    <LockersPage token={token} addToast={addToast} />,
    analytics:  <AnalyticsPage token={token} addToast={addToast} />,
    aiReport:   <AiReportPage token={token} addToast={addToast} />,
    settings:   <SettingsPage token={token} addToast={addToast} tab={settingsTab} setTab={setSettingsTab} onOpenGuide={() => setShowGuide(true)} />,
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f3f6fb", fontFamily: "'Pretendard', 'Noto Sans KR', sans-serif" }}>
      <PlanBanner subscription={subscription} />
      <GuideModal isOpen={showGuide} onClose={closeGuide} />
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        input::placeholder { color: #9ca3af; }
        input:focus { border-color: #2563eb !important; box-shadow: 0 0 0 3px rgba(37,99,235,0.1); }
        select:focus { border-color: #2563eb !important; }
        button:hover { opacity: 0.92; }
        @keyframes slideIn { from { transform: translateX(20px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
      `}</style>

      {/* Top Header */}
      <div style={{
        position: "fixed", top: (() => { const s = subscription; if (!s) return 0; if (["SUSPENDED","CANCELLED","GRACE"].includes(s.status)) return 38; if (s.status === "TRIAL") return 38; if (s.end && Math.ceil((new Date(s.end)-new Date())/86400000) <= 30) return 38; return 0; })(), left: 0, right: 0, height: 56, background: "#fff",
        borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center",
        padding: "0 24px", zIndex: 100, gap: 16
      }}>
{/* Logo */}
<div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 160 }}>

  <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -0.5, cursor: "pointer" }} onClick={() => { setSimpleMode(false); setPage("dashboard"); }}>
    <span style={{ color: "#2563eb" }}>Hey</span><span style={{ color: "#111" }}>비서</span>
  </div>
</div>

        {/* Center Tabs */}
      <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: 0 }}>
          {[
            { label: "홈", icon: "dashboard", page: "dashboard" },
            { label: "회원", icon: "members", page: "members" },
            { label: "매출", icon: "sales", page: "sales" },
            { label: "앱 푸시", icon: "bell", page: "notices" },
            { label: "스케줄", icon: "calendar", page: "scheduler" },
          ].filter(t => role === "OWNER" || role === "SUPERADMIN" || !OWNER_ONLY.includes(t.page)).map((t, i, arr) => (
            <div key={t.label} style={{ display: "flex", alignItems: "center" }}>
              <button onClick={() => { if (subscription.status === "SUSPENDED" || subscription.status === "CANCELLED") return; if (t.page === "sales" && permissions?.sales === false) return; setSimpleMode(false); setPage(t.page); }} style={{
                display: "flex", alignItems: "center", gap: 6, background: "none", border: "none",
                color: page === t.page ? "#2563eb" : "#374151", fontSize: 14, fontWeight: page === t.page ? 700 : 500,
                cursor: "pointer", padding: "4px 16px"
              }}>
                <Icon name={t.icon} size={16} color={page === t.page ? "#2563eb" : "#6b7280"} />
                {t.label}
              </button>
              {i < arr.length - 1 && <span style={{ color: "#e5e7eb", fontSize: 18 }}>|</span>}
            </div>
          ))}
        </div>

        {/* Right */}
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <button onClick={() => { if (subscription.status === "SUSPENDED" || subscription.status === "CANCELLED") return; setSimpleMode(false); }} style={{ background: (subscription.status === "SUSPENDED" || subscription.status === "CANCELLED") ? "#e5e7eb" : simpleMode ? "#fff" : "#2563eb", color: simpleMode ? "#374151" : "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 16px", fontSize: 13, fontWeight: 700, cursor: "pointer", minWidth: 72 }}>대시보드</button>
          <button onClick={() => setSimpleMode(true)} style={{ background: simpleMode ? "#2563eb" : "#fff", color: simpleMode ? "#fff" : "#374151", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 16px", fontSize: 13, fontWeight: 700, cursor: "pointer", minWidth: 72 }}>간편 모드</button>
          <div style={{ position: "relative" }}>
            <button onClick={() => setMoreMenuOpen(p => !p)} style={{ background: "none", border: "none", color: "#9ca3af", cursor: "pointer", padding: 4 }}>
              <Icon name="more" size={20} />
            </button>
            {moreMenuOpen && (
              <div style={{ position: "absolute", right: 0, top: 32, background: "#fff", borderRadius: 10, boxShadow: "0 4px 20px rgba(0,0,0,0.12)", border: "1px solid #f0f0f0", zIndex: 200, minWidth: 140, overflow: "hidden" }}
                onClick={() => setMoreMenuOpen(false)}>
                <button onClick={() => { setSimpleMode(false); setSettingsTab("basic"); setPage("settings"); }} style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", width: "100%", background: "none", border: "none", fontSize: 13, color: "#374151", cursor: "pointer", fontWeight: 500 }}>
                  <Icon name="settings" size={15} color="#6b7280" />설정
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {!simpleMode && (
  <aside style={{
    width: 220, background: "#fff", borderRight: "1px solid #f0f0f0",
    position: "fixed", top: 56, left: 0, height: "calc(100vh - 56px)",
    display: "flex", flexDirection: "column", padding: "20px 12px"
  }}>
    <div style={{ fontSize: 13, fontWeight: 800, color: "#374151", padding: "0 8px", marginBottom: 16 }}>GYM Manager</div>
    <nav style={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      {NAV.filter(n => !(OWNER_ONLY.includes(n.id) && role !== "OWNER" && role !== "SUPERADMIN")).filter(n => role === "OWNER" || !permissions || permissions[n.id] !== false).map(n => {
        const active = page === n.id || n.children?.some(c => c.id === page);
        const isParentActive = n.children?.some(c => c.id === page);
        return (
          <div key={n.id}>
            <button onClick={() => { if (subscription.status === "SUSPENDED" || subscription.status === "CANCELLED") return; setPage(n.children ? n.children[0].id : n.id); }} style={{
              display: "flex", alignItems: "center", gap: 10, padding: "10px 12px",
              borderRadius: 9, border: "none",
              background: active ? "#eff6ff" : "transparent",
              color: active ? "#2563eb" : "#6b7280",
              cursor: "pointer", fontSize: 13, fontWeight: active ? 700 : 400,
              textAlign: "left", width: "100%", transition: "all .15s"
            }}>
              <Icon name={n.icon} size={16} color={active ? "#2563eb" : "#9ca3af"} />
              {n.label}
            </button>
            {n.children && active && (
              <div style={{ paddingLeft: 28, marginBottom: 4 }}>
                {n.children.map(c => (
                  <button key={c.id} onClick={() => setPage(c.id)} style={{
                    display: "flex", alignItems: "center", gap: 6, padding: "6px 12px",
                    borderRadius: 7, border: "none",
                    background: page === c.id ? "#dbeafe" : "transparent",
                    color: page === c.id ? "#2563eb" : "#6b7280",
                    cursor: "pointer", fontSize: 12, fontWeight: page === c.id ? 700 : 400,
                    textAlign: "left", width: "100%"
                  }}>
                    <span style={{ width: 6, height: 6, borderRadius: "50%", background: page === c.id ? "#2563eb" : "#d1d5db", flexShrink: 0 }} />
                    {c.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </nav>
      <div style={{borderTop:"1px solid #f0f0f0", paddingTop:8, marginBottom:4}}>
      {NAV_BOTTOM.map(n => {
        const active = page === n.id;
        return (
          <button key={n.id} onClick={() => setPage(n.id)} style={{
            display: "flex", alignItems: "center", gap: 10, padding: "10px 12px",
            borderRadius: 9, border: "none",
            background: active ? "#eff6ff" : "transparent",
            color: active ? "#2563eb" : "#6b7280",
            cursor: "pointer", fontSize: 13, fontWeight: active ? 700 : 400,
            textAlign: "left", width: "100%"
          }}>
            <Icon name={n.icon} size={16} color={active ? "#2563eb" : "#9ca3af"} />
            {n.label}
          </button>
        );
      })}
    </div>
      
 <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: 8 }}>
      {/* 구독 상태 박스 */}
      {(() => {
        const today = new Date();
        const endDate = subscription.end ? new Date(subscription.end) : null;
        const dDay = endDate ? Math.ceil((endDate - today) / (1000 * 60 * 60 * 24)) : null;
        const color = dDay === null ? "#9ca3af" : dDay <= 7 ? "#ef4444" : dDay <= 14 ? "#f59e0b" : "#10b981";
        const planLabel = { TRIAL: "트라이얼", BASIC: "베이직", PRO: "프로", ENTERPRISE: "엔터프라이즈" }[subscription.plan] || subscription.plan;
        return (
          <div onClick={() => { setSubscriptionModal(true); setSubLive(null); fetch(`${API_BASE}/subscription/status`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.ok ? r.json() : null).then(d => { if (d) setSubLive(d); }).catch(() => {}); }} style={{ margin: "0 4px 8px", padding: "10px 12px", borderRadius: 10, background: "#f8faff", border: `1px solid ${color}22`, cursor: "pointer" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: "#374151" }}>💳 {planLabel}</span>
              <span style={{ fontSize: 10, fontWeight: 700, color, background: `${color}18`, padding: "2px 6px", borderRadius: 20 }}>
                {dDay === null ? "미설정" : dDay <= 0 ? "만료됨" : `D-${dDay}`}
              </span>
            </div>
            {endDate && dDay > 0 && (
              <div style={{ fontSize: 10, color: "#9ca3af" }}>{subscription.end} 만료</div>
            )}
          </div>
        );
      })()}
      <button onClick={() => setToken(null)} style={{
        display: "flex", alignItems: "center", gap: 10, padding: "10px 12px",
        borderRadius: 9, border: "none", background: "transparent",
        color: "#ef4444", cursor: "pointer", fontSize: 13, width: "100%", fontWeight: 500
      }}>
        <Icon name="logout" size={16} color="#ef4444" />로그아웃
      </button>
    </div>
 </aside>
)}

{/* 구독 모달 */}
{subscriptionModal && (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}
    onClick={() => { setSubscriptionModal(false); setWithdrawStep(false); setWithdrawConfirm(""); }}>
    <div style={{ background: "#fff", borderRadius: 16, padding: 28, width: 360, boxShadow: "0 8px 40px rgba(0,0,0,0.15)" }}
      onClick={e => e.stopPropagation()}>
      {!withdrawStep ? (
        <>
          <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 20 }}>구독 정보</div>
          <div style={{ background: "#f8faff", borderRadius: 10, padding: 16, marginBottom: 16 }}>
            {[
              ["플랜", { TRIAL:"트라이얼", BASIC:"베이직", PRO:"프로", ENTERPRISE:"엔터프라이즈" }[(subLive?.plan) || subscription.plan] || (subLive?.plan) || subscription.plan],
              ["상태", { TRIAL:"체험중", ACTIVE:"활성", EXPIRED:"만료", CANCELLED:"해지됨" }[(subLive?.subscription_status) || subscription.status] || (subLive?.subscription_status) || subscription.status],
              ["만료일", (subLive?.subscription_end) || subscription.end || "미설정"],
            ].map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 8 }}>
                <span style={{ color: "#6b7280" }}>{k}</span>
                <span style={{ fontWeight: 600 }}>{v}</span>
              </div>
            ))}
          </div>
          {subLive?.cancel_requested_at ? (
            <>
              <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: 14, marginBottom: 14, fontSize: 12.5, color: "#991b1b", lineHeight: 1.7 }}>
                해지가 예약되었습니다.<br/>
                <b>{(subLive?.subscription_end) || subscription.end}</b>까지 정상 이용 가능하며, 이후 서비스가 종료됩니다.<br/>
                데이터는 <b>{subLive?.purge_at}</b>까지 보관 후 삭제됩니다.
              </div>
              <button onClick={async () => {
                const tid = JSON.parse(atob(token.split('.')[1])).tenant_id;
                const r = await fetch(`${API_BASE}/tenant/${tid}/withdraw/cancel`, { method: "POST", headers: { Authorization: `Bearer ${token}` } });
                if (r.ok) {
                  addToast("해지 예약이 취소되었습니다.");
                  const s = await fetch(`${API_BASE}/subscription/status`, { headers: { Authorization: `Bearer ${token}` } });
                  if (s.ok) setSubLive(await s.json());
                } else { addToast("취소 실패", "error"); }
              }} style={{ width: "100%", background: "#2563eb", color: "#fff", border: "none", borderRadius: 10, padding: "12px 0", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
                해지 예약 취소
              </button>
            </>
          ) : (
            <>
              <button onClick={() => { setSubscriptionModal(false); setSimpleMode(false); setSettingsTab("subscription"); setPage("settings"); }} style={{ width: "100%", background: "#2563eb", color: "#fff", border: "none", borderRadius: 10, padding: "12px 0", fontSize: 14, fontWeight: 700, cursor: "pointer", marginBottom: 12 }}>
                구독 연장하기
              </button>
              <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: 12, textAlign: "center" }}>
                <button onClick={() => setWithdrawStep(true)} style={{ background: "none", border: "none", color: "#9ca3af", fontSize: 12, cursor: "pointer", textDecoration: "underline" }}>
                  서비스 해지
                </button>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 8, color: "#ef4444" }}>서비스 해지</div>
          <div style={{ fontSize: 13, color: "#374151", marginBottom: 16, lineHeight: 1.7, background: "#f9fafb", border: "1px solid #f0f0f0", borderRadius: 10, padding: 14 }}>
            · 해지해도 남은 구독 기간(<b>{(subLive?.subscription_end) || subscription.end || "만료일"}</b>)까지는 그대로 이용하실 수 있습니다.<br/>
            · 만료일에 서비스가 자동 종료되며, <b>환불은 제공되지 않습니다.</b><br/>
            · 데이터는 종료 후 <b>30일간 보관</b> 후 삭제됩니다 (그 전 재구독 시 복구).
          </div>
          <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 12 }}>
            계속하려면 아래에 <b style={{ color: "#111" }}>해지합니다</b>를 입력해주세요.
          </div>
          <input
            value={withdrawConfirm}
            onChange={e => setWithdrawConfirm(e.target.value)}
            placeholder="해지합니다"
            style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px", fontSize: 14, marginBottom: 12, outline: "none" }}
          />
          <button
            disabled={withdrawConfirm !== "해지합니다"}
            onClick={async () => {
              const tid = JSON.parse(atob(token.split('.')[1])).tenant_id;
              const r = await fetch(`${API_BASE}/tenant/${tid}/withdraw`, { method: "POST", headers: { Authorization: `Bearer ${token}` } });
              if (r.ok) {
                addToast("해지가 예약되었습니다. 만료일까지 이용 가능합니다.");
                const s = await fetch(`${API_BASE}/subscription/status`, { headers: { Authorization: `Bearer ${token}` } });
                if (s.ok) setSubLive(await s.json());
              } else { addToast("해지 신청 실패", "error"); }
              setWithdrawStep(false);
              setWithdrawConfirm("");
            }}
            style={{ width: "100%", background: withdrawConfirm === "해지합니다" ? "#ef4444" : "#f3f4f6", color: withdrawConfirm === "해지합니다" ? "#fff" : "#9ca3af", border: "none", borderRadius: 10, padding: "12px 0", fontSize: 14, fontWeight: 700, cursor: withdrawConfirm === "해지합니다" ? "pointer" : "not-allowed", marginBottom: 12 }}>
            해지 신청
          </button>
          <button onClick={() => { setWithdrawStep(false); setWithdrawConfirm(""); }} style={{ width: "100%", background: "none", border: "1px solid #e5e7eb", borderRadius: 10, padding: "12px 0", fontSize: 14, cursor: "pointer", color: "#374151" }}>
            취소
          </button>
        </>
      )}
    </div>
  </div>
)}

{/* Drawer (간편모드) */}
{simpleMode && drawerOpen && (
  <div style={{ position: "fixed", inset: 0, zIndex: 200 }} onClick={() => setDrawerOpen(false)}>
    <aside style={{
      width: 200, background: "#fff", borderRight: "1px solid #f0f0f0",
      position: "fixed", top: 56, left: 0, height: "calc(100vh - 56px)",
      display: "flex", flexDirection: "column", padding: "20px 12px",
      boxShadow: "4px 0 20px rgba(0,0,0,0.1)"
    }} onClick={e => e.stopPropagation()}>
      <div style={{ fontSize: 13, fontWeight: 800, color: "#374151", padding: "0 8px", marginBottom: 16 }}>GYM Manager</div>
      <nav style={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
        {NAV.map(n => (
          <button key={n.id} onClick={() => { setSimpleMode(false); setPage(n.id); setDrawerOpen(false); }} style={{
            display: "flex", alignItems: "center", gap: 10, padding: "10px 12px",
            borderRadius: 9, border: "none", background: "transparent",
            color: "#6b7280", cursor: "pointer", fontSize: 13, fontWeight: 400,
            textAlign: "left", width: "100%"
          }}>
            <Icon name={n.icon} size={16} color="#9ca3af" />
            {n.label}
          </button>
        ))}
      </nav>

     <div style={{borderTop:"1px solid #f0f0f0", paddingTop:8, marginBottom:4}}>
        {NAV_BOTTOM.map(n => (
          <button key={n.id} onClick={() => { setSimpleMode(false); setPage(n.id); setDrawerOpen(false); }} style={{
            display: "flex", alignItems: "center", gap: 10, padding: "10px 12px",
            borderRadius: 9, border: "none", background: "transparent",
            color: "#6b7280", cursor: "pointer", fontSize: 13, fontWeight: 400,
            textAlign: "left", width: "100%"
          }}>
            <Icon name={n.icon} size={16} color="#9ca3af" />
            {n.label}
          </button>
        ))}
      </div>
      <button onClick={() => setToken(null)} style={{
        display: "flex", alignItems: "center", gap: 10, padding: "10px 12px",
        borderRadius: 9, border: "none", background: "transparent",
        color: "#9ca3af", cursor: "pointer", fontSize: 13, width: "100%"
      }}>
        <Icon name="logout" size={16} color="#9ca3af" />로그아웃
      </button>
    </aside>
  </div>
)}

     {/* Main Content */}
     <main style={{ marginLeft: simpleMode ? 0 : 220, marginTop: (() => { const s = subscription; if (!s) return 56; if (["SUSPENDED","CANCELLED","GRACE"].includes(s.status)) return 94; if (s.status === "TRIAL") return 94; if (s.end && Math.ceil((new Date(s.end)-new Date())/86400000) <= 30) return 94; return 56; })(), flex: 1, padding: simpleMode ? 12 : 24, minHeight: "calc(100vh - 56px)", maxWidth: "none", overflowX: "visible" }}>
  {subscription.status === "SUSPENDED" || subscription.status === "CANCELLED"
    ? <SuspendedScreen />
    : simpleMode
      ? <SimpleModePage token={token} addToast={addToast} dashboardData={dashboardData} setSimpleMode={setSimpleMode} setPage={setPage} setMembersInitialFilter={setMembersInitialFilter} setConsultAutoOpen={setConsultAutoOpen} setConsultFocusId={setConsultFocusId} />
      : (OWNER_ONLY.includes(page) && role !== "OWNER" && role !== "SUPERADMIN")
        ? <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "60vh", color: "#9ca3af", gap: 10 }}>
            <Icon name="sales" size={40} color="#d1d5db" />
            <div style={{ fontSize: 16, fontWeight: 700, color: "#6b7280" }}>대표 전용 화면이에요</div>
            <div style={{ fontSize: 13 }}>이 메뉴는 대표(OWNER) 계정만 볼 수 있습니다.</div>
          </div>
        : pages[page]}
</main>

{quickResvModal && (
  <Reservation
    showToast={addToast}
    tenantId={1}
    autoOpen={true}
    onAutoClose={() => setQuickResvModal(false)}
  />
)}
      <Toast toasts={toasts} remove={removeToast} />
      <EntryAlert token={token} />
    </div>
  );
}
